//(()=>{var e={344:e=>{var t,n,r;t=window,n=0,r=function e(t,r){var s=this,i=this,o=!1;if(Array.isArray(t))return!!t.length&&t.map((function(t){return new e(t,r)}));var a={init:function(){this.options=Object.assign({duration:600,ariaEnabled:!0,collapse:!0,showMultiple:!1,onlyChildNodes:!0,openOnInit:[],elementClass:"ac",triggerClass:"ac-trigger",panelClass:"ac-panel",activeClass:"is-active",beforeOpen:function(){},onOpen:function(){},beforeClose:function(){},onClose:function(){}},r);var e="string"==typeof t;this.container=e?document.querySelector(t):t,this.createDefinitions(),i.attachEvents()},createDefinitions:function(){var e=this,t=this.options,r=t.elementClass,s=t.openOnInit,i=t.onlyChildNodes?this.container.childNodes:this.container.querySelectorAll(u(r));this.elements=Array.from(i).filter((function(e){return e.classList&&e.classList.contains(r)})),this.firstElement=this.elements[0],this.lastElement=this.elements[this.elements.length-1],this.elements.filter((function(e){return!e.classList.contains("js-enabled")})).forEach((function(t){t.classList.add("js-enabled"),e.generateIDs(t),e.setARIA(t),e.setTransition(t);var r=e.elements.indexOf(t);n++,s.includes(r)?e.showElement(t,!1):e.closeElement(t,!1)}))},setTransition:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.options,r=n.duration,s=n.panelClass,i=e.querySelector(u(s)),o=l("transitionDuration");i.style[o]=t?null:"".concat(r,"ms")},generateIDs:function(e){var t=this.options,r=t.triggerClass,s=t.panelClass,i=e.querySelector(u(r)),o=e.querySelector(u(s));e.setAttribute("id",e.id||"ac-".concat(n)),i.setAttribute("id",i.id||"ac-trigger-".concat(n)),o.setAttribute("id",o.id||"ac-panel-".concat(n))},removeIDs:function(e){var t=this.options,n=t.triggerClass,r=t.panelClass,s=e.querySelector(u(n)),i=e.querySelector(u(r));e.id.startsWith("ac-")&&e.removeAttribute("id"),s.id.startsWith("ac-")&&s.removeAttribute("id"),i.id.startsWith("ac-")&&i.removeAttribute("id")},setARIA:function(e){var t=this.options,n=t.ariaEnabled,r=t.triggerClass,s=t.panelClass;if(n){var i=e.querySelector(u(r)),o=e.querySelector(u(s));i.setAttribute("role","button"),i.setAttribute("aria-controls",o.id),i.setAttribute("aria-disabled",!1),i.setAttribute("aria-expanded",!1),o.setAttribute("role","region"),o.setAttribute("aria-labelledby",i.id)}},updateARIA:function(e,t){var n=t.ariaExpanded,r=t.ariaDisabled,s=this.options,i=s.ariaEnabled,o=s.triggerClass;if(i){var a=e.querySelector(u(o));a.setAttribute("aria-expanded",n),a.setAttribute("aria-disabled",r)}},removeARIA:function(e){var t=this.options,n=t.ariaEnabled,r=t.triggerClass,s=t.panelClass;if(n){var i=e.querySelector(u(r)),o=e.querySelector(u(s));i.removeAttribute("role"),i.removeAttribute("aria-controls"),i.removeAttribute("aria-disabled"),i.removeAttribute("aria-expanded"),o.removeAttribute("role"),o.removeAttribute("aria-labelledby")}},focus:function(e,t){e.preventDefault();var n=this.options.triggerClass;t.querySelector(u(n)).focus()},focusFirstElement:function(e){this.focus(e,this.firstElement),this.currFocusedIdx=0},focusLastElement:function(e){this.focus(e,this.lastElement),this.currFocusedIdx=this.elements.length-1},focusNextElement:function(e){var t=this.currFocusedIdx+1;if(t>this.elements.length-1)return this.focusFirstElement(e);this.focus(e,this.elements[t]),this.currFocusedIdx=t},focusPrevElement:function(e){var t=this.currFocusedIdx-1;if(t<0)return this.focusLastElement(e);this.focus(e,this.elements[t]),this.currFocusedIdx=t},showElement:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this.options,r=n.panelClass,s=n.activeClass,i=n.collapse,o=n.beforeOpen;t&&o(e);var a=e.querySelector(u(r)),l=a.scrollHeight;e.classList.add(s),requestAnimationFrame((function(){requestAnimationFrame((function(){a.style.height=t?"".concat(l,"px"):"auto"}))})),this.updateARIA(e,{ariaExpanded:!0,ariaDisabled:!i})},closeElement:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=this.options,r=n.panelClass,s=n.activeClass,i=n.beforeClose,o=e.querySelector(u(r)),a=o.scrollHeight;e.classList.remove(s),t?(i(e),requestAnimationFrame((function(){o.style.height="".concat(a,"px"),requestAnimationFrame((function(){o.style.height=0}))}))):o.style.height=0,this.updateARIA(e,{ariaExpanded:!1,ariaDisabled:!1})},toggleElement:function(e){var t=this.options,n=t.activeClass,r=t.collapse,s=e.classList.contains(n);if(!s||r)return s?this.closeElement(e):this.showElement(e)},closeElements:function(){var e=this,t=this.options,n=t.activeClass;t.showMultiple||this.elements.forEach((function(t,r){t.classList.contains(n)&&r!==e.currFocusedIdx&&e.closeElement(t)}))},handleClick:function(e){var t=this,n=e.currentTarget;this.elements.forEach((function(r,s){r.contains(n)&&"A"!==e.target.nodeName&&(t.currFocusedIdx=s,t.closeElements(),t.focus(e,r),t.toggleElement(r))}))},handleKeydown:function(e){switch(e.key){case"ArrowUp":return this.focusPrevElement(e);case"ArrowDown":return this.focusNextElement(e);case"Home":return this.focusFirstElement(e);case"End":return this.focusLastElement(e);default:return null}},handleFocus:function(e){var t=e.currentTarget,n=this.elements.find((function(e){return e.contains(t)}));this.currFocusedIdx=this.elements.indexOf(n)},handleTransitionEnd:function(e){if(e.stopPropagation(),"height"===e.propertyName){var t=this.options,n=t.onOpen,r=t.onClose,s=e.currentTarget,i=parseInt(s.style.height),o=this.elements.find((function(e){return e.contains(s)}));i>0?(s.style.height="auto",n(o)):r(o)}}};this.attachEvents=function(){if(!o){var e=a.options,t=e.triggerClass,n=e.panelClass;a.handleClick=a.handleClick.bind(a),a.handleKeydown=a.handleKeydown.bind(a),a.handleFocus=a.handleFocus.bind(a),a.handleTransitionEnd=a.handleTransitionEnd.bind(a),a.elements.forEach((function(e){var r=e.querySelector(u(t)),s=e.querySelector(u(n));r.addEventListener("click",a.handleClick),r.addEventListener("keydown",a.handleKeydown),r.addEventListener("focus",a.handleFocus),s.addEventListener("webkitTransitionEnd",a.handleTransitionEnd),s.addEventListener("transitionend",a.handleTransitionEnd)})),o=!0}},this.detachEvents=function(){if(o){var e=a.options,t=e.triggerClass,n=e.panelClass;a.elements.forEach((function(e){var r=e.querySelector(u(t)),s=e.querySelector(u(n));r.removeEventListener("click",a.handleClick),r.removeEventListener("keydown",a.handleKeydown),r.removeEventListener("focus",a.handleFocus),s.removeEventListener("webkitTransitionEnd",a.handleTransitionEnd),s.removeEventListener("transitionend",a.handleTransitionEnd)})),o=!1}},this.toggle=function(e){var t=a.elements[e];t&&a.toggleElement(t)},this.open=function(e){var t=a.elements[e];t&&a.showElement(t)},this.openAll=function(){var e=a.options,t=e.activeClass,n=e.onOpen;a.elements.forEach((function(e){e.classList.contains(t)||(a.showElement(e,!1),n(e))}))},this.close=function(e){var t=a.elements[e];t&&a.closeElement(t)},this.closeAll=function(){var e=a.options,t=e.activeClass,n=e.onClose;a.elements.forEach((function(e){e.classList.contains(t)&&(a.closeElement(e,!1),n(e))}))},this.destroy=function(){s.detachEvents(),s.openAll(),a.elements.forEach((function(e){a.removeIDs(e),a.removeARIA(e),a.setTransition(e,!0)})),o=!0},this.update=function(){a.createDefinitions(),s.detachEvents(),s.attachEvents()};var l=function(e){return"string"==typeof document.documentElement.style[e]?e:(e=c(e),e="webkit".concat(e))},c=function(e){return e.charAt(0).toUpperCase()+e.slice(1)},u=function(e){return".".concat(CSS.escape(e))};a.init()},void 0!==e.exports?e.exports=r:t.Accordion=r},30:()=>{if(null!==document.querySelector(".customers-login")){const n={recoverPasswordFormTriggers:"[data-recover-toggle]",recoverPasswordForm:"[data-recover-form]",loginForm:"[data-login-form]",formState:"[data-form-state]",resetSuccess:"[data-reset-success]"};function e(e){e.preventDefault(),t()}function t(){console.log("clicked"),document.querySelector(n.recoverPasswordForm).classList.toggle("hidden"),document.querySelector(n.loginForm).classList.toggle("hidden")}document.querySelector(n.recoverPasswordForm)&&("#recover"===window.location.hash&&t(),document.querySelector(n.formState)&&document.querySelector(n.resetSuccess).classList.remove("hidden"),document.querySelectorAll(n.recoverPasswordFormTriggers).forEach((t=>{t.addEventListener("click",e)})))}},250:()=>{null!==document.querySelector(".product-card")&&document.querySelectorAll(".product-card").forEach((e=>{const t=e.querySelectorAll("picture")[0],n=e.querySelector(".product-card__media--featured");let r="";if(n&&(r=n.src),null!==e.querySelector(".product-card__details--swatches .swatch__wrap")){const s=e.querySelectorAll(".product-card__details--swatches .swatch__wrap"),i=e.querySelectorAll("form");s.forEach((o=>{let a=r,l=r.split("&width=600")[0];o.hasAttribute("data-image")&&(a=o.getAttribute("data-image"),l=a.split("&width=600")[0]);const c=()=>{const{href:r}=o,c=o.getAttribute("data-title");let u="";o.hasAttribute("data-benefit")&&(u=o.getAttribute("data-benefit"));const d=o.getAttribute("data-form-id");s.forEach((e=>{e.classList.remove("active")})),o.classList.add("active"),n.srcset="",n.src=a,t.querySelectorAll("source")[0].srcset=`${l}&width=600`,t.querySelectorAll("source")[1].srcset=`${l}&width=600`,t.querySelectorAll("source")[2].srcset=`${l}&width=600`,t.querySelectorAll("source")[3].srcset=`${l}&width=600`,null!==e.querySelector(`.${d}-add-to-cart`)&&(i.forEach((e=>{e.classList.remove("active")})),e.querySelectorAll(`.${d}-add-to-cart`).forEach((e=>{e.classList.add("active")}))),e.querySelectorAll("a:not(.swatch__wrap").forEach((e=>{e.href=r})),e.querySelector(".product-card__details--title").textContent=c,u.length?e.querySelector(".product-card__headline").classList.remove("hidden"):e.querySelector(".product-card__headline").classList.add("hidden"),e.querySelector(".product-card__headline").textContent=u};o.addEventListener("mouseenter",c),window.isMobile()&&o.addEventListener("click",(e=>{e.preventDefault(),c()}))}))}}))},478:()=>{window.Element&&!Element.prototype.closest&&(Element.prototype.closest=function(e){var t,n=(this.document||this.ownerDocument).querySelectorAll(e),r=this;do{for(t=n.length;--t>=0&&n.item(t)!==r;);}while(t<0&&(r=r.parentElement));return r})},841:()=>{var e=document.links;for(let t=0,n=e.length;t<n;t++)e[t].hostname!==window.location.hostname&&(e[t].target="_blank",e[t].rel="noreferrer noopener")},855:()=>{window.isMobile=function(){let e=!1;var t;return t=navigator.userAgent||navigator.vendor||window.opera,(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0,4)))&&(e=!0),e},navigator.maxTouchPoints>1&&document.body.classList.add("touchpoints")},219:()=>{if(window.CSS?.supports?.("(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)")){const e=document.querySelector('meta[name="viewport"]');null!==e&&(e.content=`${e.content},user-scalable=no`)}},76:e=>{var t=/^(?:submit|button|image|reset|file)$/i,n=/^(?:input|select|textarea|keygen)/i,r=/(\[[^\[\]]*\])/g;function s(e,t,n){if(0===t.length)return e=n;var r=t.shift(),i=r.match(/^\[(.+?)\]$/);if("[]"===r)return e=e||[],Array.isArray(e)?e.push(s(null,t,n)):(e._values=e._values||[],e._values.push(s(null,t,n))),e;if(i){var o=i[1],a=+o;isNaN(a)?(e=e||{})[o]=s(e[o],t,n):(e=e||[])[a]=s(e[a],t,n)}else e[r]=s(e[r],t,n);return e}function i(e,t,n){if(t.match(r)){s(e,function(e){var t=[],n=new RegExp(r),s=/^([^\[\]]*)/.exec(e);for(s[1]&&t.push(s[1]);null!==(s=n.exec(e));)t.push(s[1]);return t}(t),n)}else{var i=e[t];i?(Array.isArray(i)||(e[t]=[i]),e[t].push(n)):e[t]=n}return e}function o(e,t,n){return n=n.replace(/(\r)?\n/g,"\r\n"),n=(n=encodeURIComponent(n)).replace(/%20/g,"+"),e+(e?"&":"")+encodeURIComponent(t)+"="+n}e.exports=function(e,r){"object"!=typeof r?r={hash:!!r}:void 0===r.hash&&(r.hash=!0);for(var s=r.hash?{}:"",a=r.serializer||(r.hash?i:o),l=e&&e.elements?e.elements:[],c=Object.create(null),u=0;u<l.length;++u){var d=l[u];if((r.disabled||!d.disabled)&&d.name&&(n.test(d.nodeName)&&!t.test(d.type))){var h=d.name,p=d.value;if("checkbox"!==d.type&&"radio"!==d.type||d.checked||(p=void 0),r.empty){if("checkbox"!==d.type||d.checked||(p=""),"radio"===d.type&&(c[d.name]||d.checked?d.checked&&(c[d.name]=!0):c[d.name]=!1),null==p&&"radio"==d.type)continue}else if(!p)continue;if("select-multiple"!==d.type)s=a(s,h,p);else{p=[];for(var f=d.options,m=!1,g=0;g<f.length;++g){var y=f[g],v=r.empty&&!y.value,w=y.value||v;y.selected&&w&&(m=!0,s=r.hash&&"[]"!==h.slice(h.length-2)?a(s,h+"[]",y.value):a(s,h,y.value))}!m&&r.empty&&(s=a(s,h,""))}}}if(r.empty)for(var h in c)c[h]||(s=a(s,h,""));return s}},372:function(e){e.exports=function(){"use strict";function e(n){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];if(!(this instanceof e))return new(Function.prototype.bind.apply(e,[null].concat(Array.prototype.slice.call(arguments))));this.element=n,this.startOffset=t(r.startOffset,n&&n.offsetHeight),this.tolerance=t(r.tolerance,8),this.showAtBottom=t(r.showAtBottom,!0),this.classNames=r.classNames||{base:"headspace",fixed:"headspace--fixed",hidden:"headspace--hidden"},this._scrollLast=0,"undefined"!=typeof window&&this.init()}function t(e,t){return void 0!==e?e:t}function n(e){var t=window.pageYOffset,n=e._scrollLast;t<=0?e.reset():e.showAtBottom&&window.innerHeight+t>=document.body.offsetHeight?e.fix():t>e.startOffset&&Math.abs(t-n)>=e.tolerance&&e[t>n?"hide":"fix"](),e._scrollLast=t}return e.prototype={init:function(){var e=this;this.addClass(this.classNames.base),window.addEventListener("scroll",(function(){return e.debounce((function(){return n(e)}))}))},reset:function(){var e=this.classNames;this.removeClass(e.fixed,e.hidden)},fix:function(){var e=this.classNames;this.addClass(e.fixed),this.removeClass(e.hidden)},hide:function(){this.addClass(this.classNames.hidden)},addClass:function(){var e;(e=this.element.classList).add.apply(e,arguments)},removeClass:function(){var e;(e=this.element.classList).remove.apply(e,arguments)},debounce:function(e){window.requestAnimationFrame(e)}},e.isSupported=function(){return!("undefined"==typeof window||!window.requestAnimationFrame||!("classList"in document.documentElement))},e}()},139:function(e){e.exports=function(){"use strict";var e={required:"This field is required",email:"This field requires a valid e-mail address",number:"This field requires a number",integer:"This field requires an integer value",url:"This field requires a valid website URL",tel:"This field requires a valid telephone number",maxlength:"This fields length must be < ${1}",minlength:"This fields length must be > ${1}",min:"Minimum value for this field is ${1}",max:"Maximum value for this field is ${1}",pattern:"Please match the requested format"};function t(e,t){for(;(e=e.parentElement)&&!e.classList.contains(t););return e}function n(e){var t=arguments;return this.replace(/\${([^{}]*)}/g,(function(e,n){return t[n]}))}function r(e){return e.pristine.self.form.querySelectorAll('input[name="'+e.getAttribute("name")+'"]:checked').length}function s(e,t){for(var n in t)n in e||(e[n]=t[n]);return e}function i(e){return!!(e&&e.constructor&&e.call&&e.apply)}var o={classTo:"form-group",errorClass:"has-danger",successClass:"has-success",errorTextParent:"form-group",errorTextTag:"div",errorTextClass:"text-help"},a="pristine-error",l="input:not([type^=hidden]):not([type^=submit]), select, textarea",c=["required","min","max","minlength","maxlength","pattern"],u=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,d={},h=function(t,n){n.name=t,n.msg||(n.msg=e[t]),void 0===n.priority&&(n.priority=1),d[t]=n};function p(e,r,u){var h=this;function p(e,t,n){e.setAttribute("novalidate","true"),h.form=e,h.config=s(t||{},o),h.live=!(!1===n),h.fields=Array.from(e.querySelectorAll(l)).map(function(e){var t=[],n={},r={};return[].forEach.call(e.attributes,(function(e){if(/^data-pristine-/.test(e.name)){var s=e.name.substr(14);if(s.endsWith("-message"))return void(r[s.slice(0,s.length-8)]=e.value);"type"===s&&(s=e.value),f(t,n,s,e.value)}else~c.indexOf(e.name)?f(t,n,e.name,e.value):"type"===e.name&&f(t,n,e.value)})),t.sort((function(e,t){return t.priority-e.priority})),h.live&&e.addEventListener(~["radio","checkbox"].indexOf(e.getAttribute("type"))?"change":"input",function(e){h.validate(e.target)}.bind(h)),e.pristine={input:e,validators:t,params:n,messages:r,self:h}}.bind(h))}function f(e,t,n,r){var s=d[n];if(s&&(e.push(s),r)){var i=r.split(",");i.unshift(null),t[n]=i}}function m(e){for(var t=[],r=!0,s=0;e.validators[s];s++){var o=e.validators[s],a=e.params[o.name]?e.params[o.name]:[];if(a[0]=e.input.value,!o.fn.apply(e.input,a)){if(r=!1,i(o.msg))t.push(o.msg(e.input.value,a));else{var l=e.messages[o.name]||o.msg;t.push(n.apply(l,a))}if(!0===o.halt)break}}return e.errors=t,r}function g(e){if(e.errorElements)return e.errorElements;var n=t(e.input,h.config.classTo),r=null,s=null;return(r=h.config.classTo===h.config.errorTextParent?n:n.querySelector("."+h.config.errorTextParent))&&((s=r.querySelector("."+a))||((s=document.createElement(h.config.errorTextTag)).className=a+" "+h.config.errorTextClass,r.appendChild(s),s.pristineDisplay=s.style.display)),e.errorElements=[n,s]}function y(e){var t=g(e),n=t[0],r=t[1];n&&(n.classList.remove(h.config.successClass),n.classList.add(h.config.errorClass)),r&&(r.innerHTML=e.errors.join("<br/>"),r.style.display=r.pristineDisplay||"")}function v(e){var t=g(e),n=t[0],r=t[1];return n&&(n.classList.remove(h.config.errorClass),n.classList.remove(h.config.successClass)),r&&(r.innerHTML="",r.style.display="none"),t}function w(e){var t=v(e)[0];t&&t.classList.add(h.config.successClass)}return p(e,r,u),h.validate=function(e,t){t=e&&!0===t||!0===e;var n=h.fields;!0!==e&&!1!==e&&(e instanceof HTMLElement?n=[e.pristine]:(e instanceof NodeList||e instanceof(window.$||Array)||e instanceof Array)&&(n=Array.from(e).map((function(e){return e.pristine}))));for(var r=!0,s=0;n[s];s++){var i=n[s];m(i)?!t&&w(i):(r=!1,!t&&y(i))}return r},h.getErrors=function(e){if(!e){for(var t=[],n=0;n<h.fields.length;n++){var r=h.fields[n];r.errors.length&&t.push({input:r.input,errors:r.errors})}return t}return e.tagName&&"select"===e.tagName.toLowerCase()?e.pristine.errors:e.length?e[0].pristine.errors:e.pristine.errors},h.addValidator=function(e,t,n,r,s){e instanceof HTMLElement?(e.pristine.validators.push({fn:t,msg:n,priority:r,halt:s}),e.pristine.validators.sort((function(e,t){return t.priority-e.priority}))):console.warn("The parameter elem must be a dom element")},h.addError=function(e,t){(e=e.length?e[0]:e).pristine.errors.push(t),y(e.pristine)},h.reset=function(){for(var e=0;h.fields[e];e++)h.fields[e].errorElements=null;Array.from(h.form.querySelectorAll("."+a)).map((function(e){e.parentNode.removeChild(e)})),Array.from(h.form.querySelectorAll("."+h.config.classTo)).map((function(e){e.classList.remove(h.config.successClass),e.classList.remove(h.config.errorClass)}))},h.destroy=function(){h.reset(),h.fields.forEach((function(e){delete e.input.pristine})),h.fields=[]},h.setGlobalConfig=function(e){o=e},h}return h("text",{fn:function(e){return!0},priority:0}),h("required",{fn:function(e){return"radio"===this.type||"checkbox"===this.type?r(this):void 0!==e&&""!==e},priority:99,halt:!0}),h("email",{fn:function(e){return!e||u.test(e)}}),h("number",{fn:function(e){return!e||!isNaN(parseFloat(e))},priority:2}),h("integer",{fn:function(e){return!e||/^\d+$/.test(e)}}),h("minlength",{fn:function(e,t){return!e||e.length>=parseInt(t)}}),h("maxlength",{fn:function(e,t){return!e||e.length<=parseInt(t)}}),h("min",{fn:function(e,t){return!e||("checkbox"===this.type?r(this)>=parseInt(t):parseFloat(e)>=parseFloat(t))}}),h("max",{fn:function(e,t){return!e||("checkbox"===this.type?r(this)<=parseInt(t):parseFloat(e)<=parseFloat(t))}}),h("pattern",{fn:function(e,t){var n=t.match(new RegExp("^/(.*?)/([gimy]*)$"));return!e||new RegExp(n[1],n[2]).test(e)}}),p.addValidator=function(e,t,n,r,s){h(e,{fn:t,msg:n,priority:r,halt:s})},p}()},130:function(e){var t;t=function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var s=t[r]={i:r,l:!1,exports:{}};return e[r].call(s.exports,s,s.exports,n),s.l=!0,s.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var s in e)n.d(r,s,function(t){return e[t]}.bind(null,s));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";n.r(t);var r=function(e){return Array.isArray(e)?e:[e]},s=function(e){return e instanceof Node},i=function(e,t){if(e&&t){e=function(e){return e instanceof NodeList}(e)?e:[e];for(var n=0;n<e.length&&!0!==t(e[n],n,e.length);n++);}},o=function(e){return console.error("[scroll-lock] ".concat(e))},a=function(e){if(Array.isArray(e))return e.join(", ")},l=function(e){var t=[];return i(e,(function(e){return t.push(e)})),t},c=function(e,t){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:document;if((!(arguments.length>2&&void 0!==arguments[2])||arguments[2])&&-1!==l(n.querySelectorAll(t)).indexOf(e))return e;for(;(e=e.parentElement)&&-1===l(n.querySelectorAll(t)).indexOf(e););return e},u=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:document;return-1!==l(n.querySelectorAll(t)).indexOf(e)},d=function(e){if(e)return"hidden"===getComputedStyle(e).overflow},h=function(e){if(e)return!!d(e)||e.scrollTop<=0},p=function(e){if(e){if(d(e))return!0;var t=e.scrollTop,n=e.scrollHeight;return t+e.offsetHeight>=n}},f=function(e){if(e)return!!d(e)||e.scrollLeft<=0},m=function(e){if(e){if(d(e))return!0;var t=e.scrollLeft,n=e.scrollWidth;return t+e.offsetWidth>=n}};function g(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,"disablePageScroll",(function(){return w})),n.d(t,"enablePageScroll",(function(){return b})),n.d(t,"getScrollState",(function(){return S})),n.d(t,"clearQueueScrollLocks",(function(){return E})),n.d(t,"getTargetScrollBarWidth",(function(){return T})),n.d(t,"getCurrentTargetScrollBarWidth",(function(){return _})),n.d(t,"getPageScrollBarWidth",(function(){return C})),n.d(t,"getCurrentPageScrollBarWidth",(function(){return x})),n.d(t,"addScrollableTarget",(function(){return A})),n.d(t,"removeScrollableTarget",(function(){return I})),n.d(t,"addScrollableSelector",(function(){return k})),n.d(t,"removeScrollableSelector",(function(){return L})),n.d(t,"addLockableTarget",(function(){return M})),n.d(t,"addLockableSelector",(function(){return D})),n.d(t,"setFillGapMethod",(function(){return N})),n.d(t,"addFillGapTarget",(function(){return P})),n.d(t,"removeFillGapTarget",(function(){return O})),n.d(t,"addFillGapSelector",(function(){return q})),n.d(t,"removeFillGapSelector",(function(){return R})),n.d(t,"refillGaps",(function(){return F}));var y=["padding","margin","width","max-width","none"],v={scroll:!0,queue:0,scrollableSelectors:["[data-scroll-lock-scrollable]"],lockableSelectors:["body","[data-scroll-lock-lockable]"],fillGapSelectors:["body","[data-scroll-lock-fill-gap]","[data-scroll-lock-lockable]"],fillGapMethod:y[0],startTouchY:0,startTouchX:0},w=function(e){v.queue<=0&&(v.scroll=!1,B(),G()),A(e),v.queue++},b=function(e){v.queue>0&&v.queue--,v.queue<=0&&(v.scroll=!0,$(),H()),I(e)},S=function(){return v.scroll},E=function(){v.queue=0},T=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(s(e)){var n=e.style.overflowY;t?S()||(e.style.overflowY=e.getAttribute("data-scroll-lock-saved-overflow-y-property")):e.style.overflowY="scroll";var r=_(e);return e.style.overflowY=n,r}return 0},_=function(e){if(s(e)){if(e===document.body){var t=document.documentElement.clientWidth;return window.innerWidth-t}var n=e.style.borderLeftWidth,r=e.style.borderRightWidth;e.style.borderLeftWidth="0px",e.style.borderRightWidth="0px";var i=e.offsetWidth-e.clientWidth;return e.style.borderLeftWidth=n,e.style.borderRightWidth=r,i}return 0},C=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return T(document.body,e)},x=function(){return _(document.body)},A=function(e){e&&r(e).map((function(e){i(e,(function(e){s(e)?e.setAttribute("data-scroll-lock-scrollable",""):o('"'.concat(e,'" is not a Element.'))}))}))},I=function(e){e&&r(e).map((function(e){i(e,(function(e){s(e)?e.removeAttribute("data-scroll-lock-scrollable"):o('"'.concat(e,'" is not a Element.'))}))}))},k=function(e){e&&r(e).map((function(e){v.scrollableSelectors.push(e)}))},L=function(e){e&&r(e).map((function(e){v.scrollableSelectors=v.scrollableSelectors.filter((function(t){return t!==e}))}))},M=function(e){e&&(r(e).map((function(e){i(e,(function(e){s(e)?e.setAttribute("data-scroll-lock-lockable",""):o('"'.concat(e,'" is not a Element.'))}))})),S()||B())},D=function(e){e&&(r(e).map((function(e){v.lockableSelectors.push(e)})),S()||B(),q(e))},N=function(e){if(e)if(-1!==y.indexOf(e))v.fillGapMethod=e,F();else{var t=y.join(", ");o('"'.concat(e,'" method is not available!\nAvailable fill gap methods: ').concat(t,"."))}},P=function(e){e&&r(e).map((function(e){i(e,(function(e){s(e)?(e.setAttribute("data-scroll-lock-fill-gap",""),v.scroll||K(e)):o('"'.concat(e,'" is not a Element.'))}))}))},O=function(e){e&&r(e).map((function(e){i(e,(function(e){s(e)?(e.removeAttribute("data-scroll-lock-fill-gap"),v.scroll||Y(e)):o('"'.concat(e,'" is not a Element.'))}))}))},q=function(e){e&&r(e).map((function(e){-1===v.fillGapSelectors.indexOf(e)&&(v.fillGapSelectors.push(e),v.scroll||W(e))}))},R=function(e){e&&r(e).map((function(e){v.fillGapSelectors=v.fillGapSelectors.filter((function(t){return t!==e})),v.scroll||Q(e)}))},F=function(){v.scroll||G()},B=function(){var e=a(v.lockableSelectors);V(e)},$=function(){var e=a(v.lockableSelectors);j(e)},V=function(e){var t=document.querySelectorAll(e);i(t,(function(e){z(e)}))},j=function(e){var t=document.querySelectorAll(e);i(t,(function(e){U(e)}))},z=function(e){if(s(e)&&"true"!==e.getAttribute("data-scroll-lock-locked")){var t=window.getComputedStyle(e);e.setAttribute("data-scroll-lock-saved-overflow-y-property",t.overflowY),e.setAttribute("data-scroll-lock-saved-inline-overflow-property",e.style.overflow),e.setAttribute("data-scroll-lock-saved-inline-overflow-y-property",e.style.overflowY),e.style.overflow="hidden",e.setAttribute("data-scroll-lock-locked","true")}},U=function(e){s(e)&&"true"===e.getAttribute("data-scroll-lock-locked")&&(e.style.overflow=e.getAttribute("data-scroll-lock-saved-inline-overflow-property"),e.style.overflowY=e.getAttribute("data-scroll-lock-saved-inline-overflow-y-property"),e.removeAttribute("data-scroll-lock-saved-overflow-property"),e.removeAttribute("data-scroll-lock-saved-inline-overflow-property"),e.removeAttribute("data-scroll-lock-saved-inline-overflow-y-property"),e.removeAttribute("data-scroll-lock-locked"))},G=function(){v.fillGapSelectors.map((function(e){W(e)}))},H=function(){v.fillGapSelectors.map((function(e){Q(e)}))},W=function(e){var t=document.querySelectorAll(e),n=-1!==v.lockableSelectors.indexOf(e);i(t,(function(e){K(e,n)}))},K=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(s(e)){var n;if(""===e.getAttribute("data-scroll-lock-lockable")||t)n=T(e,!0);else{var r=c(e,a(v.lockableSelectors));n=T(r,!0)}"true"===e.getAttribute("data-scroll-lock-filled-gap")&&Y(e);var i=window.getComputedStyle(e);if(e.setAttribute("data-scroll-lock-filled-gap","true"),e.setAttribute("data-scroll-lock-current-fill-gap-method",v.fillGapMethod),"margin"===v.fillGapMethod){var o=parseFloat(i.marginRight);e.style.marginRight="".concat(o+n,"px")}else if("width"===v.fillGapMethod)e.style.width="calc(100% - ".concat(n,"px)");else if("max-width"===v.fillGapMethod)e.style.maxWidth="calc(100% - ".concat(n,"px)");else if("padding"===v.fillGapMethod){var l=parseFloat(i.paddingRight);e.style.paddingRight="".concat(l+n,"px")}}},Q=function(e){var t=document.querySelectorAll(e);i(t,(function(e){Y(e)}))},Y=function(e){if(s(e)&&"true"===e.getAttribute("data-scroll-lock-filled-gap")){var t=e.getAttribute("data-scroll-lock-current-fill-gap-method");e.removeAttribute("data-scroll-lock-filled-gap"),e.removeAttribute("data-scroll-lock-current-fill-gap-method"),"margin"===t?e.style.marginRight="":"width"===t?e.style.width="":"max-width"===t?e.style.maxWidth="":"padding"===t&&(e.style.paddingRight="")}};"undefined"!=typeof window&&window.addEventListener("resize",(function(e){F()})),"undefined"!=typeof document&&(document.addEventListener("touchstart",(function(e){v.scroll||(v.startTouchY=e.touches[0].clientY,v.startTouchX=e.touches[0].clientX)})),document.addEventListener("touchmove",(function(e){if(!v.scroll){var t=v.startTouchY,n=v.startTouchX,r=e.touches[0].clientY,s=e.touches[0].clientX;if(e.touches.length<2){var i=a(v.scrollableSelectors),o={up:t<r,down:t>r,left:n<s,right:n>s},l={up:t+3<r,down:t-3>r,left:n+3<s,right:n-3>s};!function t(n){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n){var s=c(n,i,!1);if(function(e){return u(e,'input[type="range"]')}(n))return!1;if(r||function(e){return u(e,'textarea, [contenteditable="true"]')}(n)&&c(n,i)||u(n,i)){var a=!1;f(n)&&m(n)?(o.up&&h(n)||o.down&&p(n))&&(a=!0):h(n)&&p(n)?(o.left&&f(n)||o.right&&m(n))&&(a=!0):(l.up&&h(n)||l.down&&p(n)||l.left&&f(n)||l.right&&m(n))&&(a=!0),a&&(s?t(s,!0):e.cancelable&&e.preventDefault())}else t(s)}else e.cancelable&&e.preventDefault()}(e.target)}}}),{passive:!1}),document.addEventListener("touchend",(function(e){v.scroll||(v.startTouchY=0,v.startTouchX=0)})));var X={hide:function(e){o('"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'),w(e)},show:function(e){o('"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'),b(e)},toggle:function(e){o('"toggle" is deprecated! Do not use it.'),S()?w():b(e)},getState:function(){return o('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'),S()},getWidth:function(){return o('"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'),C()},getCurrentWidth:function(){return o('"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'),x()},setScrollableTargets:function(e){o('"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'),A(e)},setFillGapSelectors:function(e){o('"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'),q(e)},setFillGapTargets:function(e){o('"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'),P(e)},clearQueue:function(){o('"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'),E()}},J=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter((function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable})))),r.forEach((function(t){g(e,t,n[t])}))}return e}({disablePageScroll:w,enablePageScroll:b,getScrollState:S,clearQueueScrollLocks:E,getTargetScrollBarWidth:T,getCurrentTargetScrollBarWidth:_,getPageScrollBarWidth:C,getCurrentPageScrollBarWidth:x,addScrollableSelector:k,removeScrollableSelector:L,addScrollableTarget:A,removeScrollableTarget:I,addLockableSelector:D,addLockableTarget:M,addFillGapSelector:q,removeFillGapSelector:R,addFillGapTarget:P,removeFillGapTarget:O,setFillGapMethod:N,refillGaps:F,_state:v},X);t.default=J}]).default},e.exports=t()}},t={};function n(r){var s=t[r];if(void 0!==s)return s.exports;var i=t[r]={exports:{}};return e[r].call(i.exports,i,i.exports,n),i.exports}n.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return n.d(t,{a:t}),t},n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),(()=>{"use strict";n(478),n(841),n(855),n(219);var e=n(139),t=n.n(e);function r(e,t,n,r,s){if(r.querySelector(".klaviyo_messages").innerHTML="",console.log(e),n.length>1&&n.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/))if(123456!==e)(function(e,t,n){void 0===n&&(n={});var r=Object.assign({},n,{g:e,email:t}),s=Object.keys(r).reduce((function(e,t){return e.append(t,r[t]),e}),new URLSearchParams);return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe",{method:"POST",headers:{"Access-Control-Allow-Headers":"*","Content-Type":"application/x-www-form-urlencoded; charset=utf-8"},body:s}).then((function(e){return e.json()}))})(e,n,t).then((e=>{e.success?(r.querySelector(".klaviyo_messages").style.display="none",s.length?window.location.replace(s):r.querySelector(".klaviyo_success").style.display="block",r.querySelectorAll(".form__input").forEach((e=>{e.value=""}))):(r.querySelector(".klaviyo_success").style.display="none",r.querySelector(".klaviyo_messages").style.display="block",e.errors.forEach((function(e){let t=document.createRange().createContextualFragment(`<div>${e}</div>`);r.querySelector(".klaviyo_messages").append(t)})))}));else{r.querySelector(".klaviyo_messages").style.display="block";let e=document.createRange().createContextualFragment("<div>Please use a valid Klaviyo ID.</div>");r.querySelector(".klaviyo_messages").append(e)}}null!==document.querySelector(".form-validate")&&document.querySelectorAll(".form-validate").forEach((e=>{const n=new(t())(e);e.addEventListener("submit",(function(e){e.preventDefault();var t=n.validate();console.log(t)}))})),null!==document.querySelector(".klaviyo-newsletter")&&document.querySelectorAll(".klaviyo-newsletter").forEach((e=>{const t=e.querySelector("[type='submit']"),n=e.querySelector("[type='email']"),s=e.querySelector("[name='g']").value;let i=[],o={},a={};e.addEventListener("submit",(function(t){t.preventDefault(),console.log("---------Submitting form-----------"),i=["Accepts Marketing"],o={},a={},e.querySelectorAll("input").forEach((e=>{"submit"!==e.type&&"hidden"!==e.type&&"email"!==e.type&&"$first_name"!==e.name&&"$last_name"!==e.name&&(i.push(e.name),o[e.name]=e.value)})),e.querySelectorAll("textarea").forEach((e=>{i.push(e.name),o[e.name]=e.value})),e.querySelectorAll("select").forEach((e=>{i.push(e.name),o[e.name]=e.value})),null!==e.querySelector("[name='$first_name']")&&(o.$first_name=e.querySelector("[name='$first_name']").value),null!==e.querySelector("[name='$last_name']")&&(o.$last_name=e.querySelector("[name='$last_name']").value),o["Accepts Marketing"]=!0,a={$fields:i,...o},r(s,a,n.value,e,"")})),t.addEventListener("click",(t=>{t.preventDefault(),console.log("---------Submitting form-----------"),i=["Accepts Marketing"],o={},a={},e.querySelectorAll("input").forEach((e=>{"submit"!==e.type&&"hidden"!==e.type&&"email"!==e.type&&"$consent"!==e.name&&"$first_name"!==e.name&&"$last_name"!==e.name&&(i.push(e.name),o[e.name]=e.value)})),e.querySelectorAll("textarea").forEach((e=>{i.push(e.name),o[e.name]=e.value})),e.querySelectorAll("select").forEach((e=>{i.push(e.name),o[e.name]=e.value})),null!==e.querySelector("[name='$first_name']")&&(o.$first_name=e.querySelector("[name='$first_name']").value),null!==e.querySelector("[name='$last_name']")&&(o.$last_name=e.querySelector("[name='$last_name']").value),o["Accepts Marketing"]=!0,a={$fields:i,...o},r(s,a,n.value,e,"")}))}));var s=n(344),i=n.n(s);function o(e,t){var n;return"string"==typeof e?t?(null!==(n=t[e])&&void 0!==n||(t[e]=document.querySelectorAll(e)),e=t[e]):e=document.querySelectorAll(e):e instanceof Element&&(e=[e]),Array.from(e||[])}null!==document.querySelector(".accordion-container")&&document.querySelectorAll(".accordion-container").forEach((e=>{let t;t=e.hasAttribute("data-accordion-multiple")&&"false"===e.getAttribute("data-accordion-multiple")?new(i())(e,{showMultiple:!1}):new(i())(e),e.classList.contains("accordion-container--open")&&(t.openAll(),setTimeout((()=>{e.querySelector(".ac-panel").classList.remove("!h-full"),e.querySelector(".ac-panel").classList.remove("!transition-none")}),300)),e.querySelectorAll(".ac").forEach(((e,n)=>{e.classList.contains("ac--open")&&t.open(n)})),e.querySelectorAll(".ac-trigger").forEach(((t,n)=>{t.addEventListener("click",(()=>{e.querySelectorAll(".ac").forEach((e=>{e.classList.remove("ac--open")}))}))})),null!==e.querySelector(".ac-close-trigger")&&e.querySelectorAll(".ac-close-trigger").forEach(((e,n)=>{e.addEventListener("click",(()=>{t.closeAll()}))}))}));const a=e=>"function"==typeof e,l={any:0,all:1};function c(e,t,{root:n,margin:r,amount:s="any"}={}){if("undefined"==typeof IntersectionObserver)return()=>{};const i=o(e),c=new WeakMap,u=new IntersectionObserver((e=>{e.forEach((e=>{const n=c.get(e.target);if(e.isIntersecting!==Boolean(n))if(e.isIntersecting){const n=t(e);a(n)?c.set(e.target,n):u.unobserve(e.target)}else n&&(n(e),c.delete(e.target))}))}),{root:n,rootMargin:r,threshold:"number"==typeof s?s:l[s]});return i.forEach((e=>u.observe(e))),()=>u.disconnect()}const u={duration:.3,delay:0,endDelay:0,repeat:0,easing:"ease"},d={ms:e=>1e3*e,s:e=>e/1e3},h=()=>{},p=e=>e;function f(e,t=!0){if(e&&"finished"!==e.playState)try{e.stop?e.stop():(t&&e.commitStyles(),e.cancel())}catch(e){}}const m=e=>e(),g=(e,t,n=u.duration)=>new Proxy({animations:e.map(m).filter(Boolean),duration:n,options:t},y),y={get:(e,t)=>{const n=e.animations[0];switch(t){case"duration":return e.duration;case"currentTime":return d.s((null==n?void 0:n[t])||0);case"playbackRate":case"playState":return null==n?void 0:n[t];case"finished":return e.finished||(e.finished=Promise.all(e.animations.map(v)).catch(h)),e.finished;case"stop":return()=>{e.animations.forEach((e=>f(e)))};case"forEachNative":return t=>{e.animations.forEach((n=>t(n,e)))};default:return void 0===(null==n?void 0:n[t])?void 0:()=>e.animations.forEach((e=>e[t]()))}},set:(e,t,n)=>{switch(t){case"currentTime":n=d.ms(n);case"playbackRate":for(let r=0;r<e.animations.length;r++)e.animations[r][t]=n;return!0}return!1}},v=e=>e.finished,w=e=>"object"==typeof e&&Boolean(e.createAnimation),b=e=>"number"==typeof e,S=e=>Array.isArray(e)&&!b(e[0]),E=(e,t,n)=>-n*e+n*t+e,T=(e,t,n)=>t-e==0?1:(n-e)/(t-e);function _(e,t){const n=e[e.length-1];for(let r=1;r<=t;r++){const s=T(0,t,r);e.push(E(n,1,s))}}function C(e){const t=[0];return _(t,e-1),t}const x=(e,t,n)=>{const r=t-e;return((n-e)%r+r)%r+e};const A=(e,t,n)=>Math.min(Math.max(n,e),t);function I(e,t=C(e.length),n=p){const r=e.length,s=r-t.length;return s>0&&_(t,s),s=>{let i=0;for(;i<r-2&&!(s<t[i+1]);i++);let o=A(0,1,T(t[i],t[i+1],s));const a=function(e,t){return S(e)?e[x(0,e.length,t)]:e}(n,i);return o=a(o),E(e[i],e[i+1],o)}}const k=(e,t,n)=>(((1-3*n+3*t)*e+(3*n-6*t))*e+3*t)*e,L=1e-7,M=12;function D(e,t,n,r){if(e===t&&n===r)return p;const s=t=>function(e,t,n,r,s){let i,o,a=0;do{o=t+(n-t)/2,i=k(o,r,s)-e,i>0?n=o:t=o}while(Math.abs(i)>L&&++a<M);return o}(t,0,1,e,n);return e=>0===e||1===e?e:k(s(e),t,r)}const N=e=>Array.isArray(e)&&b(e[0]),P={ease:D(.25,.1,.25,1),"ease-in":D(.42,0,1,1),"ease-in-out":D(.42,0,.58,1),"ease-out":D(0,0,.58,1)},O=/\((.*?)\)/;function q(e){if(a(e))return e;if(N(e))return D(...e);if(P[e])return P[e];if(e.startsWith("steps")){const t=O.exec(e);if(t){const e=t[1].split(",");return((e,t="end")=>n=>{const r=(n="end"===t?Math.min(n,.999):Math.max(n,.001))*e,s="end"===t?Math.floor(r):Math.ceil(r);return A(0,1,s/e)})(parseFloat(e[0]),e[1].trim())}}return p}class R{constructor(e,t=[0,1],{easing:n,duration:r=u.duration,delay:s=u.delay,endDelay:i=u.endDelay,repeat:o=u.repeat,offset:a,direction:l="normal",autoplay:c=!0}={}){if(this.startTime=null,this.rate=1,this.t=0,this.cancelTimestamp=null,this.easing=p,this.duration=0,this.totalDuration=0,this.repeat=0,this.playState="idle",this.finished=new Promise(((e,t)=>{this.resolve=e,this.reject=t})),n=n||u.easing,w(n)){const e=n.createAnimation(t);n=e.easing,t=e.keyframes||t,r=e.duration||r}this.repeat=o,this.easing=S(n)?p:q(n),this.updateDuration(r);const d=I(t,a,S(n)?n.map(q):p);this.tick=t=>{var n;let r=0;r=void 0!==this.pauseTime?this.pauseTime:(t-this.startTime)*this.rate,this.t=r,r/=1e3,r=Math.max(r-s,0),"finished"===this.playState&&void 0===this.pauseTime&&(r=this.totalDuration);const o=r/this.duration;let a=Math.floor(o),c=o%1;!c&&o>=1&&(c=1),1===c&&a--;const u=a%2;("reverse"===l||"alternate"===l&&u||"alternate-reverse"===l&&!u)&&(c=1-c);const h=r>=this.totalDuration?1:Math.min(c,1),p=d(this.easing(h));e(p);void 0===this.pauseTime&&("finished"===this.playState||r>=this.totalDuration+i)?(this.playState="finished",null===(n=this.resolve)||void 0===n||n.call(this,p)):"idle"!==this.playState&&(this.frameRequestId=requestAnimationFrame(this.tick))},c&&this.play()}play(){const e=performance.now();this.playState="running",void 0!==this.pauseTime?this.startTime=e-this.pauseTime:this.startTime||(this.startTime=e),this.cancelTimestamp=this.startTime,this.pauseTime=void 0,this.frameRequestId=requestAnimationFrame(this.tick)}pause(){this.playState="paused",this.pauseTime=this.t}finish(){this.playState="finished",this.tick(0)}stop(){var e;this.playState="idle",void 0!==this.frameRequestId&&cancelAnimationFrame(this.frameRequestId),null===(e=this.reject)||void 0===e||e.call(this,!1)}cancel(){this.stop(),this.tick(this.cancelTimestamp)}reverse(){this.rate*=-1}commitStyles(){}updateDuration(e){this.duration=e,this.totalDuration=e*(this.repeat+1)}get currentTime(){return this.t}set currentTime(e){void 0!==this.pauseTime||0===this.rate?this.pauseTime=e:this.startTime=performance.now()-e/this.rate}get playbackRate(){return this.rate}set playbackRate(e){this.rate=e}}class F{setAnimation(e){this.animation=e,null==e||e.finished.then((()=>this.clearAnimation())).catch((()=>{}))}clearAnimation(){this.animation=this.generator=void 0}}const B=new WeakMap;function $(e){return B.has(e)||B.set(e,{transforms:[],values:new Map}),B.get(e)}const V=["","X","Y","Z"],j={x:"translateX",y:"translateY",z:"translateZ"},z={syntax:"<angle>",initialValue:"0deg",toDefaultUnit:e=>e+"deg"},U={translate:{syntax:"<length-percentage>",initialValue:"0px",toDefaultUnit:e=>e+"px"},rotate:z,scale:{syntax:"<number>",initialValue:1,toDefaultUnit:p},skew:z},G=new Map,H=e=>`--motion-${e}`,W=["x","y","z"];["translate","scale","rotate","skew"].forEach((e=>{V.forEach((t=>{W.push(e+t),G.set(H(e+t),U[e])}))}));const K=(e,t)=>W.indexOf(e)-W.indexOf(t),Q=new Set(W),Y=e=>Q.has(e),X=(e,t)=>{j[t]&&(t=j[t]);const{transforms:n}=$(e);var r,s;s=t,-1===(r=n).indexOf(s)&&r.push(s),e.style.transform=J(n)},J=e=>e.sort(K).reduce(Z,"").trim(),Z=(e,t)=>`${e} ${t}(var(${H(t)}))`,ee=e=>e.startsWith("--"),te=new Set;const ne=(e,t)=>document.createElement("div").animate(e,t),re={cssRegisterProperty:()=>"undefined"!=typeof CSS&&Object.hasOwnProperty.call(CSS,"registerProperty"),waapi:()=>Object.hasOwnProperty.call(Element.prototype,"animate"),partialKeyframes:()=>{try{ne({opacity:[1]})}catch(e){return!1}return!0},finished:()=>Boolean(ne({opacity:[0,1]},{duration:.001}).finished),linearEasing:()=>{try{ne({opacity:0},{easing:"linear(0, 1)"})}catch(e){return!1}return!0}},se={},ie={};for(const Ph in re)ie[Ph]=()=>(void 0===se[Ph]&&(se[Ph]=re[Ph]()),se[Ph]);const oe=(e,t)=>a(e)?ie.linearEasing()?`linear(${((e,t)=>{let n="";const r=Math.round(t/.015);for(let t=0;t<r;t++)n+=e(T(0,r-1,t))+", ";return n.substring(0,n.length-2)})(e,t)})`:u.easing:N(e)?ae(e):e,ae=([e,t,n,r])=>`cubic-bezier(${e}, ${t}, ${n}, ${r})`;const le=e=>Array.isArray(e)?e:[e];function ce(e){return j[e]&&(e=j[e]),Y(e)?H(e):e}const ue={get:(e,t)=>{t=ce(t);let n=ee(t)?e.style.getPropertyValue(t):getComputedStyle(e)[t];if(!n&&0!==n){const e=G.get(t);e&&(n=e.initialValue)}return n},set:(e,t,n)=>{t=ce(t),ee(t)?e.style.setProperty(t,n):e.style[t]=n}},de=e=>"string"==typeof e;function he(e,t,n,r={},s){const i=window.__MOTION_DEV_TOOLS_RECORD,o=!1!==r.record&&i;let l,{duration:c=u.duration,delay:m=u.delay,endDelay:g=u.endDelay,repeat:y=u.repeat,easing:v=u.easing,persist:E=!1,direction:T,offset:_,allowWebkitAcceleration:C=!1,autoplay:x=!0}=r;const A=$(e),I=Y(t);let k=ie.waapi();I&&X(e,t);const L=ce(t),M=function(e,t){return e.has(t)||e.set(t,new F),e.get(t)}(A.values,L),D=G.get(L);return f(M.animation,!(w(v)&&M.generator)&&!1!==r.record),()=>{const u=()=>{var t,n;return null!==(n=null!==(t=ue.get(e,L))&&void 0!==t?t:null==D?void 0:D.initialValue)&&void 0!==n?n:0};let f=function(e,t){for(let n=0;n<e.length;n++)null===e[n]&&(e[n]=n?e[n-1]:t());return e}(le(n),u);const A=function(e,t){var n;let r=(null==t?void 0:t.toDefaultUnit)||p;const s=e[e.length-1];if(de(s)){const e=(null===(n=s.match(/(-?[\d.]+)([a-z%]*)/))||void 0===n?void 0:n[2])||"";e&&(r=t=>t+e)}return r}(f,D);if(w(v)){const e=v.createAnimation(f,"opacity"!==t,u,L,M);v=e.easing,f=e.keyframes||f,c=e.duration||c}if(ee(L)&&(ie.cssRegisterProperty()?function(e){if(!te.has(e)){te.add(e);try{const{syntax:t,initialValue:n}=G.has(e)?G.get(e):{};CSS.registerProperty({name:e,inherits:!1,syntax:t,initialValue:n})}catch(e){}}}(L):k=!1),I&&!ie.linearEasing()&&(a(v)||S(v)&&v.some(a))&&(k=!1),k){D&&(f=f.map((e=>b(e)?D.toDefaultUnit(e):e))),1!==f.length||ie.partialKeyframes()&&!o||f.unshift(u());const t={delay:d.ms(m),duration:d.ms(c),endDelay:d.ms(g),easing:S(v)?void 0:oe(v,c),direction:T,iterations:y+1,fill:"both"};l=e.animate({[L]:f,offset:_,easing:S(v)?v.map((e=>oe(e,c))):void 0},t),l.finished||(l.finished=new Promise(((e,t)=>{l.onfinish=e,l.oncancel=t})));const n=f[f.length-1];l.finished.then((()=>{E||(ue.set(e,L,n),l.cancel())})).catch(h),C||(l.playbackRate=1.000001)}else if(s&&I)f=f.map((e=>"string"==typeof e?parseFloat(e):e)),1===f.length&&f.unshift(parseFloat(u())),l=new s((t=>{ue.set(e,L,A?A(t):t)}),f,Object.assign(Object.assign({},r),{duration:c,easing:v}));else{const t=f[f.length-1];ue.set(e,L,D&&b(t)?D.toDefaultUnit(t):t)}return o&&i(e,t,f,{duration:c,delay:m,easing:v,repeat:y,offset:_},"motion-one"),M.setAnimation(l),l&&!x&&l.pause(),l}}const pe=(e,t)=>e[t]?Object.assign(Object.assign({},e),e[t]):Object.assign({},e);function fe(e,t,n){return a(e)?e(t,n):e}const me=(ge=R,function(e,t,n={}){const r=(e=o(e)).length;Boolean(r),Boolean(t);const s=[];for(let i=0;i<r;i++){const o=e[i];for(const e in t){const a=pe(n,e);a.delay=fe(a.delay,i,r);const l=he(o,e,t[e],a,ge);s.push(l)}}return g(s,n,n.duration)});var ge;function ye(e,t={}){return g([()=>{const n=new R(e,[0,1],t);return n.finished.catch((()=>{})),n}],t,t.duration)}function ve(e,t,n){return(a(e)?ye:me)(e,t,n)}function we(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var s=0;for(r=Object.getOwnPropertySymbols(e);s<r.length;s++)t.indexOf(r[s])<0&&Object.prototype.propertyIsEnumerable.call(e,r[s])&&(n[r[s]]=e[r[s]])}return n}Object.create;Object.create;"function"==typeof SuppressedError&&SuppressedError;const be=new WeakMap;let Se;function Ee({target:e,contentRect:t,borderBoxSize:n}){var r;null===(r=be.get(e))||void 0===r||r.forEach((r=>{r({target:e,contentSize:t,get size(){return function(e,t){if(t){const{inlineSize:e,blockSize:n}=t[0];return{width:e,height:n}}return e instanceof SVGElement&&"getBBox"in e?e.getBBox():{width:e.offsetWidth,height:e.offsetHeight}}(e,n)}})}))}function Te(e){e.forEach(Ee)}function _e(e,t){Se||"undefined"!=typeof ResizeObserver&&(Se=new ResizeObserver(Te));const n=o(e);return n.forEach((e=>{let n=be.get(e);n||(n=new Set,be.set(e,n)),n.add(t),null==Se||Se.observe(e)})),()=>{n.forEach((e=>{const n=be.get(e);null==n||n.delete(t),(null==n?void 0:n.size)||null==Se||Se.unobserve(e)}))}}const Ce=new Set;let xe;function Ae(e){return Ce.add(e),xe||(xe=()=>{const e={width:window.innerWidth,height:window.innerHeight},t={target:window,size:e,contentSize:e};Ce.forEach((e=>e(t)))},window.addEventListener("resize",xe)),()=>{Ce.delete(e),!Ce.size&&xe&&(xe=void 0)}}const Ie=50,ke={x:{length:"Width",position:"Left"},y:{length:"Height",position:"Top"}};function Le(e,t,n,r){const s=n[t],{length:i,position:o}=ke[t],a=s.current,l=n.time;s.current=e["scroll"+o],s.scrollLength=e["scroll"+i]-e["client"+i],s.offset.length=0,s.offset[0]=0,s.offset[1]=s.scrollLength,s.progress=T(0,s.scrollLength,s.current);const c=r-l;var u,d;s.velocity=c>Ie?0:(u=s.current-a,(d=c)?u*(1e3/d):0)}const Me={Enter:[[0,1],[1,1]],Exit:[[0,0],[1,0]],Any:[[1,0],[0,1]],All:[[0,0],[1,1]]},De={start:0,center:.5,end:1};function Ne(e,t,n=0){let r=0;if(void 0!==De[e]&&(e=De[e]),de(e)){const t=parseFloat(e);e.endsWith("px")?r=t:e.endsWith("%")?e=t/100:e.endsWith("vw")?r=t/100*document.documentElement.clientWidth:e.endsWith("vh")?r=t/100*document.documentElement.clientHeight:e=t}return b(e)&&(r=t*e),n+r}const Pe=[0,0];function Oe(e,t,n,r){let s=Array.isArray(e)?e:Pe,i=0,o=0;return b(e)?s=[e,e]:de(e)&&(s=(e=e.trim()).includes(" ")?e.split(" "):[e,De[e]?e:"0"]),i=Ne(s[0],n,r),o=Ne(s[1],t),i-o}const qe={x:0,y:0};function Re(e,t,n){let{offset:r=Me.All}=n;const{target:s=e,axis:i="y"}=n,o="y"===i?"height":"width",a=s!==e?function(e,t){let n={x:0,y:0},r=e;for(;r&&r!==t;)if(r instanceof HTMLElement)n.x+=r.offsetLeft,n.y+=r.offsetTop,r=r.offsetParent;else if(r instanceof SVGGraphicsElement&&"getBBox"in r){const{top:e,left:t}=r.getBBox();for(n.x+=t,n.y+=e;r&&"svg"!==r.tagName;)r=r.parentNode}return n}(s,e):qe,l=s===e?{width:e.scrollWidth,height:e.scrollHeight}:{width:s.clientWidth,height:s.clientHeight},c={width:e.clientWidth,height:e.clientHeight};t[i].offset.length=0;let u=!t[i].interpolate;const d=r.length;for(let e=0;e<d;e++){const n=Oe(r[e],c[o],l[o],a[i]);u||n===t[i].interpolatorOffsets[e]||(u=!0),t[i].offset[e]=n}u&&(t[i].interpolate=I(C(d),t[i].offset),t[i].interpolatorOffsets=[...t[i].offset]),t[i].progress=t[i].interpolate(t[i].current)}function Fe(e,t,n,r={}){const s=r.axis||"y";return{measure:()=>function(e,t=e,n){if(n.x.targetOffset=0,n.y.targetOffset=0,t!==e){let r=t;for(;r&&r!=e;)n.x.targetOffset+=r.offsetLeft,n.y.targetOffset+=r.offsetTop,r=r.offsetParent}n.x.targetLength=t===e?t.scrollWidth:t.clientWidth,n.y.targetLength=t===e?t.scrollHeight:t.clientHeight,n.x.containerLength=e.clientWidth,n.y.containerLength=e.clientHeight}(e,r.target,n),update:t=>{!function(e,t,n){Le(e,"x",t,n),Le(e,"y",t,n),t.time=n}(e,n,t),(r.offset||r.target)&&Re(e,n,r)},notify:a(t)?()=>t(n):Be(t,n[s])}}function Be(e,t){return e.pause(),e.forEachNative(((e,{easing:t})=>{var n,r;if(e.updateDuration)t||(e.easing=p),e.updateDuration(1);else{const s={duration:1e3};t||(s.easing="linear"),null===(r=null===(n=e.effect)||void 0===n?void 0:n.updateTiming)||void 0===r||r.call(n,s)}})),()=>{e.currentTime=t.progress}}const $e=new WeakMap,Ve=new WeakMap,je=new WeakMap,ze=e=>e===document.documentElement?window:e;function Ue(e,t={}){var{container:n=document.documentElement}=t,r=we(t,["container"]);let s=je.get(n);s||(s=new Set,je.set(n,s));const i=Fe(n,e,{time:0,x:{current:0,offset:[],progress:0,scrollLength:0,targetOffset:0,targetLength:0,containerLength:0,velocity:0},y:{current:0,offset:[],progress:0,scrollLength:0,targetOffset:0,targetLength:0,containerLength:0,velocity:0}},r);if(s.add(i),!$e.has(n)){const e=()=>{const e=performance.now();for(const e of s)e.measure();for(const t of s)t.update(e);for(const e of s)e.notify()};$e.set(n,e);const t=ze(n);window.addEventListener("resize",e,{passive:!0}),n!==document.documentElement&&Ve.set(n,function(e,t){return a(e)?Ae(e):_e(e,t)}(n,e)),t.addEventListener("scroll",e,{passive:!0})}const o=$e.get(n),l=requestAnimationFrame(o);return()=>{var t;"function"!=typeof e&&e.stop(),cancelAnimationFrame(l);const r=je.get(n);if(!r)return;if(r.delete(i),r.size)return;const s=$e.get(n);$e.delete(n),s&&(ze(n).removeEventListener("scroll",s),null===(t=Ve.get(n))||void 0===t||t(),window.removeEventListener("resize",s))}}if(null!==document.querySelector("[data-viewport]")&&document.querySelectorAll("[data-viewport]").forEach((e=>{let t=0,n="any";e.getAttribute("data-viewport-delay")&&(t=Number(1e3*e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-amount")&&(n=Number(e.getAttribute("data-viewport-amount"))),c(e,(()=>{setTimeout((()=>{e.classList.add("in-view")}),t)}),{amount:n})})),null!==document.querySelector('[data-viewport="typography-shift"]')&&document.querySelectorAll('[data-viewport="typography-shift"]').forEach((e=>{let t=0;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),c(e,(({target:e})=>{ve(e.querySelector("span"),{y:["100%","0"],opacity:["0","1"]},{duration:.75,delay:t,easing:[.25,1,.5,1]})}))})),null!==document.querySelector(".shopify-policy__title")){const Oh=document.querySelector(".shopify-policy__title h1");Oh.innerHTML=`<span>${Oh.textContent}</span>`,setTimeout((()=>{Oh.parentElement.style.opacity=1}),50),c(Oh,(({target:e})=>{ve(e.querySelector("span"),{y:["100%","0"],opacity:["0","1"]},{duration:.75,delay:.15,easing:[.25,1,.5,1]})}))}null!==document.querySelector('[data-viewport="shift-up"]')&&document.querySelectorAll('[data-viewport="shift-up"]').forEach((e=>{let t=0,n=0;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-rotate")&&(n=Number(e.getAttribute("data-viewport-rotate"))),c(e,(({target:e})=>{ve(e,{y:["100%","0"],rotate:n,opacity:["0","1"]},{duration:.75,delay:t,easing:[.25,1,.5,1]})}))})),null!==document.querySelector('[data-viewport="blast-up"]')&&document.querySelectorAll('[data-viewport="blast-up"]').forEach((e=>{let t=0,n=0;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-rotate")&&(n=Number(e.getAttribute("data-viewport-rotate"))),c(e,(({target:e})=>{ve(e,{y:["100%","0"],rotate:n},{duration:.6,delay:t,easing:[.25,1,.5,1]})}))})),null!==document.querySelector('[data-viewport="scale-in"]')&&document.querySelectorAll('[data-viewport="scale-in"]').forEach((e=>{let t=0;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),c(e,(({target:e})=>{ve(e,{scale:["1.05","1"],opacity:["0","1"]},{duration:1.5,delay:t,easing:[.25,1,.5,1]})}))})),null!==document.querySelector('[data-viewport="rotate-in"]')&&document.querySelectorAll('[data-viewport="rotate-in"]').forEach((e=>{let t=0,n=0,r="any",s=0;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-x")&&(n=e.getAttribute("data-viewport-x")),e.getAttribute("data-viewport-amount")&&(r=Number(e.getAttribute("data-viewport-amount"))),e.getAttribute("data-viewport-rotate")&&(s=Number(e.getAttribute("data-viewport-rotate"))),c(e,(({target:e})=>{ve(e,{rotate:[-35,s],x:[n,n]},{duration:1.5,delay:t,easing:[.25,1,.5,1]})}),{amount:r})})),null!==document.querySelector('[data-viewport="fade-in"]')&&document.querySelectorAll('[data-viewport="fade-in"]').forEach((e=>{let t=0,n="any";e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-amount")&&(n=Number(e.getAttribute("data-viewport-amount"))),c(e,(({target:e})=>{ve(e,{opacity:["0","1"]},{duration:.75,delay:t,easing:[.25,1,.5,1]})}),{amount:n})})),null!==document.querySelector('[data-viewport="scale-on-scroll"]')&&document.querySelectorAll('[data-viewport="scale-on-scroll"]').forEach((e=>{let t=0,n=.75;e.getAttribute("data-viewport-delay")&&(t=Number(e.getAttribute("data-viewport-delay"))),e.getAttribute("data-viewport-duration")&&(n=Number(e.getAttribute("data-viewport-duration"))),Ue(ve(e,{scale:[1,1.35]})),c(e,(({target:e})=>{ve(e,{scale:["1.05","1"],opacity:["0","1"]},{duration:.75,delay:t,easing:[.25,1,.5,1]})}))}));n(30);const Ge=e=>{for(var t=e.parentNode.childNodes,n=0,r=0;r<t.length;r++){if(t[r]==e)return n;1==t[r].nodeType&&n++}return-1};function He(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function We(e={},t={}){Object.keys(t).forEach((n=>{void 0===e[n]?e[n]=t[n]:He(t[n])&&He(e[n])&&Object.keys(t[n]).length>0&&We(e[n],t[n])}))}const Ke={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function Qe(){const e="undefined"!=typeof document?document:{};return We(e,Ke),e}const Ye={document:Ke,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function Xe(){const e="undefined"!=typeof window?window:{};return We(e,Ye),e}class Je extends Array{constructor(e){"number"==typeof e?super(e):(super(...e||[]),function(e){const t=e.__proto__;Object.defineProperty(e,"__proto__",{get:()=>t,set(e){t.__proto__=e}})}(this))}}function Ze(e=[]){const t=[];return e.forEach((e=>{Array.isArray(e)?t.push(...Ze(e)):t.push(e)})),t}function et(e,t){return Array.prototype.filter.call(e,t)}function tt(e,t){const n=Xe(),r=Qe();let s=[];if(!t&&e instanceof Je)return e;if(!e)return new Je(s);if("string"==typeof e){const n=e.trim();if(n.indexOf("<")>=0&&n.indexOf(">")>=0){let e="div";0===n.indexOf("<li")&&(e="ul"),0===n.indexOf("<tr")&&(e="tbody"),0!==n.indexOf("<td")&&0!==n.indexOf("<th")||(e="tr"),0===n.indexOf("<tbody")&&(e="table"),0===n.indexOf("<option")&&(e="select");const t=r.createElement(e);t.innerHTML=n;for(let e=0;e<t.childNodes.length;e+=1)s.push(t.childNodes[e])}else s=function(e,t){if("string"!=typeof e)return[e];const n=[],r=t.querySelectorAll(e);for(let e=0;e<r.length;e+=1)n.push(r[e]);return n}(e.trim(),t||r)}else if(e.nodeType||e===n||e===r)s.push(e);else if(Array.isArray(e)){if(e instanceof Je)return e;s=e}return new Je(function(e){const t=[];for(let n=0;n<e.length;n+=1)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(s))}tt.fn=Je.prototype;const nt="resize scroll".split(" ");function rt(e){return function(...t){if(void 0===t[0]){for(let t=0;t<this.length;t+=1)nt.indexOf(e)<0&&(e in this[t]?this[t][e]():tt(this[t]).trigger(e));return this}return this.on(e,...t)}}rt("click"),rt("blur"),rt("focus"),rt("focusin"),rt("focusout"),rt("keyup"),rt("keydown"),rt("keypress"),rt("submit"),rt("change"),rt("mousedown"),rt("mousemove"),rt("mouseup"),rt("mouseenter"),rt("mouseleave"),rt("mouseout"),rt("mouseover"),rt("touchstart"),rt("touchend"),rt("touchmove"),rt("resize"),rt("scroll");const st={addClass:function(...e){const t=Ze(e.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.add(...t)})),this},removeClass:function(...e){const t=Ze(e.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.remove(...t)})),this},hasClass:function(...e){const t=Ze(e.map((e=>e.split(" "))));return et(this,(e=>t.filter((t=>e.classList.contains(t))).length>0)).length>0},toggleClass:function(...e){const t=Ze(e.map((e=>e.split(" "))));this.forEach((e=>{t.forEach((t=>{e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(let n=0;n<this.length;n+=1)if(2===arguments.length)this[n].setAttribute(e,t);else for(const t in e)this[n][t]=e[t],this[n].setAttribute(t,e[t]);return this},removeAttr:function(e){for(let t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?`${e}ms`:e;return this},on:function(...e){let[t,n,r,s]=e;function i(e){const t=e.target;if(!t)return;const s=e.target.dom7EventData||[];if(s.indexOf(e)<0&&s.unshift(e),tt(t).is(n))r.apply(t,s);else{const e=tt(t).parents();for(let t=0;t<e.length;t+=1)tt(e[t]).is(n)&&r.apply(e[t],s)}}function o(e){const t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof e[1]&&([t,r,s]=e,n=void 0),s||(s=!1);const a=t.split(" ");let l;for(let e=0;e<this.length;e+=1){const t=this[e];if(n)for(l=0;l<a.length;l+=1){const e=a[l];t.dom7LiveListeners||(t.dom7LiveListeners={}),t.dom7LiveListeners[e]||(t.dom7LiveListeners[e]=[]),t.dom7LiveListeners[e].push({listener:r,proxyListener:i}),t.addEventListener(e,i,s)}else for(l=0;l<a.length;l+=1){const e=a[l];t.dom7Listeners||(t.dom7Listeners={}),t.dom7Listeners[e]||(t.dom7Listeners[e]=[]),t.dom7Listeners[e].push({listener:r,proxyListener:o}),t.addEventListener(e,o,s)}}return this},off:function(...e){let[t,n,r,s]=e;"function"==typeof e[1]&&([t,r,s]=e,n=void 0),s||(s=!1);const i=t.split(" ");for(let e=0;e<i.length;e+=1){const t=i[e];for(let e=0;e<this.length;e+=1){const i=this[e];let o;if(!n&&i.dom7Listeners?o=i.dom7Listeners[t]:n&&i.dom7LiveListeners&&(o=i.dom7LiveListeners[t]),o&&o.length)for(let e=o.length-1;e>=0;e-=1){const n=o[e];r&&n.listener===r||r&&n.listener&&n.listener.dom7proxy&&n.listener.dom7proxy===r?(i.removeEventListener(t,n.proxyListener,s),o.splice(e,1)):r||(i.removeEventListener(t,n.proxyListener,s),o.splice(e,1))}}}return this},trigger:function(...e){const t=Xe(),n=e[0].split(" "),r=e[1];for(let s=0;s<n.length;s+=1){const i=n[s];for(let n=0;n<this.length;n+=1){const s=this[n];if(t.CustomEvent){const n=new t.CustomEvent(i,{detail:r,bubbles:!0,cancelable:!0});s.dom7EventData=e.filter(((e,t)=>t>0)),s.dispatchEvent(n),s.dom7EventData=[],delete s.dom7EventData}}}return this},transitionEnd:function(e){const t=this;return e&&t.on("transitionend",(function n(r){r.target===this&&(e.call(this,r),t.off("transitionend",n))})),this},outerWidth:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetWidth+parseFloat(e.getPropertyValue("margin-right"))+parseFloat(e.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetHeight+parseFloat(e.getPropertyValue("margin-top"))+parseFloat(e.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){const e=Xe();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){const e=Xe(),t=Qe(),n=this[0],r=n.getBoundingClientRect(),s=t.body,i=n.clientTop||s.clientTop||0,o=n.clientLeft||s.clientLeft||0,a=n===e?e.scrollY:n.scrollTop,l=n===e?e.scrollX:n.scrollLeft;return{top:r.top+a-i,left:r.left+l-o}}return null},css:function(e,t){const n=Xe();let r;if(1===arguments.length){if("string"!=typeof e){for(r=0;r<this.length;r+=1)for(const t in e)this[r].style[t]=e[t];return this}if(this[0])return n.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(r=0;r<this.length;r+=1)this[r].style[e]=t;return this}return this},each:function(e){return e?(this.forEach(((t,n)=>{e.apply(t,[t,n])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(let t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(let t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){const t=Xe(),n=Qe(),r=this[0];let s,i;if(!r||void 0===e)return!1;if("string"==typeof e){if(r.matches)return r.matches(e);if(r.webkitMatchesSelector)return r.webkitMatchesSelector(e);if(r.msMatchesSelector)return r.msMatchesSelector(e);for(s=tt(e),i=0;i<s.length;i+=1)if(s[i]===r)return!0;return!1}if(e===n)return r===n;if(e===t)return r===t;if(e.nodeType||e instanceof Je){for(s=e.nodeType?[e]:e,i=0;i<s.length;i+=1)if(s[i]===r)return!0;return!1}return!1},index:function(){let e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;const t=this.length;if(e>t-1)return tt([]);if(e<0){const n=t+e;return tt(n<0?[]:[this[n]])}return tt([this[e]])},append:function(...e){let t;const n=Qe();for(let r=0;r<e.length;r+=1){t=e[r];for(let e=0;e<this.length;e+=1)if("string"==typeof t){const r=n.createElement("div");for(r.innerHTML=t;r.firstChild;)this[e].appendChild(r.firstChild)}else if(t instanceof Je)for(let n=0;n<t.length;n+=1)this[e].appendChild(t[n]);else this[e].appendChild(t)}return this},prepend:function(e){const t=Qe();let n,r;for(n=0;n<this.length;n+=1)if("string"==typeof e){const s=t.createElement("div");for(s.innerHTML=e,r=s.childNodes.length-1;r>=0;r-=1)this[n].insertBefore(s.childNodes[r],this[n].childNodes[0])}else if(e instanceof Je)for(r=0;r<e.length;r+=1)this[n].insertBefore(e[r],this[n].childNodes[0]);else this[n].insertBefore(e,this[n].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&tt(this[0].nextElementSibling).is(e)?tt([this[0].nextElementSibling]):tt([]):this[0].nextElementSibling?tt([this[0].nextElementSibling]):tt([]):tt([])},nextAll:function(e){const t=[];let n=this[0];if(!n)return tt([]);for(;n.nextElementSibling;){const r=n.nextElementSibling;e?tt(r).is(e)&&t.push(r):t.push(r),n=r}return tt(t)},prev:function(e){if(this.length>0){const t=this[0];return e?t.previousElementSibling&&tt(t.previousElementSibling).is(e)?tt([t.previousElementSibling]):tt([]):t.previousElementSibling?tt([t.previousElementSibling]):tt([])}return tt([])},prevAll:function(e){const t=[];let n=this[0];if(!n)return tt([]);for(;n.previousElementSibling;){const r=n.previousElementSibling;e?tt(r).is(e)&&t.push(r):t.push(r),n=r}return tt(t)},parent:function(e){const t=[];for(let n=0;n<this.length;n+=1)null!==this[n].parentNode&&(e?tt(this[n].parentNode).is(e)&&t.push(this[n].parentNode):t.push(this[n].parentNode));return tt(t)},parents:function(e){const t=[];for(let n=0;n<this.length;n+=1){let r=this[n].parentNode;for(;r;)e?tt(r).is(e)&&t.push(r):t.push(r),r=r.parentNode}return tt(t)},closest:function(e){let t=this;return void 0===e?tt([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){const t=[];for(let n=0;n<this.length;n+=1){const r=this[n].querySelectorAll(e);for(let e=0;e<r.length;e+=1)t.push(r[e])}return tt(t)},children:function(e){const t=[];for(let n=0;n<this.length;n+=1){const r=this[n].children;for(let n=0;n<r.length;n+=1)e&&!tt(r[n]).is(e)||t.push(r[n])}return tt(t)},filter:function(e){return tt(et(this,e))},remove:function(){for(let e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};Object.keys(st).forEach((e=>{Object.defineProperty(tt.fn,e,{value:st[e],writable:!0})}));const it=tt;function ot(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function at(){return Date.now()}function lt(e,t){void 0===t&&(t="x");const n=Xe();let r,s,i;const o=function(e){const t=Xe();let n;return t.getComputedStyle&&(n=t.getComputedStyle(e,null)),!n&&e.currentStyle&&(n=e.currentStyle),n||(n=e.style),n}(e);return n.WebKitCSSMatrix?(s=o.transform||o.webkitTransform,s.split(",").length>6&&(s=s.split(", ").map((e=>e.replace(",","."))).join(", ")),i=new n.WebKitCSSMatrix("none"===s?"":s)):(i=o.MozTransform||o.OTransform||o.MsTransform||o.msTransform||o.transform||o.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),r=i.toString().split(",")),"x"===t&&(s=n.WebKitCSSMatrix?i.m41:16===r.length?parseFloat(r[12]):parseFloat(r[4])),"y"===t&&(s=n.WebKitCSSMatrix?i.m42:16===r.length?parseFloat(r[13]):parseFloat(r[5])),s||0}function ct(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function ut(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let r=1;r<arguments.length;r+=1){const s=r<0||arguments.length<=r?void 0:arguments[r];if(null!=s&&(n=s,!("undefined"!=typeof window&&void 0!==window.HTMLElement?n instanceof HTMLElement:n&&(1===n.nodeType||11===n.nodeType)))){const n=Object.keys(Object(s)).filter((e=>t.indexOf(e)<0));for(let t=0,r=n.length;t<r;t+=1){const r=n[t],i=Object.getOwnPropertyDescriptor(s,r);void 0!==i&&i.enumerable&&(ct(e[r])&&ct(s[r])?s[r].__swiper__?e[r]=s[r]:ut(e[r],s[r]):!ct(e[r])&&ct(s[r])?(e[r]={},s[r].__swiper__?e[r]=s[r]:ut(e[r],s[r])):e[r]=s[r])}}}var n;return e}function dt(e,t,n){e.style.setProperty(t,n)}function ht(e){let{swiper:t,targetPosition:n,side:r}=e;const s=Xe(),i=-t.translate;let o,a=null;const l=t.params.speed;t.wrapperEl.style.scrollSnapType="none",s.cancelAnimationFrame(t.cssModeFrameID);const c=n>i?"next":"prev",u=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,d=()=>{o=(new Date).getTime(),null===a&&(a=o);const e=Math.max(Math.min((o-a)/l,1),0),c=.5-Math.cos(e*Math.PI)/2;let h=i+c*(n-i);if(u(h,n)&&(h=n),t.wrapperEl.scrollTo({[r]:h}),u(h,n))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[r]:h})})),void s.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=s.requestAnimationFrame(d)};d()}let pt,ft,mt;function gt(){return pt||(pt=function(){const e=Xe(),t=Qe();return{smoothScroll:t.documentElement&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),passiveListener:function(){let t=!1;try{const n=Object.defineProperty({},"passive",{get(){t=!0}});e.addEventListener("testPassiveListener",null,n)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),pt}function yt(e){return void 0===e&&(e={}),ft||(ft=function(e){let{userAgent:t}=void 0===e?{}:e;const n=gt(),r=Xe(),s=r.navigator.platform,i=t||r.navigator.userAgent,o={ios:!1,android:!1},a=r.screen.width,l=r.screen.height,c=i.match(/(Android);?[\s\/]+([\d.]+)?/);let u=i.match(/(iPad).*OS\s([\d_]+)/);const d=i.match(/(iPod)(.*OS\s([\d_]+))?/),h=!u&&i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),p="Win32"===s;let f="MacIntel"===s;return!u&&f&&n.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${a}x${l}`)>=0&&(u=i.match(/(Version)\/([\d.]+)/),u||(u=[0,1,"13_0_0"]),f=!1),c&&!p&&(o.os="android",o.android=!0),(u||h||d)&&(o.os="ios",o.ios=!0),o}(e)),ft}function vt(){return mt||(mt=function(){const e=Xe();return{isSafari:function(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}(),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)}}()),mt}const wt={on(e,t,n){const r=this;if("function"!=typeof t)return r;const s=n?"unshift":"push";return e.split(" ").forEach((e=>{r.eventsListeners[e]||(r.eventsListeners[e]=[]),r.eventsListeners[e][s](t)})),r},once(e,t,n){const r=this;if("function"!=typeof t)return r;function s(){r.off(e,s),s.__emitterProxy&&delete s.__emitterProxy;for(var n=arguments.length,i=new Array(n),o=0;o<n;o++)i[o]=arguments[o];t.apply(r,i)}return s.__emitterProxy=t,r.on(e,s,n)},onAny(e,t){const n=this;if("function"!=typeof e)return n;const r=t?"unshift":"push";return n.eventsAnyListeners.indexOf(e)<0&&n.eventsAnyListeners[r](e),n},offAny(e){const t=this;if(!t.eventsAnyListeners)return t;const n=t.eventsAnyListeners.indexOf(e);return n>=0&&t.eventsAnyListeners.splice(n,1),t},off(e,t){const n=this;return n.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?n.eventsListeners[e]=[]:n.eventsListeners[e]&&n.eventsListeners[e].forEach(((r,s)=>{(r===t||r.__emitterProxy&&r.__emitterProxy===t)&&n.eventsListeners[e].splice(s,1)}))})),n):n},emit(){const e=this;if(!e.eventsListeners)return e;let t,n,r;for(var s=arguments.length,i=new Array(s),o=0;o<s;o++)i[o]=arguments[o];"string"==typeof i[0]||Array.isArray(i[0])?(t=i[0],n=i.slice(1,i.length),r=e):(t=i[0].events,n=i[0].data,r=i[0].context||e),n.unshift(r);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(r,[t,...n])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(r,n)}))})),e}};const bt={updateSize:function(){const e=this;let t,n;const r=e.$el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:r[0].clientWidth,n=void 0!==e.params.height&&null!==e.params.height?e.params.height:r[0].clientHeight,0===t&&e.isHorizontal()||0===n&&e.isVertical()||(t=t-parseInt(r.css("padding-left")||0,10)-parseInt(r.css("padding-right")||0,10),n=n-parseInt(r.css("padding-top")||0,10)-parseInt(r.css("padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(n)&&(n=0),Object.assign(e,{width:t,height:n,size:e.isHorizontal()?t:n}))},updateSlides:function(){const e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function n(e,n){return parseFloat(e.getPropertyValue(t(n))||0)}const r=e.params,{$wrapperEl:s,size:i,rtlTranslate:o,wrongRTL:a}=e,l=e.virtual&&r.virtual.enabled,c=l?e.virtual.slides.length:e.slides.length,u=s.children(`.${e.params.slideClass}`),d=l?e.virtual.slides.length:u.length;let h=[];const p=[],f=[];let m=r.slidesOffsetBefore;"function"==typeof m&&(m=r.slidesOffsetBefore.call(e));let g=r.slidesOffsetAfter;"function"==typeof g&&(g=r.slidesOffsetAfter.call(e));const y=e.snapGrid.length,v=e.slidesGrid.length;let w=r.spaceBetween,b=-m,S=0,E=0;if(void 0===i)return;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*i),e.virtualSize=-w,o?u.css({marginLeft:"",marginBottom:"",marginTop:""}):u.css({marginRight:"",marginBottom:"",marginTop:""}),r.centeredSlides&&r.cssMode&&(dt(e.wrapperEl,"--swiper-centered-offset-before",""),dt(e.wrapperEl,"--swiper-centered-offset-after",""));const T=r.grid&&r.grid.rows>1&&e.grid;let _;T&&e.grid.initSlides(d);const C="auto"===r.slidesPerView&&r.breakpoints&&Object.keys(r.breakpoints).filter((e=>void 0!==r.breakpoints[e].slidesPerView)).length>0;for(let s=0;s<d;s+=1){_=0;const o=u.eq(s);if(T&&e.grid.updateSlide(s,o,d,t),"none"!==o.css("display")){if("auto"===r.slidesPerView){C&&(u[s].style[t("width")]="");const i=getComputedStyle(o[0]),a=o[0].style.transform,l=o[0].style.webkitTransform;if(a&&(o[0].style.transform="none"),l&&(o[0].style.webkitTransform="none"),r.roundLengths)_=e.isHorizontal()?o.outerWidth(!0):o.outerHeight(!0);else{const e=n(i,"width"),t=n(i,"padding-left"),r=n(i,"padding-right"),s=n(i,"margin-left"),a=n(i,"margin-right"),l=i.getPropertyValue("box-sizing");if(l&&"border-box"===l)_=e+s+a;else{const{clientWidth:n,offsetWidth:i}=o[0];_=e+t+r+s+a+(i-n)}}a&&(o[0].style.transform=a),l&&(o[0].style.webkitTransform=l),r.roundLengths&&(_=Math.floor(_))}else _=(i-(r.slidesPerView-1)*w)/r.slidesPerView,r.roundLengths&&(_=Math.floor(_)),u[s]&&(u[s].style[t("width")]=`${_}px`);u[s]&&(u[s].swiperSlideSize=_),f.push(_),r.centeredSlides?(b=b+_/2+S/2+w,0===S&&0!==s&&(b=b-i/2-w),0===s&&(b=b-i/2-w),Math.abs(b)<.001&&(b=0),r.roundLengths&&(b=Math.floor(b)),E%r.slidesPerGroup==0&&h.push(b),p.push(b)):(r.roundLengths&&(b=Math.floor(b)),(E-Math.min(e.params.slidesPerGroupSkip,E))%e.params.slidesPerGroup==0&&h.push(b),p.push(b),b=b+_+w),e.virtualSize+=_+w,S=_,E+=1}}if(e.virtualSize=Math.max(e.virtualSize,i)+g,o&&a&&("slide"===r.effect||"coverflow"===r.effect)&&s.css({width:`${e.virtualSize+r.spaceBetween}px`}),r.setWrapperSize&&s.css({[t("width")]:`${e.virtualSize+r.spaceBetween}px`}),T&&e.grid.updateWrapperSize(_,h,t),!r.centeredSlides){const t=[];for(let n=0;n<h.length;n+=1){let s=h[n];r.roundLengths&&(s=Math.floor(s)),h[n]<=e.virtualSize-i&&t.push(s)}h=t,Math.floor(e.virtualSize-i)-Math.floor(h[h.length-1])>1&&h.push(e.virtualSize-i)}if(0===h.length&&(h=[0]),0!==r.spaceBetween){const n=e.isHorizontal()&&o?"marginLeft":t("marginRight");u.filter(((e,t)=>!r.cssMode||t!==u.length-1)).css({[n]:`${w}px`})}if(r.centeredSlides&&r.centeredSlidesBounds){let e=0;f.forEach((t=>{e+=t+(r.spaceBetween?r.spaceBetween:0)})),e-=r.spaceBetween;const t=e-i;h=h.map((e=>e<0?-m:e>t?t+g:e))}if(r.centerInsufficientSlides){let e=0;if(f.forEach((t=>{e+=t+(r.spaceBetween?r.spaceBetween:0)})),e-=r.spaceBetween,e<i){const t=(i-e)/2;h.forEach(((e,n)=>{h[n]=e-t})),p.forEach(((e,n)=>{p[n]=e+t}))}}if(Object.assign(e,{slides:u,snapGrid:h,slidesGrid:p,slidesSizesGrid:f}),r.centeredSlides&&r.cssMode&&!r.centeredSlidesBounds){dt(e.wrapperEl,"--swiper-centered-offset-before",-h[0]+"px"),dt(e.wrapperEl,"--swiper-centered-offset-after",e.size/2-f[f.length-1]/2+"px");const t=-e.snapGrid[0],n=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+n))}if(d!==c&&e.emit("slidesLengthChange"),h.length!==y&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),p.length!==v&&e.emit("slidesGridLengthChange"),r.watchSlidesProgress&&e.updateSlidesOffset(),!(l||r.cssMode||"slide"!==r.effect&&"fade"!==r.effect)){const t=`${r.containerModifierClass}backface-hidden`,n=e.$el.hasClass(t);d<=r.maxBackfaceHiddenSlides?n||e.$el.addClass(t):n&&e.$el.removeClass(t)}},updateAutoHeight:function(e){const t=this,n=[],r=t.virtual&&t.params.virtual.enabled;let s,i=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const o=e=>r?t.slides.filter((t=>parseInt(t.getAttribute("data-swiper-slide-index"),10)===e))[0]:t.slides.eq(e)[0];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)t.visibleSlides.each((e=>{n.push(e)}));else for(s=0;s<Math.ceil(t.params.slidesPerView);s+=1){const e=t.activeIndex+s;if(e>t.slides.length&&!r)break;n.push(o(e))}else n.push(o(t.activeIndex));for(s=0;s<n.length;s+=1)if(void 0!==n[s]){const e=n[s].offsetHeight;i=e>i?e:i}(i||0===i)&&t.$wrapperEl.css("height",`${i}px`)},updateSlidesOffset:function(){const e=this,t=e.slides;for(let n=0;n<t.length;n+=1)t[n].swiperSlideOffset=e.isHorizontal()?t[n].offsetLeft:t[n].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,n=t.params,{slides:r,rtlTranslate:s,snapGrid:i}=t;if(0===r.length)return;void 0===r[0].swiperSlideOffset&&t.updateSlidesOffset();let o=-e;s&&(o=e),r.removeClass(n.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(let e=0;e<r.length;e+=1){const a=r[e];let l=a.swiperSlideOffset;n.cssMode&&n.centeredSlides&&(l-=r[0].swiperSlideOffset);const c=(o+(n.centeredSlides?t.minTranslate():0)-l)/(a.swiperSlideSize+n.spaceBetween),u=(o-i[0]+(n.centeredSlides?t.minTranslate():0)-l)/(a.swiperSlideSize+n.spaceBetween),d=-(o-l),h=d+t.slidesSizesGrid[e];(d>=0&&d<t.size-1||h>1&&h<=t.size||d<=0&&h>=t.size)&&(t.visibleSlides.push(a),t.visibleSlidesIndexes.push(e),r.eq(e).addClass(n.slideVisibleClass)),a.progress=s?-c:c,a.originalProgress=s?-u:u}t.visibleSlides=it(t.visibleSlides)},updateProgress:function(e){const t=this;if(void 0===e){const n=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*n||0}const n=t.params,r=t.maxTranslate()-t.minTranslate();let{progress:s,isBeginning:i,isEnd:o}=t;const a=i,l=o;0===r?(s=0,i=!0,o=!0):(s=(e-t.minTranslate())/r,i=s<=0,o=s>=1),Object.assign(t,{progress:s,isBeginning:i,isEnd:o}),(n.watchSlidesProgress||n.centeredSlides&&n.autoHeight)&&t.updateSlidesProgress(e),i&&!a&&t.emit("reachBeginning toEdge"),o&&!l&&t.emit("reachEnd toEdge"),(a&&!i||l&&!o)&&t.emit("fromEdge"),t.emit("progress",s)},updateSlidesClasses:function(){const e=this,{slides:t,params:n,$wrapperEl:r,activeIndex:s,realIndex:i}=e,o=e.virtual&&n.virtual.enabled;let a;t.removeClass(`${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`),a=o?e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${s}"]`):t.eq(s),a.addClass(n.slideActiveClass),n.loop&&(a.hasClass(n.slideDuplicateClass)?r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${i}"]`).addClass(n.slideDuplicateActiveClass):r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${i}"]`).addClass(n.slideDuplicateActiveClass));let l=a.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);n.loop&&0===l.length&&(l=t.eq(0),l.addClass(n.slideNextClass));let c=a.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);n.loop&&0===c.length&&(c=t.eq(-1),c.addClass(n.slidePrevClass)),n.loop&&(l.hasClass(n.slideDuplicateClass)?r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass):r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicateNextClass),c.hasClass(n.slideDuplicateClass)?r.children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass):r.children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`).addClass(n.slideDuplicatePrevClass)),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,n=t.rtlTranslate?t.translate:-t.translate,{slidesGrid:r,snapGrid:s,params:i,activeIndex:o,realIndex:a,snapIndex:l}=t;let c,u=e;if(void 0===u){for(let e=0;e<r.length;e+=1)void 0!==r[e+1]?n>=r[e]&&n<r[e+1]-(r[e+1]-r[e])/2?u=e:n>=r[e]&&n<r[e+1]&&(u=e+1):n>=r[e]&&(u=e);i.normalizeSlideIndex&&(u<0||void 0===u)&&(u=0)}if(s.indexOf(n)>=0)c=s.indexOf(n);else{const e=Math.min(i.slidesPerGroupSkip,u);c=e+Math.floor((u-e)/i.slidesPerGroup)}if(c>=s.length&&(c=s.length-1),u===o)return void(c!==l&&(t.snapIndex=c,t.emit("snapIndexChange")));const d=parseInt(t.slides.eq(u).attr("data-swiper-slide-index")||u,10);Object.assign(t,{snapIndex:c,realIndex:d,previousIndex:o,activeIndex:u}),t.emit("activeIndexChange"),t.emit("snapIndexChange"),a!==d&&t.emit("realIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&t.emit("slideChange")},updateClickedSlide:function(e){const t=this,n=t.params,r=it(e).closest(`.${n.slideClass}`)[0];let s,i=!1;if(r)for(let e=0;e<t.slides.length;e+=1)if(t.slides[e]===r){i=!0,s=e;break}if(!r||!i)return t.clickedSlide=void 0,void(t.clickedIndex=void 0);t.clickedSlide=r,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(it(r).attr("data-swiper-slide-index"),10):t.clickedIndex=s,n.slideToClickedSlide&&void 0!==t.clickedIndex&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}};const St={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:n,translate:r,$wrapperEl:s}=this;if(t.virtualTranslate)return n?-r:r;if(t.cssMode)return r;let i=lt(s[0],e);return n&&(i=-i),i||0},setTranslate:function(e,t){const n=this,{rtlTranslate:r,params:s,$wrapperEl:i,wrapperEl:o,progress:a}=n;let l,c=0,u=0;n.isHorizontal()?c=r?-e:e:u=e,s.roundLengths&&(c=Math.floor(c),u=Math.floor(u)),s.cssMode?o[n.isHorizontal()?"scrollLeft":"scrollTop"]=n.isHorizontal()?-c:-u:s.virtualTranslate||i.transform(`translate3d(${c}px, ${u}px, 0px)`),n.previousTranslate=n.translate,n.translate=n.isHorizontal()?c:u;const d=n.maxTranslate()-n.minTranslate();l=0===d?0:(e-n.minTranslate())/d,l!==a&&n.updateProgress(e),n.emit("setTranslate",n.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,n,r,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===n&&(n=!0),void 0===r&&(r=!0);const i=this,{params:o,wrapperEl:a}=i;if(i.animating&&o.preventInteractionOnTransition)return!1;const l=i.minTranslate(),c=i.maxTranslate();let u;if(u=r&&e>l?l:r&&e<c?c:e,i.updateProgress(u),o.cssMode){const e=i.isHorizontal();if(0===t)a[e?"scrollLeft":"scrollTop"]=-u;else{if(!i.support.smoothScroll)return ht({swiper:i,targetPosition:-u,side:e?"left":"top"}),!0;a.scrollTo({[e?"left":"top"]:-u,behavior:"smooth"})}return!0}return 0===t?(i.setTransition(0),i.setTranslate(u),n&&(i.emit("beforeTransitionStart",t,s),i.emit("transitionEnd"))):(i.setTransition(t),i.setTranslate(u),n&&(i.emit("beforeTransitionStart",t,s),i.emit("transitionStart")),i.animating||(i.animating=!0,i.onTranslateToWrapperTransitionEnd||(i.onTranslateToWrapperTransitionEnd=function(e){i&&!i.destroyed&&e.target===this&&(i.$wrapperEl[0].removeEventListener("transitionend",i.onTranslateToWrapperTransitionEnd),i.$wrapperEl[0].removeEventListener("webkitTransitionEnd",i.onTranslateToWrapperTransitionEnd),i.onTranslateToWrapperTransitionEnd=null,delete i.onTranslateToWrapperTransitionEnd,n&&i.emit("transitionEnd"))}),i.$wrapperEl[0].addEventListener("transitionend",i.onTranslateToWrapperTransitionEnd),i.$wrapperEl[0].addEventListener("webkitTransitionEnd",i.onTranslateToWrapperTransitionEnd))),!0}};function Et(e){let{swiper:t,runCallbacks:n,direction:r,step:s}=e;const{activeIndex:i,previousIndex:o}=t;let a=r;if(a||(a=i>o?"next":i<o?"prev":"reset"),t.emit(`transition${s}`),n&&i!==o){if("reset"===a)return void t.emit(`slideResetTransition${s}`);t.emit(`slideChangeTransition${s}`),"next"===a?t.emit(`slideNextTransition${s}`):t.emit(`slidePrevTransition${s}`)}}const Tt={setTransition:function(e,t){const n=this;n.params.cssMode||n.$wrapperEl.transition(e),n.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const n=this,{params:r}=n;r.cssMode||(r.autoHeight&&n.updateAutoHeight(),Et({swiper:n,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const n=this,{params:r}=n;n.animating=!1,r.cssMode||(n.setTransition(0),Et({swiper:n,runCallbacks:e,direction:t,step:"End"}))}};const _t={slideTo:function(e,t,n,r,s){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===n&&(n=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);if("string"==typeof e){const t=parseInt(e,10);if(!isFinite(t))throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);e=t}const i=this;let o=e;o<0&&(o=0);const{params:a,snapGrid:l,slidesGrid:c,previousIndex:u,activeIndex:d,rtlTranslate:h,wrapperEl:p,enabled:f}=i;if(i.animating&&a.preventInteractionOnTransition||!f&&!r&&!s)return!1;const m=Math.min(i.params.slidesPerGroupSkip,o);let g=m+Math.floor((o-m)/i.params.slidesPerGroup);g>=l.length&&(g=l.length-1),(d||a.initialSlide||0)===(u||0)&&n&&i.emit("beforeSlideChangeStart");const y=-l[g];if(i.updateProgress(y),a.normalizeSlideIndex)for(let e=0;e<c.length;e+=1){const t=-Math.floor(100*y),n=Math.floor(100*c[e]),r=Math.floor(100*c[e+1]);void 0!==c[e+1]?t>=n&&t<r-(r-n)/2?o=e:t>=n&&t<r&&(o=e+1):t>=n&&(o=e)}if(i.initialized&&o!==d){if(!i.allowSlideNext&&y<i.translate&&y<i.minTranslate())return!1;if(!i.allowSlidePrev&&y>i.translate&&y>i.maxTranslate()&&(d||0)!==o)return!1}let v;if(v=o>d?"next":o<d?"prev":"reset",h&&-y===i.translate||!h&&y===i.translate)return i.updateActiveIndex(o),a.autoHeight&&i.updateAutoHeight(),i.updateSlidesClasses(),"slide"!==a.effect&&i.setTranslate(y),"reset"!==v&&(i.transitionStart(n,v),i.transitionEnd(n,v)),!1;if(a.cssMode){const e=i.isHorizontal(),n=h?y:-y;if(0===t){const t=i.virtual&&i.params.virtual.enabled;t&&(i.wrapperEl.style.scrollSnapType="none",i._immediateVirtual=!0),p[e?"scrollLeft":"scrollTop"]=n,t&&requestAnimationFrame((()=>{i.wrapperEl.style.scrollSnapType="",i._swiperImmediateVirtual=!1}))}else{if(!i.support.smoothScroll)return ht({swiper:i,targetPosition:n,side:e?"left":"top"}),!0;p.scrollTo({[e?"left":"top"]:n,behavior:"smooth"})}return!0}return i.setTransition(t),i.setTranslate(y),i.updateActiveIndex(o),i.updateSlidesClasses(),i.emit("beforeTransitionStart",t,r),i.transitionStart(n,v),0===t?i.transitionEnd(n,v):i.animating||(i.animating=!0,i.onSlideToWrapperTransitionEnd||(i.onSlideToWrapperTransitionEnd=function(e){i&&!i.destroyed&&e.target===this&&(i.$wrapperEl[0].removeEventListener("transitionend",i.onSlideToWrapperTransitionEnd),i.$wrapperEl[0].removeEventListener("webkitTransitionEnd",i.onSlideToWrapperTransitionEnd),i.onSlideToWrapperTransitionEnd=null,delete i.onSlideToWrapperTransitionEnd,i.transitionEnd(n,v))}),i.$wrapperEl[0].addEventListener("transitionend",i.onSlideToWrapperTransitionEnd),i.$wrapperEl[0].addEventListener("webkitTransitionEnd",i.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,n,r){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===n&&(n=!0);const s=this;let i=e;return s.params.loop&&(i+=s.loopedSlides),s.slideTo(i,t,n,r)},slideNext:function(e,t,n){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const r=this,{animating:s,enabled:i,params:o}=r;if(!i)return r;let a=o.slidesPerGroup;"auto"===o.slidesPerView&&1===o.slidesPerGroup&&o.slidesPerGroupAuto&&(a=Math.max(r.slidesPerViewDynamic("current",!0),1));const l=r.activeIndex<o.slidesPerGroupSkip?1:a;if(o.loop){if(s&&o.loopPreventsSlide)return!1;r.loopFix(),r._clientLeft=r.$wrapperEl[0].clientLeft}return o.rewind&&r.isEnd?r.slideTo(0,e,t,n):r.slideTo(r.activeIndex+l,e,t,n)},slidePrev:function(e,t,n){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const r=this,{params:s,animating:i,snapGrid:o,slidesGrid:a,rtlTranslate:l,enabled:c}=r;if(!c)return r;if(s.loop){if(i&&s.loopPreventsSlide)return!1;r.loopFix(),r._clientLeft=r.$wrapperEl[0].clientLeft}function u(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const d=u(l?r.translate:-r.translate),h=o.map((e=>u(e)));let p=o[h.indexOf(d)-1];if(void 0===p&&s.cssMode){let e;o.forEach(((t,n)=>{d>=t&&(e=n)})),void 0!==e&&(p=o[e>0?e-1:e])}let f=0;if(void 0!==p&&(f=a.indexOf(p),f<0&&(f=r.activeIndex-1),"auto"===s.slidesPerView&&1===s.slidesPerGroup&&s.slidesPerGroupAuto&&(f=f-r.slidesPerViewDynamic("previous",!0)+1,f=Math.max(f,0))),s.rewind&&r.isBeginning){const s=r.params.virtual&&r.params.virtual.enabled&&r.virtual?r.virtual.slides.length-1:r.slides.length-1;return r.slideTo(s,e,t,n)}return r.slideTo(f,e,t,n)},slideReset:function(e,t,n){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,n)},slideToClosest:function(e,t,n,r){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===r&&(r=.5);const s=this;let i=s.activeIndex;const o=Math.min(s.params.slidesPerGroupSkip,i),a=o+Math.floor((i-o)/s.params.slidesPerGroup),l=s.rtlTranslate?s.translate:-s.translate;if(l>=s.snapGrid[a]){const e=s.snapGrid[a];l-e>(s.snapGrid[a+1]-e)*r&&(i+=s.params.slidesPerGroup)}else{const e=s.snapGrid[a-1];l-e<=(s.snapGrid[a]-e)*r&&(i-=s.params.slidesPerGroup)}return i=Math.max(i,0),i=Math.min(i,s.slidesGrid.length-1),s.slideTo(i,e,t,n)},slideToClickedSlide:function(){const e=this,{params:t,$wrapperEl:n}=e,r="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let s,i=e.clickedIndex;if(t.loop){if(e.animating)return;s=parseInt(it(e.clickedSlide).attr("data-swiper-slide-index"),10),t.centeredSlides?i<e.loopedSlides-r/2||i>e.slides.length-e.loopedSlides+r/2?(e.loopFix(),i=n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),ot((()=>{e.slideTo(i)}))):e.slideTo(i):i>e.slides.length-r?(e.loopFix(),i=n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),ot((()=>{e.slideTo(i)}))):e.slideTo(i)}else e.slideTo(i)}};const Ct={loopCreate:function(){const e=this,t=Qe(),{params:n,$wrapperEl:r}=e,s=r.children().length>0?it(r.children()[0].parentNode):r;s.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();let i=s.children(`.${n.slideClass}`);if(n.loopFillGroupWithBlank){const e=n.slidesPerGroup-i.length%n.slidesPerGroup;if(e!==n.slidesPerGroup){for(let r=0;r<e;r+=1){const e=it(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);s.append(e)}i=s.children(`.${n.slideClass}`)}}"auto"!==n.slidesPerView||n.loopedSlides||(n.loopedSlides=i.length),e.loopedSlides=Math.ceil(parseFloat(n.loopedSlides||n.slidesPerView,10)),e.loopedSlides+=n.loopAdditionalSlides,e.loopedSlides>i.length&&(e.loopedSlides=i.length);const o=[],a=[];i.each(((t,n)=>{const r=it(t);n<e.loopedSlides&&a.push(t),n<i.length&&n>=i.length-e.loopedSlides&&o.push(t),r.attr("data-swiper-slide-index",n)}));for(let e=0;e<a.length;e+=1)s.append(it(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));for(let e=o.length-1;e>=0;e-=1)s.prepend(it(o[e].cloneNode(!0)).addClass(n.slideDuplicateClass))},loopFix:function(){const e=this;e.emit("beforeLoopFix");const{activeIndex:t,slides:n,loopedSlides:r,allowSlidePrev:s,allowSlideNext:i,snapGrid:o,rtlTranslate:a}=e;let l;e.allowSlidePrev=!0,e.allowSlideNext=!0;const c=-o[t]-e.getTranslate();if(t<r){l=n.length-3*r+t,l+=r;e.slideTo(l,0,!1,!0)&&0!==c&&e.setTranslate((a?-e.translate:e.translate)-c)}else if(t>=n.length-r){l=-n.length+t+r,l+=r;e.slideTo(l,0,!1,!0)&&0!==c&&e.setTranslate((a?-e.translate:e.translate)-c)}e.allowSlidePrev=s,e.allowSlideNext=i,e.emit("loopFix")},loopDestroy:function(){const{$wrapperEl:e,params:t,slides:n}=this;e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),n.removeAttr("data-swiper-slide-index")}};const xt={setGrabCursor:function(e){const t=this;if(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const n="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;n.style.cursor="move",n.style.cursor=e?"-webkit-grabbing":"-webkit-grab",n.style.cursor=e?"-moz-grabbin":"-moz-grab",n.style.cursor=e?"grabbing":"grab"},unsetGrabCursor:function(){const e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="")}};function At(e){const t=this,n=Qe(),r=Xe(),s=t.touchEventsData,{params:i,touches:o,enabled:a}=t;if(!a)return;if(t.animating&&i.preventInteractionOnTransition)return;!t.animating&&i.cssMode&&i.loop&&t.loopFix();let l=e;l.originalEvent&&(l=l.originalEvent);let c=it(l.target);if("wrapper"===i.touchEventsTarget&&!c.closest(t.wrapperEl).length)return;if(s.isTouchEvent="touchstart"===l.type,!s.isTouchEvent&&"which"in l&&3===l.which)return;if(!s.isTouchEvent&&"button"in l&&l.button>0)return;if(s.isTouched&&s.isMoved)return;!!i.noSwipingClass&&""!==i.noSwipingClass&&l.target&&l.target.shadowRoot&&e.path&&e.path[0]&&(c=it(e.path[0]));const u=i.noSwipingSelector?i.noSwipingSelector:`.${i.noSwipingClass}`,d=!(!l.target||!l.target.shadowRoot);if(i.noSwiping&&(d?function(e,t){return void 0===t&&(t=this),function t(n){return n&&n!==Qe()&&n!==Xe()?(n.assignedSlot&&(n=n.assignedSlot),n.closest(e)||t(n.getRootNode().host)):null}(t)}(u,l.target):c.closest(u)[0]))return void(t.allowClick=!0);if(i.swipeHandler&&!c.closest(i.swipeHandler)[0])return;o.currentX="touchstart"===l.type?l.targetTouches[0].pageX:l.pageX,o.currentY="touchstart"===l.type?l.targetTouches[0].pageY:l.pageY;const h=o.currentX,p=o.currentY,f=i.edgeSwipeDetection||i.iOSEdgeSwipeDetection,m=i.edgeSwipeThreshold||i.iOSEdgeSwipeThreshold;if(f&&(h<=m||h>=r.innerWidth-m)){if("prevent"!==f)return;e.preventDefault()}if(Object.assign(s,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=h,o.startY=p,s.touchStartTime=at(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,i.threshold>0&&(s.allowThresholdMove=!1),"touchstart"!==l.type){let e=!0;c.is(s.focusableElements)&&(e=!1,"SELECT"===c[0].nodeName&&(s.isTouched=!1)),n.activeElement&&it(n.activeElement).is(s.focusableElements)&&n.activeElement!==c[0]&&n.activeElement.blur();const r=e&&t.allowTouchMove&&i.touchStartPreventDefault;!i.touchStartForcePreventDefault&&!r||c[0].isContentEditable||l.preventDefault()}t.params.freeMode&&t.params.freeMode.enabled&&t.freeMode&&t.animating&&!i.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",l)}function It(e){const t=Qe(),n=this,r=n.touchEventsData,{params:s,touches:i,rtlTranslate:o,enabled:a}=n;if(!a)return;let l=e;if(l.originalEvent&&(l=l.originalEvent),!r.isTouched)return void(r.startMoving&&r.isScrolling&&n.emit("touchMoveOpposite",l));if(r.isTouchEvent&&"touchmove"!==l.type)return;const c="touchmove"===l.type&&l.targetTouches&&(l.targetTouches[0]||l.changedTouches[0]),u="touchmove"===l.type?c.pageX:l.pageX,d="touchmove"===l.type?c.pageY:l.pageY;if(l.preventedByNestedSwiper)return i.startX=u,void(i.startY=d);if(!n.allowTouchMove)return it(l.target).is(r.focusableElements)||(n.allowClick=!1),void(r.isTouched&&(Object.assign(i,{startX:u,startY:d,currentX:u,currentY:d}),r.touchStartTime=at()));if(r.isTouchEvent&&s.touchReleaseOnEdges&&!s.loop)if(n.isVertical()){if(d<i.startY&&n.translate<=n.maxTranslate()||d>i.startY&&n.translate>=n.minTranslate())return r.isTouched=!1,void(r.isMoved=!1)}else if(u<i.startX&&n.translate<=n.maxTranslate()||u>i.startX&&n.translate>=n.minTranslate())return;if(r.isTouchEvent&&t.activeElement&&l.target===t.activeElement&&it(l.target).is(r.focusableElements))return r.isMoved=!0,void(n.allowClick=!1);if(r.allowTouchCallbacks&&n.emit("touchMove",l),l.targetTouches&&l.targetTouches.length>1)return;i.currentX=u,i.currentY=d;const h=i.currentX-i.startX,p=i.currentY-i.startY;if(n.params.threshold&&Math.sqrt(h**2+p**2)<n.params.threshold)return;if(void 0===r.isScrolling){let e;n.isHorizontal()&&i.currentY===i.startY||n.isVertical()&&i.currentX===i.startX?r.isScrolling=!1:h*h+p*p>=25&&(e=180*Math.atan2(Math.abs(p),Math.abs(h))/Math.PI,r.isScrolling=n.isHorizontal()?e>s.touchAngle:90-e>s.touchAngle)}if(r.isScrolling&&n.emit("touchMoveOpposite",l),void 0===r.startMoving&&(i.currentX===i.startX&&i.currentY===i.startY||(r.startMoving=!0)),r.isScrolling)return void(r.isTouched=!1);if(!r.startMoving)return;n.allowClick=!1,!s.cssMode&&l.cancelable&&l.preventDefault(),s.touchMoveStopPropagation&&!s.nested&&l.stopPropagation(),r.isMoved||(s.loop&&!s.cssMode&&n.loopFix(),r.startTranslate=n.getTranslate(),n.setTransition(0),n.animating&&n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),r.allowMomentumBounce=!1,!s.grabCursor||!0!==n.allowSlideNext&&!0!==n.allowSlidePrev||n.setGrabCursor(!0),n.emit("sliderFirstMove",l)),n.emit("sliderMove",l),r.isMoved=!0;let f=n.isHorizontal()?h:p;i.diff=f,f*=s.touchRatio,o&&(f=-f),n.swipeDirection=f>0?"prev":"next",r.currentTranslate=f+r.startTranslate;let m=!0,g=s.resistanceRatio;if(s.touchReleaseOnEdges&&(g=0),f>0&&r.currentTranslate>n.minTranslate()?(m=!1,s.resistance&&(r.currentTranslate=n.minTranslate()-1+(-n.minTranslate()+r.startTranslate+f)**g)):f<0&&r.currentTranslate<n.maxTranslate()&&(m=!1,s.resistance&&(r.currentTranslate=n.maxTranslate()+1-(n.maxTranslate()-r.startTranslate-f)**g)),m&&(l.preventedByNestedSwiper=!0),!n.allowSlideNext&&"next"===n.swipeDirection&&r.currentTranslate<r.startTranslate&&(r.currentTranslate=r.startTranslate),!n.allowSlidePrev&&"prev"===n.swipeDirection&&r.currentTranslate>r.startTranslate&&(r.currentTranslate=r.startTranslate),n.allowSlidePrev||n.allowSlideNext||(r.currentTranslate=r.startTranslate),s.threshold>0){if(!(Math.abs(f)>s.threshold||r.allowThresholdMove))return void(r.currentTranslate=r.startTranslate);if(!r.allowThresholdMove)return r.allowThresholdMove=!0,i.startX=i.currentX,i.startY=i.currentY,r.currentTranslate=r.startTranslate,void(i.diff=n.isHorizontal()?i.currentX-i.startX:i.currentY-i.startY)}s.followFinger&&!s.cssMode&&((s.freeMode&&s.freeMode.enabled&&n.freeMode||s.watchSlidesProgress)&&(n.updateActiveIndex(),n.updateSlidesClasses()),n.params.freeMode&&s.freeMode.enabled&&n.freeMode&&n.freeMode.onTouchMove(),n.updateProgress(r.currentTranslate),n.setTranslate(r.currentTranslate))}function kt(e){const t=this,n=t.touchEventsData,{params:r,touches:s,rtlTranslate:i,slidesGrid:o,enabled:a}=t;if(!a)return;let l=e;if(l.originalEvent&&(l=l.originalEvent),n.allowTouchCallbacks&&t.emit("touchEnd",l),n.allowTouchCallbacks=!1,!n.isTouched)return n.isMoved&&r.grabCursor&&t.setGrabCursor(!1),n.isMoved=!1,void(n.startMoving=!1);r.grabCursor&&n.isMoved&&n.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const c=at(),u=c-n.touchStartTime;if(t.allowClick){const e=l.path||l.composedPath&&l.composedPath();t.updateClickedSlide(e&&e[0]||l.target),t.emit("tap click",l),u<300&&c-n.lastClickTime<300&&t.emit("doubleTap doubleClick",l)}if(n.lastClickTime=at(),ot((()=>{t.destroyed||(t.allowClick=!0)})),!n.isTouched||!n.isMoved||!t.swipeDirection||0===s.diff||n.currentTranslate===n.startTranslate)return n.isTouched=!1,n.isMoved=!1,void(n.startMoving=!1);let d;if(n.isTouched=!1,n.isMoved=!1,n.startMoving=!1,d=r.followFinger?i?t.translate:-t.translate:-n.currentTranslate,r.cssMode)return;if(t.params.freeMode&&r.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:d});let h=0,p=t.slidesSizesGrid[0];for(let e=0;e<o.length;e+=e<r.slidesPerGroupSkip?1:r.slidesPerGroup){const t=e<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;void 0!==o[e+t]?d>=o[e]&&d<o[e+t]&&(h=e,p=o[e+t]-o[e]):d>=o[e]&&(h=e,p=o[o.length-1]-o[o.length-2])}let f=null,m=null;r.rewind&&(t.isBeginning?m=t.params.virtual&&t.params.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(f=0));const g=(d-o[h])/p,y=h<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;if(u>r.longSwipesMs){if(!r.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(g>=r.longSwipesRatio?t.slideTo(r.rewind&&t.isEnd?f:h+y):t.slideTo(h)),"prev"===t.swipeDirection&&(g>1-r.longSwipesRatio?t.slideTo(h+y):null!==m&&g<0&&Math.abs(g)>r.longSwipesRatio?t.slideTo(m):t.slideTo(h))}else{if(!r.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(l.target===t.navigation.nextEl||l.target===t.navigation.prevEl)?l.target===t.navigation.nextEl?t.slideTo(h+y):t.slideTo(h):("next"===t.swipeDirection&&t.slideTo(null!==f?f:h+y),"prev"===t.swipeDirection&&t.slideTo(null!==m?m:h))}}function Lt(){const e=this,{params:t,el:n}=e;if(n&&0===n.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:r,allowSlidePrev:s,snapGrid:i}=e;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=s,e.allowSlideNext=r,e.params.watchOverflow&&i!==e.snapGrid&&e.checkOverflow()}function Mt(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function Dt(){const e=this,{wrapperEl:t,rtlTranslate:n,enabled:r}=e;if(!r)return;let s;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,-0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const i=e.maxTranslate()-e.minTranslate();s=0===i?0:(e.translate-e.minTranslate())/i,s!==e.progress&&e.updateProgress(n?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}let Nt=!1;function Pt(){}const Ot=(e,t)=>{const n=Qe(),{params:r,touchEvents:s,el:i,wrapperEl:o,device:a,support:l}=e,c=!!r.nested,u="on"===t?"addEventListener":"removeEventListener",d=t;if(l.touch){const t=!("touchstart"!==s.start||!l.passiveListener||!r.passiveListeners)&&{passive:!0,capture:!1};i[u](s.start,e.onTouchStart,t),i[u](s.move,e.onTouchMove,l.passiveListener?{passive:!1,capture:c}:c),i[u](s.end,e.onTouchEnd,t),s.cancel&&i[u](s.cancel,e.onTouchEnd,t)}else i[u](s.start,e.onTouchStart,!1),n[u](s.move,e.onTouchMove,c),n[u](s.end,e.onTouchEnd,!1);(r.preventClicks||r.preventClicksPropagation)&&i[u]("click",e.onClick,!0),r.cssMode&&o[u]("scroll",e.onScroll),r.updateOnWindowResize?e[d](a.ios||a.android?"resize orientationchange observerUpdate":"resize observerUpdate",Lt,!0):e[d]("observerUpdate",Lt,!0)};const qt={attachEvents:function(){const e=this,t=Qe(),{params:n,support:r}=e;e.onTouchStart=At.bind(e),e.onTouchMove=It.bind(e),e.onTouchEnd=kt.bind(e),n.cssMode&&(e.onScroll=Dt.bind(e)),e.onClick=Mt.bind(e),r.touch&&!Nt&&(t.addEventListener("touchstart",Pt),Nt=!0),Ot(e,"on")},detachEvents:function(){Ot(this,"off")}},Rt=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;const Ft={setBreakpoint:function(){const e=this,{activeIndex:t,initialized:n,loopedSlides:r=0,params:s,$el:i}=e,o=s.breakpoints;if(!o||o&&0===Object.keys(o).length)return;const a=e.getBreakpoint(o,e.params.breakpointsBase,e.el);if(!a||e.currentBreakpoint===a)return;const l=(a in o?o[a]:void 0)||e.originalParams,c=Rt(e,s),u=Rt(e,l),d=s.enabled;c&&!u?(i.removeClass(`${s.containerModifierClass}grid ${s.containerModifierClass}grid-column`),e.emitContainerClasses()):!c&&u&&(i.addClass(`${s.containerModifierClass}grid`),(l.grid.fill&&"column"===l.grid.fill||!l.grid.fill&&"column"===s.grid.fill)&&i.addClass(`${s.containerModifierClass}grid-column`),e.emitContainerClasses());const h=l.direction&&l.direction!==s.direction,p=s.loop&&(l.slidesPerView!==s.slidesPerView||h);h&&n&&e.changeDirection(),ut(e.params,l);const f=e.params.enabled;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),d&&!f?e.disable():!d&&f&&e.enable(),e.currentBreakpoint=a,e.emit("_beforeBreakpoint",l),p&&n&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-r+e.loopedSlides,0,!1)),e.emit("breakpoint",l)},getBreakpoint:function(e,t,n){if(void 0===t&&(t="window"),!e||"container"===t&&!n)return;let r=!1;const s=Xe(),i="window"===t?s.innerHeight:n.clientHeight,o=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:i*t,point:e}}return{value:e,point:e}}));o.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<o.length;e+=1){const{point:i,value:a}=o[e];"window"===t?s.matchMedia(`(min-width: ${a}px)`).matches&&(r=i):a<=n.clientWidth&&(r=i)}return r||"max"}};const Bt={addClasses:function(){const e=this,{classNames:t,params:n,rtl:r,$el:s,device:i,support:o}=e,a=function(e,t){const n=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((r=>{e[r]&&n.push(t+r)})):"string"==typeof e&&n.push(t+e)})),n}(["initialized",n.direction,{"pointer-events":!o.touch},{"free-mode":e.params.freeMode&&n.freeMode.enabled},{autoheight:n.autoHeight},{rtl:r},{grid:n.grid&&n.grid.rows>1},{"grid-column":n.grid&&n.grid.rows>1&&"column"===n.grid.fill},{android:i.android},{ios:i.ios},{"css-mode":n.cssMode},{centered:n.cssMode&&n.centeredSlides}],n.containerModifierClass);t.push(...a),s.addClass([...t].join(" ")),e.emitContainerClasses()},removeClasses:function(){const{$el:e,classNames:t}=this;e.removeClass(t.join(" ")),this.emitContainerClasses()}};const $t={loadImage:function(e,t,n,r,s,i){const o=Xe();let a;function l(){i&&i()}it(e).parent("picture")[0]||e.complete&&s?l():t?(a=new o.Image,a.onload=l,a.onerror=l,r&&(a.sizes=r),n&&(a.srcset=n),t&&(a.src=t)):l()},preloadImages:function(){const e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(let n=0;n<e.imagesToLoad.length;n+=1){const r=e.imagesToLoad[n];e.loadImage(r,r.currentSrc||r.getAttribute("src"),r.srcset||r.getAttribute("srcset"),r.sizes||r.getAttribute("sizes"),!0,t)}}};const Vt={checkOverflow:function(){const e=this,{isLocked:t,params:n}=e,{slidesOffsetBefore:r}=n;if(r){const t=e.slides.length-1,n=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*r;e.isLocked=e.size>n}else e.isLocked=1===e.snapGrid.length;!0===n.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===n.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},jt={init:!0,direction:"horizontal",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1};function zt(e,t){return function(n){void 0===n&&(n={});const r=Object.keys(n)[0],s=n[r];"object"==typeof s&&null!==s?(["navigation","pagination","scrollbar"].indexOf(r)>=0&&!0===e[r]&&(e[r]={auto:!0}),r in e&&"enabled"in s?(!0===e[r]&&(e[r]={enabled:!0}),"object"!=typeof e[r]||"enabled"in e[r]||(e[r].enabled=!0),e[r]||(e[r]={enabled:!1}),ut(t,n)):ut(t,n)):ut(t,n)}}const Ut={eventsEmitter:wt,update:bt,translate:St,transition:Tt,slide:_t,loop:Ct,grabCursor:xt,events:qt,breakpoints:Ft,checkOverflow:Vt,classes:Bt,images:$t},Gt={};class Ht{constructor(){let e,t;for(var n=arguments.length,r=new Array(n),s=0;s<n;s++)r[s]=arguments[s];if(1===r.length&&r[0].constructor&&"Object"===Object.prototype.toString.call(r[0]).slice(8,-1)?t=r[0]:[e,t]=r,t||(t={}),t=ut({},t),e&&!t.el&&(t.el=e),t.el&&it(t.el).length>1){const e=[];return it(t.el).each((n=>{const r=ut({},t,{el:n});e.push(new Ht(r))})),e}const i=this;i.__swiper__=!0,i.support=gt(),i.device=yt({userAgent:t.userAgent}),i.browser=vt(),i.eventsListeners={},i.eventsAnyListeners=[],i.modules=[...i.__modules__],t.modules&&Array.isArray(t.modules)&&i.modules.push(...t.modules);const o={};i.modules.forEach((e=>{e({swiper:i,extendParams:zt(t,o),on:i.on.bind(i),once:i.once.bind(i),off:i.off.bind(i),emit:i.emit.bind(i)})}));const a=ut({},jt,o);return i.params=ut({},a,Gt,t),i.originalParams=ut({},i.params),i.passedParams=ut({},t),i.params&&i.params.on&&Object.keys(i.params.on).forEach((e=>{i.on(e,i.params.on[e])})),i.params&&i.params.onAny&&i.onAny(i.params.onAny),i.$=it,Object.assign(i,{enabled:i.params.enabled,el:e,classNames:[],slides:it(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===i.params.direction,isVertical:()=>"vertical"===i.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:i.params.allowSlideNext,allowSlidePrev:i.params.allowSlidePrev,touchEvents:function(){const e=["touchstart","touchmove","touchend","touchcancel"],t=["pointerdown","pointermove","pointerup"];return i.touchEventsTouch={start:e[0],move:e[1],end:e[2],cancel:e[3]},i.touchEventsDesktop={start:t[0],move:t[1],end:t[2]},i.support.touch||!i.params.simulateTouch?i.touchEventsTouch:i.touchEventsDesktop}(),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:i.params.focusableElements,lastClickTime:at(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:i.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),i.emit("_swiper"),i.params.init&&i.init(),i}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const n=this;e=Math.min(Math.max(e,0),1);const r=n.minTranslate(),s=(n.maxTranslate()-r)*e+r;n.translateTo(s,void 0===t?0:t),n.updateActiveIndex(),n.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.each((n=>{const r=e.getSlideClasses(n);t.push({slideEl:n,classNames:r}),e.emit("_slideClass",n,r)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:n,slides:r,slidesGrid:s,slidesSizesGrid:i,size:o,activeIndex:a}=this;let l=1;if(n.centeredSlides){let e,t=r[a].swiperSlideSize;for(let n=a+1;n<r.length;n+=1)r[n]&&!e&&(t+=r[n].swiperSlideSize,l+=1,t>o&&(e=!0));for(let n=a-1;n>=0;n-=1)r[n]&&!e&&(t+=r[n].swiperSlideSize,l+=1,t>o&&(e=!0))}else if("current"===e)for(let e=a+1;e<r.length;e+=1){(t?s[e]+i[e]-s[a]<o:s[e]-s[a]<o)&&(l+=1)}else for(let e=a-1;e>=0;e-=1){s[a]-s[e]<o&&(l+=1)}return l}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:n}=e;function r(){const t=e.rtlTranslate?-1*e.translate:e.translate,n=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(n),e.updateActiveIndex(),e.updateSlidesClasses()}let s;n.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode&&e.params.freeMode.enabled?(r(),e.params.autoHeight&&e.updateAutoHeight()):(s=("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),s||r()),n.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const n=this,r=n.params.direction;return e||(e="horizontal"===r?"vertical":"horizontal"),e===r||"horizontal"!==e&&"vertical"!==e||(n.$el.removeClass(`${n.params.containerModifierClass}${r}`).addClass(`${n.params.containerModifierClass}${e}`),n.emitContainerClasses(),n.params.direction=e,n.slides.each((t=>{"vertical"===e?t.style.width="":t.style.height=""})),n.emit("changeDirection"),t&&n.update()),n}mount(e){const t=this;if(t.mounted)return!0;const n=it(e||t.params.el);if(!(e=n[0]))return!1;e.swiper=t;const r=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let s=(()=>{if(e&&e.shadowRoot&&e.shadowRoot.querySelector){const t=it(e.shadowRoot.querySelector(r()));return t.children=e=>n.children(e),t}return n.children(r())})();if(0===s.length&&t.params.createElements){const e=Qe().createElement("div");s=it(e),e.className=t.params.wrapperClass,n.append(e),n.children(`.${t.params.slideClass}`).each((e=>{s.append(e)}))}return Object.assign(t,{$el:n,el:e,$wrapperEl:s,wrapperEl:s[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===n.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===n.css("direction")),wrongRTL:"-webkit-box"===s.css("display")}),!0}init(e){const t=this;if(t.initialized)return t;return!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const n=this,{params:r,$el:s,$wrapperEl:i,slides:o}=n;return void 0===n.params||n.destroyed||(n.emit("beforeDestroy"),n.initialized=!1,n.detachEvents(),r.loop&&n.loopDestroy(),t&&(n.removeClasses(),s.removeAttr("style"),i.removeAttr("style"),o&&o.length&&o.removeClass([r.slideVisibleClass,r.slideActiveClass,r.slideNextClass,r.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),n.emit("destroy"),Object.keys(n.eventsListeners).forEach((e=>{n.off(e)})),!1!==e&&(n.$el[0].swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(n)),n.destroyed=!0),null}static extendDefaults(e){ut(Gt,e)}static get extendedDefaults(){return Gt}static get defaults(){return jt}static installModule(e){Ht.prototype.__modules__||(Ht.prototype.__modules__=[]);const t=Ht.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>Ht.installModule(e))),Ht):(Ht.installModule(e),Ht)}}Object.keys(Ut).forEach((e=>{Object.keys(Ut[e]).forEach((t=>{Ht.prototype[t]=Ut[e][t]}))})),Ht.use([function(e){let{swiper:t,on:n,emit:r}=e;const s=Xe();let i=null,o=null;const a=()=>{t&&!t.destroyed&&t.initialized&&(r("beforeResize"),r("resize"))},l=()=>{t&&!t.destroyed&&t.initialized&&r("orientationchange")};n("init",(()=>{t.params.resizeObserver&&void 0!==s.ResizeObserver?t&&!t.destroyed&&t.initialized&&(i=new ResizeObserver((e=>{o=s.requestAnimationFrame((()=>{const{width:n,height:r}=t;let s=n,i=r;e.forEach((e=>{let{contentBoxSize:n,contentRect:r,target:o}=e;o&&o!==t.el||(s=r?r.width:(n[0]||n).inlineSize,i=r?r.height:(n[0]||n).blockSize)})),s===n&&i===r||a()}))})),i.observe(t.el)):(s.addEventListener("resize",a),s.addEventListener("orientationchange",l))})),n("destroy",(()=>{o&&s.cancelAnimationFrame(o),i&&i.unobserve&&t.el&&(i.unobserve(t.el),i=null),s.removeEventListener("resize",a),s.removeEventListener("orientationchange",l)}))},function(e){let{swiper:t,extendParams:n,on:r,emit:s}=e;const i=[],o=Xe(),a=function(e,t){void 0===t&&(t={});const n=new(o.MutationObserver||o.WebkitMutationObserver)((e=>{if(1===e.length)return void s("observerUpdate",e[0]);const t=function(){s("observerUpdate",e[0])};o.requestAnimationFrame?o.requestAnimationFrame(t):o.setTimeout(t,0)}));n.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),i.push(n)};n({observer:!1,observeParents:!1,observeSlideChildren:!1}),r("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=t.$el.parents();for(let t=0;t<e.length;t+=1)a(e[t])}a(t.$el[0],{childList:t.params.observeSlideChildren}),a(t.$wrapperEl[0],{attributes:!1})}})),r("destroy",(()=>{i.forEach((e=>{e.disconnect()})),i.splice(0,i.length)}))}]);const Wt=Ht;function Kt(e){let{swiper:t,extendParams:n,on:r,emit:s}=e;const i=Xe();let o;n({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}}),t.mousewheel={enabled:!1};let a,l=at();const c=[];function u(){t.enabled&&(t.mouseEntered=!0)}function d(){t.enabled&&(t.mouseEntered=!1)}function h(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&at()-l<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&at()-l<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),s("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),s("scroll",e.raw)),l=(new i.Date).getTime(),!1)))}function p(e){let n=e,r=!0;if(!t.enabled)return;const i=t.params.mousewheel;t.params.cssMode&&n.preventDefault();let l=t.$el;if("container"!==t.params.mousewheel.eventsTarget&&(l=it(t.params.mousewheel.eventsTarget)),!t.mouseEntered&&!l[0].contains(n.target)&&!i.releaseOnEdges)return!0;n.originalEvent&&(n=n.originalEvent);let u=0;const d=t.rtlTranslate?-1:1,p=function(e){let t=0,n=0,r=0,s=0;return"detail"in e&&(n=e.detail),"wheelDelta"in e&&(n=-e.wheelDelta/120),"wheelDeltaY"in e&&(n=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=n,n=0),r=10*t,s=10*n,"deltaY"in e&&(s=e.deltaY),"deltaX"in e&&(r=e.deltaX),e.shiftKey&&!r&&(r=s,s=0),(r||s)&&e.deltaMode&&(1===e.deltaMode?(r*=40,s*=40):(r*=800,s*=800)),r&&!t&&(t=r<1?-1:1),s&&!n&&(n=s<1?-1:1),{spinX:t,spinY:n,pixelX:r,pixelY:s}}(n);if(i.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(p.pixelX)>Math.abs(p.pixelY)))return!0;u=-p.pixelX*d}else{if(!(Math.abs(p.pixelY)>Math.abs(p.pixelX)))return!0;u=-p.pixelY}else u=Math.abs(p.pixelX)>Math.abs(p.pixelY)?-p.pixelX*d:-p.pixelY;if(0===u)return!0;i.invert&&(u=-u);let f=t.getTranslate()+u*i.sensitivity;if(f>=t.minTranslate()&&(f=t.minTranslate()),f<=t.maxTranslate()&&(f=t.maxTranslate()),r=!!t.params.loop||!(f===t.minTranslate()||f===t.maxTranslate()),r&&t.params.nested&&n.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:at(),delta:Math.abs(u),direction:Math.sign(u)},r=a&&e.time<a.time+500&&e.delta<=a.delta&&e.direction===a.direction;if(!r){a=void 0,t.params.loop&&t.loopFix();let l=t.getTranslate()+u*i.sensitivity;const d=t.isBeginning,h=t.isEnd;if(l>=t.minTranslate()&&(l=t.minTranslate()),l<=t.maxTranslate()&&(l=t.maxTranslate()),t.setTransition(0),t.setTranslate(l),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!d&&t.isBeginning||!h&&t.isEnd)&&t.updateSlidesClasses(),t.params.freeMode.sticky){clearTimeout(o),o=void 0,c.length>=15&&c.shift();const n=c.length?c[c.length-1]:void 0,r=c[0];if(c.push(e),n&&(e.delta>n.delta||e.direction!==n.direction))c.splice(0);else if(c.length>=15&&e.time-r.time<500&&r.delta-e.delta>=1&&e.delta<=6){const n=u>0?.8:.2;a=e,c.splice(0),o=ot((()=>{t.slideToClosest(t.params.speed,!0,void 0,n)}),0)}o||(o=ot((()=>{a=e,c.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(r||s("scroll",n),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),l===t.minTranslate()||l===t.maxTranslate())return!0}}else{const n={time:at(),delta:Math.abs(u),direction:Math.sign(u),raw:e};c.length>=2&&c.shift();const r=c.length?c[c.length-1]:void 0;if(c.push(n),r?(n.direction!==r.direction||n.delta>r.delta||n.time>r.time+150)&&h(n):h(n),function(e){const n=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&n.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&n.releaseOnEdges)return!0;return!1}(n))return!0}return n.preventDefault?n.preventDefault():n.returnValue=!1,!1}function f(e){let n=t.$el;"container"!==t.params.mousewheel.eventsTarget&&(n=it(t.params.mousewheel.eventsTarget)),n[e]("mouseenter",u),n[e]("mouseleave",d),n[e]("wheel",p)}function m(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",p),!0):!t.mousewheel.enabled&&(f("on"),t.mousewheel.enabled=!0,!0)}function g(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,p),!0):!!t.mousewheel.enabled&&(f("off"),t.mousewheel.enabled=!1,!0)}r("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&g(),t.params.mousewheel.enabled&&m()})),r("destroy",(()=>{t.params.cssMode&&m(),t.mousewheel.enabled&&g()})),Object.assign(t.mousewheel,{enable:m,disable:g})}function Qt(e,t,n,r){const s=Qe();return e.params.createElements&&Object.keys(r).forEach((i=>{if(!n[i]&&!0===n.auto){let o=e.$el.children(`.${r[i]}`)[0];o||(o=s.createElement("div"),o.className=r[i],e.$el.append(o)),n[i]=o,t[i]=o}})),n}function Yt(e){let{swiper:t,extendParams:n,on:r,emit:s}=e;function i(e){let n;return e&&(n=it(e),t.params.uniqueNavElements&&"string"==typeof e&&n.length>1&&1===t.$el.find(e).length&&(n=t.$el.find(e))),n}function o(e,n){const r=t.params.navigation;e&&e.length>0&&(e[n?"addClass":"removeClass"](r.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=n),t.params.watchOverflow&&t.enabled&&e[t.isLocked?"addClass":"removeClass"](r.lockClass))}function a(){if(t.params.loop)return;const{$nextEl:e,$prevEl:n}=t.navigation;o(n,t.isBeginning&&!t.params.rewind),o(e,t.isEnd&&!t.params.rewind)}function l(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&t.slidePrev()}function c(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&t.slideNext()}function u(){const e=t.params.navigation;if(t.params.navigation=Qt(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;const n=i(e.nextEl),r=i(e.prevEl);n&&n.length>0&&n.on("click",c),r&&r.length>0&&r.on("click",l),Object.assign(t.navigation,{$nextEl:n,nextEl:n&&n[0],$prevEl:r,prevEl:r&&r[0]}),t.enabled||(n&&n.addClass(e.lockClass),r&&r.addClass(e.lockClass))}function d(){const{$nextEl:e,$prevEl:n}=t.navigation;e&&e.length&&(e.off("click",c),e.removeClass(t.params.navigation.disabledClass)),n&&n.length&&(n.off("click",l),n.removeClass(t.params.navigation.disabledClass))}n({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}}),t.navigation={nextEl:null,$nextEl:null,prevEl:null,$prevEl:null},r("init",(()=>{u(),a()})),r("toEdge fromEdge lock unlock",(()=>{a()})),r("destroy",(()=>{d()})),r("enable disable",(()=>{const{$nextEl:e,$prevEl:n}=t.navigation;e&&e[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass),n&&n[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass)})),r("click",((e,n)=>{const{$nextEl:r,$prevEl:i}=t.navigation,o=n.target;if(t.params.navigation.hideOnClick&&!it(o).is(i)&&!it(o).is(r)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===o||t.pagination.el.contains(o)))return;let e;r?e=r.hasClass(t.params.navigation.hiddenClass):i&&(e=i.hasClass(t.params.navigation.hiddenClass)),s(!0===e?"navigationShow":"navigationHide"),r&&r.toggleClass(t.params.navigation.hiddenClass),i&&i.toggleClass(t.params.navigation.hiddenClass)}})),Object.assign(t.navigation,{update:a,init:u,destroy:d})}function Xt(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}`}function Jt(e){let{swiper:t,extendParams:n,on:r,emit:s}=e;const i="swiper-pagination";let o;n({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${i}-bullet`,bulletActiveClass:`${i}-bullet-active`,modifierClass:`${i}-`,currentClass:`${i}-current`,totalClass:`${i}-total`,hiddenClass:`${i}-hidden`,progressbarFillClass:`${i}-progressbar-fill`,progressbarOppositeClass:`${i}-progressbar-opposite`,clickableClass:`${i}-clickable`,lockClass:`${i}-lock`,horizontalClass:`${i}-horizontal`,verticalClass:`${i}-vertical`}}),t.pagination={el:null,$el:null,bullets:[]};let a=0;function l(){return!t.params.pagination.el||!t.pagination.el||!t.pagination.$el||0===t.pagination.$el.length}function c(e,n){const{bulletActiveClass:r}=t.params.pagination;e[n]().addClass(`${r}-${n}`)[n]().addClass(`${r}-${n}-${n}`)}function u(){const e=t.rtl,n=t.params.pagination;if(l())return;const r=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,i=t.pagination.$el;let u;const d=t.params.loop?Math.ceil((r-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(u=Math.ceil((t.activeIndex-t.loopedSlides)/t.params.slidesPerGroup),u>r-1-2*t.loopedSlides&&(u-=r-2*t.loopedSlides),u>d-1&&(u-=d),u<0&&"bullets"!==t.params.paginationType&&(u=d+u)):u=void 0!==t.snapIndex?t.snapIndex:t.activeIndex||0,"bullets"===n.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const r=t.pagination.bullets;let s,l,d;if(n.dynamicBullets&&(o=r.eq(0)[t.isHorizontal()?"outerWidth":"outerHeight"](!0),i.css(t.isHorizontal()?"width":"height",o*(n.dynamicMainBullets+4)+"px"),n.dynamicMainBullets>1&&void 0!==t.previousIndex&&(a+=u-(t.previousIndex-t.loopedSlides||0),a>n.dynamicMainBullets-1?a=n.dynamicMainBullets-1:a<0&&(a=0)),s=Math.max(u-a,0),l=s+(Math.min(r.length,n.dynamicMainBullets)-1),d=(l+s)/2),r.removeClass(["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${n.bulletActiveClass}${e}`)).join(" ")),i.length>1)r.each((e=>{const t=it(e),r=t.index();r===u&&t.addClass(n.bulletActiveClass),n.dynamicBullets&&(r>=s&&r<=l&&t.addClass(`${n.bulletActiveClass}-main`),r===s&&c(t,"prev"),r===l&&c(t,"next"))}));else{const e=r.eq(u),i=e.index();if(e.addClass(n.bulletActiveClass),n.dynamicBullets){const e=r.eq(s),o=r.eq(l);for(let e=s;e<=l;e+=1)r.eq(e).addClass(`${n.bulletActiveClass}-main`);if(t.params.loop)if(i>=r.length){for(let e=n.dynamicMainBullets;e>=0;e-=1)r.eq(r.length-e).addClass(`${n.bulletActiveClass}-main`);r.eq(r.length-n.dynamicMainBullets-1).addClass(`${n.bulletActiveClass}-prev`)}else c(e,"prev"),c(o,"next");else c(e,"prev"),c(o,"next")}}if(n.dynamicBullets){const s=Math.min(r.length,n.dynamicMainBullets+4),i=(o*s-o)/2-d*o,a=e?"right":"left";r.css(t.isHorizontal()?a:"top",`${i}px`)}}if("fraction"===n.type&&(i.find(Xt(n.currentClass)).text(n.formatFractionCurrent(u+1)),i.find(Xt(n.totalClass)).text(n.formatFractionTotal(d))),"progressbar"===n.type){let e;e=n.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const r=(u+1)/d;let s=1,o=1;"horizontal"===e?s=r:o=r,i.find(Xt(n.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${s}) scaleY(${o})`).transition(t.params.speed)}"custom"===n.type&&n.renderCustom?(i.html(n.renderCustom(t,u+1,d)),s("paginationRender",i[0])):s("paginationUpdate",i[0]),t.params.watchOverflow&&t.enabled&&i[t.isLocked?"addClass":"removeClass"](n.lockClass)}function d(){const e=t.params.pagination;if(l())return;const n=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,r=t.pagination.$el;let i="";if("bullets"===e.type){let s=t.params.loop?Math.ceil((n-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&!t.params.loop&&s>n&&(s=n);for(let n=0;n<s;n+=1)e.renderBullet?i+=e.renderBullet.call(t,n,e.bulletClass):i+=`<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`;r.html(i),t.pagination.bullets=r.find(Xt(e.bulletClass))}"fraction"===e.type&&(i=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`,r.html(i)),"progressbar"===e.type&&(i=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`,r.html(i)),"custom"!==e.type&&s("paginationRender",t.pagination.$el[0])}function h(){t.params.pagination=Qt(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let n=it(e.el);0!==n.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&n.length>1&&(n=t.$el.find(e.el),n.length>1&&(n=n.filter((e=>it(e).parents(".swiper")[0]===t.el)))),"bullets"===e.type&&e.clickable&&n.addClass(e.clickableClass),n.addClass(e.modifierClass+e.type),n.addClass(e.modifierClass+t.params.direction),"bullets"===e.type&&e.dynamicBullets&&(n.addClass(`${e.modifierClass}${e.type}-dynamic`),a=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&n.addClass(e.progressbarOppositeClass),e.clickable&&n.on("click",Xt(e.bulletClass),(function(e){e.preventDefault();let n=it(this).index()*t.params.slidesPerGroup;t.params.loop&&(n+=t.loopedSlides),t.slideTo(n)})),Object.assign(t.pagination,{$el:n,el:n[0]}),t.enabled||n.addClass(e.lockClass))}function p(){const e=t.params.pagination;if(l())return;const n=t.pagination.$el;n.removeClass(e.hiddenClass),n.removeClass(e.modifierClass+e.type),n.removeClass(e.modifierClass+t.params.direction),t.pagination.bullets&&t.pagination.bullets.removeClass&&t.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&n.off("click",Xt(e.bulletClass))}r("init",(()=>{h(),d(),u()})),r("activeIndexChange",(()=>{(t.params.loop||void 0===t.snapIndex)&&u()})),r("snapIndexChange",(()=>{t.params.loop||u()})),r("slidesLengthChange",(()=>{t.params.loop&&(d(),u())})),r("snapGridLengthChange",(()=>{t.params.loop||(d(),u())})),r("destroy",(()=>{p()})),r("enable disable",(()=>{const{$el:e}=t.pagination;e&&e[t.enabled?"removeClass":"addClass"](t.params.pagination.lockClass)})),r("lock unlock",(()=>{u()})),r("click",((e,n)=>{const r=n.target,{$el:i}=t.pagination;if(t.params.pagination.el&&t.params.pagination.hideOnClick&&i.length>0&&!it(r).hasClass(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&r===t.navigation.nextEl||t.navigation.prevEl&&r===t.navigation.prevEl))return;const e=i.hasClass(t.params.pagination.hiddenClass);s(!0===e?"paginationShow":"paginationHide"),i.toggleClass(t.params.pagination.hiddenClass)}})),Object.assign(t.pagination,{render:d,update:u,init:h,destroy:p})}function Zt(e){let{swiper:t,extendParams:n,on:r,emit:s}=e;const i=Qe();let o,a,l,c,u=!1,d=null,h=null;function p(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:n,progress:r}=t,{$dragEl:s,$el:i}=e,o=t.params.scrollbar;let c=a,u=(l-a)*r;n?(u=-u,u>0?(c=a-u,u=0):-u+a>l&&(c=l+u)):u<0?(c=a+u,u=0):u+a>l&&(c=l-u),t.isHorizontal()?(s.transform(`translate3d(${u}px, 0, 0)`),s[0].style.width=`${c}px`):(s.transform(`translate3d(0px, ${u}px, 0)`),s[0].style.height=`${c}px`),o.hide&&(clearTimeout(d),i[0].style.opacity=1,d=setTimeout((()=>{i[0].style.opacity=0,i.transition(400)}),1e3))}function f(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{$dragEl:n,$el:r}=e;n[0].style.width="",n[0].style.height="",l=t.isHorizontal()?r[0].offsetWidth:r[0].offsetHeight,c=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),a="auto"===t.params.scrollbar.dragSize?l*c:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?n[0].style.width=`${a}px`:n[0].style.height=`${a}px`,r[0].style.display=c>=1?"none":"",t.params.scrollbar.hide&&(r[0].style.opacity=0),t.params.watchOverflow&&t.enabled&&e.$el[t.isLocked?"addClass":"removeClass"](t.params.scrollbar.lockClass)}function m(e){return t.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY}function g(e){const{scrollbar:n,rtlTranslate:r}=t,{$el:s}=n;let i;i=(m(e)-s.offset()[t.isHorizontal()?"left":"top"]-(null!==o?o:a/2))/(l-a),i=Math.max(Math.min(i,1),0),r&&(i=1-i);const c=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*i;t.updateProgress(c),t.setTranslate(c),t.updateActiveIndex(),t.updateSlidesClasses()}function y(e){const n=t.params.scrollbar,{scrollbar:r,$wrapperEl:i}=t,{$el:a,$dragEl:l}=r;u=!0,o=e.target===l[0]||e.target===l?m(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.transition(100),l.transition(100),g(e),clearTimeout(h),a.transition(0),n.hide&&a.css("opacity",1),t.params.cssMode&&t.$wrapperEl.css("scroll-snap-type","none"),s("scrollbarDragStart",e)}function v(e){const{scrollbar:n,$wrapperEl:r}=t,{$el:i,$dragEl:o}=n;u&&(e.preventDefault?e.preventDefault():e.returnValue=!1,g(e),r.transition(0),i.transition(0),o.transition(0),s("scrollbarDragMove",e))}function w(e){const n=t.params.scrollbar,{scrollbar:r,$wrapperEl:i}=t,{$el:o}=r;u&&(u=!1,t.params.cssMode&&(t.$wrapperEl.css("scroll-snap-type",""),i.transition("")),n.hide&&(clearTimeout(h),h=ot((()=>{o.css("opacity",0),o.transition(400)}),1e3)),s("scrollbarDragEnd",e),n.snapOnRelease&&t.slideToClosest())}function b(e){const{scrollbar:n,touchEventsTouch:r,touchEventsDesktop:s,params:o,support:a}=t,l=n.$el[0],c=!(!a.passiveListener||!o.passiveListeners)&&{passive:!1,capture:!1},u=!(!a.passiveListener||!o.passiveListeners)&&{passive:!0,capture:!1};if(!l)return;const d="on"===e?"addEventListener":"removeEventListener";a.touch?(l[d](r.start,y,c),l[d](r.move,v,c),l[d](r.end,w,u)):(l[d](s.start,y,c),i[d](s.move,v,c),i[d](s.end,w,u))}function S(){const{scrollbar:e,$el:n}=t;t.params.scrollbar=Qt(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const r=t.params.scrollbar;if(!r.el)return;let s=it(r.el);t.params.uniqueNavElements&&"string"==typeof r.el&&s.length>1&&1===n.find(r.el).length&&(s=n.find(r.el));let i=s.find(`.${t.params.scrollbar.dragClass}`);0===i.length&&(i=it(`<div class="${t.params.scrollbar.dragClass}"></div>`),s.append(i)),Object.assign(e,{$el:s,el:s[0],$dragEl:i,dragEl:i[0]}),r.draggable&&t.params.scrollbar.el&&b("on"),s&&s[t.enabled?"removeClass":"addClass"](t.params.scrollbar.lockClass)}function E(){t.params.scrollbar.el&&b("off")}n({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}}),t.scrollbar={el:null,dragEl:null,$el:null,$dragEl:null},r("init",(()=>{S(),f(),p()})),r("update resize observerUpdate lock unlock",(()=>{f()})),r("setTranslate",(()=>{p()})),r("setTransition",((e,n)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&t.scrollbar.$dragEl.transition(e)}(n)})),r("enable disable",(()=>{const{$el:e}=t.scrollbar;e&&e[t.enabled?"removeClass":"addClass"](t.params.scrollbar.lockClass)})),r("destroy",(()=>{E()})),Object.assign(t.scrollbar,{updateSize:f,setTranslate:p,init:S,destroy:E})}function en(e){let{swiper:t,extendParams:n,on:r}=e;function s(e,t){const n=function(){let e,t,n;return(r,s)=>{for(t=-1,e=r.length;e-t>1;)n=e+t>>1,r[n]<=s?t=n:e=n;return e}}();let r,s;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(s=n(this.x,e),r=s-1,(e-this.x[r])*(this.y[s]-this.y[r])/(this.x[s]-this.x[r])+this.y[r]):0},this}function i(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}n({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},r("beforeInit",(()=>{t.controller.control=t.params.controller.control})),r("update",(()=>{i()})),r("resize",(()=>{i()})),r("observerUpdate",(()=>{i()})),r("setTranslate",((e,n,r)=>{t.controller.control&&t.controller.setTranslate(n,r)})),r("setTransition",((e,n,r)=>{t.controller.control&&t.controller.setTransition(n,r)})),Object.assign(t.controller,{setTranslate:function(e,n){const r=t.controller.control;let i,o;const a=t.constructor;function l(e){const n=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline||(t.controller.spline=t.params.loop?new s(t.slidesGrid,e.slidesGrid):new s(t.snapGrid,e.snapGrid))}(e),o=-t.controller.spline.interpolate(-n)),o&&"container"!==t.params.controller.by||(i=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),o=(n-t.minTranslate())*i+e.minTranslate()),t.params.controller.inverse&&(o=e.maxTranslate()-o),e.updateProgress(o),e.setTranslate(o,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(let e=0;e<r.length;e+=1)r[e]!==n&&r[e]instanceof a&&l(r[e]);else r instanceof a&&n!==r&&l(r)},setTransition:function(e,n){const r=t.constructor,s=t.controller.control;let i;function o(n){n.setTransition(e,t),0!==e&&(n.transitionStart(),n.params.autoHeight&&ot((()=>{n.updateAutoHeight()})),n.$wrapperEl.transitionEnd((()=>{s&&(n.params.loop&&"slide"===t.params.controller.by&&n.loopFix(),n.transitionEnd())})))}if(Array.isArray(s))for(i=0;i<s.length;i+=1)s[i]!==n&&s[i]instanceof r&&o(s[i]);else s instanceof r&&n!==s&&o(s)}})}function tn(e){let t,{swiper:n,extendParams:r,on:s,emit:i}=e;function o(){const e=n.slides.eq(n.activeIndex);let r=n.params.autoplay.delay;e.attr("data-swiper-autoplay")&&(r=e.attr("data-swiper-autoplay")||n.params.autoplay.delay),clearTimeout(t),t=ot((()=>{let e;n.params.autoplay.reverseDirection?n.params.loop?(n.loopFix(),e=n.slidePrev(n.params.speed,!0,!0),i("autoplay")):n.isBeginning?n.params.autoplay.stopOnLastSlide?l():(e=n.slideTo(n.slides.length-1,n.params.speed,!0,!0),i("autoplay")):(e=n.slidePrev(n.params.speed,!0,!0),i("autoplay")):n.params.loop?(n.loopFix(),e=n.slideNext(n.params.speed,!0,!0),i("autoplay")):n.isEnd?n.params.autoplay.stopOnLastSlide?l():(e=n.slideTo(0,n.params.speed,!0,!0),i("autoplay")):(e=n.slideNext(n.params.speed,!0,!0),i("autoplay")),(n.params.cssMode&&n.autoplay.running||!1===e)&&o()}),r)}function a(){return void 0===t&&(!n.autoplay.running&&(n.autoplay.running=!0,i("autoplayStart"),o(),!0))}function l(){return!!n.autoplay.running&&(void 0!==t&&(t&&(clearTimeout(t),t=void 0),n.autoplay.running=!1,i("autoplayStop"),!0))}function c(e){n.autoplay.running&&(n.autoplay.paused||(t&&clearTimeout(t),n.autoplay.paused=!0,0!==e&&n.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((e=>{n.$wrapperEl[0].addEventListener(e,d)})):(n.autoplay.paused=!1,o())))}function u(){const e=Qe();"hidden"===e.visibilityState&&n.autoplay.running&&c(),"visible"===e.visibilityState&&n.autoplay.paused&&(o(),n.autoplay.paused=!1)}function d(e){n&&!n.destroyed&&n.$wrapperEl&&e.target===n.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((e=>{n.$wrapperEl[0].removeEventListener(e,d)})),n.autoplay.paused=!1,n.autoplay.running?o():l())}function h(){n.params.autoplay.disableOnInteraction?l():(i("autoplayPause"),c()),["transitionend","webkitTransitionEnd"].forEach((e=>{n.$wrapperEl[0].removeEventListener(e,d)}))}function p(){n.params.autoplay.disableOnInteraction||(n.autoplay.paused=!1,i("autoplayResume"),o())}n.autoplay={running:!1,paused:!1},r({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}}),s("init",(()=>{if(n.params.autoplay.enabled){a();Qe().addEventListener("visibilitychange",u),n.params.autoplay.pauseOnMouseEnter&&(n.$el.on("mouseenter",h),n.$el.on("mouseleave",p))}})),s("beforeTransitionStart",((e,t,r)=>{n.autoplay.running&&(r||!n.params.autoplay.disableOnInteraction?n.autoplay.pause(t):l())})),s("sliderFirstMove",(()=>{n.autoplay.running&&(n.params.autoplay.disableOnInteraction?l():c())})),s("touchEnd",(()=>{n.params.cssMode&&n.autoplay.paused&&!n.params.autoplay.disableOnInteraction&&o()})),s("destroy",(()=>{n.$el.off("mouseenter",h),n.$el.off("mouseleave",p),n.autoplay.running&&l();Qe().removeEventListener("visibilitychange",u)})),Object.assign(n.autoplay,{pause:c,run:o,start:a,stop:l})}function nn(e){let{swiper:t,extendParams:n,on:r}=e;n({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let s=!1,i=!1;function o(){const e=t.thumbs.swiper;if(!e)return;const n=e.clickedIndex,r=e.clickedSlide;if(r&&it(r).hasClass(t.params.thumbs.slideThumbActiveClass))return;if(null==n)return;let s;if(s=e.params.loop?parseInt(it(e.clickedSlide).attr("data-swiper-slide-index"),10):n,t.params.loop){let e=t.activeIndex;t.slides.eq(e).hasClass(t.params.slideDuplicateClass)&&(t.loopFix(),t._clientLeft=t.$wrapperEl[0].clientLeft,e=t.activeIndex);const n=t.slides.eq(e).prevAll(`[data-swiper-slide-index="${s}"]`).eq(0).index(),r=t.slides.eq(e).nextAll(`[data-swiper-slide-index="${s}"]`).eq(0).index();s=void 0===n?r:void 0===r?n:r-e<e-n?r:n}t.slideTo(s)}function a(){const{thumbs:e}=t.params;if(s)return!1;s=!0;const n=t.constructor;if(e.swiper instanceof n)t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1});else if(ct(e.swiper)){const r=Object.assign({},e.swiper);Object.assign(r,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new n(r),i=!0}return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",o),!0}function l(e){const n=t.thumbs.swiper;if(!n)return;const r="auto"===n.params.slidesPerView?n.slidesPerViewDynamic():n.params.slidesPerView,s=t.params.thumbs.autoScrollOffset,i=s&&!n.params.loop;if(t.realIndex!==n.realIndex||i){let o,a,l=n.activeIndex;if(n.params.loop){n.slides.eq(l).hasClass(n.params.slideDuplicateClass)&&(n.loopFix(),n._clientLeft=n.$wrapperEl[0].clientLeft,l=n.activeIndex);const e=n.slides.eq(l).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),r=n.slides.eq(l).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();o=void 0===e?r:void 0===r?e:r-l==l-e?n.params.slidesPerGroup>1?r:l:r-l<l-e?r:e,a=t.activeIndex>t.previousIndex?"next":"prev"}else o=t.realIndex,a=o>t.previousIndex?"next":"prev";i&&(o+="next"===a?s:-1*s),n.visibleSlidesIndexes&&n.visibleSlidesIndexes.indexOf(o)<0&&(n.params.centeredSlides?o=o>l?o-Math.floor(r/2)+1:o+Math.floor(r/2)-1:o>l&&n.params.slidesPerGroup,n.slideTo(o,e?0:void 0))}let o=1;const a=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(o=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(o=1),o=Math.floor(o),n.slides.removeClass(a),n.params.loop||n.params.virtual&&n.params.virtual.enabled)for(let e=0;e<o;e+=1)n.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex+e}"]`).addClass(a);else for(let e=0;e<o;e+=1)n.slides.eq(t.realIndex+e).addClass(a)}t.thumbs={swiper:null},r("beforeInit",(()=>{const{thumbs:e}=t.params;e&&e.swiper&&(a(),l(!0))})),r("slideChange update resize observerUpdate",(()=>{t.thumbs.swiper&&l()})),r("setTransition",((e,n)=>{const r=t.thumbs.swiper;r&&r.setTransition(n)})),r("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&i&&e&&e.destroy()})),Object.assign(t.thumbs,{init:a,update:l})}function rn(e){let{swiper:t,extendParams:n,emit:r,once:s}=e;n({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){const{touchEventsData:e,touches:n}=t;0===e.velocities.length&&e.velocities.push({position:n[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:n[t.isHorizontal()?"currentX":"currentY"],time:at()})},onTouchEnd:function(e){let{currentPos:n}=e;const{params:i,$wrapperEl:o,rtlTranslate:a,snapGrid:l,touchEventsData:c}=t,u=at()-c.touchStartTime;if(n<-t.minTranslate())t.slideTo(t.activeIndex);else if(n>-t.maxTranslate())t.slides.length<l.length?t.slideTo(l.length-1):t.slideTo(t.slides.length-1);else{if(i.freeMode.momentum){if(c.velocities.length>1){const e=c.velocities.pop(),n=c.velocities.pop(),r=e.position-n.position,s=e.time-n.time;t.velocity=r/s,t.velocity/=2,Math.abs(t.velocity)<i.freeMode.minimumVelocity&&(t.velocity=0),(s>150||at()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=i.freeMode.momentumVelocityRatio,c.velocities.length=0;let e=1e3*i.freeMode.momentumRatio;const n=t.velocity*e;let u=t.translate+n;a&&(u=-u);let d,h=!1;const p=20*Math.abs(t.velocity)*i.freeMode.momentumBounceRatio;let f;if(u<t.maxTranslate())i.freeMode.momentumBounce?(u+t.maxTranslate()<-p&&(u=t.maxTranslate()-p),d=t.maxTranslate(),h=!0,c.allowMomentumBounce=!0):u=t.maxTranslate(),i.loop&&i.centeredSlides&&(f=!0);else if(u>t.minTranslate())i.freeMode.momentumBounce?(u-t.minTranslate()>p&&(u=t.minTranslate()+p),d=t.minTranslate(),h=!0,c.allowMomentumBounce=!0):u=t.minTranslate(),i.loop&&i.centeredSlides&&(f=!0);else if(i.freeMode.sticky){let e;for(let t=0;t<l.length;t+=1)if(l[t]>-u){e=t;break}u=Math.abs(l[e]-u)<Math.abs(l[e-1]-u)||"next"===t.swipeDirection?l[e]:l[e-1],u=-u}if(f&&s("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=a?Math.abs((-u-t.translate)/t.velocity):Math.abs((u-t.translate)/t.velocity),i.freeMode.sticky){const n=Math.abs((a?-u:u)-t.translate),r=t.slidesSizesGrid[t.activeIndex];e=n<r?i.speed:n<2*r?1.5*i.speed:2.5*i.speed}}else if(i.freeMode.sticky)return void t.slideToClosest();i.freeMode.momentumBounce&&h?(t.updateProgress(d),t.setTransition(e),t.setTranslate(u),t.transitionStart(!0,t.swipeDirection),t.animating=!0,o.transitionEnd((()=>{t&&!t.destroyed&&c.allowMomentumBounce&&(r("momentumBounce"),t.setTransition(i.speed),setTimeout((()=>{t.setTranslate(d),o.transitionEnd((()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(r("_freeModeNoMomentumRelease"),t.updateProgress(u),t.setTransition(e),t.setTranslate(u),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,o.transitionEnd((()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(u),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(i.freeMode.sticky)return void t.slideToClosest();i.freeMode&&r("_freeModeNoMomentumRelease")}(!i.freeMode.momentum||u>=i.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})}function sn(e,t){return e.transformEl?t.find(e.transformEl).css({"backface-visibility":"hidden","-webkit-backface-visibility":"hidden"}):t}function on(e){let{swiper:t,extendParams:n,on:r}=e;n({fadeEffect:{crossFade:!1,transformEl:null}});!function(e){const{effect:t,swiper:n,on:r,setTranslate:s,setTransition:i,overwriteParams:o,perspective:a}=e;r("beforeInit",(()=>{if(n.params.effect!==t)return;n.classNames.push(`${n.params.containerModifierClass}${t}`),a&&a()&&n.classNames.push(`${n.params.containerModifierClass}3d`);const e=o?o():{};Object.assign(n.params,e),Object.assign(n.originalParams,e)})),r("setTranslate",(()=>{n.params.effect===t&&s()})),r("setTransition",((e,r)=>{n.params.effect===t&&i(r)}))}({effect:"fade",swiper:t,on:r,setTranslate:()=>{const{slides:e}=t,n=t.params.fadeEffect;for(let r=0;r<e.length;r+=1){const e=t.slides.eq(r);let s=-e[0].swiperSlideOffset;t.params.virtualTranslate||(s-=t.translate);let i=0;t.isHorizontal()||(i=s,s=0);const o=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e[0].progress),0):1+Math.min(Math.max(e[0].progress,-1),0);sn(n,e).css({opacity:o}).transform(`translate3d(${s}px, ${i}px, 0px)`)}},setTransition:e=>{const{transformEl:n}=t.params.fadeEffect;(n?t.slides.find(n):t.slides).transition(e),function(e){let{swiper:t,duration:n,transformEl:r,allSlides:s}=e;const{slides:i,activeIndex:o,$wrapperEl:a}=t;if(t.params.virtualTranslate&&0!==n){let e,n=!1;e=s?r?i.find(r):i:r?i.eq(o).find(r):i.eq(o),e.transitionEnd((()=>{if(n)return;if(!t||t.destroyed)return;n=!0,t.animating=!1;const e=["webkitTransitionEnd","transitionend"];for(let t=0;t<e.length;t+=1)a.trigger(e[t])}))}}({swiper:t,duration:e,transformEl:n,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})}if(null!==document.querySelector(".announcement-bar")){new Wt(".announcement-bar .swiper",{effect:"fade",loop:!0,autoplay:{delay:3500},fadeEffect:{crossFade:!0},pauseOnMouseEnter:!1,modules:[on,tn]}).on("slideChange",(function(e){const t=document.querySelector("header").offsetHeight;document.documentElement.style.setProperty("--header-height",t+"px"),document.documentElement.style.setProperty("--mobile-header-height",t+"px")}))}if(null!==document.querySelector(".text-image")){document.querySelectorAll(".text-image .swiper").forEach((e=>{if(null!==e.querySelector(".swiper-button-next")){const t={loop:!0,slidesPerView:"auto",navigation:{nextEl:e.querySelector(".swiper-button-next"),prevEl:e.querySelector(".swiper-button-prev")},freeMode:{enabled:!0},mousewheel:{forceToAxis:!0},effect:"fade",fadeEffect:{crossFade:!0},modules:[Kt,rn,Yt,on]};new Wt(e,t)}}))}if(null!==document.querySelector(".featured-products")){document.querySelectorAll(".featured-products .swiper").forEach((e=>{const t=()=>{if(null!==e.querySelector(".swiper-arrows")&&null!==e.querySelector(".swiper-slide-active img")){const t=e.querySelector(".swiper-slide-active img").clientHeight;e.querySelector(".swiper-arrows").style.height=t+"px"}},n={loop:!1,slidesPerView:"auto",spaceBetween:20,watchSlidesProgress:!0,preventClicks:!1,navigation:{nextEl:e.querySelector(".swiper-button-next"),prevEl:e.querySelector(".swiper-button-prev")},freeMode:{enabled:!0},mousewheel:{forceToAxis:!0},modules:[Kt,rn,Yt,Zt],scrollbar:{el:e.querySelector(".swiper-scrollbar"),draggable:!0},breakpoints:{1200:{slidesPerView:e.closest(".featured-products").classList.contains("ymal")?3:4,spaceBetween:e.closest(".featured-products").classList.contains("ymal")?0:60,loop:!0},992:{slidesPerView:e.closest(".featured-products").classList.contains("ymal")?3:4,spaceBetween:e.closest(".featured-products").classList.contains("ymal")?0:30,loop:!0},769:{slidesPerView:3,spaceBetween:20,scrollbar:!1,loop:!0,freeMode:!1}},on:{init:t}},r=new Wt(e,n);r.on("resize",t),r.on("slideChange",t)}))}if(null!==document.querySelector(".featured-articles")){document.querySelectorAll(".featured-articles .swiper").forEach((e=>{const t={slidesPerView:"auto",spaceBetween:40,centeredSlides:!0,loop:!0,navigation:{nextEl:e.querySelector(".swiper-button-next"),prevEl:e.querySelector(".swiper-button-prev")},freeMode:{enabled:!0},mousewheel:{forceToAxis:!0},pagination:{el:e.querySelector(".swiper-pagination"),type:"bullets",clickable:!0},modules:[Kt,rn,Yt,Jt]};new Wt(e,t)}))}if(null!==document.querySelector(".starburst-card-wrap")){document.querySelectorAll(".starburst-card-wrap").forEach((e=>{const t=e.querySelector(".starburst-cards"),n=e.querySelector(".starburst-card__tabs"),r=new Wt(n,{slidesPerView:1,direction:"horizontal",modules:[en],breakpoints:{992:{direction:"vertical"}}}),s={centeredSlides:!0,pagination:{el:e.querySelector(".swiper-pagination"),type:"bullets",clickable:!0},direction:"horizontal",modules:[en,Jt]},i=new Wt(t,s),o=((e,t)=>{let n=null;return(...r)=>{window.clearTimeout(n),n=window.setTimeout((()=>{e.apply(null,r)}),t)}})((t=>{let n=0;if(window.matchMedia("(min-width: 992px)").matches){let t=0;e.querySelectorAll(".starburst-card").forEach((e=>{null!=e.querySelector(".starburst-card__image")&&(t=e.querySelector(".starburst-card__image").clientHeight),e.querySelector(".starburst-card__text").clientHeight>t?(t=e.querySelector(".starburst-card__text").clientHeight,t+=114):t+=74,t>n&&(n=t)})),e.querySelectorAll(".starburst-card").forEach((e=>{e.style.height=n+"px"}))}else e.querySelectorAll(".starburst-card").forEach((e=>{let t=0;[...e.querySelector(".starburst-card__container").children].forEach((e=>{t+=e.clientHeight})),t+=100,t>n&&(n=t)})),e.querySelectorAll(".starburst-card").forEach((e=>{e.style.height=n+"px"}))}),500);i.controller.control=r,r.controller.control=i,i.on("touchEnd",(function(e,t){1===e.realIndex&&(e.touches.diff>75&&i.slidePrev(),e.touches.diff<-75&&i.slideNext())})),r.on("slideChange",(function(){const e=t.querySelector(".swiper-slide-active"),n=Ge(e);t.querySelectorAll(".swiper-slide").forEach(((e,t)=>{e.classList.remove("fly-away"),t!==n&&e.classList.add("fly-away")}))})),o(),window.addEventListener("resize",o),i.on("slideChange",(function(){const e=t.querySelector(".swiper-slide-active"),n=Ge(e);t.querySelectorAll(".swiper-slide").forEach(((e,t)=>{e.classList.remove("fly-away"),t!==n&&e.classList.add("fly-away")}))})),i.on("touchEnd",(e=>{setTimeout((()=>{n.querySelectorAll(".starburst-card__tab").forEach((e=>{e.classList.remove("starburst-card__tab--active")})),n.querySelectorAll(".starburst-card__tab")[e.activeIndex].classList.add("starburst-card__tab--active")}),300)})),t.querySelectorAll(".swiper-pagination-bullet").forEach((e=>{e.addEventListener("click",(()=>{console.log("CLICK"),setTimeout((()=>{const e=t.querySelector(".swiper-slide-active"),r=Ge(e);n.querySelectorAll(".starburst-card__tab").forEach((e=>{e.classList.remove("starburst-card__tab--active")})),n.querySelectorAll(".starburst-card__tab")[r].classList.add("starburst-card__tab--active")}),300)}))})),n.querySelectorAll(".swiper-slide").forEach(((e,t)=>{e.addEventListener("click",(()=>{r.slideTo(t)}))}))}))}if(null!==document.querySelector(".social-card-wrap")){document.querySelectorAll(".social-card-wrap").forEach((e=>{const t=e.querySelector(".social-cards"),n=(t.querySelector(".splide__arrow--prev"),t.querySelector(".splide__arrow--next"),{pagination:{el:e.querySelector(".swiper-pagination"),type:"bullets",clickable:!0},navigation:{nextEl:e.querySelector(".swiper-button-next"),prevEl:e.querySelector(".swiper-button-prev")},modules:[Yt,Jt]}),r=new Wt(t,n);r.on("touchEnd",(function(e,t){1===e.realIndex&&(e.touches.diff>50&&e.slidePrev(),e.touches.diff<-50&&e.slideNext())})),r.on("slideChange",(function(e){t.querySelectorAll(".swiper-slide").forEach(((t,n)=>{n!==e.realIndex?t.classList.add("fly-away"):t.classList.remove("fly-away")}))}))}))}if(null!==document.querySelector(".social-feed")){document.querySelectorAll(".social-feed").forEach((e=>{const t=e.querySelector(".swiper"),n={slidesPerView:"auto",freeMode:{enabled:!1},mousewheel:{forceToAxis:!0},scrollbar:{el:e.querySelector(".swiper-scrollbar"),draggable:!0},modules:[Kt,rn,Zt]};new Wt(t,n)}))}if(null!==document.querySelector(".product-main__images--wrap[data-page-product]")&&document.querySelectorAll(".product-main__images--wrap[data-page-product]").forEach((e=>{const t=new Wt(e.querySelector(".product-main__images--thumbs"),{spaceBetween:16,slidesPerView:"auto",loopedSlides:4,direction:"vertical",mousewheel:{forceToAxis:!0},preventClicks:!1,preventClicksPropagation:!1,freeMode:!0,loop:!1,watchSlidesProgress:!0,modules:[en,Kt,rn]}),n=new Wt(e.querySelector(".product-main__images--gallery"),{loop:!1,loopedSlides:4,navigation:{prevEl:e.querySelector(".product-main__images--thumbs .swiper-button-prev"),nextEl:e.querySelector(".product-main__images--thumbs .swiper-button-next")},thumbs:{swiper:t},pagination:{el:e.querySelector(".product-main__images--gallery .swiper-pagination"),type:"bullets",clickable:!0},modules:[nn,Yt,Jt]});e.querySelectorAll(".product-main__images--thumbs .swiper-slide").forEach((e=>{e.addEventListener("click",(r=>{r.preventDefault();const s=Number(e.getAttribute("data-index"));t.slideTo(s),n.slideTo(s)}))}))})),null!==document.querySelector(".home-hero-slider")){const qh=document.querySelector(".home-hero-slider .swiper .swiper-pagination");new Wt(".home-hero-slider .swiper",{effect:"fade",autoplay:{delay:4e3},fadeEffect:{crossFade:!0},disableOnInteraction:!0,pagination:{el:qh,clickable:!0},pauseOnMouseEnter:!1,modules:[on,tn,Jt]})}var an=n(372),ln=n.n(an),cn=n(130);const un=document.querySelector("header"),dn=(document.querySelector(".header__nav"),document.querySelector(".header__nav-dropdown")),hn=document.querySelector(".header__nav-hamburger"),pn=document.querySelector("nav"),fn=document.querySelector(".mobile-menu"),mn=document.querySelector(".mobile-menu__overlay");let gn=pn.offsetHeight;if(null!==un&&ln()(un,{startOffset:gn,tolerance:15,showAtBottom:!1,classNames:{base:"absolute",fixed:"swiped-down",hidden:"swiped-up"}}),null!==un.querySelector(".has-dropdown")){const Rh=()=>{un.classList.remove("dropdown-open"),document.querySelectorAll(".header__nav-dropdown-list").forEach((e=>{e.classList.remove("active")}))},Fh=e=>{var t,n;document.querySelectorAll(".header__nav-dropdown-list:not(.active)").forEach((e=>{e.style.display="none"})),e&&null!==document.getElementById(e)&&(t=document.getElementById(e),n="flex",t.style.opacity=0,t.style.display=n||"block",function e(){var n=parseFloat(t.style.opacity);(n+=.1)>1||(t.style.opacity=n,requestAnimationFrame(e))}(),document.getElementById(e).classList.add("active")),un.classList.add("dropdown-opens")};un.querySelectorAll(".has-dropdown").forEach((e=>{const t=e.getAttribute("data-dropdown");e.addEventListener("mouseenter",(()=>{Fh(t)}))})),document.querySelectorAll(".header__nav-wrap li").forEach((e=>{e.classList.contains("has-dropdown")||e.addEventListener("mouseenter",Rh)})),dn.addEventListener("mouseleave",Rh)}hn.addEventListener("click",(()=>{hn.classList.toggle("header__nav-hamburger--active"),fn.classList.toggle("mobile-menu--open"),mn.classList.toggle("mobile-menu__overlay--active"),fn.classList.contains("mobile-menu--open")?(0,cn.disablePageScroll)():(0,cn.enablePageScroll)()})),mn.addEventListener("click",(()=>{hn.classList.remove("header__nav-hamburger--active"),fn.classList.remove("mobile-menu--open"),mn.classList.remove("mobile-menu__overlay--active"),(0,cn.enablePageScroll)()}));const yn=()=>{gn=un.offsetHeight,document.querySelectorAll(".header__menu .toggle-trigger").forEach((e=>{e.classList.remove("active")})),document.documentElement.style.setProperty("--header-height",gn+"px"),document.documentElement.style.setProperty("--mobile-header-height",gn+"px")};yn(),window.addEventListener("resize",yn,!0);const vn=(e,t)=>{var n;"createEvent"in document?((n=document.createEvent("HTMLEvents")).initEvent(t,!1,!0),e.dispatchEvent(n)):((n=document.createEventObject()).eventType=t,e.fireEvent("on"+n.eventType,n))};if(null!==document.getElementById("add-to-cart")){const Bh=new Wt(".product-main__images--thumbs",{spaceBetween:16,slidesPerView:"auto",loopedSlides:4,direction:"vertical",mousewheel:{forceToAxis:!0},preventClicks:!1,preventClicksPropagation:!1,freeMode:!0,loop:!1,watchSlidesProgress:!0,modules:[en,Kt,rn]}),$h=new Wt(".product-main__images--gallery",{loop:!1,loopedSlides:4,navigation:{prevEl:document.querySelector(".product-main__images--thumbs .swiper-button-prev"),nextEl:document.querySelector(".product-main__images--thumbs .swiper-button-next")},thumbs:{swiper:Bh},pagination:{el:document.querySelector(".product-main__images--gallery .swiper-pagination"),type:"bullets",clickable:!0},modules:[nn,Yt,Jt]});document.querySelectorAll(".product-main__images--thumbs .swiper-slide").forEach((e=>{e.addEventListener("click",(t=>{t.preventDefault();const n=Number(e.getAttribute("data-index"));Bh.slideTo(n),$h.slideTo(n)}))}));const Vh=document.getElementById("add-to-cart");if(null!==Vh){const jh=document.getElementById("add"),zh=Vh.getAttribute("data-product-handle"),Uh=document.getElementById("minus"),Gh=document.getElementById("quantity"),Hh=document.getElementById("price"),Wh=document.getElementById("plus"),Kh=document.querySelector(".product-main__quantity");let Qh,Yh,Xh;Uh.addEventListener("click",(()=>{let e,t=parseInt(Gh.value);t>1&&(e=t-1,Gh.value=e)})),Wh.addEventListener("click",(()=>{let e;e=parseInt(Gh.value)+1,Gh.value=e})),fetch(`/products/${zh}.json`,{headers:{"Content-Type":"application/json","X-Requested-With":"xmlhttprequest"}}).then((e=>e.json())).then((e=>{Xh=e.product;if(new Shopify.OptionSelectors("product-select",{product:Xh,onVariantSelected:function(e,t){window.Shopify.variant=e,window.Shopify.variantID=e.id,window.Shopify.productID=t.product.id;let n=null!==document.querySelector(".pdp-plan-option");const r=document.getElementById("product-select");if(Qh=e.id,Yh=parseInt(r.querySelector(`option[value="${Qh}"]`).getAttribute("data-qty")),e){if(console.log(e),e.image_id&&null!==document.querySelector(`[data-image-id="product-main__image-${e.image_id}"]`)){const t=document.querySelector(`[data-image-id="product-main__image-${e.image_id}"]`),n=Ge(t);$h.slideTo(n)}null!==Hh&&(n||(Number(e.compare_at_price),Number(e.price),Hh.innerHTML=`\n\t\t\t\t\t\t\t\t\t<span class="font-tt-extra-bold leading-none inline-flex items-center gap-1.5 mt-1" style="opacity: 1;">\n\t\t\t\t\t\t\t\t\t\t<span class="">${Shopify.formatMoney(e.price).replace(".00","")}</span>\n\t\t\t\t\t\t\t\t\t\t<s class="inline-block">${Shopify.formatMoney(e.compare_at_price).replace(".00","")}</s>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t`)),Yh>0?n?jh.innerHTML="<span>Add to Cart</span>":Number(e.compare_at_price)>Number(e.price)&&!jh.classList.contains("special")?jh.innerHTML=`<span>Add to Cart</span><span class="inline-flex items-center gap-1.5 2xl:hidden lg:inline-flex sm:hidden"><span class="">${Shopify.formatMoney(e.price).replace(".00","")}</span><s class="inline-block 2xl:hidden lg:inline-block sm:hidden">${Shopify.formatMoney(e.compare_at_price).replace(".00","")}</s></span>`:jh.classList.contains("special")?jh.innerHTML='<span>Add to Cart</span><span class="inline-flex items-center gap-1.5 2xl:hidden lg:inline-flex sm:hidden"><span class="">$69.98</span></span>':jh.innerHTML=`<span>Add to Cart</span><span>${Shopify.formatMoney(e.price).replace(".00","")}</span>`:(Kh.style.display="none",jh.disabled=!0,n?jh.innerHTML="<span>Sold Out</span>":Number(e.compare_at_price)>Number(e.price)?jh.innerHTML=`<span>Sold Out</span><span class="inline-flex items-center gap-1.5"><span class="">${Shopify.formatMoney(e.price).replace(".00","")}</span><s class="inline-block 2xl:hidden lg:inline-block">${Shopify.formatMoney(e.compare_at_price).replace(".00","")}</s></span>`:jh.innerHTML=`<span>Sold Out</span><span>${Shopify.formatMoney(e.price).replace(".00","")}</span>`)}}}),null!==document.querySelector(".option-selector__group")&&document.querySelectorAll(".option-selector__group").forEach((e=>{const t=e.getAttribute("data-group-option");e.querySelectorAll(".option-selector__radio").forEach((n=>{n.addEventListener("click",(()=>{const{value:r}=n;e.querySelectorAll(".option-selector__button").forEach((e=>{e.classList.remove("active")})),n.parentElement.classList.add("active"),document.getElementById(`product-select-option-${t}`).value=r,vn(document.getElementById(`product-select-option-${t}`),"change")}))}))})),null!==document.querySelector(".pdp-plan-option")&&null===document.querySelector(".product-main .swatch__wrap")){const e=document.querySelectorAll(".pdp-plan-option-item-radio"),t=document.querySelector("[name='selling_plan']");document.getElementById("one-time-price"),document.getElementById("frequency-price");e.forEach((e=>{e.addEventListener("click",(()=>{const{value:n,name:r}=e,s=e.getAttribute("data-option"),i=e.closest(".pdp-plan-option"),o=e.closest(".pdp-plan-option-item"),a=document.querySelector('input[name="properties[_dynamicBoxId]"]'),l=document.querySelector('input[name="properties[_dynamicBoxIndex]"]'),c=document.querySelector('input[name="properties[Subscription Discount:]"]');"frequency"===r&&("One Time"===n?(a.value="",l.value="",c.disabled=!0,Gh.classList.contains("protein-powder")?Gh.value=1:Gh.value=2,t.disabled=!0,document.querySelector(".product-main__images--thumbs .swiper-wrapper").children.length>1&&$h.slideTo(1),null!==document.querySelector('.pdp-plan-option-item-radio[name="Pack Size"]')&&document.querySelectorAll('.pdp-plan-option-item-radio[name="Pack Size"]').forEach((e=>{e.checked=!1,"Single Pack"===e.value&&(e.checked=!0,vn(e,"click"))})),Kh.style.display="inline-flex"):(a.value="e529bb71-a2a6-4acb-b79f-2510576755c9",l.value="0",c.disabled=!1,Gh.classList.contains("protein-powder")?Gh.value=1:Gh.value=2,t.disabled=!1,$h.slideTo(0),null!==document.querySelector('.pdp-plan-option-item-radio[name="Pack Size"]')&&document.querySelectorAll('.pdp-plan-option-item-radio[name="Pack Size"]').forEach((e=>{e.checked=!1,"Single Pack"===e.value&&(e.checked=!0,vn(e,"click"))})),Kh.style.display="none")),null!==document.getElementById(`product-select-option-${s}`)?(document.getElementById(`product-select-option-${s}`).value=n,vn(document.getElementById(`product-select-option-${s}`),"change")):vn(document.getElementById("product-select-option-0"),"change"),Vh.querySelectorAll(".pdp-plan-option").forEach((e=>{e.classList.remove("pdp-plan-option--active"),i.classList.add("pdp-plan-option--active"),e.querySelectorAll(".pdp-plan-option-item").forEach((e=>{e.classList.remove("pdp-plan-option-item--active")}))})),o.classList.add("pdp-plan-option-item--active");var u=document.querySelector(`.pdp-plan-option-item-radio[data-variant-id='${window.Shopify.variant.id}']`).getAttribute("data-plan-pricing");void 0===u&&(u=document.getElementById("frequency-price").textContent),jh.innerHTML="<span>Add to Cart</span>",Vh.querySelectorAll("[name='frequency']").forEach((e=>{(e.checked&&"One Time"===e.value||e.checked&&"Subscribe"===e.value)&&(jh.innerHTML="<span>Add to Cart</span>")}))}))})),document.querySelectorAll("input[type='radio'][name='selling_plan']").forEach((e=>{e.addEventListener("change",(()=>{if(e.checked){const t=e.closest(".pdp-plan-option"),n=e.closest(".pdp-plan-option-item");document.querySelector(".pdp-plan-option-item-radio[name='frequency'][value='Subscribe']").checked=!0,Vh.querySelectorAll(".pdp-plan-option").forEach((e=>{e.classList.remove("pdp-plan-option--active"),t.classList.add("pdp-plan-option--active"),e.querySelectorAll(".pdp-plan-option-item").forEach((e=>{e.classList.remove("pdp-plan-option-item--active")}))})),n.classList.add("pdp-plan-option-item--active")}}))}))}}))}}var wn=n(76),bn=n.n(wn);const Sn=function(e){const t=[];let n=0;for(let r=0;r<e.length;r++){let s=e.charCodeAt(r);s<128?t[n++]=s:s<2048?(t[n++]=s>>6|192,t[n++]=63&s|128):55296==(64512&s)&&r+1<e.length&&56320==(64512&e.charCodeAt(r+1))?(s=65536+((1023&s)<<10)+(1023&e.charCodeAt(++r)),t[n++]=s>>18|240,t[n++]=s>>12&63|128,t[n++]=s>>6&63|128,t[n++]=63&s|128):(t[n++]=s>>12|224,t[n++]=s>>6&63|128,t[n++]=63&s|128)}return t},En={byteToCharMap_:null,charToByteMap_:null,byteToCharMapWebSafe_:null,charToByteMapWebSafe_:null,ENCODED_VALS_BASE:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",get ENCODED_VALS(){return this.ENCODED_VALS_BASE+"+/="},get ENCODED_VALS_WEBSAFE(){return this.ENCODED_VALS_BASE+"-_."},HAS_NATIVE_SUPPORT:"function"==typeof atob,encodeByteArray(e,t){if(!Array.isArray(e))throw Error("encodeByteArray takes an array as a parameter");this.init_();const n=t?this.byteToCharMapWebSafe_:this.byteToCharMap_,r=[];for(let t=0;t<e.length;t+=3){const s=e[t],i=t+1<e.length,o=i?e[t+1]:0,a=t+2<e.length,l=a?e[t+2]:0,c=s>>2,u=(3&s)<<4|o>>4;let d=(15&o)<<2|l>>6,h=63&l;a||(h=64,i||(d=64)),r.push(n[c],n[u],n[d],n[h])}return r.join("")},encodeString(e,t){return this.HAS_NATIVE_SUPPORT&&!t?btoa(e):this.encodeByteArray(Sn(e),t)},decodeString(e,t){return this.HAS_NATIVE_SUPPORT&&!t?atob(e):function(e){const t=[];let n=0,r=0;for(;n<e.length;){const s=e[n++];if(s<128)t[r++]=String.fromCharCode(s);else if(s>191&&s<224){const i=e[n++];t[r++]=String.fromCharCode((31&s)<<6|63&i)}else if(s>239&&s<365){const i=((7&s)<<18|(63&e[n++])<<12|(63&e[n++])<<6|63&e[n++])-65536;t[r++]=String.fromCharCode(55296+(i>>10)),t[r++]=String.fromCharCode(56320+(1023&i))}else{const i=e[n++],o=e[n++];t[r++]=String.fromCharCode((15&s)<<12|(63&i)<<6|63&o)}}return t.join("")}(this.decodeStringToByteArray(e,t))},decodeStringToByteArray(e,t){this.init_();const n=t?this.charToByteMapWebSafe_:this.charToByteMap_,r=[];for(let t=0;t<e.length;){const s=n[e.charAt(t++)],i=t<e.length?n[e.charAt(t)]:0;++t;const o=t<e.length?n[e.charAt(t)]:64;++t;const a=t<e.length?n[e.charAt(t)]:64;if(++t,null==s||null==i||null==o||null==a)throw new Tn;const l=s<<2|i>>4;if(r.push(l),64!==o){const e=i<<4&240|o>>2;if(r.push(e),64!==a){const e=o<<6&192|a;r.push(e)}}}return r},init_(){if(!this.byteToCharMap_){this.byteToCharMap_={},this.charToByteMap_={},this.byteToCharMapWebSafe_={},this.charToByteMapWebSafe_={};for(let e=0;e<this.ENCODED_VALS.length;e++)this.byteToCharMap_[e]=this.ENCODED_VALS.charAt(e),this.charToByteMap_[this.byteToCharMap_[e]]=e,this.byteToCharMapWebSafe_[e]=this.ENCODED_VALS_WEBSAFE.charAt(e),this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]]=e,e>=this.ENCODED_VALS_BASE.length&&(this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)]=e,this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)]=e)}}};class Tn extends Error{constructor(){super(...arguments),this.name="DecodeBase64StringError"}}const _n=function(e){return function(e){const t=Sn(e);return En.encodeByteArray(t,!0)}(e).replace(/\./g,"")},Cn=function(e){try{return En.decodeString(e,!0)}catch(e){console.error("base64Decode failed: ",e)}return null};const xn=()=>function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==n.g)return n.g;throw new Error("Unable to locate global object.")}().__FIREBASE_DEFAULTS__,An=()=>{try{return xn()||(()=>{if("undefined"==typeof process||void 0===process.env)return;const e=process.env.__FIREBASE_DEFAULTS__;return e?JSON.parse(e):void 0})()||(()=>{if("undefined"==typeof document)return;let e;try{e=document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/)}catch(e){return}const t=e&&Cn(e[1]);return t&&JSON.parse(t)})()}catch(e){return void console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`)}},In=e=>{const t=(e=>{var t,n;return null===(n=null===(t=An())||void 0===t?void 0:t.emulatorHosts)||void 0===n?void 0:n[e]})(e);if(!t)return;const n=t.lastIndexOf(":");if(n<=0||n+1===t.length)throw new Error(`Invalid host ${t} with no separate hostname and port!`);const r=parseInt(t.substring(n+1),10);return"["===t[0]?[t.substring(1,n-1),r]:[t.substring(0,n),r]},kn=()=>{var e;return null===(e=An())||void 0===e?void 0:e.config};class Ln{constructor(){this.reject=()=>{},this.resolve=()=>{},this.promise=new Promise(((e,t)=>{this.resolve=e,this.reject=t}))}wrapCallback(e){return(t,n)=>{t?this.reject(t):this.resolve(n),"function"==typeof e&&(this.promise.catch((()=>{})),1===e.length?e(t):e(t,n))}}}function Mn(){return"undefined"!=typeof navigator&&"string"==typeof navigator.userAgent?navigator.userAgent:""}function Dn(){return!function(){var e;const t=null===(e=An())||void 0===e?void 0:e.forceEnvironment;if("node"===t)return!0;if("browser"===t)return!1;try{return"[object process]"===Object.prototype.toString.call(n.g.process)}catch(e){return!1}}()&&!!navigator.userAgent&&navigator.userAgent.includes("Safari")&&!navigator.userAgent.includes("Chrome")}function Nn(){try{return"object"==typeof indexedDB}catch(e){return!1}}class Pn extends Error{constructor(e,t,n){super(t),this.code=e,this.customData=n,this.name="FirebaseError",Object.setPrototypeOf(this,Pn.prototype),Error.captureStackTrace&&Error.captureStackTrace(this,On.prototype.create)}}class On{constructor(e,t,n){this.service=e,this.serviceName=t,this.errors=n}create(e,...t){const n=t[0]||{},r=`${this.service}/${e}`,s=this.errors[e],i=s?function(e,t){return e.replace(qn,((e,n)=>{const r=t[n];return null!=r?String(r):`<${n}?>`}))}(s,n):"Error",o=`${this.serviceName}: ${i} (${r}).`;return new Pn(r,o,n)}}const qn=/\{\$([^}]+)}/g;function Rn(e,t){if(e===t)return!0;const n=Object.keys(e),r=Object.keys(t);for(const s of n){if(!r.includes(s))return!1;const n=e[s],i=t[s];if(Fn(n)&&Fn(i)){if(!Rn(n,i))return!1}else if(n!==i)return!1}for(const e of r)if(!n.includes(e))return!1;return!0}function Fn(e){return null!==e&&"object"==typeof e}function Bn(e){return e&&e._delegate?e._delegate:e}class $n{constructor(e,t,n){this.name=e,this.instanceFactory=t,this.type=n,this.multipleInstances=!1,this.serviceProps={},this.instantiationMode="LAZY",this.onInstanceCreated=null}setInstantiationMode(e){return this.instantiationMode=e,this}setMultipleInstances(e){return this.multipleInstances=e,this}setServiceProps(e){return this.serviceProps=e,this}setInstanceCreatedCallback(e){return this.onInstanceCreated=e,this}}const Vn="[DEFAULT]";class jn{constructor(e,t){this.name=e,this.container=t,this.component=null,this.instances=new Map,this.instancesDeferred=new Map,this.instancesOptions=new Map,this.onInitCallbacks=new Map}get(e){const t=this.normalizeInstanceIdentifier(e);if(!this.instancesDeferred.has(t)){const e=new Ln;if(this.instancesDeferred.set(t,e),this.isInitialized(t)||this.shouldAutoInitialize())try{const n=this.getOrInitializeService({instanceIdentifier:t});n&&e.resolve(n)}catch(e){}}return this.instancesDeferred.get(t).promise}getImmediate(e){var t;const n=this.normalizeInstanceIdentifier(null==e?void 0:e.identifier),r=null!==(t=null==e?void 0:e.optional)&&void 0!==t&&t;if(!this.isInitialized(n)&&!this.shouldAutoInitialize()){if(r)return null;throw Error(`Service ${this.name} is not available`)}try{return this.getOrInitializeService({instanceIdentifier:n})}catch(e){if(r)return null;throw e}}getComponent(){return this.component}setComponent(e){if(e.name!==this.name)throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);if(this.component)throw Error(`Component for ${this.name} has already been provided`);if(this.component=e,this.shouldAutoInitialize()){if(function(e){return"EAGER"===e.instantiationMode}(e))try{this.getOrInitializeService({instanceIdentifier:Vn})}catch(e){}for(const[e,t]of this.instancesDeferred.entries()){const n=this.normalizeInstanceIdentifier(e);try{const e=this.getOrInitializeService({instanceIdentifier:n});t.resolve(e)}catch(e){}}}}clearInstance(e=Vn){this.instancesDeferred.delete(e),this.instancesOptions.delete(e),this.instances.delete(e)}async delete(){const e=Array.from(this.instances.values());await Promise.all([...e.filter((e=>"INTERNAL"in e)).map((e=>e.INTERNAL.delete())),...e.filter((e=>"_delete"in e)).map((e=>e._delete()))])}isComponentSet(){return null!=this.component}isInitialized(e=Vn){return this.instances.has(e)}getOptions(e=Vn){return this.instancesOptions.get(e)||{}}initialize(e={}){const{options:t={}}=e,n=this.normalizeInstanceIdentifier(e.instanceIdentifier);if(this.isInitialized(n))throw Error(`${this.name}(${n}) has already been initialized`);if(!this.isComponentSet())throw Error(`Component ${this.name} has not been registered yet`);const r=this.getOrInitializeService({instanceIdentifier:n,options:t});for(const[e,t]of this.instancesDeferred.entries()){n===this.normalizeInstanceIdentifier(e)&&t.resolve(r)}return r}onInit(e,t){var n;const r=this.normalizeInstanceIdentifier(t),s=null!==(n=this.onInitCallbacks.get(r))&&void 0!==n?n:new Set;s.add(e),this.onInitCallbacks.set(r,s);const i=this.instances.get(r);return i&&e(i,r),()=>{s.delete(e)}}invokeOnInitCallbacks(e,t){const n=this.onInitCallbacks.get(t);if(n)for(const r of n)try{r(e,t)}catch(e){}}getOrInitializeService({instanceIdentifier:e,options:t={}}){let n=this.instances.get(e);if(!n&&this.component&&(n=this.component.instanceFactory(this.container,{instanceIdentifier:(r=e,r===Vn?void 0:r),options:t}),this.instances.set(e,n),this.instancesOptions.set(e,t),this.invokeOnInitCallbacks(n,e),this.component.onInstanceCreated))try{this.component.onInstanceCreated(this.container,e,n)}catch(e){}var r;return n||null}normalizeInstanceIdentifier(e=Vn){return this.component?this.component.multipleInstances?e:Vn:e}shouldAutoInitialize(){return!!this.component&&"EXPLICIT"!==this.component.instantiationMode}}class zn{constructor(e){this.name=e,this.providers=new Map}addComponent(e){const t=this.getProvider(e.name);if(t.isComponentSet())throw new Error(`Component ${e.name} has already been registered with ${this.name}`);t.setComponent(e)}addOrOverwriteComponent(e){this.getProvider(e.name).isComponentSet()&&this.providers.delete(e.name),this.addComponent(e)}getProvider(e){if(this.providers.has(e))return this.providers.get(e);const t=new jn(e,this);return this.providers.set(e,t),t}getProviders(){return Array.from(this.providers.values())}}const Un=[];var Gn;!function(e){e[e.DEBUG=0]="DEBUG",e[e.VERBOSE=1]="VERBOSE",e[e.INFO=2]="INFO",e[e.WARN=3]="WARN",e[e.ERROR=4]="ERROR",e[e.SILENT=5]="SILENT"}(Gn||(Gn={}));const Hn={debug:Gn.DEBUG,verbose:Gn.VERBOSE,info:Gn.INFO,warn:Gn.WARN,error:Gn.ERROR,silent:Gn.SILENT},Wn=Gn.INFO,Kn={[Gn.DEBUG]:"log",[Gn.VERBOSE]:"log",[Gn.INFO]:"info",[Gn.WARN]:"warn",[Gn.ERROR]:"error"},Qn=(e,t,...n)=>{if(t<e.logLevel)return;const r=(new Date).toISOString(),s=Kn[t];if(!s)throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);console[s](`[${r}]  ${e.name}:`,...n)};class Yn{constructor(e){this.name=e,this._logLevel=Wn,this._logHandler=Qn,this._userLogHandler=null,Un.push(this)}get logLevel(){return this._logLevel}set logLevel(e){if(!(e in Gn))throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);this._logLevel=e}setLogLevel(e){this._logLevel="string"==typeof e?Hn[e]:e}get logHandler(){return this._logHandler}set logHandler(e){if("function"!=typeof e)throw new TypeError("Value assigned to `logHandler` must be a function");this._logHandler=e}get userLogHandler(){return this._userLogHandler}set userLogHandler(e){this._userLogHandler=e}debug(...e){this._userLogHandler&&this._userLogHandler(this,Gn.DEBUG,...e),this._logHandler(this,Gn.DEBUG,...e)}log(...e){this._userLogHandler&&this._userLogHandler(this,Gn.VERBOSE,...e),this._logHandler(this,Gn.VERBOSE,...e)}info(...e){this._userLogHandler&&this._userLogHandler(this,Gn.INFO,...e),this._logHandler(this,Gn.INFO,...e)}warn(...e){this._userLogHandler&&this._userLogHandler(this,Gn.WARN,...e),this._logHandler(this,Gn.WARN,...e)}error(...e){this._userLogHandler&&this._userLogHandler(this,Gn.ERROR,...e),this._logHandler(this,Gn.ERROR,...e)}}const Xn=(e,t)=>t.some((t=>e instanceof t));let Jn,Zn;const er=new WeakMap,tr=new WeakMap,nr=new WeakMap,rr=new WeakMap,sr=new WeakMap;let ir={get(e,t,n){if(e instanceof IDBTransaction){if("done"===t)return tr.get(e);if("objectStoreNames"===t)return e.objectStoreNames||nr.get(e);if("store"===t)return n.objectStoreNames[1]?void 0:n.objectStore(n.objectStoreNames[0])}return lr(e[t])},set:(e,t,n)=>(e[t]=n,!0),has:(e,t)=>e instanceof IDBTransaction&&("done"===t||"store"===t)||t in e};function or(e){return e!==IDBDatabase.prototype.transaction||"objectStoreNames"in IDBTransaction.prototype?(Zn||(Zn=[IDBCursor.prototype.advance,IDBCursor.prototype.continue,IDBCursor.prototype.continuePrimaryKey])).includes(e)?function(...t){return e.apply(cr(this),t),lr(er.get(this))}:function(...t){return lr(e.apply(cr(this),t))}:function(t,...n){const r=e.call(cr(this),t,...n);return nr.set(r,t.sort?t.sort():[t]),lr(r)}}function ar(e){return"function"==typeof e?or(e):(e instanceof IDBTransaction&&function(e){if(tr.has(e))return;const t=new Promise(((t,n)=>{const r=()=>{e.removeEventListener("complete",s),e.removeEventListener("error",i),e.removeEventListener("abort",i)},s=()=>{t(),r()},i=()=>{n(e.error||new DOMException("AbortError","AbortError")),r()};e.addEventListener("complete",s),e.addEventListener("error",i),e.addEventListener("abort",i)}));tr.set(e,t)}(e),Xn(e,Jn||(Jn=[IDBDatabase,IDBObjectStore,IDBIndex,IDBCursor,IDBTransaction]))?new Proxy(e,ir):e)}function lr(e){if(e instanceof IDBRequest)return function(e){const t=new Promise(((t,n)=>{const r=()=>{e.removeEventListener("success",s),e.removeEventListener("error",i)},s=()=>{t(lr(e.result)),r()},i=()=>{n(e.error),r()};e.addEventListener("success",s),e.addEventListener("error",i)}));return t.then((t=>{t instanceof IDBCursor&&er.set(t,e)})).catch((()=>{})),sr.set(t,e),t}(e);if(rr.has(e))return rr.get(e);const t=ar(e);return t!==e&&(rr.set(e,t),sr.set(t,e)),t}const cr=e=>sr.get(e);const ur=["get","getKey","getAll","getAllKeys","count"],dr=["put","add","delete","clear"],hr=new Map;function pr(e,t){if(!(e instanceof IDBDatabase)||t in e||"string"!=typeof t)return;if(hr.get(t))return hr.get(t);const n=t.replace(/FromIndex$/,""),r=t!==n,s=dr.includes(n);if(!(n in(r?IDBIndex:IDBObjectStore).prototype)||!s&&!ur.includes(n))return;const i=async function(e,...t){const i=this.transaction(e,s?"readwrite":"readonly");let o=i.store;return r&&(o=o.index(t.shift())),(await Promise.all([o[n](...t),s&&i.done]))[0]};return hr.set(t,i),i}var fr;fr=e=>({...e,get:(t,n,r)=>pr(t,n)||e.get(t,n,r),has:(t,n)=>!!pr(t,n)||e.has(t,n)}),ir=fr(ir);class mr{constructor(e){this.container=e}getPlatformInfoString(){return this.container.getProviders().map((e=>{if(function(e){const t=e.getComponent();return"VERSION"===(null==t?void 0:t.type)}(e)){const t=e.getImmediate();return`${t.library}/${t.version}`}return null})).filter((e=>e)).join(" ")}}const gr="@firebase/app",yr="0.10.18",vr=new Yn("@firebase/app"),wr="[DEFAULT]",br={[gr]:"fire-core","@firebase/app-compat":"fire-core-compat","@firebase/analytics":"fire-analytics","@firebase/analytics-compat":"fire-analytics-compat","@firebase/app-check":"fire-app-check","@firebase/app-check-compat":"fire-app-check-compat","@firebase/auth":"fire-auth","@firebase/auth-compat":"fire-auth-compat","@firebase/database":"fire-rtdb","@firebase/data-connect":"fire-data-connect","@firebase/database-compat":"fire-rtdb-compat","@firebase/functions":"fire-fn","@firebase/functions-compat":"fire-fn-compat","@firebase/installations":"fire-iid","@firebase/installations-compat":"fire-iid-compat","@firebase/messaging":"fire-fcm","@firebase/messaging-compat":"fire-fcm-compat","@firebase/performance":"fire-perf","@firebase/performance-compat":"fire-perf-compat","@firebase/remote-config":"fire-rc","@firebase/remote-config-compat":"fire-rc-compat","@firebase/storage":"fire-gcs","@firebase/storage-compat":"fire-gcs-compat","@firebase/firestore":"fire-fst","@firebase/firestore-compat":"fire-fst-compat","@firebase/vertexai":"fire-vertex","fire-js":"fire-js",firebase:"fire-js-all"},Sr=new Map,Er=new Map,Tr=new Map;function _r(e,t){try{e.container.addComponent(t)}catch(n){vr.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`,n)}}function Cr(e){const t=e.name;if(Tr.has(t))return vr.debug(`There were multiple attempts to register component ${t}.`),!1;Tr.set(t,e);for(const t of Sr.values())_r(t,e);for(const t of Er.values())_r(t,e);return!0}function xr(e,t){const n=e.container.getProvider("heartbeat").getImmediate({optional:!0});return n&&n.triggerHeartbeat(),e.container.getProvider(t)}const Ar=new On("app","Firebase",{"no-app":"No Firebase App '{$appName}' has been created - call initializeApp() first","bad-app-name":"Illegal App name: '{$appName}'","duplicate-app":"Firebase App named '{$appName}' already exists with different options or config","app-deleted":"Firebase App named '{$appName}' already deleted","server-app-deleted":"Firebase Server App has been deleted","no-options":"Need to provide options, when not being deployed to hosting via source.","invalid-app-argument":"firebase.{$appName}() takes either no argument or a Firebase App instance.","invalid-log-argument":"First argument to `onLog` must be null or a function.","idb-open":"Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.","idb-get":"Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.","idb-set":"Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.","idb-delete":"Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.","finalization-registry-not-supported":"FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.","invalid-server-app-environment":"FirebaseServerApp is not for use in browser environments."});class Ir{constructor(e,t,n){this._isDeleted=!1,this._options=Object.assign({},e),this._config=Object.assign({},t),this._name=t.name,this._automaticDataCollectionEnabled=t.automaticDataCollectionEnabled,this._container=n,this.container.addComponent(new $n("app",(()=>this),"PUBLIC"))}get automaticDataCollectionEnabled(){return this.checkDestroyed(),this._automaticDataCollectionEnabled}set automaticDataCollectionEnabled(e){this.checkDestroyed(),this._automaticDataCollectionEnabled=e}get name(){return this.checkDestroyed(),this._name}get options(){return this.checkDestroyed(),this._options}get config(){return this.checkDestroyed(),this._config}get container(){return this._container}get isDeleted(){return this._isDeleted}set isDeleted(e){this._isDeleted=e}checkDestroyed(){if(this.isDeleted)throw Ar.create("app-deleted",{appName:this._name})}}function kr(e,t={}){let n=e;if("object"!=typeof t){t={name:t}}const r=Object.assign({name:wr,automaticDataCollectionEnabled:!1},t),s=r.name;if("string"!=typeof s||!s)throw Ar.create("bad-app-name",{appName:String(s)});if(n||(n=kn()),!n)throw Ar.create("no-options");const i=Sr.get(s);if(i){if(Rn(n,i.options)&&Rn(r,i.config))return i;throw Ar.create("duplicate-app",{appName:s})}const o=new zn(s);for(const e of Tr.values())o.addComponent(e);const a=new Ir(n,r,o);return Sr.set(s,a),a}function Lr(e,t,n){var r;let s=null!==(r=br[e])&&void 0!==r?r:e;n&&(s+=`-${n}`);const i=s.match(/\s|\//),o=t.match(/\s|\//);if(i||o){const e=[`Unable to register library "${s}" with version "${t}":`];return i&&e.push(`library name "${s}" contains illegal characters (whitespace or "/")`),i&&o&&e.push("and"),o&&e.push(`version name "${t}" contains illegal characters (whitespace or "/")`),void vr.warn(e.join(" "))}Cr(new $n(`${s}-version`,(()=>({library:s,version:t})),"VERSION"))}const Mr="firebase-heartbeat-database",Dr=1,Nr="firebase-heartbeat-store";let Pr=null;function Or(){return Pr||(Pr=function(e,t,{blocked:n,upgrade:r,blocking:s,terminated:i}={}){const o=indexedDB.open(e,t),a=lr(o);return r&&o.addEventListener("upgradeneeded",(e=>{r(lr(o.result),e.oldVersion,e.newVersion,lr(o.transaction),e)})),n&&o.addEventListener("blocked",(e=>n(e.oldVersion,e.newVersion,e))),a.then((e=>{i&&e.addEventListener("close",(()=>i())),s&&e.addEventListener("versionchange",(e=>s(e.oldVersion,e.newVersion,e)))})).catch((()=>{})),a}(Mr,Dr,{upgrade:(e,t)=>{if(0===t)try{e.createObjectStore(Nr)}catch(e){console.warn(e)}}}).catch((e=>{throw Ar.create("idb-open",{originalErrorMessage:e.message})}))),Pr}async function qr(e,t){try{const n=(await Or()).transaction(Nr,"readwrite"),r=n.objectStore(Nr);await r.put(t,Rr(e)),await n.done}catch(e){if(e instanceof Pn)vr.warn(e.message);else{const t=Ar.create("idb-set",{originalErrorMessage:null==e?void 0:e.message});vr.warn(t.message)}}}function Rr(e){return`${e.name}!${e.options.appId}`}class Fr{constructor(e){this.container=e,this._heartbeatsCache=null;const t=this.container.getProvider("app").getImmediate();this._storage=new $r(t),this._heartbeatsCachePromise=this._storage.read().then((e=>(this._heartbeatsCache=e,e)))}async triggerHeartbeat(){var e,t;try{const n=this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(),r=Br();if(null==(null===(e=this._heartbeatsCache)||void 0===e?void 0:e.heartbeats)&&(this._heartbeatsCache=await this._heartbeatsCachePromise,null==(null===(t=this._heartbeatsCache)||void 0===t?void 0:t.heartbeats)))return;if(this._heartbeatsCache.lastSentHeartbeatDate===r||this._heartbeatsCache.heartbeats.some((e=>e.date===r)))return;return this._heartbeatsCache.heartbeats.push({date:r,agent:n}),this._heartbeatsCache.heartbeats=this._heartbeatsCache.heartbeats.filter((e=>{const t=new Date(e.date).valueOf();return Date.now()-t<=2592e6})),this._storage.overwrite(this._heartbeatsCache)}catch(e){vr.warn(e)}}async getHeartbeatsHeader(){var e;try{if(null===this._heartbeatsCache&&await this._heartbeatsCachePromise,null==(null===(e=this._heartbeatsCache)||void 0===e?void 0:e.heartbeats)||0===this._heartbeatsCache.heartbeats.length)return"";const t=Br(),{heartbeatsToSend:n,unsentEntries:r}=function(e,t=1024){const n=[];let r=e.slice();for(const s of e){const e=n.find((e=>e.agent===s.agent));if(e){if(e.dates.push(s.date),Vr(n)>t){e.dates.pop();break}}else if(n.push({agent:s.agent,dates:[s.date]}),Vr(n)>t){n.pop();break}r=r.slice(1)}return{heartbeatsToSend:n,unsentEntries:r}}(this._heartbeatsCache.heartbeats),s=_n(JSON.stringify({version:2,heartbeats:n}));return this._heartbeatsCache.lastSentHeartbeatDate=t,r.length>0?(this._heartbeatsCache.heartbeats=r,await this._storage.overwrite(this._heartbeatsCache)):(this._heartbeatsCache.heartbeats=[],this._storage.overwrite(this._heartbeatsCache)),s}catch(e){return vr.warn(e),""}}}function Br(){return(new Date).toISOString().substring(0,10)}class $r{constructor(e){this.app=e,this._canUseIndexedDBPromise=this.runIndexedDBEnvironmentCheck()}async runIndexedDBEnvironmentCheck(){return!!Nn()&&new Promise(((e,t)=>{try{let n=!0;const r="validate-browser-context-for-indexeddb-analytics-module",s=self.indexedDB.open(r);s.onsuccess=()=>{s.result.close(),n||self.indexedDB.deleteDatabase(r),e(!0)},s.onupgradeneeded=()=>{n=!1},s.onerror=()=>{var e;t((null===(e=s.error)||void 0===e?void 0:e.message)||"")}}catch(e){t(e)}})).then((()=>!0)).catch((()=>!1))}async read(){if(await this._canUseIndexedDBPromise){const e=await async function(e){try{const t=(await Or()).transaction(Nr),n=await t.objectStore(Nr).get(Rr(e));return await t.done,n}catch(e){if(e instanceof Pn)vr.warn(e.message);else{const t=Ar.create("idb-get",{originalErrorMessage:null==e?void 0:e.message});vr.warn(t.message)}}}(this.app);return(null==e?void 0:e.heartbeats)?e:{heartbeats:[]}}return{heartbeats:[]}}async overwrite(e){var t;if(await this._canUseIndexedDBPromise){const n=await this.read();return qr(this.app,{lastSentHeartbeatDate:null!==(t=e.lastSentHeartbeatDate)&&void 0!==t?t:n.lastSentHeartbeatDate,heartbeats:e.heartbeats})}}async add(e){var t;if(await this._canUseIndexedDBPromise){const n=await this.read();return qr(this.app,{lastSentHeartbeatDate:null!==(t=e.lastSentHeartbeatDate)&&void 0!==t?t:n.lastSentHeartbeatDate,heartbeats:[...n.heartbeats,...e.heartbeats]})}}}function Vr(e){return _n(JSON.stringify({version:2,heartbeats:e})).length}var jr;jr="",Cr(new $n("platform-logger",(e=>new mr(e)),"PRIVATE")),Cr(new $n("heartbeat",(e=>new Fr(e)),"PRIVATE")),Lr(gr,yr,jr),Lr(gr,yr,"esm2017"),Lr("fire-js","");Lr("firebase","11.2.0","app");var zr,Ur,Gr="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},Hr={};(function(){var e;function t(){this.blockSize=-1,this.blockSize=64,this.g=Array(4),this.B=Array(this.blockSize),this.o=this.h=0,this.s()}function n(e,t,n){n||(n=0);var r=Array(16);if("string"==typeof t)for(var s=0;16>s;++s)r[s]=t.charCodeAt(n++)|t.charCodeAt(n++)<<8|t.charCodeAt(n++)<<16|t.charCodeAt(n++)<<24;else for(s=0;16>s;++s)r[s]=t[n++]|t[n++]<<8|t[n++]<<16|t[n++]<<24;t=e.g[0],n=e.g[1],s=e.g[2];var i=e.g[3],o=t+(i^n&(s^i))+r[0]+3614090360&4294967295;o=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=(n=(s=(i=(t=n+(o<<7&4294967295|o>>>25))+((o=i+(s^t&(n^s))+r[1]+3905402710&4294967295)<<12&4294967295|o>>>20))+((o=s+(n^i&(t^n))+r[2]+606105819&4294967295)<<17&4294967295|o>>>15))+((o=n+(t^s&(i^t))+r[3]+3250441966&4294967295)<<22&4294967295|o>>>10))+((o=t+(i^n&(s^i))+r[4]+4118548399&4294967295)<<7&4294967295|o>>>25))+((o=i+(s^t&(n^s))+r[5]+1200080426&4294967295)<<12&4294967295|o>>>20))+((o=s+(n^i&(t^n))+r[6]+2821735955&4294967295)<<17&4294967295|o>>>15))+((o=n+(t^s&(i^t))+r[7]+4249261313&4294967295)<<22&4294967295|o>>>10))+((o=t+(i^n&(s^i))+r[8]+1770035416&4294967295)<<7&4294967295|o>>>25))+((o=i+(s^t&(n^s))+r[9]+2336552879&4294967295)<<12&4294967295|o>>>20))+((o=s+(n^i&(t^n))+r[10]+4294925233&4294967295)<<17&4294967295|o>>>15))+((o=n+(t^s&(i^t))+r[11]+2304563134&4294967295)<<22&4294967295|o>>>10))+((o=t+(i^n&(s^i))+r[12]+1804603682&4294967295)<<7&4294967295|o>>>25))+((o=i+(s^t&(n^s))+r[13]+4254626195&4294967295)<<12&4294967295|o>>>20))+((o=s+(n^i&(t^n))+r[14]+2792965006&4294967295)<<17&4294967295|o>>>15))+((o=n+(t^s&(i^t))+r[15]+1236535329&4294967295)<<22&4294967295|o>>>10))+((o=t+(s^i&(n^s))+r[1]+4129170786&4294967295)<<5&4294967295|o>>>27))+((o=i+(n^s&(t^n))+r[6]+3225465664&4294967295)<<9&4294967295|o>>>23))+((o=s+(t^n&(i^t))+r[11]+643717713&4294967295)<<14&4294967295|o>>>18))+((o=n+(i^t&(s^i))+r[0]+3921069994&4294967295)<<20&4294967295|o>>>12))+((o=t+(s^i&(n^s))+r[5]+3593408605&4294967295)<<5&4294967295|o>>>27))+((o=i+(n^s&(t^n))+r[10]+38016083&4294967295)<<9&4294967295|o>>>23))+((o=s+(t^n&(i^t))+r[15]+3634488961&4294967295)<<14&4294967295|o>>>18))+((o=n+(i^t&(s^i))+r[4]+3889429448&4294967295)<<20&4294967295|o>>>12))+((o=t+(s^i&(n^s))+r[9]+568446438&4294967295)<<5&4294967295|o>>>27))+((o=i+(n^s&(t^n))+r[14]+3275163606&4294967295)<<9&4294967295|o>>>23))+((o=s+(t^n&(i^t))+r[3]+4107603335&4294967295)<<14&4294967295|o>>>18))+((o=n+(i^t&(s^i))+r[8]+1163531501&4294967295)<<20&4294967295|o>>>12))+((o=t+(s^i&(n^s))+r[13]+2850285829&4294967295)<<5&4294967295|o>>>27))+((o=i+(n^s&(t^n))+r[2]+4243563512&4294967295)<<9&4294967295|o>>>23))+((o=s+(t^n&(i^t))+r[7]+1735328473&4294967295)<<14&4294967295|o>>>18))+((o=n+(i^t&(s^i))+r[12]+2368359562&4294967295)<<20&4294967295|o>>>12))+((o=t+(n^s^i)+r[5]+4294588738&4294967295)<<4&4294967295|o>>>28))+((o=i+(t^n^s)+r[8]+2272392833&4294967295)<<11&4294967295|o>>>21))+((o=s+(i^t^n)+r[11]+1839030562&4294967295)<<16&4294967295|o>>>16))+((o=n+(s^i^t)+r[14]+4259657740&4294967295)<<23&4294967295|o>>>9))+((o=t+(n^s^i)+r[1]+2763975236&4294967295)<<4&4294967295|o>>>28))+((o=i+(t^n^s)+r[4]+1272893353&4294967295)<<11&4294967295|o>>>21))+((o=s+(i^t^n)+r[7]+4139469664&4294967295)<<16&4294967295|o>>>16))+((o=n+(s^i^t)+r[10]+3200236656&4294967295)<<23&4294967295|o>>>9))+((o=t+(n^s^i)+r[13]+681279174&4294967295)<<4&4294967295|o>>>28))+((o=i+(t^n^s)+r[0]+3936430074&4294967295)<<11&4294967295|o>>>21))+((o=s+(i^t^n)+r[3]+3572445317&4294967295)<<16&4294967295|o>>>16))+((o=n+(s^i^t)+r[6]+76029189&4294967295)<<23&4294967295|o>>>9))+((o=t+(n^s^i)+r[9]+3654602809&4294967295)<<4&4294967295|o>>>28))+((o=i+(t^n^s)+r[12]+3873151461&4294967295)<<11&4294967295|o>>>21))+((o=s+(i^t^n)+r[15]+530742520&4294967295)<<16&4294967295|o>>>16))+((o=n+(s^i^t)+r[2]+3299628645&4294967295)<<23&4294967295|o>>>9))+((o=t+(s^(n|~i))+r[0]+4096336452&4294967295)<<6&4294967295|o>>>26))+((o=i+(n^(t|~s))+r[7]+1126891415&4294967295)<<10&4294967295|o>>>22))+((o=s+(t^(i|~n))+r[14]+2878612391&4294967295)<<15&4294967295|o>>>17))+((o=n+(i^(s|~t))+r[5]+4237533241&4294967295)<<21&4294967295|o>>>11))+((o=t+(s^(n|~i))+r[12]+1700485571&4294967295)<<6&4294967295|o>>>26))+((o=i+(n^(t|~s))+r[3]+2399980690&4294967295)<<10&4294967295|o>>>22))+((o=s+(t^(i|~n))+r[10]+4293915773&4294967295)<<15&4294967295|o>>>17))+((o=n+(i^(s|~t))+r[1]+2240044497&4294967295)<<21&4294967295|o>>>11))+((o=t+(s^(n|~i))+r[8]+1873313359&4294967295)<<6&4294967295|o>>>26))+((o=i+(n^(t|~s))+r[15]+4264355552&4294967295)<<10&4294967295|o>>>22))+((o=s+(t^(i|~n))+r[6]+2734768916&4294967295)<<15&4294967295|o>>>17))+((o=n+(i^(s|~t))+r[13]+1309151649&4294967295)<<21&4294967295|o>>>11))+((i=(t=n+((o=t+(s^(n|~i))+r[4]+4149444226&4294967295)<<6&4294967295|o>>>26))+((o=i+(n^(t|~s))+r[11]+3174756917&4294967295)<<10&4294967295|o>>>22))^((s=i+((o=s+(t^(i|~n))+r[2]+718787259&4294967295)<<15&4294967295|o>>>17))|~t))+r[9]+3951481745&4294967295,e.g[0]=e.g[0]+t&4294967295,e.g[1]=e.g[1]+(s+(o<<21&4294967295|o>>>11))&4294967295,e.g[2]=e.g[2]+s&4294967295,e.g[3]=e.g[3]+i&4294967295}function r(e,t){this.h=t;for(var n=[],r=!0,s=e.length-1;0<=s;s--){var i=0|e[s];r&&i==t||(n[s]=i,r=!1)}this.g=n}!function(e,t){function n(){}n.prototype=t.prototype,e.D=t.prototype,e.prototype=new n,e.prototype.constructor=e,e.C=function(e,n,r){for(var s=Array(arguments.length-2),i=2;i<arguments.length;i++)s[i-2]=arguments[i];return t.prototype[n].apply(e,s)}}(t,(function(){this.blockSize=-1})),t.prototype.s=function(){this.g[0]=1732584193,this.g[1]=4023233417,this.g[2]=2562383102,this.g[3]=271733878,this.o=this.h=0},t.prototype.u=function(e,t){void 0===t&&(t=e.length);for(var r=t-this.blockSize,s=this.B,i=this.h,o=0;o<t;){if(0==i)for(;o<=r;)n(this,e,o),o+=this.blockSize;if("string"==typeof e){for(;o<t;)if(s[i++]=e.charCodeAt(o++),i==this.blockSize){n(this,s),i=0;break}}else for(;o<t;)if(s[i++]=e[o++],i==this.blockSize){n(this,s),i=0;break}}this.h=i,this.o+=t},t.prototype.v=function(){var e=Array((56>this.h?this.blockSize:2*this.blockSize)-this.h);e[0]=128;for(var t=1;t<e.length-8;++t)e[t]=0;var n=8*this.o;for(t=e.length-8;t<e.length;++t)e[t]=255&n,n/=256;for(this.u(e),e=Array(16),t=n=0;4>t;++t)for(var r=0;32>r;r+=8)e[n++]=this.g[t]>>>r&255;return e};var s={};function i(e){return-128<=e&&128>e?function(e,t){var n=s;return Object.prototype.hasOwnProperty.call(n,e)?n[e]:n[e]=t(e)}(e,(function(e){return new r([0|e],0>e?-1:0)})):new r([0|e],0>e?-1:0)}function o(e){if(isNaN(e)||!isFinite(e))return a;if(0>e)return h(o(-e));for(var t=[],n=1,s=0;e>=n;s++)t[s]=e/n|0,n*=4294967296;return new r(t,0)}var a=i(0),l=i(1),c=i(16777216);function u(e){if(0!=e.h)return!1;for(var t=0;t<e.g.length;t++)if(0!=e.g[t])return!1;return!0}function d(e){return-1==e.h}function h(e){for(var t=e.g.length,n=[],s=0;s<t;s++)n[s]=~e.g[s];return new r(n,~e.h).add(l)}function p(e,t){return e.add(h(t))}function f(e,t){for(;(65535&e[t])!=e[t];)e[t+1]+=e[t]>>>16,e[t]&=65535,t++}function m(e,t){this.g=e,this.h=t}function g(e,t){if(u(t))throw Error("division by zero");if(u(e))return new m(a,a);if(d(e))return t=g(h(e),t),new m(h(t.g),h(t.h));if(d(t))return t=g(e,h(t)),new m(h(t.g),t.h);if(30<e.g.length){if(d(e)||d(t))throw Error("slowDivide_ only works with positive integers.");for(var n=l,r=t;0>=r.l(e);)n=y(n),r=y(r);var s=v(n,1),i=v(r,1);for(r=v(r,2),n=v(n,2);!u(r);){var c=i.add(r);0>=c.l(e)&&(s=s.add(n),i=c),r=v(r,1),n=v(n,1)}return t=p(e,s.j(t)),new m(s,t)}for(s=a;0<=e.l(t);){for(n=Math.max(1,Math.floor(e.m()/t.m())),r=48>=(r=Math.ceil(Math.log(n)/Math.LN2))?1:Math.pow(2,r-48),c=(i=o(n)).j(t);d(c)||0<c.l(e);)c=(i=o(n-=r)).j(t);u(i)&&(i=l),s=s.add(i),e=p(e,c)}return new m(s,e)}function y(e){for(var t=e.g.length+1,n=[],s=0;s<t;s++)n[s]=e.i(s)<<1|e.i(s-1)>>>31;return new r(n,e.h)}function v(e,t){var n=t>>5;t%=32;for(var s=e.g.length-n,i=[],o=0;o<s;o++)i[o]=0<t?e.i(o+n)>>>t|e.i(o+n+1)<<32-t:e.i(o+n);return new r(i,e.h)}(e=r.prototype).m=function(){if(d(this))return-h(this).m();for(var e=0,t=1,n=0;n<this.g.length;n++){var r=this.i(n);e+=(0<=r?r:4294967296+r)*t,t*=4294967296}return e},e.toString=function(e){if(2>(e=e||10)||36<e)throw Error("radix out of range: "+e);if(u(this))return"0";if(d(this))return"-"+h(this).toString(e);for(var t=o(Math.pow(e,6)),n=this,r="";;){var s=g(n,t).g,i=((0<(n=p(n,s.j(t))).g.length?n.g[0]:n.h)>>>0).toString(e);if(u(n=s))return i+r;for(;6>i.length;)i="0"+i;r=i+r}},e.i=function(e){return 0>e?0:e<this.g.length?this.g[e]:this.h},e.l=function(e){return d(e=p(this,e))?-1:u(e)?0:1},e.abs=function(){return d(this)?h(this):this},e.add=function(e){for(var t=Math.max(this.g.length,e.g.length),n=[],s=0,i=0;i<=t;i++){var o=s+(65535&this.i(i))+(65535&e.i(i)),a=(o>>>16)+(this.i(i)>>>16)+(e.i(i)>>>16);s=a>>>16,o&=65535,a&=65535,n[i]=a<<16|o}return new r(n,-2147483648&n[n.length-1]?-1:0)},e.j=function(e){if(u(this)||u(e))return a;if(d(this))return d(e)?h(this).j(h(e)):h(h(this).j(e));if(d(e))return h(this.j(h(e)));if(0>this.l(c)&&0>e.l(c))return o(this.m()*e.m());for(var t=this.g.length+e.g.length,n=[],s=0;s<2*t;s++)n[s]=0;for(s=0;s<this.g.length;s++)for(var i=0;i<e.g.length;i++){var l=this.i(s)>>>16,p=65535&this.i(s),m=e.i(i)>>>16,g=65535&e.i(i);n[2*s+2*i]+=p*g,f(n,2*s+2*i),n[2*s+2*i+1]+=l*g,f(n,2*s+2*i+1),n[2*s+2*i+1]+=p*m,f(n,2*s+2*i+1),n[2*s+2*i+2]+=l*m,f(n,2*s+2*i+2)}for(s=0;s<t;s++)n[s]=n[2*s+1]<<16|n[2*s];for(s=t;s<2*t;s++)n[s]=0;return new r(n,0)},e.A=function(e){return g(this,e).h},e.and=function(e){for(var t=Math.max(this.g.length,e.g.length),n=[],s=0;s<t;s++)n[s]=this.i(s)&e.i(s);return new r(n,this.h&e.h)},e.or=function(e){for(var t=Math.max(this.g.length,e.g.length),n=[],s=0;s<t;s++)n[s]=this.i(s)|e.i(s);return new r(n,this.h|e.h)},e.xor=function(e){for(var t=Math.max(this.g.length,e.g.length),n=[],s=0;s<t;s++)n[s]=this.i(s)^e.i(s);return new r(n,this.h^e.h)},t.prototype.digest=t.prototype.v,t.prototype.reset=t.prototype.s,t.prototype.update=t.prototype.u,Ur=Hr.Md5=t,r.prototype.add=r.prototype.add,r.prototype.multiply=r.prototype.j,r.prototype.modulo=r.prototype.A,r.prototype.compare=r.prototype.l,r.prototype.toNumber=r.prototype.m,r.prototype.toString=r.prototype.toString,r.prototype.getBits=r.prototype.i,r.fromNumber=o,r.fromString=function e(t,n){if(0==t.length)throw Error("number format error: empty string");if(2>(n=n||10)||36<n)throw Error("radix out of range: "+n);if("-"==t.charAt(0))return h(e(t.substring(1),n));if(0<=t.indexOf("-"))throw Error('number format error: interior "-" character');for(var r=o(Math.pow(n,8)),s=a,i=0;i<t.length;i+=8){var l=Math.min(8,t.length-i),c=parseInt(t.substring(i,i+l),n);8>l?(l=o(Math.pow(n,l)),s=s.j(l).add(o(c))):s=(s=s.j(r)).add(o(c))}return s},zr=Hr.Integer=r}).apply(void 0!==Gr?Gr:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{});var Wr,Kr,Qr,Yr,Xr,Jr,Zr,es,ts="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},ns={};(function(){var e,t="function"==typeof Object.defineProperties?Object.defineProperty:function(e,t,n){return e==Array.prototype||e==Object.prototype||(e[t]=n.value),e};var n=function(e){e=["object"==typeof globalThis&&globalThis,e,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof ts&&ts];for(var t=0;t<e.length;++t){var n=e[t];if(n&&n.Math==Math)return n}throw Error("Cannot find global object")}(this);!function(e,r){if(r)e:{var s=n;e=e.split(".");for(var i=0;i<e.length-1;i++){var o=e[i];if(!(o in s))break e;s=s[o]}(r=r(i=s[e=e[e.length-1]]))!=i&&null!=r&&t(s,e,{configurable:!0,writable:!0,value:r})}}("Array.prototype.values",(function(e){return e||function(){return function(e,t){e instanceof String&&(e+="");var n=0,r=!1,s={next:function(){if(!r&&n<e.length){var s=n++;return{value:t(s,e[s]),done:!1}}return r=!0,{done:!0,value:void 0}}};return s[Symbol.iterator]=function(){return s},s}(this,(function(e,t){return t}))}}));var r=r||{},s=this||self;function i(e){var t=typeof e;return"array"==(t="object"!=t?t:e?Array.isArray(e)?"array":t:"null")||"object"==t&&"number"==typeof e.length}function o(e){var t=typeof e;return"object"==t&&null!=e||"function"==t}function a(e,t,n){return e.call.apply(e.bind,arguments)}function l(e,t,n){if(!e)throw Error();if(2<arguments.length){var r=Array.prototype.slice.call(arguments,2);return function(){var n=Array.prototype.slice.call(arguments);return Array.prototype.unshift.apply(n,r),e.apply(t,n)}}return function(){return e.apply(t,arguments)}}function c(e,t,n){return(c=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?a:l).apply(null,arguments)}function u(e,t){var n=Array.prototype.slice.call(arguments,1);return function(){var t=n.slice();return t.push.apply(t,arguments),e.apply(this,t)}}function d(e,t){function n(){}n.prototype=t.prototype,e.aa=t.prototype,e.prototype=new n,e.prototype.constructor=e,e.Qb=function(e,n,r){for(var s=Array(arguments.length-2),i=2;i<arguments.length;i++)s[i-2]=arguments[i];return t.prototype[n].apply(e,s)}}function h(e){const t=e.length;if(0<t){const n=Array(t);for(let r=0;r<t;r++)n[r]=e[r];return n}return[]}function p(e,t){for(let t=1;t<arguments.length;t++){const n=arguments[t];if(i(n)){const t=e.length||0,r=n.length||0;e.length=t+r;for(let s=0;s<r;s++)e[t+s]=n[s]}else e.push(n)}}function f(e){return/^[\s\xa0]*$/.test(e)}function m(){var e=s.navigator;return e&&(e=e.userAgent)?e:""}function g(e){return g[" "](e),e}g[" "]=function(){};var y=!(-1==m().indexOf("Gecko")||-1!=m().toLowerCase().indexOf("webkit")&&-1==m().indexOf("Edge")||-1!=m().indexOf("Trident")||-1!=m().indexOf("MSIE")||-1!=m().indexOf("Edge"));function v(e,t,n){for(const r in e)t.call(n,e[r],r,e)}function w(e){const t={};for(const n in e)t[n]=e[n];return t}const b="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function S(e,t){let n,r;for(let t=1;t<arguments.length;t++){for(n in r=arguments[t],r)e[n]=r[n];for(let t=0;t<b.length;t++)n=b[t],Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}}function E(e){var t=1;e=e.split(":");const n=[];for(;0<t&&e.length;)n.push(e.shift()),t--;return e.length&&n.push(e.join(":")),n}function T(e){s.setTimeout((()=>{throw e}),0)}function _(){var e=k;let t=null;return e.g&&(t=e.g,e.g=e.g.next,e.g||(e.h=null),t.next=null),t}var C=new class{constructor(e,t){this.i=e,this.j=t,this.h=0,this.g=null}get(){let e;return 0<this.h?(this.h--,e=this.g,this.g=e.next,e.next=null):e=this.i(),e}}((()=>new x),(e=>e.reset()));class x{constructor(){this.next=this.g=this.h=null}set(e,t){this.h=e,this.g=t,this.next=null}reset(){this.next=this.g=this.h=null}}let A,I=!1,k=new class{constructor(){this.h=this.g=null}add(e,t){const n=C.get();n.set(e,t),this.h?this.h.next=n:this.g=n,this.h=n}},L=()=>{const e=s.Promise.resolve(void 0);A=()=>{e.then(M)}};var M=()=>{for(var e;e=_();){try{e.h.call(e.g)}catch(e){T(e)}var t=C;t.j(e),100>t.h&&(t.h++,e.next=t.g,t.g=e)}I=!1};function D(){this.s=this.s,this.C=this.C}function N(e,t){this.type=e,this.g=this.target=t,this.defaultPrevented=!1}D.prototype.s=!1,D.prototype.ma=function(){this.s||(this.s=!0,this.N())},D.prototype.N=function(){if(this.C)for(;this.C.length;)this.C.shift()()},N.prototype.h=function(){this.defaultPrevented=!0};var P=function(){if(!s.addEventListener||!Object.defineProperty)return!1;var e=!1,t=Object.defineProperty({},"passive",{get:function(){e=!0}});try{const e=()=>{};s.addEventListener("test",e,t),s.removeEventListener("test",e,t)}catch(e){}return e}();function O(e,t){if(N.call(this,e?e.type:""),this.relatedTarget=this.g=this.target=null,this.button=this.screenY=this.screenX=this.clientY=this.clientX=0,this.key="",this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1,this.state=null,this.pointerId=0,this.pointerType="",this.i=null,e){var n=this.type=e.type,r=e.changedTouches&&e.changedTouches.length?e.changedTouches[0]:null;if(this.target=e.target||e.srcElement,this.g=t,t=e.relatedTarget){if(y){e:{try{g(t.nodeName);var s=!0;break e}catch(e){}s=!1}s||(t=null)}}else"mouseover"==n?t=e.fromElement:"mouseout"==n&&(t=e.toElement);this.relatedTarget=t,r?(this.clientX=void 0!==r.clientX?r.clientX:r.pageX,this.clientY=void 0!==r.clientY?r.clientY:r.pageY,this.screenX=r.screenX||0,this.screenY=r.screenY||0):(this.clientX=void 0!==e.clientX?e.clientX:e.pageX,this.clientY=void 0!==e.clientY?e.clientY:e.pageY,this.screenX=e.screenX||0,this.screenY=e.screenY||0),this.button=e.button,this.key=e.key||"",this.ctrlKey=e.ctrlKey,this.altKey=e.altKey,this.shiftKey=e.shiftKey,this.metaKey=e.metaKey,this.pointerId=e.pointerId||0,this.pointerType="string"==typeof e.pointerType?e.pointerType:q[e.pointerType]||"",this.state=e.state,this.i=e,e.defaultPrevented&&O.aa.h.call(this)}}d(O,N);var q={2:"touch",3:"pen",4:"mouse"};O.prototype.h=function(){O.aa.h.call(this);var e=this.i;e.preventDefault?e.preventDefault():e.returnValue=!1};var R="closure_listenable_"+(1e6*Math.random()|0),F=0;function B(e,t,n,r,s){this.listener=e,this.proxy=null,this.src=t,this.type=n,this.capture=!!r,this.ha=s,this.key=++F,this.da=this.fa=!1}function $(e){e.da=!0,e.listener=null,e.proxy=null,e.src=null,e.ha=null}function V(e){this.src=e,this.g={},this.h=0}function j(e,t){var n=t.type;if(n in e.g){var r,s=e.g[n],i=Array.prototype.indexOf.call(s,t,void 0);(r=0<=i)&&Array.prototype.splice.call(s,i,1),r&&($(t),0==e.g[n].length&&(delete e.g[n],e.h--))}}function z(e,t,n,r){for(var s=0;s<e.length;++s){var i=e[s];if(!i.da&&i.listener==t&&i.capture==!!n&&i.ha==r)return s}return-1}V.prototype.add=function(e,t,n,r,s){var i=e.toString();(e=this.g[i])||(e=this.g[i]=[],this.h++);var o=z(e,t,r,s);return-1<o?(t=e[o],n||(t.fa=!1)):((t=new B(t,this.src,i,!!r,s)).fa=n,e.push(t)),t};var U="closure_lm_"+(1e6*Math.random()|0),G={};function H(e,t,n,r,s){if(r&&r.once)return K(e,t,n,r,s);if(Array.isArray(t)){for(var i=0;i<t.length;i++)H(e,t[i],n,r,s);return null}return n=te(n),e&&e[R]?e.K(t,n,o(r)?!!r.capture:!!r,s):W(e,t,n,!1,r,s)}function W(e,t,n,r,s,i){if(!t)throw Error("Invalid event type");var a=o(s)?!!s.capture:!!s,l=Z(e);if(l||(e[U]=l=new V(e)),(n=l.add(t,n,r,a,i)).proxy)return n;if(r=function(){function e(n){return t.call(e.src,e.listener,n)}const t=J;return e}(),n.proxy=r,r.src=e,r.listener=n,e.addEventListener)P||(s=a),void 0===s&&(s=!1),e.addEventListener(t.toString(),r,s);else if(e.attachEvent)e.attachEvent(X(t.toString()),r);else{if(!e.addListener||!e.removeListener)throw Error("addEventListener and attachEvent are unavailable.");e.addListener(r)}return n}function K(e,t,n,r,s){if(Array.isArray(t)){for(var i=0;i<t.length;i++)K(e,t[i],n,r,s);return null}return n=te(n),e&&e[R]?e.L(t,n,o(r)?!!r.capture:!!r,s):W(e,t,n,!0,r,s)}function Q(e,t,n,r,s){if(Array.isArray(t))for(var i=0;i<t.length;i++)Q(e,t[i],n,r,s);else r=o(r)?!!r.capture:!!r,n=te(n),e&&e[R]?(e=e.i,(t=String(t).toString())in e.g&&(-1<(n=z(i=e.g[t],n,r,s))&&($(i[n]),Array.prototype.splice.call(i,n,1),0==i.length&&(delete e.g[t],e.h--)))):e&&(e=Z(e))&&(t=e.g[t.toString()],e=-1,t&&(e=z(t,n,r,s)),(n=-1<e?t[e]:null)&&Y(n))}function Y(e){if("number"!=typeof e&&e&&!e.da){var t=e.src;if(t&&t[R])j(t.i,e);else{var n=e.type,r=e.proxy;t.removeEventListener?t.removeEventListener(n,r,e.capture):t.detachEvent?t.detachEvent(X(n),r):t.addListener&&t.removeListener&&t.removeListener(r),(n=Z(t))?(j(n,e),0==n.h&&(n.src=null,t[U]=null)):$(e)}}}function X(e){return e in G?G[e]:G[e]="on"+e}function J(e,t){if(e.da)e=!0;else{t=new O(t,this);var n=e.listener,r=e.ha||e.src;e.fa&&Y(e),e=n.call(r,t)}return e}function Z(e){return(e=e[U])instanceof V?e:null}var ee="__closure_events_fn_"+(1e9*Math.random()>>>0);function te(e){return"function"==typeof e?e:(e[ee]||(e[ee]=function(t){return e.handleEvent(t)}),e[ee])}function ne(){D.call(this),this.i=new V(this),this.M=this,this.F=null}function re(e,t){var n,r=e.F;if(r)for(n=[];r;r=r.F)n.push(r);if(e=e.M,r=t.type||t,"string"==typeof t)t=new N(t,e);else if(t instanceof N)t.target=t.target||e;else{var s=t;S(t=new N(r,e),s)}if(s=!0,n)for(var i=n.length-1;0<=i;i--){var o=t.g=n[i];s=se(o,r,!0,t)&&s}if(s=se(o=t.g=e,r,!0,t)&&s,s=se(o,r,!1,t)&&s,n)for(i=0;i<n.length;i++)s=se(o=t.g=n[i],r,!1,t)&&s}function se(e,t,n,r){if(!(t=e.i.g[String(t)]))return!0;t=t.concat();for(var s=!0,i=0;i<t.length;++i){var o=t[i];if(o&&!o.da&&o.capture==n){var a=o.listener,l=o.ha||o.src;o.fa&&j(e.i,o),s=!1!==a.call(l,r)&&s}}return s&&!r.defaultPrevented}function ie(e,t,n){if("function"==typeof e)n&&(e=c(e,n));else{if(!e||"function"!=typeof e.handleEvent)throw Error("Invalid listener argument");e=c(e.handleEvent,e)}return 2147483647<Number(t)?-1:s.setTimeout(e,t||0)}function oe(e){e.g=ie((()=>{e.g=null,e.i&&(e.i=!1,oe(e))}),e.l);const t=e.h;e.h=null,e.m.apply(null,t)}d(ne,D),ne.prototype[R]=!0,ne.prototype.removeEventListener=function(e,t,n,r){Q(this,e,t,n,r)},ne.prototype.N=function(){if(ne.aa.N.call(this),this.i){var e,t=this.i;for(e in t.g){for(var n=t.g[e],r=0;r<n.length;r++)$(n[r]);delete t.g[e],t.h--}}this.F=null},ne.prototype.K=function(e,t,n,r){return this.i.add(String(e),t,!1,n,r)},ne.prototype.L=function(e,t,n,r){return this.i.add(String(e),t,!0,n,r)};class ae extends D{constructor(e,t){super(),this.m=e,this.l=t,this.h=null,this.i=!1,this.g=null}j(e){this.h=arguments,this.g?this.i=!0:oe(this)}N(){super.N(),this.g&&(s.clearTimeout(this.g),this.g=null,this.i=!1,this.h=null)}}function le(e){D.call(this),this.h=e,this.g={}}d(le,D);var ce=[];function ue(e){v(e.g,(function(e,t){this.g.hasOwnProperty(t)&&Y(e)}),e),e.g={}}le.prototype.N=function(){le.aa.N.call(this),ue(this)},le.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented")};var de=s.JSON.stringify,he=s.JSON.parse,pe=class{stringify(e){return s.JSON.stringify(e,void 0)}parse(e){return s.JSON.parse(e,void 0)}};function fe(){}function me(e){return e.h||(e.h=e.i())}function ge(){}fe.prototype.h=null;var ye={OPEN:"a",kb:"b",Ja:"c",wb:"d"};function ve(){N.call(this,"d")}function we(){N.call(this,"c")}d(ve,N),d(we,N);var be={},Se=null;function Ee(){return Se=Se||new ne}function Te(e){N.call(this,be.La,e)}function _e(e){const t=Ee();re(t,new Te(t))}function Ce(e,t){N.call(this,be.STAT_EVENT,e),this.stat=t}function xe(e){const t=Ee();re(t,new Ce(t,e))}function Ae(e,t){N.call(this,be.Ma,e),this.size=t}function Ie(e,t){if("function"!=typeof e)throw Error("Fn must not be null and must be a function");return s.setTimeout((function(){e()}),t)}function ke(){this.g=!0}function Le(e,t,n,r){e.info((function(){return"XMLHTTP TEXT ("+t+"): "+function(e,t){if(!e.g)return t;if(!t)return null;try{var n=JSON.parse(t);if(n)for(e=0;e<n.length;e++)if(Array.isArray(n[e])){var r=n[e];if(!(2>r.length)){var s=r[1];if(Array.isArray(s)&&!(1>s.length)){var i=s[0];if("noop"!=i&&"stop"!=i&&"close"!=i)for(var o=1;o<s.length;o++)s[o]=""}}}return de(n)}catch(e){return t}}(e,n)+(r?" "+r:"")}))}be.La="serverreachability",d(Te,N),be.STAT_EVENT="statevent",d(Ce,N),be.Ma="timingevent",d(Ae,N),ke.prototype.xa=function(){this.g=!1},ke.prototype.info=function(){};var Me,De={NO_ERROR:0,gb:1,tb:2,sb:3,nb:4,rb:5,ub:6,Ia:7,TIMEOUT:8,xb:9},Ne={lb:"complete",Hb:"success",Ja:"error",Ia:"abort",zb:"ready",Ab:"readystatechange",TIMEOUT:"timeout",vb:"incrementaldata",yb:"progress",ob:"downloadprogress",Pb:"uploadprogress"};function Pe(){}function Oe(e,t,n,r){this.j=e,this.i=t,this.l=n,this.R=r||1,this.U=new le(this),this.I=45e3,this.H=null,this.o=!1,this.m=this.A=this.v=this.L=this.F=this.S=this.B=null,this.D=[],this.g=null,this.C=0,this.s=this.u=null,this.X=-1,this.J=!1,this.O=0,this.M=null,this.W=this.K=this.T=this.P=!1,this.h=new qe}function qe(){this.i=null,this.g="",this.h=!1}d(Pe,fe),Pe.prototype.g=function(){return new XMLHttpRequest},Pe.prototype.i=function(){return{}},Me=new Pe;var Re={},Fe={};function Be(e,t,n){e.L=1,e.v=dt(ot(t)),e.m=n,e.P=!0,$e(e,null)}function $e(e,t){e.F=Date.now(),ze(e),e.A=ot(e.v);var n=e.A,r=e.R;Array.isArray(r)||(r=[String(r)]),Ct(n.i,"t",r),e.C=0,n=e.j.J,e.h=new qe,e.g=pn(e.j,n?t:null,!e.m),0<e.O&&(e.M=new ae(c(e.Y,e,e.g),e.O)),t=e.U,n=e.g,r=e.ca;var s="readystatechange";Array.isArray(s)||(s&&(ce[0]=s.toString()),s=ce);for(var i=0;i<s.length;i++){var o=H(n,s[i],r||t.handleEvent,!1,t.h||t);if(!o)break;t.g[o.key]=o}t=e.H?w(e.H):{},e.m?(e.u||(e.u="POST"),t["Content-Type"]="application/x-www-form-urlencoded",e.g.ea(e.A,e.u,e.m,t)):(e.u="GET",e.g.ea(e.A,e.u,null,t)),_e(),function(e,t,n,r,s,i){e.info((function(){if(e.g)if(i)for(var o="",a=i.split("&"),l=0;l<a.length;l++){var c=a[l].split("=");if(1<c.length){var u=c[0];c=c[1];var d=u.split("_");o=2<=d.length&&"type"==d[1]?o+(u+"=")+c+"&":o+(u+"=redacted&")}}else o=null;else o=i;return"XMLHTTP REQ ("+r+") [attempt "+s+"]: "+t+"\n"+n+"\n"+o}))}(e.i,e.u,e.A,e.l,e.R,e.m)}function Ve(e){return!!e.g&&("GET"==e.u&&2!=e.L&&e.j.Ca)}function je(e,t){var n=e.C,r=t.indexOf("\n",n);return-1==r?Fe:(n=Number(t.substring(n,r)),isNaN(n)?Re:(r+=1)+n>t.length?Fe:(t=t.slice(r,r+n),e.C=r+n,t))}function ze(e){e.S=Date.now()+e.I,Ue(e,e.I)}function Ue(e,t){if(null!=e.B)throw Error("WatchDog timer not null");e.B=Ie(c(e.ba,e),t)}function Ge(e){e.B&&(s.clearTimeout(e.B),e.B=null)}function He(e){0==e.j.G||e.J||ln(e.j,e)}function We(e){Ge(e);var t=e.M;t&&"function"==typeof t.ma&&t.ma(),e.M=null,ue(e.U),e.g&&(t=e.g,e.g=null,t.abort(),t.ma())}function Ke(e,t){try{var n=e.j;if(0!=n.G&&(n.g==e||Ze(n.h,e)))if(!e.K&&Ze(n.h,e)&&3==n.G){try{var r=n.Da.g.parse(t)}catch(e){r=null}if(Array.isArray(r)&&3==r.length){var s=r;if(0==s[0]){e:if(!n.u){if(n.g){if(!(n.g.F+3e3<e.F))break e;an(n),Yt(n)}rn(n),xe(18)}}else n.za=s[1],0<n.za-n.T&&37500>s[2]&&n.F&&0==n.v&&!n.C&&(n.C=Ie(c(n.Za,n),6e3));if(1>=Je(n.h)&&n.ca){try{n.ca()}catch(e){}n.ca=void 0}}else un(n,11)}else if((e.K||n.g==e)&&an(n),!f(t))for(s=n.Da.g.parse(t),t=0;t<s.length;t++){let c=s[t];if(n.T=c[0],c=c[1],2==n.G)if("c"==c[0]){n.K=c[1],n.ia=c[2];const t=c[3];null!=t&&(n.la=t,n.j.info("VER="+n.la));const s=c[4];null!=s&&(n.Aa=s,n.j.info("SVER="+n.Aa));const u=c[5];null!=u&&"number"==typeof u&&0<u&&(r=1.5*u,n.L=r,n.j.info("backChannelRequestTimeoutMs_="+r)),r=n;const d=e.g;if(d){const e=d.g?d.g.getResponseHeader("X-Client-Wire-Protocol"):null;if(e){var i=r.h;i.g||-1==e.indexOf("spdy")&&-1==e.indexOf("quic")&&-1==e.indexOf("h2")||(i.j=i.l,i.g=new Set,i.h&&(et(i,i.h),i.h=null))}if(r.D){const e=d.g?d.g.getResponseHeader("X-HTTP-Session-Id"):null;e&&(r.ya=e,ut(r.I,r.D,e))}}n.G=3,n.l&&n.l.ua(),n.ba&&(n.R=Date.now()-e.F,n.j.info("Handshake RTT: "+n.R+"ms"));var o=e;if((r=n).qa=hn(r,r.J?r.ia:null,r.W),o.K){tt(r.h,o);var a=o,l=r.L;l&&(a.I=l),a.B&&(Ge(a),ze(a)),r.g=o}else nn(r);0<n.i.length&&Jt(n)}else"stop"!=c[0]&&"close"!=c[0]||un(n,7);else 3==n.G&&("stop"==c[0]||"close"==c[0]?"stop"==c[0]?un(n,7):Qt(n):"noop"!=c[0]&&n.l&&n.l.ta(c),n.v=0)}_e()}catch(e){}}Oe.prototype.ca=function(e){e=e.target;const t=this.M;t&&3==Gt(e)?t.j():this.Y(e)},Oe.prototype.Y=function(e){try{if(e==this.g)e:{const h=Gt(this.g);var t=this.g.Ba();this.g.Z();if(!(3>h)&&(3!=h||this.g&&(this.h.h||this.g.oa()||Ht(this.g)))){this.J||4!=h||7==t||_e(),Ge(this);var n=this.g.Z();this.X=n;t:if(Ve(this)){var r=Ht(this.g);e="";var i=r.length,o=4==Gt(this.g);if(!this.h.i){if("undefined"==typeof TextDecoder){We(this),He(this);var a="";break t}this.h.i=new s.TextDecoder}for(t=0;t<i;t++)this.h.h=!0,e+=this.h.i.decode(r[t],{stream:!(o&&t==i-1)});r.length=0,this.h.g+=e,this.C=0,a=this.h.g}else a=this.g.oa();if(this.o=200==n,function(e,t,n,r,s,i,o){e.info((function(){return"XMLHTTP RESP ("+r+") [ attempt "+s+"]: "+t+"\n"+n+"\n"+i+" "+o}))}(this.i,this.u,this.A,this.l,this.R,h,n),this.o){if(this.T&&!this.K){t:{if(this.g){var l,c=this.g;if((l=c.g?c.g.getResponseHeader("X-HTTP-Initial-Response"):null)&&!f(l)){var u=l;break t}}u=null}if(!(n=u)){this.o=!1,this.s=3,xe(12),We(this),He(this);break e}Le(this.i,this.l,n,"Initial handshake response via X-HTTP-Initial-Response"),this.K=!0,Ke(this,n)}if(this.P){let e;for(n=!0;!this.J&&this.C<a.length;){if(e=je(this,a),e==Fe){4==h&&(this.s=4,xe(14),n=!1),Le(this.i,this.l,null,"[Incomplete Response]");break}if(e==Re){this.s=4,xe(15),Le(this.i,this.l,a,"[Invalid Chunk]"),n=!1;break}Le(this.i,this.l,e,null),Ke(this,e)}if(Ve(this)&&0!=this.C&&(this.h.g=this.h.g.slice(this.C),this.C=0),4!=h||0!=a.length||this.h.h||(this.s=1,xe(16),n=!1),this.o=this.o&&n,n){if(0<a.length&&!this.W){this.W=!0;var d=this.j;d.g==this&&d.ba&&!d.M&&(d.j.info("Great, no buffering proxy detected. Bytes received: "+a.length),sn(d),d.M=!0,xe(11))}}else Le(this.i,this.l,a,"[Invalid Chunked Response]"),We(this),He(this)}else Le(this.i,this.l,a,null),Ke(this,a);4==h&&We(this),this.o&&!this.J&&(4==h?ln(this.j,this):(this.o=!1,ze(this)))}else(function(e){const t={};e=(e.g&&2<=Gt(e)&&e.g.getAllResponseHeaders()||"").split("\r\n");for(let r=0;r<e.length;r++){if(f(e[r]))continue;var n=E(e[r]);const s=n[0];if("string"!=typeof(n=n[1]))continue;n=n.trim();const i=t[s]||[];t[s]=i,i.push(n)}!function(e,t){for(const n in e)t.call(void 0,e[n],n,e)}(t,(function(e){return e.join(", ")}))})(this.g),400==n&&0<a.indexOf("Unknown SID")?(this.s=3,xe(12)):(this.s=0,xe(13)),We(this),He(this)}}}catch(e){}},Oe.prototype.cancel=function(){this.J=!0,We(this)},Oe.prototype.ba=function(){this.B=null;const e=Date.now();0<=e-this.S?(function(e,t){e.info((function(){return"TIMEOUT: "+t}))}(this.i,this.A),2!=this.L&&(_e(),xe(17)),We(this),this.s=2,He(this)):Ue(this,this.S-e)};var Qe=class{constructor(e,t){this.g=e,this.map=t}};function Ye(e){this.l=e||10,s.PerformanceNavigationTiming?e=0<(e=s.performance.getEntriesByType("navigation")).length&&("hq"==e[0].nextHopProtocol||"h2"==e[0].nextHopProtocol):e=!!(s.chrome&&s.chrome.loadTimes&&s.chrome.loadTimes()&&s.chrome.loadTimes().wasFetchedViaSpdy),this.j=e?this.l:1,this.g=null,1<this.j&&(this.g=new Set),this.h=null,this.i=[]}function Xe(e){return!!e.h||!!e.g&&e.g.size>=e.j}function Je(e){return e.h?1:e.g?e.g.size:0}function Ze(e,t){return e.h?e.h==t:!!e.g&&e.g.has(t)}function et(e,t){e.g?e.g.add(t):e.h=t}function tt(e,t){e.h&&e.h==t?e.h=null:e.g&&e.g.has(t)&&e.g.delete(t)}function nt(e){if(null!=e.h)return e.i.concat(e.h.D);if(null!=e.g&&0!==e.g.size){let t=e.i;for(const n of e.g.values())t=t.concat(n.D);return t}return h(e.i)}function rt(e,t){if(e.forEach&&"function"==typeof e.forEach)e.forEach(t,void 0);else if(i(e)||"string"==typeof e)Array.prototype.forEach.call(e,t,void 0);else for(var n=function(e){if(e.na&&"function"==typeof e.na)return e.na();if(!e.V||"function"!=typeof e.V){if("undefined"!=typeof Map&&e instanceof Map)return Array.from(e.keys());if(!("undefined"!=typeof Set&&e instanceof Set)){if(i(e)||"string"==typeof e){var t=[];e=e.length;for(var n=0;n<e;n++)t.push(n);return t}t=[],n=0;for(const r in e)t[n++]=r;return t}}}(e),r=function(e){if(e.V&&"function"==typeof e.V)return e.V();if("undefined"!=typeof Map&&e instanceof Map||"undefined"!=typeof Set&&e instanceof Set)return Array.from(e.values());if("string"==typeof e)return e.split("");if(i(e)){for(var t=[],n=e.length,r=0;r<n;r++)t.push(e[r]);return t}for(r in t=[],n=0,e)t[n++]=e[r];return t}(e),s=r.length,o=0;o<s;o++)t.call(void 0,r[o],n&&n[o],e)}Ye.prototype.cancel=function(){if(this.i=nt(this),this.h)this.h.cancel(),this.h=null;else if(this.g&&0!==this.g.size){for(const e of this.g.values())e.cancel();this.g.clear()}};var st=RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");function it(e){if(this.g=this.o=this.j="",this.s=null,this.m=this.l="",this.h=!1,e instanceof it){this.h=e.h,at(this,e.j),this.o=e.o,this.g=e.g,lt(this,e.s),this.l=e.l;var t=e.i,n=new St;n.i=t.i,t.g&&(n.g=new Map(t.g),n.h=t.h),ct(this,n),this.m=e.m}else e&&(t=String(e).match(st))?(this.h=!1,at(this,t[1]||"",!0),this.o=ht(t[2]||""),this.g=ht(t[3]||"",!0),lt(this,t[4]),this.l=ht(t[5]||"",!0),ct(this,t[6]||"",!0),this.m=ht(t[7]||"")):(this.h=!1,this.i=new St(null,this.h))}function ot(e){return new it(e)}function at(e,t,n){e.j=n?ht(t,!0):t,e.j&&(e.j=e.j.replace(/:$/,""))}function lt(e,t){if(t){if(t=Number(t),isNaN(t)||0>t)throw Error("Bad port number "+t);e.s=t}else e.s=null}function ct(e,t,n){t instanceof St?(e.i=t,function(e,t){t&&!e.j&&(Et(e),e.i=null,e.g.forEach((function(e,t){var n=t.toLowerCase();t!=n&&(Tt(this,t),Ct(this,n,e))}),e)),e.j=t}(e.i,e.h)):(n||(t=pt(t,wt)),e.i=new St(t,e.h))}function ut(e,t,n){e.i.set(t,n)}function dt(e){return ut(e,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^Date.now()).toString(36)),e}function ht(e,t){return e?t?decodeURI(e.replace(/%25/g,"%2525")):decodeURIComponent(e):""}function pt(e,t,n){return"string"==typeof e?(e=encodeURI(e).replace(t,ft),n&&(e=e.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),e):null}function ft(e){return"%"+((e=e.charCodeAt(0))>>4&15).toString(16)+(15&e).toString(16)}it.prototype.toString=function(){var e=[],t=this.j;t&&e.push(pt(t,gt,!0),":");var n=this.g;return(n||"file"==t)&&(e.push("//"),(t=this.o)&&e.push(pt(t,gt,!0),"@"),e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),null!=(n=this.s)&&e.push(":",String(n))),(n=this.l)&&(this.g&&"/"!=n.charAt(0)&&e.push("/"),e.push(pt(n,"/"==n.charAt(0)?vt:yt,!0))),(n=this.i.toString())&&e.push("?",n),(n=this.m)&&e.push("#",pt(n,bt)),e.join("")};var mt,gt=/[#\/\?@]/g,yt=/[#\?:]/g,vt=/[#\?]/g,wt=/[#\?@]/g,bt=/#/g;function St(e,t){this.h=this.g=null,this.i=e||null,this.j=!!t}function Et(e){e.g||(e.g=new Map,e.h=0,e.i&&function(e,t){if(e){e=e.split("&");for(var n=0;n<e.length;n++){var r=e[n].indexOf("="),s=null;if(0<=r){var i=e[n].substring(0,r);s=e[n].substring(r+1)}else i=e[n];t(i,s?decodeURIComponent(s.replace(/\+/g," ")):"")}}}(e.i,(function(t,n){e.add(decodeURIComponent(t.replace(/\+/g," ")),n)})))}function Tt(e,t){Et(e),t=xt(e,t),e.g.has(t)&&(e.i=null,e.h-=e.g.get(t).length,e.g.delete(t))}function _t(e,t){return Et(e),t=xt(e,t),e.g.has(t)}function Ct(e,t,n){Tt(e,t),0<n.length&&(e.i=null,e.g.set(xt(e,t),h(n)),e.h+=n.length)}function xt(e,t){return t=String(t),e.j&&(t=t.toLowerCase()),t}function At(e,t,n,r,s){try{s&&(s.onload=null,s.onerror=null,s.onabort=null,s.ontimeout=null),r(n)}catch(e){}}function It(){this.g=new pe}function kt(e,t,n){const r=n||"";try{rt(e,(function(e,n){let s=e;o(e)&&(s=de(e)),t.push(r+n+"="+encodeURIComponent(s))}))}catch(e){throw t.push(r+"type="+encodeURIComponent("_badmap")),e}}function Lt(e){this.l=e.Ub||null,this.j=e.eb||!1}function Mt(e,t){ne.call(this),this.D=e,this.o=t,this.m=void 0,this.status=this.readyState=0,this.responseType=this.responseText=this.response=this.statusText="",this.onreadystatechange=null,this.u=new Headers,this.h=null,this.B="GET",this.A="",this.g=!1,this.v=this.j=this.l=null}function Dt(e){e.j.read().then(e.Pa.bind(e)).catch(e.ga.bind(e))}function Nt(e){e.readyState=4,e.l=null,e.j=null,e.v=null,Pt(e)}function Pt(e){e.onreadystatechange&&e.onreadystatechange.call(e)}function Ot(e){let t="";return v(e,(function(e,n){t+=n,t+=":",t+=e,t+="\r\n"})),t}function qt(e,t,n){e:{for(r in n){var r=!1;break e}r=!0}r||(n=Ot(n),"string"==typeof e?null!=n&&encodeURIComponent(String(n)):ut(e,t,n))}function Rt(e){ne.call(this),this.headers=new Map,this.o=e||null,this.h=!1,this.v=this.g=null,this.D="",this.m=0,this.l="",this.j=this.B=this.u=this.A=!1,this.I=null,this.H="",this.J=!1}(e=St.prototype).add=function(e,t){Et(this),this.i=null,e=xt(this,e);var n=this.g.get(e);return n||this.g.set(e,n=[]),n.push(t),this.h+=1,this},e.forEach=function(e,t){Et(this),this.g.forEach((function(n,r){n.forEach((function(n){e.call(t,n,r,this)}),this)}),this)},e.na=function(){Et(this);const e=Array.from(this.g.values()),t=Array.from(this.g.keys()),n=[];for(let r=0;r<t.length;r++){const s=e[r];for(let e=0;e<s.length;e++)n.push(t[r])}return n},e.V=function(e){Et(this);let t=[];if("string"==typeof e)_t(this,e)&&(t=t.concat(this.g.get(xt(this,e))));else{e=Array.from(this.g.values());for(let n=0;n<e.length;n++)t=t.concat(e[n])}return t},e.set=function(e,t){return Et(this),this.i=null,_t(this,e=xt(this,e))&&(this.h-=this.g.get(e).length),this.g.set(e,[t]),this.h+=1,this},e.get=function(e,t){return e&&0<(e=this.V(e)).length?String(e[0]):t},e.toString=function(){if(this.i)return this.i;if(!this.g)return"";const e=[],t=Array.from(this.g.keys());for(var n=0;n<t.length;n++){var r=t[n];const i=encodeURIComponent(String(r)),o=this.V(r);for(r=0;r<o.length;r++){var s=i;""!==o[r]&&(s+="="+encodeURIComponent(String(o[r]))),e.push(s)}}return this.i=e.join("&")},d(Lt,fe),Lt.prototype.g=function(){return new Mt(this.l,this.j)},Lt.prototype.i=(mt={},function(){return mt}),d(Mt,ne),(e=Mt.prototype).open=function(e,t){if(0!=this.readyState)throw this.abort(),Error("Error reopening a connection");this.B=e,this.A=t,this.readyState=1,Pt(this)},e.send=function(e){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.g=!0;const t={headers:this.u,method:this.B,credentials:this.m,cache:void 0};e&&(t.body=e),(this.D||s).fetch(new Request(this.A,t)).then(this.Sa.bind(this),this.ga.bind(this))},e.abort=function(){this.response=this.responseText="",this.u=new Headers,this.status=0,this.j&&this.j.cancel("Request was aborted.").catch((()=>{})),1<=this.readyState&&this.g&&4!=this.readyState&&(this.g=!1,Nt(this)),this.readyState=0},e.Sa=function(e){if(this.g&&(this.l=e,this.h||(this.status=this.l.status,this.statusText=this.l.statusText,this.h=e.headers,this.readyState=2,Pt(this)),this.g&&(this.readyState=3,Pt(this),this.g)))if("arraybuffer"===this.responseType)e.arrayBuffer().then(this.Qa.bind(this),this.ga.bind(this));else if(void 0!==s.ReadableStream&&"body"in e){if(this.j=e.body.getReader(),this.o){if(this.responseType)throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');this.response=[]}else this.response=this.responseText="",this.v=new TextDecoder;Dt(this)}else e.text().then(this.Ra.bind(this),this.ga.bind(this))},e.Pa=function(e){if(this.g){if(this.o&&e.value)this.response.push(e.value);else if(!this.o){var t=e.value?e.value:new Uint8Array(0);(t=this.v.decode(t,{stream:!e.done}))&&(this.response=this.responseText+=t)}e.done?Nt(this):Pt(this),3==this.readyState&&Dt(this)}},e.Ra=function(e){this.g&&(this.response=this.responseText=e,Nt(this))},e.Qa=function(e){this.g&&(this.response=e,Nt(this))},e.ga=function(){this.g&&Nt(this)},e.setRequestHeader=function(e,t){this.u.append(e,t)},e.getResponseHeader=function(e){return this.h&&this.h.get(e.toLowerCase())||""},e.getAllResponseHeaders=function(){if(!this.h)return"";const e=[],t=this.h.entries();for(var n=t.next();!n.done;)n=n.value,e.push(n[0]+": "+n[1]),n=t.next();return e.join("\r\n")},Object.defineProperty(Mt.prototype,"withCredentials",{get:function(){return"include"===this.m},set:function(e){this.m=e?"include":"same-origin"}}),d(Rt,ne);var Ft=/^https?$/i,Bt=["POST","PUT"];function $t(e,t){e.h=!1,e.g&&(e.j=!0,e.g.abort(),e.j=!1),e.l=t,e.m=5,Vt(e),zt(e)}function Vt(e){e.A||(e.A=!0,re(e,"complete"),re(e,"error"))}function jt(e){if(e.h&&void 0!==r&&(!e.v[1]||4!=Gt(e)||2!=e.Z()))if(e.u&&4==Gt(e))ie(e.Ea,0,e);else if(re(e,"readystatechange"),4==Gt(e)){e.h=!1;try{const r=e.Z();e:switch(r){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var t=!0;break e;default:t=!1}var n;if(!(n=t)){var i;if(i=0===r){var o=String(e.D).match(st)[1]||null;!o&&s.self&&s.self.location&&(o=s.self.location.protocol.slice(0,-1)),i=!Ft.test(o?o.toLowerCase():"")}n=i}if(n)re(e,"complete"),re(e,"success");else{e.m=6;try{var a=2<Gt(e)?e.g.statusText:""}catch(e){a=""}e.l=a+" ["+e.Z()+"]",Vt(e)}}finally{zt(e)}}}function zt(e,t){if(e.g){Ut(e);const n=e.g,r=e.v[0]?()=>{}:null;e.g=null,e.v=null,t||re(e,"ready");try{n.onreadystatechange=r}catch(e){}}}function Ut(e){e.I&&(s.clearTimeout(e.I),e.I=null)}function Gt(e){return e.g?e.g.readyState:0}function Ht(e){try{if(!e.g)return null;if("response"in e.g)return e.g.response;switch(e.H){case"":case"text":return e.g.responseText;case"arraybuffer":if("mozResponseArrayBuffer"in e.g)return e.g.mozResponseArrayBuffer}return null}catch(e){return null}}function Wt(e,t,n){return n&&n.internalChannelParams&&n.internalChannelParams[e]||t}function Kt(e){this.Aa=0,this.i=[],this.j=new ke,this.ia=this.qa=this.I=this.W=this.g=this.ya=this.D=this.H=this.m=this.S=this.o=null,this.Ya=this.U=0,this.Va=Wt("failFast",!1,e),this.F=this.C=this.u=this.s=this.l=null,this.X=!0,this.za=this.T=-1,this.Y=this.v=this.B=0,this.Ta=Wt("baseRetryDelayMs",5e3,e),this.cb=Wt("retryDelaySeedMs",1e4,e),this.Wa=Wt("forwardChannelMaxRetries",2,e),this.wa=Wt("forwardChannelRequestTimeoutMs",2e4,e),this.pa=e&&e.xmlHttpFactory||void 0,this.Xa=e&&e.Tb||void 0,this.Ca=e&&e.useFetchStreams||!1,this.L=void 0,this.J=e&&e.supportsCrossDomainXhr||!1,this.K="",this.h=new Ye(e&&e.concurrentRequestLimit),this.Da=new It,this.P=e&&e.fastHandshake||!1,this.O=e&&e.encodeInitMessageHeaders||!1,this.P&&this.O&&(this.O=!1),this.Ua=e&&e.Rb||!1,e&&e.xa&&this.j.xa(),e&&e.forceLongPolling&&(this.X=!1),this.ba=!this.P&&this.X&&e&&e.detectBufferingProxy||!1,this.ja=void 0,e&&e.longPollingTimeout&&0<e.longPollingTimeout&&(this.ja=e.longPollingTimeout),this.ca=void 0,this.R=0,this.M=!1,this.ka=this.A=null}function Qt(e){if(Xt(e),3==e.G){var t=e.U++,n=ot(e.I);if(ut(n,"SID",e.K),ut(n,"RID",t),ut(n,"TYPE","terminate"),en(e,n),(t=new Oe(e,e.j,t)).L=2,t.v=dt(ot(n)),n=!1,s.navigator&&s.navigator.sendBeacon)try{n=s.navigator.sendBeacon(t.v.toString(),"")}catch(e){}!n&&s.Image&&((new Image).src=t.v,n=!0),n||(t.g=pn(t.j,null),t.g.ea(t.v)),t.F=Date.now(),ze(t)}dn(e)}function Yt(e){e.g&&(sn(e),e.g.cancel(),e.g=null)}function Xt(e){Yt(e),e.u&&(s.clearTimeout(e.u),e.u=null),an(e),e.h.cancel(),e.s&&("number"==typeof e.s&&s.clearTimeout(e.s),e.s=null)}function Jt(e){if(!Xe(e.h)&&!e.s){e.s=!0;var t=e.Ga;A||L(),I||(A(),I=!0),k.add(t,e),e.B=0}}function Zt(e,t){var n;n=t?t.l:e.U++;const r=ot(e.I);ut(r,"SID",e.K),ut(r,"RID",n),ut(r,"AID",e.T),en(e,r),e.m&&e.o&&qt(r,e.m,e.o),n=new Oe(e,e.j,n,e.B+1),null===e.m&&(n.H=e.o),t&&(e.i=t.D.concat(e.i)),t=tn(e,n,1e3),n.I=Math.round(.5*e.wa)+Math.round(.5*e.wa*Math.random()),et(e.h,n),Be(n,r,t)}function en(e,t){e.H&&v(e.H,(function(e,n){ut(t,n,e)})),e.l&&rt({},(function(e,n){ut(t,n,e)}))}function tn(e,t,n){n=Math.min(e.i.length,n);var r=e.l?c(e.l.Na,e.l,e):null;e:{var s=e.i;let t=-1;for(;;){const e=["count="+n];-1==t?0<n?(t=s[0].g,e.push("ofs="+t)):t=0:e.push("ofs="+t);let i=!0;for(let o=0;o<n;o++){let n=s[o].g;const a=s[o].map;if(n-=t,0>n)t=Math.max(0,s[o].g-100),i=!1;else try{kt(a,e,"req"+n+"_")}catch(e){r&&r(a)}}if(i){r=e.join("&");break e}}}return e=e.i.splice(0,n),t.D=e,r}function nn(e){if(!e.g&&!e.u){e.Y=1;var t=e.Fa;A||L(),I||(A(),I=!0),k.add(t,e),e.v=0}}function rn(e){return!(e.g||e.u||3<=e.v)&&(e.Y++,e.u=Ie(c(e.Fa,e),cn(e,e.v)),e.v++,!0)}function sn(e){null!=e.A&&(s.clearTimeout(e.A),e.A=null)}function on(e){e.g=new Oe(e,e.j,"rpc",e.Y),null===e.m&&(e.g.H=e.o),e.g.O=0;var t=ot(e.qa);ut(t,"RID","rpc"),ut(t,"SID",e.K),ut(t,"AID",e.T),ut(t,"CI",e.F?"0":"1"),!e.F&&e.ja&&ut(t,"TO",e.ja),ut(t,"TYPE","xmlhttp"),en(e,t),e.m&&e.o&&qt(t,e.m,e.o),e.L&&(e.g.I=e.L);var n=e.g;e=e.ia,n.L=1,n.v=dt(ot(t)),n.m=null,n.P=!0,$e(n,e)}function an(e){null!=e.C&&(s.clearTimeout(e.C),e.C=null)}function ln(e,t){var n=null;if(e.g==t){an(e),sn(e),e.g=null;var r=2}else{if(!Ze(e.h,t))return;n=t.D,tt(e.h,t),r=1}if(0!=e.G)if(t.o)if(1==r){n=t.m?t.m.length:0,t=Date.now()-t.F;var s=e.B;re(r=Ee(),new Ae(r,n)),Jt(e)}else nn(e);else if(3==(s=t.s)||0==s&&0<t.X||!(1==r&&function(e,t){return!(Je(e.h)>=e.h.j-(e.s?1:0)||(e.s?(e.i=t.D.concat(e.i),0):1==e.G||2==e.G||e.B>=(e.Va?0:e.Wa)||(e.s=Ie(c(e.Ga,e,t),cn(e,e.B)),e.B++,0)))}(e,t)||2==r&&rn(e)))switch(n&&0<n.length&&(t=e.h,t.i=t.i.concat(n)),s){case 1:un(e,5);break;case 4:un(e,10);break;case 3:un(e,6);break;default:un(e,2)}}function cn(e,t){let n=e.Ta+Math.floor(Math.random()*e.cb);return e.isActive()||(n*=2),n*t}function un(e,t){if(e.j.info("Error code "+t),2==t){var n=c(e.fb,e),r=e.Xa;const t=!r;r=new it(r||"//www.google.com/images/cleardot.gif"),s.location&&"http"==s.location.protocol||at(r,"https"),dt(r),t?function(e,t){const n=new ke;if(s.Image){const r=new Image;r.onload=u(At,n,"TestLoadImage: loaded",!0,t,r),r.onerror=u(At,n,"TestLoadImage: error",!1,t,r),r.onabort=u(At,n,"TestLoadImage: abort",!1,t,r),r.ontimeout=u(At,n,"TestLoadImage: timeout",!1,t,r),s.setTimeout((function(){r.ontimeout&&r.ontimeout()}),1e4),r.src=e}else t(!1)}(r.toString(),n):function(e,t){new ke;const n=new AbortController,r=setTimeout((()=>{n.abort(),At(0,0,!1,t)}),1e4);fetch(e,{signal:n.signal}).then((e=>{clearTimeout(r),e.ok?At(0,0,!0,t):At(0,0,!1,t)})).catch((()=>{clearTimeout(r),At(0,0,!1,t)}))}(r.toString(),n)}else xe(2);e.G=0,e.l&&e.l.sa(t),dn(e),Xt(e)}function dn(e){if(e.G=0,e.ka=[],e.l){const t=nt(e.h);0==t.length&&0==e.i.length||(p(e.ka,t),p(e.ka,e.i),e.h.i.length=0,h(e.i),e.i.length=0),e.l.ra()}}function hn(e,t,n){var r=n instanceof it?ot(n):new it(n);if(""!=r.g)t&&(r.g=t+"."+r.g),lt(r,r.s);else{var i=s.location;r=i.protocol,t=t?t+"."+i.hostname:i.hostname,i=+i.port;var o=new it(null);r&&at(o,r),t&&(o.g=t),i&&lt(o,i),n&&(o.l=n),r=o}return n=e.D,t=e.ya,n&&t&&ut(r,n,t),ut(r,"VER",e.la),en(e,r),r}function pn(e,t,n){if(t&&!e.J)throw Error("Can't create secondary domain capable XhrIo object.");return(t=e.Ca&&!e.pa?new Rt(new Lt({eb:n})):new Rt(e.pa)).Ha(e.J),t}function fn(){}function mn(){}function gn(e,t){ne.call(this),this.g=new Kt(t),this.l=e,this.h=t&&t.messageUrlParams||null,e=t&&t.messageHeaders||null,t&&t.clientProtocolHeaderRequired&&(e?e["X-Client-Protocol"]="webchannel":e={"X-Client-Protocol":"webchannel"}),this.g.o=e,e=t&&t.initMessageHeaders||null,t&&t.messageContentType&&(e?e["X-WebChannel-Content-Type"]=t.messageContentType:e={"X-WebChannel-Content-Type":t.messageContentType}),t&&t.va&&(e?e["X-WebChannel-Client-Profile"]=t.va:e={"X-WebChannel-Client-Profile":t.va}),this.g.S=e,(e=t&&t.Sb)&&!f(e)&&(this.g.m=e),this.v=t&&t.supportsCrossDomainXhr||!1,this.u=t&&t.sendRawJson||!1,(t=t&&t.httpSessionIdParam)&&!f(t)&&(this.g.D=t,null!==(e=this.h)&&t in e&&(t in(e=this.h)&&delete e[t])),this.j=new wn(this)}function yn(e){ve.call(this),e.__headers__&&(this.headers=e.__headers__,this.statusCode=e.__status__,delete e.__headers__,delete e.__status__);var t=e.__sm__;if(t){e:{for(const n in t){e=n;break e}e=void 0}(this.i=e)&&(e=this.i,t=null!==t&&e in t?t[e]:void 0),this.data=t}else this.data=e}function vn(){we.call(this),this.status=1}function wn(e){this.g=e}(e=Rt.prototype).Ha=function(e){this.J=e},e.ea=function(e,t,n,r){if(this.g)throw Error("[goog.net.XhrIo] Object is active with another request="+this.D+"; newUri="+e);t=t?t.toUpperCase():"GET",this.D=e,this.l="",this.m=0,this.A=!1,this.h=!0,this.g=this.o?this.o.g():Me.g(),this.v=this.o?me(this.o):me(Me),this.g.onreadystatechange=c(this.Ea,this);try{this.B=!0,this.g.open(t,String(e),!0),this.B=!1}catch(e){return void $t(this,e)}if(e=n||"",n=new Map(this.headers),r)if(Object.getPrototypeOf(r)===Object.prototype)for(var i in r)n.set(i,r[i]);else{if("function"!=typeof r.keys||"function"!=typeof r.get)throw Error("Unknown input type for opt_headers: "+String(r));for(const e of r.keys())n.set(e,r.get(e))}r=Array.from(n.keys()).find((e=>"content-type"==e.toLowerCase())),i=s.FormData&&e instanceof s.FormData,!(0<=Array.prototype.indexOf.call(Bt,t,void 0))||r||i||n.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");for(const[e,t]of n)this.g.setRequestHeader(e,t);this.H&&(this.g.responseType=this.H),"withCredentials"in this.g&&this.g.withCredentials!==this.J&&(this.g.withCredentials=this.J);try{Ut(this),this.u=!0,this.g.send(e),this.u=!1}catch(e){$t(this,e)}},e.abort=function(e){this.g&&this.h&&(this.h=!1,this.j=!0,this.g.abort(),this.j=!1,this.m=e||7,re(this,"complete"),re(this,"abort"),zt(this))},e.N=function(){this.g&&(this.h&&(this.h=!1,this.j=!0,this.g.abort(),this.j=!1),zt(this,!0)),Rt.aa.N.call(this)},e.Ea=function(){this.s||(this.B||this.u||this.j?jt(this):this.bb())},e.bb=function(){jt(this)},e.isActive=function(){return!!this.g},e.Z=function(){try{return 2<Gt(this)?this.g.status:-1}catch(e){return-1}},e.oa=function(){try{return this.g?this.g.responseText:""}catch(e){return""}},e.Oa=function(e){if(this.g){var t=this.g.responseText;return e&&0==t.indexOf(e)&&(t=t.substring(e.length)),he(t)}},e.Ba=function(){return this.m},e.Ka=function(){return"string"==typeof this.l?this.l:String(this.l)},(e=Kt.prototype).la=8,e.G=1,e.connect=function(e,t,n,r){xe(0),this.W=e,this.H=t||{},n&&void 0!==r&&(this.H.OSID=n,this.H.OAID=r),this.F=this.X,this.I=hn(this,null,this.W),Jt(this)},e.Ga=function(e){if(this.s)if(this.s=null,1==this.G){if(!e){this.U=Math.floor(1e5*Math.random()),e=this.U++;const s=new Oe(this,this.j,e);let i=this.o;if(this.S&&(i?(i=w(i),S(i,this.S)):i=this.S),null!==this.m||this.O||(s.H=i,i=null),this.P)e:{for(var t=0,n=0;n<this.i.length;n++){var r=this.i[n];if(void 0===(r="__data__"in r.map&&"string"==typeof(r=r.map.__data__)?r.length:void 0))break;if(4096<(t+=r)){t=n;break e}if(4096===t||n===this.i.length-1){t=n+1;break e}}t=1e3}else t=1e3;t=tn(this,s,t),ut(n=ot(this.I),"RID",e),ut(n,"CVER",22),this.D&&ut(n,"X-HTTP-Session-Id",this.D),en(this,n),i&&(this.O?t="headers="+encodeURIComponent(String(Ot(i)))+"&"+t:this.m&&qt(n,this.m,i)),et(this.h,s),this.Ua&&ut(n,"TYPE","init"),this.P?(ut(n,"$req",t),ut(n,"SID","null"),s.T=!0,Be(s,n,null)):Be(s,n,t),this.G=2}}else 3==this.G&&(e?Zt(this,e):0==this.i.length||Xe(this.h)||Zt(this))},e.Fa=function(){if(this.u=null,on(this),this.ba&&!(this.M||null==this.g||0>=this.R)){var e=2*this.R;this.j.info("BP detection timer enabled: "+e),this.A=Ie(c(this.ab,this),e)}},e.ab=function(){this.A&&(this.A=null,this.j.info("BP detection timeout reached."),this.j.info("Buffering proxy detected and switch to long-polling!"),this.F=!1,this.M=!0,xe(10),Yt(this),on(this))},e.Za=function(){null!=this.C&&(this.C=null,Yt(this),rn(this),xe(19))},e.fb=function(e){e?(this.j.info("Successfully pinged google.com"),xe(2)):(this.j.info("Failed to ping google.com"),xe(1))},e.isActive=function(){return!!this.l&&this.l.isActive(this)},(e=fn.prototype).ua=function(){},e.ta=function(){},e.sa=function(){},e.ra=function(){},e.isActive=function(){return!0},e.Na=function(){},mn.prototype.g=function(e,t){return new gn(e,t)},d(gn,ne),gn.prototype.m=function(){this.g.l=this.j,this.v&&(this.g.J=!0),this.g.connect(this.l,this.h||void 0)},gn.prototype.close=function(){Qt(this.g)},gn.prototype.o=function(e){var t=this.g;if("string"==typeof e){var n={};n.__data__=e,e=n}else this.u&&((n={}).__data__=de(e),e=n);t.i.push(new Qe(t.Ya++,e)),3==t.G&&Jt(t)},gn.prototype.N=function(){this.g.l=null,delete this.j,Qt(this.g),delete this.g,gn.aa.N.call(this)},d(yn,ve),d(vn,we),d(wn,fn),wn.prototype.ua=function(){re(this.g,"a")},wn.prototype.ta=function(e){re(this.g,new yn(e))},wn.prototype.sa=function(e){re(this.g,new vn)},wn.prototype.ra=function(){re(this.g,"b")},mn.prototype.createWebChannel=mn.prototype.g,gn.prototype.send=gn.prototype.o,gn.prototype.open=gn.prototype.m,gn.prototype.close=gn.prototype.close,es=ns.createWebChannelTransport=function(){return new mn},Zr=ns.getStatEventTarget=function(){return Ee()},Jr=ns.Event=be,Xr=ns.Stat={mb:0,pb:1,qb:2,Jb:3,Ob:4,Lb:5,Mb:6,Kb:7,Ib:8,Nb:9,PROXY:10,NOPROXY:11,Gb:12,Cb:13,Db:14,Bb:15,Eb:16,Fb:17,ib:18,hb:19,jb:20},De.NO_ERROR=0,De.TIMEOUT=8,De.HTTP_ERROR=6,Yr=ns.ErrorCode=De,Ne.COMPLETE="complete",Qr=ns.EventType=Ne,ge.EventType=ye,ye.OPEN="a",ye.CLOSE="b",ye.ERROR="c",ye.MESSAGE="d",ne.prototype.listen=ne.prototype.K,Kr=ns.WebChannel=ge,ns.FetchXmlHttpFactory=Lt,Rt.prototype.listenOnce=Rt.prototype.L,Rt.prototype.getLastError=Rt.prototype.Ka,Rt.prototype.getLastErrorCode=Rt.prototype.Ba,Rt.prototype.getStatus=Rt.prototype.Z,Rt.prototype.getResponseJson=Rt.prototype.Oa,Rt.prototype.getResponseText=Rt.prototype.oa,Rt.prototype.send=Rt.prototype.ea,Rt.prototype.setWithCredentials=Rt.prototype.Ha,Wr=ns.XhrIo=Rt}).apply(void 0!==ts?ts:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{});const rs="@firebase/firestore";class ss{constructor(e){this.uid=e}isAuthenticated(){return null!=this.uid}toKey(){return this.isAuthenticated()?"uid:"+this.uid:"anonymous-user"}isEqual(e){return e.uid===this.uid}}ss.UNAUTHENTICATED=new ss(null),ss.GOOGLE_CREDENTIALS=new ss("google-credentials-uid"),ss.FIRST_PARTY=new ss("first-party-uid"),ss.MOCK_USER=new ss("mock-user");let is="11.2.0";const os=new Yn("@firebase/firestore");function as(){return os.logLevel}function ls(e,...t){if(os.logLevel<=Gn.DEBUG){const n=t.map(ds);os.debug(`Firestore (${is}): ${e}`,...n)}}function cs(e,...t){if(os.logLevel<=Gn.ERROR){const n=t.map(ds);os.error(`Firestore (${is}): ${e}`,...n)}}function us(e,...t){if(os.logLevel<=Gn.WARN){const n=t.map(ds);os.warn(`Firestore (${is}): ${e}`,...n)}}function ds(e){if("string"==typeof e)return e;try{return function(e){return JSON.stringify(e)}(e)}catch(t){return e}}function hs(e="Unexpected state"){const t=`FIRESTORE (${is}) INTERNAL ASSERTION FAILED: `+e;throw cs(t),new Error(t)}function ps(e,t){e||hs()}function fs(e,t){return e}const ms={OK:"ok",CANCELLED:"cancelled",UNKNOWN:"unknown",INVALID_ARGUMENT:"invalid-argument",DEADLINE_EXCEEDED:"deadline-exceeded",NOT_FOUND:"not-found",ALREADY_EXISTS:"already-exists",PERMISSION_DENIED:"permission-denied",UNAUTHENTICATED:"unauthenticated",RESOURCE_EXHAUSTED:"resource-exhausted",FAILED_PRECONDITION:"failed-precondition",ABORTED:"aborted",OUT_OF_RANGE:"out-of-range",UNIMPLEMENTED:"unimplemented",INTERNAL:"internal",UNAVAILABLE:"unavailable",DATA_LOSS:"data-loss"};class gs extends Pn{constructor(e,t){super(e,t),this.code=e,this.message=t,this.toString=()=>`${this.name}: [code=${this.code}]: ${this.message}`}}class ys{constructor(){this.promise=new Promise(((e,t)=>{this.resolve=e,this.reject=t}))}}class vs{constructor(e,t){this.user=t,this.type="OAuth",this.headers=new Map,this.headers.set("Authorization",`Bearer ${e}`)}}class ws{getToken(){return Promise.resolve(null)}invalidateToken(){}start(e,t){e.enqueueRetryable((()=>t(ss.UNAUTHENTICATED)))}shutdown(){}}class bs{constructor(e){this.token=e,this.changeListener=null}getToken(){return Promise.resolve(this.token)}invalidateToken(){}start(e,t){this.changeListener=t,e.enqueueRetryable((()=>t(this.token.user)))}shutdown(){this.changeListener=null}}class Ss{constructor(e){this.t=e,this.currentUser=ss.UNAUTHENTICATED,this.i=0,this.forceRefresh=!1,this.auth=null}start(e,t){ps(void 0===this.o);let n=this.i;const r=e=>this.i!==n?(n=this.i,t(e)):Promise.resolve();let s=new ys;this.o=()=>{this.i++,this.currentUser=this.u(),s.resolve(),s=new ys,e.enqueueRetryable((()=>r(this.currentUser)))};const i=()=>{const t=s;e.enqueueRetryable((async()=>{await t.promise,await r(this.currentUser)}))},o=e=>{ls("FirebaseAuthCredentialsProvider","Auth detected"),this.auth=e,this.o&&(this.auth.addAuthTokenListener(this.o),i())};this.t.onInit((e=>o(e))),setTimeout((()=>{if(!this.auth){const e=this.t.getImmediate({optional:!0});e?o(e):(ls("FirebaseAuthCredentialsProvider","Auth not yet detected"),s.resolve(),s=new ys)}}),0),i()}getToken(){const e=this.i,t=this.forceRefresh;return this.forceRefresh=!1,this.auth?this.auth.getToken(t).then((t=>this.i!==e?(ls("FirebaseAuthCredentialsProvider","getToken aborted due to token change."),this.getToken()):t?(ps("string"==typeof t.accessToken),new vs(t.accessToken,this.currentUser)):null)):Promise.resolve(null)}invalidateToken(){this.forceRefresh=!0}shutdown(){this.auth&&this.o&&this.auth.removeAuthTokenListener(this.o),this.o=void 0}u(){const e=this.auth&&this.auth.getUid();return ps(null===e||"string"==typeof e),new ss(e)}}class Es{constructor(e,t,n){this.l=e,this.h=t,this.P=n,this.type="FirstParty",this.user=ss.FIRST_PARTY,this.T=new Map}I(){return this.P?this.P():null}get headers(){this.T.set("X-Goog-AuthUser",this.l);const e=this.I();return e&&this.T.set("Authorization",e),this.h&&this.T.set("X-Goog-Iam-Authorization-Token",this.h),this.T}}class Ts{constructor(e,t,n){this.l=e,this.h=t,this.P=n}getToken(){return Promise.resolve(new Es(this.l,this.h,this.P))}start(e,t){e.enqueueRetryable((()=>t(ss.FIRST_PARTY)))}shutdown(){}invalidateToken(){}}class _s{constructor(e){this.value=e,this.type="AppCheck",this.headers=new Map,e&&e.length>0&&this.headers.set("x-firebase-appcheck",this.value)}}class Cs{constructor(e){this.A=e,this.forceRefresh=!1,this.appCheck=null,this.R=null}start(e,t){ps(void 0===this.o);const n=e=>{null!=e.error&&ls("FirebaseAppCheckTokenProvider",`Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);const n=e.token!==this.R;return this.R=e.token,ls("FirebaseAppCheckTokenProvider",`Received ${n?"new":"existing"} token.`),n?t(e.token):Promise.resolve()};this.o=t=>{e.enqueueRetryable((()=>n(t)))};const r=e=>{ls("FirebaseAppCheckTokenProvider","AppCheck detected"),this.appCheck=e,this.o&&this.appCheck.addTokenListener(this.o)};this.A.onInit((e=>r(e))),setTimeout((()=>{if(!this.appCheck){const e=this.A.getImmediate({optional:!0});e?r(e):ls("FirebaseAppCheckTokenProvider","AppCheck not yet detected")}}),0)}getToken(){const e=this.forceRefresh;return this.forceRefresh=!1,this.appCheck?this.appCheck.getToken(e).then((e=>e?(ps("string"==typeof e.token),this.R=e.token,new _s(e.token)):null)):Promise.resolve(null)}invalidateToken(){this.forceRefresh=!0}shutdown(){this.appCheck&&this.o&&this.appCheck.removeTokenListener(this.o),this.o=void 0}}function xs(e){const t="undefined"!=typeof self&&(self.crypto||self.msCrypto),n=new Uint8Array(e);if(t&&"function"==typeof t.getRandomValues)t.getRandomValues(n);else for(let t=0;t<e;t++)n[t]=Math.floor(256*Math.random());return n}class As{static newId(){const e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",t=62*Math.floor(256/62);let n="";for(;n.length<20;){const r=xs(40);for(let s=0;s<r.length;++s)n.length<20&&r[s]<t&&(n+=e.charAt(r[s]%62))}return n}}function Is(e,t){return e<t?-1:e>t?1:0}function ks(e,t,n){return e.length===t.length&&e.every(((e,r)=>n(e,t[r])))}class Ls{static now(){return Ls.fromMillis(Date.now())}static fromDate(e){return Ls.fromMillis(e.getTime())}static fromMillis(e){const t=Math.floor(e/1e3),n=Math.floor(1e6*(e-1e3*t));return new Ls(t,n)}constructor(e,t){if(this.seconds=e,this.nanoseconds=t,t<0)throw new gs(ms.INVALID_ARGUMENT,"Timestamp nanoseconds out of range: "+t);if(t>=1e9)throw new gs(ms.INVALID_ARGUMENT,"Timestamp nanoseconds out of range: "+t);if(e<-62135596800)throw new gs(ms.INVALID_ARGUMENT,"Timestamp seconds out of range: "+e);if(e>=253402300800)throw new gs(ms.INVALID_ARGUMENT,"Timestamp seconds out of range: "+e)}toDate(){return new Date(this.toMillis())}toMillis(){return 1e3*this.seconds+this.nanoseconds/1e6}_compareTo(e){return this.seconds===e.seconds?Is(this.nanoseconds,e.nanoseconds):Is(this.seconds,e.seconds)}isEqual(e){return e.seconds===this.seconds&&e.nanoseconds===this.nanoseconds}toString(){return"Timestamp(seconds="+this.seconds+", nanoseconds="+this.nanoseconds+")"}toJSON(){return{seconds:this.seconds,nanoseconds:this.nanoseconds}}valueOf(){const e=this.seconds- -62135596800;return String(e).padStart(12,"0")+"."+String(this.nanoseconds).padStart(9,"0")}}class Ms{static fromTimestamp(e){return new Ms(e)}static min(){return new Ms(new Ls(0,0))}static max(){return new Ms(new Ls(253402300799,999999999))}constructor(e){this.timestamp=e}compareTo(e){return this.timestamp._compareTo(e.timestamp)}isEqual(e){return this.timestamp.isEqual(e.timestamp)}toMicroseconds(){return 1e6*this.timestamp.seconds+this.timestamp.nanoseconds/1e3}toString(){return"SnapshotVersion("+this.timestamp.toString()+")"}toTimestamp(){return this.timestamp}}class Ds{constructor(e,t,n){void 0===t?t=0:t>e.length&&hs(),void 0===n?n=e.length-t:n>e.length-t&&hs(),this.segments=e,this.offset=t,this.len=n}get length(){return this.len}isEqual(e){return 0===Ds.comparator(this,e)}child(e){const t=this.segments.slice(this.offset,this.limit());return e instanceof Ds?e.forEach((e=>{t.push(e)})):t.push(e),this.construct(t)}limit(){return this.offset+this.length}popFirst(e){return e=void 0===e?1:e,this.construct(this.segments,this.offset+e,this.length-e)}popLast(){return this.construct(this.segments,this.offset,this.length-1)}firstSegment(){return this.segments[this.offset]}lastSegment(){return this.get(this.length-1)}get(e){return this.segments[this.offset+e]}isEmpty(){return 0===this.length}isPrefixOf(e){if(e.length<this.length)return!1;for(let t=0;t<this.length;t++)if(this.get(t)!==e.get(t))return!1;return!0}isImmediateParentOf(e){if(this.length+1!==e.length)return!1;for(let t=0;t<this.length;t++)if(this.get(t)!==e.get(t))return!1;return!0}forEach(e){for(let t=this.offset,n=this.limit();t<n;t++)e(this.segments[t])}toArray(){return this.segments.slice(this.offset,this.limit())}static comparator(e,t){const n=Math.min(e.length,t.length);for(let r=0;r<n;r++){const n=Ds.compareSegments(e.get(r),t.get(r));if(0!==n)return n}return Math.sign(e.length-t.length)}static compareSegments(e,t){const n=Ds.isNumericId(e),r=Ds.isNumericId(t);return n&&!r?-1:!n&&r?1:n&&r?Ds.extractNumericId(e).compare(Ds.extractNumericId(t)):e<t?-1:e>t?1:0}static isNumericId(e){return e.startsWith("__id")&&e.endsWith("__")}static extractNumericId(e){return zr.fromString(e.substring(4,e.length-2))}}class Ns extends Ds{construct(e,t,n){return new Ns(e,t,n)}canonicalString(){return this.toArray().join("/")}toString(){return this.canonicalString()}toUriEncodedString(){return this.toArray().map(encodeURIComponent).join("/")}static fromString(...e){const t=[];for(const n of e){if(n.indexOf("//")>=0)throw new gs(ms.INVALID_ARGUMENT,`Invalid segment (${n}). Paths must not contain // in them.`);t.push(...n.split("/").filter((e=>e.length>0)))}return new Ns(t)}static emptyPath(){return new Ns([])}}const Ps=/^[_a-zA-Z][_a-zA-Z0-9]*$/;class Os extends Ds{construct(e,t,n){return new Os(e,t,n)}static isValidIdentifier(e){return Ps.test(e)}canonicalString(){return this.toArray().map((e=>(e=e.replace(/\\/g,"\\\\").replace(/`/g,"\\`"),Os.isValidIdentifier(e)||(e="`"+e+"`"),e))).join(".")}toString(){return this.canonicalString()}isKeyField(){return 1===this.length&&"__name__"===this.get(0)}static keyField(){return new Os(["__name__"])}static fromServerFormat(e){const t=[];let n="",r=0;const s=()=>{if(0===n.length)throw new gs(ms.INVALID_ARGUMENT,`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);t.push(n),n=""};let i=!1;for(;r<e.length;){const t=e[r];if("\\"===t){if(r+1===e.length)throw new gs(ms.INVALID_ARGUMENT,"Path has trailing escape character: "+e);const t=e[r+1];if("\\"!==t&&"."!==t&&"`"!==t)throw new gs(ms.INVALID_ARGUMENT,"Path has invalid escape sequence: "+e);n+=t,r+=2}else"`"===t?(i=!i,r++):"."!==t||i?(n+=t,r++):(s(),r++)}if(s(),i)throw new gs(ms.INVALID_ARGUMENT,"Unterminated ` in path: "+e);return new Os(t)}static emptyPath(){return new Os([])}}class qs{constructor(e){this.path=e}static fromPath(e){return new qs(Ns.fromString(e))}static fromName(e){return new qs(Ns.fromString(e).popFirst(5))}static empty(){return new qs(Ns.emptyPath())}get collectionGroup(){return this.path.popLast().lastSegment()}hasCollectionId(e){return this.path.length>=2&&this.path.get(this.path.length-2)===e}getCollectionGroup(){return this.path.get(this.path.length-2)}getCollectionPath(){return this.path.popLast()}isEqual(e){return null!==e&&0===Ns.comparator(this.path,e.path)}toString(){return this.path.toString()}static comparator(e,t){return Ns.comparator(e.path,t.path)}static isDocumentKey(e){return e.length%2==0}static fromSegments(e){return new qs(new Ns(e.slice()))}}class Rs{constructor(e,t,n,r){this.indexId=e,this.collectionGroup=t,this.fields=n,this.indexState=r}}Rs.UNKNOWN_ID=-1;function Fs(e,t){const n=e.toTimestamp().seconds,r=e.toTimestamp().nanoseconds+1,s=Ms.fromTimestamp(1e9===r?new Ls(n+1,0):new Ls(n,r));return new $s(s,qs.empty(),t)}function Bs(e){return new $s(e.readTime,e.key,-1)}class $s{constructor(e,t,n){this.readTime=e,this.documentKey=t,this.largestBatchId=n}static min(){return new $s(Ms.min(),qs.empty(),-1)}static max(){return new $s(Ms.max(),qs.empty(),-1)}}function Vs(e,t){let n=e.readTime.compareTo(t.readTime);return 0!==n?n:(n=qs.comparator(e.documentKey,t.documentKey),0!==n?n:Is(e.largestBatchId,t.largestBatchId))}const js="The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";class zs{constructor(){this.onCommittedListeners=[]}addOnCommittedListener(e){this.onCommittedListeners.push(e)}raiseOnCommittedEvent(){this.onCommittedListeners.forEach((e=>e()))}}async function Us(e){if(e.code!==ms.FAILED_PRECONDITION||e.message!==js)throw e;ls("LocalStore","Unexpectedly lost primary lease")}class Gs{constructor(e){this.nextCallback=null,this.catchCallback=null,this.result=void 0,this.error=void 0,this.isDone=!1,this.callbackAttached=!1,e((e=>{this.isDone=!0,this.result=e,this.nextCallback&&this.nextCallback(e)}),(e=>{this.isDone=!0,this.error=e,this.catchCallback&&this.catchCallback(e)}))}catch(e){return this.next(void 0,e)}next(e,t){return this.callbackAttached&&hs(),this.callbackAttached=!0,this.isDone?this.error?this.wrapFailure(t,this.error):this.wrapSuccess(e,this.result):new Gs(((n,r)=>{this.nextCallback=t=>{this.wrapSuccess(e,t).next(n,r)},this.catchCallback=e=>{this.wrapFailure(t,e).next(n,r)}}))}toPromise(){return new Promise(((e,t)=>{this.next(e,t)}))}wrapUserFunction(e){try{const t=e();return t instanceof Gs?t:Gs.resolve(t)}catch(e){return Gs.reject(e)}}wrapSuccess(e,t){return e?this.wrapUserFunction((()=>e(t))):Gs.resolve(t)}wrapFailure(e,t){return e?this.wrapUserFunction((()=>e(t))):Gs.reject(t)}static resolve(e){return new Gs(((t,n)=>{t(e)}))}static reject(e){return new Gs(((t,n)=>{n(e)}))}static waitFor(e){return new Gs(((t,n)=>{let r=0,s=0,i=!1;e.forEach((e=>{++r,e.next((()=>{++s,i&&s===r&&t()}),(e=>n(e)))})),i=!0,s===r&&t()}))}static or(e){let t=Gs.resolve(!1);for(const n of e)t=t.next((e=>e?Gs.resolve(e):n()));return t}static forEach(e,t){const n=[];return e.forEach(((e,r)=>{n.push(t.call(this,e,r))})),this.waitFor(n)}static mapArray(e,t){return new Gs(((n,r)=>{const s=e.length,i=new Array(s);let o=0;for(let a=0;a<s;a++){const l=a;t(e[l]).next((e=>{i[l]=e,++o,o===s&&n(i)}),(e=>r(e)))}}))}static doWhile(e,t){return new Gs(((n,r)=>{const s=()=>{!0===e()?t().next((()=>{s()}),r):n()};s()}))}}function Hs(e){const t=e.match(/Android ([\d.]+)/i),n=t?t[1].split(".").slice(0,2).join("."):"-1";return Number(n)}function Ws(e){return"IndexedDbTransactionError"===e.name}class Ks{constructor(e,t){this.previousValue=e,t&&(t.sequenceNumberHandler=e=>this.ie(e),this.se=e=>t.writeSequenceNumber(e))}ie(e){return this.previousValue=Math.max(e,this.previousValue),this.previousValue}next(){const e=++this.previousValue;return this.se&&this.se(e),e}}function Qs(e){return null==e}function Ys(e){return 0===e&&1/e==-1/0}function Xs(e){return"number"==typeof e&&Number.isInteger(e)&&!Ys(e)&&e<=Number.MAX_SAFE_INTEGER&&e>=Number.MIN_SAFE_INTEGER}function Js(e){let t="";for(let n=0;n<e.length;n++)t.length>0&&(t=ei(t)),t=Zs(e.get(n),t);return ei(t)}function Zs(e,t){let n=t;const r=e.length;for(let t=0;t<r;t++){const r=e.charAt(t);switch(r){case"\0":n+="";break;case"":n+="";break;default:n+=r}}return n}function ei(e){return e+""}Ks.oe=-1;const ti=["mutationQueues","mutations","documentMutations","remoteDocuments","targets","owner","targetGlobal","targetDocuments","clientMetadata","remoteDocumentGlobal","collectionParents","bundles","namedQueries"],ni=["mutationQueues","mutations","documentMutations","remoteDocumentsV14","targets","owner","targetGlobal","targetDocuments","clientMetadata","remoteDocumentGlobal","collectionParents","bundles","namedQueries","documentOverlays"],ri=ni,si=[...ri,"indexConfiguration","indexState","indexEntries"];function ii(e){let t=0;for(const n in e)Object.prototype.hasOwnProperty.call(e,n)&&t++;return t}function oi(e,t){for(const n in e)Object.prototype.hasOwnProperty.call(e,n)&&t(n,e[n])}function ai(e){for(const t in e)if(Object.prototype.hasOwnProperty.call(e,t))return!1;return!0}class li{constructor(e,t){this.comparator=e,this.root=t||ui.EMPTY}insert(e,t){return new li(this.comparator,this.root.insert(e,t,this.comparator).copy(null,null,ui.BLACK,null,null))}remove(e){return new li(this.comparator,this.root.remove(e,this.comparator).copy(null,null,ui.BLACK,null,null))}get(e){let t=this.root;for(;!t.isEmpty();){const n=this.comparator(e,t.key);if(0===n)return t.value;n<0?t=t.left:n>0&&(t=t.right)}return null}indexOf(e){let t=0,n=this.root;for(;!n.isEmpty();){const r=this.comparator(e,n.key);if(0===r)return t+n.left.size;r<0?n=n.left:(t+=n.left.size+1,n=n.right)}return-1}isEmpty(){return this.root.isEmpty()}get size(){return this.root.size}minKey(){return this.root.minKey()}maxKey(){return this.root.maxKey()}inorderTraversal(e){return this.root.inorderTraversal(e)}forEach(e){this.inorderTraversal(((t,n)=>(e(t,n),!1)))}toString(){const e=[];return this.inorderTraversal(((t,n)=>(e.push(`${t}:${n}`),!1))),`{${e.join(", ")}}`}reverseTraversal(e){return this.root.reverseTraversal(e)}getIterator(){return new ci(this.root,null,this.comparator,!1)}getIteratorFrom(e){return new ci(this.root,e,this.comparator,!1)}getReverseIterator(){return new ci(this.root,null,this.comparator,!0)}getReverseIteratorFrom(e){return new ci(this.root,e,this.comparator,!0)}}class ci{constructor(e,t,n,r){this.isReverse=r,this.nodeStack=[];let s=1;for(;!e.isEmpty();)if(s=t?n(e.key,t):1,t&&r&&(s*=-1),s<0)e=this.isReverse?e.left:e.right;else{if(0===s){this.nodeStack.push(e);break}this.nodeStack.push(e),e=this.isReverse?e.right:e.left}}getNext(){let e=this.nodeStack.pop();const t={key:e.key,value:e.value};if(this.isReverse)for(e=e.left;!e.isEmpty();)this.nodeStack.push(e),e=e.right;else for(e=e.right;!e.isEmpty();)this.nodeStack.push(e),e=e.left;return t}hasNext(){return this.nodeStack.length>0}peek(){if(0===this.nodeStack.length)return null;const e=this.nodeStack[this.nodeStack.length-1];return{key:e.key,value:e.value}}}class ui{constructor(e,t,n,r,s){this.key=e,this.value=t,this.color=null!=n?n:ui.RED,this.left=null!=r?r:ui.EMPTY,this.right=null!=s?s:ui.EMPTY,this.size=this.left.size+1+this.right.size}copy(e,t,n,r,s){return new ui(null!=e?e:this.key,null!=t?t:this.value,null!=n?n:this.color,null!=r?r:this.left,null!=s?s:this.right)}isEmpty(){return!1}inorderTraversal(e){return this.left.inorderTraversal(e)||e(this.key,this.value)||this.right.inorderTraversal(e)}reverseTraversal(e){return this.right.reverseTraversal(e)||e(this.key,this.value)||this.left.reverseTraversal(e)}min(){return this.left.isEmpty()?this:this.left.min()}minKey(){return this.min().key}maxKey(){return this.right.isEmpty()?this.key:this.right.maxKey()}insert(e,t,n){let r=this;const s=n(e,r.key);return r=s<0?r.copy(null,null,null,r.left.insert(e,t,n),null):0===s?r.copy(null,t,null,null,null):r.copy(null,null,null,null,r.right.insert(e,t,n)),r.fixUp()}removeMin(){if(this.left.isEmpty())return ui.EMPTY;let e=this;return e.left.isRed()||e.left.left.isRed()||(e=e.moveRedLeft()),e=e.copy(null,null,null,e.left.removeMin(),null),e.fixUp()}remove(e,t){let n,r=this;if(t(e,r.key)<0)r.left.isEmpty()||r.left.isRed()||r.left.left.isRed()||(r=r.moveRedLeft()),r=r.copy(null,null,null,r.left.remove(e,t),null);else{if(r.left.isRed()&&(r=r.rotateRight()),r.right.isEmpty()||r.right.isRed()||r.right.left.isRed()||(r=r.moveRedRight()),0===t(e,r.key)){if(r.right.isEmpty())return ui.EMPTY;n=r.right.min(),r=r.copy(n.key,n.value,null,null,r.right.removeMin())}r=r.copy(null,null,null,null,r.right.remove(e,t))}return r.fixUp()}isRed(){return this.color}fixUp(){let e=this;return e.right.isRed()&&!e.left.isRed()&&(e=e.rotateLeft()),e.left.isRed()&&e.left.left.isRed()&&(e=e.rotateRight()),e.left.isRed()&&e.right.isRed()&&(e=e.colorFlip()),e}moveRedLeft(){let e=this.colorFlip();return e.right.left.isRed()&&(e=e.copy(null,null,null,null,e.right.rotateRight()),e=e.rotateLeft(),e=e.colorFlip()),e}moveRedRight(){let e=this.colorFlip();return e.left.left.isRed()&&(e=e.rotateRight(),e=e.colorFlip()),e}rotateLeft(){const e=this.copy(null,null,ui.RED,null,this.right.left);return this.right.copy(null,null,this.color,e,null)}rotateRight(){const e=this.copy(null,null,ui.RED,this.left.right,null);return this.left.copy(null,null,this.color,null,e)}colorFlip(){const e=this.left.copy(null,null,!this.left.color,null,null),t=this.right.copy(null,null,!this.right.color,null,null);return this.copy(null,null,!this.color,e,t)}checkMaxDepth(){const e=this.check();return Math.pow(2,e)<=this.size+1}check(){if(this.isRed()&&this.left.isRed())throw hs();if(this.right.isRed())throw hs();const e=this.left.check();if(e!==this.right.check())throw hs();return e+(this.isRed()?0:1)}}ui.EMPTY=null,ui.RED=!0,ui.BLACK=!1,ui.EMPTY=new class{constructor(){this.size=0}get key(){throw hs()}get value(){throw hs()}get color(){throw hs()}get left(){throw hs()}get right(){throw hs()}copy(e,t,n,r,s){return this}insert(e,t,n){return new ui(e,t)}remove(e,t){return this}isEmpty(){return!0}inorderTraversal(e){return!1}reverseTraversal(e){return!1}minKey(){return null}maxKey(){return null}isRed(){return!1}checkMaxDepth(){return!0}check(){return 0}};class di{constructor(e){this.comparator=e,this.data=new li(this.comparator)}has(e){return null!==this.data.get(e)}first(){return this.data.minKey()}last(){return this.data.maxKey()}get size(){return this.data.size}indexOf(e){return this.data.indexOf(e)}forEach(e){this.data.inorderTraversal(((t,n)=>(e(t),!1)))}forEachInRange(e,t){const n=this.data.getIteratorFrom(e[0]);for(;n.hasNext();){const r=n.getNext();if(this.comparator(r.key,e[1])>=0)return;t(r.key)}}forEachWhile(e,t){let n;for(n=void 0!==t?this.data.getIteratorFrom(t):this.data.getIterator();n.hasNext();)if(!e(n.getNext().key))return}firstAfterOrEqual(e){const t=this.data.getIteratorFrom(e);return t.hasNext()?t.getNext().key:null}getIterator(){return new hi(this.data.getIterator())}getIteratorFrom(e){return new hi(this.data.getIteratorFrom(e))}add(e){return this.copy(this.data.remove(e).insert(e,!0))}delete(e){return this.has(e)?this.copy(this.data.remove(e)):this}isEmpty(){return this.data.isEmpty()}unionWith(e){let t=this;return t.size<e.size&&(t=e,e=this),e.forEach((e=>{t=t.add(e)})),t}isEqual(e){if(!(e instanceof di))return!1;if(this.size!==e.size)return!1;const t=this.data.getIterator(),n=e.data.getIterator();for(;t.hasNext();){const e=t.getNext().key,r=n.getNext().key;if(0!==this.comparator(e,r))return!1}return!0}toArray(){const e=[];return this.forEach((t=>{e.push(t)})),e}toString(){const e=[];return this.forEach((t=>e.push(t))),"SortedSet("+e.toString()+")"}copy(e){const t=new di(this.comparator);return t.data=e,t}}class hi{constructor(e){this.iter=e}getNext(){return this.iter.getNext().key}hasNext(){return this.iter.hasNext()}}class pi{constructor(e){this.fields=e,e.sort(Os.comparator)}static empty(){return new pi([])}unionWith(e){let t=new di(Os.comparator);for(const e of this.fields)t=t.add(e);for(const n of e)t=t.add(n);return new pi(t.toArray())}covers(e){for(const t of this.fields)if(t.isPrefixOf(e))return!0;return!1}isEqual(e){return ks(this.fields,e.fields,((e,t)=>e.isEqual(t)))}}class fi extends Error{constructor(){super(...arguments),this.name="Base64DecodeError"}}class mi{constructor(e){this.binaryString=e}static fromBase64String(e){const t=function(e){try{return atob(e)}catch(e){throw"undefined"!=typeof DOMException&&e instanceof DOMException?new fi("Invalid base64 string: "+e):e}}(e);return new mi(t)}static fromUint8Array(e){const t=function(e){let t="";for(let n=0;n<e.length;++n)t+=String.fromCharCode(e[n]);return t}(e);return new mi(t)}[Symbol.iterator](){let e=0;return{next:()=>e<this.binaryString.length?{value:this.binaryString.charCodeAt(e++),done:!1}:{value:void 0,done:!0}}}toBase64(){return function(e){return btoa(e)}(this.binaryString)}toUint8Array(){return function(e){const t=new Uint8Array(e.length);for(let n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}(this.binaryString)}approximateByteSize(){return 2*this.binaryString.length}compareTo(e){return Is(this.binaryString,e.binaryString)}isEqual(e){return this.binaryString===e.binaryString}}mi.EMPTY_BYTE_STRING=new mi("");const gi=new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);function yi(e){if(ps(!!e),"string"==typeof e){let t=0;const n=gi.exec(e);if(ps(!!n),n[1]){let e=n[1];e=(e+"000000000").substr(0,9),t=Number(e)}const r=new Date(e);return{seconds:Math.floor(r.getTime()/1e3),nanos:t}}return{seconds:vi(e.seconds),nanos:vi(e.nanos)}}function vi(e){return"number"==typeof e?e:"string"==typeof e?Number(e):0}function wi(e){return"string"==typeof e?mi.fromBase64String(e):mi.fromUint8Array(e)}function bi(e){var t,n;return"server_timestamp"===(null===(n=((null===(t=null==e?void 0:e.mapValue)||void 0===t?void 0:t.fields)||{}).__type__)||void 0===n?void 0:n.stringValue)}function Si(e){const t=e.mapValue.fields.__previous_value__;return bi(t)?Si(t):t}function Ei(e){const t=yi(e.mapValue.fields.__local_write_time__.timestampValue);return new Ls(t.seconds,t.nanos)}class Ti{constructor(e,t,n,r,s,i,o,a,l){this.databaseId=e,this.appId=t,this.persistenceKey=n,this.host=r,this.ssl=s,this.forceLongPolling=i,this.autoDetectLongPolling=o,this.longPollingOptions=a,this.useFetchStreams=l}}class _i{constructor(e,t){this.projectId=e,this.database=t||"(default)"}static empty(){return new _i("","")}get isDefaultDatabase(){return"(default)"===this.database}isEqual(e){return e instanceof _i&&e.projectId===this.projectId&&e.database===this.database}}const Ci={mapValue:{fields:{__type__:{stringValue:"__max__"}}}};function xi(e){return"nullValue"in e?0:"booleanValue"in e?1:"integerValue"in e||"doubleValue"in e?2:"timestampValue"in e?3:"stringValue"in e?5:"bytesValue"in e?6:"referenceValue"in e?7:"geoPointValue"in e?8:"arrayValue"in e?9:"mapValue"in e?bi(e)?4:ji(e)?9007199254740991:$i(e)?10:11:hs()}function Ai(e,t){if(e===t)return!0;const n=xi(e);if(n!==xi(t))return!1;switch(n){case 0:case 9007199254740991:return!0;case 1:return e.booleanValue===t.booleanValue;case 4:return Ei(e).isEqual(Ei(t));case 3:return function(e,t){if("string"==typeof e.timestampValue&&"string"==typeof t.timestampValue&&e.timestampValue.length===t.timestampValue.length)return e.timestampValue===t.timestampValue;const n=yi(e.timestampValue),r=yi(t.timestampValue);return n.seconds===r.seconds&&n.nanos===r.nanos}(e,t);case 5:return e.stringValue===t.stringValue;case 6:return function(e,t){return wi(e.bytesValue).isEqual(wi(t.bytesValue))}(e,t);case 7:return e.referenceValue===t.referenceValue;case 8:return function(e,t){return vi(e.geoPointValue.latitude)===vi(t.geoPointValue.latitude)&&vi(e.geoPointValue.longitude)===vi(t.geoPointValue.longitude)}(e,t);case 2:return function(e,t){if("integerValue"in e&&"integerValue"in t)return vi(e.integerValue)===vi(t.integerValue);if("doubleValue"in e&&"doubleValue"in t){const n=vi(e.doubleValue),r=vi(t.doubleValue);return n===r?Ys(n)===Ys(r):isNaN(n)&&isNaN(r)}return!1}(e,t);case 9:return ks(e.arrayValue.values||[],t.arrayValue.values||[],Ai);case 10:case 11:return function(e,t){const n=e.mapValue.fields||{},r=t.mapValue.fields||{};if(ii(n)!==ii(r))return!1;for(const e in n)if(n.hasOwnProperty(e)&&(void 0===r[e]||!Ai(n[e],r[e])))return!1;return!0}(e,t);default:return hs()}}function Ii(e,t){return void 0!==(e.values||[]).find((e=>Ai(e,t)))}function ki(e,t){if(e===t)return 0;const n=xi(e),r=xi(t);if(n!==r)return Is(n,r);switch(n){case 0:case 9007199254740991:return 0;case 1:return Is(e.booleanValue,t.booleanValue);case 2:return function(e,t){const n=vi(e.integerValue||e.doubleValue),r=vi(t.integerValue||t.doubleValue);return n<r?-1:n>r?1:n===r?0:isNaN(n)?isNaN(r)?0:-1:1}(e,t);case 3:return Li(e.timestampValue,t.timestampValue);case 4:return Li(Ei(e),Ei(t));case 5:return Is(e.stringValue,t.stringValue);case 6:return function(e,t){const n=wi(e),r=wi(t);return n.compareTo(r)}(e.bytesValue,t.bytesValue);case 7:return function(e,t){const n=e.split("/"),r=t.split("/");for(let e=0;e<n.length&&e<r.length;e++){const t=Is(n[e],r[e]);if(0!==t)return t}return Is(n.length,r.length)}(e.referenceValue,t.referenceValue);case 8:return function(e,t){const n=Is(vi(e.latitude),vi(t.latitude));return 0!==n?n:Is(vi(e.longitude),vi(t.longitude))}(e.geoPointValue,t.geoPointValue);case 9:return Mi(e.arrayValue,t.arrayValue);case 10:return function(e,t){var n,r,s,i;const o=e.fields||{},a=t.fields||{},l=null===(n=o.value)||void 0===n?void 0:n.arrayValue,c=null===(r=a.value)||void 0===r?void 0:r.arrayValue,u=Is((null===(s=null==l?void 0:l.values)||void 0===s?void 0:s.length)||0,(null===(i=null==c?void 0:c.values)||void 0===i?void 0:i.length)||0);return 0!==u?u:Mi(l,c)}(e.mapValue,t.mapValue);case 11:return function(e,t){if(e===Ci.mapValue&&t===Ci.mapValue)return 0;if(e===Ci.mapValue)return 1;if(t===Ci.mapValue)return-1;const n=e.fields||{},r=Object.keys(n),s=t.fields||{},i=Object.keys(s);r.sort(),i.sort();for(let e=0;e<r.length&&e<i.length;++e){const t=Is(r[e],i[e]);if(0!==t)return t;const o=ki(n[r[e]],s[i[e]]);if(0!==o)return o}return Is(r.length,i.length)}(e.mapValue,t.mapValue);default:throw hs()}}function Li(e,t){if("string"==typeof e&&"string"==typeof t&&e.length===t.length)return Is(e,t);const n=yi(e),r=yi(t),s=Is(n.seconds,r.seconds);return 0!==s?s:Is(n.nanos,r.nanos)}function Mi(e,t){const n=e.values||[],r=t.values||[];for(let e=0;e<n.length&&e<r.length;++e){const t=ki(n[e],r[e]);if(t)return t}return Is(n.length,r.length)}function Di(e){return Ni(e)}function Ni(e){return"nullValue"in e?"null":"booleanValue"in e?""+e.booleanValue:"integerValue"in e?""+e.integerValue:"doubleValue"in e?""+e.doubleValue:"timestampValue"in e?function(e){const t=yi(e);return`time(${t.seconds},${t.nanos})`}(e.timestampValue):"stringValue"in e?e.stringValue:"bytesValue"in e?function(e){return wi(e).toBase64()}(e.bytesValue):"referenceValue"in e?function(e){return qs.fromName(e).toString()}(e.referenceValue):"geoPointValue"in e?function(e){return`geo(${e.latitude},${e.longitude})`}(e.geoPointValue):"arrayValue"in e?function(e){let t="[",n=!0;for(const r of e.values||[])n?n=!1:t+=",",t+=Ni(r);return t+"]"}(e.arrayValue):"mapValue"in e?function(e){const t=Object.keys(e.fields||{}).sort();let n="{",r=!0;for(const s of t)r?r=!1:n+=",",n+=`${s}:${Ni(e.fields[s])}`;return n+"}"}(e.mapValue):hs()}function Pi(e){switch(xi(e)){case 0:case 1:return 4;case 2:return 8;case 3:case 8:return 16;case 4:const t=Si(e);return t?16+Pi(t):16;case 5:return 2*e.stringValue.length;case 6:return wi(e.bytesValue).approximateByteSize();case 7:return e.referenceValue.length;case 9:return function(e){return(e.values||[]).reduce(((e,t)=>e+Pi(t)),0)}(e.arrayValue);case 10:case 11:return function(e){let t=0;return oi(e.fields,((e,n)=>{t+=e.length+Pi(n)})),t}(e.mapValue);default:throw hs()}}function Oi(e){return!!e&&"integerValue"in e}function qi(e){return!!e&&"arrayValue"in e}function Ri(e){return!!e&&"nullValue"in e}function Fi(e){return!!e&&"doubleValue"in e&&isNaN(Number(e.doubleValue))}function Bi(e){return!!e&&"mapValue"in e}function $i(e){var t,n;return"__vector__"===(null===(n=((null===(t=null==e?void 0:e.mapValue)||void 0===t?void 0:t.fields)||{}).__type__)||void 0===n?void 0:n.stringValue)}function Vi(e){if(e.geoPointValue)return{geoPointValue:Object.assign({},e.geoPointValue)};if(e.timestampValue&&"object"==typeof e.timestampValue)return{timestampValue:Object.assign({},e.timestampValue)};if(e.mapValue){const t={mapValue:{fields:{}}};return oi(e.mapValue.fields,((e,n)=>t.mapValue.fields[e]=Vi(n))),t}if(e.arrayValue){const t={arrayValue:{values:[]}};for(let n=0;n<(e.arrayValue.values||[]).length;++n)t.arrayValue.values[n]=Vi(e.arrayValue.values[n]);return t}return Object.assign({},e)}function ji(e){return"__max__"===(((e.mapValue||{}).fields||{}).__type__||{}).stringValue}class zi{constructor(e){this.value=e}static empty(){return new zi({mapValue:{}})}field(e){if(e.isEmpty())return this.value;{let t=this.value;for(let n=0;n<e.length-1;++n)if(t=(t.mapValue.fields||{})[e.get(n)],!Bi(t))return null;return t=(t.mapValue.fields||{})[e.lastSegment()],t||null}}set(e,t){this.getFieldsMap(e.popLast())[e.lastSegment()]=Vi(t)}setAll(e){let t=Os.emptyPath(),n={},r=[];e.forEach(((e,s)=>{if(!t.isImmediateParentOf(s)){const e=this.getFieldsMap(t);this.applyChanges(e,n,r),n={},r=[],t=s.popLast()}e?n[s.lastSegment()]=Vi(e):r.push(s.lastSegment())}));const s=this.getFieldsMap(t);this.applyChanges(s,n,r)}delete(e){const t=this.field(e.popLast());Bi(t)&&t.mapValue.fields&&delete t.mapValue.fields[e.lastSegment()]}isEqual(e){return Ai(this.value,e.value)}getFieldsMap(e){let t=this.value;t.mapValue.fields||(t.mapValue={fields:{}});for(let n=0;n<e.length;++n){let r=t.mapValue.fields[e.get(n)];Bi(r)&&r.mapValue.fields||(r={mapValue:{fields:{}}},t.mapValue.fields[e.get(n)]=r),t=r}return t.mapValue.fields}applyChanges(e,t,n){oi(t,((t,n)=>e[t]=n));for(const t of n)delete e[t]}clone(){return new zi(Vi(this.value))}}function Ui(e){const t=[];return oi(e.fields,((e,n)=>{const r=new Os([e]);if(Bi(n)){const e=Ui(n.mapValue).fields;if(0===e.length)t.push(r);else for(const n of e)t.push(r.child(n))}else t.push(r)})),new pi(t)}class Gi{constructor(e,t,n,r,s,i,o){this.key=e,this.documentType=t,this.version=n,this.readTime=r,this.createTime=s,this.data=i,this.documentState=o}static newInvalidDocument(e){return new Gi(e,0,Ms.min(),Ms.min(),Ms.min(),zi.empty(),0)}static newFoundDocument(e,t,n,r){return new Gi(e,1,t,Ms.min(),n,r,0)}static newNoDocument(e,t){return new Gi(e,2,t,Ms.min(),Ms.min(),zi.empty(),0)}static newUnknownDocument(e,t){return new Gi(e,3,t,Ms.min(),Ms.min(),zi.empty(),2)}convertToFoundDocument(e,t){return!this.createTime.isEqual(Ms.min())||2!==this.documentType&&0!==this.documentType||(this.createTime=e),this.version=e,this.documentType=1,this.data=t,this.documentState=0,this}convertToNoDocument(e){return this.version=e,this.documentType=2,this.data=zi.empty(),this.documentState=0,this}convertToUnknownDocument(e){return this.version=e,this.documentType=3,this.data=zi.empty(),this.documentState=2,this}setHasCommittedMutations(){return this.documentState=2,this}setHasLocalMutations(){return this.documentState=1,this.version=Ms.min(),this}setReadTime(e){return this.readTime=e,this}get hasLocalMutations(){return 1===this.documentState}get hasCommittedMutations(){return 2===this.documentState}get hasPendingWrites(){return this.hasLocalMutations||this.hasCommittedMutations}isValidDocument(){return 0!==this.documentType}isFoundDocument(){return 1===this.documentType}isNoDocument(){return 2===this.documentType}isUnknownDocument(){return 3===this.documentType}isEqual(e){return e instanceof Gi&&this.key.isEqual(e.key)&&this.version.isEqual(e.version)&&this.documentType===e.documentType&&this.documentState===e.documentState&&this.data.isEqual(e.data)}mutableCopy(){return new Gi(this.key,this.documentType,this.version,this.readTime,this.createTime,this.data.clone(),this.documentState)}toString(){return`Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`}}class Hi{constructor(e,t){this.position=e,this.inclusive=t}}function Wi(e,t,n){let r=0;for(let s=0;s<e.position.length;s++){const i=t[s],o=e.position[s];if(r=i.field.isKeyField()?qs.comparator(qs.fromName(o.referenceValue),n.key):ki(o,n.data.field(i.field)),"desc"===i.dir&&(r*=-1),0!==r)break}return r}function Ki(e,t){if(null===e)return null===t;if(null===t)return!1;if(e.inclusive!==t.inclusive||e.position.length!==t.position.length)return!1;for(let n=0;n<e.position.length;n++)if(!Ai(e.position[n],t.position[n]))return!1;return!0}class Qi{constructor(e,t="asc"){this.field=e,this.dir=t}}function Yi(e,t){return e.dir===t.dir&&e.field.isEqual(t.field)}class Xi{}class Ji extends Xi{constructor(e,t,n){super(),this.field=e,this.op=t,this.value=n}static create(e,t,n){return e.isKeyField()?"in"===t||"not-in"===t?this.createKeyFieldInFilter(e,t,n):new oo(e,t,n):"array-contains"===t?new uo(e,n):"in"===t?new ho(e,n):"not-in"===t?new po(e,n):"array-contains-any"===t?new fo(e,n):new Ji(e,t,n)}static createKeyFieldInFilter(e,t,n){return"in"===t?new ao(e,n):new lo(e,n)}matches(e){const t=e.data.field(this.field);return"!="===this.op?null!==t&&this.matchesComparison(ki(t,this.value)):null!==t&&xi(this.value)===xi(t)&&this.matchesComparison(ki(t,this.value))}matchesComparison(e){switch(this.op){case"<":return e<0;case"<=":return e<=0;case"==":return 0===e;case"!=":return 0!==e;case">":return e>0;case">=":return e>=0;default:return hs()}}isInequality(){return["<","<=",">",">=","!=","not-in"].indexOf(this.op)>=0}getFlattenedFilters(){return[this]}getFilters(){return[this]}}class Zi extends Xi{constructor(e,t){super(),this.filters=e,this.op=t,this.ae=null}static create(e,t){return new Zi(e,t)}matches(e){return eo(this)?void 0===this.filters.find((t=>!t.matches(e))):void 0!==this.filters.find((t=>t.matches(e)))}getFlattenedFilters(){return null!==this.ae||(this.ae=this.filters.reduce(((e,t)=>e.concat(t.getFlattenedFilters())),[])),this.ae}getFilters(){return Object.assign([],this.filters)}}function eo(e){return"and"===e.op}function to(e){return no(e)&&eo(e)}function no(e){for(const t of e.filters)if(t instanceof Zi)return!1;return!0}function ro(e){if(e instanceof Ji)return e.field.canonicalString()+e.op.toString()+Di(e.value);if(to(e))return e.filters.map((e=>ro(e))).join(",");{const t=e.filters.map((e=>ro(e))).join(",");return`${e.op}(${t})`}}function so(e,t){return e instanceof Ji?function(e,t){return t instanceof Ji&&e.op===t.op&&e.field.isEqual(t.field)&&Ai(e.value,t.value)}(e,t):e instanceof Zi?function(e,t){return t instanceof Zi&&e.op===t.op&&e.filters.length===t.filters.length&&e.filters.reduce(((e,n,r)=>e&&so(n,t.filters[r])),!0)}(e,t):void hs()}function io(e){return e instanceof Ji?function(e){return`${e.field.canonicalString()} ${e.op} ${Di(e.value)}`}(e):e instanceof Zi?function(e){return e.op.toString()+" {"+e.getFilters().map(io).join(" ,")+"}"}(e):"Filter"}class oo extends Ji{constructor(e,t,n){super(e,t,n),this.key=qs.fromName(n.referenceValue)}matches(e){const t=qs.comparator(e.key,this.key);return this.matchesComparison(t)}}class ao extends Ji{constructor(e,t){super(e,"in",t),this.keys=co("in",t)}matches(e){return this.keys.some((t=>t.isEqual(e.key)))}}class lo extends Ji{constructor(e,t){super(e,"not-in",t),this.keys=co("not-in",t)}matches(e){return!this.keys.some((t=>t.isEqual(e.key)))}}function co(e,t){var n;return((null===(n=t.arrayValue)||void 0===n?void 0:n.values)||[]).map((e=>qs.fromName(e.referenceValue)))}class uo extends Ji{constructor(e,t){super(e,"array-contains",t)}matches(e){const t=e.data.field(this.field);return qi(t)&&Ii(t.arrayValue,this.value)}}class ho extends Ji{constructor(e,t){super(e,"in",t)}matches(e){const t=e.data.field(this.field);return null!==t&&Ii(this.value.arrayValue,t)}}class po extends Ji{constructor(e,t){super(e,"not-in",t)}matches(e){if(Ii(this.value.arrayValue,{nullValue:"NULL_VALUE"}))return!1;const t=e.data.field(this.field);return null!==t&&!Ii(this.value.arrayValue,t)}}class fo extends Ji{constructor(e,t){super(e,"array-contains-any",t)}matches(e){const t=e.data.field(this.field);return!(!qi(t)||!t.arrayValue.values)&&t.arrayValue.values.some((e=>Ii(this.value.arrayValue,e)))}}class mo{constructor(e,t=null,n=[],r=[],s=null,i=null,o=null){this.path=e,this.collectionGroup=t,this.orderBy=n,this.filters=r,this.limit=s,this.startAt=i,this.endAt=o,this.ue=null}}function go(e,t=null,n=[],r=[],s=null,i=null,o=null){return new mo(e,t,n,r,s,i,o)}function yo(e){const t=fs(e);if(null===t.ue){let e=t.path.canonicalString();null!==t.collectionGroup&&(e+="|cg:"+t.collectionGroup),e+="|f:",e+=t.filters.map((e=>ro(e))).join(","),e+="|ob:",e+=t.orderBy.map((e=>function(e){return e.field.canonicalString()+e.dir}(e))).join(","),Qs(t.limit)||(e+="|l:",e+=t.limit),t.startAt&&(e+="|lb:",e+=t.startAt.inclusive?"b:":"a:",e+=t.startAt.position.map((e=>Di(e))).join(",")),t.endAt&&(e+="|ub:",e+=t.endAt.inclusive?"a:":"b:",e+=t.endAt.position.map((e=>Di(e))).join(",")),t.ue=e}return t.ue}function vo(e,t){if(e.limit!==t.limit)return!1;if(e.orderBy.length!==t.orderBy.length)return!1;for(let n=0;n<e.orderBy.length;n++)if(!Yi(e.orderBy[n],t.orderBy[n]))return!1;if(e.filters.length!==t.filters.length)return!1;for(let n=0;n<e.filters.length;n++)if(!so(e.filters[n],t.filters[n]))return!1;return e.collectionGroup===t.collectionGroup&&!!e.path.isEqual(t.path)&&!!Ki(e.startAt,t.startAt)&&Ki(e.endAt,t.endAt)}function wo(e){return qs.isDocumentKey(e.path)&&null===e.collectionGroup&&0===e.filters.length}class bo{constructor(e,t=null,n=[],r=[],s=null,i="F",o=null,a=null){this.path=e,this.collectionGroup=t,this.explicitOrderBy=n,this.filters=r,this.limit=s,this.limitType=i,this.startAt=o,this.endAt=a,this.ce=null,this.le=null,this.he=null,this.startAt,this.endAt}}function So(e,t,n,r,s,i,o,a){return new bo(e,t,n,r,s,i,o,a)}function Eo(e){return new bo(e)}function To(e){return 0===e.filters.length&&null===e.limit&&null==e.startAt&&null==e.endAt&&(0===e.explicitOrderBy.length||1===e.explicitOrderBy.length&&e.explicitOrderBy[0].field.isKeyField())}function _o(e){return null!==e.collectionGroup}function Co(e){const t=fs(e);if(null===t.ce){t.ce=[];const e=new Set;for(const n of t.explicitOrderBy)t.ce.push(n),e.add(n.field.canonicalString());const n=t.explicitOrderBy.length>0?t.explicitOrderBy[t.explicitOrderBy.length-1].dir:"asc",r=function(e){let t=new di(Os.comparator);return e.filters.forEach((e=>{e.getFlattenedFilters().forEach((e=>{e.isInequality()&&(t=t.add(e.field))}))})),t}(t);r.forEach((r=>{e.has(r.canonicalString())||r.isKeyField()||t.ce.push(new Qi(r,n))})),e.has(Os.keyField().canonicalString())||t.ce.push(new Qi(Os.keyField(),n))}return t.ce}function xo(e){const t=fs(e);return t.le||(t.le=Ao(t,Co(e))),t.le}function Ao(e,t){if("F"===e.limitType)return go(e.path,e.collectionGroup,t,e.filters,e.limit,e.startAt,e.endAt);{t=t.map((e=>{const t="desc"===e.dir?"asc":"desc";return new Qi(e.field,t)}));const n=e.endAt?new Hi(e.endAt.position,e.endAt.inclusive):null,r=e.startAt?new Hi(e.startAt.position,e.startAt.inclusive):null;return go(e.path,e.collectionGroup,t,e.filters,e.limit,n,r)}}function Io(e,t,n){return new bo(e.path,e.collectionGroup,e.explicitOrderBy.slice(),e.filters.slice(),t,n,e.startAt,e.endAt)}function ko(e,t){return vo(xo(e),xo(t))&&e.limitType===t.limitType}function Lo(e){return`${yo(xo(e))}|lt:${e.limitType}`}function Mo(e){return`Query(target=${function(e){let t=e.path.canonicalString();return null!==e.collectionGroup&&(t+=" collectionGroup="+e.collectionGroup),e.filters.length>0&&(t+=`, filters: [${e.filters.map((e=>io(e))).join(", ")}]`),Qs(e.limit)||(t+=", limit: "+e.limit),e.orderBy.length>0&&(t+=`, orderBy: [${e.orderBy.map((e=>function(e){return`${e.field.canonicalString()} (${e.dir})`}(e))).join(", ")}]`),e.startAt&&(t+=", startAt: ",t+=e.startAt.inclusive?"b:":"a:",t+=e.startAt.position.map((e=>Di(e))).join(",")),e.endAt&&(t+=", endAt: ",t+=e.endAt.inclusive?"a:":"b:",t+=e.endAt.position.map((e=>Di(e))).join(",")),`Target(${t})`}(xo(e))}; limitType=${e.limitType})`}function Do(e,t){return t.isFoundDocument()&&function(e,t){const n=t.key.path;return null!==e.collectionGroup?t.key.hasCollectionId(e.collectionGroup)&&e.path.isPrefixOf(n):qs.isDocumentKey(e.path)?e.path.isEqual(n):e.path.isImmediateParentOf(n)}(e,t)&&function(e,t){for(const n of Co(e))if(!n.field.isKeyField()&&null===t.data.field(n.field))return!1;return!0}(e,t)&&function(e,t){for(const n of e.filters)if(!n.matches(t))return!1;return!0}(e,t)&&function(e,t){return!(e.startAt&&!function(e,t,n){const r=Wi(e,t,n);return e.inclusive?r<=0:r<0}(e.startAt,Co(e),t))&&!(e.endAt&&!function(e,t,n){const r=Wi(e,t,n);return e.inclusive?r>=0:r>0}(e.endAt,Co(e),t))}(e,t)}function No(e){return e.collectionGroup||(e.path.length%2==1?e.path.lastSegment():e.path.get(e.path.length-2))}function Po(e){return(t,n)=>{let r=!1;for(const s of Co(e)){const e=Oo(s,t,n);if(0!==e)return e;r=r||s.field.isKeyField()}return 0}}function Oo(e,t,n){const r=e.field.isKeyField()?qs.comparator(t.key,n.key):function(e,t,n){const r=t.data.field(e),s=n.data.field(e);return null!==r&&null!==s?ki(r,s):hs()}(e.field,t,n);switch(e.dir){case"asc":return r;case"desc":return-1*r;default:return hs()}}class qo{constructor(e,t){this.mapKeyFn=e,this.equalsFn=t,this.inner={},this.innerSize=0}get(e){const t=this.mapKeyFn(e),n=this.inner[t];if(void 0!==n)for(const[t,r]of n)if(this.equalsFn(t,e))return r}has(e){return void 0!==this.get(e)}set(e,t){const n=this.mapKeyFn(e),r=this.inner[n];if(void 0===r)return this.inner[n]=[[e,t]],void this.innerSize++;for(let n=0;n<r.length;n++)if(this.equalsFn(r[n][0],e))return void(r[n]=[e,t]);r.push([e,t]),this.innerSize++}delete(e){const t=this.mapKeyFn(e),n=this.inner[t];if(void 0===n)return!1;for(let r=0;r<n.length;r++)if(this.equalsFn(n[r][0],e))return 1===n.length?delete this.inner[t]:n.splice(r,1),this.innerSize--,!0;return!1}forEach(e){oi(this.inner,((t,n)=>{for(const[t,r]of n)e(t,r)}))}isEmpty(){return ai(this.inner)}size(){return this.innerSize}}const Ro=new li(qs.comparator);function Fo(){return Ro}const Bo=new li(qs.comparator);function $o(...e){let t=Bo;for(const n of e)t=t.insert(n.key,n);return t}function Vo(e){let t=Bo;return e.forEach(((e,n)=>t=t.insert(e,n.overlayedDocument))),t}function jo(){return Uo()}function zo(){return Uo()}function Uo(){return new qo((e=>e.toString()),((e,t)=>e.isEqual(t)))}const Go=new li(qs.comparator),Ho=new di(qs.comparator);function Wo(...e){let t=Ho;for(const n of e)t=t.add(n);return t}const Ko=new di(Is);function Qo(){return Ko}function Yo(e,t){if(e.useProto3Json){if(isNaN(t))return{doubleValue:"NaN"};if(t===1/0)return{doubleValue:"Infinity"};if(t===-1/0)return{doubleValue:"-Infinity"}}return{doubleValue:Ys(t)?"-0":t}}function Xo(e){return{integerValue:""+e}}function Jo(e,t){return Xs(t)?Xo(t):Yo(e,t)}class Zo{constructor(){this._=void 0}}function ea(e,t,n){return e instanceof ra?function(e,t){const n={fields:{__type__:{stringValue:"server_timestamp"},__local_write_time__:{timestampValue:{seconds:e.seconds,nanos:e.nanoseconds}}}};return t&&bi(t)&&(t=Si(t)),t&&(n.fields.__previous_value__=t),{mapValue:n}}(n,t):e instanceof sa?ia(e,t):e instanceof oa?aa(e,t):function(e,t){const n=na(e,t),r=ca(n)+ca(e.Pe);return Oi(n)&&Oi(e.Pe)?Xo(r):Yo(e.serializer,r)}(e,t)}function ta(e,t,n){return e instanceof sa?ia(e,t):e instanceof oa?aa(e,t):n}function na(e,t){return e instanceof la?function(e){return Oi(e)||function(e){return!!e&&"doubleValue"in e}(e)}(t)?t:{integerValue:0}:null}class ra extends Zo{}class sa extends Zo{constructor(e){super(),this.elements=e}}function ia(e,t){const n=ua(t);for(const t of e.elements)n.some((e=>Ai(e,t)))||n.push(t);return{arrayValue:{values:n}}}class oa extends Zo{constructor(e){super(),this.elements=e}}function aa(e,t){let n=ua(t);for(const t of e.elements)n=n.filter((e=>!Ai(e,t)));return{arrayValue:{values:n}}}class la extends Zo{constructor(e,t){super(),this.serializer=e,this.Pe=t}}function ca(e){return vi(e.integerValue||e.doubleValue)}function ua(e){return qi(e)&&e.arrayValue.values?e.arrayValue.values.slice():[]}class da{constructor(e,t){this.version=e,this.transformResults=t}}class ha{constructor(e,t){this.updateTime=e,this.exists=t}static none(){return new ha}static exists(e){return new ha(void 0,e)}static updateTime(e){return new ha(e)}get isNone(){return void 0===this.updateTime&&void 0===this.exists}isEqual(e){return this.exists===e.exists&&(this.updateTime?!!e.updateTime&&this.updateTime.isEqual(e.updateTime):!e.updateTime)}}function pa(e,t){return void 0!==e.updateTime?t.isFoundDocument()&&t.version.isEqual(e.updateTime):void 0===e.exists||e.exists===t.isFoundDocument()}class fa{}function ma(e,t){if(!e.hasLocalMutations||t&&0===t.fields.length)return null;if(null===t)return e.isNoDocument()?new Ca(e.key,ha.none()):new ba(e.key,e.data,ha.none());{const n=e.data,r=zi.empty();let s=new di(Os.comparator);for(let e of t.fields)if(!s.has(e)){let t=n.field(e);null===t&&e.length>1&&(e=e.popLast(),t=n.field(e)),null===t?r.delete(e):r.set(e,t),s=s.add(e)}return new Sa(e.key,r,new pi(s.toArray()),ha.none())}}function ga(e,t,n){e instanceof ba?function(e,t,n){const r=e.value.clone(),s=Ta(e.fieldTransforms,t,n.transformResults);r.setAll(s),t.convertToFoundDocument(n.version,r).setHasCommittedMutations()}(e,t,n):e instanceof Sa?function(e,t,n){if(!pa(e.precondition,t))return void t.convertToUnknownDocument(n.version);const r=Ta(e.fieldTransforms,t,n.transformResults),s=t.data;s.setAll(Ea(e)),s.setAll(r),t.convertToFoundDocument(n.version,s).setHasCommittedMutations()}(e,t,n):function(e,t,n){t.convertToNoDocument(n.version).setHasCommittedMutations()}(0,t,n)}function ya(e,t,n,r){return e instanceof ba?function(e,t,n,r){if(!pa(e.precondition,t))return n;const s=e.value.clone(),i=_a(e.fieldTransforms,r,t);return s.setAll(i),t.convertToFoundDocument(t.version,s).setHasLocalMutations(),null}(e,t,n,r):e instanceof Sa?function(e,t,n,r){if(!pa(e.precondition,t))return n;const s=_a(e.fieldTransforms,r,t),i=t.data;return i.setAll(Ea(e)),i.setAll(s),t.convertToFoundDocument(t.version,i).setHasLocalMutations(),null===n?null:n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e=>e.field)))}(e,t,n,r):function(e,t,n){return pa(e.precondition,t)?(t.convertToNoDocument(t.version).setHasLocalMutations(),null):n}(e,t,n)}function va(e,t){let n=null;for(const r of e.fieldTransforms){const e=t.data.field(r.field),s=na(r.transform,e||null);null!=s&&(null===n&&(n=zi.empty()),n.set(r.field,s))}return n||null}function wa(e,t){return e.type===t.type&&!!e.key.isEqual(t.key)&&!!e.precondition.isEqual(t.precondition)&&!!function(e,t){return void 0===e&&void 0===t||!(!e||!t)&&ks(e,t,((e,t)=>function(e,t){return e.field.isEqual(t.field)&&function(e,t){return e instanceof sa&&t instanceof sa||e instanceof oa&&t instanceof oa?ks(e.elements,t.elements,Ai):e instanceof la&&t instanceof la?Ai(e.Pe,t.Pe):e instanceof ra&&t instanceof ra}(e.transform,t.transform)}(e,t)))}(e.fieldTransforms,t.fieldTransforms)&&(0===e.type?e.value.isEqual(t.value):1!==e.type||e.data.isEqual(t.data)&&e.fieldMask.isEqual(t.fieldMask))}class ba extends fa{constructor(e,t,n,r=[]){super(),this.key=e,this.value=t,this.precondition=n,this.fieldTransforms=r,this.type=0}getFieldMask(){return null}}class Sa extends fa{constructor(e,t,n,r,s=[]){super(),this.key=e,this.data=t,this.fieldMask=n,this.precondition=r,this.fieldTransforms=s,this.type=1}getFieldMask(){return this.fieldMask}}function Ea(e){const t=new Map;return e.fieldMask.fields.forEach((n=>{if(!n.isEmpty()){const r=e.data.field(n);t.set(n,r)}})),t}function Ta(e,t,n){const r=new Map;ps(e.length===n.length);for(let s=0;s<n.length;s++){const i=e[s],o=i.transform,a=t.data.field(i.field);r.set(i.field,ta(o,a,n[s]))}return r}function _a(e,t,n){const r=new Map;for(const s of e){const e=s.transform,i=n.data.field(s.field);r.set(s.field,ea(e,i,t))}return r}class Ca extends fa{constructor(e,t){super(),this.key=e,this.precondition=t,this.type=2,this.fieldTransforms=[]}getFieldMask(){return null}}class xa extends fa{constructor(e,t){super(),this.key=e,this.precondition=t,this.type=3,this.fieldTransforms=[]}getFieldMask(){return null}}class Aa{constructor(e,t,n,r){this.batchId=e,this.localWriteTime=t,this.baseMutations=n,this.mutations=r}applyToRemoteDocument(e,t){const n=t.mutationResults;for(let t=0;t<this.mutations.length;t++){const r=this.mutations[t];r.key.isEqual(e.key)&&ga(r,e,n[t])}}applyToLocalView(e,t){for(const n of this.baseMutations)n.key.isEqual(e.key)&&(t=ya(n,e,t,this.localWriteTime));for(const n of this.mutations)n.key.isEqual(e.key)&&(t=ya(n,e,t,this.localWriteTime));return t}applyToLocalDocumentSet(e,t){const n=zo();return this.mutations.forEach((r=>{const s=e.get(r.key),i=s.overlayedDocument;let o=this.applyToLocalView(i,s.mutatedFields);o=t.has(r.key)?null:o;const a=ma(i,o);null!==a&&n.set(r.key,a),i.isValidDocument()||i.convertToNoDocument(Ms.min())})),n}keys(){return this.mutations.reduce(((e,t)=>e.add(t.key)),Wo())}isEqual(e){return this.batchId===e.batchId&&ks(this.mutations,e.mutations,((e,t)=>wa(e,t)))&&ks(this.baseMutations,e.baseMutations,((e,t)=>wa(e,t)))}}class Ia{constructor(e,t,n,r){this.batch=e,this.commitVersion=t,this.mutationResults=n,this.docVersions=r}static from(e,t,n){ps(e.mutations.length===n.length);let r=Go;const s=e.mutations;for(let e=0;e<s.length;e++)r=r.insert(s[e].key,n[e].version);return new Ia(e,t,n,r)}}class ka{constructor(e,t){this.largestBatchId=e,this.mutation=t}getKey(){return this.mutation.key}isEqual(e){return null!==e&&this.mutation===e.mutation}toString(){return`Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`}}class La{constructor(e,t){this.count=e,this.unchangedNames=t}}var Ma,Da;function Na(e){switch(e){default:return hs();case ms.CANCELLED:case ms.UNKNOWN:case ms.DEADLINE_EXCEEDED:case ms.RESOURCE_EXHAUSTED:case ms.INTERNAL:case ms.UNAVAILABLE:case ms.UNAUTHENTICATED:return!1;case ms.INVALID_ARGUMENT:case ms.NOT_FOUND:case ms.ALREADY_EXISTS:case ms.PERMISSION_DENIED:case ms.FAILED_PRECONDITION:case ms.ABORTED:case ms.OUT_OF_RANGE:case ms.UNIMPLEMENTED:case ms.DATA_LOSS:return!0}}function Pa(e){if(void 0===e)return cs("GRPC error has no .code"),ms.UNKNOWN;switch(e){case Ma.OK:return ms.OK;case Ma.CANCELLED:return ms.CANCELLED;case Ma.UNKNOWN:return ms.UNKNOWN;case Ma.DEADLINE_EXCEEDED:return ms.DEADLINE_EXCEEDED;case Ma.RESOURCE_EXHAUSTED:return ms.RESOURCE_EXHAUSTED;case Ma.INTERNAL:return ms.INTERNAL;case Ma.UNAVAILABLE:return ms.UNAVAILABLE;case Ma.UNAUTHENTICATED:return ms.UNAUTHENTICATED;case Ma.INVALID_ARGUMENT:return ms.INVALID_ARGUMENT;case Ma.NOT_FOUND:return ms.NOT_FOUND;case Ma.ALREADY_EXISTS:return ms.ALREADY_EXISTS;case Ma.PERMISSION_DENIED:return ms.PERMISSION_DENIED;case Ma.FAILED_PRECONDITION:return ms.FAILED_PRECONDITION;case Ma.ABORTED:return ms.ABORTED;case Ma.OUT_OF_RANGE:return ms.OUT_OF_RANGE;case Ma.UNIMPLEMENTED:return ms.UNIMPLEMENTED;case Ma.DATA_LOSS:return ms.DATA_LOSS;default:return hs()}}(Da=Ma||(Ma={}))[Da.OK=0]="OK",Da[Da.CANCELLED=1]="CANCELLED",Da[Da.UNKNOWN=2]="UNKNOWN",Da[Da.INVALID_ARGUMENT=3]="INVALID_ARGUMENT",Da[Da.DEADLINE_EXCEEDED=4]="DEADLINE_EXCEEDED",Da[Da.NOT_FOUND=5]="NOT_FOUND",Da[Da.ALREADY_EXISTS=6]="ALREADY_EXISTS",Da[Da.PERMISSION_DENIED=7]="PERMISSION_DENIED",Da[Da.UNAUTHENTICATED=16]="UNAUTHENTICATED",Da[Da.RESOURCE_EXHAUSTED=8]="RESOURCE_EXHAUSTED",Da[Da.FAILED_PRECONDITION=9]="FAILED_PRECONDITION",Da[Da.ABORTED=10]="ABORTED",Da[Da.OUT_OF_RANGE=11]="OUT_OF_RANGE",Da[Da.UNIMPLEMENTED=12]="UNIMPLEMENTED",Da[Da.INTERNAL=13]="INTERNAL",Da[Da.UNAVAILABLE=14]="UNAVAILABLE",Da[Da.DATA_LOSS=15]="DATA_LOSS";let Oa=null;function qa(){return new TextEncoder}const Ra=new zr([4294967295,4294967295],0);function Fa(e){const t=qa().encode(e),n=new Ur;return n.update(t),new Uint8Array(n.digest())}function Ba(e){const t=new DataView(e.buffer),n=t.getUint32(0,!0),r=t.getUint32(4,!0),s=t.getUint32(8,!0),i=t.getUint32(12,!0);return[new zr([n,r],0),new zr([s,i],0)]}class $a{constructor(e,t,n){if(this.bitmap=e,this.padding=t,this.hashCount=n,t<0||t>=8)throw new Va(`Invalid padding: ${t}`);if(n<0)throw new Va(`Invalid hash count: ${n}`);if(e.length>0&&0===this.hashCount)throw new Va(`Invalid hash count: ${n}`);if(0===e.length&&0!==t)throw new Va(`Invalid padding when bitmap length is 0: ${t}`);this.Te=8*e.length-t,this.Ie=zr.fromNumber(this.Te)}de(e,t,n){let r=e.add(t.multiply(zr.fromNumber(n)));return 1===r.compare(Ra)&&(r=new zr([r.getBits(0),r.getBits(1)],0)),r.modulo(this.Ie).toNumber()}Ee(e){return 0!=(this.bitmap[Math.floor(e/8)]&1<<e%8)}mightContain(e){if(0===this.Te)return!1;const t=Fa(e),[n,r]=Ba(t);for(let e=0;e<this.hashCount;e++){const t=this.de(n,r,e);if(!this.Ee(t))return!1}return!0}static create(e,t,n){const r=e%8==0?0:8-e%8,s=new Uint8Array(Math.ceil(e/8)),i=new $a(s,r,t);return n.forEach((e=>i.insert(e))),i}insert(e){if(0===this.Te)return;const t=Fa(e),[n,r]=Ba(t);for(let e=0;e<this.hashCount;e++){const t=this.de(n,r,e);this.Ae(t)}}Ae(e){const t=Math.floor(e/8),n=e%8;this.bitmap[t]|=1<<n}}class Va extends Error{constructor(){super(...arguments),this.name="BloomFilterError"}}class ja{constructor(e,t,n,r,s){this.snapshotVersion=e,this.targetChanges=t,this.targetMismatches=n,this.documentUpdates=r,this.resolvedLimboDocuments=s}static createSynthesizedRemoteEventForCurrentChange(e,t,n){const r=new Map;return r.set(e,za.createSynthesizedTargetChangeForCurrentChange(e,t,n)),new ja(Ms.min(),r,new li(Is),Fo(),Wo())}}class za{constructor(e,t,n,r,s){this.resumeToken=e,this.current=t,this.addedDocuments=n,this.modifiedDocuments=r,this.removedDocuments=s}static createSynthesizedTargetChangeForCurrentChange(e,t,n){return new za(n,t,Wo(),Wo(),Wo())}}class Ua{constructor(e,t,n,r){this.Re=e,this.removedTargetIds=t,this.key=n,this.Ve=r}}class Ga{constructor(e,t){this.targetId=e,this.me=t}}class Ha{constructor(e,t,n=mi.EMPTY_BYTE_STRING,r=null){this.state=e,this.targetIds=t,this.resumeToken=n,this.cause=r}}class Wa{constructor(){this.fe=0,this.ge=Ya(),this.pe=mi.EMPTY_BYTE_STRING,this.ye=!1,this.we=!0}get current(){return this.ye}get resumeToken(){return this.pe}get Se(){return 0!==this.fe}get be(){return this.we}De(e){e.approximateByteSize()>0&&(this.we=!0,this.pe=e)}ve(){let e=Wo(),t=Wo(),n=Wo();return this.ge.forEach(((r,s)=>{switch(s){case 0:e=e.add(r);break;case 2:t=t.add(r);break;case 1:n=n.add(r);break;default:hs()}})),new za(this.pe,this.ye,e,t,n)}Ce(){this.we=!1,this.ge=Ya()}Fe(e,t){this.we=!0,this.ge=this.ge.insert(e,t)}Me(e){this.we=!0,this.ge=this.ge.remove(e)}xe(){this.fe+=1}Oe(){this.fe-=1,ps(this.fe>=0)}Ne(){this.we=!0,this.ye=!0}}class Ka{constructor(e){this.Be=e,this.Le=new Map,this.ke=Fo(),this.qe=Qa(),this.Qe=Qa(),this.Ke=new li(Is)}$e(e){for(const t of e.Re)e.Ve&&e.Ve.isFoundDocument()?this.Ue(t,e.Ve):this.We(t,e.key,e.Ve);for(const t of e.removedTargetIds)this.We(t,e.key,e.Ve)}Ge(e){this.forEachTarget(e,(t=>{const n=this.ze(t);switch(e.state){case 0:this.je(t)&&n.De(e.resumeToken);break;case 1:n.Oe(),n.Se||n.Ce(),n.De(e.resumeToken);break;case 2:n.Oe(),n.Se||this.removeTarget(t);break;case 3:this.je(t)&&(n.Ne(),n.De(e.resumeToken));break;case 4:this.je(t)&&(this.He(t),n.De(e.resumeToken));break;default:hs()}}))}forEachTarget(e,t){e.targetIds.length>0?e.targetIds.forEach(t):this.Le.forEach(((e,n)=>{this.je(n)&&t(n)}))}Je(e){const t=e.targetId,n=e.me.count,r=this.Ye(t);if(r){const s=r.target;if(wo(s))if(0===n){const e=new qs(s.path);this.We(t,e,Gi.newNoDocument(e,Ms.min()))}else ps(1===n);else{const r=this.Ze(t);if(r!==n){const n=this.Xe(e),s=n?this.et(n,e,r):1;if(0!==s){this.He(t);const e=2===s?"TargetPurposeExistenceFilterMismatchBloom":"TargetPurposeExistenceFilterMismatch";this.Ke=this.Ke.insert(t,e)}null==Oa||Oa.tt(function(e,t,n,r,s){var i,o,a,l,c,u;const d={localCacheCount:e,existenceFilterCount:t.count,databaseId:n.database,projectId:n.projectId},h=t.unchangedNames;return h&&(d.bloomFilter={applied:0===s,hashCount:null!==(i=null==h?void 0:h.hashCount)&&void 0!==i?i:0,bitmapLength:null!==(l=null===(a=null===(o=null==h?void 0:h.bits)||void 0===o?void 0:o.bitmap)||void 0===a?void 0:a.length)&&void 0!==l?l:0,padding:null!==(u=null===(c=null==h?void 0:h.bits)||void 0===c?void 0:c.padding)&&void 0!==u?u:0,mightContain:e=>{var t;return null!==(t=null==r?void 0:r.mightContain(e))&&void 0!==t&&t}}),d}(r,e.me,this.Be.nt(),n,s))}}}}Xe(e){const t=e.me.unchangedNames;if(!t||!t.bits)return null;const{bits:{bitmap:n="",padding:r=0},hashCount:s=0}=t;let i,o;try{i=wi(n).toUint8Array()}catch(e){if(e instanceof fi)return us("Decoding the base64 bloom filter in existence filter failed ("+e.message+"); ignoring the bloom filter and falling back to full re-query."),null;throw e}try{o=new $a(i,r,s)}catch(e){return us(e instanceof Va?"BloomFilter error: ":"Applying bloom filter failed: ",e),null}return 0===o.Te?null:o}et(e,t,n){return t.me.count===n-this.rt(e,t.targetId)?0:2}rt(e,t){const n=this.Be.getRemoteKeysForTarget(t);let r=0;return n.forEach((n=>{const s=this.Be.nt(),i=`projects/${s.projectId}/databases/${s.database}/documents/${n.path.canonicalString()}`;e.mightContain(i)||(this.We(t,n,null),r++)})),r}it(e){const t=new Map;this.Le.forEach(((n,r)=>{const s=this.Ye(r);if(s){if(n.current&&wo(s.target)){const t=new qs(s.target.path);this.st(t).has(r)||this.ot(r,t)||this.We(r,t,Gi.newNoDocument(t,e))}n.be&&(t.set(r,n.ve()),n.Ce())}}));let n=Wo();this.Qe.forEach(((e,t)=>{let r=!0;t.forEachWhile((e=>{const t=this.Ye(e);return!t||"TargetPurposeLimboResolution"===t.purpose||(r=!1,!1)})),r&&(n=n.add(e))})),this.ke.forEach(((t,n)=>n.setReadTime(e)));const r=new ja(e,t,this.Ke,this.ke,n);return this.ke=Fo(),this.qe=Qa(),this.Qe=Qa(),this.Ke=new li(Is),r}Ue(e,t){if(!this.je(e))return;const n=this.ot(e,t.key)?2:0;this.ze(e).Fe(t.key,n),this.ke=this.ke.insert(t.key,t),this.qe=this.qe.insert(t.key,this.st(t.key).add(e)),this.Qe=this.Qe.insert(t.key,this._t(t.key).add(e))}We(e,t,n){if(!this.je(e))return;const r=this.ze(e);this.ot(e,t)?r.Fe(t,1):r.Me(t),this.Qe=this.Qe.insert(t,this._t(t).delete(e)),this.Qe=this.Qe.insert(t,this._t(t).add(e)),n&&(this.ke=this.ke.insert(t,n))}removeTarget(e){this.Le.delete(e)}Ze(e){const t=this.ze(e).ve();return this.Be.getRemoteKeysForTarget(e).size+t.addedDocuments.size-t.removedDocuments.size}xe(e){this.ze(e).xe()}ze(e){let t=this.Le.get(e);return t||(t=new Wa,this.Le.set(e,t)),t}_t(e){let t=this.Qe.get(e);return t||(t=new di(Is),this.Qe=this.Qe.insert(e,t)),t}st(e){let t=this.qe.get(e);return t||(t=new di(Is),this.qe=this.qe.insert(e,t)),t}je(e){const t=null!==this.Ye(e);return t||ls("WatchChangeAggregator","Detected inactive target",e),t}Ye(e){const t=this.Le.get(e);return t&&t.Se?null:this.Be.ut(e)}He(e){this.Le.set(e,new Wa),this.Be.getRemoteKeysForTarget(e).forEach((t=>{this.We(e,t,null)}))}ot(e,t){return this.Be.getRemoteKeysForTarget(e).has(t)}}function Qa(){return new li(qs.comparator)}function Ya(){return new li(qs.comparator)}const Xa={asc:"ASCENDING",desc:"DESCENDING"},Ja={"<":"LESS_THAN","<=":"LESS_THAN_OR_EQUAL",">":"GREATER_THAN",">=":"GREATER_THAN_OR_EQUAL","==":"EQUAL","!=":"NOT_EQUAL","array-contains":"ARRAY_CONTAINS",in:"IN","not-in":"NOT_IN","array-contains-any":"ARRAY_CONTAINS_ANY"},Za={and:"AND",or:"OR"};class el{constructor(e,t){this.databaseId=e,this.useProto3Json=t}}function tl(e,t){return e.useProto3Json||Qs(t)?t:{value:t}}function nl(e,t){return e.useProto3Json?`${new Date(1e3*t.seconds).toISOString().replace(/\.\d*/,"").replace("Z","")}.${("000000000"+t.nanoseconds).slice(-9)}Z`:{seconds:""+t.seconds,nanos:t.nanoseconds}}function rl(e,t){return e.useProto3Json?t.toBase64():t.toUint8Array()}function sl(e,t){return nl(e,t.toTimestamp())}function il(e){return ps(!!e),Ms.fromTimestamp(function(e){const t=yi(e);return new Ls(t.seconds,t.nanos)}(e))}function ol(e,t){return al(e,t).canonicalString()}function al(e,t){const n=function(e){return new Ns(["projects",e.projectId,"databases",e.database])}(e).child("documents");return void 0===t?n:n.child(t)}function ll(e){const t=Ns.fromString(e);return ps(Il(t)),t}function cl(e,t){return ol(e.databaseId,t.path)}function ul(e,t){const n=ll(t);if(n.get(1)!==e.databaseId.projectId)throw new gs(ms.INVALID_ARGUMENT,"Tried to deserialize key from different project: "+n.get(1)+" vs "+e.databaseId.projectId);if(n.get(3)!==e.databaseId.database)throw new gs(ms.INVALID_ARGUMENT,"Tried to deserialize key from different database: "+n.get(3)+" vs "+e.databaseId.database);return new qs(fl(n))}function dl(e,t){return ol(e.databaseId,t)}function hl(e){const t=ll(e);return 4===t.length?Ns.emptyPath():fl(t)}function pl(e){return new Ns(["projects",e.databaseId.projectId,"databases",e.databaseId.database]).canonicalString()}function fl(e){return ps(e.length>4&&"documents"===e.get(4)),e.popFirst(5)}function ml(e,t,n){return{name:cl(e,t),fields:n.value.mapValue.fields}}function gl(e,t){let n;if(t instanceof ba)n={update:ml(e,t.key,t.value)};else if(t instanceof Ca)n={delete:cl(e,t.key)};else if(t instanceof Sa)n={update:ml(e,t.key,t.data),updateMask:Al(t.fieldMask)};else{if(!(t instanceof xa))return hs();n={verify:cl(e,t.key)}}return t.fieldTransforms.length>0&&(n.updateTransforms=t.fieldTransforms.map((e=>function(e,t){const n=t.transform;if(n instanceof ra)return{fieldPath:t.field.canonicalString(),setToServerValue:"REQUEST_TIME"};if(n instanceof sa)return{fieldPath:t.field.canonicalString(),appendMissingElements:{values:n.elements}};if(n instanceof oa)return{fieldPath:t.field.canonicalString(),removeAllFromArray:{values:n.elements}};if(n instanceof la)return{fieldPath:t.field.canonicalString(),increment:n.Pe};throw hs()}(0,e)))),t.precondition.isNone||(n.currentDocument=function(e,t){return void 0!==t.updateTime?{updateTime:sl(e,t.updateTime)}:void 0!==t.exists?{exists:t.exists}:hs()}(e,t.precondition)),n}function yl(e,t){return{documents:[dl(e,t.path)]}}function vl(e,t){const n={structuredQuery:{}},r=t.path;let s;null!==t.collectionGroup?(s=r,n.structuredQuery.from=[{collectionId:t.collectionGroup,allDescendants:!0}]):(s=r.popLast(),n.structuredQuery.from=[{collectionId:r.lastSegment()}]),n.parent=dl(e,s);const i=function(e){if(0!==e.length)return xl(Zi.create(e,"and"))}(t.filters);i&&(n.structuredQuery.where=i);const o=function(e){if(0!==e.length)return e.map((e=>function(e){return{field:_l(e.field),direction:Sl(e.dir)}}(e)))}(t.orderBy);o&&(n.structuredQuery.orderBy=o);const a=tl(e,t.limit);return null!==a&&(n.structuredQuery.limit=a),t.startAt&&(n.structuredQuery.startAt=function(e){return{before:e.inclusive,values:e.position}}(t.startAt)),t.endAt&&(n.structuredQuery.endAt=function(e){return{before:!e.inclusive,values:e.position}}(t.endAt)),{ct:n,parent:s}}function wl(e){let t=hl(e.parent);const n=e.structuredQuery,r=n.from?n.from.length:0;let s=null;if(r>0){ps(1===r);const e=n.from[0];e.allDescendants?s=e.collectionId:t=t.child(e.collectionId)}let i=[];n.where&&(i=function(e){const t=bl(e);return t instanceof Zi&&to(t)?t.getFilters():[t]}(n.where));let o=[];n.orderBy&&(o=function(e){return e.map((e=>function(e){return new Qi(Cl(e.field),function(e){switch(e){case"ASCENDING":return"asc";case"DESCENDING":return"desc";default:return}}(e.direction))}(e)))}(n.orderBy));let a=null;n.limit&&(a=function(e){let t;return t="object"==typeof e?e.value:e,Qs(t)?null:t}(n.limit));let l=null;n.startAt&&(l=function(e){const t=!!e.before,n=e.values||[];return new Hi(n,t)}(n.startAt));let c=null;return n.endAt&&(c=function(e){const t=!e.before,n=e.values||[];return new Hi(n,t)}(n.endAt)),So(t,s,o,i,a,"F",l,c)}function bl(e){return void 0!==e.unaryFilter?function(e){switch(e.unaryFilter.op){case"IS_NAN":const t=Cl(e.unaryFilter.field);return Ji.create(t,"==",{doubleValue:NaN});case"IS_NULL":const n=Cl(e.unaryFilter.field);return Ji.create(n,"==",{nullValue:"NULL_VALUE"});case"IS_NOT_NAN":const r=Cl(e.unaryFilter.field);return Ji.create(r,"!=",{doubleValue:NaN});case"IS_NOT_NULL":const s=Cl(e.unaryFilter.field);return Ji.create(s,"!=",{nullValue:"NULL_VALUE"});default:return hs()}}(e):void 0!==e.fieldFilter?function(e){return Ji.create(Cl(e.fieldFilter.field),function(e){switch(e){case"EQUAL":return"==";case"NOT_EQUAL":return"!=";case"GREATER_THAN":return">";case"GREATER_THAN_OR_EQUAL":return">=";case"LESS_THAN":return"<";case"LESS_THAN_OR_EQUAL":return"<=";case"ARRAY_CONTAINS":return"array-contains";case"IN":return"in";case"NOT_IN":return"not-in";case"ARRAY_CONTAINS_ANY":return"array-contains-any";default:return hs()}}(e.fieldFilter.op),e.fieldFilter.value)}(e):void 0!==e.compositeFilter?function(e){return Zi.create(e.compositeFilter.filters.map((e=>bl(e))),function(e){switch(e){case"AND":return"and";case"OR":return"or";default:return hs()}}(e.compositeFilter.op))}(e):hs()}function Sl(e){return Xa[e]}function El(e){return Ja[e]}function Tl(e){return Za[e]}function _l(e){return{fieldPath:e.canonicalString()}}function Cl(e){return Os.fromServerFormat(e.fieldPath)}function xl(e){return e instanceof Ji?function(e){if("=="===e.op){if(Fi(e.value))return{unaryFilter:{field:_l(e.field),op:"IS_NAN"}};if(Ri(e.value))return{unaryFilter:{field:_l(e.field),op:"IS_NULL"}}}else if("!="===e.op){if(Fi(e.value))return{unaryFilter:{field:_l(e.field),op:"IS_NOT_NAN"}};if(Ri(e.value))return{unaryFilter:{field:_l(e.field),op:"IS_NOT_NULL"}}}return{fieldFilter:{field:_l(e.field),op:El(e.op),value:e.value}}}(e):e instanceof Zi?function(e){const t=e.getFilters().map((e=>xl(e)));return 1===t.length?t[0]:{compositeFilter:{op:Tl(e.op),filters:t}}}(e):hs()}function Al(e){const t=[];return e.fields.forEach((e=>t.push(e.canonicalString()))),{fieldPaths:t}}function Il(e){return e.length>=4&&"projects"===e.get(0)&&"databases"===e.get(2)}class kl{constructor(e,t,n,r,s=Ms.min(),i=Ms.min(),o=mi.EMPTY_BYTE_STRING,a=null){this.target=e,this.targetId=t,this.purpose=n,this.sequenceNumber=r,this.snapshotVersion=s,this.lastLimboFreeSnapshotVersion=i,this.resumeToken=o,this.expectedCount=a}withSequenceNumber(e){return new kl(this.target,this.targetId,this.purpose,e,this.snapshotVersion,this.lastLimboFreeSnapshotVersion,this.resumeToken,this.expectedCount)}withResumeToken(e,t){return new kl(this.target,this.targetId,this.purpose,this.sequenceNumber,t,this.lastLimboFreeSnapshotVersion,e,null)}withExpectedCount(e){return new kl(this.target,this.targetId,this.purpose,this.sequenceNumber,this.snapshotVersion,this.lastLimboFreeSnapshotVersion,this.resumeToken,e)}withLastLimboFreeSnapshotVersion(e){return new kl(this.target,this.targetId,this.purpose,this.sequenceNumber,this.snapshotVersion,e,this.resumeToken,this.expectedCount)}}class Ll{constructor(e){this.ht=e}}function Ml(e){const t=wl({parent:e.parent,structuredQuery:e.structuredQuery});return"LAST"===e.limitType?Io(t,t.limit,"L"):t}class Dl{constructor(){}dt(e,t){this.Et(e,t),t.At()}Et(e,t){if("nullValue"in e)this.Rt(t,5);else if("booleanValue"in e)this.Rt(t,10),t.Vt(e.booleanValue?1:0);else if("integerValue"in e)this.Rt(t,15),t.Vt(vi(e.integerValue));else if("doubleValue"in e){const n=vi(e.doubleValue);isNaN(n)?this.Rt(t,13):(this.Rt(t,15),Ys(n)?t.Vt(0):t.Vt(n))}else if("timestampValue"in e){let n=e.timestampValue;this.Rt(t,20),"string"==typeof n&&(n=yi(n)),t.ft(`${n.seconds||""}`),t.Vt(n.nanos||0)}else if("stringValue"in e)this.gt(e.stringValue,t),this.yt(t);else if("bytesValue"in e)this.Rt(t,30),t.wt(wi(e.bytesValue)),this.yt(t);else if("referenceValue"in e)this.St(e.referenceValue,t);else if("geoPointValue"in e){const n=e.geoPointValue;this.Rt(t,45),t.Vt(n.latitude||0),t.Vt(n.longitude||0)}else"mapValue"in e?ji(e)?this.Rt(t,Number.MAX_SAFE_INTEGER):$i(e)?this.bt(e.mapValue,t):(this.Dt(e.mapValue,t),this.yt(t)):"arrayValue"in e?(this.vt(e.arrayValue,t),this.yt(t)):hs()}gt(e,t){this.Rt(t,25),this.Ct(e,t)}Ct(e,t){t.ft(e)}Dt(e,t){const n=e.fields||{};this.Rt(t,55);for(const e of Object.keys(n))this.gt(e,t),this.Et(n[e],t)}bt(e,t){var n,r;const s=e.fields||{};this.Rt(t,53);const i="value",o=(null===(r=null===(n=s[i].arrayValue)||void 0===n?void 0:n.values)||void 0===r?void 0:r.length)||0;this.Rt(t,15),t.Vt(vi(o)),this.gt(i,t),this.Et(s[i],t)}vt(e,t){const n=e.values||[];this.Rt(t,50);for(const e of n)this.Et(e,t)}St(e,t){this.Rt(t,37),qs.fromName(e).path.forEach((e=>{this.Rt(t,60),this.Ct(e,t)}))}Rt(e,t){e.Vt(t)}yt(e){e.Vt(2)}}Dl.Ft=new Dl;class Nl{constructor(){this.ln=new Pl}addToCollectionParentIndex(e,t){return this.ln.add(t),Gs.resolve()}getCollectionParents(e,t){return Gs.resolve(this.ln.getEntries(t))}addFieldIndex(e,t){return Gs.resolve()}deleteFieldIndex(e,t){return Gs.resolve()}deleteAllFieldIndexes(e){return Gs.resolve()}createTargetIndexes(e,t){return Gs.resolve()}getDocumentsMatchingTarget(e,t){return Gs.resolve(null)}getIndexType(e,t){return Gs.resolve(0)}getFieldIndexes(e,t){return Gs.resolve([])}getNextCollectionGroupToUpdate(e){return Gs.resolve(null)}getMinOffset(e,t){return Gs.resolve($s.min())}getMinOffsetFromCollectionGroup(e,t){return Gs.resolve($s.min())}updateCollectionGroup(e,t,n){return Gs.resolve()}updateIndexEntries(e,t){return Gs.resolve()}}class Pl{constructor(){this.index={}}add(e){const t=e.lastSegment(),n=e.popLast(),r=this.index[t]||new di(Ns.comparator),s=!r.has(n);return this.index[t]=r.add(n),s}has(e){const t=e.lastSegment(),n=e.popLast(),r=this.index[t];return r&&r.has(n)}getEntries(e){return(this.index[e]||new di(Ns.comparator)).toArray()}}new Uint8Array(0);const Ol={didRun:!1,sequenceNumbersCollected:0,targetsRemoved:0,documentsRemoved:0};class ql{static withCacheSize(e){return new ql(e,ql.DEFAULT_COLLECTION_PERCENTILE,ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT)}constructor(e,t,n){this.cacheSizeCollectionThreshold=e,this.percentileToCollect=t,this.maximumSequenceNumbersToCollect=n}}ql.DEFAULT_COLLECTION_PERCENTILE=10,ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT=1e3,ql.DEFAULT=new ql(41943040,ql.DEFAULT_COLLECTION_PERCENTILE,ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT),ql.DISABLED=new ql(-1,0,0);class Rl{constructor(e){this.kn=e}next(){return this.kn+=2,this.kn}static qn(){return new Rl(0)}static Qn(){return new Rl(-1)}}function Fl([e,t],[n,r]){const s=Is(e,n);return 0===s?Is(t,r):s}class Bl{constructor(e){this.Gn=e,this.buffer=new di(Fl),this.zn=0}jn(){return++this.zn}Hn(e){const t=[e,this.jn()];if(this.buffer.size<this.Gn)this.buffer=this.buffer.add(t);else{const e=this.buffer.last();Fl(t,e)<0&&(this.buffer=this.buffer.delete(e).add(t))}}get maxValue(){return this.buffer.last()[0]}}class $l{constructor(e,t,n){this.garbageCollector=e,this.asyncQueue=t,this.localStore=n,this.Jn=null}start(){-1!==this.garbageCollector.params.cacheSizeCollectionThreshold&&this.Yn(6e4)}stop(){this.Jn&&(this.Jn.cancel(),this.Jn=null)}get started(){return null!==this.Jn}Yn(e){ls("LruGarbageCollector",`Garbage collection scheduled in ${e}ms`),this.Jn=this.asyncQueue.enqueueAfterDelay("lru_garbage_collection",e,(async()=>{this.Jn=null;try{await this.localStore.collectGarbage(this.garbageCollector)}catch(e){Ws(e)?ls("LruGarbageCollector","Ignoring IndexedDB error during garbage collection: ",e):await Us(e)}await this.Yn(3e5)}))}}class Vl{constructor(e,t){this.Zn=e,this.params=t}calculateTargetCount(e,t){return this.Zn.Xn(e).next((e=>Math.floor(t/100*e)))}nthSequenceNumber(e,t){if(0===t)return Gs.resolve(Ks.oe);const n=new Bl(t);return this.Zn.forEachTarget(e,(e=>n.Hn(e.sequenceNumber))).next((()=>this.Zn.er(e,(e=>n.Hn(e))))).next((()=>n.maxValue))}removeTargets(e,t,n){return this.Zn.removeTargets(e,t,n)}removeOrphanedDocuments(e,t){return this.Zn.removeOrphanedDocuments(e,t)}collect(e,t){return-1===this.params.cacheSizeCollectionThreshold?(ls("LruGarbageCollector","Garbage collection skipped; disabled"),Gs.resolve(Ol)):this.getCacheSize(e).next((n=>n<this.params.cacheSizeCollectionThreshold?(ls("LruGarbageCollector",`Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`),Ol):this.tr(e,t)))}getCacheSize(e){return this.Zn.getCacheSize(e)}tr(e,t){let n,r,s,i,o,a,l;const c=Date.now();return this.calculateTargetCount(e,this.params.percentileToCollect).next((t=>(t>this.params.maximumSequenceNumbersToCollect?(ls("LruGarbageCollector",`Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`),r=this.params.maximumSequenceNumbersToCollect):r=t,i=Date.now(),this.nthSequenceNumber(e,r)))).next((r=>(n=r,o=Date.now(),this.removeTargets(e,n,t)))).next((t=>(s=t,a=Date.now(),this.removeOrphanedDocuments(e,n)))).next((e=>(l=Date.now(),as()<=Gn.DEBUG&&ls("LruGarbageCollector",`LRU Garbage Collection\n\tCounted targets in ${i-c}ms\n\tDetermined least recently used ${r} in `+(o-i)+"ms\n"+`\tRemoved ${s} targets in `+(a-o)+"ms\n"+`\tRemoved ${e} documents in `+(l-a)+"ms\n"+`Total Duration: ${l-c}ms`),Gs.resolve({didRun:!0,sequenceNumbersCollected:r,targetsRemoved:s,documentsRemoved:e}))))}}function jl(e,t){return new Vl(e,t)}class zl{constructor(){this.changes=new qo((e=>e.toString()),((e,t)=>e.isEqual(t))),this.changesApplied=!1}addEntry(e){this.assertNotApplied(),this.changes.set(e.key,e)}removeEntry(e,t){this.assertNotApplied(),this.changes.set(e,Gi.newInvalidDocument(e).setReadTime(t))}getEntry(e,t){this.assertNotApplied();const n=this.changes.get(t);return void 0!==n?Gs.resolve(n):this.getFromCache(e,t)}getEntries(e,t){return this.getAllFromCache(e,t)}apply(e){return this.assertNotApplied(),this.changesApplied=!0,this.applyChanges(e)}assertNotApplied(){}}class Ul{constructor(e,t){this.overlayedDocument=e,this.mutatedFields=t}}class Gl{constructor(e,t,n,r){this.remoteDocumentCache=e,this.mutationQueue=t,this.documentOverlayCache=n,this.indexManager=r}getDocument(e,t){let n=null;return this.documentOverlayCache.getOverlay(e,t).next((r=>(n=r,this.remoteDocumentCache.getEntry(e,t)))).next((e=>(null!==n&&ya(n.mutation,e,pi.empty(),Ls.now()),e)))}getDocuments(e,t){return this.remoteDocumentCache.getEntries(e,t).next((t=>this.getLocalViewOfDocuments(e,t,Wo()).next((()=>t))))}getLocalViewOfDocuments(e,t,n=Wo()){const r=jo();return this.populateOverlays(e,r,t).next((()=>this.computeViews(e,t,r,n).next((e=>{let t=$o();return e.forEach(((e,n)=>{t=t.insert(e,n.overlayedDocument)})),t}))))}getOverlayedDocuments(e,t){const n=jo();return this.populateOverlays(e,n,t).next((()=>this.computeViews(e,t,n,Wo())))}populateOverlays(e,t,n){const r=[];return n.forEach((e=>{t.has(e)||r.push(e)})),this.documentOverlayCache.getOverlays(e,r).next((e=>{e.forEach(((e,n)=>{t.set(e,n)}))}))}computeViews(e,t,n,r){let s=Fo();const i=Uo(),o=Uo();return t.forEach(((e,t)=>{const o=n.get(t.key);r.has(t.key)&&(void 0===o||o.mutation instanceof Sa)?s=s.insert(t.key,t):void 0!==o?(i.set(t.key,o.mutation.getFieldMask()),ya(o.mutation,t,o.mutation.getFieldMask(),Ls.now())):i.set(t.key,pi.empty())})),this.recalculateAndSaveOverlays(e,s).next((e=>(e.forEach(((e,t)=>i.set(e,t))),t.forEach(((e,t)=>{var n;return o.set(e,new Ul(t,null!==(n=i.get(e))&&void 0!==n?n:null))})),o)))}recalculateAndSaveOverlays(e,t){const n=Uo();let r=new li(((e,t)=>e-t)),s=Wo();return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e,t).next((e=>{for(const s of e)s.keys().forEach((e=>{const i=t.get(e);if(null===i)return;let o=n.get(e)||pi.empty();o=s.applyToLocalView(i,o),n.set(e,o);const a=(r.get(s.batchId)||Wo()).add(e);r=r.insert(s.batchId,a)}))})).next((()=>{const i=[],o=r.getReverseIterator();for(;o.hasNext();){const r=o.getNext(),a=r.key,l=r.value,c=zo();l.forEach((e=>{if(!s.has(e)){const r=ma(t.get(e),n.get(e));null!==r&&c.set(e,r),s=s.add(e)}})),i.push(this.documentOverlayCache.saveOverlays(e,a,c))}return Gs.waitFor(i)})).next((()=>n))}recalculateAndSaveOverlaysForDocumentKeys(e,t){return this.remoteDocumentCache.getEntries(e,t).next((t=>this.recalculateAndSaveOverlays(e,t)))}getDocumentsMatchingQuery(e,t,n,r){return function(e){return qs.isDocumentKey(e.path)&&null===e.collectionGroup&&0===e.filters.length}(t)?this.getDocumentsMatchingDocumentQuery(e,t.path):_o(t)?this.getDocumentsMatchingCollectionGroupQuery(e,t,n,r):this.getDocumentsMatchingCollectionQuery(e,t,n,r)}getNextDocuments(e,t,n,r){return this.remoteDocumentCache.getAllFromCollectionGroup(e,t,n,r).next((s=>{const i=r-s.size>0?this.documentOverlayCache.getOverlaysForCollectionGroup(e,t,n.largestBatchId,r-s.size):Gs.resolve(jo());let o=-1,a=s;return i.next((t=>Gs.forEach(t,((t,n)=>(o<n.largestBatchId&&(o=n.largestBatchId),s.get(t)?Gs.resolve():this.remoteDocumentCache.getEntry(e,t).next((e=>{a=a.insert(t,e)}))))).next((()=>this.populateOverlays(e,t,s))).next((()=>this.computeViews(e,a,t,Wo()))).next((e=>({batchId:o,changes:Vo(e)})))))}))}getDocumentsMatchingDocumentQuery(e,t){return this.getDocument(e,new qs(t)).next((e=>{let t=$o();return e.isFoundDocument()&&(t=t.insert(e.key,e)),t}))}getDocumentsMatchingCollectionGroupQuery(e,t,n,r){const s=t.collectionGroup;let i=$o();return this.indexManager.getCollectionParents(e,s).next((o=>Gs.forEach(o,(o=>{const a=function(e,t){return new bo(t,null,e.explicitOrderBy.slice(),e.filters.slice(),e.limit,e.limitType,e.startAt,e.endAt)}(t,o.child(s));return this.getDocumentsMatchingCollectionQuery(e,a,n,r).next((e=>{e.forEach(((e,t)=>{i=i.insert(e,t)}))}))})).next((()=>i))))}getDocumentsMatchingCollectionQuery(e,t,n,r){let s;return this.documentOverlayCache.getOverlaysForCollection(e,t.path,n.largestBatchId).next((i=>(s=i,this.remoteDocumentCache.getDocumentsMatchingQuery(e,t,n,s,r)))).next((e=>{s.forEach(((t,n)=>{const r=n.getKey();null===e.get(r)&&(e=e.insert(r,Gi.newInvalidDocument(r)))}));let n=$o();return e.forEach(((e,r)=>{const i=s.get(e);void 0!==i&&ya(i.mutation,r,pi.empty(),Ls.now()),Do(t,r)&&(n=n.insert(e,r))})),n}))}}class Hl{constructor(e){this.serializer=e,this.Tr=new Map,this.Ir=new Map}getBundleMetadata(e,t){return Gs.resolve(this.Tr.get(t))}saveBundleMetadata(e,t){return this.Tr.set(t.id,function(e){return{id:e.id,version:e.version,createTime:il(e.createTime)}}(t)),Gs.resolve()}getNamedQuery(e,t){return Gs.resolve(this.Ir.get(t))}saveNamedQuery(e,t){return this.Ir.set(t.name,function(e){return{name:e.name,query:Ml(e.bundledQuery),readTime:il(e.readTime)}}(t)),Gs.resolve()}}class Wl{constructor(){this.overlays=new li(qs.comparator),this.dr=new Map}getOverlay(e,t){return Gs.resolve(this.overlays.get(t))}getOverlays(e,t){const n=jo();return Gs.forEach(t,(t=>this.getOverlay(e,t).next((e=>{null!==e&&n.set(t,e)})))).next((()=>n))}saveOverlays(e,t,n){return n.forEach(((n,r)=>{this.Tt(e,t,r)})),Gs.resolve()}removeOverlaysForBatchId(e,t,n){const r=this.dr.get(n);return void 0!==r&&(r.forEach((e=>this.overlays=this.overlays.remove(e))),this.dr.delete(n)),Gs.resolve()}getOverlaysForCollection(e,t,n){const r=jo(),s=t.length+1,i=new qs(t.child("")),o=this.overlays.getIteratorFrom(i);for(;o.hasNext();){const e=o.getNext().value,i=e.getKey();if(!t.isPrefixOf(i.path))break;i.path.length===s&&e.largestBatchId>n&&r.set(e.getKey(),e)}return Gs.resolve(r)}getOverlaysForCollectionGroup(e,t,n,r){let s=new li(((e,t)=>e-t));const i=this.overlays.getIterator();for(;i.hasNext();){const e=i.getNext().value;if(e.getKey().getCollectionGroup()===t&&e.largestBatchId>n){let t=s.get(e.largestBatchId);null===t&&(t=jo(),s=s.insert(e.largestBatchId,t)),t.set(e.getKey(),e)}}const o=jo(),a=s.getIterator();for(;a.hasNext()&&(a.getNext().value.forEach(((e,t)=>o.set(e,t))),!(o.size()>=r)););return Gs.resolve(o)}Tt(e,t,n){const r=this.overlays.get(n.key);if(null!==r){const e=this.dr.get(r.largestBatchId).delete(n.key);this.dr.set(r.largestBatchId,e)}this.overlays=this.overlays.insert(n.key,new ka(t,n));let s=this.dr.get(t);void 0===s&&(s=Wo(),this.dr.set(t,s)),this.dr.set(t,s.add(n.key))}}class Kl{constructor(){this.sessionToken=mi.EMPTY_BYTE_STRING}getSessionToken(e){return Gs.resolve(this.sessionToken)}setSessionToken(e,t){return this.sessionToken=t,Gs.resolve()}}class Ql{constructor(){this.Er=new di(Yl.Ar),this.Rr=new di(Yl.Vr)}isEmpty(){return this.Er.isEmpty()}addReference(e,t){const n=new Yl(e,t);this.Er=this.Er.add(n),this.Rr=this.Rr.add(n)}mr(e,t){e.forEach((e=>this.addReference(e,t)))}removeReference(e,t){this.gr(new Yl(e,t))}pr(e,t){e.forEach((e=>this.removeReference(e,t)))}yr(e){const t=new qs(new Ns([])),n=new Yl(t,e),r=new Yl(t,e+1),s=[];return this.Rr.forEachInRange([n,r],(e=>{this.gr(e),s.push(e.key)})),s}wr(){this.Er.forEach((e=>this.gr(e)))}gr(e){this.Er=this.Er.delete(e),this.Rr=this.Rr.delete(e)}Sr(e){const t=new qs(new Ns([])),n=new Yl(t,e),r=new Yl(t,e+1);let s=Wo();return this.Rr.forEachInRange([n,r],(e=>{s=s.add(e.key)})),s}containsKey(e){const t=new Yl(e,0),n=this.Er.firstAfterOrEqual(t);return null!==n&&e.isEqual(n.key)}}class Yl{constructor(e,t){this.key=e,this.br=t}static Ar(e,t){return qs.comparator(e.key,t.key)||Is(e.br,t.br)}static Vr(e,t){return Is(e.br,t.br)||qs.comparator(e.key,t.key)}}class Xl{constructor(e,t){this.indexManager=e,this.referenceDelegate=t,this.mutationQueue=[],this.Dr=1,this.vr=new di(Yl.Ar)}checkEmpty(e){return Gs.resolve(0===this.mutationQueue.length)}addMutationBatch(e,t,n,r){const s=this.Dr;this.Dr++,this.mutationQueue.length>0&&this.mutationQueue[this.mutationQueue.length-1];const i=new Aa(s,t,n,r);this.mutationQueue.push(i);for(const t of r)this.vr=this.vr.add(new Yl(t.key,s)),this.indexManager.addToCollectionParentIndex(e,t.key.path.popLast());return Gs.resolve(i)}lookupMutationBatch(e,t){return Gs.resolve(this.Cr(t))}getNextMutationBatchAfterBatchId(e,t){const n=t+1,r=this.Fr(n),s=r<0?0:r;return Gs.resolve(this.mutationQueue.length>s?this.mutationQueue[s]:null)}getHighestUnacknowledgedBatchId(){return Gs.resolve(0===this.mutationQueue.length?-1:this.Dr-1)}getAllMutationBatches(e){return Gs.resolve(this.mutationQueue.slice())}getAllMutationBatchesAffectingDocumentKey(e,t){const n=new Yl(t,0),r=new Yl(t,Number.POSITIVE_INFINITY),s=[];return this.vr.forEachInRange([n,r],(e=>{const t=this.Cr(e.br);s.push(t)})),Gs.resolve(s)}getAllMutationBatchesAffectingDocumentKeys(e,t){let n=new di(Is);return t.forEach((e=>{const t=new Yl(e,0),r=new Yl(e,Number.POSITIVE_INFINITY);this.vr.forEachInRange([t,r],(e=>{n=n.add(e.br)}))})),Gs.resolve(this.Mr(n))}getAllMutationBatchesAffectingQuery(e,t){const n=t.path,r=n.length+1;let s=n;qs.isDocumentKey(s)||(s=s.child(""));const i=new Yl(new qs(s),0);let o=new di(Is);return this.vr.forEachWhile((e=>{const t=e.key.path;return!!n.isPrefixOf(t)&&(t.length===r&&(o=o.add(e.br)),!0)}),i),Gs.resolve(this.Mr(o))}Mr(e){const t=[];return e.forEach((e=>{const n=this.Cr(e);null!==n&&t.push(n)})),t}removeMutationBatch(e,t){ps(0===this.Or(t.batchId,"removed")),this.mutationQueue.shift();let n=this.vr;return Gs.forEach(t.mutations,(r=>{const s=new Yl(r.key,t.batchId);return n=n.delete(s),this.referenceDelegate.markPotentiallyOrphaned(e,r.key)})).next((()=>{this.vr=n}))}Bn(e){}containsKey(e,t){const n=new Yl(t,0),r=this.vr.firstAfterOrEqual(n);return Gs.resolve(t.isEqual(r&&r.key))}performConsistencyCheck(e){return this.mutationQueue.length,Gs.resolve()}Or(e,t){return this.Fr(e)}Fr(e){return 0===this.mutationQueue.length?0:e-this.mutationQueue[0].batchId}Cr(e){const t=this.Fr(e);return t<0||t>=this.mutationQueue.length?null:this.mutationQueue[t]}}class Jl{constructor(e){this.Nr=e,this.docs=new li(qs.comparator),this.size=0}setIndexManager(e){this.indexManager=e}addEntry(e,t){const n=t.key,r=this.docs.get(n),s=r?r.size:0,i=this.Nr(t);return this.docs=this.docs.insert(n,{document:t.mutableCopy(),size:i}),this.size+=i-s,this.indexManager.addToCollectionParentIndex(e,n.path.popLast())}removeEntry(e){const t=this.docs.get(e);t&&(this.docs=this.docs.remove(e),this.size-=t.size)}getEntry(e,t){const n=this.docs.get(t);return Gs.resolve(n?n.document.mutableCopy():Gi.newInvalidDocument(t))}getEntries(e,t){let n=Fo();return t.forEach((e=>{const t=this.docs.get(e);n=n.insert(e,t?t.document.mutableCopy():Gi.newInvalidDocument(e))})),Gs.resolve(n)}getDocumentsMatchingQuery(e,t,n,r){let s=Fo();const i=t.path,o=new qs(i.child("__id-9223372036854775808__")),a=this.docs.getIteratorFrom(o);for(;a.hasNext();){const{key:e,value:{document:o}}=a.getNext();if(!i.isPrefixOf(e.path))break;e.path.length>i.length+1||Vs(Bs(o),n)<=0||(r.has(o.key)||Do(t,o))&&(s=s.insert(o.key,o.mutableCopy()))}return Gs.resolve(s)}getAllFromCollectionGroup(e,t,n,r){hs()}Br(e,t){return Gs.forEach(this.docs,(e=>t(e)))}newChangeBuffer(e){return new Zl(this)}getSize(e){return Gs.resolve(this.size)}}class Zl extends zl{constructor(e){super(),this.hr=e}applyChanges(e){const t=[];return this.changes.forEach(((n,r)=>{r.isValidDocument()?t.push(this.hr.addEntry(e,r)):this.hr.removeEntry(n)})),Gs.waitFor(t)}getFromCache(e,t){return this.hr.getEntry(e,t)}getAllFromCache(e,t){return this.hr.getEntries(e,t)}}class ec{constructor(e){this.persistence=e,this.Lr=new qo((e=>yo(e)),vo),this.lastRemoteSnapshotVersion=Ms.min(),this.highestTargetId=0,this.kr=0,this.qr=new Ql,this.targetCount=0,this.Qr=Rl.qn()}forEachTarget(e,t){return this.Lr.forEach(((e,n)=>t(n))),Gs.resolve()}getLastRemoteSnapshotVersion(e){return Gs.resolve(this.lastRemoteSnapshotVersion)}getHighestSequenceNumber(e){return Gs.resolve(this.kr)}allocateTargetId(e){return this.highestTargetId=this.Qr.next(),Gs.resolve(this.highestTargetId)}setTargetsMetadata(e,t,n){return n&&(this.lastRemoteSnapshotVersion=n),t>this.kr&&(this.kr=t),Gs.resolve()}Un(e){this.Lr.set(e.target,e);const t=e.targetId;t>this.highestTargetId&&(this.Qr=new Rl(t),this.highestTargetId=t),e.sequenceNumber>this.kr&&(this.kr=e.sequenceNumber)}addTargetData(e,t){return this.Un(t),this.targetCount+=1,Gs.resolve()}updateTargetData(e,t){return this.Un(t),Gs.resolve()}removeTargetData(e,t){return this.Lr.delete(t.target),this.qr.yr(t.targetId),this.targetCount-=1,Gs.resolve()}removeTargets(e,t,n){let r=0;const s=[];return this.Lr.forEach(((i,o)=>{o.sequenceNumber<=t&&null===n.get(o.targetId)&&(this.Lr.delete(i),s.push(this.removeMatchingKeysForTargetId(e,o.targetId)),r++)})),Gs.waitFor(s).next((()=>r))}getTargetCount(e){return Gs.resolve(this.targetCount)}getTargetData(e,t){const n=this.Lr.get(t)||null;return Gs.resolve(n)}addMatchingKeys(e,t,n){return this.qr.mr(t,n),Gs.resolve()}removeMatchingKeys(e,t,n){this.qr.pr(t,n);const r=this.persistence.referenceDelegate,s=[];return r&&t.forEach((t=>{s.push(r.markPotentiallyOrphaned(e,t))})),Gs.waitFor(s)}removeMatchingKeysForTargetId(e,t){return this.qr.yr(t),Gs.resolve()}getMatchingKeysForTargetId(e,t){const n=this.qr.Sr(t);return Gs.resolve(n)}containsKey(e,t){return Gs.resolve(this.qr.containsKey(t))}}class tc{constructor(e,t){this.Kr={},this.overlays={},this.$r=new Ks(0),this.Ur=!1,this.Ur=!0,this.Wr=new Kl,this.referenceDelegate=e(this),this.Gr=new ec(this),this.indexManager=new Nl,this.remoteDocumentCache=function(e){return new Jl(e)}((e=>this.referenceDelegate.zr(e))),this.serializer=new Ll(t),this.jr=new Hl(this.serializer)}start(){return Promise.resolve()}shutdown(){return this.Ur=!1,Promise.resolve()}get started(){return this.Ur}setDatabaseDeletedListener(){}setNetworkEnabled(){}getIndexManager(e){return this.indexManager}getDocumentOverlayCache(e){let t=this.overlays[e.toKey()];return t||(t=new Wl,this.overlays[e.toKey()]=t),t}getMutationQueue(e,t){let n=this.Kr[e.toKey()];return n||(n=new Xl(t,this.referenceDelegate),this.Kr[e.toKey()]=n),n}getGlobalsCache(){return this.Wr}getTargetCache(){return this.Gr}getRemoteDocumentCache(){return this.remoteDocumentCache}getBundleCache(){return this.jr}runTransaction(e,t,n){ls("MemoryPersistence","Starting transaction:",e);const r=new nc(this.$r.next());return this.referenceDelegate.Hr(),n(r).next((e=>this.referenceDelegate.Jr(r).next((()=>e)))).toPromise().then((e=>(r.raiseOnCommittedEvent(),e)))}Yr(e,t){return Gs.or(Object.values(this.Kr).map((n=>()=>n.containsKey(e,t))))}}class nc extends zs{constructor(e){super(),this.currentSequenceNumber=e}}class rc{constructor(e){this.persistence=e,this.Zr=new Ql,this.Xr=null}static ei(e){return new rc(e)}get ti(){if(this.Xr)return this.Xr;throw hs()}addReference(e,t,n){return this.Zr.addReference(n,t),this.ti.delete(n.toString()),Gs.resolve()}removeReference(e,t,n){return this.Zr.removeReference(n,t),this.ti.add(n.toString()),Gs.resolve()}markPotentiallyOrphaned(e,t){return this.ti.add(t.toString()),Gs.resolve()}removeTarget(e,t){this.Zr.yr(t.targetId).forEach((e=>this.ti.add(e.toString())));const n=this.persistence.getTargetCache();return n.getMatchingKeysForTargetId(e,t.targetId).next((e=>{e.forEach((e=>this.ti.add(e.toString())))})).next((()=>n.removeTargetData(e,t)))}Hr(){this.Xr=new Set}Jr(e){const t=this.persistence.getRemoteDocumentCache().newChangeBuffer();return Gs.forEach(this.ti,(n=>{const r=qs.fromPath(n);return this.ni(e,r).next((e=>{e||t.removeEntry(r,Ms.min())}))})).next((()=>(this.Xr=null,t.apply(e))))}updateLimboDocument(e,t){return this.ni(e,t).next((e=>{e?this.ti.delete(t.toString()):this.ti.add(t.toString())}))}zr(e){return 0}ni(e,t){return Gs.or([()=>Gs.resolve(this.Zr.containsKey(t)),()=>this.persistence.getTargetCache().containsKey(e,t),()=>this.persistence.Yr(e,t)])}}class sc{constructor(e,t){this.persistence=e,this.ri=new qo((e=>Js(e.path)),((e,t)=>e.isEqual(t))),this.garbageCollector=jl(this,t)}static ei(e,t){return new sc(e,t)}Hr(){}Jr(e){return Gs.resolve()}forEachTarget(e,t){return this.persistence.getTargetCache().forEachTarget(e,t)}Xn(e){const t=this.nr(e);return this.persistence.getTargetCache().getTargetCount(e).next((e=>t.next((t=>e+t))))}nr(e){let t=0;return this.er(e,(e=>{t++})).next((()=>t))}er(e,t){return Gs.forEach(this.ri,((n,r)=>this.ir(e,n,r).next((e=>e?Gs.resolve():t(r)))))}removeTargets(e,t,n){return this.persistence.getTargetCache().removeTargets(e,t,n)}removeOrphanedDocuments(e,t){let n=0;const r=this.persistence.getRemoteDocumentCache(),s=r.newChangeBuffer();return r.Br(e,(r=>this.ir(e,r,t).next((e=>{e||(n++,s.removeEntry(r,Ms.min()))})))).next((()=>s.apply(e))).next((()=>n))}markPotentiallyOrphaned(e,t){return this.ri.set(t,e.currentSequenceNumber),Gs.resolve()}removeTarget(e,t){const n=t.withSequenceNumber(e.currentSequenceNumber);return this.persistence.getTargetCache().updateTargetData(e,n)}addReference(e,t,n){return this.ri.set(n,e.currentSequenceNumber),Gs.resolve()}removeReference(e,t,n){return this.ri.set(n,e.currentSequenceNumber),Gs.resolve()}updateLimboDocument(e,t){return this.ri.set(t,e.currentSequenceNumber),Gs.resolve()}zr(e){let t=e.key.toString().length;return e.isFoundDocument()&&(t+=Pi(e.data.value)),t}ir(e,t,n){return Gs.or([()=>this.persistence.Yr(e,t),()=>this.persistence.getTargetCache().containsKey(e,t),()=>{const e=this.ri.get(t);return Gs.resolve(void 0!==e&&e>n)}])}getCacheSize(e){return this.persistence.getRemoteDocumentCache().getSize(e)}}class ic{constructor(e,t,n,r){this.targetId=e,this.fromCache=t,this.Wi=n,this.Gi=r}static zi(e,t){let n=Wo(),r=Wo();for(const e of t.docChanges)switch(e.type){case 0:n=n.add(e.doc.key);break;case 1:r=r.add(e.doc.key)}return new ic(e,t.fromCache,n,r)}}class oc{constructor(){this._documentReadCount=0}get documentReadCount(){return this._documentReadCount}incrementDocumentReadCount(e){this._documentReadCount+=e}}class ac{constructor(){this.ji=!1,this.Hi=!1,this.Ji=100,this.Yi=Dn()?8:Hs(Mn())>0?6:4}initialize(e,t){this.Zi=e,this.indexManager=t,this.ji=!0}getDocumentsMatchingQuery(e,t,n,r){const s={result:null};return this.Xi(e,t).next((e=>{s.result=e})).next((()=>{if(!s.result)return this.es(e,t,r,n).next((e=>{s.result=e}))})).next((()=>{if(s.result)return;const n=new oc;return this.ts(e,t,n).next((r=>{if(s.result=r,this.Hi)return this.ns(e,t,n,r.size)}))})).next((()=>s.result))}ns(e,t,n,r){return n.documentReadCount<this.Ji?(as()<=Gn.DEBUG&&ls("QueryEngine","SDK will not create cache indexes for query:",Mo(t),"since it only creates cache indexes for collection contains","more than or equal to",this.Ji,"documents"),Gs.resolve()):(as()<=Gn.DEBUG&&ls("QueryEngine","Query:",Mo(t),"scans",n.documentReadCount,"local documents and returns",r,"documents as results."),n.documentReadCount>this.Yi*r?(as()<=Gn.DEBUG&&ls("QueryEngine","The SDK decides to create cache indexes for query:",Mo(t),"as using cache indexes may help improve performance."),this.indexManager.createTargetIndexes(e,xo(t))):Gs.resolve())}Xi(e,t){if(To(t))return Gs.resolve(null);let n=xo(t);return this.indexManager.getIndexType(e,n).next((r=>0===r?null:(null!==t.limit&&1===r&&(t=Io(t,null,"F"),n=xo(t)),this.indexManager.getDocumentsMatchingTarget(e,n).next((r=>{const s=Wo(...r);return this.Zi.getDocuments(e,s).next((r=>this.indexManager.getMinOffset(e,n).next((n=>{const i=this.rs(t,r);return this.ss(t,i,s,n.readTime)?this.Xi(e,Io(t,null,"F")):this.os(e,i,t,n)}))))})))))}es(e,t,n,r){return To(t)||r.isEqual(Ms.min())?Gs.resolve(null):this.Zi.getDocuments(e,n).next((s=>{const i=this.rs(t,s);return this.ss(t,i,n,r)?Gs.resolve(null):(as()<=Gn.DEBUG&&ls("QueryEngine","Re-using previous result from %s to execute query: %s",r.toString(),Mo(t)),this.os(e,i,t,Fs(r,-1)).next((e=>e)))}))}rs(e,t){let n=new di(Po(e));return t.forEach(((t,r)=>{Do(e,r)&&(n=n.add(r))})),n}ss(e,t,n,r){if(null===e.limit)return!1;if(n.size!==t.size)return!0;const s="F"===e.limitType?t.last():t.first();return!!s&&(s.hasPendingWrites||s.version.compareTo(r)>0)}ts(e,t,n){return as()<=Gn.DEBUG&&ls("QueryEngine","Using full collection scan to execute query:",Mo(t)),this.Zi.getDocumentsMatchingQuery(e,t,$s.min(),n)}os(e,t,n,r){return this.Zi.getDocumentsMatchingQuery(e,n,r).next((e=>(t.forEach((t=>{e=e.insert(t.key,t)})),e)))}}class lc{constructor(e,t,n,r){this.persistence=e,this._s=t,this.serializer=r,this.us=new li(Is),this.cs=new qo((e=>yo(e)),vo),this.ls=new Map,this.hs=e.getRemoteDocumentCache(),this.Gr=e.getTargetCache(),this.jr=e.getBundleCache(),this.Ps(n)}Ps(e){this.documentOverlayCache=this.persistence.getDocumentOverlayCache(e),this.indexManager=this.persistence.getIndexManager(e),this.mutationQueue=this.persistence.getMutationQueue(e,this.indexManager),this.localDocuments=new Gl(this.hs,this.mutationQueue,this.documentOverlayCache,this.indexManager),this.hs.setIndexManager(this.indexManager),this._s.initialize(this.localDocuments,this.indexManager)}collectGarbage(e){return this.persistence.runTransaction("Collect garbage","readwrite-primary",(t=>e.collect(t,this.us)))}}function cc(e,t,n,r){return new lc(e,t,n,r)}async function uc(e,t){const n=fs(e);return await n.persistence.runTransaction("Handle user change","readonly",(e=>{let r;return n.mutationQueue.getAllMutationBatches(e).next((s=>(r=s,n.Ps(t),n.mutationQueue.getAllMutationBatches(e)))).next((t=>{const s=[],i=[];let o=Wo();for(const e of r){s.push(e.batchId);for(const t of e.mutations)o=o.add(t.key)}for(const e of t){i.push(e.batchId);for(const t of e.mutations)o=o.add(t.key)}return n.localDocuments.getDocuments(e,o).next((e=>({Ts:e,removedBatchIds:s,addedBatchIds:i})))}))}))}function dc(e){const t=fs(e);return t.persistence.runTransaction("Get last remote snapshot version","readonly",(e=>t.Gr.getLastRemoteSnapshotVersion(e)))}function hc(e,t,n){let r=Wo(),s=Wo();return n.forEach((e=>r=r.add(e))),t.getEntries(e,r).next((e=>{let r=Fo();return n.forEach(((n,i)=>{const o=e.get(n);i.isFoundDocument()!==o.isFoundDocument()&&(s=s.add(n)),i.isNoDocument()&&i.version.isEqual(Ms.min())?(t.removeEntry(n,i.readTime),r=r.insert(n,i)):!o.isValidDocument()||i.version.compareTo(o.version)>0||0===i.version.compareTo(o.version)&&o.hasPendingWrites?(t.addEntry(i),r=r.insert(n,i)):ls("LocalStore","Ignoring outdated watch update for ",n,". Current version:",o.version," Watch version:",i.version)})),{Is:r,ds:s}}))}function pc(e,t){const n=fs(e);return n.persistence.runTransaction("Get next mutation batch","readonly",(e=>(void 0===t&&(t=-1),n.mutationQueue.getNextMutationBatchAfterBatchId(e,t))))}function fc(e,t){const n=fs(e);return n.persistence.runTransaction("Allocate target","readwrite",(e=>{let r;return n.Gr.getTargetData(e,t).next((s=>s?(r=s,Gs.resolve(r)):n.Gr.allocateTargetId(e).next((s=>(r=new kl(t,s,"TargetPurposeListen",e.currentSequenceNumber),n.Gr.addTargetData(e,r).next((()=>r)))))))})).then((e=>{const r=n.us.get(e.targetId);return(null===r||e.snapshotVersion.compareTo(r.snapshotVersion)>0)&&(n.us=n.us.insert(e.targetId,e),n.cs.set(t,e.targetId)),e}))}async function mc(e,t,n){const r=fs(e),s=r.us.get(t),i=n?"readwrite":"readwrite-primary";try{n||await r.persistence.runTransaction("Release target",i,(e=>r.persistence.referenceDelegate.removeTarget(e,s)))}catch(e){if(!Ws(e))throw e;ls("LocalStore",`Failed to update sequence numbers for target ${t}: ${e}`)}r.us=r.us.remove(t),r.cs.delete(s.target)}function gc(e,t,n){const r=fs(e);let s=Ms.min(),i=Wo();return r.persistence.runTransaction("Execute query","readwrite",(e=>function(e,t,n){const r=fs(e),s=r.cs.get(n);return void 0!==s?Gs.resolve(r.us.get(s)):r.Gr.getTargetData(t,n)}(r,e,xo(t)).next((t=>{if(t)return s=t.lastLimboFreeSnapshotVersion,r.Gr.getMatchingKeysForTargetId(e,t.targetId).next((e=>{i=e}))})).next((()=>r._s.getDocumentsMatchingQuery(e,t,n?s:Ms.min(),n?i:Wo()))).next((e=>(yc(r,No(t),e),{documents:e,Es:i})))))}function yc(e,t,n){let r=e.ls.get(t)||Ms.min();n.forEach(((e,t)=>{t.readTime.compareTo(r)>0&&(r=t.readTime)})),e.ls.set(t,r)}class vc{constructor(){this.activeTargetIds=Qo()}ps(e){this.activeTargetIds=this.activeTargetIds.add(e)}ys(e){this.activeTargetIds=this.activeTargetIds.delete(e)}gs(){const e={activeTargetIds:this.activeTargetIds.toArray(),updateTimeMs:Date.now()};return JSON.stringify(e)}}class wc{constructor(){this._o=new vc,this.ao={},this.onlineStateHandler=null,this.sequenceNumberHandler=null}addPendingMutation(e){}updateMutationState(e,t,n){}addLocalQueryTarget(e,t=!0){return t&&this._o.ps(e),this.ao[e]||"not-current"}updateQueryState(e,t,n){this.ao[e]=t}removeLocalQueryTarget(e){this._o.ys(e)}isLocalQueryTarget(e){return this._o.activeTargetIds.has(e)}clearQueryState(e){delete this.ao[e]}getAllActiveQueryTargets(){return this._o.activeTargetIds}isActiveQueryTarget(e){return this._o.activeTargetIds.has(e)}start(){return this._o=new vc,Promise.resolve()}handleUserChange(e,t,n){}setOnlineState(e){}shutdown(){}writeSequenceNumber(e){}notifyBundleLoaded(e){}}class bc{uo(e){}shutdown(){}}class Sc{constructor(){this.co=()=>this.lo(),this.ho=()=>this.Po(),this.To=[],this.Io()}uo(e){this.To.push(e)}shutdown(){window.removeEventListener("online",this.co),window.removeEventListener("offline",this.ho)}Io(){window.addEventListener("online",this.co),window.addEventListener("offline",this.ho)}lo(){ls("ConnectivityMonitor","Network connectivity changed: AVAILABLE");for(const e of this.To)e(0)}Po(){ls("ConnectivityMonitor","Network connectivity changed: UNAVAILABLE");for(const e of this.To)e(1)}static p(){return"undefined"!=typeof window&&void 0!==window.addEventListener&&void 0!==window.removeEventListener}}let Ec=null;function Tc(){return null===Ec?Ec=268435456+Math.round(2147483648*Math.random()):Ec++,"0x"+Ec.toString(16)}const _c={BatchGetDocuments:"batchGet",Commit:"commit",RunQuery:"runQuery",RunAggregationQuery:"runAggregationQuery"};class Cc{constructor(e){this.Eo=e.Eo,this.Ao=e.Ao}Ro(e){this.Vo=e}mo(e){this.fo=e}po(e){this.yo=e}onMessage(e){this.wo=e}close(){this.Ao()}send(e){this.Eo(e)}So(){this.Vo()}bo(){this.fo()}Do(e){this.yo(e)}vo(e){this.wo(e)}}const xc="WebChannelConnection";class Ac extends class{get Co(){return!1}constructor(e){this.databaseInfo=e,this.databaseId=e.databaseId;const t=e.ssl?"https":"http",n=encodeURIComponent(this.databaseId.projectId),r=encodeURIComponent(this.databaseId.database);this.Fo=t+"://"+e.host,this.Mo=`projects/${n}/databases/${r}`,this.xo="(default)"===this.databaseId.database?`project_id=${n}`:`project_id=${n}&database_id=${r}`}Oo(e,t,n,r,s){const i=Tc(),o=this.No(e,t.toUriEncodedString());ls("RestConnection",`Sending RPC '${e}' ${i}:`,o,n);const a={"google-cloud-resource-prefix":this.Mo,"x-goog-request-params":this.xo};return this.Bo(a,r,s),this.Lo(e,o,a,n).then((t=>(ls("RestConnection",`Received RPC '${e}' ${i}: `,t),t)),(t=>{throw us("RestConnection",`RPC '${e}' ${i} failed with error: `,t,"url: ",o,"request:",n),t}))}ko(e,t,n,r,s,i){return this.Oo(e,t,n,r,s)}Bo(e,t,n){e["X-Goog-Api-Client"]="gl-js/ fire/"+is,e["Content-Type"]="text/plain",this.databaseInfo.appId&&(e["X-Firebase-GMPID"]=this.databaseInfo.appId),t&&t.headers.forEach(((t,n)=>e[n]=t)),n&&n.headers.forEach(((t,n)=>e[n]=t))}No(e,t){const n=_c[e];return`${this.Fo}/v1/${t}:${n}`}terminate(){}}{constructor(e){super(e),this.forceLongPolling=e.forceLongPolling,this.autoDetectLongPolling=e.autoDetectLongPolling,this.useFetchStreams=e.useFetchStreams,this.longPollingOptions=e.longPollingOptions}Lo(e,t,n,r){const s=Tc();return new Promise(((i,o)=>{const a=new Wr;a.setWithCredentials(!0),a.listenOnce(Qr.COMPLETE,(()=>{try{switch(a.getLastErrorCode()){case Yr.NO_ERROR:const t=a.getResponseJson();ls(xc,`XHR for RPC '${e}' ${s} received:`,JSON.stringify(t)),i(t);break;case Yr.TIMEOUT:ls(xc,`RPC '${e}' ${s} timed out`),o(new gs(ms.DEADLINE_EXCEEDED,"Request time out"));break;case Yr.HTTP_ERROR:const n=a.getStatus();if(ls(xc,`RPC '${e}' ${s} failed with status:`,n,"response text:",a.getResponseText()),n>0){let e=a.getResponseJson();Array.isArray(e)&&(e=e[0]);const t=null==e?void 0:e.error;if(t&&t.status&&t.message){const e=function(e){const t=e.toLowerCase().replace(/_/g,"-");return Object.values(ms).indexOf(t)>=0?t:ms.UNKNOWN}(t.status);o(new gs(e,t.message))}else o(new gs(ms.UNKNOWN,"Server responded with status "+a.getStatus()))}else o(new gs(ms.UNAVAILABLE,"Connection failed."));break;default:hs()}}finally{ls(xc,`RPC '${e}' ${s} completed.`)}}));const l=JSON.stringify(r);ls(xc,`RPC '${e}' ${s} sending request:`,r),a.send(t,"POST",l,n,15)}))}qo(e,t,n){const r=Tc(),s=[this.Fo,"/","google.firestore.v1.Firestore","/",e,"/channel"],i=es(),o=Zr(),a={httpSessionIdParam:"gsessionid",initMessageHeaders:{},messageUrlParams:{database:`projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`},sendRawJson:!0,supportsCrossDomainXhr:!0,internalChannelParams:{forwardChannelRequestTimeoutMs:6e5},forceLongPolling:this.forceLongPolling,detectBufferingProxy:this.autoDetectLongPolling},l=this.longPollingOptions.timeoutSeconds;void 0!==l&&(a.longPollingTimeout=Math.round(1e3*l)),this.useFetchStreams&&(a.useFetchStreams=!0),this.Bo(a.initMessageHeaders,t,n),a.encodeInitMessageHeaders=!0;const c=s.join("");ls(xc,`Creating RPC '${e}' stream ${r}: ${c}`,a);const u=i.createWebChannel(c,a);let d=!1,h=!1;const p=new Cc({Eo:t=>{h?ls(xc,`Not sending because RPC '${e}' stream ${r} is closed:`,t):(d||(ls(xc,`Opening RPC '${e}' stream ${r} transport.`),u.open(),d=!0),ls(xc,`RPC '${e}' stream ${r} sending:`,t),u.send(t))},Ao:()=>u.close()}),f=(e,t,n)=>{e.listen(t,(e=>{try{n(e)}catch(e){setTimeout((()=>{throw e}),0)}}))};return f(u,Kr.EventType.OPEN,(()=>{h||(ls(xc,`RPC '${e}' stream ${r} transport opened.`),p.So())})),f(u,Kr.EventType.CLOSE,(()=>{h||(h=!0,ls(xc,`RPC '${e}' stream ${r} transport closed`),p.Do())})),f(u,Kr.EventType.ERROR,(t=>{h||(h=!0,us(xc,`RPC '${e}' stream ${r} transport errored:`,t),p.Do(new gs(ms.UNAVAILABLE,"The operation could not be completed")))})),f(u,Kr.EventType.MESSAGE,(t=>{var n;if(!h){const s=t.data[0];ps(!!s);const i=s,o=(null==i?void 0:i.error)||(null===(n=i[0])||void 0===n?void 0:n.error);if(o){ls(xc,`RPC '${e}' stream ${r} received error:`,o);const t=o.status;let n=function(e){const t=Ma[e];if(void 0!==t)return Pa(t)}(t),s=o.message;void 0===n&&(n=ms.INTERNAL,s="Unknown error status: "+t+" with message "+o.message),h=!0,p.Do(new gs(n,s)),u.close()}else ls(xc,`RPC '${e}' stream ${r} received:`,s),p.vo(s)}})),f(o,Jr.STAT_EVENT,(t=>{t.stat===Xr.PROXY?ls(xc,`RPC '${e}' stream ${r} detected buffering proxy`):t.stat===Xr.NOPROXY&&ls(xc,`RPC '${e}' stream ${r} detected no buffering proxy`)})),setTimeout((()=>{p.bo()}),0),p}}function Ic(){return"undefined"!=typeof document?document:null}function kc(e){return new el(e,!0)}class Lc{constructor(e,t,n=1e3,r=1.5,s=6e4){this.li=e,this.timerId=t,this.Qo=n,this.Ko=r,this.$o=s,this.Uo=0,this.Wo=null,this.Go=Date.now(),this.reset()}reset(){this.Uo=0}zo(){this.Uo=this.$o}jo(e){this.cancel();const t=Math.floor(this.Uo+this.Ho()),n=Math.max(0,Date.now()-this.Go),r=Math.max(0,t-n);r>0&&ls("ExponentialBackoff",`Backing off for ${r} ms (base delay: ${this.Uo} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`),this.Wo=this.li.enqueueAfterDelay(this.timerId,r,(()=>(this.Go=Date.now(),e()))),this.Uo*=this.Ko,this.Uo<this.Qo&&(this.Uo=this.Qo),this.Uo>this.$o&&(this.Uo=this.$o)}Jo(){null!==this.Wo&&(this.Wo.skipDelay(),this.Wo=null)}cancel(){null!==this.Wo&&(this.Wo.cancel(),this.Wo=null)}Ho(){return(Math.random()-.5)*this.Uo}}class Mc{constructor(e,t,n,r,s,i,o,a){this.li=e,this.Yo=n,this.Zo=r,this.connection=s,this.authCredentialsProvider=i,this.appCheckCredentialsProvider=o,this.listener=a,this.state=0,this.Xo=0,this.e_=null,this.t_=null,this.stream=null,this.n_=0,this.r_=new Lc(e,t)}i_(){return 1===this.state||5===this.state||this.s_()}s_(){return 2===this.state||3===this.state}start(){this.n_=0,4!==this.state?this.auth():this.o_()}async stop(){this.i_()&&await this.close(0)}__(){this.state=0,this.r_.reset()}a_(){this.s_()&&null===this.e_&&(this.e_=this.li.enqueueAfterDelay(this.Yo,6e4,(()=>this.u_())))}c_(e){this.l_(),this.stream.send(e)}async u_(){if(this.s_())return this.close(0)}l_(){this.e_&&(this.e_.cancel(),this.e_=null)}h_(){this.t_&&(this.t_.cancel(),this.t_=null)}async close(e,t){this.l_(),this.h_(),this.r_.cancel(),this.Xo++,4!==e?this.r_.reset():t&&t.code===ms.RESOURCE_EXHAUSTED?(cs(t.toString()),cs("Using maximum backoff delay to prevent overloading the backend."),this.r_.zo()):t&&t.code===ms.UNAUTHENTICATED&&3!==this.state&&(this.authCredentialsProvider.invalidateToken(),this.appCheckCredentialsProvider.invalidateToken()),null!==this.stream&&(this.P_(),this.stream.close(),this.stream=null),this.state=e,await this.listener.po(t)}P_(){}auth(){this.state=1;const e=this.T_(this.Xo),t=this.Xo;Promise.all([this.authCredentialsProvider.getToken(),this.appCheckCredentialsProvider.getToken()]).then((([e,n])=>{this.Xo===t&&this.I_(e,n)}),(t=>{e((()=>{const e=new gs(ms.UNKNOWN,"Fetching auth token failed: "+t.message);return this.d_(e)}))}))}I_(e,t){const n=this.T_(this.Xo);this.stream=this.E_(e,t),this.stream.Ro((()=>{n((()=>this.listener.Ro()))})),this.stream.mo((()=>{n((()=>(this.state=2,this.t_=this.li.enqueueAfterDelay(this.Zo,1e4,(()=>(this.s_()&&(this.state=3),Promise.resolve()))),this.listener.mo())))})),this.stream.po((e=>{n((()=>this.d_(e)))})),this.stream.onMessage((e=>{n((()=>1==++this.n_?this.A_(e):this.onNext(e)))}))}o_(){this.state=5,this.r_.jo((async()=>{this.state=0,this.start()}))}d_(e){return ls("PersistentStream",`close with error: ${e}`),this.stream=null,this.close(4,e)}T_(e){return t=>{this.li.enqueueAndForget((()=>this.Xo===e?t():(ls("PersistentStream","stream callback skipped by getCloseGuardedDispatcher."),Promise.resolve())))}}}class Dc extends Mc{constructor(e,t,n,r,s,i){super(e,"listen_stream_connection_backoff","listen_stream_idle","health_check_timeout",t,n,r,i),this.serializer=s}E_(e,t){return this.connection.qo("Listen",e,t)}A_(e){return this.onNext(e)}onNext(e){this.r_.reset();const t=function(e,t){let n;if("targetChange"in t){t.targetChange;const r=function(e){return"NO_CHANGE"===e?0:"ADD"===e?1:"REMOVE"===e?2:"CURRENT"===e?3:"RESET"===e?4:hs()}(t.targetChange.targetChangeType||"NO_CHANGE"),s=t.targetChange.targetIds||[],i=function(e,t){return e.useProto3Json?(ps(void 0===t||"string"==typeof t),mi.fromBase64String(t||"")):(ps(void 0===t||t instanceof Buffer||t instanceof Uint8Array),mi.fromUint8Array(t||new Uint8Array))}(e,t.targetChange.resumeToken),o=t.targetChange.cause,a=o&&function(e){const t=void 0===e.code?ms.UNKNOWN:Pa(e.code);return new gs(t,e.message||"")}(o);n=new Ha(r,s,i,a||null)}else if("documentChange"in t){t.documentChange;const r=t.documentChange;r.document,r.document.name,r.document.updateTime;const s=ul(e,r.document.name),i=il(r.document.updateTime),o=r.document.createTime?il(r.document.createTime):Ms.min(),a=new zi({mapValue:{fields:r.document.fields}}),l=Gi.newFoundDocument(s,i,o,a),c=r.targetIds||[],u=r.removedTargetIds||[];n=new Ua(c,u,l.key,l)}else if("documentDelete"in t){t.documentDelete;const r=t.documentDelete;r.document;const s=ul(e,r.document),i=r.readTime?il(r.readTime):Ms.min(),o=Gi.newNoDocument(s,i),a=r.removedTargetIds||[];n=new Ua([],a,o.key,o)}else if("documentRemove"in t){t.documentRemove;const r=t.documentRemove;r.document;const s=ul(e,r.document),i=r.removedTargetIds||[];n=new Ua([],i,s,null)}else{if(!("filter"in t))return hs();{t.filter;const e=t.filter;e.targetId;const{count:r=0,unchangedNames:s}=e,i=new La(r,s),o=e.targetId;n=new Ga(o,i)}}return n}(this.serializer,e),n=function(e){if(!("targetChange"in e))return Ms.min();const t=e.targetChange;return t.targetIds&&t.targetIds.length?Ms.min():t.readTime?il(t.readTime):Ms.min()}(e);return this.listener.R_(t,n)}V_(e){const t={};t.database=pl(this.serializer),t.addTarget=function(e,t){let n;const r=t.target;if(n=wo(r)?{documents:yl(e,r)}:{query:vl(e,r).ct},n.targetId=t.targetId,t.resumeToken.approximateByteSize()>0){n.resumeToken=rl(e,t.resumeToken);const r=tl(e,t.expectedCount);null!==r&&(n.expectedCount=r)}else if(t.snapshotVersion.compareTo(Ms.min())>0){n.readTime=nl(e,t.snapshotVersion.toTimestamp());const r=tl(e,t.expectedCount);null!==r&&(n.expectedCount=r)}return n}(this.serializer,e);const n=function(e,t){const n=function(e){switch(e){case"TargetPurposeListen":return null;case"TargetPurposeExistenceFilterMismatch":return"existence-filter-mismatch";case"TargetPurposeExistenceFilterMismatchBloom":return"existence-filter-mismatch-bloom";case"TargetPurposeLimboResolution":return"limbo-document";default:return hs()}}(t.purpose);return null==n?null:{"goog-listen-tags":n}}(this.serializer,e);n&&(t.labels=n),this.c_(t)}m_(e){const t={};t.database=pl(this.serializer),t.removeTarget=e,this.c_(t)}}class Nc extends Mc{constructor(e,t,n,r,s,i){super(e,"write_stream_connection_backoff","write_stream_idle","health_check_timeout",t,n,r,i),this.serializer=s}get f_(){return this.n_>0}start(){this.lastStreamToken=void 0,super.start()}P_(){this.f_&&this.g_([])}E_(e,t){return this.connection.qo("Write",e,t)}A_(e){return ps(!!e.streamToken),this.lastStreamToken=e.streamToken,ps(!e.writeResults||0===e.writeResults.length),this.listener.p_()}onNext(e){ps(!!e.streamToken),this.lastStreamToken=e.streamToken,this.r_.reset();const t=function(e,t){return e&&e.length>0?(ps(void 0!==t),e.map((e=>function(e,t){let n=e.updateTime?il(e.updateTime):il(t);return n.isEqual(Ms.min())&&(n=il(t)),new da(n,e.transformResults||[])}(e,t)))):[]}(e.writeResults,e.commitTime),n=il(e.commitTime);return this.listener.y_(n,t)}w_(){const e={};e.database=pl(this.serializer),this.c_(e)}g_(e){const t={streamToken:this.lastStreamToken,writes:e.map((e=>gl(this.serializer,e)))};this.c_(t)}}class Pc extends class{}{constructor(e,t,n,r){super(),this.authCredentials=e,this.appCheckCredentials=t,this.connection=n,this.serializer=r,this.S_=!1}b_(){if(this.S_)throw new gs(ms.FAILED_PRECONDITION,"The client has already been terminated.")}Oo(e,t,n,r){return this.b_(),Promise.all([this.authCredentials.getToken(),this.appCheckCredentials.getToken()]).then((([s,i])=>this.connection.Oo(e,al(t,n),r,s,i))).catch((e=>{throw"FirebaseError"===e.name?(e.code===ms.UNAUTHENTICATED&&(this.authCredentials.invalidateToken(),this.appCheckCredentials.invalidateToken()),e):new gs(ms.UNKNOWN,e.toString())}))}ko(e,t,n,r,s){return this.b_(),Promise.all([this.authCredentials.getToken(),this.appCheckCredentials.getToken()]).then((([i,o])=>this.connection.ko(e,al(t,n),r,i,o,s))).catch((e=>{throw"FirebaseError"===e.name?(e.code===ms.UNAUTHENTICATED&&(this.authCredentials.invalidateToken(),this.appCheckCredentials.invalidateToken()),e):new gs(ms.UNKNOWN,e.toString())}))}terminate(){this.S_=!0,this.connection.terminate()}}class Oc{constructor(e,t){this.asyncQueue=e,this.onlineStateHandler=t,this.state="Unknown",this.D_=0,this.v_=null,this.C_=!0}F_(){0===this.D_&&(this.M_("Unknown"),this.v_=this.asyncQueue.enqueueAfterDelay("online_state_timeout",1e4,(()=>(this.v_=null,this.x_("Backend didn't respond within 10 seconds."),this.M_("Offline"),Promise.resolve()))))}O_(e){"Online"===this.state?this.M_("Unknown"):(this.D_++,this.D_>=1&&(this.N_(),this.x_(`Connection failed 1 times. Most recent error: ${e.toString()}`),this.M_("Offline")))}set(e){this.N_(),this.D_=0,"Online"===e&&(this.C_=!1),this.M_(e)}M_(e){e!==this.state&&(this.state=e,this.onlineStateHandler(e))}x_(e){const t=`Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;this.C_?(cs(t),this.C_=!1):ls("OnlineStateTracker",t)}N_(){null!==this.v_&&(this.v_.cancel(),this.v_=null)}}class qc{constructor(e,t,n,r,s){this.localStore=e,this.datastore=t,this.asyncQueue=n,this.remoteSyncer={},this.B_=[],this.L_=new Map,this.k_=new Set,this.q_=[],this.Q_=s,this.Q_.uo((e=>{n.enqueueAndForget((async()=>{Gc(this)&&(ls("RemoteStore","Restarting streams for network reachability change."),await async function(e){const t=fs(e);t.k_.add(4),await Fc(t),t.K_.set("Unknown"),t.k_.delete(4),await Rc(t)}(this))}))})),this.K_=new Oc(n,r)}}async function Rc(e){if(Gc(e))for(const t of e.q_)await t(!0)}async function Fc(e){for(const t of e.q_)await t(!1)}function Bc(e,t){const n=fs(e);n.L_.has(t.targetId)||(n.L_.set(t.targetId,t),Uc(n)?zc(n):uu(n).s_()&&Vc(n,t))}function $c(e,t){const n=fs(e),r=uu(n);n.L_.delete(t),r.s_()&&jc(n,t),0===n.L_.size&&(r.s_()?r.a_():Gc(n)&&n.K_.set("Unknown"))}function Vc(e,t){if(e.U_.xe(t.targetId),t.resumeToken.approximateByteSize()>0||t.snapshotVersion.compareTo(Ms.min())>0){const n=e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;t=t.withExpectedCount(n)}uu(e).V_(t)}function jc(e,t){e.U_.xe(t),uu(e).m_(t)}function zc(e){e.U_=new Ka({getRemoteKeysForTarget:t=>e.remoteSyncer.getRemoteKeysForTarget(t),ut:t=>e.L_.get(t)||null,nt:()=>e.datastore.serializer.databaseId}),uu(e).start(),e.K_.F_()}function Uc(e){return Gc(e)&&!uu(e).i_()&&e.L_.size>0}function Gc(e){return 0===fs(e).k_.size}function Hc(e){e.U_=void 0}async function Wc(e){e.K_.set("Online")}async function Kc(e){e.L_.forEach(((t,n)=>{Vc(e,t)}))}async function Qc(e,t){Hc(e),Uc(e)?(e.K_.O_(t),zc(e)):e.K_.set("Unknown")}async function Yc(e,t,n){if(e.K_.set("Online"),t instanceof Ha&&2===t.state&&t.cause)try{await async function(e,t){const n=t.cause;for(const r of t.targetIds)e.L_.has(r)&&(await e.remoteSyncer.rejectListen(r,n),e.L_.delete(r),e.U_.removeTarget(r))}(e,t)}catch(n){ls("RemoteStore","Failed to remove targets %s: %s ",t.targetIds.join(","),n),await Xc(e,n)}else if(t instanceof Ua?e.U_.$e(t):t instanceof Ga?e.U_.Je(t):e.U_.Ge(t),!n.isEqual(Ms.min()))try{const t=await dc(e.localStore);n.compareTo(t)>=0&&await function(e,t){const n=e.U_.it(t);return n.targetChanges.forEach(((n,r)=>{if(n.resumeToken.approximateByteSize()>0){const s=e.L_.get(r);s&&e.L_.set(r,s.withResumeToken(n.resumeToken,t))}})),n.targetMismatches.forEach(((t,n)=>{const r=e.L_.get(t);if(!r)return;e.L_.set(t,r.withResumeToken(mi.EMPTY_BYTE_STRING,r.snapshotVersion)),jc(e,t);const s=new kl(r.target,t,n,r.sequenceNumber);Vc(e,s)})),e.remoteSyncer.applyRemoteEvent(n)}(e,n)}catch(t){ls("RemoteStore","Failed to raise snapshot:",t),await Xc(e,t)}}async function Xc(e,t,n){if(!Ws(t))throw t;e.k_.add(1),await Fc(e),e.K_.set("Offline"),n||(n=()=>dc(e.localStore)),e.asyncQueue.enqueueRetryable((async()=>{ls("RemoteStore","Retrying IndexedDB access"),await n(),e.k_.delete(1),await Rc(e)}))}function Jc(e,t){return t().catch((n=>Xc(e,n,t)))}async function Zc(e){const t=fs(e),n=du(t);let r=t.B_.length>0?t.B_[t.B_.length-1].batchId:-1;for(;eu(t);)try{const e=await pc(t.localStore,r);if(null===e){0===t.B_.length&&n.a_();break}r=e.batchId,tu(t,e)}catch(e){await Xc(t,e)}nu(t)&&ru(t)}function eu(e){return Gc(e)&&e.B_.length<10}function tu(e,t){e.B_.push(t);const n=du(e);n.s_()&&n.f_&&n.g_(t.mutations)}function nu(e){return Gc(e)&&!du(e).i_()&&e.B_.length>0}function ru(e){du(e).start()}async function su(e){du(e).w_()}async function iu(e){const t=du(e);for(const n of e.B_)t.g_(n.mutations)}async function ou(e,t,n){const r=e.B_.shift(),s=Ia.from(r,t,n);await Jc(e,(()=>e.remoteSyncer.applySuccessfulWrite(s))),await Zc(e)}async function au(e,t){t&&du(e).f_&&await async function(e,t){if(function(e){return Na(e)&&e!==ms.ABORTED}(t.code)){const n=e.B_.shift();du(e).__(),await Jc(e,(()=>e.remoteSyncer.rejectFailedWrite(n.batchId,t))),await Zc(e)}}(e,t),nu(e)&&ru(e)}async function lu(e,t){const n=fs(e);n.asyncQueue.verifyOperationInProgress(),ls("RemoteStore","RemoteStore received new credentials");const r=Gc(n);n.k_.add(3),await Fc(n),r&&n.K_.set("Unknown"),await n.remoteSyncer.handleCredentialChange(t),n.k_.delete(3),await Rc(n)}async function cu(e,t){const n=fs(e);t?(n.k_.delete(2),await Rc(n)):t||(n.k_.add(2),await Fc(n),n.K_.set("Unknown"))}function uu(e){return e.W_||(e.W_=function(e,t,n){const r=fs(e);return r.b_(),new Dc(t,r.connection,r.authCredentials,r.appCheckCredentials,r.serializer,n)}(e.datastore,e.asyncQueue,{Ro:Wc.bind(null,e),mo:Kc.bind(null,e),po:Qc.bind(null,e),R_:Yc.bind(null,e)}),e.q_.push((async t=>{t?(e.W_.__(),Uc(e)?zc(e):e.K_.set("Unknown")):(await e.W_.stop(),Hc(e))}))),e.W_}function du(e){return e.G_||(e.G_=function(e,t,n){const r=fs(e);return r.b_(),new Nc(t,r.connection,r.authCredentials,r.appCheckCredentials,r.serializer,n)}(e.datastore,e.asyncQueue,{Ro:()=>Promise.resolve(),mo:su.bind(null,e),po:au.bind(null,e),p_:iu.bind(null,e),y_:ou.bind(null,e)}),e.q_.push((async t=>{t?(e.G_.__(),await Zc(e)):(await e.G_.stop(),e.B_.length>0&&(ls("RemoteStore",`Stopping write stream with ${e.B_.length} pending writes`),e.B_=[]))}))),e.G_}class hu{constructor(e,t,n,r,s){this.asyncQueue=e,this.timerId=t,this.targetTimeMs=n,this.op=r,this.removalCallback=s,this.deferred=new ys,this.then=this.deferred.promise.then.bind(this.deferred.promise),this.deferred.promise.catch((e=>{}))}get promise(){return this.deferred.promise}static createAndSchedule(e,t,n,r,s){const i=Date.now()+n,o=new hu(e,t,i,r,s);return o.start(n),o}start(e){this.timerHandle=setTimeout((()=>this.handleDelayElapsed()),e)}skipDelay(){return this.handleDelayElapsed()}cancel(e){null!==this.timerHandle&&(this.clearTimeout(),this.deferred.reject(new gs(ms.CANCELLED,"Operation cancelled"+(e?": "+e:""))))}handleDelayElapsed(){this.asyncQueue.enqueueAndForget((()=>null!==this.timerHandle?(this.clearTimeout(),this.op().then((e=>this.deferred.resolve(e)))):Promise.resolve()))}clearTimeout(){null!==this.timerHandle&&(this.removalCallback(this),clearTimeout(this.timerHandle),this.timerHandle=null)}}function pu(e,t){if(cs("AsyncQueue",`${t}: ${e}`),Ws(e))return new gs(ms.UNAVAILABLE,`${t}: ${e}`);throw e}class fu{static emptySet(e){return new fu(e.comparator)}constructor(e){this.comparator=e?(t,n)=>e(t,n)||qs.comparator(t.key,n.key):(e,t)=>qs.comparator(e.key,t.key),this.keyedMap=$o(),this.sortedSet=new li(this.comparator)}has(e){return null!=this.keyedMap.get(e)}get(e){return this.keyedMap.get(e)}first(){return this.sortedSet.minKey()}last(){return this.sortedSet.maxKey()}isEmpty(){return this.sortedSet.isEmpty()}indexOf(e){const t=this.keyedMap.get(e);return t?this.sortedSet.indexOf(t):-1}get size(){return this.sortedSet.size}forEach(e){this.sortedSet.inorderTraversal(((t,n)=>(e(t),!1)))}add(e){const t=this.delete(e.key);return t.copy(t.keyedMap.insert(e.key,e),t.sortedSet.insert(e,null))}delete(e){const t=this.get(e);return t?this.copy(this.keyedMap.remove(e),this.sortedSet.remove(t)):this}isEqual(e){if(!(e instanceof fu))return!1;if(this.size!==e.size)return!1;const t=this.sortedSet.getIterator(),n=e.sortedSet.getIterator();for(;t.hasNext();){const e=t.getNext().key,r=n.getNext().key;if(!e.isEqual(r))return!1}return!0}toString(){const e=[];return this.forEach((t=>{e.push(t.toString())})),0===e.length?"DocumentSet ()":"DocumentSet (\n  "+e.join("  \n")+"\n)"}copy(e,t){const n=new fu;return n.comparator=this.comparator,n.keyedMap=e,n.sortedSet=t,n}}class mu{constructor(){this.z_=new li(qs.comparator)}track(e){const t=e.doc.key,n=this.z_.get(t);n?0!==e.type&&3===n.type?this.z_=this.z_.insert(t,e):3===e.type&&1!==n.type?this.z_=this.z_.insert(t,{type:n.type,doc:e.doc}):2===e.type&&2===n.type?this.z_=this.z_.insert(t,{type:2,doc:e.doc}):2===e.type&&0===n.type?this.z_=this.z_.insert(t,{type:0,doc:e.doc}):1===e.type&&0===n.type?this.z_=this.z_.remove(t):1===e.type&&2===n.type?this.z_=this.z_.insert(t,{type:1,doc:n.doc}):0===e.type&&1===n.type?this.z_=this.z_.insert(t,{type:2,doc:e.doc}):hs():this.z_=this.z_.insert(t,e)}j_(){const e=[];return this.z_.inorderTraversal(((t,n)=>{e.push(n)})),e}}class gu{constructor(e,t,n,r,s,i,o,a,l){this.query=e,this.docs=t,this.oldDocs=n,this.docChanges=r,this.mutatedKeys=s,this.fromCache=i,this.syncStateChanged=o,this.excludesMetadataChanges=a,this.hasCachedResults=l}static fromInitialDocuments(e,t,n,r,s){const i=[];return t.forEach((e=>{i.push({type:0,doc:e})})),new gu(e,t,fu.emptySet(t),i,n,r,!0,!1,s)}get hasPendingWrites(){return!this.mutatedKeys.isEmpty()}isEqual(e){if(!(this.fromCache===e.fromCache&&this.hasCachedResults===e.hasCachedResults&&this.syncStateChanged===e.syncStateChanged&&this.mutatedKeys.isEqual(e.mutatedKeys)&&ko(this.query,e.query)&&this.docs.isEqual(e.docs)&&this.oldDocs.isEqual(e.oldDocs)))return!1;const t=this.docChanges,n=e.docChanges;if(t.length!==n.length)return!1;for(let e=0;e<t.length;e++)if(t[e].type!==n[e].type||!t[e].doc.isEqual(n[e].doc))return!1;return!0}}class yu{constructor(){this.H_=void 0,this.J_=[]}Y_(){return this.J_.some((e=>e.Z_()))}}class vu{constructor(){this.queries=wu(),this.onlineState="Unknown",this.X_=new Set}terminate(){!function(e,t){const n=fs(e),r=n.queries;n.queries=wu(),r.forEach(((e,n)=>{for(const e of n.J_)e.onError(t)}))}(this,new gs(ms.ABORTED,"Firestore shutting down"))}}function wu(){return new qo((e=>Lo(e)),ko)}async function bu(e,t){const n=fs(e);let r=3;const s=t.query;let i=n.queries.get(s);i?!i.Y_()&&t.Z_()&&(r=2):(i=new yu,r=t.Z_()?0:1);try{switch(r){case 0:i.H_=await n.onListen(s,!0);break;case 1:i.H_=await n.onListen(s,!1);break;case 2:await n.onFirstRemoteStoreListen(s)}}catch(e){const n=pu(e,`Initialization of query '${Mo(t.query)}' failed`);return void t.onError(n)}n.queries.set(s,i),i.J_.push(t),t.ea(n.onlineState),i.H_&&t.ta(i.H_)&&_u(n)}async function Su(e,t){const n=fs(e),r=t.query;let s=3;const i=n.queries.get(r);if(i){const e=i.J_.indexOf(t);e>=0&&(i.J_.splice(e,1),0===i.J_.length?s=t.Z_()?0:1:!i.Y_()&&t.Z_()&&(s=2))}switch(s){case 0:return n.queries.delete(r),n.onUnlisten(r,!0);case 1:return n.queries.delete(r),n.onUnlisten(r,!1);case 2:return n.onLastRemoteStoreUnlisten(r);default:return}}function Eu(e,t){const n=fs(e);let r=!1;for(const e of t){const t=e.query,s=n.queries.get(t);if(s){for(const t of s.J_)t.ta(e)&&(r=!0);s.H_=e}}r&&_u(n)}function Tu(e,t,n){const r=fs(e),s=r.queries.get(t);if(s)for(const e of s.J_)e.onError(n);r.queries.delete(t)}function _u(e){e.X_.forEach((e=>{e.next()}))}var Cu,xu;(xu=Cu||(Cu={})).na="default",xu.Cache="cache";class Au{constructor(e,t,n){this.query=e,this.ra=t,this.ia=!1,this.sa=null,this.onlineState="Unknown",this.options=n||{}}ta(e){if(!this.options.includeMetadataChanges){const t=[];for(const n of e.docChanges)3!==n.type&&t.push(n);e=new gu(e.query,e.docs,e.oldDocs,t,e.mutatedKeys,e.fromCache,e.syncStateChanged,!0,e.hasCachedResults)}let t=!1;return this.ia?this.oa(e)&&(this.ra.next(e),t=!0):this._a(e,this.onlineState)&&(this.aa(e),t=!0),this.sa=e,t}onError(e){this.ra.error(e)}ea(e){this.onlineState=e;let t=!1;return this.sa&&!this.ia&&this._a(this.sa,e)&&(this.aa(this.sa),t=!0),t}_a(e,t){if(!e.fromCache)return!0;if(!this.Z_())return!0;const n="Offline"!==t;return(!this.options.ua||!n)&&(!e.docs.isEmpty()||e.hasCachedResults||"Offline"===t)}oa(e){if(e.docChanges.length>0)return!0;const t=this.sa&&this.sa.hasPendingWrites!==e.hasPendingWrites;return!(!e.syncStateChanged&&!t)&&!0===this.options.includeMetadataChanges}aa(e){e=gu.fromInitialDocuments(e.query,e.docs,e.mutatedKeys,e.fromCache,e.hasCachedResults),this.ia=!0,this.ra.next(e)}Z_(){return this.options.source!==Cu.Cache}}class Iu{constructor(e){this.key=e}}class ku{constructor(e){this.key=e}}class Lu{constructor(e,t){this.query=e,this.Ea=t,this.Aa=null,this.hasCachedResults=!1,this.current=!1,this.Ra=Wo(),this.mutatedKeys=Wo(),this.Va=Po(e),this.ma=new fu(this.Va)}get fa(){return this.Ea}ga(e,t){const n=t?t.pa:new mu,r=t?t.ma:this.ma;let s=t?t.mutatedKeys:this.mutatedKeys,i=r,o=!1;const a="F"===this.query.limitType&&r.size===this.query.limit?r.last():null,l="L"===this.query.limitType&&r.size===this.query.limit?r.first():null;if(e.inorderTraversal(((e,t)=>{const c=r.get(e),u=Do(this.query,t)?t:null,d=!!c&&this.mutatedKeys.has(c.key),h=!!u&&(u.hasLocalMutations||this.mutatedKeys.has(u.key)&&u.hasCommittedMutations);let p=!1;c&&u?c.data.isEqual(u.data)?d!==h&&(n.track({type:3,doc:u}),p=!0):this.ya(c,u)||(n.track({type:2,doc:u}),p=!0,(a&&this.Va(u,a)>0||l&&this.Va(u,l)<0)&&(o=!0)):!c&&u?(n.track({type:0,doc:u}),p=!0):c&&!u&&(n.track({type:1,doc:c}),p=!0,(a||l)&&(o=!0)),p&&(u?(i=i.add(u),s=h?s.add(e):s.delete(e)):(i=i.delete(e),s=s.delete(e)))})),null!==this.query.limit)for(;i.size>this.query.limit;){const e="F"===this.query.limitType?i.last():i.first();i=i.delete(e.key),s=s.delete(e.key),n.track({type:1,doc:e})}return{ma:i,pa:n,ss:o,mutatedKeys:s}}ya(e,t){return e.hasLocalMutations&&t.hasCommittedMutations&&!t.hasLocalMutations}applyChanges(e,t,n,r){const s=this.ma;this.ma=e.ma,this.mutatedKeys=e.mutatedKeys;const i=e.pa.j_();i.sort(((e,t)=>function(e,t){const n=e=>{switch(e){case 0:return 1;case 2:case 3:return 2;case 1:return 0;default:return hs()}};return n(e)-n(t)}(e.type,t.type)||this.Va(e.doc,t.doc))),this.wa(n),r=null!=r&&r;const o=t&&!r?this.Sa():[],a=0===this.Ra.size&&this.current&&!r?1:0,l=a!==this.Aa;return this.Aa=a,0!==i.length||l?{snapshot:new gu(this.query,e.ma,s,i,e.mutatedKeys,0===a,l,!1,!!n&&n.resumeToken.approximateByteSize()>0),ba:o}:{ba:o}}ea(e){return this.current&&"Offline"===e?(this.current=!1,this.applyChanges({ma:this.ma,pa:new mu,mutatedKeys:this.mutatedKeys,ss:!1},!1)):{ba:[]}}Da(e){return!this.Ea.has(e)&&!!this.ma.has(e)&&!this.ma.get(e).hasLocalMutations}wa(e){e&&(e.addedDocuments.forEach((e=>this.Ea=this.Ea.add(e))),e.modifiedDocuments.forEach((e=>{})),e.removedDocuments.forEach((e=>this.Ea=this.Ea.delete(e))),this.current=e.current)}Sa(){if(!this.current)return[];const e=this.Ra;this.Ra=Wo(),this.ma.forEach((e=>{this.Da(e.key)&&(this.Ra=this.Ra.add(e.key))}));const t=[];return e.forEach((e=>{this.Ra.has(e)||t.push(new ku(e))})),this.Ra.forEach((n=>{e.has(n)||t.push(new Iu(n))})),t}va(e){this.Ea=e.Es,this.Ra=Wo();const t=this.ga(e.documents);return this.applyChanges(t,!0)}Ca(){return gu.fromInitialDocuments(this.query,this.ma,this.mutatedKeys,0===this.Aa,this.hasCachedResults)}}class Mu{constructor(e,t,n){this.query=e,this.targetId=t,this.view=n}}class Du{constructor(e){this.key=e,this.Fa=!1}}class Nu{constructor(e,t,n,r,s,i){this.localStore=e,this.remoteStore=t,this.eventManager=n,this.sharedClientState=r,this.currentUser=s,this.maxConcurrentLimboResolutions=i,this.Ma={},this.xa=new qo((e=>Lo(e)),ko),this.Oa=new Map,this.Na=new Set,this.Ba=new li(qs.comparator),this.La=new Map,this.ka=new Ql,this.qa={},this.Qa=new Map,this.Ka=Rl.Qn(),this.onlineState="Unknown",this.$a=void 0}get isPrimaryClient(){return!0===this.$a}}async function Pu(e,t,n=!0){const r=td(e);let s;const i=r.xa.get(t);return i?(r.sharedClientState.addLocalQueryTarget(i.targetId),s=i.view.Ca()):s=await qu(r,t,n,!0),s}async function Ou(e,t){const n=td(e);await qu(n,t,!0,!1)}async function qu(e,t,n,r){const s=await fc(e.localStore,xo(t)),i=s.targetId,o=e.sharedClientState.addLocalQueryTarget(i,n);let a;return r&&(a=await Ru(e,t,i,"current"===o,s.resumeToken)),e.isPrimaryClient&&n&&Bc(e.remoteStore,s),a}async function Ru(e,t,n,r,s){e.Ua=(t,n,r)=>async function(e,t,n,r){let s=t.view.ga(n);s.ss&&(s=await gc(e.localStore,t.query,!1).then((({documents:e})=>t.view.ga(e,s))));const i=r&&r.targetChanges.get(t.targetId),o=r&&null!=r.targetMismatches.get(t.targetId),a=t.view.applyChanges(s,e.isPrimaryClient,i,o);return Qu(e,t.targetId,a.ba),a.snapshot}(e,t,n,r);const i=await gc(e.localStore,t,!0),o=new Lu(t,i.Es),a=o.ga(i.documents),l=za.createSynthesizedTargetChangeForCurrentChange(n,r&&"Offline"!==e.onlineState,s),c=o.applyChanges(a,e.isPrimaryClient,l);Qu(e,n,c.ba);const u=new Mu(t,n,o);return e.xa.set(t,u),e.Oa.has(n)?e.Oa.get(n).push(t):e.Oa.set(n,[t]),c.snapshot}async function Fu(e,t,n){const r=fs(e),s=r.xa.get(t),i=r.Oa.get(s.targetId);if(i.length>1)return r.Oa.set(s.targetId,i.filter((e=>!ko(e,t)))),void r.xa.delete(t);r.isPrimaryClient?(r.sharedClientState.removeLocalQueryTarget(s.targetId),r.sharedClientState.isActiveQueryTarget(s.targetId)||await mc(r.localStore,s.targetId,!1).then((()=>{r.sharedClientState.clearQueryState(s.targetId),n&&$c(r.remoteStore,s.targetId),Wu(r,s.targetId)})).catch(Us)):(Wu(r,s.targetId),await mc(r.localStore,s.targetId,!0))}async function Bu(e,t){const n=fs(e),r=n.xa.get(t),s=n.Oa.get(r.targetId);n.isPrimaryClient&&1===s.length&&(n.sharedClientState.removeLocalQueryTarget(r.targetId),$c(n.remoteStore,r.targetId))}async function $u(e,t){const n=fs(e);try{const e=await function(e,t){const n=fs(e),r=t.snapshotVersion;let s=n.us;return n.persistence.runTransaction("Apply remote event","readwrite-primary",(e=>{const i=n.hs.newChangeBuffer({trackRemovals:!0});s=n.us;const o=[];t.targetChanges.forEach(((i,a)=>{const l=s.get(a);if(!l)return;o.push(n.Gr.removeMatchingKeys(e,i.removedDocuments,a).next((()=>n.Gr.addMatchingKeys(e,i.addedDocuments,a))));let c=l.withSequenceNumber(e.currentSequenceNumber);null!==t.targetMismatches.get(a)?c=c.withResumeToken(mi.EMPTY_BYTE_STRING,Ms.min()).withLastLimboFreeSnapshotVersion(Ms.min()):i.resumeToken.approximateByteSize()>0&&(c=c.withResumeToken(i.resumeToken,r)),s=s.insert(a,c),function(e,t,n){return 0===e.resumeToken.approximateByteSize()||t.snapshotVersion.toMicroseconds()-e.snapshotVersion.toMicroseconds()>=3e8||n.addedDocuments.size+n.modifiedDocuments.size+n.removedDocuments.size>0}(l,c,i)&&o.push(n.Gr.updateTargetData(e,c))}));let a=Fo(),l=Wo();if(t.documentUpdates.forEach((r=>{t.resolvedLimboDocuments.has(r)&&o.push(n.persistence.referenceDelegate.updateLimboDocument(e,r))})),o.push(hc(e,i,t.documentUpdates).next((e=>{a=e.Is,l=e.ds}))),!r.isEqual(Ms.min())){const t=n.Gr.getLastRemoteSnapshotVersion(e).next((t=>n.Gr.setTargetsMetadata(e,e.currentSequenceNumber,r)));o.push(t)}return Gs.waitFor(o).next((()=>i.apply(e))).next((()=>n.localDocuments.getLocalViewOfDocuments(e,a,l))).next((()=>a))})).then((e=>(n.us=s,e)))}(n.localStore,t);t.targetChanges.forEach(((e,t)=>{const r=n.La.get(t);r&&(ps(e.addedDocuments.size+e.modifiedDocuments.size+e.removedDocuments.size<=1),e.addedDocuments.size>0?r.Fa=!0:e.modifiedDocuments.size>0?ps(r.Fa):e.removedDocuments.size>0&&(ps(r.Fa),r.Fa=!1))})),await Ju(n,e,t)}catch(e){await Us(e)}}function Vu(e,t,n){const r=fs(e);if(r.isPrimaryClient&&0===n||!r.isPrimaryClient&&1===n){const e=[];r.xa.forEach(((n,r)=>{const s=r.view.ea(t);s.snapshot&&e.push(s.snapshot)})),function(e,t){const n=fs(e);n.onlineState=t;let r=!1;n.queries.forEach(((e,n)=>{for(const e of n.J_)e.ea(t)&&(r=!0)})),r&&_u(n)}(r.eventManager,t),e.length&&r.Ma.R_(e),r.onlineState=t,r.isPrimaryClient&&r.sharedClientState.setOnlineState(t)}}async function ju(e,t,n){const r=fs(e);r.sharedClientState.updateQueryState(t,"rejected",n);const s=r.La.get(t),i=s&&s.key;if(i){let e=new li(qs.comparator);e=e.insert(i,Gi.newNoDocument(i,Ms.min()));const n=Wo().add(i),s=new ja(Ms.min(),new Map,new li(Is),e,n);await $u(r,s),r.Ba=r.Ba.remove(i),r.La.delete(t),Xu(r)}else await mc(r.localStore,t,!1).then((()=>Wu(r,t,n))).catch(Us)}async function zu(e,t){const n=fs(e),r=t.batch.batchId;try{const e=await function(e,t){const n=fs(e);return n.persistence.runTransaction("Acknowledge batch","readwrite-primary",(e=>{const r=t.batch.keys(),s=n.hs.newChangeBuffer({trackRemovals:!0});return function(e,t,n,r){const s=n.batch,i=s.keys();let o=Gs.resolve();return i.forEach((e=>{o=o.next((()=>r.getEntry(t,e))).next((t=>{const i=n.docVersions.get(e);ps(null!==i),t.version.compareTo(i)<0&&(s.applyToRemoteDocument(t,n),t.isValidDocument()&&(t.setReadTime(n.commitVersion),r.addEntry(t)))}))})),o.next((()=>e.mutationQueue.removeMutationBatch(t,s)))}(n,e,t,s).next((()=>s.apply(e))).next((()=>n.mutationQueue.performConsistencyCheck(e))).next((()=>n.documentOverlayCache.removeOverlaysForBatchId(e,r,t.batch.batchId))).next((()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e,function(e){let t=Wo();for(let n=0;n<e.mutationResults.length;++n)e.mutationResults[n].transformResults.length>0&&(t=t.add(e.batch.mutations[n].key));return t}(t)))).next((()=>n.localDocuments.getDocuments(e,r)))}))}(n.localStore,t);Hu(n,r,null),Gu(n,r),n.sharedClientState.updateMutationState(r,"acknowledged"),await Ju(n,e)}catch(e){await Us(e)}}async function Uu(e,t,n){const r=fs(e);try{const e=await function(e,t){const n=fs(e);return n.persistence.runTransaction("Reject batch","readwrite-primary",(e=>{let r;return n.mutationQueue.lookupMutationBatch(e,t).next((t=>(ps(null!==t),r=t.keys(),n.mutationQueue.removeMutationBatch(e,t)))).next((()=>n.mutationQueue.performConsistencyCheck(e))).next((()=>n.documentOverlayCache.removeOverlaysForBatchId(e,r,t))).next((()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e,r))).next((()=>n.localDocuments.getDocuments(e,r)))}))}(r.localStore,t);Hu(r,t,n),Gu(r,t),r.sharedClientState.updateMutationState(t,"rejected",n),await Ju(r,e)}catch(n){await Us(n)}}function Gu(e,t){(e.Qa.get(t)||[]).forEach((e=>{e.resolve()})),e.Qa.delete(t)}function Hu(e,t,n){const r=fs(e);let s=r.qa[r.currentUser.toKey()];if(s){const e=s.get(t);e&&(n?e.reject(n):e.resolve(),s=s.remove(t)),r.qa[r.currentUser.toKey()]=s}}function Wu(e,t,n=null){e.sharedClientState.removeLocalQueryTarget(t);for(const r of e.Oa.get(t))e.xa.delete(r),n&&e.Ma.Wa(r,n);e.Oa.delete(t),e.isPrimaryClient&&e.ka.yr(t).forEach((t=>{e.ka.containsKey(t)||Ku(e,t)}))}function Ku(e,t){e.Na.delete(t.path.canonicalString());const n=e.Ba.get(t);null!==n&&($c(e.remoteStore,n),e.Ba=e.Ba.remove(t),e.La.delete(n),Xu(e))}function Qu(e,t,n){for(const r of n)r instanceof Iu?(e.ka.addReference(r.key,t),Yu(e,r)):r instanceof ku?(ls("SyncEngine","Document no longer in limbo: "+r.key),e.ka.removeReference(r.key,t),e.ka.containsKey(r.key)||Ku(e,r.key)):hs()}function Yu(e,t){const n=t.key,r=n.path.canonicalString();e.Ba.get(n)||e.Na.has(r)||(ls("SyncEngine","New document in limbo: "+n),e.Na.add(r),Xu(e))}function Xu(e){for(;e.Na.size>0&&e.Ba.size<e.maxConcurrentLimboResolutions;){const t=e.Na.values().next().value;e.Na.delete(t);const n=new qs(Ns.fromString(t)),r=e.Ka.next();e.La.set(r,new Du(n)),e.Ba=e.Ba.insert(n,r),Bc(e.remoteStore,new kl(xo(Eo(n.path)),r,"TargetPurposeLimboResolution",Ks.oe))}}async function Ju(e,t,n){const r=fs(e),s=[],i=[],o=[];r.xa.isEmpty()||(r.xa.forEach(((e,a)=>{o.push(r.Ua(a,t,n).then((e=>{var t;if((e||n)&&r.isPrimaryClient){const s=e?!e.fromCache:null===(t=null==n?void 0:n.targetChanges.get(a.targetId))||void 0===t?void 0:t.current;r.sharedClientState.updateQueryState(a.targetId,s?"current":"not-current")}if(e){s.push(e);const t=ic.zi(a.targetId,e);i.push(t)}})))})),await Promise.all(o),r.Ma.R_(s),await async function(e,t){const n=fs(e);try{await n.persistence.runTransaction("notifyLocalViewChanges","readwrite",(e=>Gs.forEach(t,(t=>Gs.forEach(t.Wi,(r=>n.persistence.referenceDelegate.addReference(e,t.targetId,r))).next((()=>Gs.forEach(t.Gi,(r=>n.persistence.referenceDelegate.removeReference(e,t.targetId,r)))))))))}catch(e){if(!Ws(e))throw e;ls("LocalStore","Failed to update sequence numbers: "+e)}for(const e of t){const t=e.targetId;if(!e.fromCache){const e=n.us.get(t),r=e.snapshotVersion,s=e.withLastLimboFreeSnapshotVersion(r);n.us=n.us.insert(t,s)}}}(r.localStore,i))}async function Zu(e,t){const n=fs(e);if(!n.currentUser.isEqual(t)){ls("SyncEngine","User change. New user:",t.toKey());const e=await uc(n.localStore,t);n.currentUser=t,function(e,t){e.Qa.forEach((e=>{e.forEach((e=>{e.reject(new gs(ms.CANCELLED,t))}))})),e.Qa.clear()}(n,"'waitForPendingWrites' promise is rejected due to a user change."),n.sharedClientState.handleUserChange(t,e.removedBatchIds,e.addedBatchIds),await Ju(n,e.Ts)}}function ed(e,t){const n=fs(e),r=n.La.get(t);if(r&&r.Fa)return Wo().add(r.key);{let e=Wo();const r=n.Oa.get(t);if(!r)return e;for(const t of r){const r=n.xa.get(t);e=e.unionWith(r.view.fa)}return e}}function td(e){const t=fs(e);return t.remoteStore.remoteSyncer.applyRemoteEvent=$u.bind(null,t),t.remoteStore.remoteSyncer.getRemoteKeysForTarget=ed.bind(null,t),t.remoteStore.remoteSyncer.rejectListen=ju.bind(null,t),t.Ma.R_=Eu.bind(null,t.eventManager),t.Ma.Wa=Tu.bind(null,t.eventManager),t}function nd(e){const t=fs(e);return t.remoteStore.remoteSyncer.applySuccessfulWrite=zu.bind(null,t),t.remoteStore.remoteSyncer.rejectFailedWrite=Uu.bind(null,t),t}class rd{constructor(){this.kind="memory",this.synchronizeTabs=!1}async initialize(e){this.serializer=kc(e.databaseInfo.databaseId),this.sharedClientState=this.za(e),this.persistence=this.ja(e),await this.persistence.start(),this.localStore=this.Ha(e),this.gcScheduler=this.Ja(e,this.localStore),this.indexBackfillerScheduler=this.Ya(e,this.localStore)}Ja(e,t){return null}Ya(e,t){return null}Ha(e){return cc(this.persistence,new ac,e.initialUser,this.serializer)}ja(e){return new tc(rc.ei,this.serializer)}za(e){return new wc}async terminate(){var e,t;null===(e=this.gcScheduler)||void 0===e||e.stop(),null===(t=this.indexBackfillerScheduler)||void 0===t||t.stop(),this.sharedClientState.shutdown(),await this.persistence.shutdown()}}rd.provider={build:()=>new rd};class sd extends rd{constructor(e){super(),this.cacheSizeBytes=e}Ja(e,t){ps(this.persistence.referenceDelegate instanceof sc);const n=this.persistence.referenceDelegate.garbageCollector;return new $l(n,e.asyncQueue,t)}ja(e){const t=void 0!==this.cacheSizeBytes?ql.withCacheSize(this.cacheSizeBytes):ql.DEFAULT;return new tc((e=>sc.ei(e,t)),this.serializer)}}class id{async initialize(e,t){this.localStore||(this.localStore=e.localStore,this.sharedClientState=e.sharedClientState,this.datastore=this.createDatastore(t),this.remoteStore=this.createRemoteStore(t),this.eventManager=this.createEventManager(t),this.syncEngine=this.createSyncEngine(t,!e.synchronizeTabs),this.sharedClientState.onlineStateHandler=e=>Vu(this.syncEngine,e,1),this.remoteStore.remoteSyncer.handleCredentialChange=Zu.bind(null,this.syncEngine),await cu(this.remoteStore,this.syncEngine.isPrimaryClient))}createEventManager(e){return new vu}createDatastore(e){const t=kc(e.databaseInfo.databaseId),n=function(e){return new Ac(e)}(e.databaseInfo);return function(e,t,n,r){return new Pc(e,t,n,r)}(e.authCredentials,e.appCheckCredentials,n,t)}createRemoteStore(e){return function(e,t,n,r,s){return new qc(e,t,n,r,s)}(this.localStore,this.datastore,e.asyncQueue,(e=>Vu(this.syncEngine,e,0)),Sc.p()?new Sc:new bc)}createSyncEngine(e,t){return function(e,t,n,r,s,i,o){const a=new Nu(e,t,n,r,s,i);return o&&(a.$a=!0),a}(this.localStore,this.remoteStore,this.eventManager,this.sharedClientState,e.initialUser,e.maxConcurrentLimboResolutions,t)}async terminate(){var e,t;await async function(e){const t=fs(e);ls("RemoteStore","RemoteStore shutting down."),t.k_.add(5),await Fc(t),t.Q_.shutdown(),t.K_.set("Unknown")}(this.remoteStore),null===(e=this.datastore)||void 0===e||e.terminate(),null===(t=this.eventManager)||void 0===t||t.terminate()}}id.provider={build:()=>new id};class od{constructor(e){this.observer=e,this.muted=!1}next(e){this.muted||this.observer.next&&this.Xa(this.observer.next,e)}error(e){this.muted||(this.observer.error?this.Xa(this.observer.error,e):cs("Uncaught Error in snapshot listener:",e.toString()))}eu(){this.muted=!0}Xa(e,t){setTimeout((()=>{this.muted||e(t)}),0)}}class ad{constructor(e,t,n,r,s){this.authCredentials=e,this.appCheckCredentials=t,this.asyncQueue=n,this.databaseInfo=r,this.user=ss.UNAUTHENTICATED,this.clientId=As.newId(),this.authCredentialListener=()=>Promise.resolve(),this.appCheckCredentialListener=()=>Promise.resolve(),this._uninitializedComponentsProvider=s,this.authCredentials.start(n,(async e=>{ls("FirestoreClient","Received user=",e.uid),await this.authCredentialListener(e),this.user=e})),this.appCheckCredentials.start(n,(e=>(ls("FirestoreClient","Received new app check token=",e),this.appCheckCredentialListener(e,this.user))))}get configuration(){return{asyncQueue:this.asyncQueue,databaseInfo:this.databaseInfo,clientId:this.clientId,authCredentials:this.authCredentials,appCheckCredentials:this.appCheckCredentials,initialUser:this.user,maxConcurrentLimboResolutions:100}}setCredentialChangeListener(e){this.authCredentialListener=e}setAppCheckTokenChangeListener(e){this.appCheckCredentialListener=e}terminate(){this.asyncQueue.enterRestrictedMode();const e=new ys;return this.asyncQueue.enqueueAndForgetEvenWhileRestricted((async()=>{try{this._onlineComponents&&await this._onlineComponents.terminate(),this._offlineComponents&&await this._offlineComponents.terminate(),this.authCredentials.shutdown(),this.appCheckCredentials.shutdown(),e.resolve()}catch(t){const n=pu(t,"Failed to shutdown persistence");e.reject(n)}})),e.promise}}async function ld(e,t){e.asyncQueue.verifyOperationInProgress(),ls("FirestoreClient","Initializing OfflineComponentProvider");const n=e.configuration;await t.initialize(n);let r=n.initialUser;e.setCredentialChangeListener((async e=>{r.isEqual(e)||(await uc(t.localStore,e),r=e)})),t.persistence.setDatabaseDeletedListener((()=>e.terminate())),e._offlineComponents=t}async function cd(e,t){e.asyncQueue.verifyOperationInProgress();const n=await ud(e);ls("FirestoreClient","Initializing OnlineComponentProvider"),await t.initialize(n,e.configuration),e.setCredentialChangeListener((e=>lu(t.remoteStore,e))),e.setAppCheckTokenChangeListener(((e,n)=>lu(t.remoteStore,n))),e._onlineComponents=t}async function ud(e){if(!e._offlineComponents)if(e._uninitializedComponentsProvider){ls("FirestoreClient","Using user provided OfflineComponentProvider");try{await ld(e,e._uninitializedComponentsProvider._offline)}catch(t){const n=t;if(!function(e){return"FirebaseError"===e.name?e.code===ms.FAILED_PRECONDITION||e.code===ms.UNIMPLEMENTED:!("undefined"!=typeof DOMException&&e instanceof DOMException)||22===e.code||20===e.code||11===e.code}(n))throw n;us("Error using user provided cache. Falling back to memory cache: "+n),await ld(e,new rd)}}else ls("FirestoreClient","Using default OfflineComponentProvider"),await ld(e,new sd(void 0));return e._offlineComponents}async function dd(e){return e._onlineComponents||(e._uninitializedComponentsProvider?(ls("FirestoreClient","Using user provided OnlineComponentProvider"),await cd(e,e._uninitializedComponentsProvider._online)):(ls("FirestoreClient","Using default OnlineComponentProvider"),await cd(e,new id))),e._onlineComponents}function hd(e){return dd(e).then((e=>e.syncEngine))}async function pd(e){const t=await dd(e),n=t.eventManager;return n.onListen=Pu.bind(null,t.syncEngine),n.onUnlisten=Fu.bind(null,t.syncEngine),n.onFirstRemoteStoreListen=Ou.bind(null,t.syncEngine),n.onLastRemoteStoreUnlisten=Bu.bind(null,t.syncEngine),n}function fd(e,t,n={}){const r=new ys;return e.asyncQueue.enqueueAndForget((async()=>function(e,t,n,r,s){const i=new od({next:a=>{i.eu(),t.enqueueAndForget((()=>Su(e,o)));const l=a.docs.has(n);!l&&a.fromCache?s.reject(new gs(ms.UNAVAILABLE,"Failed to get document because the client is offline.")):l&&a.fromCache&&r&&"server"===r.source?s.reject(new gs(ms.UNAVAILABLE,'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')):s.resolve(a)},error:e=>s.reject(e)}),o=new Au(Eo(n.path),i,{includeMetadataChanges:!0,ua:!0});return bu(e,o)}(await pd(e),e.asyncQueue,t,n,r))),r.promise}function md(e,t,n={}){const r=new ys;return e.asyncQueue.enqueueAndForget((async()=>function(e,t,n,r,s){const i=new od({next:n=>{i.eu(),t.enqueueAndForget((()=>Su(e,o))),n.fromCache&&"server"===r.source?s.reject(new gs(ms.UNAVAILABLE,'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')):s.resolve(n)},error:e=>s.reject(e)}),o=new Au(n,i,{includeMetadataChanges:!0,ua:!0});return bu(e,o)}(await pd(e),e.asyncQueue,t,n,r))),r.promise}function gd(e){const t={};return void 0!==e.timeoutSeconds&&(t.timeoutSeconds=e.timeoutSeconds),t}const yd=new Map;function vd(e,t,n){if(!n)throw new gs(ms.INVALID_ARGUMENT,`Function ${e}() cannot be called with an empty ${t}.`)}function wd(e){if(!qs.isDocumentKey(e))throw new gs(ms.INVALID_ARGUMENT,`Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`)}function bd(e){if(qs.isDocumentKey(e))throw new gs(ms.INVALID_ARGUMENT,`Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`)}function Sd(e){if(void 0===e)return"undefined";if(null===e)return"null";if("string"==typeof e)return e.length>20&&(e=`${e.substring(0,20)}...`),JSON.stringify(e);if("number"==typeof e||"boolean"==typeof e)return""+e;if("object"==typeof e){if(e instanceof Array)return"an array";{const t=function(e){return e.constructor?e.constructor.name:null}(e);return t?`a custom ${t} object`:"an object"}}return"function"==typeof e?"a function":hs()}function Ed(e,t){if("_delegate"in e&&(e=e._delegate),!(e instanceof t)){if(t.name===e.constructor.name)throw new gs(ms.INVALID_ARGUMENT,"Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");{const n=Sd(e);throw new gs(ms.INVALID_ARGUMENT,`Expected type '${t.name}', but it was: ${n}`)}}return e}class Td{constructor(e){var t,n;if(void 0===e.host){if(void 0!==e.ssl)throw new gs(ms.INVALID_ARGUMENT,"Can't provide ssl option if host option is not set");this.host="firestore.googleapis.com",this.ssl=!0}else this.host=e.host,this.ssl=null===(t=e.ssl)||void 0===t||t;if(this.credentials=e.credentials,this.ignoreUndefinedProperties=!!e.ignoreUndefinedProperties,this.localCache=e.localCache,void 0===e.cacheSizeBytes)this.cacheSizeBytes=41943040;else{if(-1!==e.cacheSizeBytes&&e.cacheSizeBytes<1048576)throw new gs(ms.INVALID_ARGUMENT,"cacheSizeBytes must be at least 1048576");this.cacheSizeBytes=e.cacheSizeBytes}(function(e,t,n,r){if(!0===t&&!0===r)throw new gs(ms.INVALID_ARGUMENT,`${e} and ${n} cannot be used together.`)})("experimentalForceLongPolling",e.experimentalForceLongPolling,"experimentalAutoDetectLongPolling",e.experimentalAutoDetectLongPolling),this.experimentalForceLongPolling=!!e.experimentalForceLongPolling,this.experimentalForceLongPolling?this.experimentalAutoDetectLongPolling=!1:void 0===e.experimentalAutoDetectLongPolling?this.experimentalAutoDetectLongPolling=!0:this.experimentalAutoDetectLongPolling=!!e.experimentalAutoDetectLongPolling,this.experimentalLongPollingOptions=gd(null!==(n=e.experimentalLongPollingOptions)&&void 0!==n?n:{}),function(e){if(void 0!==e.timeoutSeconds){if(isNaN(e.timeoutSeconds))throw new gs(ms.INVALID_ARGUMENT,`invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);if(e.timeoutSeconds<5)throw new gs(ms.INVALID_ARGUMENT,`invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);if(e.timeoutSeconds>30)throw new gs(ms.INVALID_ARGUMENT,`invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`)}}(this.experimentalLongPollingOptions),this.useFetchStreams=!!e.useFetchStreams}isEqual(e){return this.host===e.host&&this.ssl===e.ssl&&this.credentials===e.credentials&&this.cacheSizeBytes===e.cacheSizeBytes&&this.experimentalForceLongPolling===e.experimentalForceLongPolling&&this.experimentalAutoDetectLongPolling===e.experimentalAutoDetectLongPolling&&function(e,t){return e.timeoutSeconds===t.timeoutSeconds}(this.experimentalLongPollingOptions,e.experimentalLongPollingOptions)&&this.ignoreUndefinedProperties===e.ignoreUndefinedProperties&&this.useFetchStreams===e.useFetchStreams}}class _d{constructor(e,t,n,r){this._authCredentials=e,this._appCheckCredentials=t,this._databaseId=n,this._app=r,this.type="firestore-lite",this._persistenceKey="(lite)",this._settings=new Td({}),this._settingsFrozen=!1,this._terminateTask="notTerminated"}get app(){if(!this._app)throw new gs(ms.FAILED_PRECONDITION,"Firestore was not initialized using the Firebase SDK. 'app' is not available");return this._app}get _initialized(){return this._settingsFrozen}get _terminated(){return"notTerminated"!==this._terminateTask}_setSettings(e){if(this._settingsFrozen)throw new gs(ms.FAILED_PRECONDITION,"Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");this._settings=new Td(e),void 0!==e.credentials&&(this._authCredentials=function(e){if(!e)return new ws;switch(e.type){case"firstParty":return new Ts(e.sessionIndex||"0",e.iamToken||null,e.authTokenFactory||null);case"provider":return e.client;default:throw new gs(ms.INVALID_ARGUMENT,"makeAuthCredentialsProvider failed due to invalid credential type")}}(e.credentials))}_getSettings(){return this._settings}_freezeSettings(){return this._settingsFrozen=!0,this._settings}_delete(){return"notTerminated"===this._terminateTask&&(this._terminateTask=this._terminate()),this._terminateTask}async _restart(){"notTerminated"===this._terminateTask?await this._terminate():this._terminateTask="notTerminated"}toJSON(){return{app:this._app,databaseId:this._databaseId,settings:this._settings}}_terminate(){return function(e){const t=yd.get(e);t&&(ls("ComponentProvider","Removing Datastore"),yd.delete(e),t.terminate())}(this),Promise.resolve()}}function Cd(e,t,n,r={}){var s;const i=(e=Ed(e,_d))._getSettings(),o=`${t}:${n}`;if("firestore.googleapis.com"!==i.host&&i.host!==o&&us("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."),e._setSettings(Object.assign(Object.assign({},i),{host:o,ssl:!1})),r.mockUserToken){let t,n;if("string"==typeof r.mockUserToken)t=r.mockUserToken,n=ss.MOCK_USER;else{t=function(e,t){if(e.uid)throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');const n=t||"demo-project",r=e.iat||0,s=e.sub||e.user_id;if(!s)throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");const i=Object.assign({iss:`https://securetoken.google.com/${n}`,aud:n,iat:r,exp:r+3600,auth_time:r,sub:s,user_id:s,firebase:{sign_in_provider:"custom",identities:{}}},e);return[_n(JSON.stringify({alg:"none",type:"JWT"})),_n(JSON.stringify(i)),""].join(".")}(r.mockUserToken,null===(s=e._app)||void 0===s?void 0:s.options.projectId);const i=r.mockUserToken.sub||r.mockUserToken.user_id;if(!i)throw new gs(ms.INVALID_ARGUMENT,"mockUserToken must contain 'sub' or 'user_id' field!");n=new ss(i)}e._authCredentials=new bs(new vs(t,n))}}class xd{constructor(e,t,n){this.converter=t,this._query=n,this.type="query",this.firestore=e}withConverter(e){return new xd(this.firestore,e,this._query)}}class Ad{constructor(e,t,n){this.converter=t,this._key=n,this.type="document",this.firestore=e}get _path(){return this._key.path}get id(){return this._key.path.lastSegment()}get path(){return this._key.path.canonicalString()}get parent(){return new Id(this.firestore,this.converter,this._key.path.popLast())}withConverter(e){return new Ad(this.firestore,e,this._key)}}class Id extends xd{constructor(e,t,n){super(e,t,Eo(n)),this._path=n,this.type="collection"}get id(){return this._query.path.lastSegment()}get path(){return this._query.path.canonicalString()}get parent(){const e=this._path.popLast();return e.isEmpty()?null:new Ad(this.firestore,null,new qs(e))}withConverter(e){return new Id(this.firestore,e,this._path)}}function kd(e,t,...n){if(e=Bn(e),vd("collection","path",t),e instanceof _d){const r=Ns.fromString(t,...n);return bd(r),new Id(e,null,r)}{if(!(e instanceof Ad||e instanceof Id))throw new gs(ms.INVALID_ARGUMENT,"Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");const r=e._path.child(Ns.fromString(t,...n));return bd(r),new Id(e.firestore,null,r)}}function Ld(e,t,...n){if(e=Bn(e),1===arguments.length&&(t=As.newId()),vd("doc","path",t),e instanceof _d){const r=Ns.fromString(t,...n);return wd(r),new Ad(e,null,new qs(r))}{if(!(e instanceof Ad||e instanceof Id))throw new gs(ms.INVALID_ARGUMENT,"Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");const r=e._path.child(Ns.fromString(t,...n));return wd(r),new Ad(e.firestore,e instanceof Id?e.converter:null,new qs(r))}}class Md{constructor(e=Promise.resolve()){this.Iu=[],this.du=!1,this.Eu=[],this.Au=null,this.Ru=!1,this.Vu=!1,this.mu=[],this.r_=new Lc(this,"async_queue_retry"),this.fu=()=>{const e=Ic();e&&ls("AsyncQueue","Visibility state changed to "+e.visibilityState),this.r_.Jo()},this.gu=e;const t=Ic();t&&"function"==typeof t.addEventListener&&t.addEventListener("visibilitychange",this.fu)}get isShuttingDown(){return this.du}enqueueAndForget(e){this.enqueue(e)}enqueueAndForgetEvenWhileRestricted(e){this.pu(),this.yu(e)}enterRestrictedMode(e){if(!this.du){this.du=!0,this.Vu=e||!1;const t=Ic();t&&"function"==typeof t.removeEventListener&&t.removeEventListener("visibilitychange",this.fu)}}enqueue(e){if(this.pu(),this.du)return new Promise((()=>{}));const t=new ys;return this.yu((()=>this.du&&this.Vu?Promise.resolve():(e().then(t.resolve,t.reject),t.promise))).then((()=>t.promise))}enqueueRetryable(e){this.enqueueAndForget((()=>(this.Iu.push(e),this.wu())))}async wu(){if(0!==this.Iu.length){try{await this.Iu[0](),this.Iu.shift(),this.r_.reset()}catch(e){if(!Ws(e))throw e;ls("AsyncQueue","Operation failed with retryable error: "+e)}this.Iu.length>0&&this.r_.jo((()=>this.wu()))}}yu(e){const t=this.gu.then((()=>(this.Ru=!0,e().catch((e=>{this.Au=e,this.Ru=!1;const t=function(e){let t=e.message||"";return e.stack&&(t=e.stack.includes(e.message)?e.stack:e.message+"\n"+e.stack),t}(e);throw cs("INTERNAL UNHANDLED ERROR: ",t),e})).then((e=>(this.Ru=!1,e))))));return this.gu=t,t}enqueueAfterDelay(e,t,n){this.pu(),this.mu.indexOf(e)>-1&&(t=0);const r=hu.createAndSchedule(this,e,t,n,(e=>this.Su(e)));return this.Eu.push(r),r}pu(){this.Au&&hs()}verifyOperationInProgress(){}async bu(){let e;do{e=this.gu,await e}while(e!==this.gu)}Du(e){for(const t of this.Eu)if(t.timerId===e)return!0;return!1}vu(e){return this.bu().then((()=>{this.Eu.sort(((e,t)=>e.targetTimeMs-t.targetTimeMs));for(const t of this.Eu)if(t.skipDelay(),"all"!==e&&t.timerId===e)break;return this.bu()}))}Cu(e){this.mu.push(e)}Su(e){const t=this.Eu.indexOf(e);this.Eu.splice(t,1)}}class Dd extends _d{constructor(e,t,n,r){super(e,t,n,r),this.type="firestore",this._queue=new Md,this._persistenceKey=(null==r?void 0:r.name)||"[DEFAULT]"}async _terminate(){if(this._firestoreClient){const e=this._firestoreClient.terminate();this._queue=new Md(e),this._firestoreClient=void 0,await e}}}function Nd(e){if(e._terminated)throw new gs(ms.FAILED_PRECONDITION,"The client has already been terminated.");return e._firestoreClient||Pd(e),e._firestoreClient}function Pd(e){var t,n,r;const s=e._freezeSettings(),i=function(e,t,n,r){return new Ti(e,t,n,r.host,r.ssl,r.experimentalForceLongPolling,r.experimentalAutoDetectLongPolling,gd(r.experimentalLongPollingOptions),r.useFetchStreams)}(e._databaseId,(null===(t=e._app)||void 0===t?void 0:t.options.appId)||"",e._persistenceKey,s);e._componentsProvider||(null===(n=s.localCache)||void 0===n?void 0:n._offlineComponentProvider)&&(null===(r=s.localCache)||void 0===r?void 0:r._onlineComponentProvider)&&(e._componentsProvider={_offline:s.localCache._offlineComponentProvider,_online:s.localCache._onlineComponentProvider}),e._firestoreClient=new ad(e._authCredentials,e._appCheckCredentials,e._queue,i,e._componentsProvider&&function(e){const t=null==e?void 0:e._online.build();return{_offline:null==e?void 0:e._offline.build(t),_online:t}}(e._componentsProvider))}class Od{constructor(e){this._byteString=e}static fromBase64String(e){try{return new Od(mi.fromBase64String(e))}catch(e){throw new gs(ms.INVALID_ARGUMENT,"Failed to construct data from Base64 string: "+e)}}static fromUint8Array(e){return new Od(mi.fromUint8Array(e))}toBase64(){return this._byteString.toBase64()}toUint8Array(){return this._byteString.toUint8Array()}toString(){return"Bytes(base64: "+this.toBase64()+")"}isEqual(e){return this._byteString.isEqual(e._byteString)}}class qd{constructor(...e){for(let t=0;t<e.length;++t)if(0===e[t].length)throw new gs(ms.INVALID_ARGUMENT,"Invalid field name at argument $(i + 1). Field names must not be empty.");this._internalPath=new Os(e)}isEqual(e){return this._internalPath.isEqual(e._internalPath)}}class Rd{constructor(e){this._methodName=e}}class Fd{constructor(e,t){if(!isFinite(e)||e<-90||e>90)throw new gs(ms.INVALID_ARGUMENT,"Latitude must be a number between -90 and 90, but was: "+e);if(!isFinite(t)||t<-180||t>180)throw new gs(ms.INVALID_ARGUMENT,"Longitude must be a number between -180 and 180, but was: "+t);this._lat=e,this._long=t}get latitude(){return this._lat}get longitude(){return this._long}isEqual(e){return this._lat===e._lat&&this._long===e._long}toJSON(){return{latitude:this._lat,longitude:this._long}}_compareTo(e){return Is(this._lat,e._lat)||Is(this._long,e._long)}}class Bd{constructor(e){this._values=(e||[]).map((e=>e))}toArray(){return this._values.map((e=>e))}isEqual(e){return function(e,t){if(e.length!==t.length)return!1;for(let n=0;n<e.length;++n)if(e[n]!==t[n])return!1;return!0}(this._values,e._values)}}const $d=/^__.*__$/;class Vd{constructor(e,t,n){this.data=e,this.fieldMask=t,this.fieldTransforms=n}toMutation(e,t){return null!==this.fieldMask?new Sa(e,this.data,this.fieldMask,t,this.fieldTransforms):new ba(e,this.data,t,this.fieldTransforms)}}class jd{constructor(e,t,n){this.data=e,this.fieldMask=t,this.fieldTransforms=n}toMutation(e,t){return new Sa(e,this.data,this.fieldMask,t,this.fieldTransforms)}}function zd(e){switch(e){case 0:case 2:case 1:return!0;case 3:case 4:return!1;default:throw hs()}}class Ud{constructor(e,t,n,r,s,i){this.settings=e,this.databaseId=t,this.serializer=n,this.ignoreUndefinedProperties=r,void 0===s&&this.Fu(),this.fieldTransforms=s||[],this.fieldMask=i||[]}get path(){return this.settings.path}get Mu(){return this.settings.Mu}xu(e){return new Ud(Object.assign(Object.assign({},this.settings),e),this.databaseId,this.serializer,this.ignoreUndefinedProperties,this.fieldTransforms,this.fieldMask)}Ou(e){var t;const n=null===(t=this.path)||void 0===t?void 0:t.child(e),r=this.xu({path:n,Nu:!1});return r.Bu(e),r}Lu(e){var t;const n=null===(t=this.path)||void 0===t?void 0:t.child(e),r=this.xu({path:n,Nu:!1});return r.Fu(),r}ku(e){return this.xu({path:void 0,Nu:!0})}qu(e){return sh(e,this.settings.methodName,this.settings.Qu||!1,this.path,this.settings.Ku)}contains(e){return void 0!==this.fieldMask.find((t=>e.isPrefixOf(t)))||void 0!==this.fieldTransforms.find((t=>e.isPrefixOf(t.field)))}Fu(){if(this.path)for(let e=0;e<this.path.length;e++)this.Bu(this.path.get(e))}Bu(e){if(0===e.length)throw this.qu("Document fields must not be empty");if(zd(this.Mu)&&$d.test(e))throw this.qu('Document fields cannot begin and end with "__"')}}class Gd{constructor(e,t,n){this.databaseId=e,this.ignoreUndefinedProperties=t,this.serializer=n||kc(e)}$u(e,t,n,r=!1){return new Ud({Mu:e,methodName:t,Ku:n,path:Os.emptyPath(),Nu:!1,Qu:r},this.databaseId,this.serializer,this.ignoreUndefinedProperties)}}function Hd(e){const t=e._freezeSettings(),n=kc(e._databaseId);return new Gd(e._databaseId,!!t.ignoreUndefinedProperties,n)}function Wd(e,t,n,r,s,i={}){const o=e.$u(i.merge||i.mergeFields?2:0,t,n,s);eh("Data must be an object, but it was:",o,r);const a=Jd(r,o);let l,c;if(i.merge)l=new pi(o.fieldMask),c=o.fieldTransforms;else if(i.mergeFields){const e=[];for(const r of i.mergeFields){const s=th(t,r,n);if(!o.contains(s))throw new gs(ms.INVALID_ARGUMENT,`Field '${s}' is specified in your field mask but missing from your input data.`);ih(e,s)||e.push(s)}l=new pi(e),c=o.fieldTransforms.filter((e=>l.covers(e.field)))}else l=null,c=o.fieldTransforms;return new Vd(new zi(a),l,c)}class Kd extends Rd{_toFieldTransform(e){if(2!==e.Mu)throw 1===e.Mu?e.qu(`${this._methodName}() can only appear at the top level of your update data`):e.qu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);return e.fieldMask.push(e.path),null}isEqual(e){return e instanceof Kd}}function Qd(e,t,n,r){const s=e.$u(1,t,n);eh("Data must be an object, but it was:",s,r);const i=[],o=zi.empty();oi(r,((e,r)=>{const a=rh(t,e,n);r=Bn(r);const l=s.Lu(a);if(r instanceof Kd)i.push(a);else{const e=Xd(r,l);null!=e&&(i.push(a),o.set(a,e))}}));const a=new pi(i);return new jd(o,a,s.fieldTransforms)}function Yd(e,t,n,r,s,i){const o=e.$u(1,t,n),a=[th(t,r,n)],l=[s];if(i.length%2!=0)throw new gs(ms.INVALID_ARGUMENT,`Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);for(let e=0;e<i.length;e+=2)a.push(th(t,i[e])),l.push(i[e+1]);const c=[],u=zi.empty();for(let e=a.length-1;e>=0;--e)if(!ih(c,a[e])){const t=a[e];let n=l[e];n=Bn(n);const r=o.Lu(t);if(n instanceof Kd)c.push(t);else{const e=Xd(n,r);null!=e&&(c.push(t),u.set(t,e))}}const d=new pi(c);return new jd(u,d,o.fieldTransforms)}function Xd(e,t){if(Zd(e=Bn(e)))return eh("Unsupported field value:",t,e),Jd(e,t);if(e instanceof Rd)return function(e,t){if(!zd(t.Mu))throw t.qu(`${e._methodName}() can only be used with update() and set()`);if(!t.path)throw t.qu(`${e._methodName}() is not currently supported inside arrays`);const n=e._toFieldTransform(t);n&&t.fieldTransforms.push(n)}(e,t),null;if(void 0===e&&t.ignoreUndefinedProperties)return null;if(t.path&&t.fieldMask.push(t.path),e instanceof Array){if(t.settings.Nu&&4!==t.Mu)throw t.qu("Nested arrays are not supported");return function(e,t){const n=[];let r=0;for(const s of e){let e=Xd(s,t.ku(r));null==e&&(e={nullValue:"NULL_VALUE"}),n.push(e),r++}return{arrayValue:{values:n}}}(e,t)}return function(e,t){if(null===(e=Bn(e)))return{nullValue:"NULL_VALUE"};if("number"==typeof e)return Jo(t.serializer,e);if("boolean"==typeof e)return{booleanValue:e};if("string"==typeof e)return{stringValue:e};if(e instanceof Date){const n=Ls.fromDate(e);return{timestampValue:nl(t.serializer,n)}}if(e instanceof Ls){const n=new Ls(e.seconds,1e3*Math.floor(e.nanoseconds/1e3));return{timestampValue:nl(t.serializer,n)}}if(e instanceof Fd)return{geoPointValue:{latitude:e.latitude,longitude:e.longitude}};if(e instanceof Od)return{bytesValue:rl(t.serializer,e._byteString)};if(e instanceof Ad){const n=t.databaseId,r=e.firestore._databaseId;if(!r.isEqual(n))throw t.qu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);return{referenceValue:ol(e.firestore._databaseId||t.databaseId,e._key.path)}}if(e instanceof Bd)return function(e,t){return{mapValue:{fields:{__type__:{stringValue:"__vector__"},value:{arrayValue:{values:e.toArray().map((e=>{if("number"!=typeof e)throw t.qu("VectorValues must only contain numeric values.");return Yo(t.serializer,e)}))}}}}}}(e,t);throw t.qu(`Unsupported field value: ${Sd(e)}`)}(e,t)}function Jd(e,t){const n={};return ai(e)?t.path&&t.path.length>0&&t.fieldMask.push(t.path):oi(e,((e,r)=>{const s=Xd(r,t.Ou(e));null!=s&&(n[e]=s)})),{mapValue:{fields:n}}}function Zd(e){return!("object"!=typeof e||null===e||e instanceof Array||e instanceof Date||e instanceof Ls||e instanceof Fd||e instanceof Od||e instanceof Ad||e instanceof Rd||e instanceof Bd)}function eh(e,t,n){if(!Zd(n)||!function(e){return"object"==typeof e&&null!==e&&(Object.getPrototypeOf(e)===Object.prototype||null===Object.getPrototypeOf(e))}(n)){const r=Sd(n);throw"an object"===r?t.qu(e+" a custom object"):t.qu(e+" "+r)}}function th(e,t,n){if((t=Bn(t))instanceof qd)return t._internalPath;if("string"==typeof t)return rh(e,t);throw sh("Field path arguments must be of type string or ",e,!1,void 0,n)}const nh=new RegExp("[~\\*/\\[\\]]");function rh(e,t,n){if(t.search(nh)>=0)throw sh(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`,e,!1,void 0,n);try{return new qd(...t.split("."))._internalPath}catch(r){throw sh(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`,e,!1,void 0,n)}}function sh(e,t,n,r,s){const i=r&&!r.isEmpty(),o=void 0!==s;let a=`Function ${t}() called with invalid data`;n&&(a+=" (via `toFirestore()`)"),a+=". ";let l="";return(i||o)&&(l+=" (found",i&&(l+=` in field ${r}`),o&&(l+=` in document ${s}`),l+=")"),new gs(ms.INVALID_ARGUMENT,a+e+l)}function ih(e,t){return e.some((e=>e.isEqual(t)))}class oh{constructor(e,t,n,r,s){this._firestore=e,this._userDataWriter=t,this._key=n,this._document=r,this._converter=s}get id(){return this._key.path.lastSegment()}get ref(){return new Ad(this._firestore,this._converter,this._key)}exists(){return null!==this._document}data(){if(this._document){if(this._converter){const e=new ah(this._firestore,this._userDataWriter,this._key,this._document,null);return this._converter.fromFirestore(e)}return this._userDataWriter.convertValue(this._document.data.value)}}get(e){if(this._document){const t=this._document.data.field(lh("DocumentSnapshot.get",e));if(null!==t)return this._userDataWriter.convertValue(t)}}}class ah extends oh{data(){return super.data()}}function lh(e,t){return"string"==typeof t?rh(e,t):t instanceof qd?t._internalPath:t._delegate._internalPath}function ch(e){if("L"===e.limitType&&0===e.explicitOrderBy.length)throw new gs(ms.UNIMPLEMENTED,"limitToLast() queries require specifying at least one orderBy() clause")}class uh{convertValue(e,t="none"){switch(xi(e)){case 0:return null;case 1:return e.booleanValue;case 2:return vi(e.integerValue||e.doubleValue);case 3:return this.convertTimestamp(e.timestampValue);case 4:return this.convertServerTimestamp(e,t);case 5:return e.stringValue;case 6:return this.convertBytes(wi(e.bytesValue));case 7:return this.convertReference(e.referenceValue);case 8:return this.convertGeoPoint(e.geoPointValue);case 9:return this.convertArray(e.arrayValue,t);case 11:return this.convertObject(e.mapValue,t);case 10:return this.convertVectorValue(e.mapValue);default:throw hs()}}convertObject(e,t){return this.convertObjectMap(e.fields,t)}convertObjectMap(e,t="none"){const n={};return oi(e,((e,r)=>{n[e]=this.convertValue(r,t)})),n}convertVectorValue(e){var t,n,r;const s=null===(r=null===(n=null===(t=e.fields)||void 0===t?void 0:t.value.arrayValue)||void 0===n?void 0:n.values)||void 0===r?void 0:r.map((e=>vi(e.doubleValue)));return new Bd(s)}convertGeoPoint(e){return new Fd(vi(e.latitude),vi(e.longitude))}convertArray(e,t){return(e.values||[]).map((e=>this.convertValue(e,t)))}convertServerTimestamp(e,t){switch(t){case"previous":const n=Si(e);return null==n?null:this.convertValue(n,t);case"estimate":return this.convertTimestamp(Ei(e));default:return null}}convertTimestamp(e){const t=yi(e);return new Ls(t.seconds,t.nanos)}convertDocumentKey(e,t){const n=Ns.fromString(e);ps(Il(n));const r=new _i(n.get(1),n.get(3)),s=new qs(n.popFirst(5));return r.isEqual(t)||cs(`Document ${s} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`),s}}function dh(e,t,n){let r;return r=e?n&&(n.merge||n.mergeFields)?e.toFirestore(t,n):e.toFirestore(t):t,r}class hh{constructor(e,t){this.hasPendingWrites=e,this.fromCache=t}isEqual(e){return this.hasPendingWrites===e.hasPendingWrites&&this.fromCache===e.fromCache}}class ph extends oh{constructor(e,t,n,r,s,i){super(e,t,n,r,i),this._firestore=e,this._firestoreImpl=e,this.metadata=s}exists(){return super.exists()}data(e={}){if(this._document){if(this._converter){const t=new fh(this._firestore,this._userDataWriter,this._key,this._document,this.metadata,null);return this._converter.fromFirestore(t,e)}return this._userDataWriter.convertValue(this._document.data.value,e.serverTimestamps)}}get(e,t={}){if(this._document){const n=this._document.data.field(lh("DocumentSnapshot.get",e));if(null!==n)return this._userDataWriter.convertValue(n,t.serverTimestamps)}}}class fh extends ph{data(e={}){return super.data(e)}}class mh{constructor(e,t,n,r){this._firestore=e,this._userDataWriter=t,this._snapshot=r,this.metadata=new hh(r.hasPendingWrites,r.fromCache),this.query=n}get docs(){const e=[];return this.forEach((t=>e.push(t))),e}get size(){return this._snapshot.docs.size}get empty(){return 0===this.size}forEach(e,t){this._snapshot.docs.forEach((n=>{e.call(t,new fh(this._firestore,this._userDataWriter,n.key,n,new hh(this._snapshot.mutatedKeys.has(n.key),this._snapshot.fromCache),this.query.converter))}))}docChanges(e={}){const t=!!e.includeMetadataChanges;if(t&&this._snapshot.excludesMetadataChanges)throw new gs(ms.INVALID_ARGUMENT,"To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");return this._cachedChanges&&this._cachedChangesIncludeMetadataChanges===t||(this._cachedChanges=function(e,t){if(e._snapshot.oldDocs.isEmpty()){let t=0;return e._snapshot.docChanges.map((n=>{const r=new fh(e._firestore,e._userDataWriter,n.doc.key,n.doc,new hh(e._snapshot.mutatedKeys.has(n.doc.key),e._snapshot.fromCache),e.query.converter);return n.doc,{type:"added",doc:r,oldIndex:-1,newIndex:t++}}))}{let n=e._snapshot.oldDocs;return e._snapshot.docChanges.filter((e=>t||3!==e.type)).map((t=>{const r=new fh(e._firestore,e._userDataWriter,t.doc.key,t.doc,new hh(e._snapshot.mutatedKeys.has(t.doc.key),e._snapshot.fromCache),e.query.converter);let s=-1,i=-1;return 0!==t.type&&(s=n.indexOf(t.doc.key),n=n.delete(t.doc.key)),1!==t.type&&(n=n.add(t.doc),i=n.indexOf(t.doc.key)),{type:gh(t.type),doc:r,oldIndex:s,newIndex:i}}))}}(this,t),this._cachedChangesIncludeMetadataChanges=t),this._cachedChanges}}function gh(e){switch(e){case 0:return"added";case 2:case 3:return"modified";case 1:return"removed";default:return hs()}}class yh extends uh{constructor(e){super(),this.firestore=e}convertBytes(e){return new Od(e)}convertReference(e){const t=this.convertDocumentKey(e,this.firestore._databaseId);return new Ad(this.firestore,null,t)}}function vh(e){e=Ed(e,xd);const t=Ed(e.firestore,Dd),n=Nd(t),r=new yh(t);return ch(e._query),md(n,e._query).then((n=>new mh(t,r,e,n)))}function wh(e,t,n,...r){e=Ed(e,Ad);const s=Ed(e.firestore,Dd),i=Hd(s);let o;return o="string"==typeof(t=Bn(t))||t instanceof qd?Yd(i,"updateDoc",e._key,t,n,r):Qd(i,"updateDoc",e._key,t),bh(s,[o.toMutation(e._key,ha.exists(!0))])}function bh(e,t){return function(e,t){const n=new ys;return e.asyncQueue.enqueueAndForget((async()=>async function(e,t,n){const r=nd(e);try{const e=await function(e,t){const n=fs(e),r=Ls.now(),s=t.reduce(((e,t)=>e.add(t.key)),Wo());let i,o;return n.persistence.runTransaction("Locally write mutations","readwrite",(e=>{let a=Fo(),l=Wo();return n.hs.getEntries(e,s).next((e=>{a=e,a.forEach(((e,t)=>{t.isValidDocument()||(l=l.add(e))}))})).next((()=>n.localDocuments.getOverlayedDocuments(e,a))).next((s=>{i=s;const o=[];for(const e of t){const t=va(e,i.get(e.key).overlayedDocument);null!=t&&o.push(new Sa(e.key,t,Ui(t.value.mapValue),ha.exists(!0)))}return n.mutationQueue.addMutationBatch(e,r,o,t)})).next((t=>{o=t;const r=t.applyToLocalDocumentSet(i,l);return n.documentOverlayCache.saveOverlays(e,t.batchId,r)}))})).then((()=>({batchId:o.batchId,changes:Vo(i)})))}(r.localStore,t);r.sharedClientState.addPendingMutation(e.batchId),function(e,t,n){let r=e.qa[e.currentUser.toKey()];r||(r=new li(Is)),r=r.insert(t,n),e.qa[e.currentUser.toKey()]=r}(r,e.batchId,n),await Ju(r,e.changes),await Zc(r.remoteStore)}catch(e){const t=pu(e,"Failed to persist write");n.reject(t)}}(await hd(e),t,n))),n.promise}(Nd(e),t)}function Sh(e,t,n){const r=n.docs.get(t._key),s=new yh(e);return new ph(e,s,t._key,r,new hh(n.hasPendingWrites,n.fromCache),t.converter)}new WeakMap;if(function(e,t=!0){!function(e){is=e}("11.2.0"),Cr(new $n("firestore",((e,{instanceIdentifier:n,options:r})=>{const s=e.getProvider("app").getImmediate(),i=new Dd(new Ss(e.getProvider("auth-internal")),new Cs(e.getProvider("app-check-internal")),function(e,t){if(!Object.prototype.hasOwnProperty.apply(e.options,["projectId"]))throw new gs(ms.INVALID_ARGUMENT,'"projectId" not provided in firebase.initializeApp.');return new _i(e.options.projectId,t)}(s,n),s);return r=Object.assign({useFetchStreams:t},r),i._setSettings(r),i}),"PUBLIC").setMultipleInstances(!0)),Lr(rs,"4.7.6",e),Lr(rs,"4.7.6","esm2017")}(),null!==document.querySelector(".cart__drawer")){const Jh=document.querySelector(".cart__drawer-wrap"),Zh=(document.querySelector(".cart__drawer-overlay"),document.querySelector(".cart__drawer"),document.getElementById("cart-header-text")),ep=document.querySelector(".cart__drawer-ticker"),tp=document.getElementById("cart-upsell-warning"),np=(document.getElementById("cart-subscription-warning"),document.getElementById("cart-product-warning")),rp=document.querySelector(".cart__drawer-items"),sp=document.querySelector(".cart__drawer-upsells"),ip=document.querySelectorAll(".cart__drawer-upsells-item"),op=document.querySelector(".bag-count"),ap=document.getElementById("checkout-button"),lp=document.querySelector(".cart__drawer-footer"),cp=()=>{fetch("/cart.js",{headers:{"Content-Type":"application/json","X-Requested-With":"xmlhttprequest"}}).then((e=>e.json())).then((e=>{console.log("BB CART",e),rp.innerHTML="";let t=!1,n=[],r=!0,s=0,i=0;if(console.log(e,"cart"),e.item_count>0){console.log("ovde sammm");const{items:o}=e;let a=1;o.forEach((e=>{if(void 0!==e.selling_plan_allocation?(t=!0,e.product_type.includes("Protein")||e.product_type.includes("Merch")||e.product_type.includes("Gift Card")?s=2:s+=e.quantity):e.product_type.includes("Protein")||e.product_type.includes("Merch")||e.product_type.includes("Gift Card")?i=2:i+=e.quantity,up(e,rp,a),void 0!==window.upsells&&window.upsells.length&&(window.upsellProdTypes.includes(e.product_type)?n.push(e.key):r=!1,window.upsells.includes(e.variant_id))){var o=upsells.indexOf(e.variant_id);window.upsells.splice(o,1)}a++})),console.log(s,i,"subscriptionProductCountOvdeees"),op.textContent=e.item_count,Zh.textContent=`Bomb Bag (${e.item_count})`,ap.textContent=`Checkout — ${Shopify.formatMoney(e.total_price)}`,lp.style.display="block",null!==ep&&(ep.style.display="flex"),null!==sp&&(void 0!==window.upsells&&window.upsells.length&&(sp.style.display="block",void 0!==window.randomizeUpsells&&!0===window.randomizeUpsells&&(e=>{for(let t=e.length-1;t>0;t--){const n=Math.floor(Math.random()*(t+1));[e[t],e[n]]=[e[n],e[t]]}})(window.upsells),ip.forEach((e=>{e.style.display="none"})),document.getElementById(`upsell-${window.upsells[0]}`).style.display="grid"),window.upsells.length||(sp.style.display="none")),s<2&&i<2?(console.log(t,"less than 22"),setTimeout((()=>{console.log("dodaj disabled"),document.querySelector("#checkout-button").classList.add("disabled"),np.style.display="block",ap.setAttribute("disabled","true")}),500)):(r||(ap.removeAttribute("disabled"),ap.classList.remove("disabled")),np.style.display="none"),r?(ap.classList.add("disabled"),ap.setAttribute("disabled",!0),tp.style.display="block",n.length&&n.forEach((e=>{Bp(e,0)}))):(t||(ap.removeAttribute("disabled"),ap.classList.remove("disabled")),tp.style.display="none")}else op.textContent="0",Zh.textContent="Bomb Bag",rp.innerHTML='<div class=\'caps-21 text-center md:text-18\'>Your cart is empty</div><div class="text-center -mt-4 md:-mt-2"><a href="/collections/all" class="button--dark-pink">Shop Now</a></div>',lp.style.display="none",null!==ep&&(ep.style.display="none"),null!==sp&&(sp.style.display="none")}))},up=(e,t,n)=>{console.log(e,t,n);let r=document.createRange().createContextualFragment(`\n\t\t\t<div class="cart__drawer-item">\n\t\t\t\t${window.disableCartProdLinks?`<div class="cart__drawer-item-image">\n\t\t\t\t\t\t<img src="${e.featured_image.url}" alt="${e.featured_image.alt}" />\n\t\t\t\t\t</div>`:`<a href="${e.url}" class="cart__drawer-item-image">\n\t\t\t\t\t\t<img src="${e.featured_image.url}" alt="${e.featured_image.alt}" />\n\t\t\t\t\t</a>`}\n\t\t\t\t<div class="cart__drawer-item-content">\n\t\t\t\t\t<div class="cart__drawer-item-content-top">\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t${window.disableCartProdLinks?`<div class="cart__drawer-item-title">\n\t\t\t\t\t\t\t\t\t${e.product_title.includes(" Blender Bomb")?`${e.product_title.endsWith("_")?e.product_title.split(" Blender Bomb")[0].slice(0,-1):e.product_title.split(" Blender Bomb")[0]}<br>Blender Bomb`:e.product_title.includes(" Bomb Bar")?`${e.product_title.endsWith("_")?e.product_title.split(" Bomb Bar")[0].slice(0,-1):e.product_title.split(" Bomb Bar")[0]}<br>Bomb Bar`:`${e.product_title.endsWith("_")?e.product_title.slice(0,-1):e.product_title}`}\n\t\t\t\t\t\t\t\t</div>`:`<a href="${e.url}" class="cart__drawer-item-title">\n\t\t\t\t\t\t\t\t\t${e.product_title.includes(" Blender Bomb")?`${e.product_title.endsWith("_")?e.product_title.split(" Blender Bomb")[0].slice(0,-1):e.product_title.split(" Blender Bomb")[0]}<br>Blender Bomb`:e.product_title.includes(" Bomb Bar")?`${e.product_title.endsWith("_")?e.product_title.split(" Bomb Bar")[0].slice(0,-1):e.product_title.split(" Bomb Bar")[0]}<br>Bomb Bar`:`${e.product_title.endsWith("_")?e.product_title.slice(0,-1):e.product_title}`}\n\t\t\t\t\t\t\t\t</a>`}\n\n\t\t\t\t\t\t\t${e.gift_card||e.product_type.includes("Bombs")||e.product_type.includes("Bar")||void 0!==e.selling_plan_allocation||e.product_has_only_default_variant||!(e.options_with_values.length>0)?"":e.options_with_values.map((e=>`<div class="cart__drawer-item-content-options">\n\t\t\t\t\t\t\t\t\t<div class="mr-1">${e.name}:</div>\n\t\t\t\t\t\t\t\t\t<div>${e.value}</div>\n\t\t\t\t\t\t\t\t</div>`)).join("")}\n\n\t\t\t\t\t\t\t${e.selling_plan_allocation?`<div class="cart__drawer-item-content-options">\n\t\t\t\t\t\t\t\t\t<div class="cart__drawer-item-content-options--delivery">Delivery ${e.selling_plan_allocation.selling_plan.name.replace(/\*/g,"")}</div>\n\t\t\t\t\t\t\t\t</div>`:e.product_type.includes("Bombs")||e.product_type.includes("Bar")?`<div>\n\t\t\t\t\t\t\t\t\t<p class="font-grenette text-14 mt-0.5">Upgrade to a Subscription and Save</p>\n\t\t\t\t\t\t\t\t\t<skio-cart-upsell item='${JSON.stringify((({product_description:e,...t})=>t)(e))}' line='${n}'></skio-cart-upsell>\n\t\t\t\t\t\t\t\t</div>`:""}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="cart__drawer-item-price">\n\t\t\t\t\t\t\t${Shopify.formatMoney(e.original_line_price)!==Shopify.formatMoney(e.final_line_price)?`<span>${Shopify.formatMoney(e.final_line_price).replace(".00","")}</span> <s class="text-cream">${Shopify.formatMoney(e.original_line_price).replace(".00","")}</s>`:`<span>${Shopify.formatMoney(e.final_line_price).replace(".00","")}</span>`}\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="cart__drawer-item-content-bottom">\n\t\t\t\t\t\t<div class="cart__drawer-item-qty">\n\t\t\t\t\t\t\t<span onclick="window.cartItemUpdate('${e.key}',${e.quantity-1})">-</span>\n\t\t\t\t\t\t\t<span>${e.quantity}</span>\n\t\t\t\t\t\t\t<span onclick="window.cartItemUpdate('${e.key}',${e.quantity+1})">+</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t`);t.prepend(r)},dp=()=>{Jh.classList.add("active")},hp=()=>{Jh.classList.contains("active")&&Jh.classList.remove("active")};function pp(e,t,n){if(e instanceof Date){var r=new Date(e),s=function(){r.getDate()!=e.getDate()&&r.setDate(0)};switch(String(t).toLowerCase()){case"year":r.setFullYear(r.getFullYear()+n),s();break;case"quarter":r.setMonth(r.getMonth()+3*n),s();break;case"month":r.setMonth(r.getMonth()+n),s();break;case"week":r.setDate(r.getDate()+7*n);break;case"day":r.setDate(r.getDate()+n);break;case"hour":r.setTime(r.getTime()+36e5*n);break;case"minute":r.setTime(r.getTime()+6e4*n);break;case"second":r.setTime(r.getTime()+1e3*n);break;default:r=void 0}return r}}function fp(e){return e.toString().padStart(2,"0")}function mp(e){return[e.getFullYear(),fp(e.getMonth()+1),fp(e.getDate())].join("-")+" "+[fp(e.getHours()),fp(e.getMinutes()),fp(e.getSeconds())].join(":")}const gp=function(e,t){const n="string"==typeof e?e:t||"(default)",r=xr("object"==typeof e?e:function(e=wr){const t=Sr.get(e);if(!t&&e===wr&&kn())return kr();if(!t)throw Ar.create("no-app",{appName:e});return t}(),"firestore").getImmediate({identifier:n});if(!r._initialized){const e=In("firestore");e&&Cd(r,...e)}return r}(kr({apiKey:"AIzaSyCW_yMKRlmCP3URcF3VlYNj6AsetFMOu44",authDomain:"bombcopopup.firebaseapp.com",projectId:"bombcopopup",storageBucket:"bombcopopup.firebasestorage.app",messagingSenderId:"116378805721",appId:"1:116378805721:web:1153f73f534e19b8ae65c8"})),yp=(kd(gp,"productEvents"),async(e,t)=>{const n=Ld(gp,"productEvents",e);try{const e=await function(e){e=Ed(e,Ad);const t=Ed(e.firestore,Dd);return fd(Nd(t),e._key).then((n=>Sh(t,e,n)))}(n);if(e.exists()){const t=e.data().addedCount||0;await wh(n,{addedCount:t+1})}else await function(e,t,n){e=Ed(e,Ad);const r=Ed(e.firestore,Dd),s=dh(e.converter,t,n);return bh(r,[Wd(Hd(r),"setDoc",e._key,s,null!==e.converter,n).toMutation(e._key,ha.none())])}(n,{name:t,addedCount:1,percentage:0});await vp(),await wp()}catch(e){console.error("Error updating Firestore:",e)}}),vp=async()=>{const e=kd(gp,"productEvents"),t=await vh(e);let n=0;const r=[];t.forEach((e=>{const t=e.data();n+=t.addedCount,r.push({id:e.id,...t})}));for(const e of r){const t=(e.addedCount/n*100).toFixed(2);await wh(Ld(gp,"productEvents",e.id),{percentage:parseFloat(t)})}},wp=async()=>{const e=kd(gp,"productEvents"),t=await vh(e),n=[];t.forEach((e=>{const t=e.data();n.push({id:e.id,...t})}));for(const e of n){const t=e.addedCount>0?(e.popupPurchasedCount/e.addedCount*100).toFixed(2):0;await wh(Ld(gp,"productEvents",e.id),{popupConversionRate:parseFloat(t)})}},bp='\n  <div id="product-popup" class="hidden fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 px-[10px]">\n    <div class="bg-white p-6 rounded-2xl shadow-lg max-w-2xl w-full text-center relative">\n      <h2 class="text-[30px] font-bold mb-2">Spice Up Your Smoothies! ❤️</h2>\n\t  <p class="text-red-500 font-bold mb-4 text-[16px]">Pair your Love Blender Bomb with Chocolate or Vanilla Bomb Protein for 50% Off Your First Month!</p>\n      <p class="text-red-500 font-bold mb-4 text-[20px]">Hurry! This irresistible offer ends in <span class="bold" id="countdown-timer">5:00</span></p>\n      <div class="flex justify-around items-center gap-6">\n        <div class="text-center">\n          <img src="https://thebombco.com/cdn/shop/files/73.png?v=1736865819&width=1800" class="w-32 h-32 mx-auto mb-2">\n          <p class="font-bold">Chocolate Bomb Plant Protein</p>\n\t\t  <div class="text-center mt-[10px]">\n\t\t\t<span class="text-lg font-bold">Only $28.99</span>\n\t\t\t<span class="text-sm line-through text-gray-500">$57.98</span>\n\t\t  </div>\n          <button id="add-product-1" class="button--dark-pink px-4 py-2 rounded-lg mt-[10px]">\n\t\t  Add to My Order\n          </button>\n        </div>\n        <div class="text-center">\n          <img src="https://thebombco.com/cdn/shop/files/79.png?v=1736864927&width=1800" class="w-32 h-32 mx-auto mb-2">\n          <p class="font-bold">Vanilla Bomb Plant Protein</p>\n\t\t  <div class="text-center mt-[10px]">\n\t\t\t<span class="text-lg font-bold">Only $28.99</span>\n\t\t\t<span class="text-sm line-through text-gray-500">$57.98</span>\n\t\t  </div>\n          <button id="add-product-2" class="button--dark-pink px-4 py-2 rounded-lg mt-[10px]">\n\t\t  Add to My Order\n          </button>\n        </div>\n      </div>\n      <button id="decline-offer" class="bg-transparent text-gray-800 underline mt-6">I\'ll skip the magic this time.</button>\n    </div>\n  </div>\n';document.body.insertAdjacentHTML("beforeend",bp);const Sp=(e,t)=>{let n,r,s=e;const i=setInterval((()=>{n=Math.floor(s/60),r=s%60,r=r<10?"0"+r:r,t.textContent=`${n}:${r}`,--s<0&&(clearInterval(i),document.getElementById("product-popup").classList.add("hidden"))}),1e3)};document.querySelector("body").getAttribute;const Ep=e=>{let t=document.getElementById(e).querySelector('[name="add"]'),n=t.getAttribute("data-special");console.log(n,"dataSpecial");let r=t.innerHTML;t.setAttribute("disabled",!0),t.innerHTML="<span>Adding...</span>";const s=bn()(document.getElementById(e),{hash:!0});let i;if("love"===n){const e=document.getElementById("product-popup");e.classList.remove("hidden");const n=document.getElementById("countdown-timer");Sp(300,n),document.getElementById("add-product-1").addEventListener("click",(()=>{i=[{id:s.id,quantity:parseInt(s.quantity||1)},{id:42525702291636,quantity:1,selling_plan:7719223476,properties:{popup_added:!0}}],yp("42525702291636","Chocolate Bomb Plant Protein"),Tp(i,t,r,e)})),document.getElementById("add-product-2").addEventListener("click",(()=>{i=[{id:s.id,quantity:parseInt(s.quantity||1)},{id:42525699113140,quantity:1,selling_plan:7719223476,properties:{popup_added:!0}}],yp("42525699113140","Vanilla Bomb Plant Protein"),Tp(i,t,r,e)})),document.getElementById("decline-offer").addEventListener("click",(()=>{i=[{id:s.id,quantity:parseInt(s.quantity||1)}],yp("Decline Offer","Decline Offer"),Tp(i,t,r,e)}))}else i=[{id:s.id,quantity:parseInt(s.quantity||1)}],Tp(i,t,r)},Tp=(e,t,n,r=null)=>{fetch("/cart/add.js",{body:JSON.stringify({items:e}),headers:{"Content-Type":"application/json","X-Requested-With":"xmlhttprequest"},method:"POST"}).then((e=>e.json())).then((e=>{console.log(e,"data"),cp(),dp(),t.removeAttribute("disabled"),t.innerHTML=n,r&&r.classList.add("hidden")})).catch((e=>{console.error("Error adding items to cart:",e),t.removeAttribute("disabled"),t.innerHTML=n,r&&r.classList.add("hidden")}))},_p=e=>{let t=document.getElementById(e).querySelector('[name="add"]'),n=t.innerHTML;t.setAttribute("disabled",!0),t.innerHTML="<span>Adding...</span>",ap.setAttribute("disabled",!0),ap.textContent="Loading...",console.log(JSON.stringify(bn()(document.getElementById(e),{hash:!0})),"bodyyy"),fetch("/cart/add.js",{body:JSON.stringify(bn()(document.getElementById(e),{hash:!0})),headers:{"Content-Type":"application/json","X-Requested-With":"xmlhttprequest"},method:"POST"}).then((e=>e.json())).then((e=>{console.log(e,"data"),cp(),dp(),t.removeAttribute("disabled"),t.innerHTML=n;let r=mp(new Date),s=new Date(r);console.log(r,s,"date"),console.log(pp(s,"minute",10),"dateAdd(d, minute, 1)");let i=pp(s,"minute",10);var o,a,l;o=i,o=(o=new Date(o)).getTime(),isNaN(o)||setInterval((function(){var e=new Date,t=(e=new Date(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate(),e.getUTCHours(),e.getUTCMinutes(),e.getUTCSeconds()),parseInt((o-e.getTime())/1e3));t>=0&&(parseInt(t/86400),t%=86400,parseInt(t/3600),t%=3600,a=parseInt(t/60),t%=60,l=parseInt(t),document.getElementById("minutess").innerHTML=("0"+a).slice(-2),document.getElementById("secondss").innerHTML=("0"+l).slice(-2))}),1e3);let c=document.querySelector(".countdown");setTimeout((()=>{c&&c.classList.add("show")}),1e3)}))},Cp=()=>{let e=document.querySelector("#add-to-cart-button");console.log(window.variantIdFirst,window.variantIdSecond,window.variantIdThird,"variantIdSHOW"),window.variantIdFirst&&window.variantIdSecond&&e.removeAttribute("disabled")};var Eh=document.querySelector(".js-product-one-selector"),Th=document.querySelector(".js-product-two-selector");let xp=()=>{const e=document.querySelector(".js-product-one-selector"),t=e.options[e.selectedIndex],n=document.querySelector(".js-product-two-selector"),r=n.options[n.selectedIndex],s=t.getAttribute("data-type"),i=r.getAttribute("data-type");let o,a,l,c,u=0;"Blender Bombs"===s&&"Blender Bombs"===i&&(u=-10.08),"Blender Bombs"===s&&"Bomb Bars"===i&&(u=-7.12),"Blender Bombs"===s&&"Protein Powder"===i&&(u=-14.49),"Protein Powder"===s&&"Blender Bombs"===i&&(u=-14.49),"Protein Powder"===s&&"Protein Powder"===i&&(u=-18.9),"Protein Powder"===s&&"Bomb Bars"===i&&(u=-11.53),"Bomb Bars"===s&&"Bomb Bars"===i&&(u=-4.16),"Bomb Bars"===s&&"Protein Powder"===i&&(u=-11.53),"Bomb Bars"===s&&"Blender Bombs"===i&&(u=-7.12),console.log(s,i,"prTypeFirst"),a=r.getAttribute("data-price"),o=t.getAttribute("data-price"),l=t.getAttribute("data-original-price"),c=r.getAttribute("data-original-price"),console.log(o,a,"priceInfo"),null==o&&(o=0),null==a&&(a=0);let d=(parseFloat(o)+parseFloat(a))/100,h=(parseFloat(l)+parseFloat(c))/100,p=d-u,f=document.querySelector(".js-pr"),m=document.querySelector(".js-pr-original"),g=document.querySelector(".js-pr-once");f.innerHTML=`$${p.toFixed(2)}`,console.log(isNaN(h),h,"total_price_original"),g&&!isNaN(h)&&(g.innerHTML=`$${h.toFixed(2)}`);let y=h-p,v=document.querySelector(".js-save");console.log(y,"diff"),console.log(l,c,"priceOriginal"),null!==l&&null!==c&&(console.log("ovde si"),m.innerHTML=`$${h.toFixed(2)}`,v.innerHTML=`Save<br> $${y.toFixed(2)}`)};Eh&&Eh.addEventListener("change",(function(){let e=Eh.value,t=Eh.options[Eh.selectedIndex].getAttribute("data-image"),n=Eh.options[Eh.selectedIndex].getAttribute("data-selling-plan-id");document.querySelector(".js-image-1").src=t,console.log(n,"sellingPlanId"),window.variantIdFirst=e,n&&(window.sellingPlanSelectorIdFirst=n),setTimeout((()=>{xp()}),400),Cp()})),Th&&Th.addEventListener("change",(function(){let e=Th.value,t=Th.options[Th.selectedIndex].getAttribute("data-image"),n=Th.options[Th.selectedIndex].getAttribute("data-selling-plan-id");document.querySelector(".js-image-2").src=t,console.log(e,"variantId"),console.log(n,"sellingPlanIdSecond"),window.variantIdSecond=e,n&&(window.sellingPlanSelectorIdSecond=n),setTimeout((()=>{xp()}),400),Cp()}));const Ap=()=>{let e=document.querySelector("#add-to-cart-button");console.log(window.variantIdFirstM,window.variantIdSecondM,window.variantIdThirdM,"variantIdSHOWMIXMATCH"),window.variantIdFirstM&&window.variantIdSecondM&&window.variantIdThirdM&&e.removeAttribute("disabled")};var _h=document.querySelector(".js-product-one-selector-m"),Ch=document.querySelector(".js-product-two-selector-m"),xh=document.querySelector(".js-product-three-selector-m");console.log(_h,Ch,xh,"variantSelectorFirstM"),_h&&_h.addEventListener("change",(function(){let e=_h.value,t=_h.options[_h.selectedIndex].getAttribute("data-image"),n=_h.options[_h.selectedIndex].getAttribute("data-selling-plan-id");document.querySelector(".js-image-1").src=t,console.log(t,"imageId"),console.log(e,"variantId"),window.variantIdFirstM=e,n&&(window.sellingPlanIdFirstM=n),Ap()})),Ch&&Ch.addEventListener("change",(function(){let e=Ch.value,t=Ch.options[Ch.selectedIndex].getAttribute("data-image"),n=Ch.options[Ch.selectedIndex].getAttribute("data-selling-plan-id");document.querySelector(".js-image-2").src=t,console.log(e,"variantId"),window.variantIdSecondM=e,n&&(window.sellingPlanIdSecondM=n),Ap()})),xh&&xh.addEventListener("change",(function(){let e=xh.value,t=xh.options[xh.selectedIndex].getAttribute("data-image"),n=xh.options[xh.selectedIndex].getAttribute("data-selling-plan-id");document.querySelector(".js-image-3").src=t,console.log(e,"variantId"),window.variantIdThirdM=e,n&&(window.sellingPlanIdThirdM=n),Ap()}));const Ip=()=>{let e=document.querySelector("#add-to-cart-button");console.log(window.variantIdFirstB,window.variantIdSecondB,window.variantIdThirdB,"variantIdBUY2GET1FREE"),window.variantIdFirstB&&window.variantIdSecondB&&window.variantIdThirdB&&e.removeAttribute("disabled")};window.priceFirst=0,window.priceSecond=0,window.priceThird=0;const kp=(e,t,n)=>{let r=Math.min(e,t,n);e===r?e=0:t===r?t=0:n=0;let s=(e+t+n)/100;console.log(s,"price"),document.querySelector(".js-price").innerHTML=`$${s.toFixed(2)}`};var Ah=document.querySelector(".js-product-one-selector-b"),Ih=document.querySelector(".js-product-two-selector-b"),kh=document.querySelector(".js-product-three-selector-b");console.log(Ah,Ih,kh,"variantSelectorFirstM"),Ah&&Ah.addEventListener("change",(function(){let e=Ah.value,t=Ah.options[Ah.selectedIndex].getAttribute("data-image"),n=Ah.options[Ah.selectedIndex].getAttribute("data-original-price");window.priceFirst=parseFloat(n),document.querySelector(".js-image-1").src=t,console.log(t,"imageId"),console.log(e,"variantId"),window.variantIdFirstB=e,kp(window.priceFirst,window.priceSecond,window.priceThird),Ip()})),Ih&&Ih.addEventListener("change",(function(){let e=Ih.value,t=Ih.options[Ih.selectedIndex].getAttribute("data-image"),n=Ih.options[Ih.selectedIndex].getAttribute("data-original-price");window.priceSecond=parseFloat(n),document.querySelector(".js-image-2").src=t,console.log(e,"variantId"),window.variantIdSecondB=e,kp(window.priceFirst,window.priceSecond,window.priceThird),Ip()})),kh&&kh.addEventListener("change",(function(){let e=kh.value,t=kh.options[kh.selectedIndex].getAttribute("data-image"),n=kh.options[kh.selectedIndex].getAttribute("data-original-price");window.priceThird=parseFloat(n),document.querySelector(".js-image-3").src=t,console.log(e,"variantId"),window.variantIdThirdB=e,kp(window.priceFirst,window.priceSecond,window.priceThird),Ip()}));let Lp=document.querySelectorAll(".pdp-plan-option-item-radio"),Mp=!0;console.log(Lp,"optionPlanSelectorNew"),Lp&&Lp.forEach((e=>{e.addEventListener("click",(function(){console.log("kliknuto"),Lp.forEach((e=>{e.parentNode.classList.remove("pdp-plan-option-item--active")})),e.parentNode.classList.add("pdp-plan-option-item--active");let t=e.getAttribute("value");if(console.log("koji je ovde values",t),"Subscribe"===t||"Single Pack"==t){Mp=!0;let e,t=document.querySelector(".js-c-price").innerHTML;document.querySelector(".nodics-price")&&(e=document.querySelector(".nodics-price").innerHTML),document.querySelector(".js-discounted-price").textContent=t,document.querySelector(".js-normal-price").textContent=e,document.querySelectorAll(".js-save")[0].classList.remove("hidden"),document.querySelectorAll(".js-save")[1].classList.remove("hidden"),document.querySelectorAll(".js-save")[2].classList.remove("hidden")}else{Mp=!1;let e,t=document.querySelector(".disc-price").innerHTML;document.querySelector(".nodics-price")&&(e=document.querySelector(".nodics-price").innerHTML),document.querySelector(".js-discounted-price").textContent=t,document.querySelector(".js-normal-price").textContent=e,document.querySelectorAll(".js-save")[0].classList.add("hidden"),document.querySelectorAll(".js-save")[1].classList.add("hidden"),document.querySelectorAll(".js-save")[2].classList.add("hidden")}console.log(Mp,t,"value")}))}));var Lh=document.querySelector(".js-plan-selector");Lh&&(window.sellingPlanSelectorId=1080000692,Lh.addEventListener("change",(function(){let e=Lh.value;console.log(e,"variantId"),window.sellingPlanSelectorId=e})));const Dp=()=>{const e={items:[{id:window.variantIdFirst,selling_plan:window.sellingPlanSelectorId,quantity:1},{id:window.variantIdSecond,selling_plan:window.sellingPlanSelectorId,quantity:1}]};fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}).then((e=>(console.log(e.status,"ok"),200===e.status&&(cp(),dp()),e.json()))).catch((e=>{console.error("Error:",e)})),console.log("test test")},Np={"Blender Bombs":{"4-weeks":"7689601204","8-weeks":"7689633972"},"Bomb Bars":{"4-weeks":"7719289012","8-weeks":"7719321780"},"Protein Powder":{"4-weeks":"7719223476","8-weeks":"7719256244"}},Pp=document.querySelector("#plan-selector");Pp&&Pp.addEventListener("change",(e=>{const t=e.target.value;document.querySelectorAll("[data-type]").forEach((e=>{const n=e.getAttribute("data-type");if(Np[n]){const r=Np[n][t];e.setAttribute("data-selling-plan-id",r)}}));var n=document.querySelector(".js-product-one-selector"),r=document.querySelector(".js-product-two-selector");let s=n.options[n.selectedIndex].getAttribute("data-selling-plan-id"),i=r.options[r.selectedIndex].getAttribute("data-selling-plan-id");console.log(s,i,"sellingPlanId"),window.sellingPlanSelectorIdFirst=s,window.sellingPlanSelectorIdSecond=i}));const Op=()=>{let e=[];e=Mp?[{id:window.variantIdFirst,selling_plan:window.sellingPlanSelectorIdFirst,quantity:1},{id:window.variantIdSecond,selling_plan:window.sellingPlanSelectorIdSecond,quantity:1}]:[{id:window.variantIdFirst,quantity:1},{id:window.variantIdSecond,quantity:1}];const t={items:e};fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}).then((e=>(console.log(e.status,"ok"),200===e.status&&(cp(),dp()),e.json()))).catch((e=>{console.error("Error:",e)})),console.log("test test")},qp=document.querySelector("#plan-selector-bundle");qp&&qp.addEventListener("change",(e=>{const t=e.target.value;document.querySelectorAll("[data-type]").forEach((e=>{const n=e.getAttribute("data-type");if(Np[n]){const r=Np[n][t];e.setAttribute("data-selling-plan-id",r)}}));var n=document.querySelector(".js-product-one-selector-m"),r=document.querySelector(".js-product-two-selector-m"),s=document.querySelector(".js-product-three-selector-m");let i=n.options[n.selectedIndex].getAttribute("data-selling-plan-id");window.sellingPlanIdFirstM=i;let o=r.options[r.selectedIndex].getAttribute("data-selling-plan-id");window.sellingPlanIdSecondM=o;let a=s.options[s.selectedIndex].getAttribute("data-selling-plan-id");window.sellingPlanIdThirdM=a}));const Rp=()=>{let e=[];e=Mp?[{id:window.variantIdFirstM,selling_plan:window.sellingPlanIdFirstM,quantity:1},{id:window.variantIdSecondM,selling_plan:window.sellingPlanIdSecondM,quantity:1},{id:window.variantIdThirdM,selling_plan:window.sellingPlanIdThirdM,quantity:1}]:[{id:window.variantIdFirstM,quantity:1},{id:window.variantIdSecondM,quantity:1},{id:window.variantIdThirdM,quantity:1}],console.log(e,"addItemsssss");const t={items:e};fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}).then((e=>(console.log(e.status,"ok"),200===e.status&&(cp(),dp()),e.json()))).catch((e=>{console.error("Error:",e)})),console.log("test test")},Fp=()=>{let e=[];e=[{id:window.variantIdFirstB,quantity:1},{id:window.variantIdSecondB,quantity:1},{id:window.variantIdThirdB,quantity:1}],console.log(e,"add buy 2 get 1 free");const t={items:e};fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)}).then((e=>(console.log(e.status,"ok"),200===e.status&&(cp(),dp()),e.json()))).catch((e=>{console.error("Error:",e)})),console.log("test test")},Bp=(e,t)=>{const n=`updates[${e}]=${t}`;ap.setAttribute("disabled",!0),ap.textContent="Loading...",fetch(`/cart/update.js?${n}`,{headers:{"Content-Type":"application/json","X-Requested-With":"xmlhttprequest"},method:"POST"}).then((e=>e.json())).then((()=>{cp(),dp()}))},$p=async()=>{let e=document.querySelector(".js-copy-code"),t=e.getAttribute("data-code");console.log(e,"textHolder");try{await navigator.clipboard.writeText(t),e.textContent="Copied!",console.log("Content copied to clipboard")}catch(e){console.error("Failed to copy: ",e)}};window.refreshCart=cp,window.addToCarts=_p,window.addToCartLove=Ep,window.cartItemUpdate=Bp,window.showCart=dp,window.closeCart=hp,window.addToCartBundle=Dp,window.addToCartBundleMix=Rp,window.addToCartBundleOneTime=Op,window.addToCartBuyTwo=Fp,window.copyContent=$p}refreshCart(),"#cart"==window.location.hash&&showCart(),document.querySelectorAll(".js-scroll-top").forEach((e=>{e.addEventListener("click",(function(e){e.preventDefault(),window.scrollTo({top:0,behavior:"smooth"})}))}));n(250);new Wt(".swiper-slider",{slidesPerView:1,loop:!0,spaceBetween:20,pagination:{el:document.querySelector(".swiper-pagination-custom"),type:"bullets",clickable:!0},modules:[nn,Yt,Jt],breakpoints:{768:{slidesPerView:2,spaceBetween:20},1024:{slidesPerView:3,spaceBetween:20}}});console.log("testimonials.js loaded");const Mh=new Wt(".wknd-testimonial-swiper",{slidesPerView:1.6,spaceBetween:20,centeredSlides:!0,loop:!0,modules:[nn,Yt,Jt],navigation:{nextEl:".wknd-testimoinals-next",prevEl:".wknd-testimoinals-prev"},pagination:{el:".wknd-testimoinals-pagination",clickable:!0}});var Dh=new Wt(".thumb-slider",{slidesPerView:1,spaceBetween:10,freeMode:!0,watchSlidesVisibility:!0,watchSlidesProgress:!0,loop:!0,modules:[nn,Yt,Jt]});new Wt(".main-slider",{slidesPerView:1.5,spaceBetween:10,loop:!0,modules:[nn,Yt,Jt],pagination:{el:".wknd-testimoinals-pagination-mobile",clickable:!0},thumbs:{swiper:Dh}});Mh.init();class Nh{constructor(e){this.element=e.element,this.video=this.element.querySelector("video"),this.playPauseBtn=this.element.querySelector(".video-image-heading-text__media-play-pause"),null!==this.video&&this.playPauseBtn.addEventListener("click",(e=>{1==this.video.paused?(this.video.play(),this.playPauseBtn.classList.toggle("pause")):(this.video.pause(),this.playPauseBtn.classList.toggle("pause"))}))}}document.querySelectorAll(".video-image-heading-text").forEach((e=>{new Nh({element:e})}))})()})();
(() => {
  var e = {
      344: (e) => {
        var t, n, r;
        (t = window),
          (n = 0),
          (r = function e(t, r) {
            var s = this,
              i = this,
              o = !1;
            if (Array.isArray(t))
              return (
                !!t.length &&
                t.map(function (t) {
                  return new e(t, r);
                })
              );
            var a = {
              init: function () {
                this.options = Object.assign(
                  {
                    duration: 600,
                    ariaEnabled: !0,
                    collapse: !0,
                    showMultiple: !1,
                    onlyChildNodes: !0,
                    openOnInit: [],
                    elementClass: "ac",
                    triggerClass: "ac-trigger",
                    panelClass: "ac-panel",
                    activeClass: "is-active",
                    beforeOpen: function () {},
                    onOpen: function () {},
                    beforeClose: function () {},
                    onClose: function () {},
                  },
                  r
                );
                var e = "string" == typeof t;
                (this.container = e ? document.querySelector(t) : t), this.createDefinitions(), i.attachEvents();
              },
              createDefinitions: function () {
                var e = this,
                  t = this.options,
                  r = t.elementClass,
                  s = t.openOnInit,
                  i = t.onlyChildNodes ? this.container.childNodes : this.container.querySelectorAll(u(r));
                (this.elements = Array.from(i).filter(function (e) {
                  return e.classList && e.classList.contains(r);
                })),
                  (this.firstElement = this.elements[0]),
                  (this.lastElement = this.elements[this.elements.length - 1]),
                  this.elements
                    .filter(function (e) {
                      return !e.classList.contains("js-enabled");
                    })
                    .forEach(function (t) {
                      t.classList.add("js-enabled"), e.generateIDs(t), e.setARIA(t), e.setTransition(t);
                      var r = e.elements.indexOf(t);
                      n++, s.includes(r) ? e.showElement(t, !1) : e.closeElement(t, !1);
                    });
              },
              setTransition: function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                  n = this.options,
                  r = n.duration,
                  s = n.panelClass,
                  i = e.querySelector(u(s)),
                  o = l("transitionDuration");
                i.style[o] = t ? null : "".concat(r, "ms");
              },
              generateIDs: function (e) {
                var t = this.options,
                  r = t.triggerClass,
                  s = t.panelClass,
                  i = e.querySelector(u(r)),
                  o = e.querySelector(u(s));
                e.setAttribute("id", e.id || "ac-".concat(n)),
                  i.setAttribute("id", i.id || "ac-trigger-".concat(n)),
                  o.setAttribute("id", o.id || "ac-panel-".concat(n));
              },
              removeIDs: function (e) {
                var t = this.options,
                  n = t.triggerClass,
                  r = t.panelClass,
                  s = e.querySelector(u(n)),
                  i = e.querySelector(u(r));
                e.id.startsWith("ac-") && e.removeAttribute("id"),
                  s.id.startsWith("ac-") && s.removeAttribute("id"),
                  i.id.startsWith("ac-") && i.removeAttribute("id");
              },
              setARIA: function (e) {
                var t = this.options,
                  n = t.ariaEnabled,
                  r = t.triggerClass,
                  s = t.panelClass;
                if (n) {
                  var i = e.querySelector(u(r)),
                    o = e.querySelector(u(s));
                  i.setAttribute("role", "button"),
                    i.setAttribute("aria-controls", o.id),
                    i.setAttribute("aria-disabled", !1),
                    i.setAttribute("aria-expanded", !1),
                    o.setAttribute("role", "region"),
                    o.setAttribute("aria-labelledby", i.id);
                }
              },
              updateARIA: function (e, t) {
                var n = t.ariaExpanded,
                  r = t.ariaDisabled,
                  s = this.options,
                  i = s.ariaEnabled,
                  o = s.triggerClass;
                if (i) {
                  var a = e.querySelector(u(o));
                  a.setAttribute("aria-expanded", n), a.setAttribute("aria-disabled", r);
                }
              },
              removeARIA: function (e) {
                var t = this.options,
                  n = t.ariaEnabled,
                  r = t.triggerClass,
                  s = t.panelClass;
                if (n) {
                  var i = e.querySelector(u(r)),
                    o = e.querySelector(u(s));
                  i.removeAttribute("role"),
                    i.removeAttribute("aria-controls"),
                    i.removeAttribute("aria-disabled"),
                    i.removeAttribute("aria-expanded"),
                    o.removeAttribute("role"),
                    o.removeAttribute("aria-labelledby");
                }
              },
              focus: function (e, t) {
                e.preventDefault();
                var n = this.options.triggerClass;
                t.querySelector(u(n)).focus();
              },
              focusFirstElement: function (e) {
                this.focus(e, this.firstElement), (this.currFocusedIdx = 0);
              },
              focusLastElement: function (e) {
                this.focus(e, this.lastElement), (this.currFocusedIdx = this.elements.length - 1);
              },
              focusNextElement: function (e) {
                var t = this.currFocusedIdx + 1;
                if (t > this.elements.length - 1) return this.focusFirstElement(e);
                this.focus(e, this.elements[t]), (this.currFocusedIdx = t);
              },
              focusPrevElement: function (e) {
                var t = this.currFocusedIdx - 1;
                if (t < 0) return this.focusLastElement(e);
                this.focus(e, this.elements[t]), (this.currFocusedIdx = t);
              },
              showElement: function (e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                  n = this.options,
                  r = n.panelClass,
                  s = n.activeClass,
                  i = n.collapse,
                  o = n.beforeOpen;
                t && o(e);
                var a = e.querySelector(u(r)),
                  l = a.scrollHeight;
                e.classList.add(s),
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      a.style.height = t ? "".concat(l, "px") : "auto";
                    });
                  }),
                  this.updateARIA(e, { ariaExpanded: !0, ariaDisabled: !i });
              },
              closeElement: function (e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                  n = this.options,
                  r = n.panelClass,
                  s = n.activeClass,
                  i = n.beforeClose,
                  o = e.querySelector(u(r)),
                  a = o.scrollHeight;
                e.classList.remove(s),
                  t
                    ? (i(e),
                      requestAnimationFrame(function () {
                        (o.style.height = "".concat(a, "px")),
                          requestAnimationFrame(function () {
                            o.style.height = 0;
                          });
                      }))
                    : (o.style.height = 0),
                  this.updateARIA(e, { ariaExpanded: !1, ariaDisabled: !1 });
              },
              toggleElement: function (e) {
                var t = this.options,
                  n = t.activeClass,
                  r = t.collapse,
                  s = e.classList.contains(n);
                if (!s || r) return s ? this.closeElement(e) : this.showElement(e);
              },
              closeElements: function () {
                var e = this,
                  t = this.options,
                  n = t.activeClass;
                t.showMultiple ||
                  this.elements.forEach(function (t, r) {
                    t.classList.contains(n) && r !== e.currFocusedIdx && e.closeElement(t);
                  });
              },
              handleClick: function (e) {
                var t = this,
                  n = e.currentTarget;
                this.elements.forEach(function (r, s) {
                  r.contains(n) &&
                    "A" !== e.target.nodeName &&
                    ((t.currFocusedIdx = s), t.closeElements(), t.focus(e, r), t.toggleElement(r));
                });
              },
              handleKeydown: function (e) {
                switch (e.key) {
                  case "ArrowUp":
                    return this.focusPrevElement(e);
                  case "ArrowDown":
                    return this.focusNextElement(e);
                  case "Home":
                    return this.focusFirstElement(e);
                  case "End":
                    return this.focusLastElement(e);
                  default:
                    return null;
                }
              },
              handleFocus: function (e) {
                var t = e.currentTarget,
                  n = this.elements.find(function (e) {
                    return e.contains(t);
                  });
                this.currFocusedIdx = this.elements.indexOf(n);
              },
              handleTransitionEnd: function (e) {
                if ((e.stopPropagation(), "height" === e.propertyName)) {
                  var t = this.options,
                    n = t.onOpen,
                    r = t.onClose,
                    s = e.currentTarget,
                    i = parseInt(s.style.height),
                    o = this.elements.find(function (e) {
                      return e.contains(s);
                    });
                  i > 0 ? ((s.style.height = "auto"), n(o)) : r(o);
                }
              },
            };
            (this.attachEvents = function () {
              if (!o) {
                var e = a.options,
                  t = e.triggerClass,
                  n = e.panelClass;
                (a.handleClick = a.handleClick.bind(a)),
                  (a.handleKeydown = a.handleKeydown.bind(a)),
                  (a.handleFocus = a.handleFocus.bind(a)),
                  (a.handleTransitionEnd = a.handleTransitionEnd.bind(a)),
                  a.elements.forEach(function (e) {
                    var r = e.querySelector(u(t)),
                      s = e.querySelector(u(n));
                    r.addEventListener("click", a.handleClick),
                      r.addEventListener("keydown", a.handleKeydown),
                      r.addEventListener("focus", a.handleFocus),
                      s.addEventListener("webkitTransitionEnd", a.handleTransitionEnd),
                      s.addEventListener("transitionend", a.handleTransitionEnd);
                  }),
                  (o = !0);
              }
            }),
              (this.detachEvents = function () {
                if (o) {
                  var e = a.options,
                    t = e.triggerClass,
                    n = e.panelClass;
                  a.elements.forEach(function (e) {
                    var r = e.querySelector(u(t)),
                      s = e.querySelector(u(n));
                    r.removeEventListener("click", a.handleClick),
                      r.removeEventListener("keydown", a.handleKeydown),
                      r.removeEventListener("focus", a.handleFocus),
                      s.removeEventListener("webkitTransitionEnd", a.handleTransitionEnd),
                      s.removeEventListener("transitionend", a.handleTransitionEnd);
                  }),
                    (o = !1);
                }
              }),
              (this.toggle = function (e) {
                var t = a.elements[e];
                t && a.toggleElement(t);
              }),
              (this.open = function (e) {
                var t = a.elements[e];
                t && a.showElement(t);
              }),
              (this.openAll = function () {
                var e = a.options,
                  t = e.activeClass,
                  n = e.onOpen;
                a.elements.forEach(function (e) {
                  e.classList.contains(t) || (a.showElement(e, !1), n(e));
                });
              }),
              (this.close = function (e) {
                var t = a.elements[e];
                t && a.closeElement(t);
              }),
              (this.closeAll = function () {
                var e = a.options,
                  t = e.activeClass,
                  n = e.onClose;
                a.elements.forEach(function (e) {
                  e.classList.contains(t) && (a.closeElement(e, !1), n(e));
                });
              }),
              (this.destroy = function () {
                s.detachEvents(),
                  s.openAll(),
                  a.elements.forEach(function (e) {
                    a.removeIDs(e), a.removeARIA(e), a.setTransition(e, !0);
                  }),
                  (o = !0);
              }),
              (this.update = function () {
                a.createDefinitions(), s.detachEvents(), s.attachEvents();
              });
            var l = function (e) {
                return "string" == typeof document.documentElement.style[e] ? e : ((e = c(e)), (e = "webkit".concat(e)));
              },
              c = function (e) {
                return e.charAt(0).toUpperCase() + e.slice(1);
              },
              u = function (e) {
                return ".".concat(CSS.escape(e));
              };
            a.init();
          }),
          void 0 !== e.exports ? (e.exports = r) : (t.Accordion = r);
      },
      30: () => {
        if (null !== document.querySelector(".customers-login")) {
          const n = {
            recoverPasswordFormTriggers: "[data-recover-toggle]",
            recoverPasswordForm: "[data-recover-form]",
            loginForm: "[data-login-form]",
            formState: "[data-form-state]",
            resetSuccess: "[data-reset-success]",
          };
          function e(e) {
            e.preventDefault(), t();
          }
          function t() {
            console.log("clicked"),
              document.querySelector(n.recoverPasswordForm).classList.toggle("hidden"),
              document.querySelector(n.loginForm).classList.toggle("hidden");
          }
          document.querySelector(n.recoverPasswordForm) &&
            ("#recover" === window.location.hash && t(),
            document.querySelector(n.formState) && document.querySelector(n.resetSuccess).classList.remove("hidden"),
            document.querySelectorAll(n.recoverPasswordFormTriggers).forEach((t) => {
              t.addEventListener("click", e);
            }));
        }
      },
      250: () => {
        null !== document.querySelector(".product-card") &&
          document.querySelectorAll(".product-card").forEach((e) => {
            const t = e.querySelectorAll("picture")[0],
              n = e.querySelector(".product-card__media--featured");
            let r = "";
            if ((n && (r = n.src), null !== e.querySelector(".product-card__details--swatches .swatch__wrap"))) {
              const s = e.querySelectorAll(".product-card__details--swatches .swatch__wrap"),
                i = e.querySelectorAll("form");
              s.forEach((o) => {
                let a = r,
                  l = r.split("&width=600")[0];
                o.hasAttribute("data-image") && ((a = o.getAttribute("data-image")), (l = a.split("&width=600")[0]));
                const c = () => {
                  const { href: r } = o,
                    c = o.getAttribute("data-title");
                  let u = "";
                  o.hasAttribute("data-benefit") && (u = o.getAttribute("data-benefit"));
                  const d = o.getAttribute("data-form-id");
                  s.forEach((e) => {
                    e.classList.remove("active");
                  }),
                    o.classList.add("active"),
                    (n.srcset = ""),
                    (n.src = a),
                    (t.querySelectorAll("source")[0].srcset = `${l}&width=600`),
                    (t.querySelectorAll("source")[1].srcset = `${l}&width=600`),
                    (t.querySelectorAll("source")[2].srcset = `${l}&width=600`),
                    (t.querySelectorAll("source")[3].srcset = `${l}&width=600`),
                    null !== e.querySelector(`.${d}-add-to-cart`) &&
                      (i.forEach((e) => {
                        e.classList.remove("active");
                      }),
                      e.querySelectorAll(`.${d}-add-to-cart`).forEach((e) => {
                        e.classList.add("active");
                      })),
                    e.querySelectorAll("a:not(.swatch__wrap").forEach((e) => {
                      e.href = r;
                    }),
                    (e.querySelector(".product-card__details--title").textContent = c),
                    u.length
                      ? e.querySelector(".product-card__headline").classList.remove("hidden")
                      : e.querySelector(".product-card__headline").classList.add("hidden"),
                    (e.querySelector(".product-card__headline").textContent = u);
                };
                o.addEventListener("mouseenter", c),
                  window.isMobile() &&
                    o.addEventListener("click", (e) => {
                      e.preventDefault(), c();
                    });
              });
            }
          });
      },
      478: () => {
        window.Element &&
          !Element.prototype.closest &&
          (Element.prototype.closest = function (e) {
            var t,
              n = (this.document || this.ownerDocument).querySelectorAll(e),
              r = this;
            do {
              for (t = n.length; --t >= 0 && n.item(t) !== r; );
            } while (t < 0 && (r = r.parentElement));
            return r;
          });
      },
      841: () => {
        var e = document.links;
        for (let t = 0, n = e.length; t < n; t++)
          e[t].hostname !== window.location.hostname && ((e[t].target = "_blank"), (e[t].rel = "noreferrer noopener"));
      },
      855: () => {
        (window.isMobile = function () {
          let e = !1;
          var t;
          return (
            (t = navigator.userAgent || navigator.vendor || window.opera),
            (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
              t
            ) ||
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                t.substr(0, 4)
              )) &&
              (e = !0),
            e
          );
        }),
          navigator.maxTouchPoints > 1 && document.body.classList.add("touchpoints");
      },
      219: () => {
        if (
          window.CSS?.supports?.("(font:-apple-system-body) and (-webkit-touch-callout:none) and (-webkit-tap-highlight-color:hotpink)")
        ) {
          const e = document.querySelector('meta[name="viewport"]');
          null !== e && (e.content = `${e.content},user-scalable=no`);
        }
      },
      76: (e) => {
        var t = /^(?:submit|button|image|reset|file)$/i,
          n = /^(?:input|select|textarea|keygen)/i,
          r = /(\[[^\[\]]*\])/g;
        function s(e, t, n) {
          if (0 === t.length) return (e = n);
          var r = t.shift(),
            i = r.match(/^\[(.+?)\]$/);
          if ("[]" === r)
            return (
              (e = e || []), Array.isArray(e) ? e.push(s(null, t, n)) : ((e._values = e._values || []), e._values.push(s(null, t, n))), e
            );
          if (i) {
            var o = i[1],
              a = +o;
            isNaN(a) ? ((e = e || {})[o] = s(e[o], t, n)) : ((e = e || [])[a] = s(e[a], t, n));
          } else e[r] = s(e[r], t, n);
          return e;
        }
        function i(e, t, n) {
          if (t.match(r)) {
            s(
              e,
              (function (e) {
                var t = [],
                  n = new RegExp(r),
                  s = /^([^\[\]]*)/.exec(e);
                for (s[1] && t.push(s[1]); null !== (s = n.exec(e)); ) t.push(s[1]);
                return t;
              })(t),
              n
            );
          } else {
            var i = e[t];
            i ? (Array.isArray(i) || (e[t] = [i]), e[t].push(n)) : (e[t] = n);
          }
          return e;
        }
        function o(e, t, n) {
          return (
            (n = n.replace(/(\r)?\n/g, "\r\n")),
            (n = (n = encodeURIComponent(n)).replace(/%20/g, "+")),
            e + (e ? "&" : "") + encodeURIComponent(t) + "=" + n
          );
        }
        e.exports = function (e, r) {
          "object" != typeof r ? (r = { hash: !!r }) : void 0 === r.hash && (r.hash = !0);
          for (
            var s = r.hash ? {} : "",
              a = r.serializer || (r.hash ? i : o),
              l = e && e.elements ? e.elements : [],
              c = Object.create(null),
              u = 0;
            u < l.length;
            ++u
          ) {
            var d = l[u];
            if ((r.disabled || !d.disabled) && d.name && n.test(d.nodeName) && !t.test(d.type)) {
              var h = d.name,
                p = d.value;
              if ((("checkbox" !== d.type && "radio" !== d.type) || d.checked || (p = void 0), r.empty)) {
                if (
                  ("checkbox" !== d.type || d.checked || (p = ""),
                  "radio" === d.type && (c[d.name] || d.checked ? d.checked && (c[d.name] = !0) : (c[d.name] = !1)),
                  null == p && "radio" == d.type)
                )
                  continue;
              } else if (!p) continue;
              if ("select-multiple" !== d.type) s = a(s, h, p);
              else {
                p = [];
                for (var f = d.options, m = !1, g = 0; g < f.length; ++g) {
                  var y = f[g],
                    v = r.empty && !y.value,
                    w = y.value || v;
                  y.selected &&
                    w &&
                    ((m = !0), (s = r.hash && "[]" !== h.slice(h.length - 2) ? a(s, h + "[]", y.value) : a(s, h, y.value)));
                }
                !m && r.empty && (s = a(s, h, ""));
              }
            }
          }
          if (r.empty) for (var h in c) c[h] || (s = a(s, h, ""));
          return s;
        };
      },
      372: function (e) {
        e.exports = (function () {
          "use strict";
          function e(n) {
            var r = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
            if (!(this instanceof e)) return new (Function.prototype.bind.apply(e, [null].concat(Array.prototype.slice.call(arguments))))();
            (this.element = n),
              (this.startOffset = t(r.startOffset, n && n.offsetHeight)),
              (this.tolerance = t(r.tolerance, 8)),
              (this.showAtBottom = t(r.showAtBottom, !0)),
              (this.classNames = r.classNames || { base: "headspace", fixed: "headspace--fixed", hidden: "headspace--hidden" }),
              (this._scrollLast = 0),
              "undefined" != typeof window && this.init();
          }
          function t(e, t) {
            return void 0 !== e ? e : t;
          }
          function n(e) {
            var t = window.pageYOffset,
              n = e._scrollLast;
            t <= 0
              ? e.reset()
              : e.showAtBottom && window.innerHeight + t >= document.body.offsetHeight
              ? e.fix()
              : t > e.startOffset && Math.abs(t - n) >= e.tolerance && e[t > n ? "hide" : "fix"](),
              (e._scrollLast = t);
          }
          return (
            (e.prototype = {
              init: function () {
                var e = this;
                this.addClass(this.classNames.base),
                  window.addEventListener("scroll", function () {
                    return e.debounce(function () {
                      return n(e);
                    });
                  });
              },
              reset: function () {
                var e = this.classNames;
                this.removeClass(e.fixed, e.hidden);
              },
              fix: function () {
                var e = this.classNames;
                this.addClass(e.fixed), this.removeClass(e.hidden);
              },
              hide: function () {
                this.addClass(this.classNames.hidden);
              },
              addClass: function () {
                var e;
                (e = this.element.classList).add.apply(e, arguments);
              },
              removeClass: function () {
                var e;
                (e = this.element.classList).remove.apply(e, arguments);
              },
              debounce: function (e) {
                window.requestAnimationFrame(e);
              },
            }),
            (e.isSupported = function () {
              return !("undefined" == typeof window || !window.requestAnimationFrame || !("classList" in document.documentElement));
            }),
            e
          );
        })();
      },
      139: function (e) {
        e.exports = (function () {
          "use strict";
          var e = {
            required: "This field is required",
            email: "This field requires a valid e-mail address",
            number: "This field requires a number",
            integer: "This field requires an integer value",
            url: "This field requires a valid website URL",
            tel: "This field requires a valid telephone number",
            maxlength: "This fields length must be < ${1}",
            minlength: "This fields length must be > ${1}",
            min: "Minimum value for this field is ${1}",
            max: "Maximum value for this field is ${1}",
            pattern: "Please match the requested format",
          };
          function t(e, t) {
            for (; (e = e.parentElement) && !e.classList.contains(t); );
            return e;
          }
          function n(e) {
            var t = arguments;
            return this.replace(/\${([^{}]*)}/g, function (e, n) {
              return t[n];
            });
          }
          function r(e) {
            return e.pristine.self.form.querySelectorAll('input[name="' + e.getAttribute("name") + '"]:checked').length;
          }
          function s(e, t) {
            for (var n in t) n in e || (e[n] = t[n]);
            return e;
          }
          function i(e) {
            return !!(e && e.constructor && e.call && e.apply);
          }
          var o = {
              classTo: "form-group",
              errorClass: "has-danger",
              successClass: "has-success",
              errorTextParent: "form-group",
              errorTextTag: "div",
              errorTextClass: "text-help",
            },
            a = "pristine-error",
            l = "input:not([type^=hidden]):not([type^=submit]), select, textarea",
            c = ["required", "min", "max", "minlength", "maxlength", "pattern"],
            u =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            d = {},
            h = function (t, n) {
              (n.name = t), n.msg || (n.msg = e[t]), void 0 === n.priority && (n.priority = 1), (d[t] = n);
            };
          function p(e, r, u) {
            var h = this;
            function p(e, t, n) {
              e.setAttribute("novalidate", "true"),
                (h.form = e),
                (h.config = s(t || {}, o)),
                (h.live = !(!1 === n)),
                (h.fields = Array.from(e.querySelectorAll(l)).map(
                  function (e) {
                    var t = [],
                      n = {},
                      r = {};
                    return (
                      [].forEach.call(e.attributes, function (e) {
                        if (/^data-pristine-/.test(e.name)) {
                          var s = e.name.substr(14);
                          if (s.endsWith("-message")) return void (r[s.slice(0, s.length - 8)] = e.value);
                          "type" === s && (s = e.value), f(t, n, s, e.value);
                        } else ~c.indexOf(e.name) ? f(t, n, e.name, e.value) : "type" === e.name && f(t, n, e.value);
                      }),
                      t.sort(function (e, t) {
                        return t.priority - e.priority;
                      }),
                      h.live &&
                        e.addEventListener(
                          ~["radio", "checkbox"].indexOf(e.getAttribute("type")) ? "change" : "input",
                          function (e) {
                            h.validate(e.target);
                          }.bind(h)
                        ),
                      (e.pristine = { input: e, validators: t, params: n, messages: r, self: h })
                    );
                  }.bind(h)
                ));
            }
            function f(e, t, n, r) {
              var s = d[n];
              if (s && (e.push(s), r)) {
                var i = r.split(",");
                i.unshift(null), (t[n] = i);
              }
            }
            function m(e) {
              for (var t = [], r = !0, s = 0; e.validators[s]; s++) {
                var o = e.validators[s],
                  a = e.params[o.name] ? e.params[o.name] : [];
                if (((a[0] = e.input.value), !o.fn.apply(e.input, a))) {
                  if (((r = !1), i(o.msg))) t.push(o.msg(e.input.value, a));
                  else {
                    var l = e.messages[o.name] || o.msg;
                    t.push(n.apply(l, a));
                  }
                  if (!0 === o.halt) break;
                }
              }
              return (e.errors = t), r;
            }
            function g(e) {
              if (e.errorElements) return e.errorElements;
              var n = t(e.input, h.config.classTo),
                r = null,
                s = null;
              return (
                (r = h.config.classTo === h.config.errorTextParent ? n : n.querySelector("." + h.config.errorTextParent)) &&
                  ((s = r.querySelector("." + a)) ||
                    (((s = document.createElement(h.config.errorTextTag)).className = a + " " + h.config.errorTextClass),
                    r.appendChild(s),
                    (s.pristineDisplay = s.style.display))),
                (e.errorElements = [n, s])
              );
            }
            function y(e) {
              var t = g(e),
                n = t[0],
                r = t[1];
              n && (n.classList.remove(h.config.successClass), n.classList.add(h.config.errorClass)),
                r && ((r.innerHTML = e.errors.join("<br/>")), (r.style.display = r.pristineDisplay || ""));
            }
            function v(e) {
              var t = g(e),
                n = t[0],
                r = t[1];
              return (
                n && (n.classList.remove(h.config.errorClass), n.classList.remove(h.config.successClass)),
                r && ((r.innerHTML = ""), (r.style.display = "none")),
                t
              );
            }
            function w(e) {
              var t = v(e)[0];
              t && t.classList.add(h.config.successClass);
            }
            return (
              p(e, r, u),
              (h.validate = function (e, t) {
                t = (e && !0 === t) || !0 === e;
                var n = h.fields;
                !0 !== e &&
                  !1 !== e &&
                  (e instanceof HTMLElement
                    ? (n = [e.pristine])
                    : (e instanceof NodeList || e instanceof (window.$ || Array) || e instanceof Array) &&
                      (n = Array.from(e).map(function (e) {
                        return e.pristine;
                      })));
                for (var r = !0, s = 0; n[s]; s++) {
                  var i = n[s];
                  m(i) ? !t && w(i) : ((r = !1), !t && y(i));
                }
                return r;
              }),
              (h.getErrors = function (e) {
                if (!e) {
                  for (var t = [], n = 0; n < h.fields.length; n++) {
                    var r = h.fields[n];
                    r.errors.length && t.push({ input: r.input, errors: r.errors });
                  }
                  return t;
                }
                return e.tagName && "select" === e.tagName.toLowerCase()
                  ? e.pristine.errors
                  : e.length
                  ? e[0].pristine.errors
                  : e.pristine.errors;
              }),
              (h.addValidator = function (e, t, n, r, s) {
                e instanceof HTMLElement
                  ? (e.pristine.validators.push({ fn: t, msg: n, priority: r, halt: s }),
                    e.pristine.validators.sort(function (e, t) {
                      return t.priority - e.priority;
                    }))
                  : console.warn("The parameter elem must be a dom element");
              }),
              (h.addError = function (e, t) {
                (e = e.length ? e[0] : e).pristine.errors.push(t), y(e.pristine);
              }),
              (h.reset = function () {
                for (var e = 0; h.fields[e]; e++) h.fields[e].errorElements = null;
                Array.from(h.form.querySelectorAll("." + a)).map(function (e) {
                  e.parentNode.removeChild(e);
                }),
                  Array.from(h.form.querySelectorAll("." + h.config.classTo)).map(function (e) {
                    e.classList.remove(h.config.successClass), e.classList.remove(h.config.errorClass);
                  });
              }),
              (h.destroy = function () {
                h.reset(),
                  h.fields.forEach(function (e) {
                    delete e.input.pristine;
                  }),
                  (h.fields = []);
              }),
              (h.setGlobalConfig = function (e) {
                o = e;
              }),
              h
            );
          }
          return (
            h("text", {
              fn: function (e) {
                return !0;
              },
              priority: 0,
            }),
            h("required", {
              fn: function (e) {
                return "radio" === this.type || "checkbox" === this.type ? r(this) : void 0 !== e && "" !== e;
              },
              priority: 99,
              halt: !0,
            }),
            h("email", {
              fn: function (e) {
                return !e || u.test(e);
              },
            }),
            h("number", {
              fn: function (e) {
                return !e || !isNaN(parseFloat(e));
              },
              priority: 2,
            }),
            h("integer", {
              fn: function (e) {
                return !e || /^\d+$/.test(e);
              },
            }),
            h("minlength", {
              fn: function (e, t) {
                return !e || e.length >= parseInt(t);
              },
            }),
            h("maxlength", {
              fn: function (e, t) {
                return !e || e.length <= parseInt(t);
              },
            }),
            h("min", {
              fn: function (e, t) {
                return !e || ("checkbox" === this.type ? r(this) >= parseInt(t) : parseFloat(e) >= parseFloat(t));
              },
            }),
            h("max", {
              fn: function (e, t) {
                return !e || ("checkbox" === this.type ? r(this) <= parseInt(t) : parseFloat(e) <= parseFloat(t));
              },
            }),
            h("pattern", {
              fn: function (e, t) {
                var n = t.match(new RegExp("^/(.*?)/([gimy]*)$"));
                return !e || new RegExp(n[1], n[2]).test(e);
              },
            }),
            (p.addValidator = function (e, t, n, r, s) {
              h(e, { fn: t, msg: n, priority: r, halt: s });
            }),
            p
          );
        })();
      },
      130: function (e) {
        var t;
        (t = function () {
          return (function (e) {
            var t = {};
            function n(r) {
              if (t[r]) return t[r].exports;
              var s = (t[r] = { i: r, l: !1, exports: {} });
              return e[r].call(s.exports, s, s.exports, n), (s.l = !0), s.exports;
            }
            return (
              (n.m = e),
              (n.c = t),
              (n.d = function (e, t, r) {
                n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
              }),
              (n.r = function (e) {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
                  Object.defineProperty(e, "__esModule", { value: !0 });
              }),
              (n.t = function (e, t) {
                if ((1 & t && (e = n(e)), 8 & t)) return e;
                if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                var r = Object.create(null);
                if ((n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                  for (var s in e)
                    n.d(
                      r,
                      s,
                      function (t) {
                        return e[t];
                      }.bind(null, s)
                    );
                return r;
              }),
              (n.n = function (e) {
                var t =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return n.d(t, "a", t), t;
              }),
              (n.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (n.p = ""),
              n((n.s = 0))
            );
          })([
            function (e, t, n) {
              "use strict";
              n.r(t);
              var r = function (e) {
                  return Array.isArray(e) ? e : [e];
                },
                s = function (e) {
                  return e instanceof Node;
                },
                i = function (e, t) {
                  if (e && t) {
                    e = (function (e) {
                      return e instanceof NodeList;
                    })(e)
                      ? e
                      : [e];
                    for (var n = 0; n < e.length && !0 !== t(e[n], n, e.length); n++);
                  }
                },
                o = function (e) {
                  return console.error("[scroll-lock] ".concat(e));
                },
                a = function (e) {
                  if (Array.isArray(e)) return e.join(", ");
                },
                l = function (e) {
                  var t = [];
                  return (
                    i(e, function (e) {
                      return t.push(e);
                    }),
                    t
                  );
                },
                c = function (e, t) {
                  var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : document;
                  if ((!(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]) && -1 !== l(n.querySelectorAll(t)).indexOf(e))
                    return e;
                  for (; (e = e.parentElement) && -1 === l(n.querySelectorAll(t)).indexOf(e); );
                  return e;
                },
                u = function (e, t) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document;
                  return -1 !== l(n.querySelectorAll(t)).indexOf(e);
                },
                d = function (e) {
                  if (e) return "hidden" === getComputedStyle(e).overflow;
                },
                h = function (e) {
                  if (e) return !!d(e) || e.scrollTop <= 0;
                },
                p = function (e) {
                  if (e) {
                    if (d(e)) return !0;
                    var t = e.scrollTop,
                      n = e.scrollHeight;
                    return t + e.offsetHeight >= n;
                  }
                },
                f = function (e) {
                  if (e) return !!d(e) || e.scrollLeft <= 0;
                },
                m = function (e) {
                  if (e) {
                    if (d(e)) return !0;
                    var t = e.scrollLeft,
                      n = e.scrollWidth;
                    return t + e.offsetWidth >= n;
                  }
                };
              function g(e, t, n) {
                return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n), e;
              }
              n.d(t, "disablePageScroll", function () {
                return w;
              }),
                n.d(t, "enablePageScroll", function () {
                  return b;
                }),
                n.d(t, "getScrollState", function () {
                  return S;
                }),
                n.d(t, "clearQueueScrollLocks", function () {
                  return E;
                }),
                n.d(t, "getTargetScrollBarWidth", function () {
                  return T;
                }),
                n.d(t, "getCurrentTargetScrollBarWidth", function () {
                  return _;
                }),
                n.d(t, "getPageScrollBarWidth", function () {
                  return C;
                }),
                n.d(t, "getCurrentPageScrollBarWidth", function () {
                  return x;
                }),
                n.d(t, "addScrollableTarget", function () {
                  return A;
                }),
                n.d(t, "removeScrollableTarget", function () {
                  return I;
                }),
                n.d(t, "addScrollableSelector", function () {
                  return k;
                }),
                n.d(t, "removeScrollableSelector", function () {
                  return L;
                }),
                n.d(t, "addLockableTarget", function () {
                  return M;
                }),
                n.d(t, "addLockableSelector", function () {
                  return D;
                }),
                n.d(t, "setFillGapMethod", function () {
                  return N;
                }),
                n.d(t, "addFillGapTarget", function () {
                  return P;
                }),
                n.d(t, "removeFillGapTarget", function () {
                  return O;
                }),
                n.d(t, "addFillGapSelector", function () {
                  return q;
                }),
                n.d(t, "removeFillGapSelector", function () {
                  return R;
                }),
                n.d(t, "refillGaps", function () {
                  return F;
                });
              var y = ["padding", "margin", "width", "max-width", "none"],
                v = {
                  scroll: !0,
                  queue: 0,
                  scrollableSelectors: ["[data-scroll-lock-scrollable]"],
                  lockableSelectors: ["body", "[data-scroll-lock-lockable]"],
                  fillGapSelectors: ["body", "[data-scroll-lock-fill-gap]", "[data-scroll-lock-lockable]"],
                  fillGapMethod: y[0],
                  startTouchY: 0,
                  startTouchX: 0,
                },
                w = function (e) {
                  v.queue <= 0 && ((v.scroll = !1), B(), G()), A(e), v.queue++;
                },
                b = function (e) {
                  v.queue > 0 && v.queue--, v.queue <= 0 && ((v.scroll = !0), $(), H()), I(e);
                },
                S = function () {
                  return v.scroll;
                },
                E = function () {
                  v.queue = 0;
                },
                T = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                  if (s(e)) {
                    var n = e.style.overflowY;
                    t
                      ? S() || (e.style.overflowY = e.getAttribute("data-scroll-lock-saved-overflow-y-property"))
                      : (e.style.overflowY = "scroll");
                    var r = _(e);
                    return (e.style.overflowY = n), r;
                  }
                  return 0;
                },
                _ = function (e) {
                  if (s(e)) {
                    if (e === document.body) {
                      var t = document.documentElement.clientWidth;
                      return window.innerWidth - t;
                    }
                    var n = e.style.borderLeftWidth,
                      r = e.style.borderRightWidth;
                    (e.style.borderLeftWidth = "0px"), (e.style.borderRightWidth = "0px");
                    var i = e.offsetWidth - e.clientWidth;
                    return (e.style.borderLeftWidth = n), (e.style.borderRightWidth = r), i;
                  }
                  return 0;
                },
                C = function () {
                  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                  return T(document.body, e);
                },
                x = function () {
                  return _(document.body);
                },
                A = function (e) {
                  e &&
                    r(e).map(function (e) {
                      i(e, function (e) {
                        s(e) ? e.setAttribute("data-scroll-lock-scrollable", "") : o('"'.concat(e, '" is not a Element.'));
                      });
                    });
                },
                I = function (e) {
                  e &&
                    r(e).map(function (e) {
                      i(e, function (e) {
                        s(e) ? e.removeAttribute("data-scroll-lock-scrollable") : o('"'.concat(e, '" is not a Element.'));
                      });
                    });
                },
                k = function (e) {
                  e &&
                    r(e).map(function (e) {
                      v.scrollableSelectors.push(e);
                    });
                },
                L = function (e) {
                  e &&
                    r(e).map(function (e) {
                      v.scrollableSelectors = v.scrollableSelectors.filter(function (t) {
                        return t !== e;
                      });
                    });
                },
                M = function (e) {
                  e &&
                    (r(e).map(function (e) {
                      i(e, function (e) {
                        s(e) ? e.setAttribute("data-scroll-lock-lockable", "") : o('"'.concat(e, '" is not a Element.'));
                      });
                    }),
                    S() || B());
                },
                D = function (e) {
                  e &&
                    (r(e).map(function (e) {
                      v.lockableSelectors.push(e);
                    }),
                    S() || B(),
                    q(e));
                },
                N = function (e) {
                  if (e)
                    if (-1 !== y.indexOf(e)) (v.fillGapMethod = e), F();
                    else {
                      var t = y.join(", ");
                      o('"'.concat(e, '" method is not available!\nAvailable fill gap methods: ').concat(t, "."));
                    }
                },
                P = function (e) {
                  e &&
                    r(e).map(function (e) {
                      i(e, function (e) {
                        s(e)
                          ? (e.setAttribute("data-scroll-lock-fill-gap", ""), v.scroll || K(e))
                          : o('"'.concat(e, '" is not a Element.'));
                      });
                    });
                },
                O = function (e) {
                  e &&
                    r(e).map(function (e) {
                      i(e, function (e) {
                        s(e) ? (e.removeAttribute("data-scroll-lock-fill-gap"), v.scroll || Y(e)) : o('"'.concat(e, '" is not a Element.'));
                      });
                    });
                },
                q = function (e) {
                  e &&
                    r(e).map(function (e) {
                      -1 === v.fillGapSelectors.indexOf(e) && (v.fillGapSelectors.push(e), v.scroll || W(e));
                    });
                },
                R = function (e) {
                  e &&
                    r(e).map(function (e) {
                      (v.fillGapSelectors = v.fillGapSelectors.filter(function (t) {
                        return t !== e;
                      })),
                        v.scroll || Q(e);
                    });
                },
                F = function () {
                  v.scroll || G();
                },
                B = function () {
                  var e = a(v.lockableSelectors);
                  V(e);
                },
                $ = function () {
                  var e = a(v.lockableSelectors);
                  j(e);
                },
                V = function (e) {
                  var t = document.querySelectorAll(e);
                  i(t, function (e) {
                    z(e);
                  });
                },
                j = function (e) {
                  var t = document.querySelectorAll(e);
                  i(t, function (e) {
                    U(e);
                  });
                },
                z = function (e) {
                  if (s(e) && "true" !== e.getAttribute("data-scroll-lock-locked")) {
                    var t = window.getComputedStyle(e);
                    e.setAttribute("data-scroll-lock-saved-overflow-y-property", t.overflowY),
                      e.setAttribute("data-scroll-lock-saved-inline-overflow-property", e.style.overflow),
                      e.setAttribute("data-scroll-lock-saved-inline-overflow-y-property", e.style.overflowY),
                      (e.style.overflow = "hidden"),
                      e.setAttribute("data-scroll-lock-locked", "true");
                  }
                },
                U = function (e) {
                  s(e) &&
                    "true" === e.getAttribute("data-scroll-lock-locked") &&
                    ((e.style.overflow = e.getAttribute("data-scroll-lock-saved-inline-overflow-property")),
                    (e.style.overflowY = e.getAttribute("data-scroll-lock-saved-inline-overflow-y-property")),
                    e.removeAttribute("data-scroll-lock-saved-overflow-property"),
                    e.removeAttribute("data-scroll-lock-saved-inline-overflow-property"),
                    e.removeAttribute("data-scroll-lock-saved-inline-overflow-y-property"),
                    e.removeAttribute("data-scroll-lock-locked"));
                },
                G = function () {
                  v.fillGapSelectors.map(function (e) {
                    W(e);
                  });
                },
                H = function () {
                  v.fillGapSelectors.map(function (e) {
                    Q(e);
                  });
                },
                W = function (e) {
                  var t = document.querySelectorAll(e),
                    n = -1 !== v.lockableSelectors.indexOf(e);
                  i(t, function (e) {
                    K(e, n);
                  });
                },
                K = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                  if (s(e)) {
                    var n;
                    if ("" === e.getAttribute("data-scroll-lock-lockable") || t) n = T(e, !0);
                    else {
                      var r = c(e, a(v.lockableSelectors));
                      n = T(r, !0);
                    }
                    "true" === e.getAttribute("data-scroll-lock-filled-gap") && Y(e);
                    var i = window.getComputedStyle(e);
                    if (
                      (e.setAttribute("data-scroll-lock-filled-gap", "true"),
                      e.setAttribute("data-scroll-lock-current-fill-gap-method", v.fillGapMethod),
                      "margin" === v.fillGapMethod)
                    ) {
                      var o = parseFloat(i.marginRight);
                      e.style.marginRight = "".concat(o + n, "px");
                    } else if ("width" === v.fillGapMethod) e.style.width = "calc(100% - ".concat(n, "px)");
                    else if ("max-width" === v.fillGapMethod) e.style.maxWidth = "calc(100% - ".concat(n, "px)");
                    else if ("padding" === v.fillGapMethod) {
                      var l = parseFloat(i.paddingRight);
                      e.style.paddingRight = "".concat(l + n, "px");
                    }
                  }
                },
                Q = function (e) {
                  var t = document.querySelectorAll(e);
                  i(t, function (e) {
                    Y(e);
                  });
                },
                Y = function (e) {
                  if (s(e) && "true" === e.getAttribute("data-scroll-lock-filled-gap")) {
                    var t = e.getAttribute("data-scroll-lock-current-fill-gap-method");
                    e.removeAttribute("data-scroll-lock-filled-gap"),
                      e.removeAttribute("data-scroll-lock-current-fill-gap-method"),
                      "margin" === t
                        ? (e.style.marginRight = "")
                        : "width" === t
                        ? (e.style.width = "")
                        : "max-width" === t
                        ? (e.style.maxWidth = "")
                        : "padding" === t && (e.style.paddingRight = "");
                  }
                };
              "undefined" != typeof window &&
                window.addEventListener("resize", function (e) {
                  F();
                }),
                "undefined" != typeof document &&
                  (document.addEventListener("touchstart", function (e) {
                    v.scroll || ((v.startTouchY = e.touches[0].clientY), (v.startTouchX = e.touches[0].clientX));
                  }),
                  document.addEventListener(
                    "touchmove",
                    function (e) {
                      if (!v.scroll) {
                        var t = v.startTouchY,
                          n = v.startTouchX,
                          r = e.touches[0].clientY,
                          s = e.touches[0].clientX;
                        if (e.touches.length < 2) {
                          var i = a(v.scrollableSelectors),
                            o = { up: t < r, down: t > r, left: n < s, right: n > s },
                            l = { up: t + 3 < r, down: t - 3 > r, left: n + 3 < s, right: n - 3 > s };
                          !(function t(n) {
                            var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            if (n) {
                              var s = c(n, i, !1);
                              if (
                                (function (e) {
                                  return u(e, 'input[type="range"]');
                                })(n)
                              )
                                return !1;
                              if (
                                r ||
                                ((function (e) {
                                  return u(e, 'textarea, [contenteditable="true"]');
                                })(n) &&
                                  c(n, i)) ||
                                u(n, i)
                              ) {
                                var a = !1;
                                f(n) && m(n)
                                  ? ((o.up && h(n)) || (o.down && p(n))) && (a = !0)
                                  : h(n) && p(n)
                                  ? ((o.left && f(n)) || (o.right && m(n))) && (a = !0)
                                  : ((l.up && h(n)) || (l.down && p(n)) || (l.left && f(n)) || (l.right && m(n))) && (a = !0),
                                  a && (s ? t(s, !0) : e.cancelable && e.preventDefault());
                              } else t(s);
                            } else e.cancelable && e.preventDefault();
                          })(e.target);
                        }
                      }
                    },
                    { passive: !1 }
                  ),
                  document.addEventListener("touchend", function (e) {
                    v.scroll || ((v.startTouchY = 0), (v.startTouchX = 0));
                  }));
              var X = {
                  hide: function (e) {
                    o(
                      '"hide" is deprecated! Use "disablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#disablepagescrollscrollabletarget'
                    ),
                      w(e);
                  },
                  show: function (e) {
                    o(
                      '"show" is deprecated! Use "enablePageScroll" instead. \n https://github.com/FL3NKEY/scroll-lock#enablepagescrollscrollabletarget'
                    ),
                      b(e);
                  },
                  toggle: function (e) {
                    o('"toggle" is deprecated! Do not use it.'), S() ? w() : b(e);
                  },
                  getState: function () {
                    return (
                      o('"getState" is deprecated! Use "getScrollState" instead. \n https://github.com/FL3NKEY/scroll-lock#getscrollstate'),
                      S()
                    );
                  },
                  getWidth: function () {
                    return (
                      o(
                        '"getWidth" is deprecated! Use "getPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getpagescrollbarwidth'
                      ),
                      C()
                    );
                  },
                  getCurrentWidth: function () {
                    return (
                      o(
                        '"getCurrentWidth" is deprecated! Use "getCurrentPageScrollBarWidth" instead. \n https://github.com/FL3NKEY/scroll-lock#getcurrentpagescrollbarwidth'
                      ),
                      x()
                    );
                  },
                  setScrollableTargets: function (e) {
                    o(
                      '"setScrollableTargets" is deprecated! Use "addScrollableTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addscrollabletargetscrollabletarget'
                    ),
                      A(e);
                  },
                  setFillGapSelectors: function (e) {
                    o(
                      '"setFillGapSelectors" is deprecated! Use "addFillGapSelector" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgapselectorfillgapselector'
                    ),
                      q(e);
                  },
                  setFillGapTargets: function (e) {
                    o(
                      '"setFillGapTargets" is deprecated! Use "addFillGapTarget" instead. \n https://github.com/FL3NKEY/scroll-lock#addfillgaptargetfillgaptarget'
                    ),
                      P(e);
                  },
                  clearQueue: function () {
                    o(
                      '"clearQueue" is deprecated! Use "clearQueueScrollLocks" instead. \n https://github.com/FL3NKEY/scroll-lock#clearqueuescrolllocks'
                    ),
                      E();
                  },
                },
                J = (function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {},
                      r = Object.keys(n);
                    "function" == typeof Object.getOwnPropertySymbols &&
                      (r = r.concat(
                        Object.getOwnPropertySymbols(n).filter(function (e) {
                          return Object.getOwnPropertyDescriptor(n, e).enumerable;
                        })
                      )),
                      r.forEach(function (t) {
                        g(e, t, n[t]);
                      });
                  }
                  return e;
                })(
                  {
                    disablePageScroll: w,
                    enablePageScroll: b,
                    getScrollState: S,
                    clearQueueScrollLocks: E,
                    getTargetScrollBarWidth: T,
                    getCurrentTargetScrollBarWidth: _,
                    getPageScrollBarWidth: C,
                    getCurrentPageScrollBarWidth: x,
                    addScrollableSelector: k,
                    removeScrollableSelector: L,
                    addScrollableTarget: A,
                    removeScrollableTarget: I,
                    addLockableSelector: D,
                    addLockableTarget: M,
                    addFillGapSelector: q,
                    removeFillGapSelector: R,
                    addFillGapTarget: P,
                    removeFillGapTarget: O,
                    setFillGapMethod: N,
                    refillGaps: F,
                    _state: v,
                  },
                  X
                );
              t.default = J;
            },
          ]).default;
        }),
          (e.exports = t());
      },
    },
    t = {};
  function n(r) {
    var s = t[r];
    if (void 0 !== s) return s.exports;
    var i = (t[r] = { exports: {} });
    return e[r].call(i.exports, i, i.exports, n), i.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, { a: t }), t;
  }),
    (n.d = (e, t) => {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (() => {
      "use strict";
      n(478), n(841), n(855), n(219);
      var e = n(139),
        t = n.n(e);
      function r(e, t, n, r, s) {
        if (
          ((r.querySelector(".klaviyo_messages").innerHTML = ""),
          console.log(e),
          n.length > 1 && n.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/))
        )
          if (123456 !== e)
            (function (e, t, n) {
              void 0 === n && (n = {});
              var r = Object.assign({}, n, { g: e, email: t }),
                s = Object.keys(r).reduce(function (e, t) {
                  return e.append(t, r[t]), e;
                }, new URLSearchParams());
              return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
                method: "POST",
                headers: { "Access-Control-Allow-Headers": "*", "Content-Type": "application/x-www-form-urlencoded; charset=utf-8" },
                body: s,
              }).then(function (e) {
                return e.json();
              });
            })(e, n, t).then((e) => {
              e.success
                ? ((r.querySelector(".klaviyo_messages").style.display = "none"),
                  s.length ? window.location.replace(s) : (r.querySelector(".klaviyo_success").style.display = "block"),
                  r.querySelectorAll(".form__input").forEach((e) => {
                    e.value = "";
                  }))
                : ((r.querySelector(".klaviyo_success").style.display = "none"),
                  (r.querySelector(".klaviyo_messages").style.display = "block"),
                  e.errors.forEach(function (e) {
                    let t = document.createRange().createContextualFragment(`<div>${e}</div>`);
                    r.querySelector(".klaviyo_messages").append(t);
                  }));
            });
          else {
            r.querySelector(".klaviyo_messages").style.display = "block";
            let e = document.createRange().createContextualFragment("<div>Please use a valid Klaviyo ID.</div>");
            r.querySelector(".klaviyo_messages").append(e);
          }
      }
      null !== document.querySelector(".form-validate") &&
        document.querySelectorAll(".form-validate").forEach((e) => {
          const n = new (t())(e);
          e.addEventListener("submit", function (e) {
            e.preventDefault();
            var t = n.validate();
            console.log(t);
          });
        }),
        null !== document.querySelector(".klaviyo-newsletter") &&
          document.querySelectorAll(".klaviyo-newsletter").forEach((e) => {
            const t = e.querySelector("[type='submit']"),
              n = e.querySelector("[type='email']"),
              s = e.querySelector("[name='g']").value;
            let i = [],
              o = {},
              a = {};
            e.addEventListener("submit", function (t) {
              t.preventDefault(),
                console.log("---------Submitting form-----------"),
                (i = ["Accepts Marketing"]),
                (o = {}),
                (a = {}),
                e.querySelectorAll("input").forEach((e) => {
                  "submit" !== e.type &&
                    "hidden" !== e.type &&
                    "email" !== e.type &&
                    "$first_name" !== e.name &&
                    "$last_name" !== e.name &&
                    (i.push(e.name), (o[e.name] = e.value));
                }),
                e.querySelectorAll("textarea").forEach((e) => {
                  i.push(e.name), (o[e.name] = e.value);
                }),
                e.querySelectorAll("select").forEach((e) => {
                  i.push(e.name), (o[e.name] = e.value);
                }),
                null !== e.querySelector("[name='$first_name']") && (o.$first_name = e.querySelector("[name='$first_name']").value),
                null !== e.querySelector("[name='$last_name']") && (o.$last_name = e.querySelector("[name='$last_name']").value),
                (o["Accepts Marketing"] = !0),
                (a = { $fields: i, ...o }),
                r(s, a, n.value, e, "");
            }),
              t.addEventListener("click", (t) => {
                t.preventDefault(),
                  console.log("---------Submitting form-----------"),
                  (i = ["Accepts Marketing"]),
                  (o = {}),
                  (a = {}),
                  e.querySelectorAll("input").forEach((e) => {
                    "submit" !== e.type &&
                      "hidden" !== e.type &&
                      "email" !== e.type &&
                      "$consent" !== e.name &&
                      "$first_name" !== e.name &&
                      "$last_name" !== e.name &&
                      (i.push(e.name), (o[e.name] = e.value));
                  }),
                  e.querySelectorAll("textarea").forEach((e) => {
                    i.push(e.name), (o[e.name] = e.value);
                  }),
                  e.querySelectorAll("select").forEach((e) => {
                    i.push(e.name), (o[e.name] = e.value);
                  }),
                  null !== e.querySelector("[name='$first_name']") && (o.$first_name = e.querySelector("[name='$first_name']").value),
                  null !== e.querySelector("[name='$last_name']") && (o.$last_name = e.querySelector("[name='$last_name']").value),
                  (o["Accepts Marketing"] = !0),
                  (a = { $fields: i, ...o }),
                  r(s, a, n.value, e, "");
              });
          });
      var s = n(344),
        i = n.n(s);
      function o(e, t) {
        var n;
        return (
          "string" == typeof e
            ? t
              ? ((null !== (n = t[e]) && void 0 !== n) || (t[e] = document.querySelectorAll(e)), (e = t[e]))
              : (e = document.querySelectorAll(e))
            : e instanceof Element && (e = [e]),
          Array.from(e || [])
        );
      }
      null !== document.querySelector(".accordion-container") &&
        document.querySelectorAll(".accordion-container").forEach((e) => {
          let t;
          (t =
            e.hasAttribute("data-accordion-multiple") && "false" === e.getAttribute("data-accordion-multiple")
              ? new (i())(e, { showMultiple: !1 })
              : new (i())(e)),
            e.classList.contains("accordion-container--open") &&
              (t.openAll(),
              setTimeout(() => {
                e.querySelector(".ac-panel").classList.remove("!h-full"), e.querySelector(".ac-panel").classList.remove("!transition-none");
              }, 300)),
            e.querySelectorAll(".ac").forEach((e, n) => {
              e.classList.contains("ac--open") && t.open(n);
            }),
            e.querySelectorAll(".ac-trigger").forEach((t, n) => {
              t.addEventListener("click", () => {
                e.querySelectorAll(".ac").forEach((e) => {
                  e.classList.remove("ac--open");
                });
              });
            }),
            null !== e.querySelector(".ac-close-trigger") &&
              e.querySelectorAll(".ac-close-trigger").forEach((e, n) => {
                e.addEventListener("click", () => {
                  t.closeAll();
                });
              });
        });
      const a = (e) => "function" == typeof e,
        l = { any: 0, all: 1 };
      function c(e, t, { root: n, margin: r, amount: s = "any" } = {}) {
        if ("undefined" == typeof IntersectionObserver) return () => {};
        const i = o(e),
          c = new WeakMap(),
          u = new IntersectionObserver(
            (e) => {
              e.forEach((e) => {
                const n = c.get(e.target);
                if (e.isIntersecting !== Boolean(n))
                  if (e.isIntersecting) {
                    const n = t(e);
                    a(n) ? c.set(e.target, n) : u.unobserve(e.target);
                  } else n && (n(e), c.delete(e.target));
              });
            },
            { root: n, rootMargin: r, threshold: "number" == typeof s ? s : l[s] }
          );
        return i.forEach((e) => u.observe(e)), () => u.disconnect();
      }
      const u = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: "ease" },
        d = { ms: (e) => 1e3 * e, s: (e) => e / 1e3 },
        h = () => {},
        p = (e) => e;
      function f(e, t = !0) {
        if (e && "finished" !== e.playState)
          try {
            e.stop ? e.stop() : (t && e.commitStyles(), e.cancel());
          } catch (e) {}
      }
      const m = (e) => e(),
        g = (e, t, n = u.duration) => new Proxy({ animations: e.map(m).filter(Boolean), duration: n, options: t }, y),
        y = {
          get: (e, t) => {
            const n = e.animations[0];
            switch (t) {
              case "duration":
                return e.duration;
              case "currentTime":
                return d.s((null == n ? void 0 : n[t]) || 0);
              case "playbackRate":
              case "playState":
                return null == n ? void 0 : n[t];
              case "finished":
                return e.finished || (e.finished = Promise.all(e.animations.map(v)).catch(h)), e.finished;
              case "stop":
                return () => {
                  e.animations.forEach((e) => f(e));
                };
              case "forEachNative":
                return (t) => {
                  e.animations.forEach((n) => t(n, e));
                };
              default:
                return void 0 === (null == n ? void 0 : n[t]) ? void 0 : () => e.animations.forEach((e) => e[t]());
            }
          },
          set: (e, t, n) => {
            switch (t) {
              case "currentTime":
                n = d.ms(n);
              case "playbackRate":
                for (let r = 0; r < e.animations.length; r++) e.animations[r][t] = n;
                return !0;
            }
            return !1;
          },
        },
        v = (e) => e.finished,
        w = (e) => "object" == typeof e && Boolean(e.createAnimation),
        b = (e) => "number" == typeof e,
        S = (e) => Array.isArray(e) && !b(e[0]),
        E = (e, t, n) => -n * e + n * t + e,
        T = (e, t, n) => (t - e == 0 ? 1 : (n - e) / (t - e));
      function _(e, t) {
        const n = e[e.length - 1];
        for (let r = 1; r <= t; r++) {
          const s = T(0, t, r);
          e.push(E(n, 1, s));
        }
      }
      function C(e) {
        const t = [0];
        return _(t, e - 1), t;
      }
      const x = (e, t, n) => {
        const r = t - e;
        return ((((n - e) % r) + r) % r) + e;
      };
      const A = (e, t, n) => Math.min(Math.max(n, e), t);
      function I(e, t = C(e.length), n = p) {
        const r = e.length,
          s = r - t.length;
        return (
          s > 0 && _(t, s),
          (s) => {
            let i = 0;
            for (; i < r - 2 && !(s < t[i + 1]); i++);
            let o = A(0, 1, T(t[i], t[i + 1], s));
            const a = (function (e, t) {
              return S(e) ? e[x(0, e.length, t)] : e;
            })(n, i);
            return (o = a(o)), E(e[i], e[i + 1], o);
          }
        );
      }
      const k = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e,
        L = 1e-7,
        M = 12;
      function D(e, t, n, r) {
        if (e === t && n === r) return p;
        const s = (t) =>
          (function (e, t, n, r, s) {
            let i,
              o,
              a = 0;
            do {
              (o = t + (n - t) / 2), (i = k(o, r, s) - e), i > 0 ? (n = o) : (t = o);
            } while (Math.abs(i) > L && ++a < M);
            return o;
          })(t, 0, 1, e, n);
        return (e) => (0 === e || 1 === e ? e : k(s(e), t, r));
      }
      const N = (e) => Array.isArray(e) && b(e[0]),
        P = { ease: D(0.25, 0.1, 0.25, 1), "ease-in": D(0.42, 0, 1, 1), "ease-in-out": D(0.42, 0, 0.58, 1), "ease-out": D(0, 0, 0.58, 1) },
        O = /\((.*?)\)/;
      function q(e) {
        if (a(e)) return e;
        if (N(e)) return D(...e);
        if (P[e]) return P[e];
        if (e.startsWith("steps")) {
          const t = O.exec(e);
          if (t) {
            const e = t[1].split(",");
            return (
              (e, t = "end") =>
              (n) => {
                const r = (n = "end" === t ? Math.min(n, 0.999) : Math.max(n, 0.001)) * e,
                  s = "end" === t ? Math.floor(r) : Math.ceil(r);
                return A(0, 1, s / e);
              }
            )(parseFloat(e[0]), e[1].trim());
          }
        }
        return p;
      }
      class R {
        constructor(
          e,
          t = [0, 1],
          {
            easing: n,
            duration: r = u.duration,
            delay: s = u.delay,
            endDelay: i = u.endDelay,
            repeat: o = u.repeat,
            offset: a,
            direction: l = "normal",
            autoplay: c = !0,
          } = {}
        ) {
          if (
            ((this.startTime = null),
            (this.rate = 1),
            (this.t = 0),
            (this.cancelTimestamp = null),
            (this.easing = p),
            (this.duration = 0),
            (this.totalDuration = 0),
            (this.repeat = 0),
            (this.playState = "idle"),
            (this.finished = new Promise((e, t) => {
              (this.resolve = e), (this.reject = t);
            })),
            (n = n || u.easing),
            w(n))
          ) {
            const e = n.createAnimation(t);
            (n = e.easing), (t = e.keyframes || t), (r = e.duration || r);
          }
          (this.repeat = o), (this.easing = S(n) ? p : q(n)), this.updateDuration(r);
          const d = I(t, a, S(n) ? n.map(q) : p);
          (this.tick = (t) => {
            var n;
            let r = 0;
            (r = void 0 !== this.pauseTime ? this.pauseTime : (t - this.startTime) * this.rate),
              (this.t = r),
              (r /= 1e3),
              (r = Math.max(r - s, 0)),
              "finished" === this.playState && void 0 === this.pauseTime && (r = this.totalDuration);
            const o = r / this.duration;
            let a = Math.floor(o),
              c = o % 1;
            !c && o >= 1 && (c = 1), 1 === c && a--;
            const u = a % 2;
            ("reverse" === l || ("alternate" === l && u) || ("alternate-reverse" === l && !u)) && (c = 1 - c);
            const h = r >= this.totalDuration ? 1 : Math.min(c, 1),
              p = d(this.easing(h));
            e(p);
            void 0 === this.pauseTime && ("finished" === this.playState || r >= this.totalDuration + i)
              ? ((this.playState = "finished"), null === (n = this.resolve) || void 0 === n || n.call(this, p))
              : "idle" !== this.playState && (this.frameRequestId = requestAnimationFrame(this.tick));
          }),
            c && this.play();
        }
        play() {
          const e = performance.now();
          (this.playState = "running"),
            void 0 !== this.pauseTime ? (this.startTime = e - this.pauseTime) : this.startTime || (this.startTime = e),
            (this.cancelTimestamp = this.startTime),
            (this.pauseTime = void 0),
            (this.frameRequestId = requestAnimationFrame(this.tick));
        }
        pause() {
          (this.playState = "paused"), (this.pauseTime = this.t);
        }
        finish() {
          (this.playState = "finished"), this.tick(0);
        }
        stop() {
          var e;
          (this.playState = "idle"),
            void 0 !== this.frameRequestId && cancelAnimationFrame(this.frameRequestId),
            null === (e = this.reject) || void 0 === e || e.call(this, !1);
        }
        cancel() {
          this.stop(), this.tick(this.cancelTimestamp);
        }
        reverse() {
          this.rate *= -1;
        }
        commitStyles() {}
        updateDuration(e) {
          (this.duration = e), (this.totalDuration = e * (this.repeat + 1));
        }
        get currentTime() {
          return this.t;
        }
        set currentTime(e) {
          void 0 !== this.pauseTime || 0 === this.rate ? (this.pauseTime = e) : (this.startTime = performance.now() - e / this.rate);
        }
        get playbackRate() {
          return this.rate;
        }
        set playbackRate(e) {
          this.rate = e;
        }
      }
      class F {
        setAnimation(e) {
          (this.animation = e), null == e || e.finished.then(() => this.clearAnimation()).catch(() => {});
        }
        clearAnimation() {
          this.animation = this.generator = void 0;
        }
      }
      const B = new WeakMap();
      function $(e) {
        return B.has(e) || B.set(e, { transforms: [], values: new Map() }), B.get(e);
      }
      const V = ["", "X", "Y", "Z"],
        j = { x: "translateX", y: "translateY", z: "translateZ" },
        z = { syntax: "<angle>", initialValue: "0deg", toDefaultUnit: (e) => e + "deg" },
        U = {
          translate: { syntax: "<length-percentage>", initialValue: "0px", toDefaultUnit: (e) => e + "px" },
          rotate: z,
          scale: { syntax: "<number>", initialValue: 1, toDefaultUnit: p },
          skew: z,
        },
        G = new Map(),
        H = (e) => `--motion-${e}`,
        W = ["x", "y", "z"];
      ["translate", "scale", "rotate", "skew"].forEach((e) => {
        V.forEach((t) => {
          W.push(e + t), G.set(H(e + t), U[e]);
        });
      });
      const K = (e, t) => W.indexOf(e) - W.indexOf(t),
        Q = new Set(W),
        Y = (e) => Q.has(e),
        X = (e, t) => {
          j[t] && (t = j[t]);
          const { transforms: n } = $(e);
          var r, s;
          (s = t), -1 === (r = n).indexOf(s) && r.push(s), (e.style.transform = J(n));
        },
        J = (e) => e.sort(K).reduce(Z, "").trim(),
        Z = (e, t) => `${e} ${t}(var(${H(t)}))`,
        ee = (e) => e.startsWith("--"),
        te = new Set();
      const ne = (e, t) => document.createElement("div").animate(e, t),
        re = {
          cssRegisterProperty: () => "undefined" != typeof CSS && Object.hasOwnProperty.call(CSS, "registerProperty"),
          waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
          partialKeyframes: () => {
            try {
              ne({ opacity: [1] });
            } catch (e) {
              return !1;
            }
            return !0;
          },
          finished: () => Boolean(ne({ opacity: [0, 1] }, { duration: 0.001 }).finished),
          linearEasing: () => {
            try {
              ne({ opacity: 0 }, { easing: "linear(0, 1)" });
            } catch (e) {
              return !1;
            }
            return !0;
          },
        },
        se = {},
        ie = {};
      for (const Ph in re) ie[Ph] = () => (void 0 === se[Ph] && (se[Ph] = re[Ph]()), se[Ph]);
      const oe = (e, t) =>
          a(e)
            ? ie.linearEasing()
              ? `linear(${((e, t) => {
                  let n = "";
                  const r = Math.round(t / 0.015);
                  for (let t = 0; t < r; t++) n += e(T(0, r - 1, t)) + ", ";
                  return n.substring(0, n.length - 2);
                })(e, t)})`
              : u.easing
            : N(e)
            ? ae(e)
            : e,
        ae = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`;
      const le = (e) => (Array.isArray(e) ? e : [e]);
      function ce(e) {
        return j[e] && (e = j[e]), Y(e) ? H(e) : e;
      }
      const ue = {
          get: (e, t) => {
            t = ce(t);
            let n = ee(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t];
            if (!n && 0 !== n) {
              const e = G.get(t);
              e && (n = e.initialValue);
            }
            return n;
          },
          set: (e, t, n) => {
            (t = ce(t)), ee(t) ? e.style.setProperty(t, n) : (e.style[t] = n);
          },
        },
        de = (e) => "string" == typeof e;
      function he(e, t, n, r = {}, s) {
        const i = window.__MOTION_DEV_TOOLS_RECORD,
          o = !1 !== r.record && i;
        let l,
          {
            duration: c = u.duration,
            delay: m = u.delay,
            endDelay: g = u.endDelay,
            repeat: y = u.repeat,
            easing: v = u.easing,
            persist: E = !1,
            direction: T,
            offset: _,
            allowWebkitAcceleration: C = !1,
            autoplay: x = !0,
          } = r;
        const A = $(e),
          I = Y(t);
        let k = ie.waapi();
        I && X(e, t);
        const L = ce(t),
          M = (function (e, t) {
            return e.has(t) || e.set(t, new F()), e.get(t);
          })(A.values, L),
          D = G.get(L);
        return (
          f(M.animation, !(w(v) && M.generator) && !1 !== r.record),
          () => {
            const u = () => {
              var t, n;
              return null !== (n = null !== (t = ue.get(e, L)) && void 0 !== t ? t : null == D ? void 0 : D.initialValue) && void 0 !== n
                ? n
                : 0;
            };
            let f = (function (e, t) {
              for (let n = 0; n < e.length; n++) null === e[n] && (e[n] = n ? e[n - 1] : t());
              return e;
            })(le(n), u);
            const A = (function (e, t) {
              var n;
              let r = (null == t ? void 0 : t.toDefaultUnit) || p;
              const s = e[e.length - 1];
              if (de(s)) {
                const e = (null === (n = s.match(/(-?[\d.]+)([a-z%]*)/)) || void 0 === n ? void 0 : n[2]) || "";
                e && (r = (t) => t + e);
              }
              return r;
            })(f, D);
            if (w(v)) {
              const e = v.createAnimation(f, "opacity" !== t, u, L, M);
              (v = e.easing), (f = e.keyframes || f), (c = e.duration || c);
            }
            if (
              (ee(L) &&
                (ie.cssRegisterProperty()
                  ? (function (e) {
                      if (!te.has(e)) {
                        te.add(e);
                        try {
                          const { syntax: t, initialValue: n } = G.has(e) ? G.get(e) : {};
                          CSS.registerProperty({ name: e, inherits: !1, syntax: t, initialValue: n });
                        } catch (e) {}
                      }
                    })(L)
                  : (k = !1)),
              I && !ie.linearEasing() && (a(v) || (S(v) && v.some(a))) && (k = !1),
              k)
            ) {
              D && (f = f.map((e) => (b(e) ? D.toDefaultUnit(e) : e))), 1 !== f.length || (ie.partialKeyframes() && !o) || f.unshift(u());
              const t = {
                delay: d.ms(m),
                duration: d.ms(c),
                endDelay: d.ms(g),
                easing: S(v) ? void 0 : oe(v, c),
                direction: T,
                iterations: y + 1,
                fill: "both",
              };
              (l = e.animate({ [L]: f, offset: _, easing: S(v) ? v.map((e) => oe(e, c)) : void 0 }, t)),
                l.finished ||
                  (l.finished = new Promise((e, t) => {
                    (l.onfinish = e), (l.oncancel = t);
                  }));
              const n = f[f.length - 1];
              l.finished
                .then(() => {
                  E || (ue.set(e, L, n), l.cancel());
                })
                .catch(h),
                C || (l.playbackRate = 1.000001);
            } else if (s && I)
              (f = f.map((e) => ("string" == typeof e ? parseFloat(e) : e))),
                1 === f.length && f.unshift(parseFloat(u())),
                (l = new s(
                  (t) => {
                    ue.set(e, L, A ? A(t) : t);
                  },
                  f,
                  Object.assign(Object.assign({}, r), { duration: c, easing: v })
                ));
            else {
              const t = f[f.length - 1];
              ue.set(e, L, D && b(t) ? D.toDefaultUnit(t) : t);
            }
            return (
              o && i(e, t, f, { duration: c, delay: m, easing: v, repeat: y, offset: _ }, "motion-one"),
              M.setAnimation(l),
              l && !x && l.pause(),
              l
            );
          }
        );
      }
      const pe = (e, t) => (e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e));
      function fe(e, t, n) {
        return a(e) ? e(t, n) : e;
      }
      const me =
        ((ge = R),
        function (e, t, n = {}) {
          const r = (e = o(e)).length;
          Boolean(r), Boolean(t);
          const s = [];
          for (let i = 0; i < r; i++) {
            const o = e[i];
            for (const e in t) {
              const a = pe(n, e);
              a.delay = fe(a.delay, i, r);
              const l = he(o, e, t[e], a, ge);
              s.push(l);
            }
          }
          return g(s, n, n.duration);
        });
      var ge;
      function ye(e, t = {}) {
        return g(
          [
            () => {
              const n = new R(e, [0, 1], t);
              return n.finished.catch(() => {}), n;
            },
          ],
          t,
          t.duration
        );
      }
      function ve(e, t, n) {
        return (a(e) ? ye : me)(e, t, n);
      }
      function we(e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var s = 0;
          for (r = Object.getOwnPropertySymbols(e); s < r.length; s++)
            t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (n[r[s]] = e[r[s]]);
        }
        return n;
      }
      Object.create;
      Object.create;
      "function" == typeof SuppressedError && SuppressedError;
      const be = new WeakMap();
      let Se;
      function Ee({ target: e, contentRect: t, borderBoxSize: n }) {
        var r;
        null === (r = be.get(e)) ||
          void 0 === r ||
          r.forEach((r) => {
            r({
              target: e,
              contentSize: t,
              get size() {
                return (function (e, t) {
                  if (t) {
                    const { inlineSize: e, blockSize: n } = t[0];
                    return { width: e, height: n };
                  }
                  return e instanceof SVGElement && "getBBox" in e ? e.getBBox() : { width: e.offsetWidth, height: e.offsetHeight };
                })(e, n);
              },
            });
          });
      }
      function Te(e) {
        e.forEach(Ee);
      }
      function _e(e, t) {
        Se || ("undefined" != typeof ResizeObserver && (Se = new ResizeObserver(Te)));
        const n = o(e);
        return (
          n.forEach((e) => {
            let n = be.get(e);
            n || ((n = new Set()), be.set(e, n)), n.add(t), null == Se || Se.observe(e);
          }),
          () => {
            n.forEach((e) => {
              const n = be.get(e);
              null == n || n.delete(t), (null == n ? void 0 : n.size) || null == Se || Se.unobserve(e);
            });
          }
        );
      }
      const Ce = new Set();
      let xe;
      function Ae(e) {
        return (
          Ce.add(e),
          xe ||
            ((xe = () => {
              const e = { width: window.innerWidth, height: window.innerHeight },
                t = { target: window, size: e, contentSize: e };
              Ce.forEach((e) => e(t));
            }),
            window.addEventListener("resize", xe)),
          () => {
            Ce.delete(e), !Ce.size && xe && (xe = void 0);
          }
        );
      }
      const Ie = 50,
        ke = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } };
      function Le(e, t, n, r) {
        const s = n[t],
          { length: i, position: o } = ke[t],
          a = s.current,
          l = n.time;
        (s.current = e["scroll" + o]),
          (s.scrollLength = e["scroll" + i] - e["client" + i]),
          (s.offset.length = 0),
          (s.offset[0] = 0),
          (s.offset[1] = s.scrollLength),
          (s.progress = T(0, s.scrollLength, s.current));
        const c = r - l;
        var u, d;
        s.velocity = c > Ie ? 0 : ((u = s.current - a), (d = c) ? u * (1e3 / d) : 0);
      }
      const Me = {
          Enter: [
            [0, 1],
            [1, 1],
          ],
          Exit: [
            [0, 0],
            [1, 0],
          ],
          Any: [
            [1, 0],
            [0, 1],
          ],
          All: [
            [0, 0],
            [1, 1],
          ],
        },
        De = { start: 0, center: 0.5, end: 1 };
      function Ne(e, t, n = 0) {
        let r = 0;
        if ((void 0 !== De[e] && (e = De[e]), de(e))) {
          const t = parseFloat(e);
          e.endsWith("px")
            ? (r = t)
            : e.endsWith("%")
            ? (e = t / 100)
            : e.endsWith("vw")
            ? (r = (t / 100) * document.documentElement.clientWidth)
            : e.endsWith("vh")
            ? (r = (t / 100) * document.documentElement.clientHeight)
            : (e = t);
        }
        return b(e) && (r = t * e), n + r;
      }
      const Pe = [0, 0];
      function Oe(e, t, n, r) {
        let s = Array.isArray(e) ? e : Pe,
          i = 0,
          o = 0;
        return (
          b(e) ? (s = [e, e]) : de(e) && (s = (e = e.trim()).includes(" ") ? e.split(" ") : [e, De[e] ? e : "0"]),
          (i = Ne(s[0], n, r)),
          (o = Ne(s[1], t)),
          i - o
        );
      }
      const qe = { x: 0, y: 0 };
      function Re(e, t, n) {
        let { offset: r = Me.All } = n;
        const { target: s = e, axis: i = "y" } = n,
          o = "y" === i ? "height" : "width",
          a =
            s !== e
              ? (function (e, t) {
                  let n = { x: 0, y: 0 },
                    r = e;
                  for (; r && r !== t; )
                    if (r instanceof HTMLElement) (n.x += r.offsetLeft), (n.y += r.offsetTop), (r = r.offsetParent);
                    else if (r instanceof SVGGraphicsElement && "getBBox" in r) {
                      const { top: e, left: t } = r.getBBox();
                      for (n.x += t, n.y += e; r && "svg" !== r.tagName; ) r = r.parentNode;
                    }
                  return n;
                })(s, e)
              : qe,
          l = s === e ? { width: e.scrollWidth, height: e.scrollHeight } : { width: s.clientWidth, height: s.clientHeight },
          c = { width: e.clientWidth, height: e.clientHeight };
        t[i].offset.length = 0;
        let u = !t[i].interpolate;
        const d = r.length;
        for (let e = 0; e < d; e++) {
          const n = Oe(r[e], c[o], l[o], a[i]);
          u || n === t[i].interpolatorOffsets[e] || (u = !0), (t[i].offset[e] = n);
        }
        u && ((t[i].interpolate = I(C(d), t[i].offset)), (t[i].interpolatorOffsets = [...t[i].offset])),
          (t[i].progress = t[i].interpolate(t[i].current));
      }
      function Fe(e, t, n, r = {}) {
        const s = r.axis || "y";
        return {
          measure: () =>
            (function (e, t = e, n) {
              if (((n.x.targetOffset = 0), (n.y.targetOffset = 0), t !== e)) {
                let r = t;
                for (; r && r != e; ) (n.x.targetOffset += r.offsetLeft), (n.y.targetOffset += r.offsetTop), (r = r.offsetParent);
              }
              (n.x.targetLength = t === e ? t.scrollWidth : t.clientWidth),
                (n.y.targetLength = t === e ? t.scrollHeight : t.clientHeight),
                (n.x.containerLength = e.clientWidth),
                (n.y.containerLength = e.clientHeight);
            })(e, r.target, n),
          update: (t) => {
            !(function (e, t, n) {
              Le(e, "x", t, n), Le(e, "y", t, n), (t.time = n);
            })(e, n, t),
              (r.offset || r.target) && Re(e, n, r);
          },
          notify: a(t) ? () => t(n) : Be(t, n[s]),
        };
      }
      function Be(e, t) {
        return (
          e.pause(),
          e.forEachNative((e, { easing: t }) => {
            var n, r;
            if (e.updateDuration) t || (e.easing = p), e.updateDuration(1);
            else {
              const s = { duration: 1e3 };
              t || (s.easing = "linear"),
                null === (r = null === (n = e.effect) || void 0 === n ? void 0 : n.updateTiming) || void 0 === r || r.call(n, s);
            }
          }),
          () => {
            e.currentTime = t.progress;
          }
        );
      }
      const $e = new WeakMap(),
        Ve = new WeakMap(),
        je = new WeakMap(),
        ze = (e) => (e === document.documentElement ? window : e);
      function Ue(e, t = {}) {
        var { container: n = document.documentElement } = t,
          r = we(t, ["container"]);
        let s = je.get(n);
        s || ((s = new Set()), je.set(n, s));
        const i = Fe(
          n,
          e,
          {
            time: 0,
            x: { current: 0, offset: [], progress: 0, scrollLength: 0, targetOffset: 0, targetLength: 0, containerLength: 0, velocity: 0 },
            y: { current: 0, offset: [], progress: 0, scrollLength: 0, targetOffset: 0, targetLength: 0, containerLength: 0, velocity: 0 },
          },
          r
        );
        if ((s.add(i), !$e.has(n))) {
          const e = () => {
            const e = performance.now();
            for (const e of s) e.measure();
            for (const t of s) t.update(e);
            for (const e of s) e.notify();
          };
          $e.set(n, e);
          const t = ze(n);
          window.addEventListener("resize", e, { passive: !0 }),
            n !== document.documentElement &&
              Ve.set(
                n,
                (function (e, t) {
                  return a(e) ? Ae(e) : _e(e, t);
                })(n, e)
              ),
            t.addEventListener("scroll", e, { passive: !0 });
        }
        const o = $e.get(n),
          l = requestAnimationFrame(o);
        return () => {
          var t;
          "function" != typeof e && e.stop(), cancelAnimationFrame(l);
          const r = je.get(n);
          if (!r) return;
          if ((r.delete(i), r.size)) return;
          const s = $e.get(n);
          $e.delete(n),
            s &&
              (ze(n).removeEventListener("scroll", s),
              null === (t = Ve.get(n)) || void 0 === t || t(),
              window.removeEventListener("resize", s));
        };
      }
      if (
        (null !== document.querySelector("[data-viewport]") &&
          document.querySelectorAll("[data-viewport]").forEach((e) => {
            let t = 0,
              n = "any";
            e.getAttribute("data-viewport-delay") && (t = Number(1e3 * e.getAttribute("data-viewport-delay"))),
              e.getAttribute("data-viewport-amount") && (n = Number(e.getAttribute("data-viewport-amount"))),
              c(
                e,
                () => {
                  setTimeout(() => {
                    e.classList.add("in-view");
                  }, t);
                },
                { amount: n }
              );
          }),
        null !== document.querySelector('[data-viewport="typography-shift"]') &&
          document.querySelectorAll('[data-viewport="typography-shift"]').forEach((e) => {
            let t = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              c(e, ({ target: e }) => {
                ve(
                  e.querySelector("span"),
                  { y: ["100%", "0"], opacity: ["0", "1"] },
                  { duration: 0.75, delay: t, easing: [0.25, 1, 0.5, 1] }
                );
              });
          }),
        null !== document.querySelector(".shopify-policy__title"))
      ) {
        const Oh = document.querySelector(".shopify-policy__title h1");
        (Oh.innerHTML = `<span>${Oh.textContent}</span>`),
          setTimeout(() => {
            Oh.parentElement.style.opacity = 1;
          }, 50),
          c(Oh, ({ target: e }) => {
            ve(
              e.querySelector("span"),
              { y: ["100%", "0"], opacity: ["0", "1"] },
              { duration: 0.75, delay: 0.15, easing: [0.25, 1, 0.5, 1] }
            );
          });
      }
      null !== document.querySelector('[data-viewport="shift-up"]') &&
        document.querySelectorAll('[data-viewport="shift-up"]').forEach((e) => {
          let t = 0,
            n = 0;
          e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
            e.getAttribute("data-viewport-rotate") && (n = Number(e.getAttribute("data-viewport-rotate"))),
            c(e, ({ target: e }) => {
              ve(e, { y: ["100%", "0"], rotate: n, opacity: ["0", "1"] }, { duration: 0.75, delay: t, easing: [0.25, 1, 0.5, 1] });
            });
        }),
        null !== document.querySelector('[data-viewport="blast-up"]') &&
          document.querySelectorAll('[data-viewport="blast-up"]').forEach((e) => {
            let t = 0,
              n = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              e.getAttribute("data-viewport-rotate") && (n = Number(e.getAttribute("data-viewport-rotate"))),
              c(e, ({ target: e }) => {
                ve(e, { y: ["100%", "0"], rotate: n }, { duration: 0.6, delay: t, easing: [0.25, 1, 0.5, 1] });
              });
          }),
        null !== document.querySelector('[data-viewport="scale-in"]') &&
          document.querySelectorAll('[data-viewport="scale-in"]').forEach((e) => {
            let t = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              c(e, ({ target: e }) => {
                ve(e, { scale: ["1.05", "1"], opacity: ["0", "1"] }, { duration: 1.5, delay: t, easing: [0.25, 1, 0.5, 1] });
              });
          }),
        null !== document.querySelector('[data-viewport="rotate-in"]') &&
          document.querySelectorAll('[data-viewport="rotate-in"]').forEach((e) => {
            let t = 0,
              n = 0,
              r = "any",
              s = 0;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              e.getAttribute("data-viewport-x") && (n = e.getAttribute("data-viewport-x")),
              e.getAttribute("data-viewport-amount") && (r = Number(e.getAttribute("data-viewport-amount"))),
              e.getAttribute("data-viewport-rotate") && (s = Number(e.getAttribute("data-viewport-rotate"))),
              c(
                e,
                ({ target: e }) => {
                  ve(e, { rotate: [-35, s], x: [n, n] }, { duration: 1.5, delay: t, easing: [0.25, 1, 0.5, 1] });
                },
                { amount: r }
              );
          }),
        null !== document.querySelector('[data-viewport="fade-in"]') &&
          document.querySelectorAll('[data-viewport="fade-in"]').forEach((e) => {
            let t = 0,
              n = "any";
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              e.getAttribute("data-viewport-amount") && (n = Number(e.getAttribute("data-viewport-amount"))),
              c(
                e,
                ({ target: e }) => {
                  ve(e, { opacity: ["0", "1"] }, { duration: 0.75, delay: t, easing: [0.25, 1, 0.5, 1] });
                },
                { amount: n }
              );
          }),
        null !== document.querySelector('[data-viewport="scale-on-scroll"]') &&
          document.querySelectorAll('[data-viewport="scale-on-scroll"]').forEach((e) => {
            let t = 0,
              n = 0.75;
            e.getAttribute("data-viewport-delay") && (t = Number(e.getAttribute("data-viewport-delay"))),
              e.getAttribute("data-viewport-duration") && (n = Number(e.getAttribute("data-viewport-duration"))),
              Ue(ve(e, { scale: [1, 1.35] })),
              c(e, ({ target: e }) => {
                ve(e, { scale: ["1.05", "1"], opacity: ["0", "1"] }, { duration: 0.75, delay: t, easing: [0.25, 1, 0.5, 1] });
              });
          });
      n(30);
      const Ge = (e) => {
        for (var t = e.parentNode.childNodes, n = 0, r = 0; r < t.length; r++) {
          if (t[r] == e) return n;
          1 == t[r].nodeType && n++;
        }
        return -1;
      };
      function He(e) {
        return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
      }
      function We(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n] ? (e[n] = t[n]) : He(t[n]) && He(e[n]) && Object.keys(t[n]).length > 0 && We(e[n], t[n]);
        });
      }
      const Ke = {
        body: {},
        addEventListener() {},
        removeEventListener() {},
        activeElement: { blur() {}, nodeName: "" },
        querySelector: () => null,
        querySelectorAll: () => [],
        getElementById: () => null,
        createEvent: () => ({ initEvent() {} }),
        createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() {}, getElementsByTagName: () => [] }),
        createElementNS: () => ({}),
        importNode: () => null,
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
      };
      function Qe() {
        const e = "undefined" != typeof document ? document : {};
        return We(e, Ke), e;
      }
      const Ye = {
        document: Ke,
        navigator: { userAgent: "" },
        location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
        history: { replaceState() {}, pushState() {}, go() {}, back() {} },
        CustomEvent: function () {
          return this;
        },
        addEventListener() {},
        removeEventListener() {},
        getComputedStyle: () => ({ getPropertyValue: () => "" }),
        Image() {},
        Date() {},
        screen: {},
        setTimeout() {},
        clearTimeout() {},
        matchMedia: () => ({}),
        requestAnimationFrame: (e) => ("undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)),
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function Xe() {
        const e = "undefined" != typeof window ? window : {};
        return We(e, Ye), e;
      }
      class Je extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get: () => t,
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function Ze(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...Ze(e)) : t.push(e);
          }),
          t
        );
      }
      function et(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function tt(e, t) {
        const n = Xe(),
          r = Qe();
        let s = [];
        if (!t && e instanceof Je) return e;
        if (!e) return new Je(s);
        if ("string" == typeof e) {
          const n = e.trim();
          if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
            let e = "div";
            0 === n.indexOf("<li") && (e = "ul"),
              0 === n.indexOf("<tr") && (e = "tbody"),
              (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
              0 === n.indexOf("<tbody") && (e = "table"),
              0 === n.indexOf("<option") && (e = "select");
            const t = r.createElement(e);
            t.innerHTML = n;
            for (let e = 0; e < t.childNodes.length; e += 1) s.push(t.childNodes[e]);
          } else
            s = (function (e, t) {
              if ("string" != typeof e) return [e];
              const n = [],
                r = t.querySelectorAll(e);
              for (let e = 0; e < r.length; e += 1) n.push(r[e]);
              return n;
            })(e.trim(), t || r);
        } else if (e.nodeType || e === n || e === r) s.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof Je) return e;
          s = e;
        }
        return new Je(
          (function (e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1) -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(s)
        );
      }
      tt.fn = Je.prototype;
      const nt = "resize scroll".split(" ");
      function rt(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1) nt.indexOf(e) < 0 && (e in this[t] ? this[t][e]() : tt(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      rt("click"),
        rt("blur"),
        rt("focus"),
        rt("focusin"),
        rt("focusout"),
        rt("keyup"),
        rt("keydown"),
        rt("keypress"),
        rt("submit"),
        rt("change"),
        rt("mousedown"),
        rt("mousemove"),
        rt("mouseup"),
        rt("mouseenter"),
        rt("mouseleave"),
        rt("mouseout"),
        rt("mouseover"),
        rt("touchstart"),
        rt("touchend"),
        rt("touchmove"),
        rt("resize"),
        rt("scroll");
      const st = {
        addClass: function (...e) {
          const t = Ze(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = Ze(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = Ze(e.map((e) => e.split(" ")));
          return et(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0).length > 0;
        },
        toggleClass: function (...e) {
          const t = Ze(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
          for (let n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else for (const t in e) (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transitionDuration = "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, n, r, s] = e;
          function i(e) {
            const t = e.target;
            if (!t) return;
            const s = e.target.dom7EventData || [];
            if ((s.indexOf(e) < 0 && s.unshift(e), tt(t).is(n))) r.apply(t, s);
            else {
              const e = tt(t).parents();
              for (let t = 0; t < e.length; t += 1) tt(e[t]).is(n) && r.apply(e[t], s);
            }
          }
          function o(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
          }
          "function" == typeof e[1] && (([t, r, s] = e), (n = void 0)), s || (s = !1);
          const a = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (n)
              for (l = 0; l < a.length; l += 1) {
                const e = a[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({ listener: r, proxyListener: i }),
                  t.addEventListener(e, i, s);
              }
            else
              for (l = 0; l < a.length; l += 1) {
                const e = a[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: r, proxyListener: o }),
                  t.addEventListener(e, o, s);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, n, r, s] = e;
          "function" == typeof e[1] && (([t, r, s] = e), (n = void 0)), s || (s = !1);
          const i = t.split(" ");
          for (let e = 0; e < i.length; e += 1) {
            const t = i[e];
            for (let e = 0; e < this.length; e += 1) {
              const i = this[e];
              let o;
              if (
                (!n && i.dom7Listeners ? (o = i.dom7Listeners[t]) : n && i.dom7LiveListeners && (o = i.dom7LiveListeners[t]), o && o.length)
              )
                for (let e = o.length - 1; e >= 0; e -= 1) {
                  const n = o[e];
                  (r && n.listener === r) || (r && n.listener && n.listener.dom7proxy && n.listener.dom7proxy === r)
                    ? (i.removeEventListener(t, n.proxyListener, s), o.splice(e, 1))
                    : r || (i.removeEventListener(t, n.proxyListener, s), o.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = Xe(),
            n = e[0].split(" "),
            r = e[1];
          for (let s = 0; s < n.length; s += 1) {
            const i = n[s];
            for (let n = 0; n < this.length; n += 1) {
              const s = this[n];
              if (t.CustomEvent) {
                const n = new t.CustomEvent(i, { detail: r, bubbles: !0, cancelable: !0 });
                (s.dom7EventData = e.filter((e, t) => t > 0)), s.dispatchEvent(n), (s.dom7EventData = []), delete s.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
              t.on("transitionend", function n(r) {
                r.target === this && (e.call(this, r), t.off("transitionend", n));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = Xe();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = Xe(),
              t = Qe(),
              n = this[0],
              r = n.getBoundingClientRect(),
              s = t.body,
              i = n.clientTop || s.clientTop || 0,
              o = n.clientLeft || s.clientLeft || 0,
              a = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: r.top + a - i, left: r.left + l - o };
          }
          return null;
        },
        css: function (e, t) {
          const n = Xe();
          let r;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (r = 0; r < this.length; r += 1) for (const t in e) this[r].style[t] = e[t];
              return this;
            }
            if (this[0]) return n.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (r = 0; r < this.length; r += 1) this[r].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, n) => {
                e.apply(t, [t, n]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = Xe(),
            n = Qe(),
            r = this[0];
          let s, i;
          if (!r || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (r.matches) return r.matches(e);
            if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
            if (r.msMatchesSelector) return r.msMatchesSelector(e);
            for (s = tt(e), i = 0; i < s.length; i += 1) if (s[i] === r) return !0;
            return !1;
          }
          if (e === n) return r === n;
          if (e === t) return r === t;
          if (e.nodeType || e instanceof Je) {
            for (s = e.nodeType ? [e] : e, i = 0; i < s.length; i += 1) if (s[i] === r) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return tt([]);
          if (e < 0) {
            const n = t + e;
            return tt(n < 0 ? [] : [this[n]]);
          }
          return tt([this[e]]);
        },
        append: function (...e) {
          let t;
          const n = Qe();
          for (let r = 0; r < e.length; r += 1) {
            t = e[r];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const r = n.createElement("div");
                for (r.innerHTML = t; r.firstChild; ) this[e].appendChild(r.firstChild);
              } else if (t instanceof Je) for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = Qe();
          let n, r;
          for (n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              const s = t.createElement("div");
              for (s.innerHTML = e, r = s.childNodes.length - 1; r >= 0; r -= 1)
                this[n].insertBefore(s.childNodes[r], this[n].childNodes[0]);
            } else if (e instanceof Je) for (r = 0; r < e.length; r += 1) this[n].insertBefore(e[r], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling && tt(this[0].nextElementSibling).is(e)
                ? tt([this[0].nextElementSibling])
                : tt([])
              : this[0].nextElementSibling
              ? tt([this[0].nextElementSibling])
              : tt([])
            : tt([]);
        },
        nextAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return tt([]);
          for (; n.nextElementSibling; ) {
            const r = n.nextElementSibling;
            e ? tt(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return tt(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && tt(t.previousElementSibling).is(e)
                ? tt([t.previousElementSibling])
                : tt([])
              : t.previousElementSibling
              ? tt([t.previousElementSibling])
              : tt([]);
          }
          return tt([]);
        },
        prevAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return tt([]);
          for (; n.previousElementSibling; ) {
            const r = n.previousElementSibling;
            e ? tt(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return tt(t);
        },
        parent: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1)
            null !== this[n].parentNode && (e ? tt(this[n].parentNode).is(e) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
          return tt(t);
        },
        parents: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            let r = this[n].parentNode;
            for (; r; ) e ? tt(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
          }
          return tt(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e ? tt([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].querySelectorAll(e);
            for (let e = 0; e < r.length; e += 1) t.push(r[e]);
          }
          return tt(t);
        },
        children: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].children;
            for (let n = 0; n < r.length; n += 1) (e && !tt(r[n]).is(e)) || t.push(r[n]);
          }
          return tt(t);
        },
        filter: function (e) {
          return tt(et(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(st).forEach((e) => {
        Object.defineProperty(tt.fn, e, { value: st[e], writable: !0 });
      });
      const it = tt;
      function ot(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function at() {
        return Date.now();
      }
      function lt(e, t) {
        void 0 === t && (t = "x");
        const n = Xe();
        let r, s, i;
        const o = (function (e) {
          const t = Xe();
          let n;
          return (
            t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n || (n = e.style), n
          );
        })(e);
        return (
          n.WebKitCSSMatrix
            ? ((s = o.transform || o.webkitTransform),
              s.split(",").length > 6 &&
                (s = s
                  .split(", ")
                  .map((e) => e.replace(",", "."))
                  .join(", ")),
              (i = new n.WebKitCSSMatrix("none" === s ? "" : s)))
            : ((i =
                o.MozTransform ||
                o.OTransform ||
                o.MsTransform ||
                o.msTransform ||
                o.transform ||
                o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
              (r = i.toString().split(","))),
          "x" === t && (s = n.WebKitCSSMatrix ? i.m41 : 16 === r.length ? parseFloat(r[12]) : parseFloat(r[4])),
          "y" === t && (s = n.WebKitCSSMatrix ? i.m42 : 16 === r.length ? parseFloat(r[13]) : parseFloat(r[5])),
          s || 0
        );
      }
      function ct(e) {
        return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
      }
      function ut() {
        const e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
          t = ["__proto__", "constructor", "prototype"];
        for (let r = 1; r < arguments.length; r += 1) {
          const s = r < 0 || arguments.length <= r ? void 0 : arguments[r];
          if (
            null != s &&
            ((n = s),
            !("undefined" != typeof window && void 0 !== window.HTMLElement
              ? n instanceof HTMLElement
              : n && (1 === n.nodeType || 11 === n.nodeType)))
          ) {
            const n = Object.keys(Object(s)).filter((e) => t.indexOf(e) < 0);
            for (let t = 0, r = n.length; t < r; t += 1) {
              const r = n[t],
                i = Object.getOwnPropertyDescriptor(s, r);
              void 0 !== i &&
                i.enumerable &&
                (ct(e[r]) && ct(s[r])
                  ? s[r].__swiper__
                    ? (e[r] = s[r])
                    : ut(e[r], s[r])
                  : !ct(e[r]) && ct(s[r])
                  ? ((e[r] = {}), s[r].__swiper__ ? (e[r] = s[r]) : ut(e[r], s[r]))
                  : (e[r] = s[r]));
            }
          }
        }
        var n;
        return e;
      }
      function dt(e, t, n) {
        e.style.setProperty(t, n);
      }
      function ht(e) {
        let { swiper: t, targetPosition: n, side: r } = e;
        const s = Xe(),
          i = -t.translate;
        let o,
          a = null;
        const l = t.params.speed;
        (t.wrapperEl.style.scrollSnapType = "none"), s.cancelAnimationFrame(t.cssModeFrameID);
        const c = n > i ? "next" : "prev",
          u = (e, t) => ("next" === c && e >= t) || ("prev" === c && e <= t),
          d = () => {
            (o = new Date().getTime()), null === a && (a = o);
            const e = Math.max(Math.min((o - a) / l, 1), 0),
              c = 0.5 - Math.cos(e * Math.PI) / 2;
            let h = i + c * (n - i);
            if ((u(h, n) && (h = n), t.wrapperEl.scrollTo({ [r]: h }), u(h, n)))
              return (
                (t.wrapperEl.style.overflow = "hidden"),
                (t.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (t.wrapperEl.style.overflow = ""), t.wrapperEl.scrollTo({ [r]: h });
                }),
                void s.cancelAnimationFrame(t.cssModeFrameID)
              );
            t.cssModeFrameID = s.requestAnimationFrame(d);
          };
        d();
      }
      let pt, ft, mt;
      function gt() {
        return (
          pt ||
            (pt = (function () {
              const e = Xe(),
                t = Qe();
              return {
                smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
                touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                passiveListener: (function () {
                  let t = !1;
                  try {
                    const n = Object.defineProperty({}, "passive", {
                      get() {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, n);
                  } catch (e) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          pt
        );
      }
      function yt(e) {
        return (
          void 0 === e && (e = {}),
          ft ||
            (ft = (function (e) {
              let { userAgent: t } = void 0 === e ? {} : e;
              const n = gt(),
                r = Xe(),
                s = r.navigator.platform,
                i = t || r.navigator.userAgent,
                o = { ios: !1, android: !1 },
                a = r.screen.width,
                l = r.screen.height,
                c = i.match(/(Android);?[\s\/]+([\d.]+)?/);
              let u = i.match(/(iPad).*OS\s([\d_]+)/);
              const d = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                h = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                p = "Win32" === s;
              let f = "MacIntel" === s;
              return (
                !u &&
                  f &&
                  n.touch &&
                  [
                    "1024x1366",
                    "1366x1024",
                    "834x1194",
                    "1194x834",
                    "834x1112",
                    "1112x834",
                    "768x1024",
                    "1024x768",
                    "820x1180",
                    "1180x820",
                    "810x1080",
                    "1080x810",
                  ].indexOf(`${a}x${l}`) >= 0 &&
                  ((u = i.match(/(Version)\/([\d.]+)/)), u || (u = [0, 1, "13_0_0"]), (f = !1)),
                c && !p && ((o.os = "android"), (o.android = !0)),
                (u || h || d) && ((o.os = "ios"), (o.ios = !0)),
                o
              );
            })(e)),
          ft
        );
      }
      function vt() {
        return (
          mt ||
            (mt = (function () {
              const e = Xe();
              return {
                isSafari: (function () {
                  const t = e.navigator.userAgent.toLowerCase();
                  return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                })(),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
              };
            })()),
          mt
        );
      }
      const wt = {
        on(e, t, n) {
          const r = this;
          if ("function" != typeof t) return r;
          const s = n ? "unshift" : "push";
          return (
            e.split(" ").forEach((e) => {
              r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][s](t);
            }),
            r
          );
        },
        once(e, t, n) {
          const r = this;
          if ("function" != typeof t) return r;
          function s() {
            r.off(e, s), s.__emitterProxy && delete s.__emitterProxy;
            for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
            t.apply(r, i);
          }
          return (s.__emitterProxy = t), r.on(e, s, n);
        },
        onAny(e, t) {
          const n = this;
          if ("function" != typeof e) return n;
          const r = t ? "unshift" : "push";
          return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
        },
        offAny(e) {
          const t = this;
          if (!t.eventsAnyListeners) return t;
          const n = t.eventsAnyListeners.indexOf(e);
          return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
        },
        off(e, t) {
          const n = this;
          return n.eventsListeners
            ? (e.split(" ").forEach((e) => {
                void 0 === t
                  ? (n.eventsListeners[e] = [])
                  : n.eventsListeners[e] &&
                    n.eventsListeners[e].forEach((r, s) => {
                      (r === t || (r.__emitterProxy && r.__emitterProxy === t)) && n.eventsListeners[e].splice(s, 1);
                    });
              }),
              n)
            : n;
        },
        emit() {
          const e = this;
          if (!e.eventsListeners) return e;
          let t, n, r;
          for (var s = arguments.length, i = new Array(s), o = 0; o < s; o++) i[o] = arguments[o];
          "string" == typeof i[0] || Array.isArray(i[0])
            ? ((t = i[0]), (n = i.slice(1, i.length)), (r = e))
            : ((t = i[0].events), (n = i[0].data), (r = i[0].context || e)),
            n.unshift(r);
          return (
            (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
              e.eventsAnyListeners &&
                e.eventsAnyListeners.length &&
                e.eventsAnyListeners.forEach((e) => {
                  e.apply(r, [t, ...n]);
                }),
                e.eventsListeners &&
                  e.eventsListeners[t] &&
                  e.eventsListeners[t].forEach((e) => {
                    e.apply(r, n);
                  });
            }),
            e
          );
        },
      };
      const bt = {
        updateSize: function () {
          const e = this;
          let t, n;
          const r = e.$el;
          (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : r[0].clientWidth),
            (n = void 0 !== e.params.height && null !== e.params.height ? e.params.height : r[0].clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === n && e.isVertical()) ||
              ((t = t - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10)),
              (n = n - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(n) && (n = 0),
              Object.assign(e, { width: t, height: n, size: e.isHorizontal() ? t : n }));
        },
        updateSlides: function () {
          const e = this;
          function t(t) {
            return e.isHorizontal()
              ? t
              : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
                }[t];
          }
          function n(e, n) {
            return parseFloat(e.getPropertyValue(t(n)) || 0);
          }
          const r = e.params,
            { $wrapperEl: s, size: i, rtlTranslate: o, wrongRTL: a } = e,
            l = e.virtual && r.virtual.enabled,
            c = l ? e.virtual.slides.length : e.slides.length,
            u = s.children(`.${e.params.slideClass}`),
            d = l ? e.virtual.slides.length : u.length;
          let h = [];
          const p = [],
            f = [];
          let m = r.slidesOffsetBefore;
          "function" == typeof m && (m = r.slidesOffsetBefore.call(e));
          let g = r.slidesOffsetAfter;
          "function" == typeof g && (g = r.slidesOffsetAfter.call(e));
          const y = e.snapGrid.length,
            v = e.slidesGrid.length;
          let w = r.spaceBetween,
            b = -m,
            S = 0,
            E = 0;
          if (void 0 === i) return;
          "string" == typeof w && w.indexOf("%") >= 0 && (w = (parseFloat(w.replace("%", "")) / 100) * i),
            (e.virtualSize = -w),
            o ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" }) : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
            r.centeredSlides &&
              r.cssMode &&
              (dt(e.wrapperEl, "--swiper-centered-offset-before", ""), dt(e.wrapperEl, "--swiper-centered-offset-after", ""));
          const T = r.grid && r.grid.rows > 1 && e.grid;
          let _;
          T && e.grid.initSlides(d);
          const C =
            "auto" === r.slidesPerView &&
            r.breakpoints &&
            Object.keys(r.breakpoints).filter((e) => void 0 !== r.breakpoints[e].slidesPerView).length > 0;
          for (let s = 0; s < d; s += 1) {
            _ = 0;
            const o = u.eq(s);
            if ((T && e.grid.updateSlide(s, o, d, t), "none" !== o.css("display"))) {
              if ("auto" === r.slidesPerView) {
                C && (u[s].style[t("width")] = "");
                const i = getComputedStyle(o[0]),
                  a = o[0].style.transform,
                  l = o[0].style.webkitTransform;
                if ((a && (o[0].style.transform = "none"), l && (o[0].style.webkitTransform = "none"), r.roundLengths))
                  _ = e.isHorizontal() ? o.outerWidth(!0) : o.outerHeight(!0);
                else {
                  const e = n(i, "width"),
                    t = n(i, "padding-left"),
                    r = n(i, "padding-right"),
                    s = n(i, "margin-left"),
                    a = n(i, "margin-right"),
                    l = i.getPropertyValue("box-sizing");
                  if (l && "border-box" === l) _ = e + s + a;
                  else {
                    const { clientWidth: n, offsetWidth: i } = o[0];
                    _ = e + t + r + s + a + (i - n);
                  }
                }
                a && (o[0].style.transform = a), l && (o[0].style.webkitTransform = l), r.roundLengths && (_ = Math.floor(_));
              } else
                (_ = (i - (r.slidesPerView - 1) * w) / r.slidesPerView),
                  r.roundLengths && (_ = Math.floor(_)),
                  u[s] && (u[s].style[t("width")] = `${_}px`);
              u[s] && (u[s].swiperSlideSize = _),
                f.push(_),
                r.centeredSlides
                  ? ((b = b + _ / 2 + S / 2 + w),
                    0 === S && 0 !== s && (b = b - i / 2 - w),
                    0 === s && (b = b - i / 2 - w),
                    Math.abs(b) < 0.001 && (b = 0),
                    r.roundLengths && (b = Math.floor(b)),
                    E % r.slidesPerGroup == 0 && h.push(b),
                    p.push(b))
                  : (r.roundLengths && (b = Math.floor(b)),
                    (E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup == 0 && h.push(b),
                    p.push(b),
                    (b = b + _ + w)),
                (e.virtualSize += _ + w),
                (S = _),
                (E += 1);
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, i) + g),
            o && a && ("slide" === r.effect || "coverflow" === r.effect) && s.css({ width: `${e.virtualSize + r.spaceBetween}px` }),
            r.setWrapperSize && s.css({ [t("width")]: `${e.virtualSize + r.spaceBetween}px` }),
            T && e.grid.updateWrapperSize(_, h, t),
            !r.centeredSlides)
          ) {
            const t = [];
            for (let n = 0; n < h.length; n += 1) {
              let s = h[n];
              r.roundLengths && (s = Math.floor(s)), h[n] <= e.virtualSize - i && t.push(s);
            }
            (h = t), Math.floor(e.virtualSize - i) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - i);
          }
          if ((0 === h.length && (h = [0]), 0 !== r.spaceBetween)) {
            const n = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
            u.filter((e, t) => !r.cssMode || t !== u.length - 1).css({ [n]: `${w}px` });
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            let e = 0;
            f.forEach((t) => {
              e += t + (r.spaceBetween ? r.spaceBetween : 0);
            }),
              (e -= r.spaceBetween);
            const t = e - i;
            h = h.map((e) => (e < 0 ? -m : e > t ? t + g : e));
          }
          if (r.centerInsufficientSlides) {
            let e = 0;
            if (
              (f.forEach((t) => {
                e += t + (r.spaceBetween ? r.spaceBetween : 0);
              }),
              (e -= r.spaceBetween),
              e < i)
            ) {
              const t = (i - e) / 2;
              h.forEach((e, n) => {
                h[n] = e - t;
              }),
                p.forEach((e, n) => {
                  p[n] = e + t;
                });
            }
          }
          if (
            (Object.assign(e, { slides: u, snapGrid: h, slidesGrid: p, slidesSizesGrid: f }),
            r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
          ) {
            dt(e.wrapperEl, "--swiper-centered-offset-before", -h[0] + "px"),
              dt(e.wrapperEl, "--swiper-centered-offset-after", e.size / 2 - f[f.length - 1] / 2 + "px");
            const t = -e.snapGrid[0],
              n = -e.slidesGrid[0];
            (e.snapGrid = e.snapGrid.map((e) => e + t)), (e.slidesGrid = e.slidesGrid.map((e) => e + n));
          }
          if (
            (d !== c && e.emit("slidesLengthChange"),
            h.length !== y && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
            p.length !== v && e.emit("slidesGridLengthChange"),
            r.watchSlidesProgress && e.updateSlidesOffset(),
            !(l || r.cssMode || ("slide" !== r.effect && "fade" !== r.effect)))
          ) {
            const t = `${r.containerModifierClass}backface-hidden`,
              n = e.$el.hasClass(t);
            d <= r.maxBackfaceHiddenSlides ? n || e.$el.addClass(t) : n && e.$el.removeClass(t);
          }
        },
        updateAutoHeight: function (e) {
          const t = this,
            n = [],
            r = t.virtual && t.params.virtual.enabled;
          let s,
            i = 0;
          "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
          const o = (e) =>
            r ? t.slides.filter((t) => parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e)[0] : t.slides.eq(e)[0];
          if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              t.visibleSlides.each((e) => {
                n.push(e);
              });
            else
              for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
                const e = t.activeIndex + s;
                if (e > t.slides.length && !r) break;
                n.push(o(e));
              }
          else n.push(o(t.activeIndex));
          for (s = 0; s < n.length; s += 1)
            if (void 0 !== n[s]) {
              const e = n[s].offsetHeight;
              i = e > i ? e : i;
            }
          (i || 0 === i) && t.$wrapperEl.css("height", `${i}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides;
          for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop;
        },
        updateSlidesProgress: function (e) {
          void 0 === e && (e = (this && this.translate) || 0);
          const t = this,
            n = t.params,
            { slides: r, rtlTranslate: s, snapGrid: i } = t;
          if (0 === r.length) return;
          void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
          let o = -e;
          s && (o = e), r.removeClass(n.slideVisibleClass), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
          for (let e = 0; e < r.length; e += 1) {
            const a = r[e];
            let l = a.swiperSlideOffset;
            n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
            const c = (o + (n.centeredSlides ? t.minTranslate() : 0) - l) / (a.swiperSlideSize + n.spaceBetween),
              u = (o - i[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (a.swiperSlideSize + n.spaceBetween),
              d = -(o - l),
              h = d + t.slidesSizesGrid[e];
            ((d >= 0 && d < t.size - 1) || (h > 1 && h <= t.size) || (d <= 0 && h >= t.size)) &&
              (t.visibleSlides.push(a), t.visibleSlidesIndexes.push(e), r.eq(e).addClass(n.slideVisibleClass)),
              (a.progress = s ? -c : c),
              (a.originalProgress = s ? -u : u);
          }
          t.visibleSlides = it(t.visibleSlides);
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const n = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * n) || 0;
          }
          const n = t.params,
            r = t.maxTranslate() - t.minTranslate();
          let { progress: s, isBeginning: i, isEnd: o } = t;
          const a = i,
            l = o;
          0 === r ? ((s = 0), (i = !0), (o = !0)) : ((s = (e - t.minTranslate()) / r), (i = s <= 0), (o = s >= 1)),
            Object.assign(t, { progress: s, isBeginning: i, isEnd: o }),
            (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) && t.updateSlidesProgress(e),
            i && !a && t.emit("reachBeginning toEdge"),
            o && !l && t.emit("reachEnd toEdge"),
            ((a && !i) || (l && !o)) && t.emit("fromEdge"),
            t.emit("progress", s);
        },
        updateSlidesClasses: function () {
          const e = this,
            { slides: t, params: n, $wrapperEl: r, activeIndex: s, realIndex: i } = e,
            o = e.virtual && n.virtual.enabled;
          let a;
          t.removeClass(
            `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
          ),
            (a = o ? e.$wrapperEl.find(`.${n.slideClass}[data-swiper-slide-index="${s}"]`) : t.eq(s)),
            a.addClass(n.slideActiveClass),
            n.loop &&
              (a.hasClass(n.slideDuplicateClass)
                ? r
                    .children(`.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${i}"]`)
                    .addClass(n.slideDuplicateActiveClass)
                : r
                    .children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${i}"]`)
                    .addClass(n.slideDuplicateActiveClass));
          let l = a.nextAll(`.${n.slideClass}`).eq(0).addClass(n.slideNextClass);
          n.loop && 0 === l.length && ((l = t.eq(0)), l.addClass(n.slideNextClass));
          let c = a.prevAll(`.${n.slideClass}`).eq(0).addClass(n.slidePrevClass);
          n.loop && 0 === c.length && ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
            n.loop &&
              (l.hasClass(n.slideDuplicateClass)
                ? r
                    .children(
                      `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`
                    )
                    .addClass(n.slideDuplicateNextClass)
                : r
                    .children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`)
                    .addClass(n.slideDuplicateNextClass),
              c.hasClass(n.slideDuplicateClass)
                ? r
                    .children(
                      `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`
                    )
                    .addClass(n.slideDuplicatePrevClass)
                : r
                    .children(`.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${c.attr("data-swiper-slide-index")}"]`)
                    .addClass(n.slideDuplicatePrevClass)),
            e.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
          const t = this,
            n = t.rtlTranslate ? t.translate : -t.translate,
            { slidesGrid: r, snapGrid: s, params: i, activeIndex: o, realIndex: a, snapIndex: l } = t;
          let c,
            u = e;
          if (void 0 === u) {
            for (let e = 0; e < r.length; e += 1)
              void 0 !== r[e + 1]
                ? n >= r[e] && n < r[e + 1] - (r[e + 1] - r[e]) / 2
                  ? (u = e)
                  : n >= r[e] && n < r[e + 1] && (u = e + 1)
                : n >= r[e] && (u = e);
            i.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
          }
          if (s.indexOf(n) >= 0) c = s.indexOf(n);
          else {
            const e = Math.min(i.slidesPerGroupSkip, u);
            c = e + Math.floor((u - e) / i.slidesPerGroup);
          }
          if ((c >= s.length && (c = s.length - 1), u === o)) return void (c !== l && ((t.snapIndex = c), t.emit("snapIndexChange")));
          const d = parseInt(t.slides.eq(u).attr("data-swiper-slide-index") || u, 10);
          Object.assign(t, { snapIndex: c, realIndex: d, previousIndex: o, activeIndex: u }),
            t.emit("activeIndexChange"),
            t.emit("snapIndexChange"),
            a !== d && t.emit("realIndexChange"),
            (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
        },
        updateClickedSlide: function (e) {
          const t = this,
            n = t.params,
            r = it(e).closest(`.${n.slideClass}`)[0];
          let s,
            i = !1;
          if (r)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === r) {
                (i = !0), (s = e);
                break;
              }
          if (!r || !i) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
          (t.clickedSlide = r),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(it(r).attr("data-swiper-slide-index"), 10))
              : (t.clickedIndex = s),
            n.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
        },
      };
      const St = {
        getTranslate: function (e) {
          void 0 === e && (e = this.isHorizontal() ? "x" : "y");
          const { params: t, rtlTranslate: n, translate: r, $wrapperEl: s } = this;
          if (t.virtualTranslate) return n ? -r : r;
          if (t.cssMode) return r;
          let i = lt(s[0], e);
          return n && (i = -i), i || 0;
        },
        setTranslate: function (e, t) {
          const n = this,
            { rtlTranslate: r, params: s, $wrapperEl: i, wrapperEl: o, progress: a } = n;
          let l,
            c = 0,
            u = 0;
          n.isHorizontal() ? (c = r ? -e : e) : (u = e),
            s.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
            s.cssMode
              ? (o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -c : -u)
              : s.virtualTranslate || i.transform(`translate3d(${c}px, ${u}px, 0px)`),
            (n.previousTranslate = n.translate),
            (n.translate = n.isHorizontal() ? c : u);
          const d = n.maxTranslate() - n.minTranslate();
          (l = 0 === d ? 0 : (e - n.minTranslate()) / d), l !== a && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e, t, n, r, s) {
          void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === r && (r = !0);
          const i = this,
            { params: o, wrapperEl: a } = i;
          if (i.animating && o.preventInteractionOnTransition) return !1;
          const l = i.minTranslate(),
            c = i.maxTranslate();
          let u;
          if (((u = r && e > l ? l : r && e < c ? c : e), i.updateProgress(u), o.cssMode)) {
            const e = i.isHorizontal();
            if (0 === t) a[e ? "scrollLeft" : "scrollTop"] = -u;
            else {
              if (!i.support.smoothScroll) return ht({ swiper: i, targetPosition: -u, side: e ? "left" : "top" }), !0;
              a.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" });
            }
            return !0;
          }
          return (
            0 === t
              ? (i.setTransition(0), i.setTranslate(u), n && (i.emit("beforeTransitionStart", t, s), i.emit("transitionEnd")))
              : (i.setTransition(t),
                i.setTranslate(u),
                n && (i.emit("beforeTransitionStart", t, s), i.emit("transitionStart")),
                i.animating ||
                  ((i.animating = !0),
                  i.onTranslateToWrapperTransitionEnd ||
                    (i.onTranslateToWrapperTransitionEnd = function (e) {
                      i &&
                        !i.destroyed &&
                        e.target === this &&
                        (i.$wrapperEl[0].removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd),
                        i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd),
                        (i.onTranslateToWrapperTransitionEnd = null),
                        delete i.onTranslateToWrapperTransitionEnd,
                        n && i.emit("transitionEnd"));
                    }),
                  i.$wrapperEl[0].addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd),
                  i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd))),
            !0
          );
        },
      };
      function Et(e) {
        let { swiper: t, runCallbacks: n, direction: r, step: s } = e;
        const { activeIndex: i, previousIndex: o } = t;
        let a = r;
        if ((a || (a = i > o ? "next" : i < o ? "prev" : "reset"), t.emit(`transition${s}`), n && i !== o)) {
          if ("reset" === a) return void t.emit(`slideResetTransition${s}`);
          t.emit(`slideChangeTransition${s}`), "next" === a ? t.emit(`slideNextTransition${s}`) : t.emit(`slidePrevTransition${s}`);
        }
      }
      const Tt = {
        setTransition: function (e, t) {
          const n = this;
          n.params.cssMode || n.$wrapperEl.transition(e), n.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          const n = this,
            { params: r } = n;
          r.cssMode || (r.autoHeight && n.updateAutoHeight(), Et({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          const n = this,
            { params: r } = n;
          (n.animating = !1), r.cssMode || (n.setTransition(0), Et({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
        },
      };
      const _t = {
        slideTo: function (e, t, n, r, s) {
          if (
            (void 0 === e && (e = 0),
            void 0 === t && (t = this.params.speed),
            void 0 === n && (n = !0),
            "number" != typeof e && "string" != typeof e)
          )
            throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
          if ("string" == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t)) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
            e = t;
          }
          const i = this;
          let o = e;
          o < 0 && (o = 0);
          const { params: a, snapGrid: l, slidesGrid: c, previousIndex: u, activeIndex: d, rtlTranslate: h, wrapperEl: p, enabled: f } = i;
          if ((i.animating && a.preventInteractionOnTransition) || (!f && !r && !s)) return !1;
          const m = Math.min(i.params.slidesPerGroupSkip, o);
          let g = m + Math.floor((o - m) / i.params.slidesPerGroup);
          g >= l.length && (g = l.length - 1), (d || a.initialSlide || 0) === (u || 0) && n && i.emit("beforeSlideChangeStart");
          const y = -l[g];
          if ((i.updateProgress(y), a.normalizeSlideIndex))
            for (let e = 0; e < c.length; e += 1) {
              const t = -Math.floor(100 * y),
                n = Math.floor(100 * c[e]),
                r = Math.floor(100 * c[e + 1]);
              void 0 !== c[e + 1] ? (t >= n && t < r - (r - n) / 2 ? (o = e) : t >= n && t < r && (o = e + 1)) : t >= n && (o = e);
            }
          if (i.initialized && o !== d) {
            if (!i.allowSlideNext && y < i.translate && y < i.minTranslate()) return !1;
            if (!i.allowSlidePrev && y > i.translate && y > i.maxTranslate() && (d || 0) !== o) return !1;
          }
          let v;
          if (((v = o > d ? "next" : o < d ? "prev" : "reset"), (h && -y === i.translate) || (!h && y === i.translate)))
            return (
              i.updateActiveIndex(o),
              a.autoHeight && i.updateAutoHeight(),
              i.updateSlidesClasses(),
              "slide" !== a.effect && i.setTranslate(y),
              "reset" !== v && (i.transitionStart(n, v), i.transitionEnd(n, v)),
              !1
            );
          if (a.cssMode) {
            const e = i.isHorizontal(),
              n = h ? y : -y;
            if (0 === t) {
              const t = i.virtual && i.params.virtual.enabled;
              t && ((i.wrapperEl.style.scrollSnapType = "none"), (i._immediateVirtual = !0)),
                (p[e ? "scrollLeft" : "scrollTop"] = n),
                t &&
                  requestAnimationFrame(() => {
                    (i.wrapperEl.style.scrollSnapType = ""), (i._swiperImmediateVirtual = !1);
                  });
            } else {
              if (!i.support.smoothScroll) return ht({ swiper: i, targetPosition: n, side: e ? "left" : "top" }), !0;
              p.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
            }
            return !0;
          }
          return (
            i.setTransition(t),
            i.setTranslate(y),
            i.updateActiveIndex(o),
            i.updateSlidesClasses(),
            i.emit("beforeTransitionStart", t, r),
            i.transitionStart(n, v),
            0 === t
              ? i.transitionEnd(n, v)
              : i.animating ||
                ((i.animating = !0),
                i.onSlideToWrapperTransitionEnd ||
                  (i.onSlideToWrapperTransitionEnd = function (e) {
                    i &&
                      !i.destroyed &&
                      e.target === this &&
                      (i.$wrapperEl[0].removeEventListener("transitionend", i.onSlideToWrapperTransitionEnd),
                      i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd),
                      (i.onSlideToWrapperTransitionEnd = null),
                      delete i.onSlideToWrapperTransitionEnd,
                      i.transitionEnd(n, v));
                  }),
                i.$wrapperEl[0].addEventListener("transitionend", i.onSlideToWrapperTransitionEnd),
                i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onSlideToWrapperTransitionEnd)),
            !0
          );
        },
        slideToLoop: function (e, t, n, r) {
          void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
          const s = this;
          let i = e;
          return s.params.loop && (i += s.loopedSlides), s.slideTo(i, t, n, r);
        },
        slideNext: function (e, t, n) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          const r = this,
            { animating: s, enabled: i, params: o } = r;
          if (!i) return r;
          let a = o.slidesPerGroup;
          "auto" === o.slidesPerView &&
            1 === o.slidesPerGroup &&
            o.slidesPerGroupAuto &&
            (a = Math.max(r.slidesPerViewDynamic("current", !0), 1));
          const l = r.activeIndex < o.slidesPerGroupSkip ? 1 : a;
          if (o.loop) {
            if (s && o.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          return o.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + l, e, t, n);
        },
        slidePrev: function (e, t, n) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
          const r = this,
            { params: s, animating: i, snapGrid: o, slidesGrid: a, rtlTranslate: l, enabled: c } = r;
          if (!c) return r;
          if (s.loop) {
            if (i && s.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          function u(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const d = u(l ? r.translate : -r.translate),
            h = o.map((e) => u(e));
          let p = o[h.indexOf(d) - 1];
          if (void 0 === p && s.cssMode) {
            let e;
            o.forEach((t, n) => {
              d >= t && (e = n);
            }),
              void 0 !== e && (p = o[e > 0 ? e - 1 : e]);
          }
          let f = 0;
          if (
            (void 0 !== p &&
              ((f = a.indexOf(p)),
              f < 0 && (f = r.activeIndex - 1),
              "auto" === s.slidesPerView &&
                1 === s.slidesPerGroup &&
                s.slidesPerGroupAuto &&
                ((f = f - r.slidesPerViewDynamic("previous", !0) + 1), (f = Math.max(f, 0)))),
            s.rewind && r.isBeginning)
          ) {
            const s = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
            return r.slideTo(s, e, t, n);
          }
          return r.slideTo(f, e, t, n);
        },
        slideReset: function (e, t, n) {
          return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, n);
        },
        slideToClosest: function (e, t, n, r) {
          void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = 0.5);
          const s = this;
          let i = s.activeIndex;
          const o = Math.min(s.params.slidesPerGroupSkip, i),
            a = o + Math.floor((i - o) / s.params.slidesPerGroup),
            l = s.rtlTranslate ? s.translate : -s.translate;
          if (l >= s.snapGrid[a]) {
            const e = s.snapGrid[a];
            l - e > (s.snapGrid[a + 1] - e) * r && (i += s.params.slidesPerGroup);
          } else {
            const e = s.snapGrid[a - 1];
            l - e <= (s.snapGrid[a] - e) * r && (i -= s.params.slidesPerGroup);
          }
          return (i = Math.max(i, 0)), (i = Math.min(i, s.slidesGrid.length - 1)), s.slideTo(i, e, t, n);
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, $wrapperEl: n } = e,
            r = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let s,
            i = e.clickedIndex;
          if (t.loop) {
            if (e.animating) return;
            (s = parseInt(it(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
              t.centeredSlides
                ? i < e.loopedSlides - r / 2 || i > e.slides.length - e.loopedSlides + r / 2
                  ? (e.loopFix(),
                    (i = n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                    ot(() => {
                      e.slideTo(i);
                    }))
                  : e.slideTo(i)
                : i > e.slides.length - r
                ? (e.loopFix(),
                  (i = n.children(`.${t.slideClass}[data-swiper-slide-index="${s}"]:not(.${t.slideDuplicateClass})`).eq(0).index()),
                  ot(() => {
                    e.slideTo(i);
                  }))
                : e.slideTo(i);
          } else e.slideTo(i);
        },
      };
      const Ct = {
        loopCreate: function () {
          const e = this,
            t = Qe(),
            { params: n, $wrapperEl: r } = e,
            s = r.children().length > 0 ? it(r.children()[0].parentNode) : r;
          s.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
          let i = s.children(`.${n.slideClass}`);
          if (n.loopFillGroupWithBlank) {
            const e = n.slidesPerGroup - (i.length % n.slidesPerGroup);
            if (e !== n.slidesPerGroup) {
              for (let r = 0; r < e; r += 1) {
                const e = it(t.createElement("div")).addClass(`${n.slideClass} ${n.slideBlankClass}`);
                s.append(e);
              }
              i = s.children(`.${n.slideClass}`);
            }
          }
          "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = i.length),
            (e.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10))),
            (e.loopedSlides += n.loopAdditionalSlides),
            e.loopedSlides > i.length && (e.loopedSlides = i.length);
          const o = [],
            a = [];
          i.each((t, n) => {
            const r = it(t);
            n < e.loopedSlides && a.push(t),
              n < i.length && n >= i.length - e.loopedSlides && o.push(t),
              r.attr("data-swiper-slide-index", n);
          });
          for (let e = 0; e < a.length; e += 1) s.append(it(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
          for (let e = o.length - 1; e >= 0; e -= 1) s.prepend(it(o[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
        },
        loopFix: function () {
          const e = this;
          e.emit("beforeLoopFix");
          const { activeIndex: t, slides: n, loopedSlides: r, allowSlidePrev: s, allowSlideNext: i, snapGrid: o, rtlTranslate: a } = e;
          let l;
          (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
          const c = -o[t] - e.getTranslate();
          if (t < r) {
            (l = n.length - 3 * r + t), (l += r);
            e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((a ? -e.translate : e.translate) - c);
          } else if (t >= n.length - r) {
            (l = -n.length + t + r), (l += r);
            e.slideTo(l, 0, !1, !0) && 0 !== c && e.setTranslate((a ? -e.translate : e.translate) - c);
          }
          (e.allowSlidePrev = s), (e.allowSlideNext = i), e.emit("loopFix");
        },
        loopDestroy: function () {
          const { $wrapperEl: e, params: t, slides: n } = this;
          e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),
            n.removeAttr("data-swiper-slide-index");
        },
      };
      const xt = {
        setGrabCursor: function (e) {
          const t = this;
          if (t.support.touch || !t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode) return;
          const n = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          (n.style.cursor = "move"),
            (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
            (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
            (n.style.cursor = e ? "grabbing" : "grab");
        },
        unsetGrabCursor: function () {
          const e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
        },
      };
      function At(e) {
        const t = this,
          n = Qe(),
          r = Xe(),
          s = t.touchEventsData,
          { params: i, touches: o, enabled: a } = t;
        if (!a) return;
        if (t.animating && i.preventInteractionOnTransition) return;
        !t.animating && i.cssMode && i.loop && t.loopFix();
        let l = e;
        l.originalEvent && (l = l.originalEvent);
        let c = it(l.target);
        if ("wrapper" === i.touchEventsTarget && !c.closest(t.wrapperEl).length) return;
        if (((s.isTouchEvent = "touchstart" === l.type), !s.isTouchEvent && "which" in l && 3 === l.which)) return;
        if (!s.isTouchEvent && "button" in l && l.button > 0) return;
        if (s.isTouched && s.isMoved) return;
        !!i.noSwipingClass && "" !== i.noSwipingClass && l.target && l.target.shadowRoot && e.path && e.path[0] && (c = it(e.path[0]));
        const u = i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`,
          d = !(!l.target || !l.target.shadowRoot);
        if (
          i.noSwiping &&
          (d
            ? (function (e, t) {
                return (
                  void 0 === t && (t = this),
                  (function t(n) {
                    return n && n !== Qe() && n !== Xe()
                      ? (n.assignedSlot && (n = n.assignedSlot), n.closest(e) || t(n.getRootNode().host))
                      : null;
                  })(t)
                );
              })(u, l.target)
            : c.closest(u)[0])
        )
          return void (t.allowClick = !0);
        if (i.swipeHandler && !c.closest(i.swipeHandler)[0]) return;
        (o.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
          (o.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
        const h = o.currentX,
          p = o.currentY,
          f = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
          m = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
        if (f && (h <= m || h >= r.innerWidth - m)) {
          if ("prevent" !== f) return;
          e.preventDefault();
        }
        if (
          (Object.assign(s, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
          (o.startX = h),
          (o.startY = p),
          (s.touchStartTime = at()),
          (t.allowClick = !0),
          t.updateSize(),
          (t.swipeDirection = void 0),
          i.threshold > 0 && (s.allowThresholdMove = !1),
          "touchstart" !== l.type)
        ) {
          let e = !0;
          c.is(s.focusableElements) && ((e = !1), "SELECT" === c[0].nodeName && (s.isTouched = !1)),
            n.activeElement && it(n.activeElement).is(s.focusableElements) && n.activeElement !== c[0] && n.activeElement.blur();
          const r = e && t.allowTouchMove && i.touchStartPreventDefault;
          (!i.touchStartForcePreventDefault && !r) || c[0].isContentEditable || l.preventDefault();
        }
        t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !i.cssMode && t.freeMode.onTouchStart(),
          t.emit("touchStart", l);
      }
      function It(e) {
        const t = Qe(),
          n = this,
          r = n.touchEventsData,
          { params: s, touches: i, rtlTranslate: o, enabled: a } = n;
        if (!a) return;
        let l = e;
        if ((l.originalEvent && (l = l.originalEvent), !r.isTouched))
          return void (r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", l));
        if (r.isTouchEvent && "touchmove" !== l.type) return;
        const c = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
          u = "touchmove" === l.type ? c.pageX : l.pageX,
          d = "touchmove" === l.type ? c.pageY : l.pageY;
        if (l.preventedByNestedSwiper) return (i.startX = u), void (i.startY = d);
        if (!n.allowTouchMove)
          return (
            it(l.target).is(r.focusableElements) || (n.allowClick = !1),
            void (r.isTouched && (Object.assign(i, { startX: u, startY: d, currentX: u, currentY: d }), (r.touchStartTime = at())))
          );
        if (r.isTouchEvent && s.touchReleaseOnEdges && !s.loop)
          if (n.isVertical()) {
            if ((d < i.startY && n.translate <= n.maxTranslate()) || (d > i.startY && n.translate >= n.minTranslate()))
              return (r.isTouched = !1), void (r.isMoved = !1);
          } else if ((u < i.startX && n.translate <= n.maxTranslate()) || (u > i.startX && n.translate >= n.minTranslate())) return;
        if (r.isTouchEvent && t.activeElement && l.target === t.activeElement && it(l.target).is(r.focusableElements))
          return (r.isMoved = !0), void (n.allowClick = !1);
        if ((r.allowTouchCallbacks && n.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)) return;
        (i.currentX = u), (i.currentY = d);
        const h = i.currentX - i.startX,
          p = i.currentY - i.startY;
        if (n.params.threshold && Math.sqrt(h ** 2 + p ** 2) < n.params.threshold) return;
        if (void 0 === r.isScrolling) {
          let e;
          (n.isHorizontal() && i.currentY === i.startY) || (n.isVertical() && i.currentX === i.startX)
            ? (r.isScrolling = !1)
            : h * h + p * p >= 25 &&
              ((e = (180 * Math.atan2(Math.abs(p), Math.abs(h))) / Math.PI),
              (r.isScrolling = n.isHorizontal() ? e > s.touchAngle : 90 - e > s.touchAngle));
        }
        if (
          (r.isScrolling && n.emit("touchMoveOpposite", l),
          void 0 === r.startMoving && ((i.currentX === i.startX && i.currentY === i.startY) || (r.startMoving = !0)),
          r.isScrolling)
        )
          return void (r.isTouched = !1);
        if (!r.startMoving) return;
        (n.allowClick = !1),
          !s.cssMode && l.cancelable && l.preventDefault(),
          s.touchMoveStopPropagation && !s.nested && l.stopPropagation(),
          r.isMoved ||
            (s.loop && !s.cssMode && n.loopFix(),
            (r.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (r.allowMomentumBounce = !1),
            !s.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
            n.emit("sliderFirstMove", l)),
          n.emit("sliderMove", l),
          (r.isMoved = !0);
        let f = n.isHorizontal() ? h : p;
        (i.diff = f),
          (f *= s.touchRatio),
          o && (f = -f),
          (n.swipeDirection = f > 0 ? "prev" : "next"),
          (r.currentTranslate = f + r.startTranslate);
        let m = !0,
          g = s.resistanceRatio;
        if (
          (s.touchReleaseOnEdges && (g = 0),
          f > 0 && r.currentTranslate > n.minTranslate()
            ? ((m = !1), s.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + f) ** g))
            : f < 0 &&
              r.currentTranslate < n.maxTranslate() &&
              ((m = !1), s.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - f) ** g)),
          m && (l.preventedByNestedSwiper = !0),
          !n.allowSlideNext &&
            "next" === n.swipeDirection &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          !n.allowSlidePrev &&
            "prev" === n.swipeDirection &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
          n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate),
          s.threshold > 0)
        ) {
          if (!(Math.abs(f) > s.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
          if (!r.allowThresholdMove)
            return (
              (r.allowThresholdMove = !0),
              (i.startX = i.currentX),
              (i.startY = i.currentY),
              (r.currentTranslate = r.startTranslate),
              void (i.diff = n.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY)
            );
        }
        s.followFinger &&
          !s.cssMode &&
          (((s.freeMode && s.freeMode.enabled && n.freeMode) || s.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()),
          n.params.freeMode && s.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(),
          n.updateProgress(r.currentTranslate),
          n.setTranslate(r.currentTranslate));
      }
      function kt(e) {
        const t = this,
          n = t.touchEventsData,
          { params: r, touches: s, rtlTranslate: i, slidesGrid: o, enabled: a } = t;
        if (!a) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
          n.allowTouchCallbacks && t.emit("touchEnd", l),
          (n.allowTouchCallbacks = !1),
          !n.isTouched)
        )
          return n.isMoved && r.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1);
        r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        const c = at(),
          u = c - n.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            u < 300 && c - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", l);
        }
        if (
          ((n.lastClickTime = at()),
          ot(() => {
            t.destroyed || (t.allowClick = !0);
          }),
          !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === s.diff || n.currentTranslate === n.startTranslate)
        )
          return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
        let d;
        if (
          ((n.isTouched = !1),
          (n.isMoved = !1),
          (n.startMoving = !1),
          (d = r.followFinger ? (i ? t.translate : -t.translate) : -n.currentTranslate),
          r.cssMode)
        )
          return;
        if (t.params.freeMode && r.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: d });
        let h = 0,
          p = t.slidesSizesGrid[0];
        for (let e = 0; e < o.length; e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup) {
          const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
          void 0 !== o[e + t]
            ? d >= o[e] && d < o[e + t] && ((h = e), (p = o[e + t] - o[e]))
            : d >= o[e] && ((h = e), (p = o[o.length - 1] - o[o.length - 2]));
        }
        let f = null,
          m = null;
        r.rewind &&
          (t.isBeginning
            ? (m = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1)
            : t.isEnd && (f = 0));
        const g = (d - o[h]) / p,
          y = h < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
        if (u > r.longSwipesMs) {
          if (!r.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection && (g >= r.longSwipesRatio ? t.slideTo(r.rewind && t.isEnd ? f : h + y) : t.slideTo(h)),
            "prev" === t.swipeDirection &&
              (g > 1 - r.longSwipesRatio
                ? t.slideTo(h + y)
                : null !== m && g < 0 && Math.abs(g) > r.longSwipesRatio
                ? t.slideTo(m)
                : t.slideTo(h));
        } else {
          if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
          t.navigation && (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl)
            ? l.target === t.navigation.nextEl
              ? t.slideTo(h + y)
              : t.slideTo(h)
            : ("next" === t.swipeDirection && t.slideTo(null !== f ? f : h + y),
              "prev" === t.swipeDirection && t.slideTo(null !== m ? m : h));
        }
      }
      function Lt() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: s, snapGrid: i } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
          (e.allowSlidePrev = s),
          (e.allowSlideNext = r),
          e.params.watchOverflow && i !== e.snapGrid && e.checkOverflow();
      }
      function Mt(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function Dt() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
        if (!r) return;
        let s;
        (e.previousTranslate = e.translate),
          e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
          -0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const i = e.maxTranslate() - e.minTranslate();
        (s = 0 === i ? 0 : (e.translate - e.minTranslate()) / i),
          s !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let Nt = !1;
      function Pt() {}
      const Ot = (e, t) => {
        const n = Qe(),
          { params: r, touchEvents: s, el: i, wrapperEl: o, device: a, support: l } = e,
          c = !!r.nested,
          u = "on" === t ? "addEventListener" : "removeEventListener",
          d = t;
        if (l.touch) {
          const t = !("touchstart" !== s.start || !l.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
          i[u](s.start, e.onTouchStart, t),
            i[u](s.move, e.onTouchMove, l.passiveListener ? { passive: !1, capture: c } : c),
            i[u](s.end, e.onTouchEnd, t),
            s.cancel && i[u](s.cancel, e.onTouchEnd, t);
        } else i[u](s.start, e.onTouchStart, !1), n[u](s.move, e.onTouchMove, c), n[u](s.end, e.onTouchEnd, !1);
        (r.preventClicks || r.preventClicksPropagation) && i[u]("click", e.onClick, !0),
          r.cssMode && o[u]("scroll", e.onScroll),
          r.updateOnWindowResize
            ? e[d](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Lt, !0)
            : e[d]("observerUpdate", Lt, !0);
      };
      const qt = {
          attachEvents: function () {
            const e = this,
              t = Qe(),
              { params: n, support: r } = e;
            (e.onTouchStart = At.bind(e)),
              (e.onTouchMove = It.bind(e)),
              (e.onTouchEnd = kt.bind(e)),
              n.cssMode && (e.onScroll = Dt.bind(e)),
              (e.onClick = Mt.bind(e)),
              r.touch && !Nt && (t.addEventListener("touchstart", Pt), (Nt = !0)),
              Ot(e, "on");
          },
          detachEvents: function () {
            Ot(this, "off");
          },
        },
        Rt = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      const Ft = {
        setBreakpoint: function () {
          const e = this,
            { activeIndex: t, initialized: n, loopedSlides: r = 0, params: s, $el: i } = e,
            o = s.breakpoints;
          if (!o || (o && 0 === Object.keys(o).length)) return;
          const a = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
          if (!a || e.currentBreakpoint === a) return;
          const l = (a in o ? o[a] : void 0) || e.originalParams,
            c = Rt(e, s),
            u = Rt(e, l),
            d = s.enabled;
          c && !u
            ? (i.removeClass(`${s.containerModifierClass}grid ${s.containerModifierClass}grid-column`), e.emitContainerClasses())
            : !c &&
              u &&
              (i.addClass(`${s.containerModifierClass}grid`),
              ((l.grid.fill && "column" === l.grid.fill) || (!l.grid.fill && "column" === s.grid.fill)) &&
                i.addClass(`${s.containerModifierClass}grid-column`),
              e.emitContainerClasses());
          const h = l.direction && l.direction !== s.direction,
            p = s.loop && (l.slidesPerView !== s.slidesPerView || h);
          h && n && e.changeDirection(), ut(e.params, l);
          const f = e.params.enabled;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            d && !f ? e.disable() : !d && f && e.enable(),
            (e.currentBreakpoint = a),
            e.emit("_beforeBreakpoint", l),
            p && n && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - r + e.loopedSlides, 0, !1)),
            e.emit("breakpoint", l);
        },
        getBreakpoint: function (e, t, n) {
          if ((void 0 === t && (t = "window"), !e || ("container" === t && !n))) return;
          let r = !1;
          const s = Xe(),
            i = "window" === t ? s.innerHeight : n.clientHeight,
            o = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: i * t, point: e };
              }
              return { value: e, point: e };
            });
          o.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < o.length; e += 1) {
            const { point: i, value: a } = o[e];
            "window" === t ? s.matchMedia(`(min-width: ${a}px)`).matches && (r = i) : a <= n.clientWidth && (r = i);
          }
          return r || "max";
        },
      };
      const Bt = {
        addClasses: function () {
          const e = this,
            { classNames: t, params: n, rtl: r, $el: s, device: i, support: o } = e,
            a = (function (e, t) {
              const n = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((r) => {
                        e[r] && n.push(t + r);
                      })
                    : "string" == typeof e && n.push(t + e);
                }),
                n
              );
            })(
              [
                "initialized",
                n.direction,
                { "pointer-events": !o.touch },
                { "free-mode": e.params.freeMode && n.freeMode.enabled },
                { autoheight: n.autoHeight },
                { rtl: r },
                { grid: n.grid && n.grid.rows > 1 },
                { "grid-column": n.grid && n.grid.rows > 1 && "column" === n.grid.fill },
                { android: i.android },
                { ios: i.ios },
                { "css-mode": n.cssMode },
                { centered: n.cssMode && n.centeredSlides },
              ],
              n.containerModifierClass
            );
          t.push(...a), s.addClass([...t].join(" ")), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { $el: e, classNames: t } = this;
          e.removeClass(t.join(" ")), this.emitContainerClasses();
        },
      };
      const $t = {
        loadImage: function (e, t, n, r, s, i) {
          const o = Xe();
          let a;
          function l() {
            i && i();
          }
          it(e).parent("picture")[0] || (e.complete && s)
            ? l()
            : t
            ? ((a = new o.Image()), (a.onload = l), (a.onerror = l), r && (a.sizes = r), n && (a.srcset = n), t && (a.src = t))
            : l();
        },
        preloadImages: function () {
          const e = this;
          function t() {
            null != e &&
              e &&
              !e.destroyed &&
              (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
              e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
          }
          e.imagesToLoad = e.$el.find("img");
          for (let n = 0; n < e.imagesToLoad.length; n += 1) {
            const r = e.imagesToLoad[n];
            e.loadImage(
              r,
              r.currentSrc || r.getAttribute("src"),
              r.srcset || r.getAttribute("srcset"),
              r.sizes || r.getAttribute("sizes"),
              !0,
              t
            );
          }
        },
      };
      const Vt = {
          checkOverflow: function () {
            const e = this,
              { isLocked: t, params: n } = e,
              { slidesOffsetBefore: r } = n;
            if (r) {
              const t = e.slides.length - 1,
                n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
              e.isLocked = e.size > n;
            } else e.isLocked = 1 === e.snapGrid.length;
            !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
              !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
              t && t !== e.isLocked && (e.isEnd = !1),
              t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
          },
        },
        jt = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements: "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function zt(e, t) {
        return function (n) {
          void 0 === n && (n = {});
          const r = Object.keys(n)[0],
            s = n[r];
          "object" == typeof s && null !== s
            ? (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 && !0 === e[r] && (e[r] = { auto: !0 }),
              r in e && "enabled" in s
                ? (!0 === e[r] && (e[r] = { enabled: !0 }),
                  "object" != typeof e[r] || "enabled" in e[r] || (e[r].enabled = !0),
                  e[r] || (e[r] = { enabled: !1 }),
                  ut(t, n))
                : ut(t, n))
            : ut(t, n);
        };
      }
      const Ut = {
          eventsEmitter: wt,
          update: bt,
          translate: St,
          transition: Tt,
          slide: _t,
          loop: Ct,
          grabCursor: xt,
          events: qt,
          breakpoints: Ft,
          checkOverflow: Vt,
          classes: Bt,
          images: $t,
        },
        Gt = {};
      class Ht {
        constructor() {
          let e, t;
          for (var n = arguments.length, r = new Array(n), s = 0; s < n; s++) r[s] = arguments[s];
          if (
            (1 === r.length && r[0].constructor && "Object" === Object.prototype.toString.call(r[0]).slice(8, -1)
              ? (t = r[0])
              : ([e, t] = r),
            t || (t = {}),
            (t = ut({}, t)),
            e && !t.el && (t.el = e),
            t.el && it(t.el).length > 1)
          ) {
            const e = [];
            return (
              it(t.el).each((n) => {
                const r = ut({}, t, { el: n });
                e.push(new Ht(r));
              }),
              e
            );
          }
          const i = this;
          (i.__swiper__ = !0),
            (i.support = gt()),
            (i.device = yt({ userAgent: t.userAgent })),
            (i.browser = vt()),
            (i.eventsListeners = {}),
            (i.eventsAnyListeners = []),
            (i.modules = [...i.__modules__]),
            t.modules && Array.isArray(t.modules) && i.modules.push(...t.modules);
          const o = {};
          i.modules.forEach((e) => {
            e({ swiper: i, extendParams: zt(t, o), on: i.on.bind(i), once: i.once.bind(i), off: i.off.bind(i), emit: i.emit.bind(i) });
          });
          const a = ut({}, jt, o);
          return (
            (i.params = ut({}, a, Gt, t)),
            (i.originalParams = ut({}, i.params)),
            (i.passedParams = ut({}, t)),
            i.params &&
              i.params.on &&
              Object.keys(i.params.on).forEach((e) => {
                i.on(e, i.params.on[e]);
              }),
            i.params && i.params.onAny && i.onAny(i.params.onAny),
            (i.$ = it),
            Object.assign(i, {
              enabled: i.params.enabled,
              el: e,
              classNames: [],
              slides: it(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal: () => "horizontal" === i.params.direction,
              isVertical: () => "vertical" === i.params.direction,
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: i.params.allowSlideNext,
              allowSlidePrev: i.params.allowSlidePrev,
              touchEvents: (function () {
                const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (i.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
                  (i.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
                  i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: i.params.focusableElements,
                lastClickTime: at(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: i.params.allowTouchMove,
              touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            i.emit("_swiper"),
            i.params.init && i.init(),
            i
          );
        }
        enable() {
          const e = this;
          e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const r = n.minTranslate(),
            s = (n.maxTranslate() - r) * e + r;
          n.translateTo(s, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className.split(" ").filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return e.className
            .split(" ")
            .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
            .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((n) => {
            const r = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e, t) {
          void 0 === e && (e = "current"), void 0 === t && (t = !1);
          const { params: n, slides: r, slidesGrid: s, slidesSizesGrid: i, size: o, activeIndex: a } = this;
          let l = 1;
          if (n.centeredSlides) {
            let e,
              t = r[a].swiperSlideSize;
            for (let n = a + 1; n < r.length; n += 1) r[n] && !e && ((t += r[n].swiperSlideSize), (l += 1), t > o && (e = !0));
            for (let n = a - 1; n >= 0; n -= 1) r[n] && !e && ((t += r[n].swiperSlideSize), (l += 1), t > o && (e = !0));
          } else if ("current" === e)
            for (let e = a + 1; e < r.length; e += 1) {
              (t ? s[e] + i[e] - s[a] < o : s[e] - s[a] < o) && (l += 1);
            }
          else
            for (let e = a - 1; e >= 0; e -= 1) {
              s[a] - s[e] < o && (l += 1);
            }
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function r() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let s;
          n.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (r(), e.params.autoHeight && e.updateAutoHeight())
              : ((s =
                  ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0)),
                s || r()),
            n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t) {
          void 0 === t && (t = !0);
          const n = this,
            r = n.params.direction;
          return (
            e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r ||
              ("horizontal" !== e && "vertical" !== e) ||
              (n.$el.removeClass(`${n.params.containerModifierClass}${r}`).addClass(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              n.emit("changeDirection"),
              t && n.update()),
            n
          );
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const n = it(e || t.params.el);
          if (!(e = n[0])) return !1;
          e.swiper = t;
          const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let s = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = it(e.shadowRoot.querySelector(r()));
              return (t.children = (e) => n.children(e)), t;
            }
            return n.children(r());
          })();
          if (0 === s.length && t.params.createElements) {
            const e = Qe().createElement("div");
            (s = it(e)),
              (e.className = t.params.wrapperClass),
              n.append(e),
              n.children(`.${t.params.slideClass}`).each((e) => {
                s.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: n,
              el: e,
              $wrapperEl: s,
              wrapperEl: s[0],
              mounted: !0,
              rtl: "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
              rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
              wrongRTL: "-webkit-box" === s.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          if (t.initialized) return t;
          return (
            !1 === t.mount(e) ||
              (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0)
                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e, t) {
          void 0 === e && (e = !0), void 0 === t && (t = !0);
          const n = this,
            { params: r, $el: s, $wrapperEl: i, slides: o } = n;
          return (
            void 0 === n.params ||
              n.destroyed ||
              (n.emit("beforeDestroy"),
              (n.initialized = !1),
              n.detachEvents(),
              r.loop && n.loopDestroy(),
              t &&
                (n.removeClasses(),
                s.removeAttr("style"),
                i.removeAttr("style"),
                o &&
                  o.length &&
                  o
                    .removeClass([r.slideVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass].join(" "))
                    .removeAttr("style")
                    .removeAttr("data-swiper-slide-index")),
              n.emit("destroy"),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e &&
                ((n.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) {}
                    try {
                      delete t[e];
                    } catch (e) {}
                  });
                })(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          ut(Gt, e);
        }
        static get extendedDefaults() {
          return Gt;
        }
        static get defaults() {
          return jt;
        }
        static installModule(e) {
          Ht.prototype.__modules__ || (Ht.prototype.__modules__ = []);
          const t = Ht.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e) ? (e.forEach((e) => Ht.installModule(e)), Ht) : (Ht.installModule(e), Ht);
        }
      }
      Object.keys(Ut).forEach((e) => {
        Object.keys(Ut[e]).forEach((t) => {
          Ht.prototype[t] = Ut[e][t];
        });
      }),
        Ht.use([
          function (e) {
            let { swiper: t, on: n, emit: r } = e;
            const s = Xe();
            let i = null,
              o = null;
            const a = () => {
                t && !t.destroyed && t.initialized && (r("beforeResize"), r("resize"));
              },
              l = () => {
                t && !t.destroyed && t.initialized && r("orientationchange");
              };
            n("init", () => {
              t.params.resizeObserver && void 0 !== s.ResizeObserver
                ? t &&
                  !t.destroyed &&
                  t.initialized &&
                  ((i = new ResizeObserver((e) => {
                    o = s.requestAnimationFrame(() => {
                      const { width: n, height: r } = t;
                      let s = n,
                        i = r;
                      e.forEach((e) => {
                        let { contentBoxSize: n, contentRect: r, target: o } = e;
                        (o && o !== t.el) || ((s = r ? r.width : (n[0] || n).inlineSize), (i = r ? r.height : (n[0] || n).blockSize));
                      }),
                        (s === n && i === r) || a();
                    });
                  })),
                  i.observe(t.el))
                : (s.addEventListener("resize", a), s.addEventListener("orientationchange", l));
            }),
              n("destroy", () => {
                o && s.cancelAnimationFrame(o),
                  i && i.unobserve && t.el && (i.unobserve(t.el), (i = null)),
                  s.removeEventListener("resize", a),
                  s.removeEventListener("orientationchange", l);
              });
          },
          function (e) {
            let { swiper: t, extendParams: n, on: r, emit: s } = e;
            const i = [],
              o = Xe(),
              a = function (e, t) {
                void 0 === t && (t = {});
                const n = new (o.MutationObserver || o.WebkitMutationObserver)((e) => {
                  if (1 === e.length) return void s("observerUpdate", e[0]);
                  const t = function () {
                    s("observerUpdate", e[0]);
                  };
                  o.requestAnimationFrame ? o.requestAnimationFrame(t) : o.setTimeout(t, 0);
                });
                n.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  i.push(n);
              };
            n({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              r("init", () => {
                if (t.params.observer) {
                  if (t.params.observeParents) {
                    const e = t.$el.parents();
                    for (let t = 0; t < e.length; t += 1) a(e[t]);
                  }
                  a(t.$el[0], { childList: t.params.observeSlideChildren }), a(t.$wrapperEl[0], { attributes: !1 });
                }
              }),
              r("destroy", () => {
                i.forEach((e) => {
                  e.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      const Wt = Ht;
      function Kt(e) {
        let { swiper: t, extendParams: n, on: r, emit: s } = e;
        const i = Xe();
        let o;
        n({
          mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
          },
        }),
          (t.mousewheel = { enabled: !1 });
        let a,
          l = at();
        const c = [];
        function u() {
          t.enabled && (t.mouseEntered = !0);
        }
        function d() {
          t.enabled && (t.mouseEntered = !1);
        }
        function h(e) {
          return (
            !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) &&
            !(t.params.mousewheel.thresholdTime && at() - l < t.params.mousewheel.thresholdTime) &&
            ((e.delta >= 6 && at() - l < 60) ||
              (e.direction < 0
                ? (t.isEnd && !t.params.loop) || t.animating || (t.slideNext(), s("scroll", e.raw))
                : (t.isBeginning && !t.params.loop) || t.animating || (t.slidePrev(), s("scroll", e.raw)),
              (l = new i.Date().getTime()),
              !1))
          );
        }
        function p(e) {
          let n = e,
            r = !0;
          if (!t.enabled) return;
          const i = t.params.mousewheel;
          t.params.cssMode && n.preventDefault();
          let l = t.$el;
          if (
            ("container" !== t.params.mousewheel.eventsTarget && (l = it(t.params.mousewheel.eventsTarget)),
            !t.mouseEntered && !l[0].contains(n.target) && !i.releaseOnEdges)
          )
            return !0;
          n.originalEvent && (n = n.originalEvent);
          let u = 0;
          const d = t.rtlTranslate ? -1 : 1,
            p = (function (e) {
              let t = 0,
                n = 0,
                r = 0,
                s = 0;
              return (
                "detail" in e && (n = e.detail),
                "wheelDelta" in e && (n = -e.wheelDelta / 120),
                "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
                (r = 10 * t),
                (s = 10 * n),
                "deltaY" in e && (s = e.deltaY),
                "deltaX" in e && (r = e.deltaX),
                e.shiftKey && !r && ((r = s), (s = 0)),
                (r || s) && e.deltaMode && (1 === e.deltaMode ? ((r *= 40), (s *= 40)) : ((r *= 800), (s *= 800))),
                r && !t && (t = r < 1 ? -1 : 1),
                s && !n && (n = s < 1 ? -1 : 1),
                { spinX: t, spinY: n, pixelX: r, pixelY: s }
              );
            })(n);
          if (i.forceToAxis)
            if (t.isHorizontal()) {
              if (!(Math.abs(p.pixelX) > Math.abs(p.pixelY))) return !0;
              u = -p.pixelX * d;
            } else {
              if (!(Math.abs(p.pixelY) > Math.abs(p.pixelX))) return !0;
              u = -p.pixelY;
            }
          else u = Math.abs(p.pixelX) > Math.abs(p.pixelY) ? -p.pixelX * d : -p.pixelY;
          if (0 === u) return !0;
          i.invert && (u = -u);
          let f = t.getTranslate() + u * i.sensitivity;
          if (
            (f >= t.minTranslate() && (f = t.minTranslate()),
            f <= t.maxTranslate() && (f = t.maxTranslate()),
            (r = !!t.params.loop || !(f === t.minTranslate() || f === t.maxTranslate())),
            r && t.params.nested && n.stopPropagation(),
            t.params.freeMode && t.params.freeMode.enabled)
          ) {
            const e = { time: at(), delta: Math.abs(u), direction: Math.sign(u) },
              r = a && e.time < a.time + 500 && e.delta <= a.delta && e.direction === a.direction;
            if (!r) {
              (a = void 0), t.params.loop && t.loopFix();
              let l = t.getTranslate() + u * i.sensitivity;
              const d = t.isBeginning,
                h = t.isEnd;
              if (
                (l >= t.minTranslate() && (l = t.minTranslate()),
                l <= t.maxTranslate() && (l = t.maxTranslate()),
                t.setTransition(0),
                t.setTranslate(l),
                t.updateProgress(),
                t.updateActiveIndex(),
                t.updateSlidesClasses(),
                ((!d && t.isBeginning) || (!h && t.isEnd)) && t.updateSlidesClasses(),
                t.params.freeMode.sticky)
              ) {
                clearTimeout(o), (o = void 0), c.length >= 15 && c.shift();
                const n = c.length ? c[c.length - 1] : void 0,
                  r = c[0];
                if ((c.push(e), n && (e.delta > n.delta || e.direction !== n.direction))) c.splice(0);
                else if (c.length >= 15 && e.time - r.time < 500 && r.delta - e.delta >= 1 && e.delta <= 6) {
                  const n = u > 0 ? 0.8 : 0.2;
                  (a = e),
                    c.splice(0),
                    (o = ot(() => {
                      t.slideToClosest(t.params.speed, !0, void 0, n);
                    }, 0));
                }
                o ||
                  (o = ot(() => {
                    (a = e), c.splice(0), t.slideToClosest(t.params.speed, !0, void 0, 0.5);
                  }, 500));
              }
              if (
                (r || s("scroll", n),
                t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(),
                l === t.minTranslate() || l === t.maxTranslate())
              )
                return !0;
            }
          } else {
            const n = { time: at(), delta: Math.abs(u), direction: Math.sign(u), raw: e };
            c.length >= 2 && c.shift();
            const r = c.length ? c[c.length - 1] : void 0;
            if (
              (c.push(n),
              r ? (n.direction !== r.direction || n.delta > r.delta || n.time > r.time + 150) && h(n) : h(n),
              (function (e) {
                const n = t.params.mousewheel;
                if (e.direction < 0) {
                  if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
                } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges) return !0;
                return !1;
              })(n))
            )
              return !0;
          }
          return n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1;
        }
        function f(e) {
          let n = t.$el;
          "container" !== t.params.mousewheel.eventsTarget && (n = it(t.params.mousewheel.eventsTarget)),
            n[e]("mouseenter", u),
            n[e]("mouseleave", d),
            n[e]("wheel", p);
        }
        function m() {
          return t.params.cssMode
            ? (t.wrapperEl.removeEventListener("wheel", p), !0)
            : !t.mousewheel.enabled && (f("on"), (t.mousewheel.enabled = !0), !0);
        }
        function g() {
          return t.params.cssMode
            ? (t.wrapperEl.addEventListener(event, p), !0)
            : !!t.mousewheel.enabled && (f("off"), (t.mousewheel.enabled = !1), !0);
        }
        r("init", () => {
          !t.params.mousewheel.enabled && t.params.cssMode && g(), t.params.mousewheel.enabled && m();
        }),
          r("destroy", () => {
            t.params.cssMode && m(), t.mousewheel.enabled && g();
          }),
          Object.assign(t.mousewheel, { enable: m, disable: g });
      }
      function Qt(e, t, n, r) {
        const s = Qe();
        return (
          e.params.createElements &&
            Object.keys(r).forEach((i) => {
              if (!n[i] && !0 === n.auto) {
                let o = e.$el.children(`.${r[i]}`)[0];
                o || ((o = s.createElement("div")), (o.className = r[i]), e.$el.append(o)), (n[i] = o), (t[i] = o);
              }
            }),
          n
        );
      }
      function Yt(e) {
        let { swiper: t, extendParams: n, on: r, emit: s } = e;
        function i(e) {
          let n;
          return (
            e &&
              ((n = it(e)),
              t.params.uniqueNavElements && "string" == typeof e && n.length > 1 && 1 === t.$el.find(e).length && (n = t.$el.find(e))),
            n
          );
        }
        function o(e, n) {
          const r = t.params.navigation;
          e &&
            e.length > 0 &&
            (e[n ? "addClass" : "removeClass"](r.disabledClass),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = n),
            t.params.watchOverflow && t.enabled && e[t.isLocked ? "addClass" : "removeClass"](r.lockClass));
        }
        function a() {
          if (t.params.loop) return;
          const { $nextEl: e, $prevEl: n } = t.navigation;
          o(n, t.isBeginning && !t.params.rewind), o(e, t.isEnd && !t.params.rewind);
        }
        function l(e) {
          e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && t.slidePrev();
        }
        function c(e) {
          e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && t.slideNext();
        }
        function u() {
          const e = t.params.navigation;
          if (
            ((t.params.navigation = Qt(t, t.originalParams.navigation, t.params.navigation, {
              nextEl: "swiper-button-next",
              prevEl: "swiper-button-prev",
            })),
            !e.nextEl && !e.prevEl)
          )
            return;
          const n = i(e.nextEl),
            r = i(e.prevEl);
          n && n.length > 0 && n.on("click", c),
            r && r.length > 0 && r.on("click", l),
            Object.assign(t.navigation, { $nextEl: n, nextEl: n && n[0], $prevEl: r, prevEl: r && r[0] }),
            t.enabled || (n && n.addClass(e.lockClass), r && r.addClass(e.lockClass));
        }
        function d() {
          const { $nextEl: e, $prevEl: n } = t.navigation;
          e && e.length && (e.off("click", c), e.removeClass(t.params.navigation.disabledClass)),
            n && n.length && (n.off("click", l), n.removeClass(t.params.navigation.disabledClass));
        }
        n({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
          },
        }),
          (t.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null }),
          r("init", () => {
            u(), a();
          }),
          r("toEdge fromEdge lock unlock", () => {
            a();
          }),
          r("destroy", () => {
            d();
          }),
          r("enable disable", () => {
            const { $nextEl: e, $prevEl: n } = t.navigation;
            e && e[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass),
              n && n[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass);
          }),
          r("click", (e, n) => {
            const { $nextEl: r, $prevEl: i } = t.navigation,
              o = n.target;
            if (t.params.navigation.hideOnClick && !it(o).is(i) && !it(o).is(r)) {
              if (
                t.pagination &&
                t.params.pagination &&
                t.params.pagination.clickable &&
                (t.pagination.el === o || t.pagination.el.contains(o))
              )
                return;
              let e;
              r ? (e = r.hasClass(t.params.navigation.hiddenClass)) : i && (e = i.hasClass(t.params.navigation.hiddenClass)),
                s(!0 === e ? "navigationShow" : "navigationHide"),
                r && r.toggleClass(t.params.navigation.hiddenClass),
                i && i.toggleClass(t.params.navigation.hiddenClass);
            }
          }),
          Object.assign(t.navigation, { update: a, init: u, destroy: d });
      }
      function Xt(e) {
        return (
          void 0 === e && (e = ""),
          `.${e
            .trim()
            .replace(/([\.:!\/])/g, "\\$1")
            .replace(/ /g, ".")}`
        );
      }
      function Jt(e) {
        let { swiper: t, extendParams: n, on: r, emit: s } = e;
        const i = "swiper-pagination";
        let o;
        n({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: (e) => e,
            formatFractionTotal: (e) => e,
            bulletClass: `${i}-bullet`,
            bulletActiveClass: `${i}-bullet-active`,
            modifierClass: `${i}-`,
            currentClass: `${i}-current`,
            totalClass: `${i}-total`,
            hiddenClass: `${i}-hidden`,
            progressbarFillClass: `${i}-progressbar-fill`,
            progressbarOppositeClass: `${i}-progressbar-opposite`,
            clickableClass: `${i}-clickable`,
            lockClass: `${i}-lock`,
            horizontalClass: `${i}-horizontal`,
            verticalClass: `${i}-vertical`,
          },
        }),
          (t.pagination = { el: null, $el: null, bullets: [] });
        let a = 0;
        function l() {
          return !t.params.pagination.el || !t.pagination.el || !t.pagination.$el || 0 === t.pagination.$el.length;
        }
        function c(e, n) {
          const { bulletActiveClass: r } = t.params.pagination;
          e[n]().addClass(`${r}-${n}`)[n]().addClass(`${r}-${n}-${n}`);
        }
        function u() {
          const e = t.rtl,
            n = t.params.pagination;
          if (l()) return;
          const r = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
            i = t.pagination.$el;
          let u;
          const d = t.params.loop ? Math.ceil((r - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
          if (
            (t.params.loop
              ? ((u = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup)),
                u > r - 1 - 2 * t.loopedSlides && (u -= r - 2 * t.loopedSlides),
                u > d - 1 && (u -= d),
                u < 0 && "bullets" !== t.params.paginationType && (u = d + u))
              : (u = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0),
            "bullets" === n.type && t.pagination.bullets && t.pagination.bullets.length > 0)
          ) {
            const r = t.pagination.bullets;
            let s, l, d;
            if (
              (n.dynamicBullets &&
                ((o = r.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                i.css(t.isHorizontal() ? "width" : "height", o * (n.dynamicMainBullets + 4) + "px"),
                n.dynamicMainBullets > 1 &&
                  void 0 !== t.previousIndex &&
                  ((a += u - (t.previousIndex - t.loopedSlides || 0)),
                  a > n.dynamicMainBullets - 1 ? (a = n.dynamicMainBullets - 1) : a < 0 && (a = 0)),
                (s = Math.max(u - a, 0)),
                (l = s + (Math.min(r.length, n.dynamicMainBullets) - 1)),
                (d = (l + s) / 2)),
              r.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e) => `${n.bulletActiveClass}${e}`).join(" ")),
              i.length > 1)
            )
              r.each((e) => {
                const t = it(e),
                  r = t.index();
                r === u && t.addClass(n.bulletActiveClass),
                  n.dynamicBullets &&
                    (r >= s && r <= l && t.addClass(`${n.bulletActiveClass}-main`), r === s && c(t, "prev"), r === l && c(t, "next"));
              });
            else {
              const e = r.eq(u),
                i = e.index();
              if ((e.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                const e = r.eq(s),
                  o = r.eq(l);
                for (let e = s; e <= l; e += 1) r.eq(e).addClass(`${n.bulletActiveClass}-main`);
                if (t.params.loop)
                  if (i >= r.length) {
                    for (let e = n.dynamicMainBullets; e >= 0; e -= 1) r.eq(r.length - e).addClass(`${n.bulletActiveClass}-main`);
                    r.eq(r.length - n.dynamicMainBullets - 1).addClass(`${n.bulletActiveClass}-prev`);
                  } else c(e, "prev"), c(o, "next");
                else c(e, "prev"), c(o, "next");
              }
            }
            if (n.dynamicBullets) {
              const s = Math.min(r.length, n.dynamicMainBullets + 4),
                i = (o * s - o) / 2 - d * o,
                a = e ? "right" : "left";
              r.css(t.isHorizontal() ? a : "top", `${i}px`);
            }
          }
          if (
            ("fraction" === n.type &&
              (i.find(Xt(n.currentClass)).text(n.formatFractionCurrent(u + 1)), i.find(Xt(n.totalClass)).text(n.formatFractionTotal(d))),
            "progressbar" === n.type)
          ) {
            let e;
            e = n.progressbarOpposite ? (t.isHorizontal() ? "vertical" : "horizontal") : t.isHorizontal() ? "horizontal" : "vertical";
            const r = (u + 1) / d;
            let s = 1,
              o = 1;
            "horizontal" === e ? (s = r) : (o = r),
              i.find(Xt(n.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${s}) scaleY(${o})`).transition(t.params.speed);
          }
          "custom" === n.type && n.renderCustom
            ? (i.html(n.renderCustom(t, u + 1, d)), s("paginationRender", i[0]))
            : s("paginationUpdate", i[0]),
            t.params.watchOverflow && t.enabled && i[t.isLocked ? "addClass" : "removeClass"](n.lockClass);
        }
        function d() {
          const e = t.params.pagination;
          if (l()) return;
          const n = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
            r = t.pagination.$el;
          let i = "";
          if ("bullets" === e.type) {
            let s = t.params.loop ? Math.ceil((n - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
            t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && s > n && (s = n);
            for (let n = 0; n < s; n += 1)
              e.renderBullet
                ? (i += e.renderBullet.call(t, n, e.bulletClass))
                : (i += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
            r.html(i), (t.pagination.bullets = r.find(Xt(e.bulletClass)));
          }
          "fraction" === e.type &&
            ((i = e.renderFraction
              ? e.renderFraction.call(t, e.currentClass, e.totalClass)
              : `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
            r.html(i)),
            "progressbar" === e.type &&
              ((i = e.renderProgressbar
                ? e.renderProgressbar.call(t, e.progressbarFillClass)
                : `<span class="${e.progressbarFillClass}"></span>`),
              r.html(i)),
            "custom" !== e.type && s("paginationRender", t.pagination.$el[0]);
        }
        function h() {
          t.params.pagination = Qt(t, t.originalParams.pagination, t.params.pagination, { el: "swiper-pagination" });
          const e = t.params.pagination;
          if (!e.el) return;
          let n = it(e.el);
          0 !== n.length &&
            (t.params.uniqueNavElements &&
              "string" == typeof e.el &&
              n.length > 1 &&
              ((n = t.$el.find(e.el)), n.length > 1 && (n = n.filter((e) => it(e).parents(".swiper")[0] === t.el))),
            "bullets" === e.type && e.clickable && n.addClass(e.clickableClass),
            n.addClass(e.modifierClass + e.type),
            n.addClass(e.modifierClass + t.params.direction),
            "bullets" === e.type &&
              e.dynamicBullets &&
              (n.addClass(`${e.modifierClass}${e.type}-dynamic`), (a = 0), e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
            "progressbar" === e.type && e.progressbarOpposite && n.addClass(e.progressbarOppositeClass),
            e.clickable &&
              n.on("click", Xt(e.bulletClass), function (e) {
                e.preventDefault();
                let n = it(this).index() * t.params.slidesPerGroup;
                t.params.loop && (n += t.loopedSlides), t.slideTo(n);
              }),
            Object.assign(t.pagination, { $el: n, el: n[0] }),
            t.enabled || n.addClass(e.lockClass));
        }
        function p() {
          const e = t.params.pagination;
          if (l()) return;
          const n = t.pagination.$el;
          n.removeClass(e.hiddenClass),
            n.removeClass(e.modifierClass + e.type),
            n.removeClass(e.modifierClass + t.params.direction),
            t.pagination.bullets && t.pagination.bullets.removeClass && t.pagination.bullets.removeClass(e.bulletActiveClass),
            e.clickable && n.off("click", Xt(e.bulletClass));
        }
        r("init", () => {
          h(), d(), u();
        }),
          r("activeIndexChange", () => {
            (t.params.loop || void 0 === t.snapIndex) && u();
          }),
          r("snapIndexChange", () => {
            t.params.loop || u();
          }),
          r("slidesLengthChange", () => {
            t.params.loop && (d(), u());
          }),
          r("snapGridLengthChange", () => {
            t.params.loop || (d(), u());
          }),
          r("destroy", () => {
            p();
          }),
          r("enable disable", () => {
            const { $el: e } = t.pagination;
            e && e[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass);
          }),
          r("lock unlock", () => {
            u();
          }),
          r("click", (e, n) => {
            const r = n.target,
              { $el: i } = t.pagination;
            if (
              t.params.pagination.el &&
              t.params.pagination.hideOnClick &&
              i.length > 0 &&
              !it(r).hasClass(t.params.pagination.bulletClass)
            ) {
              if (
                t.navigation &&
                ((t.navigation.nextEl && r === t.navigation.nextEl) || (t.navigation.prevEl && r === t.navigation.prevEl))
              )
                return;
              const e = i.hasClass(t.params.pagination.hiddenClass);
              s(!0 === e ? "paginationShow" : "paginationHide"), i.toggleClass(t.params.pagination.hiddenClass);
            }
          }),
          Object.assign(t.pagination, { render: d, update: u, init: h, destroy: p });
      }
      function Zt(e) {
        let { swiper: t, extendParams: n, on: r, emit: s } = e;
        const i = Qe();
        let o,
          a,
          l,
          c,
          u = !1,
          d = null,
          h = null;
        function p() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e, rtlTranslate: n, progress: r } = t,
            { $dragEl: s, $el: i } = e,
            o = t.params.scrollbar;
          let c = a,
            u = (l - a) * r;
          n
            ? ((u = -u), u > 0 ? ((c = a - u), (u = 0)) : -u + a > l && (c = l + u))
            : u < 0
            ? ((c = a + u), (u = 0))
            : u + a > l && (c = l - u),
            t.isHorizontal()
              ? (s.transform(`translate3d(${u}px, 0, 0)`), (s[0].style.width = `${c}px`))
              : (s.transform(`translate3d(0px, ${u}px, 0)`), (s[0].style.height = `${c}px`)),
            o.hide &&
              (clearTimeout(d),
              (i[0].style.opacity = 1),
              (d = setTimeout(() => {
                (i[0].style.opacity = 0), i.transition(400);
              }, 1e3)));
        }
        function f() {
          if (!t.params.scrollbar.el || !t.scrollbar.el) return;
          const { scrollbar: e } = t,
            { $dragEl: n, $el: r } = e;
          (n[0].style.width = ""),
            (n[0].style.height = ""),
            (l = t.isHorizontal() ? r[0].offsetWidth : r[0].offsetHeight),
            (c = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0))),
            (a = "auto" === t.params.scrollbar.dragSize ? l * c : parseInt(t.params.scrollbar.dragSize, 10)),
            t.isHorizontal() ? (n[0].style.width = `${a}px`) : (n[0].style.height = `${a}px`),
            (r[0].style.display = c >= 1 ? "none" : ""),
            t.params.scrollbar.hide && (r[0].style.opacity = 0),
            t.params.watchOverflow && t.enabled && e.$el[t.isLocked ? "addClass" : "removeClass"](t.params.scrollbar.lockClass);
        }
        function m(e) {
          return t.isHorizontal()
            ? "touchstart" === e.type || "touchmove" === e.type
              ? e.targetTouches[0].clientX
              : e.clientX
            : "touchstart" === e.type || "touchmove" === e.type
            ? e.targetTouches[0].clientY
            : e.clientY;
        }
        function g(e) {
          const { scrollbar: n, rtlTranslate: r } = t,
            { $el: s } = n;
          let i;
          (i = (m(e) - s.offset()[t.isHorizontal() ? "left" : "top"] - (null !== o ? o : a / 2)) / (l - a)),
            (i = Math.max(Math.min(i, 1), 0)),
            r && (i = 1 - i);
          const c = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * i;
          t.updateProgress(c), t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
        }
        function y(e) {
          const n = t.params.scrollbar,
            { scrollbar: r, $wrapperEl: i } = t,
            { $el: a, $dragEl: l } = r;
          (u = !0),
            (o = e.target === l[0] || e.target === l ? m(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null),
            e.preventDefault(),
            e.stopPropagation(),
            i.transition(100),
            l.transition(100),
            g(e),
            clearTimeout(h),
            a.transition(0),
            n.hide && a.css("opacity", 1),
            t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
            s("scrollbarDragStart", e);
        }
        function v(e) {
          const { scrollbar: n, $wrapperEl: r } = t,
            { $el: i, $dragEl: o } = n;
          u &&
            (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
            g(e),
            r.transition(0),
            i.transition(0),
            o.transition(0),
            s("scrollbarDragMove", e));
        }
        function w(e) {
          const n = t.params.scrollbar,
            { scrollbar: r, $wrapperEl: i } = t,
            { $el: o } = r;
          u &&
            ((u = !1),
            t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
            n.hide &&
              (clearTimeout(h),
              (h = ot(() => {
                o.css("opacity", 0), o.transition(400);
              }, 1e3))),
            s("scrollbarDragEnd", e),
            n.snapOnRelease && t.slideToClosest());
        }
        function b(e) {
          const { scrollbar: n, touchEventsTouch: r, touchEventsDesktop: s, params: o, support: a } = t,
            l = n.$el[0],
            c = !(!a.passiveListener || !o.passiveListeners) && { passive: !1, capture: !1 },
            u = !(!a.passiveListener || !o.passiveListeners) && { passive: !0, capture: !1 };
          if (!l) return;
          const d = "on" === e ? "addEventListener" : "removeEventListener";
          a.touch
            ? (l[d](r.start, y, c), l[d](r.move, v, c), l[d](r.end, w, u))
            : (l[d](s.start, y, c), i[d](s.move, v, c), i[d](s.end, w, u));
        }
        function S() {
          const { scrollbar: e, $el: n } = t;
          t.params.scrollbar = Qt(t, t.originalParams.scrollbar, t.params.scrollbar, { el: "swiper-scrollbar" });
          const r = t.params.scrollbar;
          if (!r.el) return;
          let s = it(r.el);
          t.params.uniqueNavElements && "string" == typeof r.el && s.length > 1 && 1 === n.find(r.el).length && (s = n.find(r.el));
          let i = s.find(`.${t.params.scrollbar.dragClass}`);
          0 === i.length && ((i = it(`<div class="${t.params.scrollbar.dragClass}"></div>`)), s.append(i)),
            Object.assign(e, { $el: s, el: s[0], $dragEl: i, dragEl: i[0] }),
            r.draggable && t.params.scrollbar.el && b("on"),
            s && s[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
        }
        function E() {
          t.params.scrollbar.el && b("off");
        }
        n({
          scrollbar: {
            el: null,
            dragSize: "auto",
            hide: !1,
            draggable: !1,
            snapOnRelease: !0,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
          },
        }),
          (t.scrollbar = { el: null, dragEl: null, $el: null, $dragEl: null }),
          r("init", () => {
            S(), f(), p();
          }),
          r("update resize observerUpdate lock unlock", () => {
            f();
          }),
          r("setTranslate", () => {
            p();
          }),
          r("setTransition", (e, n) => {
            !(function (e) {
              t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
            })(n);
          }),
          r("enable disable", () => {
            const { $el: e } = t.scrollbar;
            e && e[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
          }),
          r("destroy", () => {
            E();
          }),
          Object.assign(t.scrollbar, { updateSize: f, setTranslate: p, init: S, destroy: E });
      }
      function en(e) {
        let { swiper: t, extendParams: n, on: r } = e;
        function s(e, t) {
          const n = (function () {
            let e, t, n;
            return (r, s) => {
              for (t = -1, e = r.length; e - t > 1; ) (n = (e + t) >> 1), r[n] <= s ? (t = n) : (e = n);
              return e;
            };
          })();
          let r, s;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((s = n(this.x, e)), (r = s - 1), ((e - this.x[r]) * (this.y[s] - this.y[r])) / (this.x[s] - this.x[r]) + this.y[r])
                : 0;
            }),
            this
          );
        }
        function i() {
          t.controller.control && t.controller.spline && ((t.controller.spline = void 0), delete t.controller.spline);
        }
        n({ controller: { control: void 0, inverse: !1, by: "slide" } }),
          (t.controller = { control: void 0 }),
          r("beforeInit", () => {
            t.controller.control = t.params.controller.control;
          }),
          r("update", () => {
            i();
          }),
          r("resize", () => {
            i();
          }),
          r("observerUpdate", () => {
            i();
          }),
          r("setTranslate", (e, n, r) => {
            t.controller.control && t.controller.setTranslate(n, r);
          }),
          r("setTransition", (e, n, r) => {
            t.controller.control && t.controller.setTransition(n, r);
          }),
          Object.assign(t.controller, {
            setTranslate: function (e, n) {
              const r = t.controller.control;
              let i, o;
              const a = t.constructor;
              function l(e) {
                const n = t.rtlTranslate ? -t.translate : t.translate;
                "slide" === t.params.controller.by &&
                  (!(function (e) {
                    t.controller.spline ||
                      (t.controller.spline = t.params.loop ? new s(t.slidesGrid, e.slidesGrid) : new s(t.snapGrid, e.snapGrid));
                  })(e),
                  (o = -t.controller.spline.interpolate(-n))),
                  (o && "container" !== t.params.controller.by) ||
                    ((i = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate())),
                    (o = (n - t.minTranslate()) * i + e.minTranslate())),
                  t.params.controller.inverse && (o = e.maxTranslate() - o),
                  e.updateProgress(o),
                  e.setTranslate(o, t),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses();
              }
              if (Array.isArray(r)) for (let e = 0; e < r.length; e += 1) r[e] !== n && r[e] instanceof a && l(r[e]);
              else r instanceof a && n !== r && l(r);
            },
            setTransition: function (e, n) {
              const r = t.constructor,
                s = t.controller.control;
              let i;
              function o(n) {
                n.setTransition(e, t),
                  0 !== e &&
                    (n.transitionStart(),
                    n.params.autoHeight &&
                      ot(() => {
                        n.updateAutoHeight();
                      }),
                    n.$wrapperEl.transitionEnd(() => {
                      s && (n.params.loop && "slide" === t.params.controller.by && n.loopFix(), n.transitionEnd());
                    }));
              }
              if (Array.isArray(s)) for (i = 0; i < s.length; i += 1) s[i] !== n && s[i] instanceof r && o(s[i]);
              else s instanceof r && n !== s && o(s);
            },
          });
      }
      function tn(e) {
        let t,
          { swiper: n, extendParams: r, on: s, emit: i } = e;
        function o() {
          const e = n.slides.eq(n.activeIndex);
          let r = n.params.autoplay.delay;
          e.attr("data-swiper-autoplay") && (r = e.attr("data-swiper-autoplay") || n.params.autoplay.delay),
            clearTimeout(t),
            (t = ot(() => {
              let e;
              n.params.autoplay.reverseDirection
                ? n.params.loop
                  ? (n.loopFix(), (e = n.slidePrev(n.params.speed, !0, !0)), i("autoplay"))
                  : n.isBeginning
                  ? n.params.autoplay.stopOnLastSlide
                    ? l()
                    : ((e = n.slideTo(n.slides.length - 1, n.params.speed, !0, !0)), i("autoplay"))
                  : ((e = n.slidePrev(n.params.speed, !0, !0)), i("autoplay"))
                : n.params.loop
                ? (n.loopFix(), (e = n.slideNext(n.params.speed, !0, !0)), i("autoplay"))
                : n.isEnd
                ? n.params.autoplay.stopOnLastSlide
                  ? l()
                  : ((e = n.slideTo(0, n.params.speed, !0, !0)), i("autoplay"))
                : ((e = n.slideNext(n.params.speed, !0, !0)), i("autoplay")),
                ((n.params.cssMode && n.autoplay.running) || !1 === e) && o();
            }, r));
        }
        function a() {
          return void 0 === t && !n.autoplay.running && ((n.autoplay.running = !0), i("autoplayStart"), o(), !0);
        }
        function l() {
          return (
            !!n.autoplay.running && void 0 !== t && (t && (clearTimeout(t), (t = void 0)), (n.autoplay.running = !1), i("autoplayStop"), !0)
          );
        }
        function c(e) {
          n.autoplay.running &&
            (n.autoplay.paused ||
              (t && clearTimeout(t),
              (n.autoplay.paused = !0),
              0 !== e && n.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach((e) => {
                    n.$wrapperEl[0].addEventListener(e, d);
                  })
                : ((n.autoplay.paused = !1), o())));
        }
        function u() {
          const e = Qe();
          "hidden" === e.visibilityState && n.autoplay.running && c(),
            "visible" === e.visibilityState && n.autoplay.paused && (o(), (n.autoplay.paused = !1));
        }
        function d(e) {
          n &&
            !n.destroyed &&
            n.$wrapperEl &&
            e.target === n.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            }),
            (n.autoplay.paused = !1),
            n.autoplay.running ? o() : l());
        }
        function h() {
          n.params.autoplay.disableOnInteraction ? l() : (i("autoplayPause"), c()),
            ["transitionend", "webkitTransitionEnd"].forEach((e) => {
              n.$wrapperEl[0].removeEventListener(e, d);
            });
        }
        function p() {
          n.params.autoplay.disableOnInteraction || ((n.autoplay.paused = !1), i("autoplayResume"), o());
        }
        (n.autoplay = { running: !1, paused: !1 }),
          r({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !0,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          }),
          s("init", () => {
            if (n.params.autoplay.enabled) {
              a();
              Qe().addEventListener("visibilitychange", u),
                n.params.autoplay.pauseOnMouseEnter && (n.$el.on("mouseenter", h), n.$el.on("mouseleave", p));
            }
          }),
          s("beforeTransitionStart", (e, t, r) => {
            n.autoplay.running && (r || !n.params.autoplay.disableOnInteraction ? n.autoplay.pause(t) : l());
          }),
          s("sliderFirstMove", () => {
            n.autoplay.running && (n.params.autoplay.disableOnInteraction ? l() : c());
          }),
          s("touchEnd", () => {
            n.params.cssMode && n.autoplay.paused && !n.params.autoplay.disableOnInteraction && o();
          }),
          s("destroy", () => {
            n.$el.off("mouseenter", h), n.$el.off("mouseleave", p), n.autoplay.running && l();
            Qe().removeEventListener("visibilitychange", u);
          }),
          Object.assign(n.autoplay, { pause: c, run: o, start: a, stop: l });
      }
      function nn(e) {
        let { swiper: t, extendParams: n, on: r } = e;
        n({
          thumbs: {
            swiper: null,
            multipleActiveThumbs: !0,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs",
          },
        });
        let s = !1,
          i = !1;
        function o() {
          const e = t.thumbs.swiper;
          if (!e) return;
          const n = e.clickedIndex,
            r = e.clickedSlide;
          if (r && it(r).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
          if (null == n) return;
          let s;
          if (((s = e.params.loop ? parseInt(it(e.clickedSlide).attr("data-swiper-slide-index"), 10) : n), t.params.loop)) {
            let e = t.activeIndex;
            t.slides.eq(e).hasClass(t.params.slideDuplicateClass) &&
              (t.loopFix(), (t._clientLeft = t.$wrapperEl[0].clientLeft), (e = t.activeIndex));
            const n = t.slides.eq(e).prevAll(`[data-swiper-slide-index="${s}"]`).eq(0).index(),
              r = t.slides.eq(e).nextAll(`[data-swiper-slide-index="${s}"]`).eq(0).index();
            s = void 0 === n ? r : void 0 === r ? n : r - e < e - n ? r : n;
          }
          t.slideTo(s);
        }
        function a() {
          const { thumbs: e } = t.params;
          if (s) return !1;
          s = !0;
          const n = t.constructor;
          if (e.swiper instanceof n)
            (t.thumbs.swiper = e.swiper),
              Object.assign(t.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
              Object.assign(t.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 });
          else if (ct(e.swiper)) {
            const r = Object.assign({}, e.swiper);
            Object.assign(r, { watchSlidesProgress: !0, slideToClickedSlide: !1 }), (t.thumbs.swiper = new n(r)), (i = !0);
          }
          return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", o), !0;
        }
        function l(e) {
          const n = t.thumbs.swiper;
          if (!n) return;
          const r = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView,
            s = t.params.thumbs.autoScrollOffset,
            i = s && !n.params.loop;
          if (t.realIndex !== n.realIndex || i) {
            let o,
              a,
              l = n.activeIndex;
            if (n.params.loop) {
              n.slides.eq(l).hasClass(n.params.slideDuplicateClass) &&
                (n.loopFix(), (n._clientLeft = n.$wrapperEl[0].clientLeft), (l = n.activeIndex));
              const e = n.slides.eq(l).prevAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index(),
                r = n.slides.eq(l).nextAll(`[data-swiper-slide-index="${t.realIndex}"]`).eq(0).index();
              (o = void 0 === e ? r : void 0 === r ? e : r - l == l - e ? (n.params.slidesPerGroup > 1 ? r : l) : r - l < l - e ? r : e),
                (a = t.activeIndex > t.previousIndex ? "next" : "prev");
            } else (o = t.realIndex), (a = o > t.previousIndex ? "next" : "prev");
            i && (o += "next" === a ? s : -1 * s),
              n.visibleSlidesIndexes &&
                n.visibleSlidesIndexes.indexOf(o) < 0 &&
                (n.params.centeredSlides
                  ? (o = o > l ? o - Math.floor(r / 2) + 1 : o + Math.floor(r / 2) - 1)
                  : o > l && n.params.slidesPerGroup,
                n.slideTo(o, e ? 0 : void 0));
          }
          let o = 1;
          const a = t.params.thumbs.slideThumbActiveClass;
          if (
            (t.params.slidesPerView > 1 && !t.params.centeredSlides && (o = t.params.slidesPerView),
            t.params.thumbs.multipleActiveThumbs || (o = 1),
            (o = Math.floor(o)),
            n.slides.removeClass(a),
            n.params.loop || (n.params.virtual && n.params.virtual.enabled))
          )
            for (let e = 0; e < o; e += 1) n.$wrapperEl.children(`[data-swiper-slide-index="${t.realIndex + e}"]`).addClass(a);
          else for (let e = 0; e < o; e += 1) n.slides.eq(t.realIndex + e).addClass(a);
        }
        (t.thumbs = { swiper: null }),
          r("beforeInit", () => {
            const { thumbs: e } = t.params;
            e && e.swiper && (a(), l(!0));
          }),
          r("slideChange update resize observerUpdate", () => {
            t.thumbs.swiper && l();
          }),
          r("setTransition", (e, n) => {
            const r = t.thumbs.swiper;
            r && r.setTransition(n);
          }),
          r("beforeDestroy", () => {
            const e = t.thumbs.swiper;
            e && i && e && e.destroy();
          }),
          Object.assign(t.thumbs, { init: a, update: l });
      }
      function rn(e) {
        let { swiper: t, extendParams: n, emit: r, once: s } = e;
        n({
          freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: 0.02,
          },
        }),
          Object.assign(t, {
            freeMode: {
              onTouchStart: function () {
                const e = t.getTranslate();
                t.setTranslate(e),
                  t.setTransition(0),
                  (t.touchEventsData.velocities.length = 0),
                  t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate });
              },
              onTouchMove: function () {
                const { touchEventsData: e, touches: n } = t;
                0 === e.velocities.length &&
                  e.velocities.push({ position: n[t.isHorizontal() ? "startX" : "startY"], time: e.touchStartTime }),
                  e.velocities.push({ position: n[t.isHorizontal() ? "currentX" : "currentY"], time: at() });
              },
              onTouchEnd: function (e) {
                let { currentPos: n } = e;
                const { params: i, $wrapperEl: o, rtlTranslate: a, snapGrid: l, touchEventsData: c } = t,
                  u = at() - c.touchStartTime;
                if (n < -t.minTranslate()) t.slideTo(t.activeIndex);
                else if (n > -t.maxTranslate()) t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1);
                else {
                  if (i.freeMode.momentum) {
                    if (c.velocities.length > 1) {
                      const e = c.velocities.pop(),
                        n = c.velocities.pop(),
                        r = e.position - n.position,
                        s = e.time - n.time;
                      (t.velocity = r / s),
                        (t.velocity /= 2),
                        Math.abs(t.velocity) < i.freeMode.minimumVelocity && (t.velocity = 0),
                        (s > 150 || at() - e.time > 300) && (t.velocity = 0);
                    } else t.velocity = 0;
                    (t.velocity *= i.freeMode.momentumVelocityRatio), (c.velocities.length = 0);
                    let e = 1e3 * i.freeMode.momentumRatio;
                    const n = t.velocity * e;
                    let u = t.translate + n;
                    a && (u = -u);
                    let d,
                      h = !1;
                    const p = 20 * Math.abs(t.velocity) * i.freeMode.momentumBounceRatio;
                    let f;
                    if (u < t.maxTranslate())
                      i.freeMode.momentumBounce
                        ? (u + t.maxTranslate() < -p && (u = t.maxTranslate() - p),
                          (d = t.maxTranslate()),
                          (h = !0),
                          (c.allowMomentumBounce = !0))
                        : (u = t.maxTranslate()),
                        i.loop && i.centeredSlides && (f = !0);
                    else if (u > t.minTranslate())
                      i.freeMode.momentumBounce
                        ? (u - t.minTranslate() > p && (u = t.minTranslate() + p),
                          (d = t.minTranslate()),
                          (h = !0),
                          (c.allowMomentumBounce = !0))
                        : (u = t.minTranslate()),
                        i.loop && i.centeredSlides && (f = !0);
                    else if (i.freeMode.sticky) {
                      let e;
                      for (let t = 0; t < l.length; t += 1)
                        if (l[t] > -u) {
                          e = t;
                          break;
                        }
                      (u = Math.abs(l[e] - u) < Math.abs(l[e - 1] - u) || "next" === t.swipeDirection ? l[e] : l[e - 1]), (u = -u);
                    }
                    if (
                      (f &&
                        s("transitionEnd", () => {
                          t.loopFix();
                        }),
                      0 !== t.velocity)
                    ) {
                      if (
                        ((e = a ? Math.abs((-u - t.translate) / t.velocity) : Math.abs((u - t.translate) / t.velocity)), i.freeMode.sticky)
                      ) {
                        const n = Math.abs((a ? -u : u) - t.translate),
                          r = t.slidesSizesGrid[t.activeIndex];
                        e = n < r ? i.speed : n < 2 * r ? 1.5 * i.speed : 2.5 * i.speed;
                      }
                    } else if (i.freeMode.sticky) return void t.slideToClosest();
                    i.freeMode.momentumBounce && h
                      ? (t.updateProgress(d),
                        t.setTransition(e),
                        t.setTranslate(u),
                        t.transitionStart(!0, t.swipeDirection),
                        (t.animating = !0),
                        o.transitionEnd(() => {
                          t &&
                            !t.destroyed &&
                            c.allowMomentumBounce &&
                            (r("momentumBounce"),
                            t.setTransition(i.speed),
                            setTimeout(() => {
                              t.setTranslate(d),
                                o.transitionEnd(() => {
                                  t && !t.destroyed && t.transitionEnd();
                                });
                            }, 0));
                        }))
                      : t.velocity
                      ? (r("_freeModeNoMomentumRelease"),
                        t.updateProgress(u),
                        t.setTransition(e),
                        t.setTranslate(u),
                        t.transitionStart(!0, t.swipeDirection),
                        t.animating ||
                          ((t.animating = !0),
                          o.transitionEnd(() => {
                            t && !t.destroyed && t.transitionEnd();
                          })))
                      : t.updateProgress(u),
                      t.updateActiveIndex(),
                      t.updateSlidesClasses();
                  } else {
                    if (i.freeMode.sticky) return void t.slideToClosest();
                    i.freeMode && r("_freeModeNoMomentumRelease");
                  }
                  (!i.freeMode.momentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
                }
              },
            },
          });
      }
      function sn(e, t) {
        return e.transformEl ? t.find(e.transformEl).css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" }) : t;
      }
      function on(e) {
        let { swiper: t, extendParams: n, on: r } = e;
        n({ fadeEffect: { crossFade: !1, transformEl: null } });
        !(function (e) {
          const { effect: t, swiper: n, on: r, setTranslate: s, setTransition: i, overwriteParams: o, perspective: a } = e;
          r("beforeInit", () => {
            if (n.params.effect !== t) return;
            n.classNames.push(`${n.params.containerModifierClass}${t}`),
              a && a() && n.classNames.push(`${n.params.containerModifierClass}3d`);
            const e = o ? o() : {};
            Object.assign(n.params, e), Object.assign(n.originalParams, e);
          }),
            r("setTranslate", () => {
              n.params.effect === t && s();
            }),
            r("setTransition", (e, r) => {
              n.params.effect === t && i(r);
            });
        })({
          effect: "fade",
          swiper: t,
          on: r,
          setTranslate: () => {
            const { slides: e } = t,
              n = t.params.fadeEffect;
            for (let r = 0; r < e.length; r += 1) {
              const e = t.slides.eq(r);
              let s = -e[0].swiperSlideOffset;
              t.params.virtualTranslate || (s -= t.translate);
              let i = 0;
              t.isHorizontal() || ((i = s), (s = 0));
              const o = t.params.fadeEffect.crossFade
                ? Math.max(1 - Math.abs(e[0].progress), 0)
                : 1 + Math.min(Math.max(e[0].progress, -1), 0);
              sn(n, e).css({ opacity: o }).transform(`translate3d(${s}px, ${i}px, 0px)`);
            }
          },
          setTransition: (e) => {
            const { transformEl: n } = t.params.fadeEffect;
            (n ? t.slides.find(n) : t.slides).transition(e),
              (function (e) {
                let { swiper: t, duration: n, transformEl: r, allSlides: s } = e;
                const { slides: i, activeIndex: o, $wrapperEl: a } = t;
                if (t.params.virtualTranslate && 0 !== n) {
                  let e,
                    n = !1;
                  (e = s ? (r ? i.find(r) : i) : r ? i.eq(o).find(r) : i.eq(o)),
                    e.transitionEnd(() => {
                      if (n) return;
                      if (!t || t.destroyed) return;
                      (n = !0), (t.animating = !1);
                      const e = ["webkitTransitionEnd", "transitionend"];
                      for (let t = 0; t < e.length; t += 1) a.trigger(e[t]);
                    });
                }
              })({ swiper: t, duration: e, transformEl: n, allSlides: !0 });
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !t.params.cssMode,
          }),
        });
      }
      if (null !== document.querySelector(".announcement-bar")) {
        new Wt(".announcement-bar .swiper", {
          effect: "fade",
          loop: !0,
          autoplay: { delay: 3500 },
          fadeEffect: { crossFade: !0 },
          pauseOnMouseEnter: !1,
          modules: [on, tn],
        }).on("slideChange", function (e) {
          const t = document.querySelector("header").offsetHeight;
          document.documentElement.style.setProperty("--header-height", t + "px"),
            document.documentElement.style.setProperty("--mobile-header-height", t + "px");
        });
      }
      if (null !== document.querySelector(".text-image")) {
        document.querySelectorAll(".text-image .swiper").forEach((e) => {
          if (null !== e.querySelector(".swiper-button-next")) {
            const t = {
              loop: !0,
              slidesPerView: "auto",
              navigation: { nextEl: e.querySelector(".swiper-button-next"), prevEl: e.querySelector(".swiper-button-prev") },
              freeMode: { enabled: !0 },
              mousewheel: { forceToAxis: !0 },
              effect: "fade",
              fadeEffect: { crossFade: !0 },
              modules: [Kt, rn, Yt, on],
            };
            new Wt(e, t);
          }
        });
      }
      if (null !== document.querySelector(".featured-products")) {
        document.querySelectorAll(".featured-products .swiper").forEach((e) => {
          const t = () => {
              if (null !== e.querySelector(".swiper-arrows") && null !== e.querySelector(".swiper-slide-active img")) {
                const t = e.querySelector(".swiper-slide-active img").clientHeight;
                e.querySelector(".swiper-arrows").style.height = t + "px";
              }
            },
            n = {
              loop: !1,
              slidesPerView: "auto",
              spaceBetween: 20,
              watchSlidesProgress: !0,
              preventClicks: !1,
              navigation: { nextEl: e.querySelector(".swiper-button-next"), prevEl: e.querySelector(".swiper-button-prev") },
              freeMode: { enabled: !0 },
              mousewheel: { forceToAxis: !0 },
              modules: [Kt, rn, Yt, Zt],
              scrollbar: { el: e.querySelector(".swiper-scrollbar"), draggable: !0 },
              breakpoints: {
                1200: {
                  slidesPerView: e.closest(".featured-products").classList.contains("ymal") ? 3 : 4,
                  spaceBetween: e.closest(".featured-products").classList.contains("ymal") ? 0 : 60,
                  loop: !0,
                },
                992: {
                  slidesPerView: e.closest(".featured-products").classList.contains("ymal") ? 3 : 4,
                  spaceBetween: e.closest(".featured-products").classList.contains("ymal") ? 0 : 30,
                  loop: !0,
                },
                769: { slidesPerView: 3, spaceBetween: 20, scrollbar: !1, loop: !0, freeMode: !1 },
              },
              on: { init: t },
            },
            r = new Wt(e, n);
          r.on("resize", t), r.on("slideChange", t);
        });
      }
      if (null !== document.querySelector(".featured-articles")) {
        document.querySelectorAll(".featured-articles .swiper").forEach((e) => {
          const t = {
            slidesPerView: "auto",
            spaceBetween: 40,
            centeredSlides: !0,
            loop: !0,
            navigation: { nextEl: e.querySelector(".swiper-button-next"), prevEl: e.querySelector(".swiper-button-prev") },
            freeMode: { enabled: !0 },
            mousewheel: { forceToAxis: !0 },
            pagination: { el: e.querySelector(".swiper-pagination"), type: "bullets", clickable: !0 },
            modules: [Kt, rn, Yt, Jt],
          };
          new Wt(e, t);
        });
      }
      if (null !== document.querySelector(".starburst-card-wrap")) {
        document.querySelectorAll(".starburst-card-wrap").forEach((e) => {
          const t = e.querySelector(".starburst-cards"),
            n = e.querySelector(".starburst-card__tabs"),
            r = new Wt(n, { slidesPerView: 1, direction: "horizontal", modules: [en], breakpoints: { 992: { direction: "vertical" } } }),
            s = {
              centeredSlides: !0,
              pagination: { el: e.querySelector(".swiper-pagination"), type: "bullets", clickable: !0 },
              direction: "horizontal",
              modules: [en, Jt],
            },
            i = new Wt(t, s),
            o = ((e, t) => {
              let n = null;
              return (...r) => {
                window.clearTimeout(n),
                  (n = window.setTimeout(() => {
                    e.apply(null, r);
                  }, t));
              };
            })((t) => {
              let n = 0;
              if (window.matchMedia("(min-width: 992px)").matches) {
                let t = 0;
                e.querySelectorAll(".starburst-card").forEach((e) => {
                  null != e.querySelector(".starburst-card__image") && (t = e.querySelector(".starburst-card__image").clientHeight),
                    e.querySelector(".starburst-card__text").clientHeight > t
                      ? ((t = e.querySelector(".starburst-card__text").clientHeight), (t += 114))
                      : (t += 74),
                    t > n && (n = t);
                }),
                  e.querySelectorAll(".starburst-card").forEach((e) => {
                    e.style.height = n + "px";
                  });
              } else
                e.querySelectorAll(".starburst-card").forEach((e) => {
                  let t = 0;
                  [...e.querySelector(".starburst-card__container").children].forEach((e) => {
                    t += e.clientHeight;
                  }),
                    (t += 100),
                    t > n && (n = t);
                }),
                  e.querySelectorAll(".starburst-card").forEach((e) => {
                    e.style.height = n + "px";
                  });
            }, 500);
          (i.controller.control = r),
            (r.controller.control = i),
            i.on("touchEnd", function (e, t) {
              1 === e.realIndex && (e.touches.diff > 75 && i.slidePrev(), e.touches.diff < -75 && i.slideNext());
            }),
            r.on("slideChange", function () {
              const e = t.querySelector(".swiper-slide-active"),
                n = Ge(e);
              t.querySelectorAll(".swiper-slide").forEach((e, t) => {
                e.classList.remove("fly-away"), t !== n && e.classList.add("fly-away");
              });
            }),
            o(),
            window.addEventListener("resize", o),
            i.on("slideChange", function () {
              const e = t.querySelector(".swiper-slide-active"),
                n = Ge(e);
              t.querySelectorAll(".swiper-slide").forEach((e, t) => {
                e.classList.remove("fly-away"), t !== n && e.classList.add("fly-away");
              });
            }),
            i.on("touchEnd", (e) => {
              setTimeout(() => {
                n.querySelectorAll(".starburst-card__tab").forEach((e) => {
                  e.classList.remove("starburst-card__tab--active");
                }),
                  n.querySelectorAll(".starburst-card__tab")[e.activeIndex].classList.add("starburst-card__tab--active");
              }, 300);
            }),
            t.querySelectorAll(".swiper-pagination-bullet").forEach((e) => {
              e.addEventListener("click", () => {
                console.log("CLICK"),
                  setTimeout(() => {
                    const e = t.querySelector(".swiper-slide-active"),
                      r = Ge(e);
                    n.querySelectorAll(".starburst-card__tab").forEach((e) => {
                      e.classList.remove("starburst-card__tab--active");
                    }),
                      n.querySelectorAll(".starburst-card__tab")[r].classList.add("starburst-card__tab--active");
                  }, 300);
              });
            }),
            n.querySelectorAll(".swiper-slide").forEach((e, t) => {
              e.addEventListener("click", () => {
                r.slideTo(t);
              });
            });
        });
      }
      if (null !== document.querySelector(".social-card-wrap")) {
        document.querySelectorAll(".social-card-wrap").forEach((e) => {
          const t = e.querySelector(".social-cards"),
            n =
              (t.querySelector(".splide__arrow--prev"),
              t.querySelector(".splide__arrow--next"),
              {
                pagination: { el: e.querySelector(".swiper-pagination"), type: "bullets", clickable: !0 },
                navigation: { nextEl: e.querySelector(".swiper-button-next"), prevEl: e.querySelector(".swiper-button-prev") },
                modules: [Yt, Jt],
              }),
            r = new Wt(t, n);
          r.on("touchEnd", function (e, t) {
            1 === e.realIndex && (e.touches.diff > 50 && e.slidePrev(), e.touches.diff < -50 && e.slideNext());
          }),
            r.on("slideChange", function (e) {
              t.querySelectorAll(".swiper-slide").forEach((t, n) => {
                n !== e.realIndex ? t.classList.add("fly-away") : t.classList.remove("fly-away");
              });
            });
        });
      }
      if (null !== document.querySelector(".social-feed")) {
        document.querySelectorAll(".social-feed").forEach((e) => {
          const t = e.querySelector(".swiper"),
            n = {
              slidesPerView: "auto",
              freeMode: { enabled: !1 },
              mousewheel: { forceToAxis: !0 },
              scrollbar: { el: e.querySelector(".swiper-scrollbar"), draggable: !0 },
              modules: [Kt, rn, Zt],
            };
          new Wt(t, n);
        });
      }
      if (
        (null !== document.querySelector(".product-main__images--wrap[data-page-product]") &&
          document.querySelectorAll(".product-main__images--wrap[data-page-product]").forEach((e) => {
            const t = new Wt(e.querySelector(".product-main__images--thumbs"), {
                spaceBetween: 16,
                slidesPerView: "auto",
                loopedSlides: 4,
                direction: "vertical",
                mousewheel: { forceToAxis: !0 },
                preventClicks: !1,
                preventClicksPropagation: !1,
                freeMode: !0,
                loop: !1,
                watchSlidesProgress: !0,
                modules: [en, Kt, rn],
              }),
              n = new Wt(e.querySelector(".product-main__images--gallery"), {
                loop: !1,
                loopedSlides: 4,
                navigation: {
                  prevEl: e.querySelector(".product-main__images--thumbs .swiper-button-prev"),
                  nextEl: e.querySelector(".product-main__images--thumbs .swiper-button-next"),
                },
                thumbs: { swiper: t },
                pagination: { el: e.querySelector(".product-main__images--gallery .swiper-pagination"), type: "bullets", clickable: !0 },
                modules: [nn, Yt, Jt],
              });
            e.querySelectorAll(".product-main__images--thumbs .swiper-slide").forEach((e) => {
              e.addEventListener("click", (r) => {
                r.preventDefault();
                const s = Number(e.getAttribute("data-index"));
                t.slideTo(s), n.slideTo(s);
              });
            });
          }),
        null !== document.querySelector(".home-hero-slider"))
      ) {
        const qh = document.querySelector(".home-hero-slider .swiper .swiper-pagination");
        new Wt(".home-hero-slider .swiper", {
          effect: "fade",
          autoplay: { delay: 4e3 },
          fadeEffect: { crossFade: !0 },
          disableOnInteraction: !0,
          pagination: { el: qh, clickable: !0 },
          pauseOnMouseEnter: !1,
          modules: [on, tn, Jt],
        });
      }
      var an = n(372),
        ln = n.n(an),
        cn = n(130);
      const un = document.querySelector("header"),
        dn = (document.querySelector(".header__nav"), document.querySelector(".header__nav-dropdown")),
        hn = document.querySelector(".header__nav-hamburger"),
        pn = document.querySelector("nav"),
        fn = document.querySelector(".mobile-menu"),
        mn = document.querySelector(".mobile-menu__overlay");
      let gn = pn.offsetHeight;
      if (
        (null !== un &&
          ln()(un, {
            startOffset: gn,
            tolerance: 15,
            showAtBottom: !1,
            classNames: { base: "absolute", fixed: "swiped-down", hidden: "swiped-up" },
          }),
        null !== un.querySelector(".has-dropdown"))
      ) {
        const Rh = () => {
            un.classList.remove("dropdown-open"),
              document.querySelectorAll(".header__nav-dropdown-list").forEach((e) => {
                e.classList.remove("active");
              });
          },
          Fh = (e) => {
            var t, n;
            document.querySelectorAll(".header__nav-dropdown-list:not(.active)").forEach((e) => {
              e.style.display = "none";
            }),
              e &&
                null !== document.getElementById(e) &&
                ((t = document.getElementById(e)),
                (n = "flex"),
                (t.style.opacity = 0),
                (t.style.display = n || "block"),
                (function e() {
                  var n = parseFloat(t.style.opacity);
                  (n += 0.1) > 1 || ((t.style.opacity = n), requestAnimationFrame(e));
                })(),
                document.getElementById(e).classList.add("active")),
              un.classList.add("dropdown-open");
          };
        un.querySelectorAll(".has-dropdown").forEach((e) => {
          const t = e.getAttribute("data-dropdown");
          e.addEventListener("mouseenter", () => {
            Fh(t);
          });
        }),
          document.querySelectorAll(".header__nav-wrap li").forEach((e) => {
            e.classList.contains("has-dropdown") || e.addEventListener("mouseenter", Rh);
          }),
          dn.addEventListener("mouseleave", Rh);
      }
      hn.addEventListener("click", () => {
        hn.classList.toggle("header__nav-hamburger--active"),
          fn.classList.toggle("mobile-menu--open"),
          mn.classList.toggle("mobile-menu__overlay--active"),
          fn.classList.contains("mobile-menu--open") ? (0, cn.disablePageScroll)() : (0, cn.enablePageScroll)();
      }),
        mn.addEventListener("click", () => {
          hn.classList.remove("header__nav-hamburger--active"),
            fn.classList.remove("mobile-menu--open"),
            mn.classList.remove("mobile-menu__overlay--active"),
            (0, cn.enablePageScroll)();
        });
      const yn = () => {
        (gn = un.offsetHeight),
          document.querySelectorAll(".header__menu .toggle-trigger").forEach((e) => {
            e.classList.remove("active");
          }),
          document.documentElement.style.setProperty("--header-height", gn + "px"),
          document.documentElement.style.setProperty("--mobile-header-height", gn + "px");
      };
      yn(), window.addEventListener("resize", yn, !0);
      const vn = (e, t) => {
        var n;
        "createEvent" in document
          ? ((n = document.createEvent("HTMLEvents")).initEvent(t, !1, !0), e.dispatchEvent(n))
          : (((n = document.createEventObject()).eventType = t), e.fireEvent("on" + n.eventType, n));
      };
      if (null !== document.getElementById("add-to-cart")) {
        const Bh = new Wt(".product-main__images--thumbs", {
            spaceBetween: 16,
            slidesPerView: "auto",
            loopedSlides: 4,
            direction: "vertical",
            mousewheel: { forceToAxis: !0 },
            preventClicks: !1,
            preventClicksPropagation: !1,
            freeMode: !0,
            loop: !1,
            watchSlidesProgress: !0,
            modules: [en, Kt, rn],
          }),
          $h = new Wt(".product-main__images--gallery", {
            loop: !1,
            loopedSlides: 4,
            navigation: {
              prevEl: document.querySelector(".product-main__images--thumbs .swiper-button-prev"),
              nextEl: document.querySelector(".product-main__images--thumbs .swiper-button-next"),
            },
            thumbs: { swiper: Bh },
            pagination: { el: document.querySelector(".product-main__images--gallery .swiper-pagination"), type: "bullets", clickable: !0 },
            modules: [nn, Yt, Jt],
          });
        document.querySelectorAll(".product-main__images--thumbs .swiper-slide").forEach((e) => {
          e.addEventListener("click", (t) => {
            t.preventDefault();
            const n = Number(e.getAttribute("data-index"));
            Bh.slideTo(n), $h.slideTo(n);
          });
        });
        const Vh = document.getElementById("add-to-cart");
        if (null !== Vh) {
          const jh = document.getElementById("add"),
            zh = Vh.getAttribute("data-product-handle"),
            Uh = document.getElementById("minus"),
            Gh = document.getElementById("quantity"),
            Hh = document.getElementById("price"),
            Wh = document.getElementById("plus"),
            Kh = document.querySelector(".product-main__quantity");
          let Qh, Yh, Xh;
          Uh.addEventListener("click", () => {
            let e,
              t = parseInt(Gh.value);
            t > 1 && ((e = t - 1), (Gh.value = e));
          }),
            Wh.addEventListener("click", () => {
              let e;
              (e = parseInt(Gh.value) + 1), (Gh.value = e);
            }),
            fetch(`/products/${zh}.json`, { headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" } })
              .then((e) => e.json())
              .then((e) => {
                Xh = e.product;
                if (
                  (new Shopify.OptionSelectors("product-select", {
                    product: Xh,
                    onVariantSelected: function (e, t) {
                      (window.Shopify.variant = e), (window.Shopify.variantID = e.id), (window.Shopify.productID = t.product.id);
                      let n = null !== document.querySelector(".pdp-plan-option");
                      const r = document.getElementById("product-select");
                      if (((Qh = e.id), (Yh = parseInt(r.querySelector(`option[value="${Qh}"]`).getAttribute("data-qty"))), e)) {
                        if (
                          (console.log(e),
                          e.image_id && null !== document.querySelector(`[data-image-id="product-main__image-${e.image_id}"]`))
                        ) {
                          const t = document.querySelector(`[data-image-id="product-main__image-${e.image_id}"]`),
                            n = Ge(t);
                          $h.slideTo(n);
                        }
                        null !== Hh &&
                          (n ||
                            (Number(e.compare_at_price),
                            Number(e.price),
                            (Hh.innerHTML = `\n\t\t\t\t\t\t\t\t\t<span class="font-tt-extra-bold leading-none inline-flex items-center gap-1.5 mt-1" style="opacity: 1;">\n\t\t\t\t\t\t\t\t\t\t<span class="">${Shopify.formatMoney(
                              e.price
                            ).replace(".00", "")}</span>\n\t\t\t\t\t\t\t\t\t\t<s class="inline-block">${Shopify.formatMoney(
                              e.compare_at_price
                            ).replace(".00", "")}</s>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t`))),
                          Yh > 0
                            ? n
                              ? (jh.innerHTML = "<span>Add to Cart</span>")
                              : Number(e.compare_at_price) > Number(e.price) && !jh.classList.contains("special")
                              ? (function() {
                                  // Verificar se já existe metafield no botão
                                  const existingPriceSpan = jh.querySelector('#current-price-once');
                                  if (existingPriceSpan && existingPriceSpan.innerHTML.includes('<s class="ml-2">')) {
                                    // Se já tem metafield configurado, manter o HTML existente
                                    console.log('Mantendo metafields com compare price no botão');
                                    return;
                                  }
                                  // Caso contrário, usar variant prices como fallback
                                  jh.innerHTML = `<span>Add to Cart</span><span class="inline-flex items-center gap-1.5 2xl:hidden lg:inline-flex sm:hidden"><span class="">${Shopify.formatMoney(
                                    e.price
                                  ).replace(
                                    ".00",
                                    ""
                                  )}</span><s class="inline-block 2xl:hidden lg:inline-block sm:hidden">${Shopify.formatMoney(
                                    e.compare_at_price
                                  ).replace(".00", "")}</s></span>`;
                                })()
                              : jh.classList.contains("special")
                              ? (jh.innerHTML =
                                  '<span>Add to Cart</span><span class="inline-flex items-center gap-1.5 2xl:hidden lg:inline-flex sm:hidden"><span class="">$69.98</span></span>')
                              : (function() {
                                  // Verificar se já existe metafield no botão (preservar se já foi configurado via Liquid)
                                  const existingPriceSpan = jh.querySelector('#current-price-once');
                                  if (existingPriceSpan && existingPriceSpan.innerHTML.includes('<s class="ml-2">')) {
                                    // Se já tem metafield configurado, manter o HTML existente
                                    console.log('Mantendo metafields existentes no botão');
                                    return;
                                  }
                                  // Caso contrário, usar variant price como fallback
                                  jh.innerHTML = `<span>Add to Cart</span><span>${Shopify.formatMoney(e.price).replace(".00", "")}</span>`;
                                })()
                            : ((Kh.style.display = "none"),
                              (jh.disabled = !0),
                              n
                                ? (jh.innerHTML = "<span>Sold Out</span>")
                                : Number(e.compare_at_price) > Number(e.price)
                                ? (jh.innerHTML = `<span>Sold Out</span><span class="inline-flex items-center gap-1.5"><span class="">${Shopify.formatMoney(
                                    e.price
                                  ).replace(".00", "")}</span><s class="inline-block 2xl:hidden lg:inline-block">${Shopify.formatMoney(
                                    e.compare_at_price
                                  ).replace(".00", "")}</s></span>`)
                                : (jh.innerHTML = `<span>Sold Out</span><span>${Shopify.formatMoney(e.price).replace(".00", "")}</span>`));
                      }
                    },
                  }),
                  null !== document.querySelector(".option-selector__group") &&
                    document.querySelectorAll(".option-selector__group").forEach((e) => {
                      const t = e.getAttribute("data-group-option");
                      e.querySelectorAll(".option-selector__radio").forEach((n) => {
                        n.addEventListener("click", () => {
                          const { value: r } = n;
                          e.querySelectorAll(".option-selector__button").forEach((e) => {
                            e.classList.remove("active");
                          }),
                            n.parentElement.classList.add("active"),
                            (document.getElementById(`product-select-option-${t}`).value = r),
                            vn(document.getElementById(`product-select-option-${t}`), "change");
                        });
                      });
                    }),
                  null !== document.querySelector(".pdp-plan-option") && null === document.querySelector(".product-main .swatch__wrap"))
                ) {
                  console.log("123123123");
                  const e = document.querySelectorAll(".pdp-plan-option-item-radio"),
                    t = document.querySelector("[name='selling_plan']");
                  document.getElementById("one-time-price"), document.getElementById("frequency-price");
                  e.forEach((e) => {
                    e.addEventListener("click", () => {
                      const { value: n, name: r } = e,
                        s = e.getAttribute("data-option"),
                        i = e.closest(".pdp-plan-option"),
                        o = e.closest(".pdp-plan-option-item"),
                        a = document.querySelector('input[name="properties[_dynamicBoxId]"]'),
                        l = document.querySelector('input[name="properties[_dynamicBoxIndex]"]'),
                        c = document.querySelector('input[name="properties[Subscription Discount:]"]');
                      console.log("Gh.classList", Gh.classList);
                      "frequency" === r &&
                        ("One Time" === n
                          ? ((a.value = ""),
                            (l.value = ""),
                            (c.disabled = !0),
                            Gh.classList.contains("protein-powder") ||
                            Gh.classList.contains("granola") ||
                            Gh.classList.contains("blender-bombs")
                              ? (Gh.value = 1)
                              : (Gh.value = 2),
                            (t.disabled = !0),
                            document.querySelector(".product-main__images--thumbs .swiper-wrapper").children.length > 1 && $h.slideTo(1),
                            null !== document.querySelector('.pdp-plan-option-item-radio[name="Pack Size"]') &&
                              document.querySelectorAll('.pdp-plan-option-item-radio[name="Pack Size"]').forEach((e) => {
                                (e.checked = !1), "Single Pack" === e.value && ((e.checked = !0), vn(e, "click"));
                              }),
                            (Kh.style.display = "inline-flex"))
                          : ((a.value = "e529bb71-a2a6-4acb-b79f-2510576755c9"),
                            (l.value = "0"),
                            (c.disabled = !1),
                            Gh.classList.contains("protein-powder") ||
                            Gh.classList.contains("granola") ||
                            Gh.classList.contains("blender-bombs")
                              ? (Gh.value = 1)
                              : (Gh.value = 2),
                            (t.disabled = !1),
                            $h.slideTo(0),
                            null !== document.querySelector('.pdp-plan-option-item-radio[name="Pack Size"]') &&
                              document.querySelectorAll('.pdp-plan-option-item-radio[name="Pack Size"]').forEach((e) => {
                                (e.checked = !1), "Single Pack" === e.value && ((e.checked = !0), vn(e, "click"));
                              }),
                            (Kh.style.display = "none"))),
                        null !== document.getElementById(`product-select-option-${s}`)
                          ? ((document.getElementById(`product-select-option-${s}`).value = n),
                            vn(document.getElementById(`product-select-option-${s}`), "change"))
                          : vn(document.getElementById("product-select-option-0"), "change"),
                        Vh.querySelectorAll(".pdp-plan-option").forEach((e) => {
                          e.classList.remove("pdp-plan-option--active"),
                            i.classList.add("pdp-plan-option--active"),
                            e.querySelectorAll(".pdp-plan-option-item").forEach((e) => {
                              e.classList.remove("pdp-plan-option-item--active");
                            });
                        }),
                        o.classList.add("pdp-plan-option-item--active");
                      var u = document
                        .querySelector(`.pdp-plan-option-item-radio[data-variant-id='${window.Shopify.variant.id}']`)
                        .getAttribute("data-plan-pricing");
                      void 0 === u && (u = document.getElementById("frequency-price").textContent),
                        (jh.innerHTML = "<span>Add to Cart</span>"),
                        Vh.querySelectorAll("[name='frequency']").forEach((e) => {
                          ((e.checked && "One Time" === e.value) || (e.checked && "Subscribe" === e.value)) &&
                            (jh.innerHTML = "<span>Add to Cart</span>");
                        });
                    });
                  }),
                    document.querySelectorAll("input[type='radio'][name='selling_plan']").forEach((e) => {
                      e.addEventListener("change", () => {
                        if (e.checked) {
                          const t = e.closest(".pdp-plan-option"),
                            n = e.closest(".pdp-plan-option-item");
                          (document.querySelector(".pdp-plan-option-item-radio[name='frequency'][value='Subscribe']").checked = !0),
                            Vh.querySelectorAll(".pdp-plan-option").forEach((e) => {
                              e.classList.remove("pdp-plan-option--active"),
                                t.classList.add("pdp-plan-option--active"),
                                e.querySelectorAll(".pdp-plan-option-item").forEach((e) => {
                                  e.classList.remove("pdp-plan-option-item--active");
                                });
                            }),
                            n.classList.add("pdp-plan-option-item--active");
                        }
                      });
                    });
                }
              });
        }
      }
      var wn = n(76),
        bn = n.n(wn);
      const Sn = function (e) {
          const t = [];
          let n = 0;
          for (let r = 0; r < e.length; r++) {
            let s = e.charCodeAt(r);
            s < 128
              ? (t[n++] = s)
              : s < 2048
              ? ((t[n++] = (s >> 6) | 192), (t[n++] = (63 & s) | 128))
              : 55296 == (64512 & s) && r + 1 < e.length && 56320 == (64512 & e.charCodeAt(r + 1))
              ? ((s = 65536 + ((1023 & s) << 10) + (1023 & e.charCodeAt(++r))),
                (t[n++] = (s >> 18) | 240),
                (t[n++] = ((s >> 12) & 63) | 128),
                (t[n++] = ((s >> 6) & 63) | 128),
                (t[n++] = (63 & s) | 128))
              : ((t[n++] = (s >> 12) | 224), (t[n++] = ((s >> 6) & 63) | 128), (t[n++] = (63 & s) | 128));
          }
          return t;
        },
        En = {
          byteToCharMap_: null,
          charToByteMap_: null,
          byteToCharMapWebSafe_: null,
          charToByteMapWebSafe_: null,
          ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
          get ENCODED_VALS() {
            return this.ENCODED_VALS_BASE + "+/=";
          },
          get ENCODED_VALS_WEBSAFE() {
            return this.ENCODED_VALS_BASE + "-_.";
          },
          HAS_NATIVE_SUPPORT: "function" == typeof atob,
          encodeByteArray(e, t) {
            if (!Array.isArray(e)) throw Error("encodeByteArray takes an array as a parameter");
            this.init_();
            const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_,
              r = [];
            for (let t = 0; t < e.length; t += 3) {
              const s = e[t],
                i = t + 1 < e.length,
                o = i ? e[t + 1] : 0,
                a = t + 2 < e.length,
                l = a ? e[t + 2] : 0,
                c = s >> 2,
                u = ((3 & s) << 4) | (o >> 4);
              let d = ((15 & o) << 2) | (l >> 6),
                h = 63 & l;
              a || ((h = 64), i || (d = 64)), r.push(n[c], n[u], n[d], n[h]);
            }
            return r.join("");
          },
          encodeString(e, t) {
            return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(Sn(e), t);
          },
          decodeString(e, t) {
            return this.HAS_NATIVE_SUPPORT && !t
              ? atob(e)
              : (function (e) {
                  const t = [];
                  let n = 0,
                    r = 0;
                  for (; n < e.length; ) {
                    const s = e[n++];
                    if (s < 128) t[r++] = String.fromCharCode(s);
                    else if (s > 191 && s < 224) {
                      const i = e[n++];
                      t[r++] = String.fromCharCode(((31 & s) << 6) | (63 & i));
                    } else if (s > 239 && s < 365) {
                      const i = (((7 & s) << 18) | ((63 & e[n++]) << 12) | ((63 & e[n++]) << 6) | (63 & e[n++])) - 65536;
                      (t[r++] = String.fromCharCode(55296 + (i >> 10))), (t[r++] = String.fromCharCode(56320 + (1023 & i)));
                    } else {
                      const i = e[n++],
                        o = e[n++];
                      t[r++] = String.fromCharCode(((15 & s) << 12) | ((63 & i) << 6) | (63 & o));
                    }
                  }
                  return t.join("");
                })(this.decodeStringToByteArray(e, t));
          },
          decodeStringToByteArray(e, t) {
            this.init_();
            const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_,
              r = [];
            for (let t = 0; t < e.length; ) {
              const s = n[e.charAt(t++)],
                i = t < e.length ? n[e.charAt(t)] : 0;
              ++t;
              const o = t < e.length ? n[e.charAt(t)] : 64;
              ++t;
              const a = t < e.length ? n[e.charAt(t)] : 64;
              if ((++t, null == s || null == i || null == o || null == a)) throw new Tn();
              const l = (s << 2) | (i >> 4);
              if ((r.push(l), 64 !== o)) {
                const e = ((i << 4) & 240) | (o >> 2);
                if ((r.push(e), 64 !== a)) {
                  const e = ((o << 6) & 192) | a;
                  r.push(e);
                }
              }
            }
            return r;
          },
          init_() {
            if (!this.byteToCharMap_) {
              (this.byteToCharMap_ = {}), (this.charToByteMap_ = {}), (this.byteToCharMapWebSafe_ = {}), (this.charToByteMapWebSafe_ = {});
              for (let e = 0; e < this.ENCODED_VALS.length; e++)
                (this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e)),
                  (this.charToByteMap_[this.byteToCharMap_[e]] = e),
                  (this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e)),
                  (this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e),
                  e >= this.ENCODED_VALS_BASE.length &&
                    ((this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e),
                    (this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e));
            }
          },
        };
      class Tn extends Error {
        constructor() {
          super(...arguments), (this.name = "DecodeBase64StringError");
        }
      }
      const _n = function (e) {
          return (function (e) {
            const t = Sn(e);
            return En.encodeByteArray(t, !0);
          })(e).replace(/\./g, "");
        },
        Cn = function (e) {
          try {
            return En.decodeString(e, !0);
          } catch (e) {
            console.error("base64Decode failed: ", e);
          }
          return null;
        };
      const xn = () =>
          (function () {
            if ("undefined" != typeof self) return self;
            if ("undefined" != typeof window) return window;
            if (void 0 !== n.g) return n.g;
            throw new Error("Unable to locate global object.");
          })().__FIREBASE_DEFAULTS__,
        An = () => {
          try {
            return (
              xn() ||
              (() => {
                if ("undefined" == typeof process || void 0 === process.env) return;
                const e = process.env.__FIREBASE_DEFAULTS__;
                return e ? JSON.parse(e) : void 0;
              })() ||
              (() => {
                if ("undefined" == typeof document) return;
                let e;
                try {
                  e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
                } catch (e) {
                  return;
                }
                const t = e && Cn(e[1]);
                return t && JSON.parse(t);
              })()
            );
          } catch (e) {
            return void console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
          }
        },
        In = (e) => {
          const t = ((e) => {
            var t, n;
            return null === (n = null === (t = An()) || void 0 === t ? void 0 : t.emulatorHosts) || void 0 === n ? void 0 : n[e];
          })(e);
          if (!t) return;
          const n = t.lastIndexOf(":");
          if (n <= 0 || n + 1 === t.length) throw new Error(`Invalid host ${t} with no separate hostname and port!`);
          const r = parseInt(t.substring(n + 1), 10);
          return "[" === t[0] ? [t.substring(1, n - 1), r] : [t.substring(0, n), r];
        },
        kn = () => {
          var e;
          return null === (e = An()) || void 0 === e ? void 0 : e.config;
        };
      class Ln {
        constructor() {
          (this.reject = () => {}),
            (this.resolve = () => {}),
            (this.promise = new Promise((e, t) => {
              (this.resolve = e), (this.reject = t);
            }));
        }
        wrapCallback(e) {
          return (t, n) => {
            t ? this.reject(t) : this.resolve(n), "function" == typeof e && (this.promise.catch(() => {}), 1 === e.length ? e(t) : e(t, n));
          };
        }
      }
      function Mn() {
        return "undefined" != typeof navigator && "string" == typeof navigator.userAgent ? navigator.userAgent : "";
      }
      function Dn() {
        return (
          !(function () {
            var e;
            const t = null === (e = An()) || void 0 === e ? void 0 : e.forceEnvironment;
            if ("node" === t) return !0;
            if ("browser" === t) return !1;
            try {
              return "[object process]" === Object.prototype.toString.call(n.g.process);
            } catch (e) {
              return !1;
            }
          })() &&
          !!navigator.userAgent &&
          navigator.userAgent.includes("Safari") &&
          !navigator.userAgent.includes("Chrome")
        );
      }
      function Nn() {
        try {
          return "object" == typeof indexedDB;
        } catch (e) {
          return !1;
        }
      }
      class Pn extends Error {
        constructor(e, t, n) {
          super(t),
            (this.code = e),
            (this.customData = n),
            (this.name = "FirebaseError"),
            Object.setPrototypeOf(this, Pn.prototype),
            Error.captureStackTrace && Error.captureStackTrace(this, On.prototype.create);
        }
      }
      class On {
        constructor(e, t, n) {
          (this.service = e), (this.serviceName = t), (this.errors = n);
        }
        create(e, ...t) {
          const n = t[0] || {},
            r = `${this.service}/${e}`,
            s = this.errors[e],
            i = s
              ? (function (e, t) {
                  return e.replace(qn, (e, n) => {
                    const r = t[n];
                    return null != r ? String(r) : `<${n}?>`;
                  });
                })(s, n)
              : "Error",
            o = `${this.serviceName}: ${i} (${r}).`;
          return new Pn(r, o, n);
        }
      }
      const qn = /\{\$([^}]+)}/g;
      function Rn(e, t) {
        if (e === t) return !0;
        const n = Object.keys(e),
          r = Object.keys(t);
        for (const s of n) {
          if (!r.includes(s)) return !1;
          const n = e[s],
            i = t[s];
          if (Fn(n) && Fn(i)) {
            if (!Rn(n, i)) return !1;
          } else if (n !== i) return !1;
        }
        for (const e of r) if (!n.includes(e)) return !1;
        return !0;
      }
      function Fn(e) {
        return null !== e && "object" == typeof e;
      }
      function Bn(e) {
        return e && e._delegate ? e._delegate : e;
      }
      class $n {
        constructor(e, t, n) {
          (this.name = e),
            (this.instanceFactory = t),
            (this.type = n),
            (this.multipleInstances = !1),
            (this.serviceProps = {}),
            (this.instantiationMode = "LAZY"),
            (this.onInstanceCreated = null);
        }
        setInstantiationMode(e) {
          return (this.instantiationMode = e), this;
        }
        setMultipleInstances(e) {
          return (this.multipleInstances = e), this;
        }
        setServiceProps(e) {
          return (this.serviceProps = e), this;
        }
        setInstanceCreatedCallback(e) {
          return (this.onInstanceCreated = e), this;
        }
      }
      const Vn = "[DEFAULT]";
      class jn {
        constructor(e, t) {
          (this.name = e),
            (this.container = t),
            (this.component = null),
            (this.instances = new Map()),
            (this.instancesDeferred = new Map()),
            (this.instancesOptions = new Map()),
            (this.onInitCallbacks = new Map());
        }
        get(e) {
          const t = this.normalizeInstanceIdentifier(e);
          if (!this.instancesDeferred.has(t)) {
            const e = new Ln();
            if ((this.instancesDeferred.set(t, e), this.isInitialized(t) || this.shouldAutoInitialize()))
              try {
                const n = this.getOrInitializeService({ instanceIdentifier: t });
                n && e.resolve(n);
              } catch (e) {}
          }
          return this.instancesDeferred.get(t).promise;
        }
        getImmediate(e) {
          var t;
          const n = this.normalizeInstanceIdentifier(null == e ? void 0 : e.identifier),
            r = null !== (t = null == e ? void 0 : e.optional) && void 0 !== t && t;
          if (!this.isInitialized(n) && !this.shouldAutoInitialize()) {
            if (r) return null;
            throw Error(`Service ${this.name} is not available`);
          }
          try {
            return this.getOrInitializeService({ instanceIdentifier: n });
          } catch (e) {
            if (r) return null;
            throw e;
          }
        }
        getComponent() {
          return this.component;
        }
        setComponent(e) {
          if (e.name !== this.name) throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
          if (this.component) throw Error(`Component for ${this.name} has already been provided`);
          if (((this.component = e), this.shouldAutoInitialize())) {
            if (
              (function (e) {
                return "EAGER" === e.instantiationMode;
              })(e)
            )
              try {
                this.getOrInitializeService({ instanceIdentifier: Vn });
              } catch (e) {}
            for (const [e, t] of this.instancesDeferred.entries()) {
              const n = this.normalizeInstanceIdentifier(e);
              try {
                const e = this.getOrInitializeService({ instanceIdentifier: n });
                t.resolve(e);
              } catch (e) {}
            }
          }
        }
        clearInstance(e = Vn) {
          this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
        }
        async delete() {
          const e = Array.from(this.instances.values());
          await Promise.all([
            ...e.filter((e) => "INTERNAL" in e).map((e) => e.INTERNAL.delete()),
            ...e.filter((e) => "_delete" in e).map((e) => e._delete()),
          ]);
        }
        isComponentSet() {
          return null != this.component;
        }
        isInitialized(e = Vn) {
          return this.instances.has(e);
        }
        getOptions(e = Vn) {
          return this.instancesOptions.get(e) || {};
        }
        initialize(e = {}) {
          const { options: t = {} } = e,
            n = this.normalizeInstanceIdentifier(e.instanceIdentifier);
          if (this.isInitialized(n)) throw Error(`${this.name}(${n}) has already been initialized`);
          if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
          const r = this.getOrInitializeService({ instanceIdentifier: n, options: t });
          for (const [e, t] of this.instancesDeferred.entries()) {
            n === this.normalizeInstanceIdentifier(e) && t.resolve(r);
          }
          return r;
        }
        onInit(e, t) {
          var n;
          const r = this.normalizeInstanceIdentifier(t),
            s = null !== (n = this.onInitCallbacks.get(r)) && void 0 !== n ? n : new Set();
          s.add(e), this.onInitCallbacks.set(r, s);
          const i = this.instances.get(r);
          return (
            i && e(i, r),
            () => {
              s.delete(e);
            }
          );
        }
        invokeOnInitCallbacks(e, t) {
          const n = this.onInitCallbacks.get(t);
          if (n)
            for (const r of n)
              try {
                r(e, t);
              } catch (e) {}
        }
        getOrInitializeService({ instanceIdentifier: e, options: t = {} }) {
          let n = this.instances.get(e);
          if (
            !n &&
            this.component &&
            ((n = this.component.instanceFactory(this.container, { instanceIdentifier: ((r = e), r === Vn ? void 0 : r), options: t })),
            this.instances.set(e, n),
            this.instancesOptions.set(e, t),
            this.invokeOnInitCallbacks(n, e),
            this.component.onInstanceCreated)
          )
            try {
              this.component.onInstanceCreated(this.container, e, n);
            } catch (e) {}
          var r;
          return n || null;
        }
        normalizeInstanceIdentifier(e = Vn) {
          return this.component ? (this.component.multipleInstances ? e : Vn) : e;
        }
        shouldAutoInitialize() {
          return !!this.component && "EXPLICIT" !== this.component.instantiationMode;
        }
      }
      class zn {
        constructor(e) {
          (this.name = e), (this.providers = new Map());
        }
        addComponent(e) {
          const t = this.getProvider(e.name);
          if (t.isComponentSet()) throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
          t.setComponent(e);
        }
        addOrOverwriteComponent(e) {
          this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
        }
        getProvider(e) {
          if (this.providers.has(e)) return this.providers.get(e);
          const t = new jn(e, this);
          return this.providers.set(e, t), t;
        }
        getProviders() {
          return Array.from(this.providers.values());
        }
      }
      const Un = [];
      var Gn;
      !(function (e) {
        (e[(e.DEBUG = 0)] = "DEBUG"),
          (e[(e.VERBOSE = 1)] = "VERBOSE"),
          (e[(e.INFO = 2)] = "INFO"),
          (e[(e.WARN = 3)] = "WARN"),
          (e[(e.ERROR = 4)] = "ERROR"),
          (e[(e.SILENT = 5)] = "SILENT");
      })(Gn || (Gn = {}));
      const Hn = { debug: Gn.DEBUG, verbose: Gn.VERBOSE, info: Gn.INFO, warn: Gn.WARN, error: Gn.ERROR, silent: Gn.SILENT },
        Wn = Gn.INFO,
        Kn = { [Gn.DEBUG]: "log", [Gn.VERBOSE]: "log", [Gn.INFO]: "info", [Gn.WARN]: "warn", [Gn.ERROR]: "error" },
        Qn = (e, t, ...n) => {
          if (t < e.logLevel) return;
          const r = new Date().toISOString(),
            s = Kn[t];
          if (!s) throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
          console[s](`[${r}]  ${e.name}:`, ...n);
        };
      class Yn {
        constructor(e) {
          (this.name = e), (this._logLevel = Wn), (this._logHandler = Qn), (this._userLogHandler = null), Un.push(this);
        }
        get logLevel() {
          return this._logLevel;
        }
        set logLevel(e) {
          if (!(e in Gn)) throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
          this._logLevel = e;
        }
        setLogLevel(e) {
          this._logLevel = "string" == typeof e ? Hn[e] : e;
        }
        get logHandler() {
          return this._logHandler;
        }
        set logHandler(e) {
          if ("function" != typeof e) throw new TypeError("Value assigned to `logHandler` must be a function");
          this._logHandler = e;
        }
        get userLogHandler() {
          return this._userLogHandler;
        }
        set userLogHandler(e) {
          this._userLogHandler = e;
        }
        debug(...e) {
          this._userLogHandler && this._userLogHandler(this, Gn.DEBUG, ...e), this._logHandler(this, Gn.DEBUG, ...e);
        }
        log(...e) {
          this._userLogHandler && this._userLogHandler(this, Gn.VERBOSE, ...e), this._logHandler(this, Gn.VERBOSE, ...e);
        }
        info(...e) {
          this._userLogHandler && this._userLogHandler(this, Gn.INFO, ...e), this._logHandler(this, Gn.INFO, ...e);
        }
        warn(...e) {
          this._userLogHandler && this._userLogHandler(this, Gn.WARN, ...e), this._logHandler(this, Gn.WARN, ...e);
        }
        error(...e) {
          this._userLogHandler && this._userLogHandler(this, Gn.ERROR, ...e), this._logHandler(this, Gn.ERROR, ...e);
        }
      }
      const Xn = (e, t) => t.some((t) => e instanceof t);
      let Jn, Zn;
      const er = new WeakMap(),
        tr = new WeakMap(),
        nr = new WeakMap(),
        rr = new WeakMap(),
        sr = new WeakMap();
      let ir = {
        get(e, t, n) {
          if (e instanceof IDBTransaction) {
            if ("done" === t) return tr.get(e);
            if ("objectStoreNames" === t) return e.objectStoreNames || nr.get(e);
            if ("store" === t) return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
          }
          return lr(e[t]);
        },
        set: (e, t, n) => ((e[t] = n), !0),
        has: (e, t) => (e instanceof IDBTransaction && ("done" === t || "store" === t)) || t in e,
      };
      function or(e) {
        return e !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype
          ? (Zn || (Zn = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey])).includes(e)
            ? function (...t) {
                return e.apply(cr(this), t), lr(er.get(this));
              }
            : function (...t) {
                return lr(e.apply(cr(this), t));
              }
          : function (t, ...n) {
              const r = e.call(cr(this), t, ...n);
              return nr.set(r, t.sort ? t.sort() : [t]), lr(r);
            };
      }
      function ar(e) {
        return "function" == typeof e
          ? or(e)
          : (e instanceof IDBTransaction &&
              (function (e) {
                if (tr.has(e)) return;
                const t = new Promise((t, n) => {
                  const r = () => {
                      e.removeEventListener("complete", s), e.removeEventListener("error", i), e.removeEventListener("abort", i);
                    },
                    s = () => {
                      t(), r();
                    },
                    i = () => {
                      n(e.error || new DOMException("AbortError", "AbortError")), r();
                    };
                  e.addEventListener("complete", s), e.addEventListener("error", i), e.addEventListener("abort", i);
                });
                tr.set(e, t);
              })(e),
            Xn(e, Jn || (Jn = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])) ? new Proxy(e, ir) : e);
      }
      function lr(e) {
        if (e instanceof IDBRequest)
          return (function (e) {
            const t = new Promise((t, n) => {
              const r = () => {
                  e.removeEventListener("success", s), e.removeEventListener("error", i);
                },
                s = () => {
                  t(lr(e.result)), r();
                },
                i = () => {
                  n(e.error), r();
                };
              e.addEventListener("success", s), e.addEventListener("error", i);
            });
            return (
              t
                .then((t) => {
                  t instanceof IDBCursor && er.set(t, e);
                })
                .catch(() => {}),
              sr.set(t, e),
              t
            );
          })(e);
        if (rr.has(e)) return rr.get(e);
        const t = ar(e);
        return t !== e && (rr.set(e, t), sr.set(t, e)), t;
      }
      const cr = (e) => sr.get(e);
      const ur = ["get", "getKey", "getAll", "getAllKeys", "count"],
        dr = ["put", "add", "delete", "clear"],
        hr = new Map();
      function pr(e, t) {
        if (!(e instanceof IDBDatabase) || t in e || "string" != typeof t) return;
        if (hr.get(t)) return hr.get(t);
        const n = t.replace(/FromIndex$/, ""),
          r = t !== n,
          s = dr.includes(n);
        if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || (!s && !ur.includes(n))) return;
        const i = async function (e, ...t) {
          const i = this.transaction(e, s ? "readwrite" : "readonly");
          let o = i.store;
          return r && (o = o.index(t.shift())), (await Promise.all([o[n](...t), s && i.done]))[0];
        };
        return hr.set(t, i), i;
      }
      var fr;
      (fr = (e) => ({ ...e, get: (t, n, r) => pr(t, n) || e.get(t, n, r), has: (t, n) => !!pr(t, n) || e.has(t, n) })), (ir = fr(ir));
      class mr {
        constructor(e) {
          this.container = e;
        }
        getPlatformInfoString() {
          return this.container
            .getProviders()
            .map((e) => {
              if (
                (function (e) {
                  const t = e.getComponent();
                  return "VERSION" === (null == t ? void 0 : t.type);
                })(e)
              ) {
                const t = e.getImmediate();
                return `${t.library}/${t.version}`;
              }
              return null;
            })
            .filter((e) => e)
            .join(" ");
        }
      }
      const gr = "@firebase/app",
        yr = "0.10.18",
        vr = new Yn("@firebase/app"),
        wr = "[DEFAULT]",
        br = {
          [gr]: "fire-core",
          "@firebase/app-compat": "fire-core-compat",
          "@firebase/analytics": "fire-analytics",
          "@firebase/analytics-compat": "fire-analytics-compat",
          "@firebase/app-check": "fire-app-check",
          "@firebase/app-check-compat": "fire-app-check-compat",
          "@firebase/auth": "fire-auth",
          "@firebase/auth-compat": "fire-auth-compat",
          "@firebase/database": "fire-rtdb",
          "@firebase/data-connect": "fire-data-connect",
          "@firebase/database-compat": "fire-rtdb-compat",
          "@firebase/functions": "fire-fn",
          "@firebase/functions-compat": "fire-fn-compat",
          "@firebase/installations": "fire-iid",
          "@firebase/installations-compat": "fire-iid-compat",
          "@firebase/messaging": "fire-fcm",
          "@firebase/messaging-compat": "fire-fcm-compat",
          "@firebase/performance": "fire-perf",
          "@firebase/performance-compat": "fire-perf-compat",
          "@firebase/remote-config": "fire-rc",
          "@firebase/remote-config-compat": "fire-rc-compat",
          "@firebase/storage": "fire-gcs",
          "@firebase/storage-compat": "fire-gcs-compat",
          "@firebase/firestore": "fire-fst",
          "@firebase/firestore-compat": "fire-fst-compat",
          "@firebase/vertexai": "fire-vertex",
          "fire-js": "fire-js",
          firebase: "fire-js-all",
        },
        Sr = new Map(),
        Er = new Map(),
        Tr = new Map();
      function _r(e, t) {
        try {
          e.container.addComponent(t);
        } catch (n) {
          vr.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
        }
      }
      function Cr(e) {
        const t = e.name;
        if (Tr.has(t)) return vr.debug(`There were multiple attempts to register component ${t}.`), !1;
        Tr.set(t, e);
        for (const t of Sr.values()) _r(t, e);
        for (const t of Er.values()) _r(t, e);
        return !0;
      }
      function xr(e, t) {
        const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
        return n && n.triggerHeartbeat(), e.container.getProvider(t);
      }
      const Ar = new On("app", "Firebase", {
        "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
        "bad-app-name": "Illegal App name: '{$appName}'",
        "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
        "app-deleted": "Firebase App named '{$appName}' already deleted",
        "server-app-deleted": "Firebase Server App has been deleted",
        "no-options": "Need to provide options, when not being deployed to hosting via source.",
        "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
        "invalid-log-argument": "First argument to `onLog` must be null or a function.",
        "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
        "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
        "finalization-registry-not-supported":
          "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
        "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments.",
      });
      class Ir {
        constructor(e, t, n) {
          (this._isDeleted = !1),
            (this._options = Object.assign({}, e)),
            (this._config = Object.assign({}, t)),
            (this._name = t.name),
            (this._automaticDataCollectionEnabled = t.automaticDataCollectionEnabled),
            (this._container = n),
            this.container.addComponent(new $n("app", () => this, "PUBLIC"));
        }
        get automaticDataCollectionEnabled() {
          return this.checkDestroyed(), this._automaticDataCollectionEnabled;
        }
        set automaticDataCollectionEnabled(e) {
          this.checkDestroyed(), (this._automaticDataCollectionEnabled = e);
        }
        get name() {
          return this.checkDestroyed(), this._name;
        }
        get options() {
          return this.checkDestroyed(), this._options;
        }
        get config() {
          return this.checkDestroyed(), this._config;
        }
        get container() {
          return this._container;
        }
        get isDeleted() {
          return this._isDeleted;
        }
        set isDeleted(e) {
          this._isDeleted = e;
        }
        checkDestroyed() {
          if (this.isDeleted) throw Ar.create("app-deleted", { appName: this._name });
        }
      }
      function kr(e, t = {}) {
        let n = e;
        if ("object" != typeof t) {
          t = { name: t };
        }
        const r = Object.assign({ name: wr, automaticDataCollectionEnabled: !1 }, t),
          s = r.name;
        if ("string" != typeof s || !s) throw Ar.create("bad-app-name", { appName: String(s) });
        if ((n || (n = kn()), !n)) throw Ar.create("no-options");
        const i = Sr.get(s);
        if (i) {
          if (Rn(n, i.options) && Rn(r, i.config)) return i;
          throw Ar.create("duplicate-app", { appName: s });
        }
        const o = new zn(s);
        for (const e of Tr.values()) o.addComponent(e);
        const a = new Ir(n, r, o);
        return Sr.set(s, a), a;
      }
      function Lr(e, t, n) {
        var r;
        let s = null !== (r = br[e]) && void 0 !== r ? r : e;
        n && (s += `-${n}`);
        const i = s.match(/\s|\//),
          o = t.match(/\s|\//);
        if (i || o) {
          const e = [`Unable to register library "${s}" with version "${t}":`];
          return (
            i && e.push(`library name "${s}" contains illegal characters (whitespace or "/")`),
            i && o && e.push("and"),
            o && e.push(`version name "${t}" contains illegal characters (whitespace or "/")`),
            void vr.warn(e.join(" "))
          );
        }
        Cr(new $n(`${s}-version`, () => ({ library: s, version: t }), "VERSION"));
      }
      const Mr = "firebase-heartbeat-database",
        Dr = 1,
        Nr = "firebase-heartbeat-store";
      let Pr = null;
      function Or() {
        return (
          Pr ||
            (Pr = (function (e, t, { blocked: n, upgrade: r, blocking: s, terminated: i } = {}) {
              const o = indexedDB.open(e, t),
                a = lr(o);
              return (
                r &&
                  o.addEventListener("upgradeneeded", (e) => {
                    r(lr(o.result), e.oldVersion, e.newVersion, lr(o.transaction), e);
                  }),
                n && o.addEventListener("blocked", (e) => n(e.oldVersion, e.newVersion, e)),
                a
                  .then((e) => {
                    i && e.addEventListener("close", () => i()),
                      s && e.addEventListener("versionchange", (e) => s(e.oldVersion, e.newVersion, e));
                  })
                  .catch(() => {}),
                a
              );
            })(Mr, Dr, {
              upgrade: (e, t) => {
                if (0 === t)
                  try {
                    e.createObjectStore(Nr);
                  } catch (e) {
                    console.warn(e);
                  }
              },
            }).catch((e) => {
              throw Ar.create("idb-open", { originalErrorMessage: e.message });
            })),
          Pr
        );
      }
      async function qr(e, t) {
        try {
          const n = (await Or()).transaction(Nr, "readwrite"),
            r = n.objectStore(Nr);
          await r.put(t, Rr(e)), await n.done;
        } catch (e) {
          if (e instanceof Pn) vr.warn(e.message);
          else {
            const t = Ar.create("idb-set", { originalErrorMessage: null == e ? void 0 : e.message });
            vr.warn(t.message);
          }
        }
      }
      function Rr(e) {
        return `${e.name}!${e.options.appId}`;
      }
      class Fr {
        constructor(e) {
          (this.container = e), (this._heartbeatsCache = null);
          const t = this.container.getProvider("app").getImmediate();
          (this._storage = new $r(t)), (this._heartbeatsCachePromise = this._storage.read().then((e) => ((this._heartbeatsCache = e), e)));
        }
        async triggerHeartbeat() {
          var e, t;
          try {
            const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(),
              r = Br();
            if (
              null == (null === (e = this._heartbeatsCache) || void 0 === e ? void 0 : e.heartbeats) &&
              ((this._heartbeatsCache = await this._heartbeatsCachePromise),
              null == (null === (t = this._heartbeatsCache) || void 0 === t ? void 0 : t.heartbeats))
            )
              return;
            if (this._heartbeatsCache.lastSentHeartbeatDate === r || this._heartbeatsCache.heartbeats.some((e) => e.date === r)) return;
            return (
              this._heartbeatsCache.heartbeats.push({ date: r, agent: n }),
              (this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((e) => {
                const t = new Date(e.date).valueOf();
                return Date.now() - t <= 2592e6;
              })),
              this._storage.overwrite(this._heartbeatsCache)
            );
          } catch (e) {
            vr.warn(e);
          }
        }
        async getHeartbeatsHeader() {
          var e;
          try {
            if (
              (null === this._heartbeatsCache && (await this._heartbeatsCachePromise),
              null == (null === (e = this._heartbeatsCache) || void 0 === e ? void 0 : e.heartbeats) ||
                0 === this._heartbeatsCache.heartbeats.length)
            )
              return "";
            const t = Br(),
              { heartbeatsToSend: n, unsentEntries: r } = (function (e, t = 1024) {
                const n = [];
                let r = e.slice();
                for (const s of e) {
                  const e = n.find((e) => e.agent === s.agent);
                  if (e) {
                    if ((e.dates.push(s.date), Vr(n) > t)) {
                      e.dates.pop();
                      break;
                    }
                  } else if ((n.push({ agent: s.agent, dates: [s.date] }), Vr(n) > t)) {
                    n.pop();
                    break;
                  }
                  r = r.slice(1);
                }
                return { heartbeatsToSend: n, unsentEntries: r };
              })(this._heartbeatsCache.heartbeats),
              s = _n(JSON.stringify({ version: 2, heartbeats: n }));
            return (
              (this._heartbeatsCache.lastSentHeartbeatDate = t),
              r.length > 0
                ? ((this._heartbeatsCache.heartbeats = r), await this._storage.overwrite(this._heartbeatsCache))
                : ((this._heartbeatsCache.heartbeats = []), this._storage.overwrite(this._heartbeatsCache)),
              s
            );
          } catch (e) {
            return vr.warn(e), "";
          }
        }
      }
      function Br() {
        return new Date().toISOString().substring(0, 10);
      }
      class $r {
        constructor(e) {
          (this.app = e), (this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck());
        }
        async runIndexedDBEnvironmentCheck() {
          return (
            !!Nn() &&
            new Promise((e, t) => {
              try {
                let n = !0;
                const r = "validate-browser-context-for-indexeddb-analytics-module",
                  s = self.indexedDB.open(r);
                (s.onsuccess = () => {
                  s.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
                }),
                  (s.onupgradeneeded = () => {
                    n = !1;
                  }),
                  (s.onerror = () => {
                    var e;
                    t((null === (e = s.error) || void 0 === e ? void 0 : e.message) || "");
                  });
              } catch (e) {
                t(e);
              }
            })
              .then(() => !0)
              .catch(() => !1)
          );
        }
        async read() {
          if (await this._canUseIndexedDBPromise) {
            const e = await (async function (e) {
              try {
                const t = (await Or()).transaction(Nr),
                  n = await t.objectStore(Nr).get(Rr(e));
                return await t.done, n;
              } catch (e) {
                if (e instanceof Pn) vr.warn(e.message);
                else {
                  const t = Ar.create("idb-get", { originalErrorMessage: null == e ? void 0 : e.message });
                  vr.warn(t.message);
                }
              }
            })(this.app);
            return (null == e ? void 0 : e.heartbeats) ? e : { heartbeats: [] };
          }
          return { heartbeats: [] };
        }
        async overwrite(e) {
          var t;
          if (await this._canUseIndexedDBPromise) {
            const n = await this.read();
            return qr(this.app, {
              lastSentHeartbeatDate: null !== (t = e.lastSentHeartbeatDate) && void 0 !== t ? t : n.lastSentHeartbeatDate,
              heartbeats: e.heartbeats,
            });
          }
        }
        async add(e) {
          var t;
          if (await this._canUseIndexedDBPromise) {
            const n = await this.read();
            return qr(this.app, {
              lastSentHeartbeatDate: null !== (t = e.lastSentHeartbeatDate) && void 0 !== t ? t : n.lastSentHeartbeatDate,
              heartbeats: [...n.heartbeats, ...e.heartbeats],
            });
          }
        }
      }
      function Vr(e) {
        return _n(JSON.stringify({ version: 2, heartbeats: e })).length;
      }
      var jr;
      (jr = ""),
        Cr(new $n("platform-logger", (e) => new mr(e), "PRIVATE")),
        Cr(new $n("heartbeat", (e) => new Fr(e), "PRIVATE")),
        Lr(gr, yr, jr),
        Lr(gr, yr, "esm2017"),
        Lr("fire-js", "");
      Lr("firebase", "11.2.0", "app");
      var zr,
        Ur,
        Gr =
          "undefined" != typeof globalThis
            ? globalThis
            : "undefined" != typeof window
            ? window
            : "undefined" != typeof global
            ? global
            : "undefined" != typeof self
            ? self
            : {},
        Hr = {};
      (function () {
        var e;
        function t() {
          (this.blockSize = -1),
            (this.blockSize = 64),
            (this.g = Array(4)),
            (this.B = Array(this.blockSize)),
            (this.o = this.h = 0),
            this.s();
        }
        function n(e, t, n) {
          n || (n = 0);
          var r = Array(16);
          if ("string" == typeof t)
            for (var s = 0; 16 > s; ++s)
              r[s] = t.charCodeAt(n++) | (t.charCodeAt(n++) << 8) | (t.charCodeAt(n++) << 16) | (t.charCodeAt(n++) << 24);
          else for (s = 0; 16 > s; ++s) r[s] = t[n++] | (t[n++] << 8) | (t[n++] << 16) | (t[n++] << 24);
          (t = e.g[0]), (n = e.g[1]), (s = e.g[2]);
          var i = e.g[3],
            o = (t + (i ^ (n & (s ^ i))) + r[0] + 3614090360) & 4294967295;
          (o =
            ((n =
              (s =
                (i =
                  (t =
                    (n =
                      (s =
                        (i =
                          (t =
                            (n =
                              (s =
                                (i =
                                  (t =
                                    (n =
                                      (s =
                                        (i =
                                          (t =
                                            (n =
                                              (s =
                                                (i =
                                                  (t =
                                                    (n =
                                                      (s =
                                                        (i =
                                                          (t =
                                                            (n =
                                                              (s =
                                                                (i =
                                                                  (t =
                                                                    (n =
                                                                      (s =
                                                                        (i =
                                                                          (t =
                                                                            (n =
                                                                              (s =
                                                                                (i =
                                                                                  (t =
                                                                                    (n =
                                                                                      (s =
                                                                                        (i =
                                                                                          (t =
                                                                                            (n =
                                                                                              (s =
                                                                                                (i =
                                                                                                  (t =
                                                                                                    (n =
                                                                                                      (s =
                                                                                                        (i =
                                                                                                          (t =
                                                                                                            (n =
                                                                                                              (s =
                                                                                                                (i =
                                                                                                                  (t =
                                                                                                                    (n =
                                                                                                                      (s =
                                                                                                                        (i =
                                                                                                                          (t =
                                                                                                                            (n =
                                                                                                                              (s =
                                                                                                                                (i =
                                                                                                                                  (t =
                                                                                                                                    n +
                                                                                                                                    (((o <<
                                                                                                                                      7) &
                                                                                                                                      4294967295) |
                                                                                                                                      (o >>>
                                                                                                                                        25))) +
                                                                                                                                  ((((o =
                                                                                                                                    (i +
                                                                                                                                      (s ^
                                                                                                                                        (t &
                                                                                                                                          (n ^
                                                                                                                                            s))) +
                                                                                                                                      r[1] +
                                                                                                                                      3905402710) &
                                                                                                                                    4294967295) <<
                                                                                                                                    12) &
                                                                                                                                    4294967295) |
                                                                                                                                    (o >>>
                                                                                                                                      20))) +
                                                                                                                                ((((o =
                                                                                                                                  (s +
                                                                                                                                    (n ^
                                                                                                                                      (i &
                                                                                                                                        (t ^
                                                                                                                                          n))) +
                                                                                                                                    r[2] +
                                                                                                                                    606105819) &
                                                                                                                                  4294967295) <<
                                                                                                                                  17) &
                                                                                                                                  4294967295) |
                                                                                                                                  (o >>>
                                                                                                                                    15))) +
                                                                                                                              ((((o =
                                                                                                                                (n +
                                                                                                                                  (t ^
                                                                                                                                    (s &
                                                                                                                                      (i ^
                                                                                                                                        t))) +
                                                                                                                                  r[3] +
                                                                                                                                  3250441966) &
                                                                                                                                4294967295) <<
                                                                                                                                22) &
                                                                                                                                4294967295) |
                                                                                                                                (o >>>
                                                                                                                                  10))) +
                                                                                                                            ((((o =
                                                                                                                              (t +
                                                                                                                                (i ^
                                                                                                                                  (n &
                                                                                                                                    (s ^
                                                                                                                                      i))) +
                                                                                                                                r[4] +
                                                                                                                                4118548399) &
                                                                                                                              4294967295) <<
                                                                                                                              7) &
                                                                                                                              4294967295) |
                                                                                                                              (o >>> 25))) +
                                                                                                                          ((((o =
                                                                                                                            (i +
                                                                                                                              (s ^
                                                                                                                                (t &
                                                                                                                                  (n ^
                                                                                                                                    s))) +
                                                                                                                              r[5] +
                                                                                                                              1200080426) &
                                                                                                                            4294967295) <<
                                                                                                                            12) &
                                                                                                                            4294967295) |
                                                                                                                            (o >>> 20))) +
                                                                                                                        ((((o =
                                                                                                                          (s +
                                                                                                                            (n ^
                                                                                                                              (i &
                                                                                                                                (t ^ n))) +
                                                                                                                            r[6] +
                                                                                                                            2821735955) &
                                                                                                                          4294967295) <<
                                                                                                                          17) &
                                                                                                                          4294967295) |
                                                                                                                          (o >>> 15))) +
                                                                                                                      ((((o =
                                                                                                                        (n +
                                                                                                                          (t ^
                                                                                                                            (s & (i ^ t))) +
                                                                                                                          r[7] +
                                                                                                                          4249261313) &
                                                                                                                        4294967295) <<
                                                                                                                        22) &
                                                                                                                        4294967295) |
                                                                                                                        (o >>> 10))) +
                                                                                                                    ((((o =
                                                                                                                      (t +
                                                                                                                        (i ^
                                                                                                                          (n & (s ^ i))) +
                                                                                                                        r[8] +
                                                                                                                        1770035416) &
                                                                                                                      4294967295) <<
                                                                                                                      7) &
                                                                                                                      4294967295) |
                                                                                                                      (o >>> 25))) +
                                                                                                                  ((((o =
                                                                                                                    (i +
                                                                                                                      (s ^ (t & (n ^ s))) +
                                                                                                                      r[9] +
                                                                                                                      2336552879) &
                                                                                                                    4294967295) <<
                                                                                                                    12) &
                                                                                                                    4294967295) |
                                                                                                                    (o >>> 20))) +
                                                                                                                ((((o =
                                                                                                                  (s +
                                                                                                                    (n ^ (i & (t ^ n))) +
                                                                                                                    r[10] +
                                                                                                                    4294925233) &
                                                                                                                  4294967295) <<
                                                                                                                  17) &
                                                                                                                  4294967295) |
                                                                                                                  (o >>> 15))) +
                                                                                                              ((((o =
                                                                                                                (n +
                                                                                                                  (t ^ (s & (i ^ t))) +
                                                                                                                  r[11] +
                                                                                                                  2304563134) &
                                                                                                                4294967295) <<
                                                                                                                22) &
                                                                                                                4294967295) |
                                                                                                                (o >>> 10))) +
                                                                                                            ((((o =
                                                                                                              (t +
                                                                                                                (i ^ (n & (s ^ i))) +
                                                                                                                r[12] +
                                                                                                                1804603682) &
                                                                                                              4294967295) <<
                                                                                                              7) &
                                                                                                              4294967295) |
                                                                                                              (o >>> 25))) +
                                                                                                          ((((o =
                                                                                                            (i +
                                                                                                              (s ^ (t & (n ^ s))) +
                                                                                                              r[13] +
                                                                                                              4254626195) &
                                                                                                            4294967295) <<
                                                                                                            12) &
                                                                                                            4294967295) |
                                                                                                            (o >>> 20))) +
                                                                                                        ((((o =
                                                                                                          (s +
                                                                                                            (n ^ (i & (t ^ n))) +
                                                                                                            r[14] +
                                                                                                            2792965006) &
                                                                                                          4294967295) <<
                                                                                                          17) &
                                                                                                          4294967295) |
                                                                                                          (o >>> 15))) +
                                                                                                      ((((o =
                                                                                                        (n +
                                                                                                          (t ^ (s & (i ^ t))) +
                                                                                                          r[15] +
                                                                                                          1236535329) &
                                                                                                        4294967295) <<
                                                                                                        22) &
                                                                                                        4294967295) |
                                                                                                        (o >>> 10))) +
                                                                                                    ((((o =
                                                                                                      (t +
                                                                                                        (s ^ (i & (n ^ s))) +
                                                                                                        r[1] +
                                                                                                        4129170786) &
                                                                                                      4294967295) <<
                                                                                                      5) &
                                                                                                      4294967295) |
                                                                                                      (o >>> 27))) +
                                                                                                  ((((o =
                                                                                                    (i +
                                                                                                      (n ^ (s & (t ^ n))) +
                                                                                                      r[6] +
                                                                                                      3225465664) &
                                                                                                    4294967295) <<
                                                                                                    9) &
                                                                                                    4294967295) |
                                                                                                    (o >>> 23))) +
                                                                                                ((((o =
                                                                                                  (s +
                                                                                                    (t ^ (n & (i ^ t))) +
                                                                                                    r[11] +
                                                                                                    643717713) &
                                                                                                  4294967295) <<
                                                                                                  14) &
                                                                                                  4294967295) |
                                                                                                  (o >>> 18))) +
                                                                                              ((((o =
                                                                                                (n +
                                                                                                  (i ^ (t & (s ^ i))) +
                                                                                                  r[0] +
                                                                                                  3921069994) &
                                                                                                4294967295) <<
                                                                                                20) &
                                                                                                4294967295) |
                                                                                                (o >>> 12))) +
                                                                                            ((((o =
                                                                                              (t +
                                                                                                (s ^ (i & (n ^ s))) +
                                                                                                r[5] +
                                                                                                3593408605) &
                                                                                              4294967295) <<
                                                                                              5) &
                                                                                              4294967295) |
                                                                                              (o >>> 27))) +
                                                                                          ((((o =
                                                                                            (i + (n ^ (s & (t ^ n))) + r[10] + 38016083) &
                                                                                            4294967295) <<
                                                                                            9) &
                                                                                            4294967295) |
                                                                                            (o >>> 23))) +
                                                                                        ((((o =
                                                                                          (s + (t ^ (n & (i ^ t))) + r[15] + 3634488961) &
                                                                                          4294967295) <<
                                                                                          14) &
                                                                                          4294967295) |
                                                                                          (o >>> 18))) +
                                                                                      ((((o =
                                                                                        (n + (i ^ (t & (s ^ i))) + r[4] + 3889429448) &
                                                                                        4294967295) <<
                                                                                        20) &
                                                                                        4294967295) |
                                                                                        (o >>> 12))) +
                                                                                    ((((o =
                                                                                      (t + (s ^ (i & (n ^ s))) + r[9] + 568446438) &
                                                                                      4294967295) <<
                                                                                      5) &
                                                                                      4294967295) |
                                                                                      (o >>> 27))) +
                                                                                  ((((o =
                                                                                    (i + (n ^ (s & (t ^ n))) + r[14] + 3275163606) &
                                                                                    4294967295) <<
                                                                                    9) &
                                                                                    4294967295) |
                                                                                    (o >>> 23))) +
                                                                                ((((o =
                                                                                  (s + (t ^ (n & (i ^ t))) + r[3] + 4107603335) &
                                                                                  4294967295) <<
                                                                                  14) &
                                                                                  4294967295) |
                                                                                  (o >>> 18))) +
                                                                              ((((o =
                                                                                (n + (i ^ (t & (s ^ i))) + r[8] + 1163531501) &
                                                                                4294967295) <<
                                                                                20) &
                                                                                4294967295) |
                                                                                (o >>> 12))) +
                                                                            ((((o =
                                                                              (t + (s ^ (i & (n ^ s))) + r[13] + 2850285829) &
                                                                              4294967295) <<
                                                                              5) &
                                                                              4294967295) |
                                                                              (o >>> 27))) +
                                                                          ((((o =
                                                                            (i + (n ^ (s & (t ^ n))) + r[2] + 4243563512) & 4294967295) <<
                                                                            9) &
                                                                            4294967295) |
                                                                            (o >>> 23))) +
                                                                        ((((o =
                                                                          (s + (t ^ (n & (i ^ t))) + r[7] + 1735328473) & 4294967295) <<
                                                                          14) &
                                                                          4294967295) |
                                                                          (o >>> 18))) +
                                                                      ((((o =
                                                                        (n + (i ^ (t & (s ^ i))) + r[12] + 2368359562) & 4294967295) <<
                                                                        20) &
                                                                        4294967295) |
                                                                        (o >>> 12))) +
                                                                    ((((o = (t + (n ^ s ^ i) + r[5] + 4294588738) & 4294967295) << 4) &
                                                                      4294967295) |
                                                                      (o >>> 28))) +
                                                                  ((((o = (i + (t ^ n ^ s) + r[8] + 2272392833) & 4294967295) << 11) &
                                                                    4294967295) |
                                                                    (o >>> 21))) +
                                                                ((((o = (s + (i ^ t ^ n) + r[11] + 1839030562) & 4294967295) << 16) &
                                                                  4294967295) |
                                                                  (o >>> 16))) +
                                                              ((((o = (n + (s ^ i ^ t) + r[14] + 4259657740) & 4294967295) << 23) &
                                                                4294967295) |
                                                                (o >>> 9))) +
                                                            ((((o = (t + (n ^ s ^ i) + r[1] + 2763975236) & 4294967295) << 4) &
                                                              4294967295) |
                                                              (o >>> 28))) +
                                                          ((((o = (i + (t ^ n ^ s) + r[4] + 1272893353) & 4294967295) << 11) & 4294967295) |
                                                            (o >>> 21))) +
                                                        ((((o = (s + (i ^ t ^ n) + r[7] + 4139469664) & 4294967295) << 16) & 4294967295) |
                                                          (o >>> 16))) +
                                                      ((((o = (n + (s ^ i ^ t) + r[10] + 3200236656) & 4294967295) << 23) & 4294967295) |
                                                        (o >>> 9))) +
                                                    ((((o = (t + (n ^ s ^ i) + r[13] + 681279174) & 4294967295) << 4) & 4294967295) |
                                                      (o >>> 28))) +
                                                  ((((o = (i + (t ^ n ^ s) + r[0] + 3936430074) & 4294967295) << 11) & 4294967295) |
                                                    (o >>> 21))) +
                                                ((((o = (s + (i ^ t ^ n) + r[3] + 3572445317) & 4294967295) << 16) & 4294967295) |
                                                  (o >>> 16))) +
                                              ((((o = (n + (s ^ i ^ t) + r[6] + 76029189) & 4294967295) << 23) & 4294967295) | (o >>> 9))) +
                                            ((((o = (t + (n ^ s ^ i) + r[9] + 3654602809) & 4294967295) << 4) & 4294967295) | (o >>> 28))) +
                                          ((((o = (i + (t ^ n ^ s) + r[12] + 3873151461) & 4294967295) << 11) & 4294967295) | (o >>> 21))) +
                                        ((((o = (s + (i ^ t ^ n) + r[15] + 530742520) & 4294967295) << 16) & 4294967295) | (o >>> 16))) +
                                      ((((o = (n + (s ^ i ^ t) + r[2] + 3299628645) & 4294967295) << 23) & 4294967295) | (o >>> 9))) +
                                    ((((o = (t + (s ^ (n | ~i)) + r[0] + 4096336452) & 4294967295) << 6) & 4294967295) | (o >>> 26))) +
                                  ((((o = (i + (n ^ (t | ~s)) + r[7] + 1126891415) & 4294967295) << 10) & 4294967295) | (o >>> 22))) +
                                ((((o = (s + (t ^ (i | ~n)) + r[14] + 2878612391) & 4294967295) << 15) & 4294967295) | (o >>> 17))) +
                              ((((o = (n + (i ^ (s | ~t)) + r[5] + 4237533241) & 4294967295) << 21) & 4294967295) | (o >>> 11))) +
                            ((((o = (t + (s ^ (n | ~i)) + r[12] + 1700485571) & 4294967295) << 6) & 4294967295) | (o >>> 26))) +
                          ((((o = (i + (n ^ (t | ~s)) + r[3] + 2399980690) & 4294967295) << 10) & 4294967295) | (o >>> 22))) +
                        ((((o = (s + (t ^ (i | ~n)) + r[10] + 4293915773) & 4294967295) << 15) & 4294967295) | (o >>> 17))) +
                      ((((o = (n + (i ^ (s | ~t)) + r[1] + 2240044497) & 4294967295) << 21) & 4294967295) | (o >>> 11))) +
                    ((((o = (t + (s ^ (n | ~i)) + r[8] + 1873313359) & 4294967295) << 6) & 4294967295) | (o >>> 26))) +
                  ((((o = (i + (n ^ (t | ~s)) + r[15] + 4264355552) & 4294967295) << 10) & 4294967295) | (o >>> 22))) +
                ((((o = (s + (t ^ (i | ~n)) + r[6] + 2734768916) & 4294967295) << 15) & 4294967295) | (o >>> 17))) +
              ((((o = (n + (i ^ (s | ~t)) + r[13] + 1309151649) & 4294967295) << 21) & 4294967295) | (o >>> 11))) +
              ((i =
                (t = n + ((((o = (t + (s ^ (n | ~i)) + r[4] + 4149444226) & 4294967295) << 6) & 4294967295) | (o >>> 26))) +
                ((((o = (i + (n ^ (t | ~s)) + r[11] + 3174756917) & 4294967295) << 10) & 4294967295) | (o >>> 22))) ^
                ((s = i + ((((o = (s + (t ^ (i | ~n)) + r[2] + 718787259) & 4294967295) << 15) & 4294967295) | (o >>> 17))) | ~t)) +
              r[9] +
              3951481745) &
            4294967295),
            (e.g[0] = (e.g[0] + t) & 4294967295),
            (e.g[1] = (e.g[1] + (s + (((o << 21) & 4294967295) | (o >>> 11)))) & 4294967295),
            (e.g[2] = (e.g[2] + s) & 4294967295),
            (e.g[3] = (e.g[3] + i) & 4294967295);
        }
        function r(e, t) {
          this.h = t;
          for (var n = [], r = !0, s = e.length - 1; 0 <= s; s--) {
            var i = 0 | e[s];
            (r && i == t) || ((n[s] = i), (r = !1));
          }
          this.g = n;
        }
        !(function (e, t) {
          function n() {}
          (n.prototype = t.prototype),
            (e.D = t.prototype),
            (e.prototype = new n()),
            (e.prototype.constructor = e),
            (e.C = function (e, n, r) {
              for (var s = Array(arguments.length - 2), i = 2; i < arguments.length; i++) s[i - 2] = arguments[i];
              return t.prototype[n].apply(e, s);
            });
        })(t, function () {
          this.blockSize = -1;
        }),
          (t.prototype.s = function () {
            (this.g[0] = 1732584193), (this.g[1] = 4023233417), (this.g[2] = 2562383102), (this.g[3] = 271733878), (this.o = this.h = 0);
          }),
          (t.prototype.u = function (e, t) {
            void 0 === t && (t = e.length);
            for (var r = t - this.blockSize, s = this.B, i = this.h, o = 0; o < t; ) {
              if (0 == i) for (; o <= r; ) n(this, e, o), (o += this.blockSize);
              if ("string" == typeof e) {
                for (; o < t; )
                  if (((s[i++] = e.charCodeAt(o++)), i == this.blockSize)) {
                    n(this, s), (i = 0);
                    break;
                  }
              } else
                for (; o < t; )
                  if (((s[i++] = e[o++]), i == this.blockSize)) {
                    n(this, s), (i = 0);
                    break;
                  }
            }
            (this.h = i), (this.o += t);
          }),
          (t.prototype.v = function () {
            var e = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
            e[0] = 128;
            for (var t = 1; t < e.length - 8; ++t) e[t] = 0;
            var n = 8 * this.o;
            for (t = e.length - 8; t < e.length; ++t) (e[t] = 255 & n), (n /= 256);
            for (this.u(e), e = Array(16), t = n = 0; 4 > t; ++t) for (var r = 0; 32 > r; r += 8) e[n++] = (this.g[t] >>> r) & 255;
            return e;
          });
        var s = {};
        function i(e) {
          return -128 <= e && 128 > e
            ? (function (e, t) {
                var n = s;
                return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : (n[e] = t(e));
              })(e, function (e) {
                return new r([0 | e], 0 > e ? -1 : 0);
              })
            : new r([0 | e], 0 > e ? -1 : 0);
        }
        function o(e) {
          if (isNaN(e) || !isFinite(e)) return a;
          if (0 > e) return h(o(-e));
          for (var t = [], n = 1, s = 0; e >= n; s++) (t[s] = (e / n) | 0), (n *= 4294967296);
          return new r(t, 0);
        }
        var a = i(0),
          l = i(1),
          c = i(16777216);
        function u(e) {
          if (0 != e.h) return !1;
          for (var t = 0; t < e.g.length; t++) if (0 != e.g[t]) return !1;
          return !0;
        }
        function d(e) {
          return -1 == e.h;
        }
        function h(e) {
          for (var t = e.g.length, n = [], s = 0; s < t; s++) n[s] = ~e.g[s];
          return new r(n, ~e.h).add(l);
        }
        function p(e, t) {
          return e.add(h(t));
        }
        function f(e, t) {
          for (; (65535 & e[t]) != e[t]; ) (e[t + 1] += e[t] >>> 16), (e[t] &= 65535), t++;
        }
        function m(e, t) {
          (this.g = e), (this.h = t);
        }
        function g(e, t) {
          if (u(t)) throw Error("division by zero");
          if (u(e)) return new m(a, a);
          if (d(e)) return (t = g(h(e), t)), new m(h(t.g), h(t.h));
          if (d(t)) return (t = g(e, h(t))), new m(h(t.g), t.h);
          if (30 < e.g.length) {
            if (d(e) || d(t)) throw Error("slowDivide_ only works with positive integers.");
            for (var n = l, r = t; 0 >= r.l(e); ) (n = y(n)), (r = y(r));
            var s = v(n, 1),
              i = v(r, 1);
            for (r = v(r, 2), n = v(n, 2); !u(r); ) {
              var c = i.add(r);
              0 >= c.l(e) && ((s = s.add(n)), (i = c)), (r = v(r, 1)), (n = v(n, 1));
            }
            return (t = p(e, s.j(t))), new m(s, t);
          }
          for (s = a; 0 <= e.l(t); ) {
            for (
              n = Math.max(1, Math.floor(e.m() / t.m())),
                r = 48 >= (r = Math.ceil(Math.log(n) / Math.LN2)) ? 1 : Math.pow(2, r - 48),
                c = (i = o(n)).j(t);
              d(c) || 0 < c.l(e);

            )
              c = (i = o((n -= r))).j(t);
            u(i) && (i = l), (s = s.add(i)), (e = p(e, c));
          }
          return new m(s, e);
        }
        function y(e) {
          for (var t = e.g.length + 1, n = [], s = 0; s < t; s++) n[s] = (e.i(s) << 1) | (e.i(s - 1) >>> 31);
          return new r(n, e.h);
        }
        function v(e, t) {
          var n = t >> 5;
          t %= 32;
          for (var s = e.g.length - n, i = [], o = 0; o < s; o++)
            i[o] = 0 < t ? (e.i(o + n) >>> t) | (e.i(o + n + 1) << (32 - t)) : e.i(o + n);
          return new r(i, e.h);
        }
        ((e = r.prototype).m = function () {
          if (d(this)) return -h(this).m();
          for (var e = 0, t = 1, n = 0; n < this.g.length; n++) {
            var r = this.i(n);
            (e += (0 <= r ? r : 4294967296 + r) * t), (t *= 4294967296);
          }
          return e;
        }),
          (e.toString = function (e) {
            if (2 > (e = e || 10) || 36 < e) throw Error("radix out of range: " + e);
            if (u(this)) return "0";
            if (d(this)) return "-" + h(this).toString(e);
            for (var t = o(Math.pow(e, 6)), n = this, r = ""; ; ) {
              var s = g(n, t).g,
                i = ((0 < (n = p(n, s.j(t))).g.length ? n.g[0] : n.h) >>> 0).toString(e);
              if (u((n = s))) return i + r;
              for (; 6 > i.length; ) i = "0" + i;
              r = i + r;
            }
          }),
          (e.i = function (e) {
            return 0 > e ? 0 : e < this.g.length ? this.g[e] : this.h;
          }),
          (e.l = function (e) {
            return d((e = p(this, e))) ? -1 : u(e) ? 0 : 1;
          }),
          (e.abs = function () {
            return d(this) ? h(this) : this;
          }),
          (e.add = function (e) {
            for (var t = Math.max(this.g.length, e.g.length), n = [], s = 0, i = 0; i <= t; i++) {
              var o = s + (65535 & this.i(i)) + (65535 & e.i(i)),
                a = (o >>> 16) + (this.i(i) >>> 16) + (e.i(i) >>> 16);
              (s = a >>> 16), (o &= 65535), (a &= 65535), (n[i] = (a << 16) | o);
            }
            return new r(n, -2147483648 & n[n.length - 1] ? -1 : 0);
          }),
          (e.j = function (e) {
            if (u(this) || u(e)) return a;
            if (d(this)) return d(e) ? h(this).j(h(e)) : h(h(this).j(e));
            if (d(e)) return h(this.j(h(e)));
            if (0 > this.l(c) && 0 > e.l(c)) return o(this.m() * e.m());
            for (var t = this.g.length + e.g.length, n = [], s = 0; s < 2 * t; s++) n[s] = 0;
            for (s = 0; s < this.g.length; s++)
              for (var i = 0; i < e.g.length; i++) {
                var l = this.i(s) >>> 16,
                  p = 65535 & this.i(s),
                  m = e.i(i) >>> 16,
                  g = 65535 & e.i(i);
                (n[2 * s + 2 * i] += p * g),
                  f(n, 2 * s + 2 * i),
                  (n[2 * s + 2 * i + 1] += l * g),
                  f(n, 2 * s + 2 * i + 1),
                  (n[2 * s + 2 * i + 1] += p * m),
                  f(n, 2 * s + 2 * i + 1),
                  (n[2 * s + 2 * i + 2] += l * m),
                  f(n, 2 * s + 2 * i + 2);
              }
            for (s = 0; s < t; s++) n[s] = (n[2 * s + 1] << 16) | n[2 * s];
            for (s = t; s < 2 * t; s++) n[s] = 0;
            return new r(n, 0);
          }),
          (e.A = function (e) {
            return g(this, e).h;
          }),
          (e.and = function (e) {
            for (var t = Math.max(this.g.length, e.g.length), n = [], s = 0; s < t; s++) n[s] = this.i(s) & e.i(s);
            return new r(n, this.h & e.h);
          }),
          (e.or = function (e) {
            for (var t = Math.max(this.g.length, e.g.length), n = [], s = 0; s < t; s++) n[s] = this.i(s) | e.i(s);
            return new r(n, this.h | e.h);
          }),
          (e.xor = function (e) {
            for (var t = Math.max(this.g.length, e.g.length), n = [], s = 0; s < t; s++) n[s] = this.i(s) ^ e.i(s);
            return new r(n, this.h ^ e.h);
          }),
          (t.prototype.digest = t.prototype.v),
          (t.prototype.reset = t.prototype.s),
          (t.prototype.update = t.prototype.u),
          (Ur = Hr.Md5 = t),
          (r.prototype.add = r.prototype.add),
          (r.prototype.multiply = r.prototype.j),
          (r.prototype.modulo = r.prototype.A),
          (r.prototype.compare = r.prototype.l),
          (r.prototype.toNumber = r.prototype.m),
          (r.prototype.toString = r.prototype.toString),
          (r.prototype.getBits = r.prototype.i),
          (r.fromNumber = o),
          (r.fromString = function e(t, n) {
            if (0 == t.length) throw Error("number format error: empty string");
            if (2 > (n = n || 10) || 36 < n) throw Error("radix out of range: " + n);
            if ("-" == t.charAt(0)) return h(e(t.substring(1), n));
            if (0 <= t.indexOf("-")) throw Error('number format error: interior "-" character');
            for (var r = o(Math.pow(n, 8)), s = a, i = 0; i < t.length; i += 8) {
              var l = Math.min(8, t.length - i),
                c = parseInt(t.substring(i, i + l), n);
              8 > l ? ((l = o(Math.pow(n, l))), (s = s.j(l).add(o(c)))) : (s = (s = s.j(r)).add(o(c)));
            }
            return s;
          }),
          (zr = Hr.Integer = r);
      }).apply(void 0 !== Gr ? Gr : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      var Wr,
        Kr,
        Qr,
        Yr,
        Xr,
        Jr,
        Zr,
        es,
        ts =
          "undefined" != typeof globalThis
            ? globalThis
            : "undefined" != typeof window
            ? window
            : "undefined" != typeof global
            ? global
            : "undefined" != typeof self
            ? self
            : {},
        ns = {};
      (function () {
        var e,
          t =
            "function" == typeof Object.defineProperties
              ? Object.defineProperty
              : function (e, t, n) {
                  return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
                };
        var n = (function (e) {
          e = [
            "object" == typeof globalThis && globalThis,
            e,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof ts && ts,
          ];
          for (var t = 0; t < e.length; ++t) {
            var n = e[t];
            if (n && n.Math == Math) return n;
          }
          throw Error("Cannot find global object");
        })(this);
        !(function (e, r) {
          if (r)
            e: {
              var s = n;
              e = e.split(".");
              for (var i = 0; i < e.length - 1; i++) {
                var o = e[i];
                if (!(o in s)) break e;
                s = s[o];
              }
              (r = r((i = s[(e = e[e.length - 1])]))) != i && null != r && t(s, e, { configurable: !0, writable: !0, value: r });
            }
        })("Array.prototype.values", function (e) {
          return (
            e ||
            function () {
              return (function (e, t) {
                e instanceof String && (e += "");
                var n = 0,
                  r = !1,
                  s = {
                    next: function () {
                      if (!r && n < e.length) {
                        var s = n++;
                        return { value: t(s, e[s]), done: !1 };
                      }
                      return (r = !0), { done: !0, value: void 0 };
                    },
                  };
                return (
                  (s[Symbol.iterator] = function () {
                    return s;
                  }),
                  s
                );
              })(this, function (e, t) {
                return t;
              });
            }
          );
        });
        var r = r || {},
          s = this || self;
        function i(e) {
          var t = typeof e;
          return (
            "array" == (t = "object" != t ? t : e ? (Array.isArray(e) ? "array" : t) : "null") ||
            ("object" == t && "number" == typeof e.length)
          );
        }
        function o(e) {
          var t = typeof e;
          return ("object" == t && null != e) || "function" == t;
        }
        function a(e, t, n) {
          return e.call.apply(e.bind, arguments);
        }
        function l(e, t, n) {
          if (!e) throw Error();
          if (2 < arguments.length) {
            var r = Array.prototype.slice.call(arguments, 2);
            return function () {
              var n = Array.prototype.slice.call(arguments);
              return Array.prototype.unshift.apply(n, r), e.apply(t, n);
            };
          }
          return function () {
            return e.apply(t, arguments);
          };
        }
        function c(e, t, n) {
          return (c = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? a : l).apply(
            null,
            arguments
          );
        }
        function u(e, t) {
          var n = Array.prototype.slice.call(arguments, 1);
          return function () {
            var t = n.slice();
            return t.push.apply(t, arguments), e.apply(this, t);
          };
        }
        function d(e, t) {
          function n() {}
          (n.prototype = t.prototype),
            (e.aa = t.prototype),
            (e.prototype = new n()),
            (e.prototype.constructor = e),
            (e.Qb = function (e, n, r) {
              for (var s = Array(arguments.length - 2), i = 2; i < arguments.length; i++) s[i - 2] = arguments[i];
              return t.prototype[n].apply(e, s);
            });
        }
        function h(e) {
          const t = e.length;
          if (0 < t) {
            const n = Array(t);
            for (let r = 0; r < t; r++) n[r] = e[r];
            return n;
          }
          return [];
        }
        function p(e, t) {
          for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            if (i(n)) {
              const t = e.length || 0,
                r = n.length || 0;
              e.length = t + r;
              for (let s = 0; s < r; s++) e[t + s] = n[s];
            } else e.push(n);
          }
        }
        function f(e) {
          return /^[\s\xa0]*$/.test(e);
        }
        function m() {
          var e = s.navigator;
          return e && (e = e.userAgent) ? e : "";
        }
        function g(e) {
          return g[" "](e), e;
        }
        g[" "] = function () {};
        var y = !(
          -1 == m().indexOf("Gecko") ||
          (-1 != m().toLowerCase().indexOf("webkit") && -1 == m().indexOf("Edge")) ||
          -1 != m().indexOf("Trident") ||
          -1 != m().indexOf("MSIE") ||
          -1 != m().indexOf("Edge")
        );
        function v(e, t, n) {
          for (const r in e) t.call(n, e[r], r, e);
        }
        function w(e) {
          const t = {};
          for (const n in e) t[n] = e[n];
          return t;
        }
        const b = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
        function S(e, t) {
          let n, r;
          for (let t = 1; t < arguments.length; t++) {
            for (n in ((r = arguments[t]), r)) e[n] = r[n];
            for (let t = 0; t < b.length; t++) (n = b[t]), Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }
        function E(e) {
          var t = 1;
          e = e.split(":");
          const n = [];
          for (; 0 < t && e.length; ) n.push(e.shift()), t--;
          return e.length && n.push(e.join(":")), n;
        }
        function T(e) {
          s.setTimeout(() => {
            throw e;
          }, 0);
        }
        function _() {
          var e = k;
          let t = null;
          return e.g && ((t = e.g), (e.g = e.g.next), e.g || (e.h = null), (t.next = null)), t;
        }
        var C = new (class {
          constructor(e, t) {
            (this.i = e), (this.j = t), (this.h = 0), (this.g = null);
          }
          get() {
            let e;
            return 0 < this.h ? (this.h--, (e = this.g), (this.g = e.next), (e.next = null)) : (e = this.i()), e;
          }
        })(
          () => new x(),
          (e) => e.reset()
        );
        class x {
          constructor() {
            this.next = this.g = this.h = null;
          }
          set(e, t) {
            (this.h = e), (this.g = t), (this.next = null);
          }
          reset() {
            this.next = this.g = this.h = null;
          }
        }
        let A,
          I = !1,
          k = new (class {
            constructor() {
              this.h = this.g = null;
            }
            add(e, t) {
              const n = C.get();
              n.set(e, t), this.h ? (this.h.next = n) : (this.g = n), (this.h = n);
            }
          })(),
          L = () => {
            const e = s.Promise.resolve(void 0);
            A = () => {
              e.then(M);
            };
          };
        var M = () => {
          for (var e; (e = _()); ) {
            try {
              e.h.call(e.g);
            } catch (e) {
              T(e);
            }
            var t = C;
            t.j(e), 100 > t.h && (t.h++, (e.next = t.g), (t.g = e));
          }
          I = !1;
        };
        function D() {
          (this.s = this.s), (this.C = this.C);
        }
        function N(e, t) {
          (this.type = e), (this.g = this.target = t), (this.defaultPrevented = !1);
        }
        (D.prototype.s = !1),
          (D.prototype.ma = function () {
            this.s || ((this.s = !0), this.N());
          }),
          (D.prototype.N = function () {
            if (this.C) for (; this.C.length; ) this.C.shift()();
          }),
          (N.prototype.h = function () {
            this.defaultPrevented = !0;
          });
        var P = (function () {
          if (!s.addEventListener || !Object.defineProperty) return !1;
          var e = !1,
            t = Object.defineProperty({}, "passive", {
              get: function () {
                e = !0;
              },
            });
          try {
            const e = () => {};
            s.addEventListener("test", e, t), s.removeEventListener("test", e, t);
          } catch (e) {}
          return e;
        })();
        function O(e, t) {
          if (
            (N.call(this, e ? e.type : ""),
            (this.relatedTarget = this.g = this.target = null),
            (this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0),
            (this.key = ""),
            (this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1),
            (this.state = null),
            (this.pointerId = 0),
            (this.pointerType = ""),
            (this.i = null),
            e)
          ) {
            var n = (this.type = e.type),
              r = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null;
            if (((this.target = e.target || e.srcElement), (this.g = t), (t = e.relatedTarget))) {
              if (y) {
                e: {
                  try {
                    g(t.nodeName);
                    var s = !0;
                    break e;
                  } catch (e) {}
                  s = !1;
                }
                s || (t = null);
              }
            } else "mouseover" == n ? (t = e.fromElement) : "mouseout" == n && (t = e.toElement);
            (this.relatedTarget = t),
              r
                ? ((this.clientX = void 0 !== r.clientX ? r.clientX : r.pageX),
                  (this.clientY = void 0 !== r.clientY ? r.clientY : r.pageY),
                  (this.screenX = r.screenX || 0),
                  (this.screenY = r.screenY || 0))
                : ((this.clientX = void 0 !== e.clientX ? e.clientX : e.pageX),
                  (this.clientY = void 0 !== e.clientY ? e.clientY : e.pageY),
                  (this.screenX = e.screenX || 0),
                  (this.screenY = e.screenY || 0)),
              (this.button = e.button),
              (this.key = e.key || ""),
              (this.ctrlKey = e.ctrlKey),
              (this.altKey = e.altKey),
              (this.shiftKey = e.shiftKey),
              (this.metaKey = e.metaKey),
              (this.pointerId = e.pointerId || 0),
              (this.pointerType = "string" == typeof e.pointerType ? e.pointerType : q[e.pointerType] || ""),
              (this.state = e.state),
              (this.i = e),
              e.defaultPrevented && O.aa.h.call(this);
          }
        }
        d(O, N);
        var q = { 2: "touch", 3: "pen", 4: "mouse" };
        O.prototype.h = function () {
          O.aa.h.call(this);
          var e = this.i;
          e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
        };
        var R = "closure_listenable_" + ((1e6 * Math.random()) | 0),
          F = 0;
        function B(e, t, n, r, s) {
          (this.listener = e),
            (this.proxy = null),
            (this.src = t),
            (this.type = n),
            (this.capture = !!r),
            (this.ha = s),
            (this.key = ++F),
            (this.da = this.fa = !1);
        }
        function $(e) {
          (e.da = !0), (e.listener = null), (e.proxy = null), (e.src = null), (e.ha = null);
        }
        function V(e) {
          (this.src = e), (this.g = {}), (this.h = 0);
        }
        function j(e, t) {
          var n = t.type;
          if (n in e.g) {
            var r,
              s = e.g[n],
              i = Array.prototype.indexOf.call(s, t, void 0);
            (r = 0 <= i) && Array.prototype.splice.call(s, i, 1), r && ($(t), 0 == e.g[n].length && (delete e.g[n], e.h--));
          }
        }
        function z(e, t, n, r) {
          for (var s = 0; s < e.length; ++s) {
            var i = e[s];
            if (!i.da && i.listener == t && i.capture == !!n && i.ha == r) return s;
          }
          return -1;
        }
        V.prototype.add = function (e, t, n, r, s) {
          var i = e.toString();
          (e = this.g[i]) || ((e = this.g[i] = []), this.h++);
          var o = z(e, t, r, s);
          return -1 < o ? ((t = e[o]), n || (t.fa = !1)) : (((t = new B(t, this.src, i, !!r, s)).fa = n), e.push(t)), t;
        };
        var U = "closure_lm_" + ((1e6 * Math.random()) | 0),
          G = {};
        function H(e, t, n, r, s) {
          if (r && r.once) return K(e, t, n, r, s);
          if (Array.isArray(t)) {
            for (var i = 0; i < t.length; i++) H(e, t[i], n, r, s);
            return null;
          }
          return (n = te(n)), e && e[R] ? e.K(t, n, o(r) ? !!r.capture : !!r, s) : W(e, t, n, !1, r, s);
        }
        function W(e, t, n, r, s, i) {
          if (!t) throw Error("Invalid event type");
          var a = o(s) ? !!s.capture : !!s,
            l = Z(e);
          if ((l || (e[U] = l = new V(e)), (n = l.add(t, n, r, a, i)).proxy)) return n;
          if (
            ((r = (function () {
              function e(n) {
                return t.call(e.src, e.listener, n);
              }
              const t = J;
              return e;
            })()),
            (n.proxy = r),
            (r.src = e),
            (r.listener = n),
            e.addEventListener)
          )
            P || (s = a), void 0 === s && (s = !1), e.addEventListener(t.toString(), r, s);
          else if (e.attachEvent) e.attachEvent(X(t.toString()), r);
          else {
            if (!e.addListener || !e.removeListener) throw Error("addEventListener and attachEvent are unavailable.");
            e.addListener(r);
          }
          return n;
        }
        function K(e, t, n, r, s) {
          if (Array.isArray(t)) {
            for (var i = 0; i < t.length; i++) K(e, t[i], n, r, s);
            return null;
          }
          return (n = te(n)), e && e[R] ? e.L(t, n, o(r) ? !!r.capture : !!r, s) : W(e, t, n, !0, r, s);
        }
        function Q(e, t, n, r, s) {
          if (Array.isArray(t)) for (var i = 0; i < t.length; i++) Q(e, t[i], n, r, s);
          else
            (r = o(r) ? !!r.capture : !!r),
              (n = te(n)),
              e && e[R]
                ? ((e = e.i),
                  (t = String(t).toString()) in e.g &&
                    -1 < (n = z((i = e.g[t]), n, r, s)) &&
                    ($(i[n]), Array.prototype.splice.call(i, n, 1), 0 == i.length && (delete e.g[t], e.h--)))
                : e && (e = Z(e)) && ((t = e.g[t.toString()]), (e = -1), t && (e = z(t, n, r, s)), (n = -1 < e ? t[e] : null) && Y(n));
        }
        function Y(e) {
          if ("number" != typeof e && e && !e.da) {
            var t = e.src;
            if (t && t[R]) j(t.i, e);
            else {
              var n = e.type,
                r = e.proxy;
              t.removeEventListener
                ? t.removeEventListener(n, r, e.capture)
                : t.detachEvent
                ? t.detachEvent(X(n), r)
                : t.addListener && t.removeListener && t.removeListener(r),
                (n = Z(t)) ? (j(n, e), 0 == n.h && ((n.src = null), (t[U] = null))) : $(e);
            }
          }
        }
        function X(e) {
          return e in G ? G[e] : (G[e] = "on" + e);
        }
        function J(e, t) {
          if (e.da) e = !0;
          else {
            t = new O(t, this);
            var n = e.listener,
              r = e.ha || e.src;
            e.fa && Y(e), (e = n.call(r, t));
          }
          return e;
        }
        function Z(e) {
          return (e = e[U]) instanceof V ? e : null;
        }
        var ee = "__closure_events_fn_" + ((1e9 * Math.random()) >>> 0);
        function te(e) {
          return "function" == typeof e
            ? e
            : (e[ee] ||
                (e[ee] = function (t) {
                  return e.handleEvent(t);
                }),
              e[ee]);
        }
        function ne() {
          D.call(this), (this.i = new V(this)), (this.M = this), (this.F = null);
        }
        function re(e, t) {
          var n,
            r = e.F;
          if (r) for (n = []; r; r = r.F) n.push(r);
          if (((e = e.M), (r = t.type || t), "string" == typeof t)) t = new N(t, e);
          else if (t instanceof N) t.target = t.target || e;
          else {
            var s = t;
            S((t = new N(r, e)), s);
          }
          if (((s = !0), n))
            for (var i = n.length - 1; 0 <= i; i--) {
              var o = (t.g = n[i]);
              s = se(o, r, !0, t) && s;
            }
          if (((s = se((o = t.g = e), r, !0, t) && s), (s = se(o, r, !1, t) && s), n))
            for (i = 0; i < n.length; i++) s = se((o = t.g = n[i]), r, !1, t) && s;
        }
        function se(e, t, n, r) {
          if (!(t = e.i.g[String(t)])) return !0;
          t = t.concat();
          for (var s = !0, i = 0; i < t.length; ++i) {
            var o = t[i];
            if (o && !o.da && o.capture == n) {
              var a = o.listener,
                l = o.ha || o.src;
              o.fa && j(e.i, o), (s = !1 !== a.call(l, r) && s);
            }
          }
          return s && !r.defaultPrevented;
        }
        function ie(e, t, n) {
          if ("function" == typeof e) n && (e = c(e, n));
          else {
            if (!e || "function" != typeof e.handleEvent) throw Error("Invalid listener argument");
            e = c(e.handleEvent, e);
          }
          return 2147483647 < Number(t) ? -1 : s.setTimeout(e, t || 0);
        }
        function oe(e) {
          e.g = ie(() => {
            (e.g = null), e.i && ((e.i = !1), oe(e));
          }, e.l);
          const t = e.h;
          (e.h = null), e.m.apply(null, t);
        }
        d(ne, D),
          (ne.prototype[R] = !0),
          (ne.prototype.removeEventListener = function (e, t, n, r) {
            Q(this, e, t, n, r);
          }),
          (ne.prototype.N = function () {
            if ((ne.aa.N.call(this), this.i)) {
              var e,
                t = this.i;
              for (e in t.g) {
                for (var n = t.g[e], r = 0; r < n.length; r++) $(n[r]);
                delete t.g[e], t.h--;
              }
            }
            this.F = null;
          }),
          (ne.prototype.K = function (e, t, n, r) {
            return this.i.add(String(e), t, !1, n, r);
          }),
          (ne.prototype.L = function (e, t, n, r) {
            return this.i.add(String(e), t, !0, n, r);
          });
        class ae extends D {
          constructor(e, t) {
            super(), (this.m = e), (this.l = t), (this.h = null), (this.i = !1), (this.g = null);
          }
          j(e) {
            (this.h = arguments), this.g ? (this.i = !0) : oe(this);
          }
          N() {
            super.N(), this.g && (s.clearTimeout(this.g), (this.g = null), (this.i = !1), (this.h = null));
          }
        }
        function le(e) {
          D.call(this), (this.h = e), (this.g = {});
        }
        d(le, D);
        var ce = [];
        function ue(e) {
          v(
            e.g,
            function (e, t) {
              this.g.hasOwnProperty(t) && Y(e);
            },
            e
          ),
            (e.g = {});
        }
        (le.prototype.N = function () {
          le.aa.N.call(this), ue(this);
        }),
          (le.prototype.handleEvent = function () {
            throw Error("EventHandler.handleEvent not implemented");
          });
        var de = s.JSON.stringify,
          he = s.JSON.parse,
          pe = class {
            stringify(e) {
              return s.JSON.stringify(e, void 0);
            }
            parse(e) {
              return s.JSON.parse(e, void 0);
            }
          };
        function fe() {}
        function me(e) {
          return e.h || (e.h = e.i());
        }
        function ge() {}
        fe.prototype.h = null;
        var ye = { OPEN: "a", kb: "b", Ja: "c", wb: "d" };
        function ve() {
          N.call(this, "d");
        }
        function we() {
          N.call(this, "c");
        }
        d(ve, N), d(we, N);
        var be = {},
          Se = null;
        function Ee() {
          return (Se = Se || new ne());
        }
        function Te(e) {
          N.call(this, be.La, e);
        }
        function _e(e) {
          const t = Ee();
          re(t, new Te(t));
        }
        function Ce(e, t) {
          N.call(this, be.STAT_EVENT, e), (this.stat = t);
        }
        function xe(e) {
          const t = Ee();
          re(t, new Ce(t, e));
        }
        function Ae(e, t) {
          N.call(this, be.Ma, e), (this.size = t);
        }
        function Ie(e, t) {
          if ("function" != typeof e) throw Error("Fn must not be null and must be a function");
          return s.setTimeout(function () {
            e();
          }, t);
        }
        function ke() {
          this.g = !0;
        }
        function Le(e, t, n, r) {
          e.info(function () {
            return (
              "XMLHTTP TEXT (" +
              t +
              "): " +
              (function (e, t) {
                if (!e.g) return t;
                if (!t) return null;
                try {
                  var n = JSON.parse(t);
                  if (n)
                    for (e = 0; e < n.length; e++)
                      if (Array.isArray(n[e])) {
                        var r = n[e];
                        if (!(2 > r.length)) {
                          var s = r[1];
                          if (Array.isArray(s) && !(1 > s.length)) {
                            var i = s[0];
                            if ("noop" != i && "stop" != i && "close" != i) for (var o = 1; o < s.length; o++) s[o] = "";
                          }
                        }
                      }
                  return de(n);
                } catch (e) {
                  return t;
                }
              })(e, n) +
              (r ? " " + r : "")
            );
          });
        }
        (be.La = "serverreachability"),
          d(Te, N),
          (be.STAT_EVENT = "statevent"),
          d(Ce, N),
          (be.Ma = "timingevent"),
          d(Ae, N),
          (ke.prototype.xa = function () {
            this.g = !1;
          }),
          (ke.prototype.info = function () {});
        var Me,
          De = { NO_ERROR: 0, gb: 1, tb: 2, sb: 3, nb: 4, rb: 5, ub: 6, Ia: 7, TIMEOUT: 8, xb: 9 },
          Ne = {
            lb: "complete",
            Hb: "success",
            Ja: "error",
            Ia: "abort",
            zb: "ready",
            Ab: "readystatechange",
            TIMEOUT: "timeout",
            vb: "incrementaldata",
            yb: "progress",
            ob: "downloadprogress",
            Pb: "uploadprogress",
          };
        function Pe() {}
        function Oe(e, t, n, r) {
          (this.j = e),
            (this.i = t),
            (this.l = n),
            (this.R = r || 1),
            (this.U = new le(this)),
            (this.I = 45e3),
            (this.H = null),
            (this.o = !1),
            (this.m = this.A = this.v = this.L = this.F = this.S = this.B = null),
            (this.D = []),
            (this.g = null),
            (this.C = 0),
            (this.s = this.u = null),
            (this.X = -1),
            (this.J = !1),
            (this.O = 0),
            (this.M = null),
            (this.W = this.K = this.T = this.P = !1),
            (this.h = new qe());
        }
        function qe() {
          (this.i = null), (this.g = ""), (this.h = !1);
        }
        d(Pe, fe),
          (Pe.prototype.g = function () {
            return new XMLHttpRequest();
          }),
          (Pe.prototype.i = function () {
            return {};
          }),
          (Me = new Pe());
        var Re = {},
          Fe = {};
        function Be(e, t, n) {
          (e.L = 1), (e.v = dt(ot(t))), (e.m = n), (e.P = !0), $e(e, null);
        }
        function $e(e, t) {
          (e.F = Date.now()), ze(e), (e.A = ot(e.v));
          var n = e.A,
            r = e.R;
          Array.isArray(r) || (r = [String(r)]),
            Ct(n.i, "t", r),
            (e.C = 0),
            (n = e.j.J),
            (e.h = new qe()),
            (e.g = pn(e.j, n ? t : null, !e.m)),
            0 < e.O && (e.M = new ae(c(e.Y, e, e.g), e.O)),
            (t = e.U),
            (n = e.g),
            (r = e.ca);
          var s = "readystatechange";
          Array.isArray(s) || (s && (ce[0] = s.toString()), (s = ce));
          for (var i = 0; i < s.length; i++) {
            var o = H(n, s[i], r || t.handleEvent, !1, t.h || t);
            if (!o) break;
            t.g[o.key] = o;
          }
          (t = e.H ? w(e.H) : {}),
            e.m
              ? (e.u || (e.u = "POST"), (t["Content-Type"] = "application/x-www-form-urlencoded"), e.g.ea(e.A, e.u, e.m, t))
              : ((e.u = "GET"), e.g.ea(e.A, e.u, null, t)),
            _e(),
            (function (e, t, n, r, s, i) {
              e.info(function () {
                if (e.g)
                  if (i)
                    for (var o = "", a = i.split("&"), l = 0; l < a.length; l++) {
                      var c = a[l].split("=");
                      if (1 < c.length) {
                        var u = c[0];
                        c = c[1];
                        var d = u.split("_");
                        o = 2 <= d.length && "type" == d[1] ? o + (u + "=") + c + "&" : o + (u + "=redacted&");
                      }
                    }
                  else o = null;
                else o = i;
                return "XMLHTTP REQ (" + r + ") [attempt " + s + "]: " + t + "\n" + n + "\n" + o;
              });
            })(e.i, e.u, e.A, e.l, e.R, e.m);
        }
        function Ve(e) {
          return !!e.g && "GET" == e.u && 2 != e.L && e.j.Ca;
        }
        function je(e, t) {
          var n = e.C,
            r = t.indexOf("\n", n);
          return -1 == r
            ? Fe
            : ((n = Number(t.substring(n, r))), isNaN(n) ? Re : (r += 1) + n > t.length ? Fe : ((t = t.slice(r, r + n)), (e.C = r + n), t));
        }
        function ze(e) {
          (e.S = Date.now() + e.I), Ue(e, e.I);
        }
        function Ue(e, t) {
          if (null != e.B) throw Error("WatchDog timer not null");
          e.B = Ie(c(e.ba, e), t);
        }
        function Ge(e) {
          e.B && (s.clearTimeout(e.B), (e.B = null));
        }
        function He(e) {
          0 == e.j.G || e.J || ln(e.j, e);
        }
        function We(e) {
          Ge(e);
          var t = e.M;
          t && "function" == typeof t.ma && t.ma(), (e.M = null), ue(e.U), e.g && ((t = e.g), (e.g = null), t.abort(), t.ma());
        }
        function Ke(e, t) {
          try {
            var n = e.j;
            if (0 != n.G && (n.g == e || Ze(n.h, e)))
              if (!e.K && Ze(n.h, e) && 3 == n.G) {
                try {
                  var r = n.Da.g.parse(t);
                } catch (e) {
                  r = null;
                }
                if (Array.isArray(r) && 3 == r.length) {
                  var s = r;
                  if (0 == s[0]) {
                    e: if (!n.u) {
                      if (n.g) {
                        if (!(n.g.F + 3e3 < e.F)) break e;
                        an(n), Yt(n);
                      }
                      rn(n), xe(18);
                    }
                  } else (n.za = s[1]), 0 < n.za - n.T && 37500 > s[2] && n.F && 0 == n.v && !n.C && (n.C = Ie(c(n.Za, n), 6e3));
                  if (1 >= Je(n.h) && n.ca) {
                    try {
                      n.ca();
                    } catch (e) {}
                    n.ca = void 0;
                  }
                } else un(n, 11);
              } else if (((e.K || n.g == e) && an(n), !f(t)))
                for (s = n.Da.g.parse(t), t = 0; t < s.length; t++) {
                  let c = s[t];
                  if (((n.T = c[0]), (c = c[1]), 2 == n.G))
                    if ("c" == c[0]) {
                      (n.K = c[1]), (n.ia = c[2]);
                      const t = c[3];
                      null != t && ((n.la = t), n.j.info("VER=" + n.la));
                      const s = c[4];
                      null != s && ((n.Aa = s), n.j.info("SVER=" + n.Aa));
                      const u = c[5];
                      null != u &&
                        "number" == typeof u &&
                        0 < u &&
                        ((r = 1.5 * u), (n.L = r), n.j.info("backChannelRequestTimeoutMs_=" + r)),
                        (r = n);
                      const d = e.g;
                      if (d) {
                        const e = d.g ? d.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                        if (e) {
                          var i = r.h;
                          i.g ||
                            (-1 == e.indexOf("spdy") && -1 == e.indexOf("quic") && -1 == e.indexOf("h2")) ||
                            ((i.j = i.l), (i.g = new Set()), i.h && (et(i, i.h), (i.h = null)));
                        }
                        if (r.D) {
                          const e = d.g ? d.g.getResponseHeader("X-HTTP-Session-Id") : null;
                          e && ((r.ya = e), ut(r.I, r.D, e));
                        }
                      }
                      (n.G = 3), n.l && n.l.ua(), n.ba && ((n.R = Date.now() - e.F), n.j.info("Handshake RTT: " + n.R + "ms"));
                      var o = e;
                      if ((((r = n).qa = hn(r, r.J ? r.ia : null, r.W)), o.K)) {
                        tt(r.h, o);
                        var a = o,
                          l = r.L;
                        l && (a.I = l), a.B && (Ge(a), ze(a)), (r.g = o);
                      } else nn(r);
                      0 < n.i.length && Jt(n);
                    } else ("stop" != c[0] && "close" != c[0]) || un(n, 7);
                  else
                    3 == n.G &&
                      ("stop" == c[0] || "close" == c[0] ? ("stop" == c[0] ? un(n, 7) : Qt(n)) : "noop" != c[0] && n.l && n.l.ta(c),
                      (n.v = 0));
                }
            _e();
          } catch (e) {}
        }
        (Oe.prototype.ca = function (e) {
          e = e.target;
          const t = this.M;
          t && 3 == Gt(e) ? t.j() : this.Y(e);
        }),
          (Oe.prototype.Y = function (e) {
            try {
              if (e == this.g)
                e: {
                  const h = Gt(this.g);
                  var t = this.g.Ba();
                  this.g.Z();
                  if (!(3 > h) && (3 != h || (this.g && (this.h.h || this.g.oa() || Ht(this.g))))) {
                    this.J || 4 != h || 7 == t || _e(), Ge(this);
                    var n = this.g.Z();
                    this.X = n;
                    t: if (Ve(this)) {
                      var r = Ht(this.g);
                      e = "";
                      var i = r.length,
                        o = 4 == Gt(this.g);
                      if (!this.h.i) {
                        if ("undefined" == typeof TextDecoder) {
                          We(this), He(this);
                          var a = "";
                          break t;
                        }
                        this.h.i = new s.TextDecoder();
                      }
                      for (t = 0; t < i; t++) (this.h.h = !0), (e += this.h.i.decode(r[t], { stream: !(o && t == i - 1) }));
                      (r.length = 0), (this.h.g += e), (this.C = 0), (a = this.h.g);
                    } else a = this.g.oa();
                    if (
                      ((this.o = 200 == n),
                      (function (e, t, n, r, s, i, o) {
                        e.info(function () {
                          return "XMLHTTP RESP (" + r + ") [ attempt " + s + "]: " + t + "\n" + n + "\n" + i + " " + o;
                        });
                      })(this.i, this.u, this.A, this.l, this.R, h, n),
                      this.o)
                    ) {
                      if (this.T && !this.K) {
                        t: {
                          if (this.g) {
                            var l,
                              c = this.g;
                            if ((l = c.g ? c.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !f(l)) {
                              var u = l;
                              break t;
                            }
                          }
                          u = null;
                        }
                        if (!(n = u)) {
                          (this.o = !1), (this.s = 3), xe(12), We(this), He(this);
                          break e;
                        }
                        Le(this.i, this.l, n, "Initial handshake response via X-HTTP-Initial-Response"), (this.K = !0), Ke(this, n);
                      }
                      if (this.P) {
                        let e;
                        for (n = !0; !this.J && this.C < a.length; ) {
                          if (((e = je(this, a)), e == Fe)) {
                            4 == h && ((this.s = 4), xe(14), (n = !1)), Le(this.i, this.l, null, "[Incomplete Response]");
                            break;
                          }
                          if (e == Re) {
                            (this.s = 4), xe(15), Le(this.i, this.l, a, "[Invalid Chunk]"), (n = !1);
                            break;
                          }
                          Le(this.i, this.l, e, null), Ke(this, e);
                        }
                        if (
                          (Ve(this) && 0 != this.C && ((this.h.g = this.h.g.slice(this.C)), (this.C = 0)),
                          4 != h || 0 != a.length || this.h.h || ((this.s = 1), xe(16), (n = !1)),
                          (this.o = this.o && n),
                          n)
                        ) {
                          if (0 < a.length && !this.W) {
                            this.W = !0;
                            var d = this.j;
                            d.g == this &&
                              d.ba &&
                              !d.M &&
                              (d.j.info("Great, no buffering proxy detected. Bytes received: " + a.length), sn(d), (d.M = !0), xe(11));
                          }
                        } else Le(this.i, this.l, a, "[Invalid Chunked Response]"), We(this), He(this);
                      } else Le(this.i, this.l, a, null), Ke(this, a);
                      4 == h && We(this), this.o && !this.J && (4 == h ? ln(this.j, this) : ((this.o = !1), ze(this)));
                    } else
                      (function (e) {
                        const t = {};
                        e = ((e.g && 2 <= Gt(e) && e.g.getAllResponseHeaders()) || "").split("\r\n");
                        for (let r = 0; r < e.length; r++) {
                          if (f(e[r])) continue;
                          var n = E(e[r]);
                          const s = n[0];
                          if ("string" != typeof (n = n[1])) continue;
                          n = n.trim();
                          const i = t[s] || [];
                          (t[s] = i), i.push(n);
                        }
                        !(function (e, t) {
                          for (const n in e) t.call(void 0, e[n], n, e);
                        })(t, function (e) {
                          return e.join(", ");
                        });
                      })(this.g),
                        400 == n && 0 < a.indexOf("Unknown SID") ? ((this.s = 3), xe(12)) : ((this.s = 0), xe(13)),
                        We(this),
                        He(this);
                  }
                }
            } catch (e) {}
          }),
          (Oe.prototype.cancel = function () {
            (this.J = !0), We(this);
          }),
          (Oe.prototype.ba = function () {
            this.B = null;
            const e = Date.now();
            0 <= e - this.S
              ? ((function (e, t) {
                  e.info(function () {
                    return "TIMEOUT: " + t;
                  });
                })(this.i, this.A),
                2 != this.L && (_e(), xe(17)),
                We(this),
                (this.s = 2),
                He(this))
              : Ue(this, this.S - e);
          });
        var Qe = class {
          constructor(e, t) {
            (this.g = e), (this.map = t);
          }
        };
        function Ye(e) {
          (this.l = e || 10),
            s.PerformanceNavigationTiming
              ? (e =
                  0 < (e = s.performance.getEntriesByType("navigation")).length &&
                  ("hq" == e[0].nextHopProtocol || "h2" == e[0].nextHopProtocol))
              : (e = !!(s.chrome && s.chrome.loadTimes && s.chrome.loadTimes() && s.chrome.loadTimes().wasFetchedViaSpdy)),
            (this.j = e ? this.l : 1),
            (this.g = null),
            1 < this.j && (this.g = new Set()),
            (this.h = null),
            (this.i = []);
        }
        function Xe(e) {
          return !!e.h || (!!e.g && e.g.size >= e.j);
        }
        function Je(e) {
          return e.h ? 1 : e.g ? e.g.size : 0;
        }
        function Ze(e, t) {
          return e.h ? e.h == t : !!e.g && e.g.has(t);
        }
        function et(e, t) {
          e.g ? e.g.add(t) : (e.h = t);
        }
        function tt(e, t) {
          e.h && e.h == t ? (e.h = null) : e.g && e.g.has(t) && e.g.delete(t);
        }
        function nt(e) {
          if (null != e.h) return e.i.concat(e.h.D);
          if (null != e.g && 0 !== e.g.size) {
            let t = e.i;
            for (const n of e.g.values()) t = t.concat(n.D);
            return t;
          }
          return h(e.i);
        }
        function rt(e, t) {
          if (e.forEach && "function" == typeof e.forEach) e.forEach(t, void 0);
          else if (i(e) || "string" == typeof e) Array.prototype.forEach.call(e, t, void 0);
          else
            for (
              var n = (function (e) {
                  if (e.na && "function" == typeof e.na) return e.na();
                  if (!e.V || "function" != typeof e.V) {
                    if ("undefined" != typeof Map && e instanceof Map) return Array.from(e.keys());
                    if (!("undefined" != typeof Set && e instanceof Set)) {
                      if (i(e) || "string" == typeof e) {
                        var t = [];
                        e = e.length;
                        for (var n = 0; n < e; n++) t.push(n);
                        return t;
                      }
                      (t = []), (n = 0);
                      for (const r in e) t[n++] = r;
                      return t;
                    }
                  }
                })(e),
                r = (function (e) {
                  if (e.V && "function" == typeof e.V) return e.V();
                  if (("undefined" != typeof Map && e instanceof Map) || ("undefined" != typeof Set && e instanceof Set))
                    return Array.from(e.values());
                  if ("string" == typeof e) return e.split("");
                  if (i(e)) {
                    for (var t = [], n = e.length, r = 0; r < n; r++) t.push(e[r]);
                    return t;
                  }
                  for (r in ((t = []), (n = 0), e)) t[n++] = e[r];
                  return t;
                })(e),
                s = r.length,
                o = 0;
              o < s;
              o++
            )
              t.call(void 0, r[o], n && n[o], e);
        }
        Ye.prototype.cancel = function () {
          if (((this.i = nt(this)), this.h)) this.h.cancel(), (this.h = null);
          else if (this.g && 0 !== this.g.size) {
            for (const e of this.g.values()) e.cancel();
            this.g.clear();
          }
        };
        var st = RegExp(
          "^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$"
        );
        function it(e) {
          if (((this.g = this.o = this.j = ""), (this.s = null), (this.m = this.l = ""), (this.h = !1), e instanceof it)) {
            (this.h = e.h), at(this, e.j), (this.o = e.o), (this.g = e.g), lt(this, e.s), (this.l = e.l);
            var t = e.i,
              n = new St();
            (n.i = t.i), t.g && ((n.g = new Map(t.g)), (n.h = t.h)), ct(this, n), (this.m = e.m);
          } else
            e && (t = String(e).match(st))
              ? ((this.h = !1),
                at(this, t[1] || "", !0),
                (this.o = ht(t[2] || "")),
                (this.g = ht(t[3] || "", !0)),
                lt(this, t[4]),
                (this.l = ht(t[5] || "", !0)),
                ct(this, t[6] || "", !0),
                (this.m = ht(t[7] || "")))
              : ((this.h = !1), (this.i = new St(null, this.h)));
        }
        function ot(e) {
          return new it(e);
        }
        function at(e, t, n) {
          (e.j = n ? ht(t, !0) : t), e.j && (e.j = e.j.replace(/:$/, ""));
        }
        function lt(e, t) {
          if (t) {
            if (((t = Number(t)), isNaN(t) || 0 > t)) throw Error("Bad port number " + t);
            e.s = t;
          } else e.s = null;
        }
        function ct(e, t, n) {
          t instanceof St
            ? ((e.i = t),
              (function (e, t) {
                t &&
                  !e.j &&
                  (Et(e),
                  (e.i = null),
                  e.g.forEach(function (e, t) {
                    var n = t.toLowerCase();
                    t != n && (Tt(this, t), Ct(this, n, e));
                  }, e)),
                  (e.j = t);
              })(e.i, e.h))
            : (n || (t = pt(t, wt)), (e.i = new St(t, e.h)));
        }
        function ut(e, t, n) {
          e.i.set(t, n);
        }
        function dt(e) {
          return (
            ut(
              e,
              "zx",
              Math.floor(2147483648 * Math.random()).toString(36) +
                Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)
            ),
            e
          );
        }
        function ht(e, t) {
          return e ? (t ? decodeURI(e.replace(/%25/g, "%2525")) : decodeURIComponent(e)) : "";
        }
        function pt(e, t, n) {
          return "string" == typeof e ? ((e = encodeURI(e).replace(t, ft)), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
        }
        function ft(e) {
          return "%" + (((e = e.charCodeAt(0)) >> 4) & 15).toString(16) + (15 & e).toString(16);
        }
        it.prototype.toString = function () {
          var e = [],
            t = this.j;
          t && e.push(pt(t, gt, !0), ":");
          var n = this.g;
          return (
            (n || "file" == t) &&
              (e.push("//"),
              (t = this.o) && e.push(pt(t, gt, !0), "@"),
              e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")),
              null != (n = this.s) && e.push(":", String(n))),
            (n = this.l) && (this.g && "/" != n.charAt(0) && e.push("/"), e.push(pt(n, "/" == n.charAt(0) ? vt : yt, !0))),
            (n = this.i.toString()) && e.push("?", n),
            (n = this.m) && e.push("#", pt(n, bt)),
            e.join("")
          );
        };
        var mt,
          gt = /[#\/\?@]/g,
          yt = /[#\?:]/g,
          vt = /[#\?]/g,
          wt = /[#\?@]/g,
          bt = /#/g;
        function St(e, t) {
          (this.h = this.g = null), (this.i = e || null), (this.j = !!t);
        }
        function Et(e) {
          e.g ||
            ((e.g = new Map()),
            (e.h = 0),
            e.i &&
              (function (e, t) {
                if (e) {
                  e = e.split("&");
                  for (var n = 0; n < e.length; n++) {
                    var r = e[n].indexOf("="),
                      s = null;
                    if (0 <= r) {
                      var i = e[n].substring(0, r);
                      s = e[n].substring(r + 1);
                    } else i = e[n];
                    t(i, s ? decodeURIComponent(s.replace(/\+/g, " ")) : "");
                  }
                }
              })(e.i, function (t, n) {
                e.add(decodeURIComponent(t.replace(/\+/g, " ")), n);
              }));
        }
        function Tt(e, t) {
          Et(e), (t = xt(e, t)), e.g.has(t) && ((e.i = null), (e.h -= e.g.get(t).length), e.g.delete(t));
        }
        function _t(e, t) {
          return Et(e), (t = xt(e, t)), e.g.has(t);
        }
        function Ct(e, t, n) {
          Tt(e, t), 0 < n.length && ((e.i = null), e.g.set(xt(e, t), h(n)), (e.h += n.length));
        }
        function xt(e, t) {
          return (t = String(t)), e.j && (t = t.toLowerCase()), t;
        }
        function At(e, t, n, r, s) {
          try {
            s && ((s.onload = null), (s.onerror = null), (s.onabort = null), (s.ontimeout = null)), r(n);
          } catch (e) {}
        }
        function It() {
          this.g = new pe();
        }
        function kt(e, t, n) {
          const r = n || "";
          try {
            rt(e, function (e, n) {
              let s = e;
              o(e) && (s = de(e)), t.push(r + n + "=" + encodeURIComponent(s));
            });
          } catch (e) {
            throw (t.push(r + "type=" + encodeURIComponent("_badmap")), e);
          }
        }
        function Lt(e) {
          (this.l = e.Ub || null), (this.j = e.eb || !1);
        }
        function Mt(e, t) {
          ne.call(this),
            (this.D = e),
            (this.o = t),
            (this.m = void 0),
            (this.status = this.readyState = 0),
            (this.responseType = this.responseText = this.response = this.statusText = ""),
            (this.onreadystatechange = null),
            (this.u = new Headers()),
            (this.h = null),
            (this.B = "GET"),
            (this.A = ""),
            (this.g = !1),
            (this.v = this.j = this.l = null);
        }
        function Dt(e) {
          e.j.read().then(e.Pa.bind(e)).catch(e.ga.bind(e));
        }
        function Nt(e) {
          (e.readyState = 4), (e.l = null), (e.j = null), (e.v = null), Pt(e);
        }
        function Pt(e) {
          e.onreadystatechange && e.onreadystatechange.call(e);
        }
        function Ot(e) {
          let t = "";
          return (
            v(e, function (e, n) {
              (t += n), (t += ":"), (t += e), (t += "\r\n");
            }),
            t
          );
        }
        function qt(e, t, n) {
          e: {
            for (r in n) {
              var r = !1;
              break e;
            }
            r = !0;
          }
          r || ((n = Ot(n)), "string" == typeof e ? null != n && encodeURIComponent(String(n)) : ut(e, t, n));
        }
        function Rt(e) {
          ne.call(this),
            (this.headers = new Map()),
            (this.o = e || null),
            (this.h = !1),
            (this.v = this.g = null),
            (this.D = ""),
            (this.m = 0),
            (this.l = ""),
            (this.j = this.B = this.u = this.A = !1),
            (this.I = null),
            (this.H = ""),
            (this.J = !1);
        }
        ((e = St.prototype).add = function (e, t) {
          Et(this), (this.i = null), (e = xt(this, e));
          var n = this.g.get(e);
          return n || this.g.set(e, (n = [])), n.push(t), (this.h += 1), this;
        }),
          (e.forEach = function (e, t) {
            Et(this),
              this.g.forEach(function (n, r) {
                n.forEach(function (n) {
                  e.call(t, n, r, this);
                }, this);
              }, this);
          }),
          (e.na = function () {
            Et(this);
            const e = Array.from(this.g.values()),
              t = Array.from(this.g.keys()),
              n = [];
            for (let r = 0; r < t.length; r++) {
              const s = e[r];
              for (let e = 0; e < s.length; e++) n.push(t[r]);
            }
            return n;
          }),
          (e.V = function (e) {
            Et(this);
            let t = [];
            if ("string" == typeof e) _t(this, e) && (t = t.concat(this.g.get(xt(this, e))));
            else {
              e = Array.from(this.g.values());
              for (let n = 0; n < e.length; n++) t = t.concat(e[n]);
            }
            return t;
          }),
          (e.set = function (e, t) {
            return (
              Et(this),
              (this.i = null),
              _t(this, (e = xt(this, e))) && (this.h -= this.g.get(e).length),
              this.g.set(e, [t]),
              (this.h += 1),
              this
            );
          }),
          (e.get = function (e, t) {
            return e && 0 < (e = this.V(e)).length ? String(e[0]) : t;
          }),
          (e.toString = function () {
            if (this.i) return this.i;
            if (!this.g) return "";
            const e = [],
              t = Array.from(this.g.keys());
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              const i = encodeURIComponent(String(r)),
                o = this.V(r);
              for (r = 0; r < o.length; r++) {
                var s = i;
                "" !== o[r] && (s += "=" + encodeURIComponent(String(o[r]))), e.push(s);
              }
            }
            return (this.i = e.join("&"));
          }),
          d(Lt, fe),
          (Lt.prototype.g = function () {
            return new Mt(this.l, this.j);
          }),
          (Lt.prototype.i =
            ((mt = {}),
            function () {
              return mt;
            })),
          d(Mt, ne),
          ((e = Mt.prototype).open = function (e, t) {
            if (0 != this.readyState) throw (this.abort(), Error("Error reopening a connection"));
            (this.B = e), (this.A = t), (this.readyState = 1), Pt(this);
          }),
          (e.send = function (e) {
            if (1 != this.readyState) throw (this.abort(), Error("need to call open() first. "));
            this.g = !0;
            const t = { headers: this.u, method: this.B, credentials: this.m, cache: void 0 };
            e && (t.body = e), (this.D || s).fetch(new Request(this.A, t)).then(this.Sa.bind(this), this.ga.bind(this));
          }),
          (e.abort = function () {
            (this.response = this.responseText = ""),
              (this.u = new Headers()),
              (this.status = 0),
              this.j && this.j.cancel("Request was aborted.").catch(() => {}),
              1 <= this.readyState && this.g && 4 != this.readyState && ((this.g = !1), Nt(this)),
              (this.readyState = 0);
          }),
          (e.Sa = function (e) {
            if (
              this.g &&
              ((this.l = e),
              this.h ||
                ((this.status = this.l.status),
                (this.statusText = this.l.statusText),
                (this.h = e.headers),
                (this.readyState = 2),
                Pt(this)),
              this.g && ((this.readyState = 3), Pt(this), this.g))
            )
              if ("arraybuffer" === this.responseType) e.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
              else if (void 0 !== s.ReadableStream && "body" in e) {
                if (((this.j = e.body.getReader()), this.o)) {
                  if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                  this.response = [];
                } else (this.response = this.responseText = ""), (this.v = new TextDecoder());
                Dt(this);
              } else e.text().then(this.Ra.bind(this), this.ga.bind(this));
          }),
          (e.Pa = function (e) {
            if (this.g) {
              if (this.o && e.value) this.response.push(e.value);
              else if (!this.o) {
                var t = e.value ? e.value : new Uint8Array(0);
                (t = this.v.decode(t, { stream: !e.done })) && (this.response = this.responseText += t);
              }
              e.done ? Nt(this) : Pt(this), 3 == this.readyState && Dt(this);
            }
          }),
          (e.Ra = function (e) {
            this.g && ((this.response = this.responseText = e), Nt(this));
          }),
          (e.Qa = function (e) {
            this.g && ((this.response = e), Nt(this));
          }),
          (e.ga = function () {
            this.g && Nt(this);
          }),
          (e.setRequestHeader = function (e, t) {
            this.u.append(e, t);
          }),
          (e.getResponseHeader = function (e) {
            return (this.h && this.h.get(e.toLowerCase())) || "";
          }),
          (e.getAllResponseHeaders = function () {
            if (!this.h) return "";
            const e = [],
              t = this.h.entries();
            for (var n = t.next(); !n.done; ) (n = n.value), e.push(n[0] + ": " + n[1]), (n = t.next());
            return e.join("\r\n");
          }),
          Object.defineProperty(Mt.prototype, "withCredentials", {
            get: function () {
              return "include" === this.m;
            },
            set: function (e) {
              this.m = e ? "include" : "same-origin";
            },
          }),
          d(Rt, ne);
        var Ft = /^https?$/i,
          Bt = ["POST", "PUT"];
        function $t(e, t) {
          (e.h = !1), e.g && ((e.j = !0), e.g.abort(), (e.j = !1)), (e.l = t), (e.m = 5), Vt(e), zt(e);
        }
        function Vt(e) {
          e.A || ((e.A = !0), re(e, "complete"), re(e, "error"));
        }
        function jt(e) {
          if (e.h && void 0 !== r && (!e.v[1] || 4 != Gt(e) || 2 != e.Z()))
            if (e.u && 4 == Gt(e)) ie(e.Ea, 0, e);
            else if ((re(e, "readystatechange"), 4 == Gt(e))) {
              e.h = !1;
              try {
                const r = e.Z();
                e: switch (r) {
                  case 200:
                  case 201:
                  case 202:
                  case 204:
                  case 206:
                  case 304:
                  case 1223:
                    var t = !0;
                    break e;
                  default:
                    t = !1;
                }
                var n;
                if (!(n = t)) {
                  var i;
                  if ((i = 0 === r)) {
                    var o = String(e.D).match(st)[1] || null;
                    !o && s.self && s.self.location && (o = s.self.location.protocol.slice(0, -1)),
                      (i = !Ft.test(o ? o.toLowerCase() : ""));
                  }
                  n = i;
                }
                if (n) re(e, "complete"), re(e, "success");
                else {
                  e.m = 6;
                  try {
                    var a = 2 < Gt(e) ? e.g.statusText : "";
                  } catch (e) {
                    a = "";
                  }
                  (e.l = a + " [" + e.Z() + "]"), Vt(e);
                }
              } finally {
                zt(e);
              }
            }
        }
        function zt(e, t) {
          if (e.g) {
            Ut(e);
            const n = e.g,
              r = e.v[0] ? () => {} : null;
            (e.g = null), (e.v = null), t || re(e, "ready");
            try {
              n.onreadystatechange = r;
            } catch (e) {}
          }
        }
        function Ut(e) {
          e.I && (s.clearTimeout(e.I), (e.I = null));
        }
        function Gt(e) {
          return e.g ? e.g.readyState : 0;
        }
        function Ht(e) {
          try {
            if (!e.g) return null;
            if ("response" in e.g) return e.g.response;
            switch (e.H) {
              case "":
              case "text":
                return e.g.responseText;
              case "arraybuffer":
                if ("mozResponseArrayBuffer" in e.g) return e.g.mozResponseArrayBuffer;
            }
            return null;
          } catch (e) {
            return null;
          }
        }
        function Wt(e, t, n) {
          return (n && n.internalChannelParams && n.internalChannelParams[e]) || t;
        }
        function Kt(e) {
          (this.Aa = 0),
            (this.i = []),
            (this.j = new ke()),
            (this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null),
            (this.Ya = this.U = 0),
            (this.Va = Wt("failFast", !1, e)),
            (this.F = this.C = this.u = this.s = this.l = null),
            (this.X = !0),
            (this.za = this.T = -1),
            (this.Y = this.v = this.B = 0),
            (this.Ta = Wt("baseRetryDelayMs", 5e3, e)),
            (this.cb = Wt("retryDelaySeedMs", 1e4, e)),
            (this.Wa = Wt("forwardChannelMaxRetries", 2, e)),
            (this.wa = Wt("forwardChannelRequestTimeoutMs", 2e4, e)),
            (this.pa = (e && e.xmlHttpFactory) || void 0),
            (this.Xa = (e && e.Tb) || void 0),
            (this.Ca = (e && e.useFetchStreams) || !1),
            (this.L = void 0),
            (this.J = (e && e.supportsCrossDomainXhr) || !1),
            (this.K = ""),
            (this.h = new Ye(e && e.concurrentRequestLimit)),
            (this.Da = new It()),
            (this.P = (e && e.fastHandshake) || !1),
            (this.O = (e && e.encodeInitMessageHeaders) || !1),
            this.P && this.O && (this.O = !1),
            (this.Ua = (e && e.Rb) || !1),
            e && e.xa && this.j.xa(),
            e && e.forceLongPolling && (this.X = !1),
            (this.ba = (!this.P && this.X && e && e.detectBufferingProxy) || !1),
            (this.ja = void 0),
            e && e.longPollingTimeout && 0 < e.longPollingTimeout && (this.ja = e.longPollingTimeout),
            (this.ca = void 0),
            (this.R = 0),
            (this.M = !1),
            (this.ka = this.A = null);
        }
        function Qt(e) {
          if ((Xt(e), 3 == e.G)) {
            var t = e.U++,
              n = ot(e.I);
            if (
              (ut(n, "SID", e.K),
              ut(n, "RID", t),
              ut(n, "TYPE", "terminate"),
              en(e, n),
              ((t = new Oe(e, e.j, t)).L = 2),
              (t.v = dt(ot(n))),
              (n = !1),
              s.navigator && s.navigator.sendBeacon)
            )
              try {
                n = s.navigator.sendBeacon(t.v.toString(), "");
              } catch (e) {}
            !n && s.Image && ((new Image().src = t.v), (n = !0)), n || ((t.g = pn(t.j, null)), t.g.ea(t.v)), (t.F = Date.now()), ze(t);
          }
          dn(e);
        }
        function Yt(e) {
          e.g && (sn(e), e.g.cancel(), (e.g = null));
        }
        function Xt(e) {
          Yt(e),
            e.u && (s.clearTimeout(e.u), (e.u = null)),
            an(e),
            e.h.cancel(),
            e.s && ("number" == typeof e.s && s.clearTimeout(e.s), (e.s = null));
        }
        function Jt(e) {
          if (!Xe(e.h) && !e.s) {
            e.s = !0;
            var t = e.Ga;
            A || L(), I || (A(), (I = !0)), k.add(t, e), (e.B = 0);
          }
        }
        function Zt(e, t) {
          var n;
          n = t ? t.l : e.U++;
          const r = ot(e.I);
          ut(r, "SID", e.K),
            ut(r, "RID", n),
            ut(r, "AID", e.T),
            en(e, r),
            e.m && e.o && qt(r, e.m, e.o),
            (n = new Oe(e, e.j, n, e.B + 1)),
            null === e.m && (n.H = e.o),
            t && (e.i = t.D.concat(e.i)),
            (t = tn(e, n, 1e3)),
            (n.I = Math.round(0.5 * e.wa) + Math.round(0.5 * e.wa * Math.random())),
            et(e.h, n),
            Be(n, r, t);
        }
        function en(e, t) {
          e.H &&
            v(e.H, function (e, n) {
              ut(t, n, e);
            }),
            e.l &&
              rt({}, function (e, n) {
                ut(t, n, e);
              });
        }
        function tn(e, t, n) {
          n = Math.min(e.i.length, n);
          var r = e.l ? c(e.l.Na, e.l, e) : null;
          e: {
            var s = e.i;
            let t = -1;
            for (;;) {
              const e = ["count=" + n];
              -1 == t ? (0 < n ? ((t = s[0].g), e.push("ofs=" + t)) : (t = 0)) : e.push("ofs=" + t);
              let i = !0;
              for (let o = 0; o < n; o++) {
                let n = s[o].g;
                const a = s[o].map;
                if (((n -= t), 0 > n)) (t = Math.max(0, s[o].g - 100)), (i = !1);
                else
                  try {
                    kt(a, e, "req" + n + "_");
                  } catch (e) {
                    r && r(a);
                  }
              }
              if (i) {
                r = e.join("&");
                break e;
              }
            }
          }
          return (e = e.i.splice(0, n)), (t.D = e), r;
        }
        function nn(e) {
          if (!e.g && !e.u) {
            e.Y = 1;
            var t = e.Fa;
            A || L(), I || (A(), (I = !0)), k.add(t, e), (e.v = 0);
          }
        }
        function rn(e) {
          return !(e.g || e.u || 3 <= e.v) && (e.Y++, (e.u = Ie(c(e.Fa, e), cn(e, e.v))), e.v++, !0);
        }
        function sn(e) {
          null != e.A && (s.clearTimeout(e.A), (e.A = null));
        }
        function on(e) {
          (e.g = new Oe(e, e.j, "rpc", e.Y)), null === e.m && (e.g.H = e.o), (e.g.O = 0);
          var t = ot(e.qa);
          ut(t, "RID", "rpc"),
            ut(t, "SID", e.K),
            ut(t, "AID", e.T),
            ut(t, "CI", e.F ? "0" : "1"),
            !e.F && e.ja && ut(t, "TO", e.ja),
            ut(t, "TYPE", "xmlhttp"),
            en(e, t),
            e.m && e.o && qt(t, e.m, e.o),
            e.L && (e.g.I = e.L);
          var n = e.g;
          (e = e.ia), (n.L = 1), (n.v = dt(ot(t))), (n.m = null), (n.P = !0), $e(n, e);
        }
        function an(e) {
          null != e.C && (s.clearTimeout(e.C), (e.C = null));
        }
        function ln(e, t) {
          var n = null;
          if (e.g == t) {
            an(e), sn(e), (e.g = null);
            var r = 2;
          } else {
            if (!Ze(e.h, t)) return;
            (n = t.D), tt(e.h, t), (r = 1);
          }
          if (0 != e.G)
            if (t.o)
              if (1 == r) {
                (n = t.m ? t.m.length : 0), (t = Date.now() - t.F);
                var s = e.B;
                re((r = Ee()), new Ae(r, n)), Jt(e);
              } else nn(e);
            else if (
              3 == (s = t.s) ||
              (0 == s && 0 < t.X) ||
              !(
                (1 == r &&
                  (function (e, t) {
                    return !(
                      Je(e.h) >= e.h.j - (e.s ? 1 : 0) ||
                      (e.s
                        ? ((e.i = t.D.concat(e.i)), 0)
                        : 1 == e.G || 2 == e.G || e.B >= (e.Va ? 0 : e.Wa) || ((e.s = Ie(c(e.Ga, e, t), cn(e, e.B))), e.B++, 0))
                    );
                  })(e, t)) ||
                (2 == r && rn(e))
              )
            )
              switch ((n && 0 < n.length && ((t = e.h), (t.i = t.i.concat(n))), s)) {
                case 1:
                  un(e, 5);
                  break;
                case 4:
                  un(e, 10);
                  break;
                case 3:
                  un(e, 6);
                  break;
                default:
                  un(e, 2);
              }
        }
        function cn(e, t) {
          let n = e.Ta + Math.floor(Math.random() * e.cb);
          return e.isActive() || (n *= 2), n * t;
        }
        function un(e, t) {
          if ((e.j.info("Error code " + t), 2 == t)) {
            var n = c(e.fb, e),
              r = e.Xa;
            const t = !r;
            (r = new it(r || "//www.google.com/images/cleardot.gif")),
              (s.location && "http" == s.location.protocol) || at(r, "https"),
              dt(r),
              t
                ? (function (e, t) {
                    const n = new ke();
                    if (s.Image) {
                      const r = new Image();
                      (r.onload = u(At, n, "TestLoadImage: loaded", !0, t, r)),
                        (r.onerror = u(At, n, "TestLoadImage: error", !1, t, r)),
                        (r.onabort = u(At, n, "TestLoadImage: abort", !1, t, r)),
                        (r.ontimeout = u(At, n, "TestLoadImage: timeout", !1, t, r)),
                        s.setTimeout(function () {
                          r.ontimeout && r.ontimeout();
                        }, 1e4),
                        (r.src = e);
                    } else t(!1);
                  })(r.toString(), n)
                : (function (e, t) {
                    new ke();
                    const n = new AbortController(),
                      r = setTimeout(() => {
                        n.abort(), At(0, 0, !1, t);
                      }, 1e4);
                    fetch(e, { signal: n.signal })
                      .then((e) => {
                        clearTimeout(r), e.ok ? At(0, 0, !0, t) : At(0, 0, !1, t);
                      })
                      .catch(() => {
                        clearTimeout(r), At(0, 0, !1, t);
                      });
                  })(r.toString(), n);
          } else xe(2);
          (e.G = 0), e.l && e.l.sa(t), dn(e), Xt(e);
        }
        function dn(e) {
          if (((e.G = 0), (e.ka = []), e.l)) {
            const t = nt(e.h);
            (0 == t.length && 0 == e.i.length) || (p(e.ka, t), p(e.ka, e.i), (e.h.i.length = 0), h(e.i), (e.i.length = 0)), e.l.ra();
          }
        }
        function hn(e, t, n) {
          var r = n instanceof it ? ot(n) : new it(n);
          if ("" != r.g) t && (r.g = t + "." + r.g), lt(r, r.s);
          else {
            var i = s.location;
            (r = i.protocol), (t = t ? t + "." + i.hostname : i.hostname), (i = +i.port);
            var o = new it(null);
            r && at(o, r), t && (o.g = t), i && lt(o, i), n && (o.l = n), (r = o);
          }
          return (n = e.D), (t = e.ya), n && t && ut(r, n, t), ut(r, "VER", e.la), en(e, r), r;
        }
        function pn(e, t, n) {
          if (t && !e.J) throw Error("Can't create secondary domain capable XhrIo object.");
          return (t = e.Ca && !e.pa ? new Rt(new Lt({ eb: n })) : new Rt(e.pa)).Ha(e.J), t;
        }
        function fn() {}
        function mn() {}
        function gn(e, t) {
          ne.call(this),
            (this.g = new Kt(t)),
            (this.l = e),
            (this.h = (t && t.messageUrlParams) || null),
            (e = (t && t.messageHeaders) || null),
            t &&
              t.clientProtocolHeaderRequired &&
              (e ? (e["X-Client-Protocol"] = "webchannel") : (e = { "X-Client-Protocol": "webchannel" })),
            (this.g.o = e),
            (e = (t && t.initMessageHeaders) || null),
            t &&
              t.messageContentType &&
              (e ? (e["X-WebChannel-Content-Type"] = t.messageContentType) : (e = { "X-WebChannel-Content-Type": t.messageContentType })),
            t && t.va && (e ? (e["X-WebChannel-Client-Profile"] = t.va) : (e = { "X-WebChannel-Client-Profile": t.va })),
            (this.g.S = e),
            (e = t && t.Sb) && !f(e) && (this.g.m = e),
            (this.v = (t && t.supportsCrossDomainXhr) || !1),
            (this.u = (t && t.sendRawJson) || !1),
            (t = t && t.httpSessionIdParam) &&
              !f(t) &&
              ((this.g.D = t), null !== (e = this.h) && t in e && t in (e = this.h) && delete e[t]),
            (this.j = new wn(this));
        }
        function yn(e) {
          ve.call(this),
            e.__headers__ && ((this.headers = e.__headers__), (this.statusCode = e.__status__), delete e.__headers__, delete e.__status__);
          var t = e.__sm__;
          if (t) {
            e: {
              for (const n in t) {
                e = n;
                break e;
              }
              e = void 0;
            }
            (this.i = e) && ((e = this.i), (t = null !== t && e in t ? t[e] : void 0)), (this.data = t);
          } else this.data = e;
        }
        function vn() {
          we.call(this), (this.status = 1);
        }
        function wn(e) {
          this.g = e;
        }
        ((e = Rt.prototype).Ha = function (e) {
          this.J = e;
        }),
          (e.ea = function (e, t, n, r) {
            if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + e);
            (t = t ? t.toUpperCase() : "GET"),
              (this.D = e),
              (this.l = ""),
              (this.m = 0),
              (this.A = !1),
              (this.h = !0),
              (this.g = this.o ? this.o.g() : Me.g()),
              (this.v = this.o ? me(this.o) : me(Me)),
              (this.g.onreadystatechange = c(this.Ea, this));
            try {
              (this.B = !0), this.g.open(t, String(e), !0), (this.B = !1);
            } catch (e) {
              return void $t(this, e);
            }
            if (((e = n || ""), (n = new Map(this.headers)), r))
              if (Object.getPrototypeOf(r) === Object.prototype) for (var i in r) n.set(i, r[i]);
              else {
                if ("function" != typeof r.keys || "function" != typeof r.get)
                  throw Error("Unknown input type for opt_headers: " + String(r));
                for (const e of r.keys()) n.set(e, r.get(e));
              }
            (r = Array.from(n.keys()).find((e) => "content-type" == e.toLowerCase())),
              (i = s.FormData && e instanceof s.FormData),
              !(0 <= Array.prototype.indexOf.call(Bt, t, void 0)) ||
                r ||
                i ||
                n.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
            for (const [e, t] of n) this.g.setRequestHeader(e, t);
            this.H && (this.g.responseType = this.H),
              "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
            try {
              Ut(this), (this.u = !0), this.g.send(e), (this.u = !1);
            } catch (e) {
              $t(this, e);
            }
          }),
          (e.abort = function (e) {
            this.g &&
              this.h &&
              ((this.h = !1),
              (this.j = !0),
              this.g.abort(),
              (this.j = !1),
              (this.m = e || 7),
              re(this, "complete"),
              re(this, "abort"),
              zt(this));
          }),
          (e.N = function () {
            this.g && (this.h && ((this.h = !1), (this.j = !0), this.g.abort(), (this.j = !1)), zt(this, !0)), Rt.aa.N.call(this);
          }),
          (e.Ea = function () {
            this.s || (this.B || this.u || this.j ? jt(this) : this.bb());
          }),
          (e.bb = function () {
            jt(this);
          }),
          (e.isActive = function () {
            return !!this.g;
          }),
          (e.Z = function () {
            try {
              return 2 < Gt(this) ? this.g.status : -1;
            } catch (e) {
              return -1;
            }
          }),
          (e.oa = function () {
            try {
              return this.g ? this.g.responseText : "";
            } catch (e) {
              return "";
            }
          }),
          (e.Oa = function (e) {
            if (this.g) {
              var t = this.g.responseText;
              return e && 0 == t.indexOf(e) && (t = t.substring(e.length)), he(t);
            }
          }),
          (e.Ba = function () {
            return this.m;
          }),
          (e.Ka = function () {
            return "string" == typeof this.l ? this.l : String(this.l);
          }),
          ((e = Kt.prototype).la = 8),
          (e.G = 1),
          (e.connect = function (e, t, n, r) {
            xe(0),
              (this.W = e),
              (this.H = t || {}),
              n && void 0 !== r && ((this.H.OSID = n), (this.H.OAID = r)),
              (this.F = this.X),
              (this.I = hn(this, null, this.W)),
              Jt(this);
          }),
          (e.Ga = function (e) {
            if (this.s)
              if (((this.s = null), 1 == this.G)) {
                if (!e) {
                  (this.U = Math.floor(1e5 * Math.random())), (e = this.U++);
                  const s = new Oe(this, this.j, e);
                  let i = this.o;
                  if (
                    (this.S && (i ? ((i = w(i)), S(i, this.S)) : (i = this.S)),
                    null !== this.m || this.O || ((s.H = i), (i = null)),
                    this.P)
                  )
                    e: {
                      for (var t = 0, n = 0; n < this.i.length; n++) {
                        var r = this.i[n];
                        if (void 0 === (r = "__data__" in r.map && "string" == typeof (r = r.map.__data__) ? r.length : void 0)) break;
                        if (4096 < (t += r)) {
                          t = n;
                          break e;
                        }
                        if (4096 === t || n === this.i.length - 1) {
                          t = n + 1;
                          break e;
                        }
                      }
                      t = 1e3;
                    }
                  else t = 1e3;
                  (t = tn(this, s, t)),
                    ut((n = ot(this.I)), "RID", e),
                    ut(n, "CVER", 22),
                    this.D && ut(n, "X-HTTP-Session-Id", this.D),
                    en(this, n),
                    i && (this.O ? (t = "headers=" + encodeURIComponent(String(Ot(i))) + "&" + t) : this.m && qt(n, this.m, i)),
                    et(this.h, s),
                    this.Ua && ut(n, "TYPE", "init"),
                    this.P ? (ut(n, "$req", t), ut(n, "SID", "null"), (s.T = !0), Be(s, n, null)) : Be(s, n, t),
                    (this.G = 2);
                }
              } else 3 == this.G && (e ? Zt(this, e) : 0 == this.i.length || Xe(this.h) || Zt(this));
          }),
          (e.Fa = function () {
            if (((this.u = null), on(this), this.ba && !(this.M || null == this.g || 0 >= this.R))) {
              var e = 2 * this.R;
              this.j.info("BP detection timer enabled: " + e), (this.A = Ie(c(this.ab, this), e));
            }
          }),
          (e.ab = function () {
            this.A &&
              ((this.A = null),
              this.j.info("BP detection timeout reached."),
              this.j.info("Buffering proxy detected and switch to long-polling!"),
              (this.F = !1),
              (this.M = !0),
              xe(10),
              Yt(this),
              on(this));
          }),
          (e.Za = function () {
            null != this.C && ((this.C = null), Yt(this), rn(this), xe(19));
          }),
          (e.fb = function (e) {
            e ? (this.j.info("Successfully pinged google.com"), xe(2)) : (this.j.info("Failed to ping google.com"), xe(1));
          }),
          (e.isActive = function () {
            return !!this.l && this.l.isActive(this);
          }),
          ((e = fn.prototype).ua = function () {}),
          (e.ta = function () {}),
          (e.sa = function () {}),
          (e.ra = function () {}),
          (e.isActive = function () {
            return !0;
          }),
          (e.Na = function () {}),
          (mn.prototype.g = function (e, t) {
            return new gn(e, t);
          }),
          d(gn, ne),
          (gn.prototype.m = function () {
            (this.g.l = this.j), this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
          }),
          (gn.prototype.close = function () {
            Qt(this.g);
          }),
          (gn.prototype.o = function (e) {
            var t = this.g;
            if ("string" == typeof e) {
              var n = {};
              (n.__data__ = e), (e = n);
            } else this.u && (((n = {}).__data__ = de(e)), (e = n));
            t.i.push(new Qe(t.Ya++, e)), 3 == t.G && Jt(t);
          }),
          (gn.prototype.N = function () {
            (this.g.l = null), delete this.j, Qt(this.g), delete this.g, gn.aa.N.call(this);
          }),
          d(yn, ve),
          d(vn, we),
          d(wn, fn),
          (wn.prototype.ua = function () {
            re(this.g, "a");
          }),
          (wn.prototype.ta = function (e) {
            re(this.g, new yn(e));
          }),
          (wn.prototype.sa = function (e) {
            re(this.g, new vn());
          }),
          (wn.prototype.ra = function () {
            re(this.g, "b");
          }),
          (mn.prototype.createWebChannel = mn.prototype.g),
          (gn.prototype.send = gn.prototype.o),
          (gn.prototype.open = gn.prototype.m),
          (gn.prototype.close = gn.prototype.close),
          (es = ns.createWebChannelTransport =
            function () {
              return new mn();
            }),
          (Zr = ns.getStatEventTarget =
            function () {
              return Ee();
            }),
          (Jr = ns.Event = be),
          (Xr = ns.Stat =
            {
              mb: 0,
              pb: 1,
              qb: 2,
              Jb: 3,
              Ob: 4,
              Lb: 5,
              Mb: 6,
              Kb: 7,
              Ib: 8,
              Nb: 9,
              PROXY: 10,
              NOPROXY: 11,
              Gb: 12,
              Cb: 13,
              Db: 14,
              Bb: 15,
              Eb: 16,
              Fb: 17,
              ib: 18,
              hb: 19,
              jb: 20,
            }),
          (De.NO_ERROR = 0),
          (De.TIMEOUT = 8),
          (De.HTTP_ERROR = 6),
          (Yr = ns.ErrorCode = De),
          (Ne.COMPLETE = "complete"),
          (Qr = ns.EventType = Ne),
          (ge.EventType = ye),
          (ye.OPEN = "a"),
          (ye.CLOSE = "b"),
          (ye.ERROR = "c"),
          (ye.MESSAGE = "d"),
          (ne.prototype.listen = ne.prototype.K),
          (Kr = ns.WebChannel = ge),
          (ns.FetchXmlHttpFactory = Lt),
          (Rt.prototype.listenOnce = Rt.prototype.L),
          (Rt.prototype.getLastError = Rt.prototype.Ka),
          (Rt.prototype.getLastErrorCode = Rt.prototype.Ba),
          (Rt.prototype.getStatus = Rt.prototype.Z),
          (Rt.prototype.getResponseJson = Rt.prototype.Oa),
          (Rt.prototype.getResponseText = Rt.prototype.oa),
          (Rt.prototype.send = Rt.prototype.ea),
          (Rt.prototype.setWithCredentials = Rt.prototype.Ha),
          (Wr = ns.XhrIo = Rt);
      }).apply(void 0 !== ts ? ts : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      const rs = "@firebase/firestore";
      class ss {
        constructor(e) {
          this.uid = e;
        }
        isAuthenticated() {
          return null != this.uid;
        }
        toKey() {
          return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
        }
        isEqual(e) {
          return e.uid === this.uid;
        }
      }
      (ss.UNAUTHENTICATED = new ss(null)),
        (ss.GOOGLE_CREDENTIALS = new ss("google-credentials-uid")),
        (ss.FIRST_PARTY = new ss("first-party-uid")),
        (ss.MOCK_USER = new ss("mock-user"));
      let is = "11.2.0";
      const os = new Yn("@firebase/firestore");
      function as() {
        return os.logLevel;
      }
      function ls(e, ...t) {
        if (os.logLevel <= Gn.DEBUG) {
          const n = t.map(ds);
          os.debug(`Firestore (${is}): ${e}`, ...n);
        }
      }
      function cs(e, ...t) {
        if (os.logLevel <= Gn.ERROR) {
          const n = t.map(ds);
          os.error(`Firestore (${is}): ${e}`, ...n);
        }
      }
      function us(e, ...t) {
        if (os.logLevel <= Gn.WARN) {
          const n = t.map(ds);
          os.warn(`Firestore (${is}): ${e}`, ...n);
        }
      }
      function ds(e) {
        if ("string" == typeof e) return e;
        try {
          return (function (e) {
            return JSON.stringify(e);
          })(e);
        } catch (t) {
          return e;
        }
      }
      function hs(e = "Unexpected state") {
        const t = `FIRESTORE (${is}) INTERNAL ASSERTION FAILED: ` + e;
        throw (cs(t), new Error(t));
      }
      function ps(e, t) {
        e || hs();
      }
      function fs(e, t) {
        return e;
      }
      const ms = {
        OK: "ok",
        CANCELLED: "cancelled",
        UNKNOWN: "unknown",
        INVALID_ARGUMENT: "invalid-argument",
        DEADLINE_EXCEEDED: "deadline-exceeded",
        NOT_FOUND: "not-found",
        ALREADY_EXISTS: "already-exists",
        PERMISSION_DENIED: "permission-denied",
        UNAUTHENTICATED: "unauthenticated",
        RESOURCE_EXHAUSTED: "resource-exhausted",
        FAILED_PRECONDITION: "failed-precondition",
        ABORTED: "aborted",
        OUT_OF_RANGE: "out-of-range",
        UNIMPLEMENTED: "unimplemented",
        INTERNAL: "internal",
        UNAVAILABLE: "unavailable",
        DATA_LOSS: "data-loss",
      };
      class gs extends Pn {
        constructor(e, t) {
          super(e, t), (this.code = e), (this.message = t), (this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`);
        }
      }
      class ys {
        constructor() {
          this.promise = new Promise((e, t) => {
            (this.resolve = e), (this.reject = t);
          });
        }
      }
      class vs {
        constructor(e, t) {
          (this.user = t), (this.type = "OAuth"), (this.headers = new Map()), this.headers.set("Authorization", `Bearer ${e}`);
        }
      }
      class ws {
        getToken() {
          return Promise.resolve(null);
        }
        invalidateToken() {}
        start(e, t) {
          e.enqueueRetryable(() => t(ss.UNAUTHENTICATED));
        }
        shutdown() {}
      }
      class bs {
        constructor(e) {
          (this.token = e), (this.changeListener = null);
        }
        getToken() {
          return Promise.resolve(this.token);
        }
        invalidateToken() {}
        start(e, t) {
          (this.changeListener = t), e.enqueueRetryable(() => t(this.token.user));
        }
        shutdown() {
          this.changeListener = null;
        }
      }
      class Ss {
        constructor(e) {
          (this.t = e), (this.currentUser = ss.UNAUTHENTICATED), (this.i = 0), (this.forceRefresh = !1), (this.auth = null);
        }
        start(e, t) {
          ps(void 0 === this.o);
          let n = this.i;
          const r = (e) => (this.i !== n ? ((n = this.i), t(e)) : Promise.resolve());
          let s = new ys();
          this.o = () => {
            this.i++, (this.currentUser = this.u()), s.resolve(), (s = new ys()), e.enqueueRetryable(() => r(this.currentUser));
          };
          const i = () => {
              const t = s;
              e.enqueueRetryable(async () => {
                await t.promise, await r(this.currentUser);
              });
            },
            o = (e) => {
              ls("FirebaseAuthCredentialsProvider", "Auth detected"),
                (this.auth = e),
                this.o && (this.auth.addAuthTokenListener(this.o), i());
            };
          this.t.onInit((e) => o(e)),
            setTimeout(() => {
              if (!this.auth) {
                const e = this.t.getImmediate({ optional: !0 });
                e ? o(e) : (ls("FirebaseAuthCredentialsProvider", "Auth not yet detected"), s.resolve(), (s = new ys()));
              }
            }, 0),
            i();
        }
        getToken() {
          const e = this.i,
            t = this.forceRefresh;
          return (
            (this.forceRefresh = !1),
            this.auth
              ? this.auth
                  .getToken(t)
                  .then((t) =>
                    this.i !== e
                      ? (ls("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken())
                      : t
                      ? (ps("string" == typeof t.accessToken), new vs(t.accessToken, this.currentUser))
                      : null
                  )
              : Promise.resolve(null)
          );
        }
        invalidateToken() {
          this.forceRefresh = !0;
        }
        shutdown() {
          this.auth && this.o && this.auth.removeAuthTokenListener(this.o), (this.o = void 0);
        }
        u() {
          const e = this.auth && this.auth.getUid();
          return ps(null === e || "string" == typeof e), new ss(e);
        }
      }
      class Es {
        constructor(e, t, n) {
          (this.l = e), (this.h = t), (this.P = n), (this.type = "FirstParty"), (this.user = ss.FIRST_PARTY), (this.T = new Map());
        }
        I() {
          return this.P ? this.P() : null;
        }
        get headers() {
          this.T.set("X-Goog-AuthUser", this.l);
          const e = this.I();
          return e && this.T.set("Authorization", e), this.h && this.T.set("X-Goog-Iam-Authorization-Token", this.h), this.T;
        }
      }
      class Ts {
        constructor(e, t, n) {
          (this.l = e), (this.h = t), (this.P = n);
        }
        getToken() {
          return Promise.resolve(new Es(this.l, this.h, this.P));
        }
        start(e, t) {
          e.enqueueRetryable(() => t(ss.FIRST_PARTY));
        }
        shutdown() {}
        invalidateToken() {}
      }
      class _s {
        constructor(e) {
          (this.value = e),
            (this.type = "AppCheck"),
            (this.headers = new Map()),
            e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
        }
      }
      class Cs {
        constructor(e) {
          (this.A = e), (this.forceRefresh = !1), (this.appCheck = null), (this.R = null);
        }
        start(e, t) {
          ps(void 0 === this.o);
          const n = (e) => {
            null != e.error &&
              ls(
                "FirebaseAppCheckTokenProvider",
                `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`
              );
            const n = e.token !== this.R;
            return (
              (this.R = e.token),
              ls("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`),
              n ? t(e.token) : Promise.resolve()
            );
          };
          this.o = (t) => {
            e.enqueueRetryable(() => n(t));
          };
          const r = (e) => {
            ls("FirebaseAppCheckTokenProvider", "AppCheck detected"), (this.appCheck = e), this.o && this.appCheck.addTokenListener(this.o);
          };
          this.A.onInit((e) => r(e)),
            setTimeout(() => {
              if (!this.appCheck) {
                const e = this.A.getImmediate({ optional: !0 });
                e ? r(e) : ls("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
              }
            }, 0);
        }
        getToken() {
          const e = this.forceRefresh;
          return (
            (this.forceRefresh = !1),
            this.appCheck
              ? this.appCheck.getToken(e).then((e) => (e ? (ps("string" == typeof e.token), (this.R = e.token), new _s(e.token)) : null))
              : Promise.resolve(null)
          );
        }
        invalidateToken() {
          this.forceRefresh = !0;
        }
        shutdown() {
          this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), (this.o = void 0);
        }
      }
      function xs(e) {
        const t = "undefined" != typeof self && (self.crypto || self.msCrypto),
          n = new Uint8Array(e);
        if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
        else for (let t = 0; t < e; t++) n[t] = Math.floor(256 * Math.random());
        return n;
      }
      class As {
        static newId() {
          const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
            t = 62 * Math.floor(256 / 62);
          let n = "";
          for (; n.length < 20; ) {
            const r = xs(40);
            for (let s = 0; s < r.length; ++s) n.length < 20 && r[s] < t && (n += e.charAt(r[s] % 62));
          }
          return n;
        }
      }
      function Is(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
      }
      function ks(e, t, n) {
        return e.length === t.length && e.every((e, r) => n(e, t[r]));
      }
      class Ls {
        static now() {
          return Ls.fromMillis(Date.now());
        }
        static fromDate(e) {
          return Ls.fromMillis(e.getTime());
        }
        static fromMillis(e) {
          const t = Math.floor(e / 1e3),
            n = Math.floor(1e6 * (e - 1e3 * t));
          return new Ls(t, n);
        }
        constructor(e, t) {
          if (((this.seconds = e), (this.nanoseconds = t), t < 0))
            throw new gs(ms.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
          if (t >= 1e9) throw new gs(ms.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
          if (e < -62135596800) throw new gs(ms.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
          if (e >= 253402300800) throw new gs(ms.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        }
        toDate() {
          return new Date(this.toMillis());
        }
        toMillis() {
          return 1e3 * this.seconds + this.nanoseconds / 1e6;
        }
        _compareTo(e) {
          return this.seconds === e.seconds ? Is(this.nanoseconds, e.nanoseconds) : Is(this.seconds, e.seconds);
        }
        isEqual(e) {
          return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
        }
        toString() {
          return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
        }
        toJSON() {
          return { seconds: this.seconds, nanoseconds: this.nanoseconds };
        }
        valueOf() {
          const e = this.seconds - -62135596800;
          return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
        }
      }
      class Ms {
        static fromTimestamp(e) {
          return new Ms(e);
        }
        static min() {
          return new Ms(new Ls(0, 0));
        }
        static max() {
          return new Ms(new Ls(253402300799, 999999999));
        }
        constructor(e) {
          this.timestamp = e;
        }
        compareTo(e) {
          return this.timestamp._compareTo(e.timestamp);
        }
        isEqual(e) {
          return this.timestamp.isEqual(e.timestamp);
        }
        toMicroseconds() {
          return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
        }
        toString() {
          return "SnapshotVersion(" + this.timestamp.toString() + ")";
        }
        toTimestamp() {
          return this.timestamp;
        }
      }
      class Ds {
        constructor(e, t, n) {
          void 0 === t ? (t = 0) : t > e.length && hs(),
            void 0 === n ? (n = e.length - t) : n > e.length - t && hs(),
            (this.segments = e),
            (this.offset = t),
            (this.len = n);
        }
        get length() {
          return this.len;
        }
        isEqual(e) {
          return 0 === Ds.comparator(this, e);
        }
        child(e) {
          const t = this.segments.slice(this.offset, this.limit());
          return (
            e instanceof Ds
              ? e.forEach((e) => {
                  t.push(e);
                })
              : t.push(e),
            this.construct(t)
          );
        }
        limit() {
          return this.offset + this.length;
        }
        popFirst(e) {
          return (e = void 0 === e ? 1 : e), this.construct(this.segments, this.offset + e, this.length - e);
        }
        popLast() {
          return this.construct(this.segments, this.offset, this.length - 1);
        }
        firstSegment() {
          return this.segments[this.offset];
        }
        lastSegment() {
          return this.get(this.length - 1);
        }
        get(e) {
          return this.segments[this.offset + e];
        }
        isEmpty() {
          return 0 === this.length;
        }
        isPrefixOf(e) {
          if (e.length < this.length) return !1;
          for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
          return !0;
        }
        isImmediateParentOf(e) {
          if (this.length + 1 !== e.length) return !1;
          for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
          return !0;
        }
        forEach(e) {
          for (let t = this.offset, n = this.limit(); t < n; t++) e(this.segments[t]);
        }
        toArray() {
          return this.segments.slice(this.offset, this.limit());
        }
        static comparator(e, t) {
          const n = Math.min(e.length, t.length);
          for (let r = 0; r < n; r++) {
            const n = Ds.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
          }
          return Math.sign(e.length - t.length);
        }
        static compareSegments(e, t) {
          const n = Ds.isNumericId(e),
            r = Ds.isNumericId(t);
          return n && !r ? -1 : !n && r ? 1 : n && r ? Ds.extractNumericId(e).compare(Ds.extractNumericId(t)) : e < t ? -1 : e > t ? 1 : 0;
        }
        static isNumericId(e) {
          return e.startsWith("__id") && e.endsWith("__");
        }
        static extractNumericId(e) {
          return zr.fromString(e.substring(4, e.length - 2));
        }
      }
      class Ns extends Ds {
        construct(e, t, n) {
          return new Ns(e, t, n);
        }
        canonicalString() {
          return this.toArray().join("/");
        }
        toString() {
          return this.canonicalString();
        }
        toUriEncodedString() {
          return this.toArray().map(encodeURIComponent).join("/");
        }
        static fromString(...e) {
          const t = [];
          for (const n of e) {
            if (n.indexOf("//") >= 0) throw new gs(ms.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            t.push(...n.split("/").filter((e) => e.length > 0));
          }
          return new Ns(t);
        }
        static emptyPath() {
          return new Ns([]);
        }
      }
      const Ps = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
      class Os extends Ds {
        construct(e, t, n) {
          return new Os(e, t, n);
        }
        static isValidIdentifier(e) {
          return Ps.test(e);
        }
        canonicalString() {
          return this.toArray()
            .map((e) => ((e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`")), Os.isValidIdentifier(e) || (e = "`" + e + "`"), e))
            .join(".");
        }
        toString() {
          return this.canonicalString();
        }
        isKeyField() {
          return 1 === this.length && "__name__" === this.get(0);
        }
        static keyField() {
          return new Os(["__name__"]);
        }
        static fromServerFormat(e) {
          const t = [];
          let n = "",
            r = 0;
          const s = () => {
            if (0 === n.length)
              throw new gs(
                ms.INVALID_ARGUMENT,
                `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`
              );
            t.push(n), (n = "");
          };
          let i = !1;
          for (; r < e.length; ) {
            const t = e[r];
            if ("\\" === t) {
              if (r + 1 === e.length) throw new gs(ms.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
              const t = e[r + 1];
              if ("\\" !== t && "." !== t && "`" !== t) throw new gs(ms.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
              (n += t), (r += 2);
            } else "`" === t ? ((i = !i), r++) : "." !== t || i ? ((n += t), r++) : (s(), r++);
          }
          if ((s(), i)) throw new gs(ms.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
          return new Os(t);
        }
        static emptyPath() {
          return new Os([]);
        }
      }
      class qs {
        constructor(e) {
          this.path = e;
        }
        static fromPath(e) {
          return new qs(Ns.fromString(e));
        }
        static fromName(e) {
          return new qs(Ns.fromString(e).popFirst(5));
        }
        static empty() {
          return new qs(Ns.emptyPath());
        }
        get collectionGroup() {
          return this.path.popLast().lastSegment();
        }
        hasCollectionId(e) {
          return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
        }
        getCollectionGroup() {
          return this.path.get(this.path.length - 2);
        }
        getCollectionPath() {
          return this.path.popLast();
        }
        isEqual(e) {
          return null !== e && 0 === Ns.comparator(this.path, e.path);
        }
        toString() {
          return this.path.toString();
        }
        static comparator(e, t) {
          return Ns.comparator(e.path, t.path);
        }
        static isDocumentKey(e) {
          return e.length % 2 == 0;
        }
        static fromSegments(e) {
          return new qs(new Ns(e.slice()));
        }
      }
      class Rs {
        constructor(e, t, n, r) {
          (this.indexId = e), (this.collectionGroup = t), (this.fields = n), (this.indexState = r);
        }
      }
      Rs.UNKNOWN_ID = -1;
      function Fs(e, t) {
        const n = e.toTimestamp().seconds,
          r = e.toTimestamp().nanoseconds + 1,
          s = Ms.fromTimestamp(1e9 === r ? new Ls(n + 1, 0) : new Ls(n, r));
        return new $s(s, qs.empty(), t);
      }
      function Bs(e) {
        return new $s(e.readTime, e.key, -1);
      }
      class $s {
        constructor(e, t, n) {
          (this.readTime = e), (this.documentKey = t), (this.largestBatchId = n);
        }
        static min() {
          return new $s(Ms.min(), qs.empty(), -1);
        }
        static max() {
          return new $s(Ms.max(), qs.empty(), -1);
        }
      }
      function Vs(e, t) {
        let n = e.readTime.compareTo(t.readTime);
        return 0 !== n ? n : ((n = qs.comparator(e.documentKey, t.documentKey)), 0 !== n ? n : Is(e.largestBatchId, t.largestBatchId));
      }
      const js =
        "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
      class zs {
        constructor() {
          this.onCommittedListeners = [];
        }
        addOnCommittedListener(e) {
          this.onCommittedListeners.push(e);
        }
        raiseOnCommittedEvent() {
          this.onCommittedListeners.forEach((e) => e());
        }
      }
      async function Us(e) {
        if (e.code !== ms.FAILED_PRECONDITION || e.message !== js) throw e;
        ls("LocalStore", "Unexpectedly lost primary lease");
      }
      class Gs {
        constructor(e) {
          (this.nextCallback = null),
            (this.catchCallback = null),
            (this.result = void 0),
            (this.error = void 0),
            (this.isDone = !1),
            (this.callbackAttached = !1),
            e(
              (e) => {
                (this.isDone = !0), (this.result = e), this.nextCallback && this.nextCallback(e);
              },
              (e) => {
                (this.isDone = !0), (this.error = e), this.catchCallback && this.catchCallback(e);
              }
            );
        }
        catch(e) {
          return this.next(void 0, e);
        }
        next(e, t) {
          return (
            this.callbackAttached && hs(),
            (this.callbackAttached = !0),
            this.isDone
              ? this.error
                ? this.wrapFailure(t, this.error)
                : this.wrapSuccess(e, this.result)
              : new Gs((n, r) => {
                  (this.nextCallback = (t) => {
                    this.wrapSuccess(e, t).next(n, r);
                  }),
                    (this.catchCallback = (e) => {
                      this.wrapFailure(t, e).next(n, r);
                    });
                })
          );
        }
        toPromise() {
          return new Promise((e, t) => {
            this.next(e, t);
          });
        }
        wrapUserFunction(e) {
          try {
            const t = e();
            return t instanceof Gs ? t : Gs.resolve(t);
          } catch (e) {
            return Gs.reject(e);
          }
        }
        wrapSuccess(e, t) {
          return e ? this.wrapUserFunction(() => e(t)) : Gs.resolve(t);
        }
        wrapFailure(e, t) {
          return e ? this.wrapUserFunction(() => e(t)) : Gs.reject(t);
        }
        static resolve(e) {
          return new Gs((t, n) => {
            t(e);
          });
        }
        static reject(e) {
          return new Gs((t, n) => {
            n(e);
          });
        }
        static waitFor(e) {
          return new Gs((t, n) => {
            let r = 0,
              s = 0,
              i = !1;
            e.forEach((e) => {
              ++r,
                e.next(
                  () => {
                    ++s, i && s === r && t();
                  },
                  (e) => n(e)
                );
            }),
              (i = !0),
              s === r && t();
          });
        }
        static or(e) {
          let t = Gs.resolve(!1);
          for (const n of e) t = t.next((e) => (e ? Gs.resolve(e) : n()));
          return t;
        }
        static forEach(e, t) {
          const n = [];
          return (
            e.forEach((e, r) => {
              n.push(t.call(this, e, r));
            }),
            this.waitFor(n)
          );
        }
        static mapArray(e, t) {
          return new Gs((n, r) => {
            const s = e.length,
              i = new Array(s);
            let o = 0;
            for (let a = 0; a < s; a++) {
              const l = a;
              t(e[l]).next(
                (e) => {
                  (i[l] = e), ++o, o === s && n(i);
                },
                (e) => r(e)
              );
            }
          });
        }
        static doWhile(e, t) {
          return new Gs((n, r) => {
            const s = () => {
              !0 === e()
                ? t().next(() => {
                    s();
                  }, r)
                : n();
            };
            s();
          });
        }
      }
      function Hs(e) {
        const t = e.match(/Android ([\d.]+)/i),
          n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
      }
      function Ws(e) {
        return "IndexedDbTransactionError" === e.name;
      }
      class Ks {
        constructor(e, t) {
          (this.previousValue = e), t && ((t.sequenceNumberHandler = (e) => this.ie(e)), (this.se = (e) => t.writeSequenceNumber(e)));
        }
        ie(e) {
          return (this.previousValue = Math.max(e, this.previousValue)), this.previousValue;
        }
        next() {
          const e = ++this.previousValue;
          return this.se && this.se(e), e;
        }
      }
      function Qs(e) {
        return null == e;
      }
      function Ys(e) {
        return 0 === e && 1 / e == -1 / 0;
      }
      function Xs(e) {
        return "number" == typeof e && Number.isInteger(e) && !Ys(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
      }
      function Js(e) {
        let t = "";
        for (let n = 0; n < e.length; n++) t.length > 0 && (t = ei(t)), (t = Zs(e.get(n), t));
        return ei(t);
      }
      function Zs(e, t) {
        let n = t;
        const r = e.length;
        for (let t = 0; t < r; t++) {
          const r = e.charAt(t);
          switch (r) {
            case "\0":
              n += "";
              break;
            case "":
              n += "";
              break;
            default:
              n += r;
          }
        }
        return n;
      }
      function ei(e) {
        return e + "";
      }
      Ks.oe = -1;
      const ti = [
          "mutationQueues",
          "mutations",
          "documentMutations",
          "remoteDocuments",
          "targets",
          "owner",
          "targetGlobal",
          "targetDocuments",
          "clientMetadata",
          "remoteDocumentGlobal",
          "collectionParents",
          "bundles",
          "namedQueries",
        ],
        ni = [
          "mutationQueues",
          "mutations",
          "documentMutations",
          "remoteDocumentsV14",
          "targets",
          "owner",
          "targetGlobal",
          "targetDocuments",
          "clientMetadata",
          "remoteDocumentGlobal",
          "collectionParents",
          "bundles",
          "namedQueries",
          "documentOverlays",
        ],
        ri = ni,
        si = [...ri, "indexConfiguration", "indexState", "indexEntries"];
      function ii(e) {
        let t = 0;
        for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t++;
        return t;
      }
      function oi(e, t) {
        for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
      }
      function ai(e) {
        for (const t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
        return !0;
      }
      class li {
        constructor(e, t) {
          (this.comparator = e), (this.root = t || ui.EMPTY);
        }
        insert(e, t) {
          return new li(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, ui.BLACK, null, null));
        }
        remove(e) {
          return new li(this.comparator, this.root.remove(e, this.comparator).copy(null, null, ui.BLACK, null, null));
        }
        get(e) {
          let t = this.root;
          for (; !t.isEmpty(); ) {
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? (t = t.left) : n > 0 && (t = t.right);
          }
          return null;
        }
        indexOf(e) {
          let t = 0,
            n = this.root;
          for (; !n.isEmpty(); ) {
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? (n = n.left) : ((t += n.left.size + 1), (n = n.right));
          }
          return -1;
        }
        isEmpty() {
          return this.root.isEmpty();
        }
        get size() {
          return this.root.size;
        }
        minKey() {
          return this.root.minKey();
        }
        maxKey() {
          return this.root.maxKey();
        }
        inorderTraversal(e) {
          return this.root.inorderTraversal(e);
        }
        forEach(e) {
          this.inorderTraversal((t, n) => (e(t, n), !1));
        }
        toString() {
          const e = [];
          return this.inorderTraversal((t, n) => (e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
        }
        reverseTraversal(e) {
          return this.root.reverseTraversal(e);
        }
        getIterator() {
          return new ci(this.root, null, this.comparator, !1);
        }
        getIteratorFrom(e) {
          return new ci(this.root, e, this.comparator, !1);
        }
        getReverseIterator() {
          return new ci(this.root, null, this.comparator, !0);
        }
        getReverseIteratorFrom(e) {
          return new ci(this.root, e, this.comparator, !0);
        }
      }
      class ci {
        constructor(e, t, n, r) {
          (this.isReverse = r), (this.nodeStack = []);
          let s = 1;
          for (; !e.isEmpty(); )
            if (((s = t ? n(e.key, t) : 1), t && r && (s *= -1), s < 0)) e = this.isReverse ? e.left : e.right;
            else {
              if (0 === s) {
                this.nodeStack.push(e);
                break;
              }
              this.nodeStack.push(e), (e = this.isReverse ? e.right : e.left);
            }
        }
        getNext() {
          let e = this.nodeStack.pop();
          const t = { key: e.key, value: e.value };
          if (this.isReverse) for (e = e.left; !e.isEmpty(); ) this.nodeStack.push(e), (e = e.right);
          else for (e = e.right; !e.isEmpty(); ) this.nodeStack.push(e), (e = e.left);
          return t;
        }
        hasNext() {
          return this.nodeStack.length > 0;
        }
        peek() {
          if (0 === this.nodeStack.length) return null;
          const e = this.nodeStack[this.nodeStack.length - 1];
          return { key: e.key, value: e.value };
        }
      }
      class ui {
        constructor(e, t, n, r, s) {
          (this.key = e),
            (this.value = t),
            (this.color = null != n ? n : ui.RED),
            (this.left = null != r ? r : ui.EMPTY),
            (this.right = null != s ? s : ui.EMPTY),
            (this.size = this.left.size + 1 + this.right.size);
        }
        copy(e, t, n, r, s) {
          return new ui(
            null != e ? e : this.key,
            null != t ? t : this.value,
            null != n ? n : this.color,
            null != r ? r : this.left,
            null != s ? s : this.right
          );
        }
        isEmpty() {
          return !1;
        }
        inorderTraversal(e) {
          return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
        }
        reverseTraversal(e) {
          return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
        }
        min() {
          return this.left.isEmpty() ? this : this.left.min();
        }
        minKey() {
          return this.min().key;
        }
        maxKey() {
          return this.right.isEmpty() ? this.key : this.right.maxKey();
        }
        insert(e, t, n) {
          let r = this;
          const s = n(e, r.key);
          return (
            (r =
              s < 0
                ? r.copy(null, null, null, r.left.insert(e, t, n), null)
                : 0 === s
                ? r.copy(null, t, null, null, null)
                : r.copy(null, null, null, null, r.right.insert(e, t, n))),
            r.fixUp()
          );
        }
        removeMin() {
          if (this.left.isEmpty()) return ui.EMPTY;
          let e = this;
          return (
            e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()),
            (e = e.copy(null, null, null, e.left.removeMin(), null)),
            e.fixUp()
          );
        }
        remove(e, t) {
          let n,
            r = this;
          if (t(e, r.key) < 0)
            r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()),
              (r = r.copy(null, null, null, r.left.remove(e, t), null));
          else {
            if (
              (r.left.isRed() && (r = r.rotateRight()),
              r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()),
              0 === t(e, r.key))
            ) {
              if (r.right.isEmpty()) return ui.EMPTY;
              (n = r.right.min()), (r = r.copy(n.key, n.value, null, null, r.right.removeMin()));
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
          }
          return r.fixUp();
        }
        isRed() {
          return this.color;
        }
        fixUp() {
          let e = this;
          return (
            e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()),
            e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()),
            e.left.isRed() && e.right.isRed() && (e = e.colorFlip()),
            e
          );
        }
        moveRedLeft() {
          let e = this.colorFlip();
          return (
            e.right.left.isRed() &&
              ((e = e.copy(null, null, null, null, e.right.rotateRight())), (e = e.rotateLeft()), (e = e.colorFlip())),
            e
          );
        }
        moveRedRight() {
          let e = this.colorFlip();
          return e.left.left.isRed() && ((e = e.rotateRight()), (e = e.colorFlip())), e;
        }
        rotateLeft() {
          const e = this.copy(null, null, ui.RED, null, this.right.left);
          return this.right.copy(null, null, this.color, e, null);
        }
        rotateRight() {
          const e = this.copy(null, null, ui.RED, this.left.right, null);
          return this.left.copy(null, null, this.color, null, e);
        }
        colorFlip() {
          const e = this.left.copy(null, null, !this.left.color, null, null),
            t = this.right.copy(null, null, !this.right.color, null, null);
          return this.copy(null, null, !this.color, e, t);
        }
        checkMaxDepth() {
          const e = this.check();
          return Math.pow(2, e) <= this.size + 1;
        }
        check() {
          if (this.isRed() && this.left.isRed()) throw hs();
          if (this.right.isRed()) throw hs();
          const e = this.left.check();
          if (e !== this.right.check()) throw hs();
          return e + (this.isRed() ? 0 : 1);
        }
      }
      (ui.EMPTY = null),
        (ui.RED = !0),
        (ui.BLACK = !1),
        (ui.EMPTY = new (class {
          constructor() {
            this.size = 0;
          }
          get key() {
            throw hs();
          }
          get value() {
            throw hs();
          }
          get color() {
            throw hs();
          }
          get left() {
            throw hs();
          }
          get right() {
            throw hs();
          }
          copy(e, t, n, r, s) {
            return this;
          }
          insert(e, t, n) {
            return new ui(e, t);
          }
          remove(e, t) {
            return this;
          }
          isEmpty() {
            return !0;
          }
          inorderTraversal(e) {
            return !1;
          }
          reverseTraversal(e) {
            return !1;
          }
          minKey() {
            return null;
          }
          maxKey() {
            return null;
          }
          isRed() {
            return !1;
          }
          checkMaxDepth() {
            return !0;
          }
          check() {
            return 0;
          }
        })());
      class di {
        constructor(e) {
          (this.comparator = e), (this.data = new li(this.comparator));
        }
        has(e) {
          return null !== this.data.get(e);
        }
        first() {
          return this.data.minKey();
        }
        last() {
          return this.data.maxKey();
        }
        get size() {
          return this.data.size;
        }
        indexOf(e) {
          return this.data.indexOf(e);
        }
        forEach(e) {
          this.data.inorderTraversal((t, n) => (e(t), !1));
        }
        forEachInRange(e, t) {
          const n = this.data.getIteratorFrom(e[0]);
          for (; n.hasNext(); ) {
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
          }
        }
        forEachWhile(e, t) {
          let n;
          for (n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext(); ) if (!e(n.getNext().key)) return;
        }
        firstAfterOrEqual(e) {
          const t = this.data.getIteratorFrom(e);
          return t.hasNext() ? t.getNext().key : null;
        }
        getIterator() {
          return new hi(this.data.getIterator());
        }
        getIteratorFrom(e) {
          return new hi(this.data.getIteratorFrom(e));
        }
        add(e) {
          return this.copy(this.data.remove(e).insert(e, !0));
        }
        delete(e) {
          return this.has(e) ? this.copy(this.data.remove(e)) : this;
        }
        isEmpty() {
          return this.data.isEmpty();
        }
        unionWith(e) {
          let t = this;
          return (
            t.size < e.size && ((t = e), (e = this)),
            e.forEach((e) => {
              t = t.add(e);
            }),
            t
          );
        }
        isEqual(e) {
          if (!(e instanceof di)) return !1;
          if (this.size !== e.size) return !1;
          const t = this.data.getIterator(),
            n = e.data.getIterator();
          for (; t.hasNext(); ) {
            const e = t.getNext().key,
              r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
          }
          return !0;
        }
        toArray() {
          const e = [];
          return (
            this.forEach((t) => {
              e.push(t);
            }),
            e
          );
        }
        toString() {
          const e = [];
          return this.forEach((t) => e.push(t)), "SortedSet(" + e.toString() + ")";
        }
        copy(e) {
          const t = new di(this.comparator);
          return (t.data = e), t;
        }
      }
      class hi {
        constructor(e) {
          this.iter = e;
        }
        getNext() {
          return this.iter.getNext().key;
        }
        hasNext() {
          return this.iter.hasNext();
        }
      }
      class pi {
        constructor(e) {
          (this.fields = e), e.sort(Os.comparator);
        }
        static empty() {
          return new pi([]);
        }
        unionWith(e) {
          let t = new di(Os.comparator);
          for (const e of this.fields) t = t.add(e);
          for (const n of e) t = t.add(n);
          return new pi(t.toArray());
        }
        covers(e) {
          for (const t of this.fields) if (t.isPrefixOf(e)) return !0;
          return !1;
        }
        isEqual(e) {
          return ks(this.fields, e.fields, (e, t) => e.isEqual(t));
        }
      }
      class fi extends Error {
        constructor() {
          super(...arguments), (this.name = "Base64DecodeError");
        }
      }
      class mi {
        constructor(e) {
          this.binaryString = e;
        }
        static fromBase64String(e) {
          const t = (function (e) {
            try {
              return atob(e);
            } catch (e) {
              throw "undefined" != typeof DOMException && e instanceof DOMException ? new fi("Invalid base64 string: " + e) : e;
            }
          })(e);
          return new mi(t);
        }
        static fromUint8Array(e) {
          const t = (function (e) {
            let t = "";
            for (let n = 0; n < e.length; ++n) t += String.fromCharCode(e[n]);
            return t;
          })(e);
          return new mi(t);
        }
        [Symbol.iterator]() {
          let e = 0;
          return {
            next: () =>
              e < this.binaryString.length ? { value: this.binaryString.charCodeAt(e++), done: !1 } : { value: void 0, done: !0 },
          };
        }
        toBase64() {
          return (function (e) {
            return btoa(e);
          })(this.binaryString);
        }
        toUint8Array() {
          return (function (e) {
            const t = new Uint8Array(e.length);
            for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
            return t;
          })(this.binaryString);
        }
        approximateByteSize() {
          return 2 * this.binaryString.length;
        }
        compareTo(e) {
          return Is(this.binaryString, e.binaryString);
        }
        isEqual(e) {
          return this.binaryString === e.binaryString;
        }
      }
      mi.EMPTY_BYTE_STRING = new mi("");
      const gi = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
      function yi(e) {
        if ((ps(!!e), "string" == typeof e)) {
          let t = 0;
          const n = gi.exec(e);
          if ((ps(!!n), n[1])) {
            let e = n[1];
            (e = (e + "000000000").substr(0, 9)), (t = Number(e));
          }
          const r = new Date(e);
          return { seconds: Math.floor(r.getTime() / 1e3), nanos: t };
        }
        return { seconds: vi(e.seconds), nanos: vi(e.nanos) };
      }
      function vi(e) {
        return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
      }
      function wi(e) {
        return "string" == typeof e ? mi.fromBase64String(e) : mi.fromUint8Array(e);
      }
      function bi(e) {
        var t, n;
        return (
          "server_timestamp" ===
          (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) ||
          void 0 === n
            ? void 0
            : n.stringValue)
        );
      }
      function Si(e) {
        const t = e.mapValue.fields.__previous_value__;
        return bi(t) ? Si(t) : t;
      }
      function Ei(e) {
        const t = yi(e.mapValue.fields.__local_write_time__.timestampValue);
        return new Ls(t.seconds, t.nanos);
      }
      class Ti {
        constructor(e, t, n, r, s, i, o, a, l) {
          (this.databaseId = e),
            (this.appId = t),
            (this.persistenceKey = n),
            (this.host = r),
            (this.ssl = s),
            (this.forceLongPolling = i),
            (this.autoDetectLongPolling = o),
            (this.longPollingOptions = a),
            (this.useFetchStreams = l);
        }
      }
      class _i {
        constructor(e, t) {
          (this.projectId = e), (this.database = t || "(default)");
        }
        static empty() {
          return new _i("", "");
        }
        get isDefaultDatabase() {
          return "(default)" === this.database;
        }
        isEqual(e) {
          return e instanceof _i && e.projectId === this.projectId && e.database === this.database;
        }
      }
      const Ci = { mapValue: { fields: { __type__: { stringValue: "__max__" } } } };
      function xi(e) {
        return "nullValue" in e
          ? 0
          : "booleanValue" in e
          ? 1
          : "integerValue" in e || "doubleValue" in e
          ? 2
          : "timestampValue" in e
          ? 3
          : "stringValue" in e
          ? 5
          : "bytesValue" in e
          ? 6
          : "referenceValue" in e
          ? 7
          : "geoPointValue" in e
          ? 8
          : "arrayValue" in e
          ? 9
          : "mapValue" in e
          ? bi(e)
            ? 4
            : ji(e)
            ? 9007199254740991
            : $i(e)
            ? 10
            : 11
          : hs();
      }
      function Ai(e, t) {
        if (e === t) return !0;
        const n = xi(e);
        if (n !== xi(t)) return !1;
        switch (n) {
          case 0:
          case 9007199254740991:
            return !0;
          case 1:
            return e.booleanValue === t.booleanValue;
          case 4:
            return Ei(e).isEqual(Ei(t));
          case 3:
            return (function (e, t) {
              if (
                "string" == typeof e.timestampValue &&
                "string" == typeof t.timestampValue &&
                e.timestampValue.length === t.timestampValue.length
              )
                return e.timestampValue === t.timestampValue;
              const n = yi(e.timestampValue),
                r = yi(t.timestampValue);
              return n.seconds === r.seconds && n.nanos === r.nanos;
            })(e, t);
          case 5:
            return e.stringValue === t.stringValue;
          case 6:
            return (function (e, t) {
              return wi(e.bytesValue).isEqual(wi(t.bytesValue));
            })(e, t);
          case 7:
            return e.referenceValue === t.referenceValue;
          case 8:
            return (function (e, t) {
              return (
                vi(e.geoPointValue.latitude) === vi(t.geoPointValue.latitude) &&
                vi(e.geoPointValue.longitude) === vi(t.geoPointValue.longitude)
              );
            })(e, t);
          case 2:
            return (function (e, t) {
              if ("integerValue" in e && "integerValue" in t) return vi(e.integerValue) === vi(t.integerValue);
              if ("doubleValue" in e && "doubleValue" in t) {
                const n = vi(e.doubleValue),
                  r = vi(t.doubleValue);
                return n === r ? Ys(n) === Ys(r) : isNaN(n) && isNaN(r);
              }
              return !1;
            })(e, t);
          case 9:
            return ks(e.arrayValue.values || [], t.arrayValue.values || [], Ai);
          case 10:
          case 11:
            return (function (e, t) {
              const n = e.mapValue.fields || {},
                r = t.mapValue.fields || {};
              if (ii(n) !== ii(r)) return !1;
              for (const e in n) if (n.hasOwnProperty(e) && (void 0 === r[e] || !Ai(n[e], r[e]))) return !1;
              return !0;
            })(e, t);
          default:
            return hs();
        }
      }
      function Ii(e, t) {
        return void 0 !== (e.values || []).find((e) => Ai(e, t));
      }
      function ki(e, t) {
        if (e === t) return 0;
        const n = xi(e),
          r = xi(t);
        if (n !== r) return Is(n, r);
        switch (n) {
          case 0:
          case 9007199254740991:
            return 0;
          case 1:
            return Is(e.booleanValue, t.booleanValue);
          case 2:
            return (function (e, t) {
              const n = vi(e.integerValue || e.doubleValue),
                r = vi(t.integerValue || t.doubleValue);
              return n < r ? -1 : n > r ? 1 : n === r ? 0 : isNaN(n) ? (isNaN(r) ? 0 : -1) : 1;
            })(e, t);
          case 3:
            return Li(e.timestampValue, t.timestampValue);
          case 4:
            return Li(Ei(e), Ei(t));
          case 5:
            return Is(e.stringValue, t.stringValue);
          case 6:
            return (function (e, t) {
              const n = wi(e),
                r = wi(t);
              return n.compareTo(r);
            })(e.bytesValue, t.bytesValue);
          case 7:
            return (function (e, t) {
              const n = e.split("/"),
                r = t.split("/");
              for (let e = 0; e < n.length && e < r.length; e++) {
                const t = Is(n[e], r[e]);
                if (0 !== t) return t;
              }
              return Is(n.length, r.length);
            })(e.referenceValue, t.referenceValue);
          case 8:
            return (function (e, t) {
              const n = Is(vi(e.latitude), vi(t.latitude));
              return 0 !== n ? n : Is(vi(e.longitude), vi(t.longitude));
            })(e.geoPointValue, t.geoPointValue);
          case 9:
            return Mi(e.arrayValue, t.arrayValue);
          case 10:
            return (function (e, t) {
              var n, r, s, i;
              const o = e.fields || {},
                a = t.fields || {},
                l = null === (n = o.value) || void 0 === n ? void 0 : n.arrayValue,
                c = null === (r = a.value) || void 0 === r ? void 0 : r.arrayValue,
                u = Is(
                  (null === (s = null == l ? void 0 : l.values) || void 0 === s ? void 0 : s.length) || 0,
                  (null === (i = null == c ? void 0 : c.values) || void 0 === i ? void 0 : i.length) || 0
                );
              return 0 !== u ? u : Mi(l, c);
            })(e.mapValue, t.mapValue);
          case 11:
            return (function (e, t) {
              if (e === Ci.mapValue && t === Ci.mapValue) return 0;
              if (e === Ci.mapValue) return 1;
              if (t === Ci.mapValue) return -1;
              const n = e.fields || {},
                r = Object.keys(n),
                s = t.fields || {},
                i = Object.keys(s);
              r.sort(), i.sort();
              for (let e = 0; e < r.length && e < i.length; ++e) {
                const t = Is(r[e], i[e]);
                if (0 !== t) return t;
                const o = ki(n[r[e]], s[i[e]]);
                if (0 !== o) return o;
              }
              return Is(r.length, i.length);
            })(e.mapValue, t.mapValue);
          default:
            throw hs();
        }
      }
      function Li(e, t) {
        if ("string" == typeof e && "string" == typeof t && e.length === t.length) return Is(e, t);
        const n = yi(e),
          r = yi(t),
          s = Is(n.seconds, r.seconds);
        return 0 !== s ? s : Is(n.nanos, r.nanos);
      }
      function Mi(e, t) {
        const n = e.values || [],
          r = t.values || [];
        for (let e = 0; e < n.length && e < r.length; ++e) {
          const t = ki(n[e], r[e]);
          if (t) return t;
        }
        return Is(n.length, r.length);
      }
      function Di(e) {
        return Ni(e);
      }
      function Ni(e) {
        return "nullValue" in e
          ? "null"
          : "booleanValue" in e
          ? "" + e.booleanValue
          : "integerValue" in e
          ? "" + e.integerValue
          : "doubleValue" in e
          ? "" + e.doubleValue
          : "timestampValue" in e
          ? (function (e) {
              const t = yi(e);
              return `time(${t.seconds},${t.nanos})`;
            })(e.timestampValue)
          : "stringValue" in e
          ? e.stringValue
          : "bytesValue" in e
          ? (function (e) {
              return wi(e).toBase64();
            })(e.bytesValue)
          : "referenceValue" in e
          ? (function (e) {
              return qs.fromName(e).toString();
            })(e.referenceValue)
          : "geoPointValue" in e
          ? (function (e) {
              return `geo(${e.latitude},${e.longitude})`;
            })(e.geoPointValue)
          : "arrayValue" in e
          ? (function (e) {
              let t = "[",
                n = !0;
              for (const r of e.values || []) n ? (n = !1) : (t += ","), (t += Ni(r));
              return t + "]";
            })(e.arrayValue)
          : "mapValue" in e
          ? (function (e) {
              const t = Object.keys(e.fields || {}).sort();
              let n = "{",
                r = !0;
              for (const s of t) r ? (r = !1) : (n += ","), (n += `${s}:${Ni(e.fields[s])}`);
              return n + "}";
            })(e.mapValue)
          : hs();
      }
      function Pi(e) {
        switch (xi(e)) {
          case 0:
          case 1:
            return 4;
          case 2:
            return 8;
          case 3:
          case 8:
            return 16;
          case 4:
            const t = Si(e);
            return t ? 16 + Pi(t) : 16;
          case 5:
            return 2 * e.stringValue.length;
          case 6:
            return wi(e.bytesValue).approximateByteSize();
          case 7:
            return e.referenceValue.length;
          case 9:
            return (function (e) {
              return (e.values || []).reduce((e, t) => e + Pi(t), 0);
            })(e.arrayValue);
          case 10:
          case 11:
            return (function (e) {
              let t = 0;
              return (
                oi(e.fields, (e, n) => {
                  t += e.length + Pi(n);
                }),
                t
              );
            })(e.mapValue);
          default:
            throw hs();
        }
      }
      function Oi(e) {
        return !!e && "integerValue" in e;
      }
      function qi(e) {
        return !!e && "arrayValue" in e;
      }
      function Ri(e) {
        return !!e && "nullValue" in e;
      }
      function Fi(e) {
        return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
      }
      function Bi(e) {
        return !!e && "mapValue" in e;
      }
      function $i(e) {
        var t, n;
        return (
          "__vector__" ===
          (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) ||
          void 0 === n
            ? void 0
            : n.stringValue)
        );
      }
      function Vi(e) {
        if (e.geoPointValue) return { geoPointValue: Object.assign({}, e.geoPointValue) };
        if (e.timestampValue && "object" == typeof e.timestampValue) return { timestampValue: Object.assign({}, e.timestampValue) };
        if (e.mapValue) {
          const t = { mapValue: { fields: {} } };
          return oi(e.mapValue.fields, (e, n) => (t.mapValue.fields[e] = Vi(n))), t;
        }
        if (e.arrayValue) {
          const t = { arrayValue: { values: [] } };
          for (let n = 0; n < (e.arrayValue.values || []).length; ++n) t.arrayValue.values[n] = Vi(e.arrayValue.values[n]);
          return t;
        }
        return Object.assign({}, e);
      }
      function ji(e) {
        return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
      }
      class zi {
        constructor(e) {
          this.value = e;
        }
        static empty() {
          return new zi({ mapValue: {} });
        }
        field(e) {
          if (e.isEmpty()) return this.value;
          {
            let t = this.value;
            for (let n = 0; n < e.length - 1; ++n) if (((t = (t.mapValue.fields || {})[e.get(n)]), !Bi(t))) return null;
            return (t = (t.mapValue.fields || {})[e.lastSegment()]), t || null;
          }
        }
        set(e, t) {
          this.getFieldsMap(e.popLast())[e.lastSegment()] = Vi(t);
        }
        setAll(e) {
          let t = Os.emptyPath(),
            n = {},
            r = [];
          e.forEach((e, s) => {
            if (!t.isImmediateParentOf(s)) {
              const e = this.getFieldsMap(t);
              this.applyChanges(e, n, r), (n = {}), (r = []), (t = s.popLast());
            }
            e ? (n[s.lastSegment()] = Vi(e)) : r.push(s.lastSegment());
          });
          const s = this.getFieldsMap(t);
          this.applyChanges(s, n, r);
        }
        delete(e) {
          const t = this.field(e.popLast());
          Bi(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
        }
        isEqual(e) {
          return Ai(this.value, e.value);
        }
        getFieldsMap(e) {
          let t = this.value;
          t.mapValue.fields || (t.mapValue = { fields: {} });
          for (let n = 0; n < e.length; ++n) {
            let r = t.mapValue.fields[e.get(n)];
            (Bi(r) && r.mapValue.fields) || ((r = { mapValue: { fields: {} } }), (t.mapValue.fields[e.get(n)] = r)), (t = r);
          }
          return t.mapValue.fields;
        }
        applyChanges(e, t, n) {
          oi(t, (t, n) => (e[t] = n));
          for (const t of n) delete e[t];
        }
        clone() {
          return new zi(Vi(this.value));
        }
      }
      function Ui(e) {
        const t = [];
        return (
          oi(e.fields, (e, n) => {
            const r = new Os([e]);
            if (Bi(n)) {
              const e = Ui(n.mapValue).fields;
              if (0 === e.length) t.push(r);
              else for (const n of e) t.push(r.child(n));
            } else t.push(r);
          }),
          new pi(t)
        );
      }
      class Gi {
        constructor(e, t, n, r, s, i, o) {
          (this.key = e),
            (this.documentType = t),
            (this.version = n),
            (this.readTime = r),
            (this.createTime = s),
            (this.data = i),
            (this.documentState = o);
        }
        static newInvalidDocument(e) {
          return new Gi(e, 0, Ms.min(), Ms.min(), Ms.min(), zi.empty(), 0);
        }
        static newFoundDocument(e, t, n, r) {
          return new Gi(e, 1, t, Ms.min(), n, r, 0);
        }
        static newNoDocument(e, t) {
          return new Gi(e, 2, t, Ms.min(), Ms.min(), zi.empty(), 0);
        }
        static newUnknownDocument(e, t) {
          return new Gi(e, 3, t, Ms.min(), Ms.min(), zi.empty(), 2);
        }
        convertToFoundDocument(e, t) {
          return (
            !this.createTime.isEqual(Ms.min()) || (2 !== this.documentType && 0 !== this.documentType) || (this.createTime = e),
            (this.version = e),
            (this.documentType = 1),
            (this.data = t),
            (this.documentState = 0),
            this
          );
        }
        convertToNoDocument(e) {
          return (this.version = e), (this.documentType = 2), (this.data = zi.empty()), (this.documentState = 0), this;
        }
        convertToUnknownDocument(e) {
          return (this.version = e), (this.documentType = 3), (this.data = zi.empty()), (this.documentState = 2), this;
        }
        setHasCommittedMutations() {
          return (this.documentState = 2), this;
        }
        setHasLocalMutations() {
          return (this.documentState = 1), (this.version = Ms.min()), this;
        }
        setReadTime(e) {
          return (this.readTime = e), this;
        }
        get hasLocalMutations() {
          return 1 === this.documentState;
        }
        get hasCommittedMutations() {
          return 2 === this.documentState;
        }
        get hasPendingWrites() {
          return this.hasLocalMutations || this.hasCommittedMutations;
        }
        isValidDocument() {
          return 0 !== this.documentType;
        }
        isFoundDocument() {
          return 1 === this.documentType;
        }
        isNoDocument() {
          return 2 === this.documentType;
        }
        isUnknownDocument() {
          return 3 === this.documentType;
        }
        isEqual(e) {
          return (
            e instanceof Gi &&
            this.key.isEqual(e.key) &&
            this.version.isEqual(e.version) &&
            this.documentType === e.documentType &&
            this.documentState === e.documentState &&
            this.data.isEqual(e.data)
          );
        }
        mutableCopy() {
          return new Gi(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
        }
        toString() {
          return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${
            this.createTime
          }}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
        }
      }
      class Hi {
        constructor(e, t) {
          (this.position = e), (this.inclusive = t);
        }
      }
      function Wi(e, t, n) {
        let r = 0;
        for (let s = 0; s < e.position.length; s++) {
          const i = t[s],
            o = e.position[s];
          if (
            ((r = i.field.isKeyField() ? qs.comparator(qs.fromName(o.referenceValue), n.key) : ki(o, n.data.field(i.field))),
            "desc" === i.dir && (r *= -1),
            0 !== r)
          )
            break;
        }
        return r;
      }
      function Ki(e, t) {
        if (null === e) return null === t;
        if (null === t) return !1;
        if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
        for (let n = 0; n < e.position.length; n++) if (!Ai(e.position[n], t.position[n])) return !1;
        return !0;
      }
      class Qi {
        constructor(e, t = "asc") {
          (this.field = e), (this.dir = t);
        }
      }
      function Yi(e, t) {
        return e.dir === t.dir && e.field.isEqual(t.field);
      }
      class Xi {}
      class Ji extends Xi {
        constructor(e, t, n) {
          super(), (this.field = e), (this.op = t), (this.value = n);
        }
        static create(e, t, n) {
          return e.isKeyField()
            ? "in" === t || "not-in" === t
              ? this.createKeyFieldInFilter(e, t, n)
              : new oo(e, t, n)
            : "array-contains" === t
            ? new uo(e, n)
            : "in" === t
            ? new ho(e, n)
            : "not-in" === t
            ? new po(e, n)
            : "array-contains-any" === t
            ? new fo(e, n)
            : new Ji(e, t, n);
        }
        static createKeyFieldInFilter(e, t, n) {
          return "in" === t ? new ao(e, n) : new lo(e, n);
        }
        matches(e) {
          const t = e.data.field(this.field);
          return "!=" === this.op
            ? null !== t && this.matchesComparison(ki(t, this.value))
            : null !== t && xi(this.value) === xi(t) && this.matchesComparison(ki(t, this.value));
        }
        matchesComparison(e) {
          switch (this.op) {
            case "<":
              return e < 0;
            case "<=":
              return e <= 0;
            case "==":
              return 0 === e;
            case "!=":
              return 0 !== e;
            case ">":
              return e > 0;
            case ">=":
              return e >= 0;
            default:
              return hs();
          }
        }
        isInequality() {
          return ["<", "<=", ">", ">=", "!=", "not-in"].indexOf(this.op) >= 0;
        }
        getFlattenedFilters() {
          return [this];
        }
        getFilters() {
          return [this];
        }
      }
      class Zi extends Xi {
        constructor(e, t) {
          super(), (this.filters = e), (this.op = t), (this.ae = null);
        }
        static create(e, t) {
          return new Zi(e, t);
        }
        matches(e) {
          return eo(this) ? void 0 === this.filters.find((t) => !t.matches(e)) : void 0 !== this.filters.find((t) => t.matches(e));
        }
        getFlattenedFilters() {
          return null !== this.ae || (this.ae = this.filters.reduce((e, t) => e.concat(t.getFlattenedFilters()), [])), this.ae;
        }
        getFilters() {
          return Object.assign([], this.filters);
        }
      }
      function eo(e) {
        return "and" === e.op;
      }
      function to(e) {
        return no(e) && eo(e);
      }
      function no(e) {
        for (const t of e.filters) if (t instanceof Zi) return !1;
        return !0;
      }
      function ro(e) {
        if (e instanceof Ji) return e.field.canonicalString() + e.op.toString() + Di(e.value);
        if (to(e)) return e.filters.map((e) => ro(e)).join(",");
        {
          const t = e.filters.map((e) => ro(e)).join(",");
          return `${e.op}(${t})`;
        }
      }
      function so(e, t) {
        return e instanceof Ji
          ? (function (e, t) {
              return t instanceof Ji && e.op === t.op && e.field.isEqual(t.field) && Ai(e.value, t.value);
            })(e, t)
          : e instanceof Zi
          ? (function (e, t) {
              return (
                t instanceof Zi &&
                e.op === t.op &&
                e.filters.length === t.filters.length &&
                e.filters.reduce((e, n, r) => e && so(n, t.filters[r]), !0)
              );
            })(e, t)
          : void hs();
      }
      function io(e) {
        return e instanceof Ji
          ? (function (e) {
              return `${e.field.canonicalString()} ${e.op} ${Di(e.value)}`;
            })(e)
          : e instanceof Zi
          ? (function (e) {
              return e.op.toString() + " {" + e.getFilters().map(io).join(" ,") + "}";
            })(e)
          : "Filter";
      }
      class oo extends Ji {
        constructor(e, t, n) {
          super(e, t, n), (this.key = qs.fromName(n.referenceValue));
        }
        matches(e) {
          const t = qs.comparator(e.key, this.key);
          return this.matchesComparison(t);
        }
      }
      class ao extends Ji {
        constructor(e, t) {
          super(e, "in", t), (this.keys = co("in", t));
        }
        matches(e) {
          return this.keys.some((t) => t.isEqual(e.key));
        }
      }
      class lo extends Ji {
        constructor(e, t) {
          super(e, "not-in", t), (this.keys = co("not-in", t));
        }
        matches(e) {
          return !this.keys.some((t) => t.isEqual(e.key));
        }
      }
      function co(e, t) {
        var n;
        return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e) => qs.fromName(e.referenceValue));
      }
      class uo extends Ji {
        constructor(e, t) {
          super(e, "array-contains", t);
        }
        matches(e) {
          const t = e.data.field(this.field);
          return qi(t) && Ii(t.arrayValue, this.value);
        }
      }
      class ho extends Ji {
        constructor(e, t) {
          super(e, "in", t);
        }
        matches(e) {
          const t = e.data.field(this.field);
          return null !== t && Ii(this.value.arrayValue, t);
        }
      }
      class po extends Ji {
        constructor(e, t) {
          super(e, "not-in", t);
        }
        matches(e) {
          if (Ii(this.value.arrayValue, { nullValue: "NULL_VALUE" })) return !1;
          const t = e.data.field(this.field);
          return null !== t && !Ii(this.value.arrayValue, t);
        }
      }
      class fo extends Ji {
        constructor(e, t) {
          super(e, "array-contains-any", t);
        }
        matches(e) {
          const t = e.data.field(this.field);
          return !(!qi(t) || !t.arrayValue.values) && t.arrayValue.values.some((e) => Ii(this.value.arrayValue, e));
        }
      }
      class mo {
        constructor(e, t = null, n = [], r = [], s = null, i = null, o = null) {
          (this.path = e),
            (this.collectionGroup = t),
            (this.orderBy = n),
            (this.filters = r),
            (this.limit = s),
            (this.startAt = i),
            (this.endAt = o),
            (this.ue = null);
        }
      }
      function go(e, t = null, n = [], r = [], s = null, i = null, o = null) {
        return new mo(e, t, n, r, s, i, o);
      }
      function yo(e) {
        const t = fs(e);
        if (null === t.ue) {
          let e = t.path.canonicalString();
          null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup),
            (e += "|f:"),
            (e += t.filters.map((e) => ro(e)).join(",")),
            (e += "|ob:"),
            (e += t.orderBy
              .map((e) =>
                (function (e) {
                  return e.field.canonicalString() + e.dir;
                })(e)
              )
              .join(",")),
            Qs(t.limit) || ((e += "|l:"), (e += t.limit)),
            t.startAt && ((e += "|lb:"), (e += t.startAt.inclusive ? "b:" : "a:"), (e += t.startAt.position.map((e) => Di(e)).join(","))),
            t.endAt && ((e += "|ub:"), (e += t.endAt.inclusive ? "a:" : "b:"), (e += t.endAt.position.map((e) => Di(e)).join(","))),
            (t.ue = e);
        }
        return t.ue;
      }
      function vo(e, t) {
        if (e.limit !== t.limit) return !1;
        if (e.orderBy.length !== t.orderBy.length) return !1;
        for (let n = 0; n < e.orderBy.length; n++) if (!Yi(e.orderBy[n], t.orderBy[n])) return !1;
        if (e.filters.length !== t.filters.length) return !1;
        for (let n = 0; n < e.filters.length; n++) if (!so(e.filters[n], t.filters[n])) return !1;
        return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!Ki(e.startAt, t.startAt) && Ki(e.endAt, t.endAt);
      }
      function wo(e) {
        return qs.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
      }
      class bo {
        constructor(e, t = null, n = [], r = [], s = null, i = "F", o = null, a = null) {
          (this.path = e),
            (this.collectionGroup = t),
            (this.explicitOrderBy = n),
            (this.filters = r),
            (this.limit = s),
            (this.limitType = i),
            (this.startAt = o),
            (this.endAt = a),
            (this.ce = null),
            (this.le = null),
            (this.he = null),
            this.startAt,
            this.endAt;
        }
      }
      function So(e, t, n, r, s, i, o, a) {
        return new bo(e, t, n, r, s, i, o, a);
      }
      function Eo(e) {
        return new bo(e);
      }
      function To(e) {
        return (
          0 === e.filters.length &&
          null === e.limit &&
          null == e.startAt &&
          null == e.endAt &&
          (0 === e.explicitOrderBy.length || (1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField()))
        );
      }
      function _o(e) {
        return null !== e.collectionGroup;
      }
      function Co(e) {
        const t = fs(e);
        if (null === t.ce) {
          t.ce = [];
          const e = new Set();
          for (const n of t.explicitOrderBy) t.ce.push(n), e.add(n.field.canonicalString());
          const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc",
            r = (function (e) {
              let t = new di(Os.comparator);
              return (
                e.filters.forEach((e) => {
                  e.getFlattenedFilters().forEach((e) => {
                    e.isInequality() && (t = t.add(e.field));
                  });
                }),
                t
              );
            })(t);
          r.forEach((r) => {
            e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new Qi(r, n));
          }),
            e.has(Os.keyField().canonicalString()) || t.ce.push(new Qi(Os.keyField(), n));
        }
        return t.ce;
      }
      function xo(e) {
        const t = fs(e);
        return t.le || (t.le = Ao(t, Co(e))), t.le;
      }
      function Ao(e, t) {
        if ("F" === e.limitType) return go(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
        {
          t = t.map((e) => {
            const t = "desc" === e.dir ? "asc" : "desc";
            return new Qi(e.field, t);
          });
          const n = e.endAt ? new Hi(e.endAt.position, e.endAt.inclusive) : null,
            r = e.startAt ? new Hi(e.startAt.position, e.startAt.inclusive) : null;
          return go(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
        }
      }
      function Io(e, t, n) {
        return new bo(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
      }
      function ko(e, t) {
        return vo(xo(e), xo(t)) && e.limitType === t.limitType;
      }
      function Lo(e) {
        return `${yo(xo(e))}|lt:${e.limitType}`;
      }
      function Mo(e) {
        return `Query(target=${(function (e) {
          let t = e.path.canonicalString();
          return (
            null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup),
            e.filters.length > 0 && (t += `, filters: [${e.filters.map((e) => io(e)).join(", ")}]`),
            Qs(e.limit) || (t += ", limit: " + e.limit),
            e.orderBy.length > 0 &&
              (t += `, orderBy: [${e.orderBy
                .map((e) =>
                  (function (e) {
                    return `${e.field.canonicalString()} (${e.dir})`;
                  })(e)
                )
                .join(", ")}]`),
            e.startAt &&
              ((t += ", startAt: "), (t += e.startAt.inclusive ? "b:" : "a:"), (t += e.startAt.position.map((e) => Di(e)).join(","))),
            e.endAt && ((t += ", endAt: "), (t += e.endAt.inclusive ? "a:" : "b:"), (t += e.endAt.position.map((e) => Di(e)).join(","))),
            `Target(${t})`
          );
        })(xo(e))}; limitType=${e.limitType})`;
      }
      function Do(e, t) {
        return (
          t.isFoundDocument() &&
          (function (e, t) {
            const n = t.key.path;
            return null !== e.collectionGroup
              ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n)
              : qs.isDocumentKey(e.path)
              ? e.path.isEqual(n)
              : e.path.isImmediateParentOf(n);
          })(e, t) &&
          (function (e, t) {
            for (const n of Co(e)) if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
            return !0;
          })(e, t) &&
          (function (e, t) {
            for (const n of e.filters) if (!n.matches(t)) return !1;
            return !0;
          })(e, t) &&
          (function (e, t) {
            return (
              !(
                e.startAt &&
                !(function (e, t, n) {
                  const r = Wi(e, t, n);
                  return e.inclusive ? r <= 0 : r < 0;
                })(e.startAt, Co(e), t)
              ) &&
              !(
                e.endAt &&
                !(function (e, t, n) {
                  const r = Wi(e, t, n);
                  return e.inclusive ? r >= 0 : r > 0;
                })(e.endAt, Co(e), t)
              )
            );
          })(e, t)
        );
      }
      function No(e) {
        return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
      }
      function Po(e) {
        return (t, n) => {
          let r = !1;
          for (const s of Co(e)) {
            const e = Oo(s, t, n);
            if (0 !== e) return e;
            r = r || s.field.isKeyField();
          }
          return 0;
        };
      }
      function Oo(e, t, n) {
        const r = e.field.isKeyField()
          ? qs.comparator(t.key, n.key)
          : (function (e, t, n) {
              const r = t.data.field(e),
                s = n.data.field(e);
              return null !== r && null !== s ? ki(r, s) : hs();
            })(e.field, t, n);
        switch (e.dir) {
          case "asc":
            return r;
          case "desc":
            return -1 * r;
          default:
            return hs();
        }
      }
      class qo {
        constructor(e, t) {
          (this.mapKeyFn = e), (this.equalsFn = t), (this.inner = {}), (this.innerSize = 0);
        }
        get(e) {
          const t = this.mapKeyFn(e),
            n = this.inner[t];
          if (void 0 !== n) for (const [t, r] of n) if (this.equalsFn(t, e)) return r;
        }
        has(e) {
          return void 0 !== this.get(e);
        }
        set(e, t) {
          const n = this.mapKeyFn(e),
            r = this.inner[n];
          if (void 0 === r) return (this.inner[n] = [[e, t]]), void this.innerSize++;
          for (let n = 0; n < r.length; n++) if (this.equalsFn(r[n][0], e)) return void (r[n] = [e, t]);
          r.push([e, t]), this.innerSize++;
        }
        delete(e) {
          const t = this.mapKeyFn(e),
            n = this.inner[t];
          if (void 0 === n) return !1;
          for (let r = 0; r < n.length; r++)
            if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
          return !1;
        }
        forEach(e) {
          oi(this.inner, (t, n) => {
            for (const [t, r] of n) e(t, r);
          });
        }
        isEmpty() {
          return ai(this.inner);
        }
        size() {
          return this.innerSize;
        }
      }
      const Ro = new li(qs.comparator);
      function Fo() {
        return Ro;
      }
      const Bo = new li(qs.comparator);
      function $o(...e) {
        let t = Bo;
        for (const n of e) t = t.insert(n.key, n);
        return t;
      }
      function Vo(e) {
        let t = Bo;
        return e.forEach((e, n) => (t = t.insert(e, n.overlayedDocument))), t;
      }
      function jo() {
        return Uo();
      }
      function zo() {
        return Uo();
      }
      function Uo() {
        return new qo(
          (e) => e.toString(),
          (e, t) => e.isEqual(t)
        );
      }
      const Go = new li(qs.comparator),
        Ho = new di(qs.comparator);
      function Wo(...e) {
        let t = Ho;
        for (const n of e) t = t.add(n);
        return t;
      }
      const Ko = new di(Is);
      function Qo() {
        return Ko;
      }
      function Yo(e, t) {
        if (e.useProto3Json) {
          if (isNaN(t)) return { doubleValue: "NaN" };
          if (t === 1 / 0) return { doubleValue: "Infinity" };
          if (t === -1 / 0) return { doubleValue: "-Infinity" };
        }
        return { doubleValue: Ys(t) ? "-0" : t };
      }
      function Xo(e) {
        return { integerValue: "" + e };
      }
      function Jo(e, t) {
        return Xs(t) ? Xo(t) : Yo(e, t);
      }
      class Zo {
        constructor() {
          this._ = void 0;
        }
      }
      function ea(e, t, n) {
        return e instanceof ra
          ? (function (e, t) {
              const n = {
                fields: {
                  __type__: { stringValue: "server_timestamp" },
                  __local_write_time__: { timestampValue: { seconds: e.seconds, nanos: e.nanoseconds } },
                },
              };
              return t && bi(t) && (t = Si(t)), t && (n.fields.__previous_value__ = t), { mapValue: n };
            })(n, t)
          : e instanceof sa
          ? ia(e, t)
          : e instanceof oa
          ? aa(e, t)
          : (function (e, t) {
              const n = na(e, t),
                r = ca(n) + ca(e.Pe);
              return Oi(n) && Oi(e.Pe) ? Xo(r) : Yo(e.serializer, r);
            })(e, t);
      }
      function ta(e, t, n) {
        return e instanceof sa ? ia(e, t) : e instanceof oa ? aa(e, t) : n;
      }
      function na(e, t) {
        return e instanceof la
          ? (function (e) {
              return (
                Oi(e) ||
                (function (e) {
                  return !!e && "doubleValue" in e;
                })(e)
              );
            })(t)
            ? t
            : { integerValue: 0 }
          : null;
      }
      class ra extends Zo {}
      class sa extends Zo {
        constructor(e) {
          super(), (this.elements = e);
        }
      }
      function ia(e, t) {
        const n = ua(t);
        for (const t of e.elements) n.some((e) => Ai(e, t)) || n.push(t);
        return { arrayValue: { values: n } };
      }
      class oa extends Zo {
        constructor(e) {
          super(), (this.elements = e);
        }
      }
      function aa(e, t) {
        let n = ua(t);
        for (const t of e.elements) n = n.filter((e) => !Ai(e, t));
        return { arrayValue: { values: n } };
      }
      class la extends Zo {
        constructor(e, t) {
          super(), (this.serializer = e), (this.Pe = t);
        }
      }
      function ca(e) {
        return vi(e.integerValue || e.doubleValue);
      }
      function ua(e) {
        return qi(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
      }
      class da {
        constructor(e, t) {
          (this.version = e), (this.transformResults = t);
        }
      }
      class ha {
        constructor(e, t) {
          (this.updateTime = e), (this.exists = t);
        }
        static none() {
          return new ha();
        }
        static exists(e) {
          return new ha(void 0, e);
        }
        static updateTime(e) {
          return new ha(e);
        }
        get isNone() {
          return void 0 === this.updateTime && void 0 === this.exists;
        }
        isEqual(e) {
          return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
        }
      }
      function pa(e, t) {
        return void 0 !== e.updateTime
          ? t.isFoundDocument() && t.version.isEqual(e.updateTime)
          : void 0 === e.exists || e.exists === t.isFoundDocument();
      }
      class fa {}
      function ma(e, t) {
        if (!e.hasLocalMutations || (t && 0 === t.fields.length)) return null;
        if (null === t) return e.isNoDocument() ? new Ca(e.key, ha.none()) : new ba(e.key, e.data, ha.none());
        {
          const n = e.data,
            r = zi.empty();
          let s = new di(Os.comparator);
          for (let e of t.fields)
            if (!s.has(e)) {
              let t = n.field(e);
              null === t && e.length > 1 && ((e = e.popLast()), (t = n.field(e))), null === t ? r.delete(e) : r.set(e, t), (s = s.add(e));
            }
          return new Sa(e.key, r, new pi(s.toArray()), ha.none());
        }
      }
      function ga(e, t, n) {
        e instanceof ba
          ? (function (e, t, n) {
              const r = e.value.clone(),
                s = Ta(e.fieldTransforms, t, n.transformResults);
              r.setAll(s), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
            })(e, t, n)
          : e instanceof Sa
          ? (function (e, t, n) {
              if (!pa(e.precondition, t)) return void t.convertToUnknownDocument(n.version);
              const r = Ta(e.fieldTransforms, t, n.transformResults),
                s = t.data;
              s.setAll(Ea(e)), s.setAll(r), t.convertToFoundDocument(n.version, s).setHasCommittedMutations();
            })(e, t, n)
          : (function (e, t, n) {
              t.convertToNoDocument(n.version).setHasCommittedMutations();
            })(0, t, n);
      }
      function ya(e, t, n, r) {
        return e instanceof ba
          ? (function (e, t, n, r) {
              if (!pa(e.precondition, t)) return n;
              const s = e.value.clone(),
                i = _a(e.fieldTransforms, r, t);
              return s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null;
            })(e, t, n, r)
          : e instanceof Sa
          ? (function (e, t, n, r) {
              if (!pa(e.precondition, t)) return n;
              const s = _a(e.fieldTransforms, r, t),
                i = t.data;
              return (
                i.setAll(Ea(e)),
                i.setAll(s),
                t.convertToFoundDocument(t.version, i).setHasLocalMutations(),
                null === n ? null : n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e) => e.field))
              );
            })(e, t, n, r)
          : (function (e, t, n) {
              return pa(e.precondition, t) ? (t.convertToNoDocument(t.version).setHasLocalMutations(), null) : n;
            })(e, t, n);
      }
      function va(e, t) {
        let n = null;
        for (const r of e.fieldTransforms) {
          const e = t.data.field(r.field),
            s = na(r.transform, e || null);
          null != s && (null === n && (n = zi.empty()), n.set(r.field, s));
        }
        return n || null;
      }
      function wa(e, t) {
        return (
          e.type === t.type &&
          !!e.key.isEqual(t.key) &&
          !!e.precondition.isEqual(t.precondition) &&
          !!(function (e, t) {
            return (
              (void 0 === e && void 0 === t) ||
              (!(!e || !t) &&
                ks(e, t, (e, t) =>
                  (function (e, t) {
                    return (
                      e.field.isEqual(t.field) &&
                      (function (e, t) {
                        return (e instanceof sa && t instanceof sa) || (e instanceof oa && t instanceof oa)
                          ? ks(e.elements, t.elements, Ai)
                          : e instanceof la && t instanceof la
                          ? Ai(e.Pe, t.Pe)
                          : e instanceof ra && t instanceof ra;
                      })(e.transform, t.transform)
                    );
                  })(e, t)
                ))
            );
          })(e.fieldTransforms, t.fieldTransforms) &&
          (0 === e.type ? e.value.isEqual(t.value) : 1 !== e.type || (e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask)))
        );
      }
      class ba extends fa {
        constructor(e, t, n, r = []) {
          super(), (this.key = e), (this.value = t), (this.precondition = n), (this.fieldTransforms = r), (this.type = 0);
        }
        getFieldMask() {
          return null;
        }
      }
      class Sa extends fa {
        constructor(e, t, n, r, s = []) {
          super(),
            (this.key = e),
            (this.data = t),
            (this.fieldMask = n),
            (this.precondition = r),
            (this.fieldTransforms = s),
            (this.type = 1);
        }
        getFieldMask() {
          return this.fieldMask;
        }
      }
      function Ea(e) {
        const t = new Map();
        return (
          e.fieldMask.fields.forEach((n) => {
            if (!n.isEmpty()) {
              const r = e.data.field(n);
              t.set(n, r);
            }
          }),
          t
        );
      }
      function Ta(e, t, n) {
        const r = new Map();
        ps(e.length === n.length);
        for (let s = 0; s < n.length; s++) {
          const i = e[s],
            o = i.transform,
            a = t.data.field(i.field);
          r.set(i.field, ta(o, a, n[s]));
        }
        return r;
      }
      function _a(e, t, n) {
        const r = new Map();
        for (const s of e) {
          const e = s.transform,
            i = n.data.field(s.field);
          r.set(s.field, ea(e, i, t));
        }
        return r;
      }
      class Ca extends fa {
        constructor(e, t) {
          super(), (this.key = e), (this.precondition = t), (this.type = 2), (this.fieldTransforms = []);
        }
        getFieldMask() {
          return null;
        }
      }
      class xa extends fa {
        constructor(e, t) {
          super(), (this.key = e), (this.precondition = t), (this.type = 3), (this.fieldTransforms = []);
        }
        getFieldMask() {
          return null;
        }
      }
      class Aa {
        constructor(e, t, n, r) {
          (this.batchId = e), (this.localWriteTime = t), (this.baseMutations = n), (this.mutations = r);
        }
        applyToRemoteDocument(e, t) {
          const n = t.mutationResults;
          for (let t = 0; t < this.mutations.length; t++) {
            const r = this.mutations[t];
            r.key.isEqual(e.key) && ga(r, e, n[t]);
          }
        }
        applyToLocalView(e, t) {
          for (const n of this.baseMutations) n.key.isEqual(e.key) && (t = ya(n, e, t, this.localWriteTime));
          for (const n of this.mutations) n.key.isEqual(e.key) && (t = ya(n, e, t, this.localWriteTime));
          return t;
        }
        applyToLocalDocumentSet(e, t) {
          const n = zo();
          return (
            this.mutations.forEach((r) => {
              const s = e.get(r.key),
                i = s.overlayedDocument;
              let o = this.applyToLocalView(i, s.mutatedFields);
              o = t.has(r.key) ? null : o;
              const a = ma(i, o);
              null !== a && n.set(r.key, a), i.isValidDocument() || i.convertToNoDocument(Ms.min());
            }),
            n
          );
        }
        keys() {
          return this.mutations.reduce((e, t) => e.add(t.key), Wo());
        }
        isEqual(e) {
          return (
            this.batchId === e.batchId &&
            ks(this.mutations, e.mutations, (e, t) => wa(e, t)) &&
            ks(this.baseMutations, e.baseMutations, (e, t) => wa(e, t))
          );
        }
      }
      class Ia {
        constructor(e, t, n, r) {
          (this.batch = e), (this.commitVersion = t), (this.mutationResults = n), (this.docVersions = r);
        }
        static from(e, t, n) {
          ps(e.mutations.length === n.length);
          let r = Go;
          const s = e.mutations;
          for (let e = 0; e < s.length; e++) r = r.insert(s[e].key, n[e].version);
          return new Ia(e, t, n, r);
        }
      }
      class ka {
        constructor(e, t) {
          (this.largestBatchId = e), (this.mutation = t);
        }
        getKey() {
          return this.mutation.key;
        }
        isEqual(e) {
          return null !== e && this.mutation === e.mutation;
        }
        toString() {
          return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
        }
      }
      class La {
        constructor(e, t) {
          (this.count = e), (this.unchangedNames = t);
        }
      }
      var Ma, Da;
      function Na(e) {
        switch (e) {
          default:
            return hs();
          case ms.CANCELLED:
          case ms.UNKNOWN:
          case ms.DEADLINE_EXCEEDED:
          case ms.RESOURCE_EXHAUSTED:
          case ms.INTERNAL:
          case ms.UNAVAILABLE:
          case ms.UNAUTHENTICATED:
            return !1;
          case ms.INVALID_ARGUMENT:
          case ms.NOT_FOUND:
          case ms.ALREADY_EXISTS:
          case ms.PERMISSION_DENIED:
          case ms.FAILED_PRECONDITION:
          case ms.ABORTED:
          case ms.OUT_OF_RANGE:
          case ms.UNIMPLEMENTED:
          case ms.DATA_LOSS:
            return !0;
        }
      }
      function Pa(e) {
        if (void 0 === e) return cs("GRPC error has no .code"), ms.UNKNOWN;
        switch (e) {
          case Ma.OK:
            return ms.OK;
          case Ma.CANCELLED:
            return ms.CANCELLED;
          case Ma.UNKNOWN:
            return ms.UNKNOWN;
          case Ma.DEADLINE_EXCEEDED:
            return ms.DEADLINE_EXCEEDED;
          case Ma.RESOURCE_EXHAUSTED:
            return ms.RESOURCE_EXHAUSTED;
          case Ma.INTERNAL:
            return ms.INTERNAL;
          case Ma.UNAVAILABLE:
            return ms.UNAVAILABLE;
          case Ma.UNAUTHENTICATED:
            return ms.UNAUTHENTICATED;
          case Ma.INVALID_ARGUMENT:
            return ms.INVALID_ARGUMENT;
          case Ma.NOT_FOUND:
            return ms.NOT_FOUND;
          case Ma.ALREADY_EXISTS:
            return ms.ALREADY_EXISTS;
          case Ma.PERMISSION_DENIED:
            return ms.PERMISSION_DENIED;
          case Ma.FAILED_PRECONDITION:
            return ms.FAILED_PRECONDITION;
          case Ma.ABORTED:
            return ms.ABORTED;
          case Ma.OUT_OF_RANGE:
            return ms.OUT_OF_RANGE;
          case Ma.UNIMPLEMENTED:
            return ms.UNIMPLEMENTED;
          case Ma.DATA_LOSS:
            return ms.DATA_LOSS;
          default:
            return hs();
        }
      }
      ((Da = Ma || (Ma = {}))[(Da.OK = 0)] = "OK"),
        (Da[(Da.CANCELLED = 1)] = "CANCELLED"),
        (Da[(Da.UNKNOWN = 2)] = "UNKNOWN"),
        (Da[(Da.INVALID_ARGUMENT = 3)] = "INVALID_ARGUMENT"),
        (Da[(Da.DEADLINE_EXCEEDED = 4)] = "DEADLINE_EXCEEDED"),
        (Da[(Da.NOT_FOUND = 5)] = "NOT_FOUND"),
        (Da[(Da.ALREADY_EXISTS = 6)] = "ALREADY_EXISTS"),
        (Da[(Da.PERMISSION_DENIED = 7)] = "PERMISSION_DENIED"),
        (Da[(Da.UNAUTHENTICATED = 16)] = "UNAUTHENTICATED"),
        (Da[(Da.RESOURCE_EXHAUSTED = 8)] = "RESOURCE_EXHAUSTED"),
        (Da[(Da.FAILED_PRECONDITION = 9)] = "FAILED_PRECONDITION"),
        (Da[(Da.ABORTED = 10)] = "ABORTED"),
        (Da[(Da.OUT_OF_RANGE = 11)] = "OUT_OF_RANGE"),
        (Da[(Da.UNIMPLEMENTED = 12)] = "UNIMPLEMENTED"),
        (Da[(Da.INTERNAL = 13)] = "INTERNAL"),
        (Da[(Da.UNAVAILABLE = 14)] = "UNAVAILABLE"),
        (Da[(Da.DATA_LOSS = 15)] = "DATA_LOSS");
      let Oa = null;
      function qa() {
        return new TextEncoder();
      }
      const Ra = new zr([4294967295, 4294967295], 0);
      function Fa(e) {
        const t = qa().encode(e),
          n = new Ur();
        return n.update(t), new Uint8Array(n.digest());
      }
      function Ba(e) {
        const t = new DataView(e.buffer),
          n = t.getUint32(0, !0),
          r = t.getUint32(4, !0),
          s = t.getUint32(8, !0),
          i = t.getUint32(12, !0);
        return [new zr([n, r], 0), new zr([s, i], 0)];
      }
      class $a {
        constructor(e, t, n) {
          if (((this.bitmap = e), (this.padding = t), (this.hashCount = n), t < 0 || t >= 8)) throw new Va(`Invalid padding: ${t}`);
          if (n < 0) throw new Va(`Invalid hash count: ${n}`);
          if (e.length > 0 && 0 === this.hashCount) throw new Va(`Invalid hash count: ${n}`);
          if (0 === e.length && 0 !== t) throw new Va(`Invalid padding when bitmap length is 0: ${t}`);
          (this.Te = 8 * e.length - t), (this.Ie = zr.fromNumber(this.Te));
        }
        de(e, t, n) {
          let r = e.add(t.multiply(zr.fromNumber(n)));
          return 1 === r.compare(Ra) && (r = new zr([r.getBits(0), r.getBits(1)], 0)), r.modulo(this.Ie).toNumber();
        }
        Ee(e) {
          return 0 != (this.bitmap[Math.floor(e / 8)] & (1 << e % 8));
        }
        mightContain(e) {
          if (0 === this.Te) return !1;
          const t = Fa(e),
            [n, r] = Ba(t);
          for (let e = 0; e < this.hashCount; e++) {
            const t = this.de(n, r, e);
            if (!this.Ee(t)) return !1;
          }
          return !0;
        }
        static create(e, t, n) {
          const r = e % 8 == 0 ? 0 : 8 - (e % 8),
            s = new Uint8Array(Math.ceil(e / 8)),
            i = new $a(s, r, t);
          return n.forEach((e) => i.insert(e)), i;
        }
        insert(e) {
          if (0 === this.Te) return;
          const t = Fa(e),
            [n, r] = Ba(t);
          for (let e = 0; e < this.hashCount; e++) {
            const t = this.de(n, r, e);
            this.Ae(t);
          }
        }
        Ae(e) {
          const t = Math.floor(e / 8),
            n = e % 8;
          this.bitmap[t] |= 1 << n;
        }
      }
      class Va extends Error {
        constructor() {
          super(...arguments), (this.name = "BloomFilterError");
        }
      }
      class ja {
        constructor(e, t, n, r, s) {
          (this.snapshotVersion = e),
            (this.targetChanges = t),
            (this.targetMismatches = n),
            (this.documentUpdates = r),
            (this.resolvedLimboDocuments = s);
        }
        static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
          const r = new Map();
          return r.set(e, za.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new ja(Ms.min(), r, new li(Is), Fo(), Wo());
        }
      }
      class za {
        constructor(e, t, n, r, s) {
          (this.resumeToken = e), (this.current = t), (this.addedDocuments = n), (this.modifiedDocuments = r), (this.removedDocuments = s);
        }
        static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
          return new za(n, t, Wo(), Wo(), Wo());
        }
      }
      class Ua {
        constructor(e, t, n, r) {
          (this.Re = e), (this.removedTargetIds = t), (this.key = n), (this.Ve = r);
        }
      }
      class Ga {
        constructor(e, t) {
          (this.targetId = e), (this.me = t);
        }
      }
      class Ha {
        constructor(e, t, n = mi.EMPTY_BYTE_STRING, r = null) {
          (this.state = e), (this.targetIds = t), (this.resumeToken = n), (this.cause = r);
        }
      }
      class Wa {
        constructor() {
          (this.fe = 0), (this.ge = Ya()), (this.pe = mi.EMPTY_BYTE_STRING), (this.ye = !1), (this.we = !0);
        }
        get current() {
          return this.ye;
        }
        get resumeToken() {
          return this.pe;
        }
        get Se() {
          return 0 !== this.fe;
        }
        get be() {
          return this.we;
        }
        De(e) {
          e.approximateByteSize() > 0 && ((this.we = !0), (this.pe = e));
        }
        ve() {
          let e = Wo(),
            t = Wo(),
            n = Wo();
          return (
            this.ge.forEach((r, s) => {
              switch (s) {
                case 0:
                  e = e.add(r);
                  break;
                case 2:
                  t = t.add(r);
                  break;
                case 1:
                  n = n.add(r);
                  break;
                default:
                  hs();
              }
            }),
            new za(this.pe, this.ye, e, t, n)
          );
        }
        Ce() {
          (this.we = !1), (this.ge = Ya());
        }
        Fe(e, t) {
          (this.we = !0), (this.ge = this.ge.insert(e, t));
        }
        Me(e) {
          (this.we = !0), (this.ge = this.ge.remove(e));
        }
        xe() {
          this.fe += 1;
        }
        Oe() {
          (this.fe -= 1), ps(this.fe >= 0);
        }
        Ne() {
          (this.we = !0), (this.ye = !0);
        }
      }
      class Ka {
        constructor(e) {
          (this.Be = e), (this.Le = new Map()), (this.ke = Fo()), (this.qe = Qa()), (this.Qe = Qa()), (this.Ke = new li(Is));
        }
        $e(e) {
          for (const t of e.Re) e.Ve && e.Ve.isFoundDocument() ? this.Ue(t, e.Ve) : this.We(t, e.key, e.Ve);
          for (const t of e.removedTargetIds) this.We(t, e.key, e.Ve);
        }
        Ge(e) {
          this.forEachTarget(e, (t) => {
            const n = this.ze(t);
            switch (e.state) {
              case 0:
                this.je(t) && n.De(e.resumeToken);
                break;
              case 1:
                n.Oe(), n.Se || n.Ce(), n.De(e.resumeToken);
                break;
              case 2:
                n.Oe(), n.Se || this.removeTarget(t);
                break;
              case 3:
                this.je(t) && (n.Ne(), n.De(e.resumeToken));
                break;
              case 4:
                this.je(t) && (this.He(t), n.De(e.resumeToken));
                break;
              default:
                hs();
            }
          });
        }
        forEachTarget(e, t) {
          e.targetIds.length > 0
            ? e.targetIds.forEach(t)
            : this.Le.forEach((e, n) => {
                this.je(n) && t(n);
              });
        }
        Je(e) {
          const t = e.targetId,
            n = e.me.count,
            r = this.Ye(t);
          if (r) {
            const s = r.target;
            if (wo(s))
              if (0 === n) {
                const e = new qs(s.path);
                this.We(t, e, Gi.newNoDocument(e, Ms.min()));
              } else ps(1 === n);
            else {
              const r = this.Ze(t);
              if (r !== n) {
                const n = this.Xe(e),
                  s = n ? this.et(n, e, r) : 1;
                if (0 !== s) {
                  this.He(t);
                  const e = 2 === s ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
                  this.Ke = this.Ke.insert(t, e);
                }
                null == Oa ||
                  Oa.tt(
                    (function (e, t, n, r, s) {
                      var i, o, a, l, c, u;
                      const d = { localCacheCount: e, existenceFilterCount: t.count, databaseId: n.database, projectId: n.projectId },
                        h = t.unchangedNames;
                      return (
                        h &&
                          (d.bloomFilter = {
                            applied: 0 === s,
                            hashCount: null !== (i = null == h ? void 0 : h.hashCount) && void 0 !== i ? i : 0,
                            bitmapLength:
                              null !==
                                (l =
                                  null === (a = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) ||
                                  void 0 === a
                                    ? void 0
                                    : a.length) && void 0 !== l
                                ? l
                                : 0,
                            padding:
                              null !== (u = null === (c = null == h ? void 0 : h.bits) || void 0 === c ? void 0 : c.padding) && void 0 !== u
                                ? u
                                : 0,
                            mightContain: (e) => {
                              var t;
                              return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            },
                          }),
                        d
                      );
                    })(r, e.me, this.Be.nt(), n, s)
                  );
              }
            }
          }
        }
        Xe(e) {
          const t = e.me.unchangedNames;
          if (!t || !t.bits) return null;
          const {
            bits: { bitmap: n = "", padding: r = 0 },
            hashCount: s = 0,
          } = t;
          let i, o;
          try {
            i = wi(n).toUint8Array();
          } catch (e) {
            if (e instanceof fi)
              return (
                us(
                  "Decoding the base64 bloom filter in existence filter failed (" +
                    e.message +
                    "); ignoring the bloom filter and falling back to full re-query."
                ),
                null
              );
            throw e;
          }
          try {
            o = new $a(i, r, s);
          } catch (e) {
            return us(e instanceof Va ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
          }
          return 0 === o.Te ? null : o;
        }
        et(e, t, n) {
          return t.me.count === n - this.rt(e, t.targetId) ? 0 : 2;
        }
        rt(e, t) {
          const n = this.Be.getRemoteKeysForTarget(t);
          let r = 0;
          return (
            n.forEach((n) => {
              const s = this.Be.nt(),
                i = `projects/${s.projectId}/databases/${s.database}/documents/${n.path.canonicalString()}`;
              e.mightContain(i) || (this.We(t, n, null), r++);
            }),
            r
          );
        }
        it(e) {
          const t = new Map();
          this.Le.forEach((n, r) => {
            const s = this.Ye(r);
            if (s) {
              if (n.current && wo(s.target)) {
                const t = new qs(s.target.path);
                this.st(t).has(r) || this.ot(r, t) || this.We(r, t, Gi.newNoDocument(t, e));
              }
              n.be && (t.set(r, n.ve()), n.Ce());
            }
          });
          let n = Wo();
          this.Qe.forEach((e, t) => {
            let r = !0;
            t.forEachWhile((e) => {
              const t = this.Ye(e);
              return !t || "TargetPurposeLimboResolution" === t.purpose || ((r = !1), !1);
            }),
              r && (n = n.add(e));
          }),
            this.ke.forEach((t, n) => n.setReadTime(e));
          const r = new ja(e, t, this.Ke, this.ke, n);
          return (this.ke = Fo()), (this.qe = Qa()), (this.Qe = Qa()), (this.Ke = new li(Is)), r;
        }
        Ue(e, t) {
          if (!this.je(e)) return;
          const n = this.ot(e, t.key) ? 2 : 0;
          this.ze(e).Fe(t.key, n),
            (this.ke = this.ke.insert(t.key, t)),
            (this.qe = this.qe.insert(t.key, this.st(t.key).add(e))),
            (this.Qe = this.Qe.insert(t.key, this._t(t.key).add(e)));
        }
        We(e, t, n) {
          if (!this.je(e)) return;
          const r = this.ze(e);
          this.ot(e, t) ? r.Fe(t, 1) : r.Me(t),
            (this.Qe = this.Qe.insert(t, this._t(t).delete(e))),
            (this.Qe = this.Qe.insert(t, this._t(t).add(e))),
            n && (this.ke = this.ke.insert(t, n));
        }
        removeTarget(e) {
          this.Le.delete(e);
        }
        Ze(e) {
          const t = this.ze(e).ve();
          return this.Be.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
        }
        xe(e) {
          this.ze(e).xe();
        }
        ze(e) {
          let t = this.Le.get(e);
          return t || ((t = new Wa()), this.Le.set(e, t)), t;
        }
        _t(e) {
          let t = this.Qe.get(e);
          return t || ((t = new di(Is)), (this.Qe = this.Qe.insert(e, t))), t;
        }
        st(e) {
          let t = this.qe.get(e);
          return t || ((t = new di(Is)), (this.qe = this.qe.insert(e, t))), t;
        }
        je(e) {
          const t = null !== this.Ye(e);
          return t || ls("WatchChangeAggregator", "Detected inactive target", e), t;
        }
        Ye(e) {
          const t = this.Le.get(e);
          return t && t.Se ? null : this.Be.ut(e);
        }
        He(e) {
          this.Le.set(e, new Wa()),
            this.Be.getRemoteKeysForTarget(e).forEach((t) => {
              this.We(e, t, null);
            });
        }
        ot(e, t) {
          return this.Be.getRemoteKeysForTarget(e).has(t);
        }
      }
      function Qa() {
        return new li(qs.comparator);
      }
      function Ya() {
        return new li(qs.comparator);
      }
      const Xa = { asc: "ASCENDING", desc: "DESCENDING" },
        Ja = {
          "<": "LESS_THAN",
          "<=": "LESS_THAN_OR_EQUAL",
          ">": "GREATER_THAN",
          ">=": "GREATER_THAN_OR_EQUAL",
          "==": "EQUAL",
          "!=": "NOT_EQUAL",
          "array-contains": "ARRAY_CONTAINS",
          in: "IN",
          "not-in": "NOT_IN",
          "array-contains-any": "ARRAY_CONTAINS_ANY",
        },
        Za = { and: "AND", or: "OR" };
      class el {
        constructor(e, t) {
          (this.databaseId = e), (this.useProto3Json = t);
        }
      }
      function tl(e, t) {
        return e.useProto3Json || Qs(t) ? t : { value: t };
      }
      function nl(e, t) {
        return e.useProto3Json
          ? `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`
          : { seconds: "" + t.seconds, nanos: t.nanoseconds };
      }
      function rl(e, t) {
        return e.useProto3Json ? t.toBase64() : t.toUint8Array();
      }
      function sl(e, t) {
        return nl(e, t.toTimestamp());
      }
      function il(e) {
        return (
          ps(!!e),
          Ms.fromTimestamp(
            (function (e) {
              const t = yi(e);
              return new Ls(t.seconds, t.nanos);
            })(e)
          )
        );
      }
      function ol(e, t) {
        return al(e, t).canonicalString();
      }
      function al(e, t) {
        const n = (function (e) {
          return new Ns(["projects", e.projectId, "databases", e.database]);
        })(e).child("documents");
        return void 0 === t ? n : n.child(t);
      }
      function ll(e) {
        const t = Ns.fromString(e);
        return ps(Il(t)), t;
      }
      function cl(e, t) {
        return ol(e.databaseId, t.path);
      }
      function ul(e, t) {
        const n = ll(t);
        if (n.get(1) !== e.databaseId.projectId)
          throw new gs(
            ms.INVALID_ARGUMENT,
            "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId
          );
        if (n.get(3) !== e.databaseId.database)
          throw new gs(
            ms.INVALID_ARGUMENT,
            "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database
          );
        return new qs(fl(n));
      }
      function dl(e, t) {
        return ol(e.databaseId, t);
      }
      function hl(e) {
        const t = ll(e);
        return 4 === t.length ? Ns.emptyPath() : fl(t);
      }
      function pl(e) {
        return new Ns(["projects", e.databaseId.projectId, "databases", e.databaseId.database]).canonicalString();
      }
      function fl(e) {
        return ps(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
      }
      function ml(e, t, n) {
        return { name: cl(e, t), fields: n.value.mapValue.fields };
      }
      function gl(e, t) {
        let n;
        if (t instanceof ba) n = { update: ml(e, t.key, t.value) };
        else if (t instanceof Ca) n = { delete: cl(e, t.key) };
        else if (t instanceof Sa) n = { update: ml(e, t.key, t.data), updateMask: Al(t.fieldMask) };
        else {
          if (!(t instanceof xa)) return hs();
          n = { verify: cl(e, t.key) };
        }
        return (
          t.fieldTransforms.length > 0 &&
            (n.updateTransforms = t.fieldTransforms.map((e) =>
              (function (e, t) {
                const n = t.transform;
                if (n instanceof ra) return { fieldPath: t.field.canonicalString(), setToServerValue: "REQUEST_TIME" };
                if (n instanceof sa) return { fieldPath: t.field.canonicalString(), appendMissingElements: { values: n.elements } };
                if (n instanceof oa) return { fieldPath: t.field.canonicalString(), removeAllFromArray: { values: n.elements } };
                if (n instanceof la) return { fieldPath: t.field.canonicalString(), increment: n.Pe };
                throw hs();
              })(0, e)
            )),
          t.precondition.isNone ||
            (n.currentDocument = (function (e, t) {
              return void 0 !== t.updateTime ? { updateTime: sl(e, t.updateTime) } : void 0 !== t.exists ? { exists: t.exists } : hs();
            })(e, t.precondition)),
          n
        );
      }
      function yl(e, t) {
        return { documents: [dl(e, t.path)] };
      }
      function vl(e, t) {
        const n = { structuredQuery: {} },
          r = t.path;
        let s;
        null !== t.collectionGroup
          ? ((s = r), (n.structuredQuery.from = [{ collectionId: t.collectionGroup, allDescendants: !0 }]))
          : ((s = r.popLast()), (n.structuredQuery.from = [{ collectionId: r.lastSegment() }])),
          (n.parent = dl(e, s));
        const i = (function (e) {
          if (0 !== e.length) return xl(Zi.create(e, "and"));
        })(t.filters);
        i && (n.structuredQuery.where = i);
        const o = (function (e) {
          if (0 !== e.length)
            return e.map((e) =>
              (function (e) {
                return { field: _l(e.field), direction: Sl(e.dir) };
              })(e)
            );
        })(t.orderBy);
        o && (n.structuredQuery.orderBy = o);
        const a = tl(e, t.limit);
        return (
          null !== a && (n.structuredQuery.limit = a),
          t.startAt &&
            (n.structuredQuery.startAt = (function (e) {
              return { before: e.inclusive, values: e.position };
            })(t.startAt)),
          t.endAt &&
            (n.structuredQuery.endAt = (function (e) {
              return { before: !e.inclusive, values: e.position };
            })(t.endAt)),
          { ct: n, parent: s }
        );
      }
      function wl(e) {
        let t = hl(e.parent);
        const n = e.structuredQuery,
          r = n.from ? n.from.length : 0;
        let s = null;
        if (r > 0) {
          ps(1 === r);
          const e = n.from[0];
          e.allDescendants ? (s = e.collectionId) : (t = t.child(e.collectionId));
        }
        let i = [];
        n.where &&
          (i = (function (e) {
            const t = bl(e);
            return t instanceof Zi && to(t) ? t.getFilters() : [t];
          })(n.where));
        let o = [];
        n.orderBy &&
          (o = (function (e) {
            return e.map((e) =>
              (function (e) {
                return new Qi(
                  Cl(e.field),
                  (function (e) {
                    switch (e) {
                      case "ASCENDING":
                        return "asc";
                      case "DESCENDING":
                        return "desc";
                      default:
                        return;
                    }
                  })(e.direction)
                );
              })(e)
            );
          })(n.orderBy));
        let a = null;
        n.limit &&
          (a = (function (e) {
            let t;
            return (t = "object" == typeof e ? e.value : e), Qs(t) ? null : t;
          })(n.limit));
        let l = null;
        n.startAt &&
          (l = (function (e) {
            const t = !!e.before,
              n = e.values || [];
            return new Hi(n, t);
          })(n.startAt));
        let c = null;
        return (
          n.endAt &&
            (c = (function (e) {
              const t = !e.before,
                n = e.values || [];
              return new Hi(n, t);
            })(n.endAt)),
          So(t, s, o, i, a, "F", l, c)
        );
      }
      function bl(e) {
        return void 0 !== e.unaryFilter
          ? (function (e) {
              switch (e.unaryFilter.op) {
                case "IS_NAN":
                  const t = Cl(e.unaryFilter.field);
                  return Ji.create(t, "==", { doubleValue: NaN });
                case "IS_NULL":
                  const n = Cl(e.unaryFilter.field);
                  return Ji.create(n, "==", { nullValue: "NULL_VALUE" });
                case "IS_NOT_NAN":
                  const r = Cl(e.unaryFilter.field);
                  return Ji.create(r, "!=", { doubleValue: NaN });
                case "IS_NOT_NULL":
                  const s = Cl(e.unaryFilter.field);
                  return Ji.create(s, "!=", { nullValue: "NULL_VALUE" });
                default:
                  return hs();
              }
            })(e)
          : void 0 !== e.fieldFilter
          ? (function (e) {
              return Ji.create(
                Cl(e.fieldFilter.field),
                (function (e) {
                  switch (e) {
                    case "EQUAL":
                      return "==";
                    case "NOT_EQUAL":
                      return "!=";
                    case "GREATER_THAN":
                      return ">";
                    case "GREATER_THAN_OR_EQUAL":
                      return ">=";
                    case "LESS_THAN":
                      return "<";
                    case "LESS_THAN_OR_EQUAL":
                      return "<=";
                    case "ARRAY_CONTAINS":
                      return "array-contains";
                    case "IN":
                      return "in";
                    case "NOT_IN":
                      return "not-in";
                    case "ARRAY_CONTAINS_ANY":
                      return "array-contains-any";
                    default:
                      return hs();
                  }
                })(e.fieldFilter.op),
                e.fieldFilter.value
              );
            })(e)
          : void 0 !== e.compositeFilter
          ? (function (e) {
              return Zi.create(
                e.compositeFilter.filters.map((e) => bl(e)),
                (function (e) {
                  switch (e) {
                    case "AND":
                      return "and";
                    case "OR":
                      return "or";
                    default:
                      return hs();
                  }
                })(e.compositeFilter.op)
              );
            })(e)
          : hs();
      }
      function Sl(e) {
        return Xa[e];
      }
      function El(e) {
        return Ja[e];
      }
      function Tl(e) {
        return Za[e];
      }
      function _l(e) {
        return { fieldPath: e.canonicalString() };
      }
      function Cl(e) {
        return Os.fromServerFormat(e.fieldPath);
      }
      function xl(e) {
        return e instanceof Ji
          ? (function (e) {
              if ("==" === e.op) {
                if (Fi(e.value)) return { unaryFilter: { field: _l(e.field), op: "IS_NAN" } };
                if (Ri(e.value)) return { unaryFilter: { field: _l(e.field), op: "IS_NULL" } };
              } else if ("!=" === e.op) {
                if (Fi(e.value)) return { unaryFilter: { field: _l(e.field), op: "IS_NOT_NAN" } };
                if (Ri(e.value)) return { unaryFilter: { field: _l(e.field), op: "IS_NOT_NULL" } };
              }
              return { fieldFilter: { field: _l(e.field), op: El(e.op), value: e.value } };
            })(e)
          : e instanceof Zi
          ? (function (e) {
              const t = e.getFilters().map((e) => xl(e));
              return 1 === t.length ? t[0] : { compositeFilter: { op: Tl(e.op), filters: t } };
            })(e)
          : hs();
      }
      function Al(e) {
        const t = [];
        return e.fields.forEach((e) => t.push(e.canonicalString())), { fieldPaths: t };
      }
      function Il(e) {
        return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
      }
      class kl {
        constructor(e, t, n, r, s = Ms.min(), i = Ms.min(), o = mi.EMPTY_BYTE_STRING, a = null) {
          (this.target = e),
            (this.targetId = t),
            (this.purpose = n),
            (this.sequenceNumber = r),
            (this.snapshotVersion = s),
            (this.lastLimboFreeSnapshotVersion = i),
            (this.resumeToken = o),
            (this.expectedCount = a);
        }
        withSequenceNumber(e) {
          return new kl(
            this.target,
            this.targetId,
            this.purpose,
            e,
            this.snapshotVersion,
            this.lastLimboFreeSnapshotVersion,
            this.resumeToken,
            this.expectedCount
          );
        }
        withResumeToken(e, t) {
          return new kl(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, null);
        }
        withExpectedCount(e) {
          return new kl(
            this.target,
            this.targetId,
            this.purpose,
            this.sequenceNumber,
            this.snapshotVersion,
            this.lastLimboFreeSnapshotVersion,
            this.resumeToken,
            e
          );
        }
        withLastLimboFreeSnapshotVersion(e) {
          return new kl(
            this.target,
            this.targetId,
            this.purpose,
            this.sequenceNumber,
            this.snapshotVersion,
            e,
            this.resumeToken,
            this.expectedCount
          );
        }
      }
      class Ll {
        constructor(e) {
          this.ht = e;
        }
      }
      function Ml(e) {
        const t = wl({ parent: e.parent, structuredQuery: e.structuredQuery });
        return "LAST" === e.limitType ? Io(t, t.limit, "L") : t;
      }
      class Dl {
        constructor() {}
        dt(e, t) {
          this.Et(e, t), t.At();
        }
        Et(e, t) {
          if ("nullValue" in e) this.Rt(t, 5);
          else if ("booleanValue" in e) this.Rt(t, 10), t.Vt(e.booleanValue ? 1 : 0);
          else if ("integerValue" in e) this.Rt(t, 15), t.Vt(vi(e.integerValue));
          else if ("doubleValue" in e) {
            const n = vi(e.doubleValue);
            isNaN(n) ? this.Rt(t, 13) : (this.Rt(t, 15), Ys(n) ? t.Vt(0) : t.Vt(n));
          } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Rt(t, 20), "string" == typeof n && (n = yi(n)), t.ft(`${n.seconds || ""}`), t.Vt(n.nanos || 0);
          } else if ("stringValue" in e) this.gt(e.stringValue, t), this.yt(t);
          else if ("bytesValue" in e) this.Rt(t, 30), t.wt(wi(e.bytesValue)), this.yt(t);
          else if ("referenceValue" in e) this.St(e.referenceValue, t);
          else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Rt(t, 45), t.Vt(n.latitude || 0), t.Vt(n.longitude || 0);
          } else
            "mapValue" in e
              ? ji(e)
                ? this.Rt(t, Number.MAX_SAFE_INTEGER)
                : $i(e)
                ? this.bt(e.mapValue, t)
                : (this.Dt(e.mapValue, t), this.yt(t))
              : "arrayValue" in e
              ? (this.vt(e.arrayValue, t), this.yt(t))
              : hs();
        }
        gt(e, t) {
          this.Rt(t, 25), this.Ct(e, t);
        }
        Ct(e, t) {
          t.ft(e);
        }
        Dt(e, t) {
          const n = e.fields || {};
          this.Rt(t, 55);
          for (const e of Object.keys(n)) this.gt(e, t), this.Et(n[e], t);
        }
        bt(e, t) {
          var n, r;
          const s = e.fields || {};
          this.Rt(t, 53);
          const i = "value",
            o =
              (null === (r = null === (n = s[i].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
          this.Rt(t, 15), t.Vt(vi(o)), this.gt(i, t), this.Et(s[i], t);
        }
        vt(e, t) {
          const n = e.values || [];
          this.Rt(t, 50);
          for (const e of n) this.Et(e, t);
        }
        St(e, t) {
          this.Rt(t, 37),
            qs.fromName(e).path.forEach((e) => {
              this.Rt(t, 60), this.Ct(e, t);
            });
        }
        Rt(e, t) {
          e.Vt(t);
        }
        yt(e) {
          e.Vt(2);
        }
      }
      Dl.Ft = new Dl();
      class Nl {
        constructor() {
          this.ln = new Pl();
        }
        addToCollectionParentIndex(e, t) {
          return this.ln.add(t), Gs.resolve();
        }
        getCollectionParents(e, t) {
          return Gs.resolve(this.ln.getEntries(t));
        }
        addFieldIndex(e, t) {
          return Gs.resolve();
        }
        deleteFieldIndex(e, t) {
          return Gs.resolve();
        }
        deleteAllFieldIndexes(e) {
          return Gs.resolve();
        }
        createTargetIndexes(e, t) {
          return Gs.resolve();
        }
        getDocumentsMatchingTarget(e, t) {
          return Gs.resolve(null);
        }
        getIndexType(e, t) {
          return Gs.resolve(0);
        }
        getFieldIndexes(e, t) {
          return Gs.resolve([]);
        }
        getNextCollectionGroupToUpdate(e) {
          return Gs.resolve(null);
        }
        getMinOffset(e, t) {
          return Gs.resolve($s.min());
        }
        getMinOffsetFromCollectionGroup(e, t) {
          return Gs.resolve($s.min());
        }
        updateCollectionGroup(e, t, n) {
          return Gs.resolve();
        }
        updateIndexEntries(e, t) {
          return Gs.resolve();
        }
      }
      class Pl {
        constructor() {
          this.index = {};
        }
        add(e) {
          const t = e.lastSegment(),
            n = e.popLast(),
            r = this.index[t] || new di(Ns.comparator),
            s = !r.has(n);
          return (this.index[t] = r.add(n)), s;
        }
        has(e) {
          const t = e.lastSegment(),
            n = e.popLast(),
            r = this.index[t];
          return r && r.has(n);
        }
        getEntries(e) {
          return (this.index[e] || new di(Ns.comparator)).toArray();
        }
      }
      new Uint8Array(0);
      const Ol = { didRun: !1, sequenceNumbersCollected: 0, targetsRemoved: 0, documentsRemoved: 0 };
      class ql {
        static withCacheSize(e) {
          return new ql(e, ql.DEFAULT_COLLECTION_PERCENTILE, ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
        }
        constructor(e, t, n) {
          (this.cacheSizeCollectionThreshold = e), (this.percentileToCollect = t), (this.maximumSequenceNumbersToCollect = n);
        }
      }
      (ql.DEFAULT_COLLECTION_PERCENTILE = 10),
        (ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3),
        (ql.DEFAULT = new ql(41943040, ql.DEFAULT_COLLECTION_PERCENTILE, ql.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT)),
        (ql.DISABLED = new ql(-1, 0, 0));
      class Rl {
        constructor(e) {
          this.kn = e;
        }
        next() {
          return (this.kn += 2), this.kn;
        }
        static qn() {
          return new Rl(0);
        }
        static Qn() {
          return new Rl(-1);
        }
      }
      function Fl([e, t], [n, r]) {
        const s = Is(e, n);
        return 0 === s ? Is(t, r) : s;
      }
      class Bl {
        constructor(e) {
          (this.Gn = e), (this.buffer = new di(Fl)), (this.zn = 0);
        }
        jn() {
          return ++this.zn;
        }
        Hn(e) {
          const t = [e, this.jn()];
          if (this.buffer.size < this.Gn) this.buffer = this.buffer.add(t);
          else {
            const e = this.buffer.last();
            Fl(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
          }
        }
        get maxValue() {
          return this.buffer.last()[0];
        }
      }
      class $l {
        constructor(e, t, n) {
          (this.garbageCollector = e), (this.asyncQueue = t), (this.localStore = n), (this.Jn = null);
        }
        start() {
          -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Yn(6e4);
        }
        stop() {
          this.Jn && (this.Jn.cancel(), (this.Jn = null));
        }
        get started() {
          return null !== this.Jn;
        }
        Yn(e) {
          ls("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`),
            (this.Jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection", e, async () => {
              this.Jn = null;
              try {
                await this.localStore.collectGarbage(this.garbageCollector);
              } catch (e) {
                Ws(e) ? ls("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await Us(e);
              }
              await this.Yn(3e5);
            }));
        }
      }
      class Vl {
        constructor(e, t) {
          (this.Zn = e), (this.params = t);
        }
        calculateTargetCount(e, t) {
          return this.Zn.Xn(e).next((e) => Math.floor((t / 100) * e));
        }
        nthSequenceNumber(e, t) {
          if (0 === t) return Gs.resolve(Ks.oe);
          const n = new Bl(t);
          return this.Zn.forEachTarget(e, (e) => n.Hn(e.sequenceNumber))
            .next(() => this.Zn.er(e, (e) => n.Hn(e)))
            .next(() => n.maxValue);
        }
        removeTargets(e, t, n) {
          return this.Zn.removeTargets(e, t, n);
        }
        removeOrphanedDocuments(e, t) {
          return this.Zn.removeOrphanedDocuments(e, t);
        }
        collect(e, t) {
          return -1 === this.params.cacheSizeCollectionThreshold
            ? (ls("LruGarbageCollector", "Garbage collection skipped; disabled"), Gs.resolve(Ol))
            : this.getCacheSize(e).next((n) =>
                n < this.params.cacheSizeCollectionThreshold
                  ? (ls(
                      "LruGarbageCollector",
                      `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`
                    ),
                    Ol)
                  : this.tr(e, t)
              );
        }
        getCacheSize(e) {
          return this.Zn.getCacheSize(e);
        }
        tr(e, t) {
          let n, r, s, i, o, a, l;
          const c = Date.now();
          return this.calculateTargetCount(e, this.params.percentileToCollect)
            .next(
              (t) => (
                t > this.params.maximumSequenceNumbersToCollect
                  ? (ls(
                      "LruGarbageCollector",
                      `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`
                    ),
                    (r = this.params.maximumSequenceNumbersToCollect))
                  : (r = t),
                (i = Date.now()),
                this.nthSequenceNumber(e, r)
              )
            )
            .next((r) => ((n = r), (o = Date.now()), this.removeTargets(e, n, t)))
            .next((t) => ((s = t), (a = Date.now()), this.removeOrphanedDocuments(e, n)))
            .next(
              (e) => (
                (l = Date.now()),
                as() <= Gn.DEBUG &&
                  ls(
                    "LruGarbageCollector",
                    `LRU Garbage Collection\n\tCounted targets in ${i - c}ms\n\tDetermined least recently used ${r} in ` +
                      (o - i) +
                      "ms\n" +
                      `\tRemoved ${s} targets in ` +
                      (a - o) +
                      "ms\n" +
                      `\tRemoved ${e} documents in ` +
                      (l - a) +
                      "ms\n" +
                      `Total Duration: ${l - c}ms`
                  ),
                Gs.resolve({ didRun: !0, sequenceNumbersCollected: r, targetsRemoved: s, documentsRemoved: e })
              )
            );
        }
      }
      function jl(e, t) {
        return new Vl(e, t);
      }
      class zl {
        constructor() {
          (this.changes = new qo(
            (e) => e.toString(),
            (e, t) => e.isEqual(t)
          )),
            (this.changesApplied = !1);
        }
        addEntry(e) {
          this.assertNotApplied(), this.changes.set(e.key, e);
        }
        removeEntry(e, t) {
          this.assertNotApplied(), this.changes.set(e, Gi.newInvalidDocument(e).setReadTime(t));
        }
        getEntry(e, t) {
          this.assertNotApplied();
          const n = this.changes.get(t);
          return void 0 !== n ? Gs.resolve(n) : this.getFromCache(e, t);
        }
        getEntries(e, t) {
          return this.getAllFromCache(e, t);
        }
        apply(e) {
          return this.assertNotApplied(), (this.changesApplied = !0), this.applyChanges(e);
        }
        assertNotApplied() {}
      }
      class Ul {
        constructor(e, t) {
          (this.overlayedDocument = e), (this.mutatedFields = t);
        }
      }
      class Gl {
        constructor(e, t, n, r) {
          (this.remoteDocumentCache = e), (this.mutationQueue = t), (this.documentOverlayCache = n), (this.indexManager = r);
        }
        getDocument(e, t) {
          let n = null;
          return this.documentOverlayCache
            .getOverlay(e, t)
            .next((r) => ((n = r), this.remoteDocumentCache.getEntry(e, t)))
            .next((e) => (null !== n && ya(n.mutation, e, pi.empty(), Ls.now()), e));
        }
        getDocuments(e, t) {
          return this.remoteDocumentCache.getEntries(e, t).next((t) => this.getLocalViewOfDocuments(e, t, Wo()).next(() => t));
        }
        getLocalViewOfDocuments(e, t, n = Wo()) {
          const r = jo();
          return this.populateOverlays(e, r, t).next(() =>
            this.computeViews(e, t, r, n).next((e) => {
              let t = $o();
              return (
                e.forEach((e, n) => {
                  t = t.insert(e, n.overlayedDocument);
                }),
                t
              );
            })
          );
        }
        getOverlayedDocuments(e, t) {
          const n = jo();
          return this.populateOverlays(e, n, t).next(() => this.computeViews(e, t, n, Wo()));
        }
        populateOverlays(e, t, n) {
          const r = [];
          return (
            n.forEach((e) => {
              t.has(e) || r.push(e);
            }),
            this.documentOverlayCache.getOverlays(e, r).next((e) => {
              e.forEach((e, n) => {
                t.set(e, n);
              });
            })
          );
        }
        computeViews(e, t, n, r) {
          let s = Fo();
          const i = Uo(),
            o = Uo();
          return (
            t.forEach((e, t) => {
              const o = n.get(t.key);
              r.has(t.key) && (void 0 === o || o.mutation instanceof Sa)
                ? (s = s.insert(t.key, t))
                : void 0 !== o
                ? (i.set(t.key, o.mutation.getFieldMask()), ya(o.mutation, t, o.mutation.getFieldMask(), Ls.now()))
                : i.set(t.key, pi.empty());
            }),
            this.recalculateAndSaveOverlays(e, s).next(
              (e) => (
                e.forEach((e, t) => i.set(e, t)),
                t.forEach((e, t) => {
                  var n;
                  return o.set(e, new Ul(t, null !== (n = i.get(e)) && void 0 !== n ? n : null));
                }),
                o
              )
            )
          );
        }
        recalculateAndSaveOverlays(e, t) {
          const n = Uo();
          let r = new li((e, t) => e - t),
            s = Wo();
          return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKeys(e, t)
            .next((e) => {
              for (const s of e)
                s.keys().forEach((e) => {
                  const i = t.get(e);
                  if (null === i) return;
                  let o = n.get(e) || pi.empty();
                  (o = s.applyToLocalView(i, o)), n.set(e, o);
                  const a = (r.get(s.batchId) || Wo()).add(e);
                  r = r.insert(s.batchId, a);
                });
            })
            .next(() => {
              const i = [],
                o = r.getReverseIterator();
              for (; o.hasNext(); ) {
                const r = o.getNext(),
                  a = r.key,
                  l = r.value,
                  c = zo();
                l.forEach((e) => {
                  if (!s.has(e)) {
                    const r = ma(t.get(e), n.get(e));
                    null !== r && c.set(e, r), (s = s.add(e));
                  }
                }),
                  i.push(this.documentOverlayCache.saveOverlays(e, a, c));
              }
              return Gs.waitFor(i);
            })
            .next(() => n);
        }
        recalculateAndSaveOverlaysForDocumentKeys(e, t) {
          return this.remoteDocumentCache.getEntries(e, t).next((t) => this.recalculateAndSaveOverlays(e, t));
        }
        getDocumentsMatchingQuery(e, t, n, r) {
          return (function (e) {
            return qs.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
          })(t)
            ? this.getDocumentsMatchingDocumentQuery(e, t.path)
            : _o(t)
            ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r)
            : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
        }
        getNextDocuments(e, t, n, r) {
          return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((s) => {
            const i =
              r - s.size > 0
                ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - s.size)
                : Gs.resolve(jo());
            let o = -1,
              a = s;
            return i.next((t) =>
              Gs.forEach(
                t,
                (t, n) => (
                  o < n.largestBatchId && (o = n.largestBatchId),
                  s.get(t)
                    ? Gs.resolve()
                    : this.remoteDocumentCache.getEntry(e, t).next((e) => {
                        a = a.insert(t, e);
                      })
                )
              )
                .next(() => this.populateOverlays(e, t, s))
                .next(() => this.computeViews(e, a, t, Wo()))
                .next((e) => ({ batchId: o, changes: Vo(e) }))
            );
          });
        }
        getDocumentsMatchingDocumentQuery(e, t) {
          return this.getDocument(e, new qs(t)).next((e) => {
            let t = $o();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
          });
        }
        getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
          const s = t.collectionGroup;
          let i = $o();
          return this.indexManager.getCollectionParents(e, s).next((o) =>
            Gs.forEach(o, (o) => {
              const a = (function (e, t) {
                return new bo(t, null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
              })(t, o.child(s));
              return this.getDocumentsMatchingCollectionQuery(e, a, n, r).next((e) => {
                e.forEach((e, t) => {
                  i = i.insert(e, t);
                });
              });
            }).next(() => i)
          );
        }
        getDocumentsMatchingCollectionQuery(e, t, n, r) {
          let s;
          return this.documentOverlayCache
            .getOverlaysForCollection(e, t.path, n.largestBatchId)
            .next((i) => ((s = i), this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, s, r)))
            .next((e) => {
              s.forEach((t, n) => {
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, Gi.newInvalidDocument(r)));
              });
              let n = $o();
              return (
                e.forEach((e, r) => {
                  const i = s.get(e);
                  void 0 !== i && ya(i.mutation, r, pi.empty(), Ls.now()), Do(t, r) && (n = n.insert(e, r));
                }),
                n
              );
            });
        }
      }
      class Hl {
        constructor(e) {
          (this.serializer = e), (this.Tr = new Map()), (this.Ir = new Map());
        }
        getBundleMetadata(e, t) {
          return Gs.resolve(this.Tr.get(t));
        }
        saveBundleMetadata(e, t) {
          return (
            this.Tr.set(
              t.id,
              (function (e) {
                return { id: e.id, version: e.version, createTime: il(e.createTime) };
              })(t)
            ),
            Gs.resolve()
          );
        }
        getNamedQuery(e, t) {
          return Gs.resolve(this.Ir.get(t));
        }
        saveNamedQuery(e, t) {
          return (
            this.Ir.set(
              t.name,
              (function (e) {
                return { name: e.name, query: Ml(e.bundledQuery), readTime: il(e.readTime) };
              })(t)
            ),
            Gs.resolve()
          );
        }
      }
      class Wl {
        constructor() {
          (this.overlays = new li(qs.comparator)), (this.dr = new Map());
        }
        getOverlay(e, t) {
          return Gs.resolve(this.overlays.get(t));
        }
        getOverlays(e, t) {
          const n = jo();
          return Gs.forEach(t, (t) =>
            this.getOverlay(e, t).next((e) => {
              null !== e && n.set(t, e);
            })
          ).next(() => n);
        }
        saveOverlays(e, t, n) {
          return (
            n.forEach((n, r) => {
              this.Tt(e, t, r);
            }),
            Gs.resolve()
          );
        }
        removeOverlaysForBatchId(e, t, n) {
          const r = this.dr.get(n);
          return void 0 !== r && (r.forEach((e) => (this.overlays = this.overlays.remove(e))), this.dr.delete(n)), Gs.resolve();
        }
        getOverlaysForCollection(e, t, n) {
          const r = jo(),
            s = t.length + 1,
            i = new qs(t.child("")),
            o = this.overlays.getIteratorFrom(i);
          for (; o.hasNext(); ) {
            const e = o.getNext().value,
              i = e.getKey();
            if (!t.isPrefixOf(i.path)) break;
            i.path.length === s && e.largestBatchId > n && r.set(e.getKey(), e);
          }
          return Gs.resolve(r);
        }
        getOverlaysForCollectionGroup(e, t, n, r) {
          let s = new li((e, t) => e - t);
          const i = this.overlays.getIterator();
          for (; i.hasNext(); ) {
            const e = i.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
              let t = s.get(e.largestBatchId);
              null === t && ((t = jo()), (s = s.insert(e.largestBatchId, t))), t.set(e.getKey(), e);
            }
          }
          const o = jo(),
            a = s.getIterator();
          for (; a.hasNext() && (a.getNext().value.forEach((e, t) => o.set(e, t)), !(o.size() >= r)); );
          return Gs.resolve(o);
        }
        Tt(e, t, n) {
          const r = this.overlays.get(n.key);
          if (null !== r) {
            const e = this.dr.get(r.largestBatchId).delete(n.key);
            this.dr.set(r.largestBatchId, e);
          }
          this.overlays = this.overlays.insert(n.key, new ka(t, n));
          let s = this.dr.get(t);
          void 0 === s && ((s = Wo()), this.dr.set(t, s)), this.dr.set(t, s.add(n.key));
        }
      }
      class Kl {
        constructor() {
          this.sessionToken = mi.EMPTY_BYTE_STRING;
        }
        getSessionToken(e) {
          return Gs.resolve(this.sessionToken);
        }
        setSessionToken(e, t) {
          return (this.sessionToken = t), Gs.resolve();
        }
      }
      class Ql {
        constructor() {
          (this.Er = new di(Yl.Ar)), (this.Rr = new di(Yl.Vr));
        }
        isEmpty() {
          return this.Er.isEmpty();
        }
        addReference(e, t) {
          const n = new Yl(e, t);
          (this.Er = this.Er.add(n)), (this.Rr = this.Rr.add(n));
        }
        mr(e, t) {
          e.forEach((e) => this.addReference(e, t));
        }
        removeReference(e, t) {
          this.gr(new Yl(e, t));
        }
        pr(e, t) {
          e.forEach((e) => this.removeReference(e, t));
        }
        yr(e) {
          const t = new qs(new Ns([])),
            n = new Yl(t, e),
            r = new Yl(t, e + 1),
            s = [];
          return (
            this.Rr.forEachInRange([n, r], (e) => {
              this.gr(e), s.push(e.key);
            }),
            s
          );
        }
        wr() {
          this.Er.forEach((e) => this.gr(e));
        }
        gr(e) {
          (this.Er = this.Er.delete(e)), (this.Rr = this.Rr.delete(e));
        }
        Sr(e) {
          const t = new qs(new Ns([])),
            n = new Yl(t, e),
            r = new Yl(t, e + 1);
          let s = Wo();
          return (
            this.Rr.forEachInRange([n, r], (e) => {
              s = s.add(e.key);
            }),
            s
          );
        }
        containsKey(e) {
          const t = new Yl(e, 0),
            n = this.Er.firstAfterOrEqual(t);
          return null !== n && e.isEqual(n.key);
        }
      }
      class Yl {
        constructor(e, t) {
          (this.key = e), (this.br = t);
        }
        static Ar(e, t) {
          return qs.comparator(e.key, t.key) || Is(e.br, t.br);
        }
        static Vr(e, t) {
          return Is(e.br, t.br) || qs.comparator(e.key, t.key);
        }
      }
      class Xl {
        constructor(e, t) {
          (this.indexManager = e), (this.referenceDelegate = t), (this.mutationQueue = []), (this.Dr = 1), (this.vr = new di(Yl.Ar));
        }
        checkEmpty(e) {
          return Gs.resolve(0 === this.mutationQueue.length);
        }
        addMutationBatch(e, t, n, r) {
          const s = this.Dr;
          this.Dr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
          const i = new Aa(s, t, n, r);
          this.mutationQueue.push(i);
          for (const t of r)
            (this.vr = this.vr.add(new Yl(t.key, s))), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
          return Gs.resolve(i);
        }
        lookupMutationBatch(e, t) {
          return Gs.resolve(this.Cr(t));
        }
        getNextMutationBatchAfterBatchId(e, t) {
          const n = t + 1,
            r = this.Fr(n),
            s = r < 0 ? 0 : r;
          return Gs.resolve(this.mutationQueue.length > s ? this.mutationQueue[s] : null);
        }
        getHighestUnacknowledgedBatchId() {
          return Gs.resolve(0 === this.mutationQueue.length ? -1 : this.Dr - 1);
        }
        getAllMutationBatches(e) {
          return Gs.resolve(this.mutationQueue.slice());
        }
        getAllMutationBatchesAffectingDocumentKey(e, t) {
          const n = new Yl(t, 0),
            r = new Yl(t, Number.POSITIVE_INFINITY),
            s = [];
          return (
            this.vr.forEachInRange([n, r], (e) => {
              const t = this.Cr(e.br);
              s.push(t);
            }),
            Gs.resolve(s)
          );
        }
        getAllMutationBatchesAffectingDocumentKeys(e, t) {
          let n = new di(Is);
          return (
            t.forEach((e) => {
              const t = new Yl(e, 0),
                r = new Yl(e, Number.POSITIVE_INFINITY);
              this.vr.forEachInRange([t, r], (e) => {
                n = n.add(e.br);
              });
            }),
            Gs.resolve(this.Mr(n))
          );
        }
        getAllMutationBatchesAffectingQuery(e, t) {
          const n = t.path,
            r = n.length + 1;
          let s = n;
          qs.isDocumentKey(s) || (s = s.child(""));
          const i = new Yl(new qs(s), 0);
          let o = new di(Is);
          return (
            this.vr.forEachWhile((e) => {
              const t = e.key.path;
              return !!n.isPrefixOf(t) && (t.length === r && (o = o.add(e.br)), !0);
            }, i),
            Gs.resolve(this.Mr(o))
          );
        }
        Mr(e) {
          const t = [];
          return (
            e.forEach((e) => {
              const n = this.Cr(e);
              null !== n && t.push(n);
            }),
            t
          );
        }
        removeMutationBatch(e, t) {
          ps(0 === this.Or(t.batchId, "removed")), this.mutationQueue.shift();
          let n = this.vr;
          return Gs.forEach(t.mutations, (r) => {
            const s = new Yl(r.key, t.batchId);
            return (n = n.delete(s)), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
          }).next(() => {
            this.vr = n;
          });
        }
        Bn(e) {}
        containsKey(e, t) {
          const n = new Yl(t, 0),
            r = this.vr.firstAfterOrEqual(n);
          return Gs.resolve(t.isEqual(r && r.key));
        }
        performConsistencyCheck(e) {
          return this.mutationQueue.length, Gs.resolve();
        }
        Or(e, t) {
          return this.Fr(e);
        }
        Fr(e) {
          return 0 === this.mutationQueue.length ? 0 : e - this.mutationQueue[0].batchId;
        }
        Cr(e) {
          const t = this.Fr(e);
          return t < 0 || t >= this.mutationQueue.length ? null : this.mutationQueue[t];
        }
      }
      class Jl {
        constructor(e) {
          (this.Nr = e), (this.docs = new li(qs.comparator)), (this.size = 0);
        }
        setIndexManager(e) {
          this.indexManager = e;
        }
        addEntry(e, t) {
          const n = t.key,
            r = this.docs.get(n),
            s = r ? r.size : 0,
            i = this.Nr(t);
          return (
            (this.docs = this.docs.insert(n, { document: t.mutableCopy(), size: i })),
            (this.size += i - s),
            this.indexManager.addToCollectionParentIndex(e, n.path.popLast())
          );
        }
        removeEntry(e) {
          const t = this.docs.get(e);
          t && ((this.docs = this.docs.remove(e)), (this.size -= t.size));
        }
        getEntry(e, t) {
          const n = this.docs.get(t);
          return Gs.resolve(n ? n.document.mutableCopy() : Gi.newInvalidDocument(t));
        }
        getEntries(e, t) {
          let n = Fo();
          return (
            t.forEach((e) => {
              const t = this.docs.get(e);
              n = n.insert(e, t ? t.document.mutableCopy() : Gi.newInvalidDocument(e));
            }),
            Gs.resolve(n)
          );
        }
        getDocumentsMatchingQuery(e, t, n, r) {
          let s = Fo();
          const i = t.path,
            o = new qs(i.child("__id-9223372036854775808__")),
            a = this.docs.getIteratorFrom(o);
          for (; a.hasNext(); ) {
            const {
              key: e,
              value: { document: o },
            } = a.getNext();
            if (!i.isPrefixOf(e.path)) break;
            e.path.length > i.length + 1 || Vs(Bs(o), n) <= 0 || ((r.has(o.key) || Do(t, o)) && (s = s.insert(o.key, o.mutableCopy())));
          }
          return Gs.resolve(s);
        }
        getAllFromCollectionGroup(e, t, n, r) {
          hs();
        }
        Br(e, t) {
          return Gs.forEach(this.docs, (e) => t(e));
        }
        newChangeBuffer(e) {
          return new Zl(this);
        }
        getSize(e) {
          return Gs.resolve(this.size);
        }
      }
      class Zl extends zl {
        constructor(e) {
          super(), (this.hr = e);
        }
        applyChanges(e) {
          const t = [];
          return (
            this.changes.forEach((n, r) => {
              r.isValidDocument() ? t.push(this.hr.addEntry(e, r)) : this.hr.removeEntry(n);
            }),
            Gs.waitFor(t)
          );
        }
        getFromCache(e, t) {
          return this.hr.getEntry(e, t);
        }
        getAllFromCache(e, t) {
          return this.hr.getEntries(e, t);
        }
      }
      class ec {
        constructor(e) {
          (this.persistence = e),
            (this.Lr = new qo((e) => yo(e), vo)),
            (this.lastRemoteSnapshotVersion = Ms.min()),
            (this.highestTargetId = 0),
            (this.kr = 0),
            (this.qr = new Ql()),
            (this.targetCount = 0),
            (this.Qr = Rl.qn());
        }
        forEachTarget(e, t) {
          return this.Lr.forEach((e, n) => t(n)), Gs.resolve();
        }
        getLastRemoteSnapshotVersion(e) {
          return Gs.resolve(this.lastRemoteSnapshotVersion);
        }
        getHighestSequenceNumber(e) {
          return Gs.resolve(this.kr);
        }
        allocateTargetId(e) {
          return (this.highestTargetId = this.Qr.next()), Gs.resolve(this.highestTargetId);
        }
        setTargetsMetadata(e, t, n) {
          return n && (this.lastRemoteSnapshotVersion = n), t > this.kr && (this.kr = t), Gs.resolve();
        }
        Un(e) {
          this.Lr.set(e.target, e);
          const t = e.targetId;
          t > this.highestTargetId && ((this.Qr = new Rl(t)), (this.highestTargetId = t)),
            e.sequenceNumber > this.kr && (this.kr = e.sequenceNumber);
        }
        addTargetData(e, t) {
          return this.Un(t), (this.targetCount += 1), Gs.resolve();
        }
        updateTargetData(e, t) {
          return this.Un(t), Gs.resolve();
        }
        removeTargetData(e, t) {
          return this.Lr.delete(t.target), this.qr.yr(t.targetId), (this.targetCount -= 1), Gs.resolve();
        }
        removeTargets(e, t, n) {
          let r = 0;
          const s = [];
          return (
            this.Lr.forEach((i, o) => {
              o.sequenceNumber <= t &&
                null === n.get(o.targetId) &&
                (this.Lr.delete(i), s.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
            }),
            Gs.waitFor(s).next(() => r)
          );
        }
        getTargetCount(e) {
          return Gs.resolve(this.targetCount);
        }
        getTargetData(e, t) {
          const n = this.Lr.get(t) || null;
          return Gs.resolve(n);
        }
        addMatchingKeys(e, t, n) {
          return this.qr.mr(t, n), Gs.resolve();
        }
        removeMatchingKeys(e, t, n) {
          this.qr.pr(t, n);
          const r = this.persistence.referenceDelegate,
            s = [];
          return (
            r &&
              t.forEach((t) => {
                s.push(r.markPotentiallyOrphaned(e, t));
              }),
            Gs.waitFor(s)
          );
        }
        removeMatchingKeysForTargetId(e, t) {
          return this.qr.yr(t), Gs.resolve();
        }
        getMatchingKeysForTargetId(e, t) {
          const n = this.qr.Sr(t);
          return Gs.resolve(n);
        }
        containsKey(e, t) {
          return Gs.resolve(this.qr.containsKey(t));
        }
      }
      class tc {
        constructor(e, t) {
          (this.Kr = {}),
            (this.overlays = {}),
            (this.$r = new Ks(0)),
            (this.Ur = !1),
            (this.Ur = !0),
            (this.Wr = new Kl()),
            (this.referenceDelegate = e(this)),
            (this.Gr = new ec(this)),
            (this.indexManager = new Nl()),
            (this.remoteDocumentCache = (function (e) {
              return new Jl(e);
            })((e) => this.referenceDelegate.zr(e))),
            (this.serializer = new Ll(t)),
            (this.jr = new Hl(this.serializer));
        }
        start() {
          return Promise.resolve();
        }
        shutdown() {
          return (this.Ur = !1), Promise.resolve();
        }
        get started() {
          return this.Ur;
        }
        setDatabaseDeletedListener() {}
        setNetworkEnabled() {}
        getIndexManager(e) {
          return this.indexManager;
        }
        getDocumentOverlayCache(e) {
          let t = this.overlays[e.toKey()];
          return t || ((t = new Wl()), (this.overlays[e.toKey()] = t)), t;
        }
        getMutationQueue(e, t) {
          let n = this.Kr[e.toKey()];
          return n || ((n = new Xl(t, this.referenceDelegate)), (this.Kr[e.toKey()] = n)), n;
        }
        getGlobalsCache() {
          return this.Wr;
        }
        getTargetCache() {
          return this.Gr;
        }
        getRemoteDocumentCache() {
          return this.remoteDocumentCache;
        }
        getBundleCache() {
          return this.jr;
        }
        runTransaction(e, t, n) {
          ls("MemoryPersistence", "Starting transaction:", e);
          const r = new nc(this.$r.next());
          return (
            this.referenceDelegate.Hr(),
            n(r)
              .next((e) => this.referenceDelegate.Jr(r).next(() => e))
              .toPromise()
              .then((e) => (r.raiseOnCommittedEvent(), e))
          );
        }
        Yr(e, t) {
          return Gs.or(Object.values(this.Kr).map((n) => () => n.containsKey(e, t)));
        }
      }
      class nc extends zs {
        constructor(e) {
          super(), (this.currentSequenceNumber = e);
        }
      }
      class rc {
        constructor(e) {
          (this.persistence = e), (this.Zr = new Ql()), (this.Xr = null);
        }
        static ei(e) {
          return new rc(e);
        }
        get ti() {
          if (this.Xr) return this.Xr;
          throw hs();
        }
        addReference(e, t, n) {
          return this.Zr.addReference(n, t), this.ti.delete(n.toString()), Gs.resolve();
        }
        removeReference(e, t, n) {
          return this.Zr.removeReference(n, t), this.ti.add(n.toString()), Gs.resolve();
        }
        markPotentiallyOrphaned(e, t) {
          return this.ti.add(t.toString()), Gs.resolve();
        }
        removeTarget(e, t) {
          this.Zr.yr(t.targetId).forEach((e) => this.ti.add(e.toString()));
          const n = this.persistence.getTargetCache();
          return n
            .getMatchingKeysForTargetId(e, t.targetId)
            .next((e) => {
              e.forEach((e) => this.ti.add(e.toString()));
            })
            .next(() => n.removeTargetData(e, t));
        }
        Hr() {
          this.Xr = new Set();
        }
        Jr(e) {
          const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
          return Gs.forEach(this.ti, (n) => {
            const r = qs.fromPath(n);
            return this.ni(e, r).next((e) => {
              e || t.removeEntry(r, Ms.min());
            });
          }).next(() => ((this.Xr = null), t.apply(e)));
        }
        updateLimboDocument(e, t) {
          return this.ni(e, t).next((e) => {
            e ? this.ti.delete(t.toString()) : this.ti.add(t.toString());
          });
        }
        zr(e) {
          return 0;
        }
        ni(e, t) {
          return Gs.or([
            () => Gs.resolve(this.Zr.containsKey(t)),
            () => this.persistence.getTargetCache().containsKey(e, t),
            () => this.persistence.Yr(e, t),
          ]);
        }
      }
      class sc {
        constructor(e, t) {
          (this.persistence = e),
            (this.ri = new qo(
              (e) => Js(e.path),
              (e, t) => e.isEqual(t)
            )),
            (this.garbageCollector = jl(this, t));
        }
        static ei(e, t) {
          return new sc(e, t);
        }
        Hr() {}
        Jr(e) {
          return Gs.resolve();
        }
        forEachTarget(e, t) {
          return this.persistence.getTargetCache().forEachTarget(e, t);
        }
        Xn(e) {
          const t = this.nr(e);
          return this.persistence
            .getTargetCache()
            .getTargetCount(e)
            .next((e) => t.next((t) => e + t));
        }
        nr(e) {
          let t = 0;
          return this.er(e, (e) => {
            t++;
          }).next(() => t);
        }
        er(e, t) {
          return Gs.forEach(this.ri, (n, r) => this.ir(e, n, r).next((e) => (e ? Gs.resolve() : t(r))));
        }
        removeTargets(e, t, n) {
          return this.persistence.getTargetCache().removeTargets(e, t, n);
        }
        removeOrphanedDocuments(e, t) {
          let n = 0;
          const r = this.persistence.getRemoteDocumentCache(),
            s = r.newChangeBuffer();
          return r
            .Br(e, (r) =>
              this.ir(e, r, t).next((e) => {
                e || (n++, s.removeEntry(r, Ms.min()));
              })
            )
            .next(() => s.apply(e))
            .next(() => n);
        }
        markPotentiallyOrphaned(e, t) {
          return this.ri.set(t, e.currentSequenceNumber), Gs.resolve();
        }
        removeTarget(e, t) {
          const n = t.withSequenceNumber(e.currentSequenceNumber);
          return this.persistence.getTargetCache().updateTargetData(e, n);
        }
        addReference(e, t, n) {
          return this.ri.set(n, e.currentSequenceNumber), Gs.resolve();
        }
        removeReference(e, t, n) {
          return this.ri.set(n, e.currentSequenceNumber), Gs.resolve();
        }
        updateLimboDocument(e, t) {
          return this.ri.set(t, e.currentSequenceNumber), Gs.resolve();
        }
        zr(e) {
          let t = e.key.toString().length;
          return e.isFoundDocument() && (t += Pi(e.data.value)), t;
        }
        ir(e, t, n) {
          return Gs.or([
            () => this.persistence.Yr(e, t),
            () => this.persistence.getTargetCache().containsKey(e, t),
            () => {
              const e = this.ri.get(t);
              return Gs.resolve(void 0 !== e && e > n);
            },
          ]);
        }
        getCacheSize(e) {
          return this.persistence.getRemoteDocumentCache().getSize(e);
        }
      }
      class ic {
        constructor(e, t, n, r) {
          (this.targetId = e), (this.fromCache = t), (this.Wi = n), (this.Gi = r);
        }
        static zi(e, t) {
          let n = Wo(),
            r = Wo();
          for (const e of t.docChanges)
            switch (e.type) {
              case 0:
                n = n.add(e.doc.key);
                break;
              case 1:
                r = r.add(e.doc.key);
            }
          return new ic(e, t.fromCache, n, r);
        }
      }
      class oc {
        constructor() {
          this._documentReadCount = 0;
        }
        get documentReadCount() {
          return this._documentReadCount;
        }
        incrementDocumentReadCount(e) {
          this._documentReadCount += e;
        }
      }
      class ac {
        constructor() {
          (this.ji = !1), (this.Hi = !1), (this.Ji = 100), (this.Yi = Dn() ? 8 : Hs(Mn()) > 0 ? 6 : 4);
        }
        initialize(e, t) {
          (this.Zi = e), (this.indexManager = t), (this.ji = !0);
        }
        getDocumentsMatchingQuery(e, t, n, r) {
          const s = { result: null };
          return this.Xi(e, t)
            .next((e) => {
              s.result = e;
            })
            .next(() => {
              if (!s.result)
                return this.es(e, t, r, n).next((e) => {
                  s.result = e;
                });
            })
            .next(() => {
              if (s.result) return;
              const n = new oc();
              return this.ts(e, t, n).next((r) => {
                if (((s.result = r), this.Hi)) return this.ns(e, t, n, r.size);
              });
            })
            .next(() => s.result);
        }
        ns(e, t, n, r) {
          return n.documentReadCount < this.Ji
            ? (as() <= Gn.DEBUG &&
                ls(
                  "QueryEngine",
                  "SDK will not create cache indexes for query:",
                  Mo(t),
                  "since it only creates cache indexes for collection contains",
                  "more than or equal to",
                  this.Ji,
                  "documents"
                ),
              Gs.resolve())
            : (as() <= Gn.DEBUG &&
                ls("QueryEngine", "Query:", Mo(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."),
              n.documentReadCount > this.Yi * r
                ? (as() <= Gn.DEBUG &&
                    ls(
                      "QueryEngine",
                      "The SDK decides to create cache indexes for query:",
                      Mo(t),
                      "as using cache indexes may help improve performance."
                    ),
                  this.indexManager.createTargetIndexes(e, xo(t)))
                : Gs.resolve());
        }
        Xi(e, t) {
          if (To(t)) return Gs.resolve(null);
          let n = xo(t);
          return this.indexManager.getIndexType(e, n).next((r) =>
            0 === r
              ? null
              : (null !== t.limit && 1 === r && ((t = Io(t, null, "F")), (n = xo(t))),
                this.indexManager.getDocumentsMatchingTarget(e, n).next((r) => {
                  const s = Wo(...r);
                  return this.Zi.getDocuments(e, s).next((r) =>
                    this.indexManager.getMinOffset(e, n).next((n) => {
                      const i = this.rs(t, r);
                      return this.ss(t, i, s, n.readTime) ? this.Xi(e, Io(t, null, "F")) : this.os(e, i, t, n);
                    })
                  );
                }))
          );
        }
        es(e, t, n, r) {
          return To(t) || r.isEqual(Ms.min())
            ? Gs.resolve(null)
            : this.Zi.getDocuments(e, n).next((s) => {
                const i = this.rs(t, s);
                return this.ss(t, i, n, r)
                  ? Gs.resolve(null)
                  : (as() <= Gn.DEBUG && ls("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), Mo(t)),
                    this.os(e, i, t, Fs(r, -1)).next((e) => e));
              });
        }
        rs(e, t) {
          let n = new di(Po(e));
          return (
            t.forEach((t, r) => {
              Do(e, r) && (n = n.add(r));
            }),
            n
          );
        }
        ss(e, t, n, r) {
          if (null === e.limit) return !1;
          if (n.size !== t.size) return !0;
          const s = "F" === e.limitType ? t.last() : t.first();
          return !!s && (s.hasPendingWrites || s.version.compareTo(r) > 0);
        }
        ts(e, t, n) {
          return (
            as() <= Gn.DEBUG && ls("QueryEngine", "Using full collection scan to execute query:", Mo(t)),
            this.Zi.getDocumentsMatchingQuery(e, t, $s.min(), n)
          );
        }
        os(e, t, n, r) {
          return this.Zi.getDocumentsMatchingQuery(e, n, r).next(
            (e) => (
              t.forEach((t) => {
                e = e.insert(t.key, t);
              }),
              e
            )
          );
        }
      }
      class lc {
        constructor(e, t, n, r) {
          (this.persistence = e),
            (this._s = t),
            (this.serializer = r),
            (this.us = new li(Is)),
            (this.cs = new qo((e) => yo(e), vo)),
            (this.ls = new Map()),
            (this.hs = e.getRemoteDocumentCache()),
            (this.Gr = e.getTargetCache()),
            (this.jr = e.getBundleCache()),
            this.Ps(n);
        }
        Ps(e) {
          (this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e)),
            (this.indexManager = this.persistence.getIndexManager(e)),
            (this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager)),
            (this.localDocuments = new Gl(this.hs, this.mutationQueue, this.documentOverlayCache, this.indexManager)),
            this.hs.setIndexManager(this.indexManager),
            this._s.initialize(this.localDocuments, this.indexManager);
        }
        collectGarbage(e) {
          return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t) => e.collect(t, this.us));
        }
      }
      function cc(e, t, n, r) {
        return new lc(e, t, n, r);
      }
      async function uc(e, t) {
        const n = fs(e);
        return await n.persistence.runTransaction("Handle user change", "readonly", (e) => {
          let r;
          return n.mutationQueue
            .getAllMutationBatches(e)
            .next((s) => ((r = s), n.Ps(t), n.mutationQueue.getAllMutationBatches(e)))
            .next((t) => {
              const s = [],
                i = [];
              let o = Wo();
              for (const e of r) {
                s.push(e.batchId);
                for (const t of e.mutations) o = o.add(t.key);
              }
              for (const e of t) {
                i.push(e.batchId);
                for (const t of e.mutations) o = o.add(t.key);
              }
              return n.localDocuments.getDocuments(e, o).next((e) => ({ Ts: e, removedBatchIds: s, addedBatchIds: i }));
            });
        });
      }
      function dc(e) {
        const t = fs(e);
        return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e) => t.Gr.getLastRemoteSnapshotVersion(e));
      }
      function hc(e, t, n) {
        let r = Wo(),
          s = Wo();
        return (
          n.forEach((e) => (r = r.add(e))),
          t.getEntries(e, r).next((e) => {
            let r = Fo();
            return (
              n.forEach((n, i) => {
                const o = e.get(n);
                i.isFoundDocument() !== o.isFoundDocument() && (s = s.add(n)),
                  i.isNoDocument() && i.version.isEqual(Ms.min())
                    ? (t.removeEntry(n, i.readTime), (r = r.insert(n, i)))
                    : !o.isValidDocument() ||
                      i.version.compareTo(o.version) > 0 ||
                      (0 === i.version.compareTo(o.version) && o.hasPendingWrites)
                    ? (t.addEntry(i), (r = r.insert(n, i)))
                    : ls(
                        "LocalStore",
                        "Ignoring outdated watch update for ",
                        n,
                        ". Current version:",
                        o.version,
                        " Watch version:",
                        i.version
                      );
              }),
              { Is: r, ds: s }
            );
          })
        );
      }
      function pc(e, t) {
        const n = fs(e);
        return n.persistence.runTransaction(
          "Get next mutation batch",
          "readonly",
          (e) => (void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t))
        );
      }
      function fc(e, t) {
        const n = fs(e);
        return n.persistence
          .runTransaction("Allocate target", "readwrite", (e) => {
            let r;
            return n.Gr.getTargetData(e, t).next((s) =>
              s
                ? ((r = s), Gs.resolve(r))
                : n.Gr.allocateTargetId(e).next(
                    (s) => ((r = new kl(t, s, "TargetPurposeListen", e.currentSequenceNumber)), n.Gr.addTargetData(e, r).next(() => r))
                  )
            );
          })
          .then((e) => {
            const r = n.us.get(e.targetId);
            return (
              (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) &&
                ((n.us = n.us.insert(e.targetId, e)), n.cs.set(t, e.targetId)),
              e
            );
          });
      }
      async function mc(e, t, n) {
        const r = fs(e),
          s = r.us.get(t),
          i = n ? "readwrite" : "readwrite-primary";
        try {
          n || (await r.persistence.runTransaction("Release target", i, (e) => r.persistence.referenceDelegate.removeTarget(e, s)));
        } catch (e) {
          if (!Ws(e)) throw e;
          ls("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
        }
        (r.us = r.us.remove(t)), r.cs.delete(s.target);
      }
      function gc(e, t, n) {
        const r = fs(e);
        let s = Ms.min(),
          i = Wo();
        return r.persistence.runTransaction("Execute query", "readwrite", (e) =>
          (function (e, t, n) {
            const r = fs(e),
              s = r.cs.get(n);
            return void 0 !== s ? Gs.resolve(r.us.get(s)) : r.Gr.getTargetData(t, n);
          })(r, e, xo(t))
            .next((t) => {
              if (t)
                return (
                  (s = t.lastLimboFreeSnapshotVersion),
                  r.Gr.getMatchingKeysForTargetId(e, t.targetId).next((e) => {
                    i = e;
                  })
                );
            })
            .next(() => r._s.getDocumentsMatchingQuery(e, t, n ? s : Ms.min(), n ? i : Wo()))
            .next((e) => (yc(r, No(t), e), { documents: e, Es: i }))
        );
      }
      function yc(e, t, n) {
        let r = e.ls.get(t) || Ms.min();
        n.forEach((e, t) => {
          t.readTime.compareTo(r) > 0 && (r = t.readTime);
        }),
          e.ls.set(t, r);
      }
      class vc {
        constructor() {
          this.activeTargetIds = Qo();
        }
        ps(e) {
          this.activeTargetIds = this.activeTargetIds.add(e);
        }
        ys(e) {
          this.activeTargetIds = this.activeTargetIds.delete(e);
        }
        gs() {
          const e = { activeTargetIds: this.activeTargetIds.toArray(), updateTimeMs: Date.now() };
          return JSON.stringify(e);
        }
      }
      class wc {
        constructor() {
          (this._o = new vc()), (this.ao = {}), (this.onlineStateHandler = null), (this.sequenceNumberHandler = null);
        }
        addPendingMutation(e) {}
        updateMutationState(e, t, n) {}
        addLocalQueryTarget(e, t = !0) {
          return t && this._o.ps(e), this.ao[e] || "not-current";
        }
        updateQueryState(e, t, n) {
          this.ao[e] = t;
        }
        removeLocalQueryTarget(e) {
          this._o.ys(e);
        }
        isLocalQueryTarget(e) {
          return this._o.activeTargetIds.has(e);
        }
        clearQueryState(e) {
          delete this.ao[e];
        }
        getAllActiveQueryTargets() {
          return this._o.activeTargetIds;
        }
        isActiveQueryTarget(e) {
          return this._o.activeTargetIds.has(e);
        }
        start() {
          return (this._o = new vc()), Promise.resolve();
        }
        handleUserChange(e, t, n) {}
        setOnlineState(e) {}
        shutdown() {}
        writeSequenceNumber(e) {}
        notifyBundleLoaded(e) {}
      }
      class bc {
        uo(e) {}
        shutdown() {}
      }
      class Sc {
        constructor() {
          (this.co = () => this.lo()), (this.ho = () => this.Po()), (this.To = []), this.Io();
        }
        uo(e) {
          this.To.push(e);
        }
        shutdown() {
          window.removeEventListener("online", this.co), window.removeEventListener("offline", this.ho);
        }
        Io() {
          window.addEventListener("online", this.co), window.addEventListener("offline", this.ho);
        }
        lo() {
          ls("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
          for (const e of this.To) e(0);
        }
        Po() {
          ls("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
          for (const e of this.To) e(1);
        }
        static p() {
          return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
        }
      }
      let Ec = null;
      function Tc() {
        return null === Ec ? (Ec = 268435456 + Math.round(2147483648 * Math.random())) : Ec++, "0x" + Ec.toString(16);
      }
      const _c = { BatchGetDocuments: "batchGet", Commit: "commit", RunQuery: "runQuery", RunAggregationQuery: "runAggregationQuery" };
      class Cc {
        constructor(e) {
          (this.Eo = e.Eo), (this.Ao = e.Ao);
        }
        Ro(e) {
          this.Vo = e;
        }
        mo(e) {
          this.fo = e;
        }
        po(e) {
          this.yo = e;
        }
        onMessage(e) {
          this.wo = e;
        }
        close() {
          this.Ao();
        }
        send(e) {
          this.Eo(e);
        }
        So() {
          this.Vo();
        }
        bo() {
          this.fo();
        }
        Do(e) {
          this.yo(e);
        }
        vo(e) {
          this.wo(e);
        }
      }
      const xc = "WebChannelConnection";
      class Ac extends class {
        get Co() {
          return !1;
        }
        constructor(e) {
          (this.databaseInfo = e), (this.databaseId = e.databaseId);
          const t = e.ssl ? "https" : "http",
            n = encodeURIComponent(this.databaseId.projectId),
            r = encodeURIComponent(this.databaseId.database);
          (this.Fo = t + "://" + e.host),
            (this.Mo = `projects/${n}/databases/${r}`),
            (this.xo = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`);
        }
        Oo(e, t, n, r, s) {
          const i = Tc(),
            o = this.No(e, t.toUriEncodedString());
          ls("RestConnection", `Sending RPC '${e}' ${i}:`, o, n);
          const a = { "google-cloud-resource-prefix": this.Mo, "x-goog-request-params": this.xo };
          return (
            this.Bo(a, r, s),
            this.Lo(e, o, a, n).then(
              (t) => (ls("RestConnection", `Received RPC '${e}' ${i}: `, t), t),
              (t) => {
                throw (us("RestConnection", `RPC '${e}' ${i} failed with error: `, t, "url: ", o, "request:", n), t);
              }
            )
          );
        }
        ko(e, t, n, r, s, i) {
          return this.Oo(e, t, n, r, s);
        }
        Bo(e, t, n) {
          (e["X-Goog-Api-Client"] = "gl-js/ fire/" + is),
            (e["Content-Type"] = "text/plain"),
            this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId),
            t && t.headers.forEach((t, n) => (e[n] = t)),
            n && n.headers.forEach((t, n) => (e[n] = t));
        }
        No(e, t) {
          const n = _c[e];
          return `${this.Fo}/v1/${t}:${n}`;
        }
        terminate() {}
      } {
        constructor(e) {
          super(e),
            (this.forceLongPolling = e.forceLongPolling),
            (this.autoDetectLongPolling = e.autoDetectLongPolling),
            (this.useFetchStreams = e.useFetchStreams),
            (this.longPollingOptions = e.longPollingOptions);
        }
        Lo(e, t, n, r) {
          const s = Tc();
          return new Promise((i, o) => {
            const a = new Wr();
            a.setWithCredentials(!0),
              a.listenOnce(Qr.COMPLETE, () => {
                try {
                  switch (a.getLastErrorCode()) {
                    case Yr.NO_ERROR:
                      const t = a.getResponseJson();
                      ls(xc, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                      break;
                    case Yr.TIMEOUT:
                      ls(xc, `RPC '${e}' ${s} timed out`), o(new gs(ms.DEADLINE_EXCEEDED, "Request time out"));
                      break;
                    case Yr.HTTP_ERROR:
                      const n = a.getStatus();
                      if ((ls(xc, `RPC '${e}' ${s} failed with status:`, n, "response text:", a.getResponseText()), n > 0)) {
                        let e = a.getResponseJson();
                        Array.isArray(e) && (e = e[0]);
                        const t = null == e ? void 0 : e.error;
                        if (t && t.status && t.message) {
                          const e = (function (e) {
                            const t = e.toLowerCase().replace(/_/g, "-");
                            return Object.values(ms).indexOf(t) >= 0 ? t : ms.UNKNOWN;
                          })(t.status);
                          o(new gs(e, t.message));
                        } else o(new gs(ms.UNKNOWN, "Server responded with status " + a.getStatus()));
                      } else o(new gs(ms.UNAVAILABLE, "Connection failed."));
                      break;
                    default:
                      hs();
                  }
                } finally {
                  ls(xc, `RPC '${e}' ${s} completed.`);
                }
              });
            const l = JSON.stringify(r);
            ls(xc, `RPC '${e}' ${s} sending request:`, r), a.send(t, "POST", l, n, 15);
          });
        }
        qo(e, t, n) {
          const r = Tc(),
            s = [this.Fo, "/", "google.firestore.v1.Firestore", "/", e, "/channel"],
            i = es(),
            o = Zr(),
            a = {
              httpSessionIdParam: "gsessionid",
              initMessageHeaders: {},
              messageUrlParams: { database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}` },
              sendRawJson: !0,
              supportsCrossDomainXhr: !0,
              internalChannelParams: { forwardChannelRequestTimeoutMs: 6e5 },
              forceLongPolling: this.forceLongPolling,
              detectBufferingProxy: this.autoDetectLongPolling,
            },
            l = this.longPollingOptions.timeoutSeconds;
          void 0 !== l && (a.longPollingTimeout = Math.round(1e3 * l)),
            this.useFetchStreams && (a.useFetchStreams = !0),
            this.Bo(a.initMessageHeaders, t, n),
            (a.encodeInitMessageHeaders = !0);
          const c = s.join("");
          ls(xc, `Creating RPC '${e}' stream ${r}: ${c}`, a);
          const u = i.createWebChannel(c, a);
          let d = !1,
            h = !1;
          const p = new Cc({
              Eo: (t) => {
                h
                  ? ls(xc, `Not sending because RPC '${e}' stream ${r} is closed:`, t)
                  : (d || (ls(xc, `Opening RPC '${e}' stream ${r} transport.`), u.open(), (d = !0)),
                    ls(xc, `RPC '${e}' stream ${r} sending:`, t),
                    u.send(t));
              },
              Ao: () => u.close(),
            }),
            f = (e, t, n) => {
              e.listen(t, (e) => {
                try {
                  n(e);
                } catch (e) {
                  setTimeout(() => {
                    throw e;
                  }, 0);
                }
              });
            };
          return (
            f(u, Kr.EventType.OPEN, () => {
              h || (ls(xc, `RPC '${e}' stream ${r} transport opened.`), p.So());
            }),
            f(u, Kr.EventType.CLOSE, () => {
              h || ((h = !0), ls(xc, `RPC '${e}' stream ${r} transport closed`), p.Do());
            }),
            f(u, Kr.EventType.ERROR, (t) => {
              h ||
                ((h = !0),
                us(xc, `RPC '${e}' stream ${r} transport errored:`, t),
                p.Do(new gs(ms.UNAVAILABLE, "The operation could not be completed")));
            }),
            f(u, Kr.EventType.MESSAGE, (t) => {
              var n;
              if (!h) {
                const s = t.data[0];
                ps(!!s);
                const i = s,
                  o = (null == i ? void 0 : i.error) || (null === (n = i[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                  ls(xc, `RPC '${e}' stream ${r} received error:`, o);
                  const t = o.status;
                  let n = (function (e) {
                      const t = Ma[e];
                      if (void 0 !== t) return Pa(t);
                    })(t),
                    s = o.message;
                  void 0 === n && ((n = ms.INTERNAL), (s = "Unknown error status: " + t + " with message " + o.message)),
                    (h = !0),
                    p.Do(new gs(n, s)),
                    u.close();
                } else ls(xc, `RPC '${e}' stream ${r} received:`, s), p.vo(s);
              }
            }),
            f(o, Jr.STAT_EVENT, (t) => {
              t.stat === Xr.PROXY
                ? ls(xc, `RPC '${e}' stream ${r} detected buffering proxy`)
                : t.stat === Xr.NOPROXY && ls(xc, `RPC '${e}' stream ${r} detected no buffering proxy`);
            }),
            setTimeout(() => {
              p.bo();
            }, 0),
            p
          );
        }
      }
      function Ic() {
        return "undefined" != typeof document ? document : null;
      }
      function kc(e) {
        return new el(e, !0);
      }
      class Lc {
        constructor(e, t, n = 1e3, r = 1.5, s = 6e4) {
          (this.li = e),
            (this.timerId = t),
            (this.Qo = n),
            (this.Ko = r),
            (this.$o = s),
            (this.Uo = 0),
            (this.Wo = null),
            (this.Go = Date.now()),
            this.reset();
        }
        reset() {
          this.Uo = 0;
        }
        zo() {
          this.Uo = this.$o;
        }
        jo(e) {
          this.cancel();
          const t = Math.floor(this.Uo + this.Ho()),
            n = Math.max(0, Date.now() - this.Go),
            r = Math.max(0, t - n);
          r > 0 &&
            ls(
              "ExponentialBackoff",
              `Backing off for ${r} ms (base delay: ${this.Uo} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`
            ),
            (this.Wo = this.li.enqueueAfterDelay(this.timerId, r, () => ((this.Go = Date.now()), e()))),
            (this.Uo *= this.Ko),
            this.Uo < this.Qo && (this.Uo = this.Qo),
            this.Uo > this.$o && (this.Uo = this.$o);
        }
        Jo() {
          null !== this.Wo && (this.Wo.skipDelay(), (this.Wo = null));
        }
        cancel() {
          null !== this.Wo && (this.Wo.cancel(), (this.Wo = null));
        }
        Ho() {
          return (Math.random() - 0.5) * this.Uo;
        }
      }
      class Mc {
        constructor(e, t, n, r, s, i, o, a) {
          (this.li = e),
            (this.Yo = n),
            (this.Zo = r),
            (this.connection = s),
            (this.authCredentialsProvider = i),
            (this.appCheckCredentialsProvider = o),
            (this.listener = a),
            (this.state = 0),
            (this.Xo = 0),
            (this.e_ = null),
            (this.t_ = null),
            (this.stream = null),
            (this.n_ = 0),
            (this.r_ = new Lc(e, t));
        }
        i_() {
          return 1 === this.state || 5 === this.state || this.s_();
        }
        s_() {
          return 2 === this.state || 3 === this.state;
        }
        start() {
          (this.n_ = 0), 4 !== this.state ? this.auth() : this.o_();
        }
        async stop() {
          this.i_() && (await this.close(0));
        }
        __() {
          (this.state = 0), this.r_.reset();
        }
        a_() {
          this.s_() && null === this.e_ && (this.e_ = this.li.enqueueAfterDelay(this.Yo, 6e4, () => this.u_()));
        }
        c_(e) {
          this.l_(), this.stream.send(e);
        }
        async u_() {
          if (this.s_()) return this.close(0);
        }
        l_() {
          this.e_ && (this.e_.cancel(), (this.e_ = null));
        }
        h_() {
          this.t_ && (this.t_.cancel(), (this.t_ = null));
        }
        async close(e, t) {
          this.l_(),
            this.h_(),
            this.r_.cancel(),
            this.Xo++,
            4 !== e
              ? this.r_.reset()
              : t && t.code === ms.RESOURCE_EXHAUSTED
              ? (cs(t.toString()), cs("Using maximum backoff delay to prevent overloading the backend."), this.r_.zo())
              : t &&
                t.code === ms.UNAUTHENTICATED &&
                3 !== this.state &&
                (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()),
            null !== this.stream && (this.P_(), this.stream.close(), (this.stream = null)),
            (this.state = e),
            await this.listener.po(t);
        }
        P_() {}
        auth() {
          this.state = 1;
          const e = this.T_(this.Xo),
            t = this.Xo;
          Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then(
            ([e, n]) => {
              this.Xo === t && this.I_(e, n);
            },
            (t) => {
              e(() => {
                const e = new gs(ms.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.d_(e);
              });
            }
          );
        }
        I_(e, t) {
          const n = this.T_(this.Xo);
          (this.stream = this.E_(e, t)),
            this.stream.Ro(() => {
              n(() => this.listener.Ro());
            }),
            this.stream.mo(() => {
              n(
                () => (
                  (this.state = 2),
                  (this.t_ = this.li.enqueueAfterDelay(this.Zo, 1e4, () => (this.s_() && (this.state = 3), Promise.resolve()))),
                  this.listener.mo()
                )
              );
            }),
            this.stream.po((e) => {
              n(() => this.d_(e));
            }),
            this.stream.onMessage((e) => {
              n(() => (1 == ++this.n_ ? this.A_(e) : this.onNext(e)));
            });
        }
        o_() {
          (this.state = 5),
            this.r_.jo(async () => {
              (this.state = 0), this.start();
            });
        }
        d_(e) {
          return ls("PersistentStream", `close with error: ${e}`), (this.stream = null), this.close(4, e);
        }
        T_(e) {
          return (t) => {
            this.li.enqueueAndForget(() =>
              this.Xo === e ? t() : (ls("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve())
            );
          };
        }
      }
      class Dc extends Mc {
        constructor(e, t, n, r, s, i) {
          super(e, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", t, n, r, i), (this.serializer = s);
        }
        E_(e, t) {
          return this.connection.qo("Listen", e, t);
        }
        A_(e) {
          return this.onNext(e);
        }
        onNext(e) {
          this.r_.reset();
          const t = (function (e, t) {
              let n;
              if ("targetChange" in t) {
                t.targetChange;
                const r = (function (e) {
                    return "NO_CHANGE" === e ? 0 : "ADD" === e ? 1 : "REMOVE" === e ? 2 : "CURRENT" === e ? 3 : "RESET" === e ? 4 : hs();
                  })(t.targetChange.targetChangeType || "NO_CHANGE"),
                  s = t.targetChange.targetIds || [],
                  i = (function (e, t) {
                    return e.useProto3Json
                      ? (ps(void 0 === t || "string" == typeof t), mi.fromBase64String(t || ""))
                      : (ps(void 0 === t || t instanceof Buffer || t instanceof Uint8Array), mi.fromUint8Array(t || new Uint8Array()));
                  })(e, t.targetChange.resumeToken),
                  o = t.targetChange.cause,
                  a =
                    o &&
                    (function (e) {
                      const t = void 0 === e.code ? ms.UNKNOWN : Pa(e.code);
                      return new gs(t, e.message || "");
                    })(o);
                n = new Ha(r, s, i, a || null);
              } else if ("documentChange" in t) {
                t.documentChange;
                const r = t.documentChange;
                r.document, r.document.name, r.document.updateTime;
                const s = ul(e, r.document.name),
                  i = il(r.document.updateTime),
                  o = r.document.createTime ? il(r.document.createTime) : Ms.min(),
                  a = new zi({ mapValue: { fields: r.document.fields } }),
                  l = Gi.newFoundDocument(s, i, o, a),
                  c = r.targetIds || [],
                  u = r.removedTargetIds || [];
                n = new Ua(c, u, l.key, l);
              } else if ("documentDelete" in t) {
                t.documentDelete;
                const r = t.documentDelete;
                r.document;
                const s = ul(e, r.document),
                  i = r.readTime ? il(r.readTime) : Ms.min(),
                  o = Gi.newNoDocument(s, i),
                  a = r.removedTargetIds || [];
                n = new Ua([], a, o.key, o);
              } else if ("documentRemove" in t) {
                t.documentRemove;
                const r = t.documentRemove;
                r.document;
                const s = ul(e, r.document),
                  i = r.removedTargetIds || [];
                n = new Ua([], i, s, null);
              } else {
                if (!("filter" in t)) return hs();
                {
                  t.filter;
                  const e = t.filter;
                  e.targetId;
                  const { count: r = 0, unchangedNames: s } = e,
                    i = new La(r, s),
                    o = e.targetId;
                  n = new Ga(o, i);
                }
              }
              return n;
            })(this.serializer, e),
            n = (function (e) {
              if (!("targetChange" in e)) return Ms.min();
              const t = e.targetChange;
              return t.targetIds && t.targetIds.length ? Ms.min() : t.readTime ? il(t.readTime) : Ms.min();
            })(e);
          return this.listener.R_(t, n);
        }
        V_(e) {
          const t = {};
          (t.database = pl(this.serializer)),
            (t.addTarget = (function (e, t) {
              let n;
              const r = t.target;
              if (
                ((n = wo(r) ? { documents: yl(e, r) } : { query: vl(e, r).ct }),
                (n.targetId = t.targetId),
                t.resumeToken.approximateByteSize() > 0)
              ) {
                n.resumeToken = rl(e, t.resumeToken);
                const r = tl(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
              } else if (t.snapshotVersion.compareTo(Ms.min()) > 0) {
                n.readTime = nl(e, t.snapshotVersion.toTimestamp());
                const r = tl(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
              }
              return n;
            })(this.serializer, e));
          const n = (function (e, t) {
            const n = (function (e) {
              switch (e) {
                case "TargetPurposeListen":
                  return null;
                case "TargetPurposeExistenceFilterMismatch":
                  return "existence-filter-mismatch";
                case "TargetPurposeExistenceFilterMismatchBloom":
                  return "existence-filter-mismatch-bloom";
                case "TargetPurposeLimboResolution":
                  return "limbo-document";
                default:
                  return hs();
              }
            })(t.purpose);
            return null == n ? null : { "goog-listen-tags": n };
          })(this.serializer, e);
          n && (t.labels = n), this.c_(t);
        }
        m_(e) {
          const t = {};
          (t.database = pl(this.serializer)), (t.removeTarget = e), this.c_(t);
        }
      }
      class Nc extends Mc {
        constructor(e, t, n, r, s, i) {
          super(e, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", t, n, r, i), (this.serializer = s);
        }
        get f_() {
          return this.n_ > 0;
        }
        start() {
          (this.lastStreamToken = void 0), super.start();
        }
        P_() {
          this.f_ && this.g_([]);
        }
        E_(e, t) {
          return this.connection.qo("Write", e, t);
        }
        A_(e) {
          return (
            ps(!!e.streamToken),
            (this.lastStreamToken = e.streamToken),
            ps(!e.writeResults || 0 === e.writeResults.length),
            this.listener.p_()
          );
        }
        onNext(e) {
          ps(!!e.streamToken), (this.lastStreamToken = e.streamToken), this.r_.reset();
          const t = (function (e, t) {
              return e && e.length > 0
                ? (ps(void 0 !== t),
                  e.map((e) =>
                    (function (e, t) {
                      let n = e.updateTime ? il(e.updateTime) : il(t);
                      return n.isEqual(Ms.min()) && (n = il(t)), new da(n, e.transformResults || []);
                    })(e, t)
                  ))
                : [];
            })(e.writeResults, e.commitTime),
            n = il(e.commitTime);
          return this.listener.y_(n, t);
        }
        w_() {
          const e = {};
          (e.database = pl(this.serializer)), this.c_(e);
        }
        g_(e) {
          const t = { streamToken: this.lastStreamToken, writes: e.map((e) => gl(this.serializer, e)) };
          this.c_(t);
        }
      }
      class Pc extends class {} {
        constructor(e, t, n, r) {
          super(), (this.authCredentials = e), (this.appCheckCredentials = t), (this.connection = n), (this.serializer = r), (this.S_ = !1);
        }
        b_() {
          if (this.S_) throw new gs(ms.FAILED_PRECONDITION, "The client has already been terminated.");
        }
        Oo(e, t, n, r) {
          return (
            this.b_(),
            Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()])
              .then(([s, i]) => this.connection.Oo(e, al(t, n), r, s, i))
              .catch((e) => {
                throw "FirebaseError" === e.name
                  ? (e.code === ms.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()),
                    e)
                  : new gs(ms.UNKNOWN, e.toString());
              })
          );
        }
        ko(e, t, n, r, s) {
          return (
            this.b_(),
            Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()])
              .then(([i, o]) => this.connection.ko(e, al(t, n), r, i, o, s))
              .catch((e) => {
                throw "FirebaseError" === e.name
                  ? (e.code === ms.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()),
                    e)
                  : new gs(ms.UNKNOWN, e.toString());
              })
          );
        }
        terminate() {
          (this.S_ = !0), this.connection.terminate();
        }
      }
      class Oc {
        constructor(e, t) {
          (this.asyncQueue = e), (this.onlineStateHandler = t), (this.state = "Unknown"), (this.D_ = 0), (this.v_ = null), (this.C_ = !0);
        }
        F_() {
          0 === this.D_ &&
            (this.M_("Unknown"),
            (this.v_ = this.asyncQueue.enqueueAfterDelay(
              "online_state_timeout",
              1e4,
              () => ((this.v_ = null), this.x_("Backend didn't respond within 10 seconds."), this.M_("Offline"), Promise.resolve())
            )));
        }
        O_(e) {
          "Online" === this.state
            ? this.M_("Unknown")
            : (this.D_++,
              this.D_ >= 1 && (this.N_(), this.x_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.M_("Offline")));
        }
        set(e) {
          this.N_(), (this.D_ = 0), "Online" === e && (this.C_ = !1), this.M_(e);
        }
        M_(e) {
          e !== this.state && ((this.state = e), this.onlineStateHandler(e));
        }
        x_(e) {
          const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
          this.C_ ? (cs(t), (this.C_ = !1)) : ls("OnlineStateTracker", t);
        }
        N_() {
          null !== this.v_ && (this.v_.cancel(), (this.v_ = null));
        }
      }
      class qc {
        constructor(e, t, n, r, s) {
          (this.localStore = e),
            (this.datastore = t),
            (this.asyncQueue = n),
            (this.remoteSyncer = {}),
            (this.B_ = []),
            (this.L_ = new Map()),
            (this.k_ = new Set()),
            (this.q_ = []),
            (this.Q_ = s),
            this.Q_.uo((e) => {
              n.enqueueAndForget(async () => {
                Gc(this) &&
                  (ls("RemoteStore", "Restarting streams for network reachability change."),
                  await (async function (e) {
                    const t = fs(e);
                    t.k_.add(4), await Fc(t), t.K_.set("Unknown"), t.k_.delete(4), await Rc(t);
                  })(this));
              });
            }),
            (this.K_ = new Oc(n, r));
        }
      }
      async function Rc(e) {
        if (Gc(e)) for (const t of e.q_) await t(!0);
      }
      async function Fc(e) {
        for (const t of e.q_) await t(!1);
      }
      function Bc(e, t) {
        const n = fs(e);
        n.L_.has(t.targetId) || (n.L_.set(t.targetId, t), Uc(n) ? zc(n) : uu(n).s_() && Vc(n, t));
      }
      function $c(e, t) {
        const n = fs(e),
          r = uu(n);
        n.L_.delete(t), r.s_() && jc(n, t), 0 === n.L_.size && (r.s_() ? r.a_() : Gc(n) && n.K_.set("Unknown"));
      }
      function Vc(e, t) {
        if ((e.U_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(Ms.min()) > 0)) {
          const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
          t = t.withExpectedCount(n);
        }
        uu(e).V_(t);
      }
      function jc(e, t) {
        e.U_.xe(t), uu(e).m_(t);
      }
      function zc(e) {
        (e.U_ = new Ka({
          getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
          ut: (t) => e.L_.get(t) || null,
          nt: () => e.datastore.serializer.databaseId,
        })),
          uu(e).start(),
          e.K_.F_();
      }
      function Uc(e) {
        return Gc(e) && !uu(e).i_() && e.L_.size > 0;
      }
      function Gc(e) {
        return 0 === fs(e).k_.size;
      }
      function Hc(e) {
        e.U_ = void 0;
      }
      async function Wc(e) {
        e.K_.set("Online");
      }
      async function Kc(e) {
        e.L_.forEach((t, n) => {
          Vc(e, t);
        });
      }
      async function Qc(e, t) {
        Hc(e), Uc(e) ? (e.K_.O_(t), zc(e)) : e.K_.set("Unknown");
      }
      async function Yc(e, t, n) {
        if ((e.K_.set("Online"), t instanceof Ha && 2 === t.state && t.cause))
          try {
            await (async function (e, t) {
              const n = t.cause;
              for (const r of t.targetIds) e.L_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.L_.delete(r), e.U_.removeTarget(r));
            })(e, t);
          } catch (n) {
            ls("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await Xc(e, n);
          }
        else if ((t instanceof Ua ? e.U_.$e(t) : t instanceof Ga ? e.U_.Je(t) : e.U_.Ge(t), !n.isEqual(Ms.min())))
          try {
            const t = await dc(e.localStore);
            n.compareTo(t) >= 0 &&
              (await (function (e, t) {
                const n = e.U_.it(t);
                return (
                  n.targetChanges.forEach((n, r) => {
                    if (n.resumeToken.approximateByteSize() > 0) {
                      const s = e.L_.get(r);
                      s && e.L_.set(r, s.withResumeToken(n.resumeToken, t));
                    }
                  }),
                  n.targetMismatches.forEach((t, n) => {
                    const r = e.L_.get(t);
                    if (!r) return;
                    e.L_.set(t, r.withResumeToken(mi.EMPTY_BYTE_STRING, r.snapshotVersion)), jc(e, t);
                    const s = new kl(r.target, t, n, r.sequenceNumber);
                    Vc(e, s);
                  }),
                  e.remoteSyncer.applyRemoteEvent(n)
                );
              })(e, n));
          } catch (t) {
            ls("RemoteStore", "Failed to raise snapshot:", t), await Xc(e, t);
          }
      }
      async function Xc(e, t, n) {
        if (!Ws(t)) throw t;
        e.k_.add(1),
          await Fc(e),
          e.K_.set("Offline"),
          n || (n = () => dc(e.localStore)),
          e.asyncQueue.enqueueRetryable(async () => {
            ls("RemoteStore", "Retrying IndexedDB access"), await n(), e.k_.delete(1), await Rc(e);
          });
      }
      function Jc(e, t) {
        return t().catch((n) => Xc(e, n, t));
      }
      async function Zc(e) {
        const t = fs(e),
          n = du(t);
        let r = t.B_.length > 0 ? t.B_[t.B_.length - 1].batchId : -1;
        for (; eu(t); )
          try {
            const e = await pc(t.localStore, r);
            if (null === e) {
              0 === t.B_.length && n.a_();
              break;
            }
            (r = e.batchId), tu(t, e);
          } catch (e) {
            await Xc(t, e);
          }
        nu(t) && ru(t);
      }
      function eu(e) {
        return Gc(e) && e.B_.length < 10;
      }
      function tu(e, t) {
        e.B_.push(t);
        const n = du(e);
        n.s_() && n.f_ && n.g_(t.mutations);
      }
      function nu(e) {
        return Gc(e) && !du(e).i_() && e.B_.length > 0;
      }
      function ru(e) {
        du(e).start();
      }
      async function su(e) {
        du(e).w_();
      }
      async function iu(e) {
        const t = du(e);
        for (const n of e.B_) t.g_(n.mutations);
      }
      async function ou(e, t, n) {
        const r = e.B_.shift(),
          s = Ia.from(r, t, n);
        await Jc(e, () => e.remoteSyncer.applySuccessfulWrite(s)), await Zc(e);
      }
      async function au(e, t) {
        t &&
          du(e).f_ &&
          (await (async function (e, t) {
            if (
              (function (e) {
                return Na(e) && e !== ms.ABORTED;
              })(t.code)
            ) {
              const n = e.B_.shift();
              du(e).__(), await Jc(e, () => e.remoteSyncer.rejectFailedWrite(n.batchId, t)), await Zc(e);
            }
          })(e, t)),
          nu(e) && ru(e);
      }
      async function lu(e, t) {
        const n = fs(e);
        n.asyncQueue.verifyOperationInProgress(), ls("RemoteStore", "RemoteStore received new credentials");
        const r = Gc(n);
        n.k_.add(3), await Fc(n), r && n.K_.set("Unknown"), await n.remoteSyncer.handleCredentialChange(t), n.k_.delete(3), await Rc(n);
      }
      async function cu(e, t) {
        const n = fs(e);
        t ? (n.k_.delete(2), await Rc(n)) : t || (n.k_.add(2), await Fc(n), n.K_.set("Unknown"));
      }
      function uu(e) {
        return (
          e.W_ ||
            ((e.W_ = (function (e, t, n) {
              const r = fs(e);
              return r.b_(), new Dc(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
            })(e.datastore, e.asyncQueue, { Ro: Wc.bind(null, e), mo: Kc.bind(null, e), po: Qc.bind(null, e), R_: Yc.bind(null, e) })),
            e.q_.push(async (t) => {
              t ? (e.W_.__(), Uc(e) ? zc(e) : e.K_.set("Unknown")) : (await e.W_.stop(), Hc(e));
            })),
          e.W_
        );
      }
      function du(e) {
        return (
          e.G_ ||
            ((e.G_ = (function (e, t, n) {
              const r = fs(e);
              return r.b_(), new Nc(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
            })(e.datastore, e.asyncQueue, {
              Ro: () => Promise.resolve(),
              mo: su.bind(null, e),
              po: au.bind(null, e),
              p_: iu.bind(null, e),
              y_: ou.bind(null, e),
            })),
            e.q_.push(async (t) => {
              t
                ? (e.G_.__(), await Zc(e))
                : (await e.G_.stop(),
                  e.B_.length > 0 && (ls("RemoteStore", `Stopping write stream with ${e.B_.length} pending writes`), (e.B_ = [])));
            })),
          e.G_
        );
      }
      class hu {
        constructor(e, t, n, r, s) {
          (this.asyncQueue = e),
            (this.timerId = t),
            (this.targetTimeMs = n),
            (this.op = r),
            (this.removalCallback = s),
            (this.deferred = new ys()),
            (this.then = this.deferred.promise.then.bind(this.deferred.promise)),
            this.deferred.promise.catch((e) => {});
        }
        get promise() {
          return this.deferred.promise;
        }
        static createAndSchedule(e, t, n, r, s) {
          const i = Date.now() + n,
            o = new hu(e, t, i, r, s);
          return o.start(n), o;
        }
        start(e) {
          this.timerHandle = setTimeout(() => this.handleDelayElapsed(), e);
        }
        skipDelay() {
          return this.handleDelayElapsed();
        }
        cancel(e) {
          null !== this.timerHandle &&
            (this.clearTimeout(), this.deferred.reject(new gs(ms.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
        }
        handleDelayElapsed() {
          this.asyncQueue.enqueueAndForget(() =>
            null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e) => this.deferred.resolve(e))) : Promise.resolve()
          );
        }
        clearTimeout() {
          null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), (this.timerHandle = null));
        }
      }
      function pu(e, t) {
        if ((cs("AsyncQueue", `${t}: ${e}`), Ws(e))) return new gs(ms.UNAVAILABLE, `${t}: ${e}`);
        throw e;
      }
      class fu {
        static emptySet(e) {
          return new fu(e.comparator);
        }
        constructor(e) {
          (this.comparator = e ? (t, n) => e(t, n) || qs.comparator(t.key, n.key) : (e, t) => qs.comparator(e.key, t.key)),
            (this.keyedMap = $o()),
            (this.sortedSet = new li(this.comparator));
        }
        has(e) {
          return null != this.keyedMap.get(e);
        }
        get(e) {
          return this.keyedMap.get(e);
        }
        first() {
          return this.sortedSet.minKey();
        }
        last() {
          return this.sortedSet.maxKey();
        }
        isEmpty() {
          return this.sortedSet.isEmpty();
        }
        indexOf(e) {
          const t = this.keyedMap.get(e);
          return t ? this.sortedSet.indexOf(t) : -1;
        }
        get size() {
          return this.sortedSet.size;
        }
        forEach(e) {
          this.sortedSet.inorderTraversal((t, n) => (e(t), !1));
        }
        add(e) {
          const t = this.delete(e.key);
          return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
        }
        delete(e) {
          const t = this.get(e);
          return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
        }
        isEqual(e) {
          if (!(e instanceof fu)) return !1;
          if (this.size !== e.size) return !1;
          const t = this.sortedSet.getIterator(),
            n = e.sortedSet.getIterator();
          for (; t.hasNext(); ) {
            const e = t.getNext().key,
              r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
          }
          return !0;
        }
        toString() {
          const e = [];
          return (
            this.forEach((t) => {
              e.push(t.toString());
            }),
            0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)"
          );
        }
        copy(e, t) {
          const n = new fu();
          return (n.comparator = this.comparator), (n.keyedMap = e), (n.sortedSet = t), n;
        }
      }
      class mu {
        constructor() {
          this.z_ = new li(qs.comparator);
        }
        track(e) {
          const t = e.doc.key,
            n = this.z_.get(t);
          n
            ? 0 !== e.type && 3 === n.type
              ? (this.z_ = this.z_.insert(t, e))
              : 3 === e.type && 1 !== n.type
              ? (this.z_ = this.z_.insert(t, { type: n.type, doc: e.doc }))
              : 2 === e.type && 2 === n.type
              ? (this.z_ = this.z_.insert(t, { type: 2, doc: e.doc }))
              : 2 === e.type && 0 === n.type
              ? (this.z_ = this.z_.insert(t, { type: 0, doc: e.doc }))
              : 1 === e.type && 0 === n.type
              ? (this.z_ = this.z_.remove(t))
              : 1 === e.type && 2 === n.type
              ? (this.z_ = this.z_.insert(t, { type: 1, doc: n.doc }))
              : 0 === e.type && 1 === n.type
              ? (this.z_ = this.z_.insert(t, { type: 2, doc: e.doc }))
              : hs()
            : (this.z_ = this.z_.insert(t, e));
        }
        j_() {
          const e = [];
          return (
            this.z_.inorderTraversal((t, n) => {
              e.push(n);
            }),
            e
          );
        }
      }
      class gu {
        constructor(e, t, n, r, s, i, o, a, l) {
          (this.query = e),
            (this.docs = t),
            (this.oldDocs = n),
            (this.docChanges = r),
            (this.mutatedKeys = s),
            (this.fromCache = i),
            (this.syncStateChanged = o),
            (this.excludesMetadataChanges = a),
            (this.hasCachedResults = l);
        }
        static fromInitialDocuments(e, t, n, r, s) {
          const i = [];
          return (
            t.forEach((e) => {
              i.push({ type: 0, doc: e });
            }),
            new gu(e, t, fu.emptySet(t), i, n, r, !0, !1, s)
          );
        }
        get hasPendingWrites() {
          return !this.mutatedKeys.isEmpty();
        }
        isEqual(e) {
          if (
            !(
              this.fromCache === e.fromCache &&
              this.hasCachedResults === e.hasCachedResults &&
              this.syncStateChanged === e.syncStateChanged &&
              this.mutatedKeys.isEqual(e.mutatedKeys) &&
              ko(this.query, e.query) &&
              this.docs.isEqual(e.docs) &&
              this.oldDocs.isEqual(e.oldDocs)
            )
          )
            return !1;
          const t = this.docChanges,
            n = e.docChanges;
          if (t.length !== n.length) return !1;
          for (let e = 0; e < t.length; e++) if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
          return !0;
        }
      }
      class yu {
        constructor() {
          (this.H_ = void 0), (this.J_ = []);
        }
        Y_() {
          return this.J_.some((e) => e.Z_());
        }
      }
      class vu {
        constructor() {
          (this.queries = wu()), (this.onlineState = "Unknown"), (this.X_ = new Set());
        }
        terminate() {
          !(function (e, t) {
            const n = fs(e),
              r = n.queries;
            (n.queries = wu()),
              r.forEach((e, n) => {
                for (const e of n.J_) e.onError(t);
              });
          })(this, new gs(ms.ABORTED, "Firestore shutting down"));
        }
      }
      function wu() {
        return new qo((e) => Lo(e), ko);
      }
      async function bu(e, t) {
        const n = fs(e);
        let r = 3;
        const s = t.query;
        let i = n.queries.get(s);
        i ? !i.Y_() && t.Z_() && (r = 2) : ((i = new yu()), (r = t.Z_() ? 0 : 1));
        try {
          switch (r) {
            case 0:
              i.H_ = await n.onListen(s, !0);
              break;
            case 1:
              i.H_ = await n.onListen(s, !1);
              break;
            case 2:
              await n.onFirstRemoteStoreListen(s);
          }
        } catch (e) {
          const n = pu(e, `Initialization of query '${Mo(t.query)}' failed`);
          return void t.onError(n);
        }
        n.queries.set(s, i), i.J_.push(t), t.ea(n.onlineState), i.H_ && t.ta(i.H_) && _u(n);
      }
      async function Su(e, t) {
        const n = fs(e),
          r = t.query;
        let s = 3;
        const i = n.queries.get(r);
        if (i) {
          const e = i.J_.indexOf(t);
          e >= 0 && (i.J_.splice(e, 1), 0 === i.J_.length ? (s = t.Z_() ? 0 : 1) : !i.Y_() && t.Z_() && (s = 2));
        }
        switch (s) {
          case 0:
            return n.queries.delete(r), n.onUnlisten(r, !0);
          case 1:
            return n.queries.delete(r), n.onUnlisten(r, !1);
          case 2:
            return n.onLastRemoteStoreUnlisten(r);
          default:
            return;
        }
      }
      function Eu(e, t) {
        const n = fs(e);
        let r = !1;
        for (const e of t) {
          const t = e.query,
            s = n.queries.get(t);
          if (s) {
            for (const t of s.J_) t.ta(e) && (r = !0);
            s.H_ = e;
          }
        }
        r && _u(n);
      }
      function Tu(e, t, n) {
        const r = fs(e),
          s = r.queries.get(t);
        if (s) for (const e of s.J_) e.onError(n);
        r.queries.delete(t);
      }
      function _u(e) {
        e.X_.forEach((e) => {
          e.next();
        });
      }
      var Cu, xu;
      ((xu = Cu || (Cu = {})).na = "default"), (xu.Cache = "cache");
      class Au {
        constructor(e, t, n) {
          (this.query = e), (this.ra = t), (this.ia = !1), (this.sa = null), (this.onlineState = "Unknown"), (this.options = n || {});
        }
        ta(e) {
          if (!this.options.includeMetadataChanges) {
            const t = [];
            for (const n of e.docChanges) 3 !== n.type && t.push(n);
            e = new gu(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, !0, e.hasCachedResults);
          }
          let t = !1;
          return (
            this.ia ? this.oa(e) && (this.ra.next(e), (t = !0)) : this._a(e, this.onlineState) && (this.aa(e), (t = !0)), (this.sa = e), t
          );
        }
        onError(e) {
          this.ra.error(e);
        }
        ea(e) {
          this.onlineState = e;
          let t = !1;
          return this.sa && !this.ia && this._a(this.sa, e) && (this.aa(this.sa), (t = !0)), t;
        }
        _a(e, t) {
          if (!e.fromCache) return !0;
          if (!this.Z_()) return !0;
          const n = "Offline" !== t;
          return (!this.options.ua || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" === t);
        }
        oa(e) {
          if (e.docChanges.length > 0) return !0;
          const t = this.sa && this.sa.hasPendingWrites !== e.hasPendingWrites;
          return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
        }
        aa(e) {
          (e = gu.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults)), (this.ia = !0), this.ra.next(e);
        }
        Z_() {
          return this.options.source !== Cu.Cache;
        }
      }
      class Iu {
        constructor(e) {
          this.key = e;
        }
      }
      class ku {
        constructor(e) {
          this.key = e;
        }
      }
      class Lu {
        constructor(e, t) {
          (this.query = e),
            (this.Ea = t),
            (this.Aa = null),
            (this.hasCachedResults = !1),
            (this.current = !1),
            (this.Ra = Wo()),
            (this.mutatedKeys = Wo()),
            (this.Va = Po(e)),
            (this.ma = new fu(this.Va));
        }
        get fa() {
          return this.Ea;
        }
        ga(e, t) {
          const n = t ? t.pa : new mu(),
            r = t ? t.ma : this.ma;
          let s = t ? t.mutatedKeys : this.mutatedKeys,
            i = r,
            o = !1;
          const a = "F" === this.query.limitType && r.size === this.query.limit ? r.last() : null,
            l = "L" === this.query.limitType && r.size === this.query.limit ? r.first() : null;
          if (
            (e.inorderTraversal((e, t) => {
              const c = r.get(e),
                u = Do(this.query, t) ? t : null,
                d = !!c && this.mutatedKeys.has(c.key),
                h = !!u && (u.hasLocalMutations || (this.mutatedKeys.has(u.key) && u.hasCommittedMutations));
              let p = !1;
              c && u
                ? c.data.isEqual(u.data)
                  ? d !== h && (n.track({ type: 3, doc: u }), (p = !0))
                  : this.ya(c, u) ||
                    (n.track({ type: 2, doc: u }), (p = !0), ((a && this.Va(u, a) > 0) || (l && this.Va(u, l) < 0)) && (o = !0))
                : !c && u
                ? (n.track({ type: 0, doc: u }), (p = !0))
                : c && !u && (n.track({ type: 1, doc: c }), (p = !0), (a || l) && (o = !0)),
                p && (u ? ((i = i.add(u)), (s = h ? s.add(e) : s.delete(e))) : ((i = i.delete(e)), (s = s.delete(e))));
            }),
            null !== this.query.limit)
          )
            for (; i.size > this.query.limit; ) {
              const e = "F" === this.query.limitType ? i.last() : i.first();
              (i = i.delete(e.key)), (s = s.delete(e.key)), n.track({ type: 1, doc: e });
            }
          return { ma: i, pa: n, ss: o, mutatedKeys: s };
        }
        ya(e, t) {
          return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
        }
        applyChanges(e, t, n, r) {
          const s = this.ma;
          (this.ma = e.ma), (this.mutatedKeys = e.mutatedKeys);
          const i = e.pa.j_();
          i.sort(
            (e, t) =>
              (function (e, t) {
                const n = (e) => {
                  switch (e) {
                    case 0:
                      return 1;
                    case 2:
                    case 3:
                      return 2;
                    case 1:
                      return 0;
                    default:
                      return hs();
                  }
                };
                return n(e) - n(t);
              })(e.type, t.type) || this.Va(e.doc, t.doc)
          ),
            this.wa(n),
            (r = null != r && r);
          const o = t && !r ? this.Sa() : [],
            a = 0 === this.Ra.size && this.current && !r ? 1 : 0,
            l = a !== this.Aa;
          return (
            (this.Aa = a),
            0 !== i.length || l
              ? {
                  snapshot: new gu(this.query, e.ma, s, i, e.mutatedKeys, 0 === a, l, !1, !!n && n.resumeToken.approximateByteSize() > 0),
                  ba: o,
                }
              : { ba: o }
          );
        }
        ea(e) {
          return this.current && "Offline" === e
            ? ((this.current = !1), this.applyChanges({ ma: this.ma, pa: new mu(), mutatedKeys: this.mutatedKeys, ss: !1 }, !1))
            : { ba: [] };
        }
        Da(e) {
          return !this.Ea.has(e) && !!this.ma.has(e) && !this.ma.get(e).hasLocalMutations;
        }
        wa(e) {
          e &&
            (e.addedDocuments.forEach((e) => (this.Ea = this.Ea.add(e))),
            e.modifiedDocuments.forEach((e) => {}),
            e.removedDocuments.forEach((e) => (this.Ea = this.Ea.delete(e))),
            (this.current = e.current));
        }
        Sa() {
          if (!this.current) return [];
          const e = this.Ra;
          (this.Ra = Wo()),
            this.ma.forEach((e) => {
              this.Da(e.key) && (this.Ra = this.Ra.add(e.key));
            });
          const t = [];
          return (
            e.forEach((e) => {
              this.Ra.has(e) || t.push(new ku(e));
            }),
            this.Ra.forEach((n) => {
              e.has(n) || t.push(new Iu(n));
            }),
            t
          );
        }
        va(e) {
          (this.Ea = e.Es), (this.Ra = Wo());
          const t = this.ga(e.documents);
          return this.applyChanges(t, !0);
        }
        Ca() {
          return gu.fromInitialDocuments(this.query, this.ma, this.mutatedKeys, 0 === this.Aa, this.hasCachedResults);
        }
      }
      class Mu {
        constructor(e, t, n) {
          (this.query = e), (this.targetId = t), (this.view = n);
        }
      }
      class Du {
        constructor(e) {
          (this.key = e), (this.Fa = !1);
        }
      }
      class Nu {
        constructor(e, t, n, r, s, i) {
          (this.localStore = e),
            (this.remoteStore = t),
            (this.eventManager = n),
            (this.sharedClientState = r),
            (this.currentUser = s),
            (this.maxConcurrentLimboResolutions = i),
            (this.Ma = {}),
            (this.xa = new qo((e) => Lo(e), ko)),
            (this.Oa = new Map()),
            (this.Na = new Set()),
            (this.Ba = new li(qs.comparator)),
            (this.La = new Map()),
            (this.ka = new Ql()),
            (this.qa = {}),
            (this.Qa = new Map()),
            (this.Ka = Rl.Qn()),
            (this.onlineState = "Unknown"),
            (this.$a = void 0);
        }
        get isPrimaryClient() {
          return !0 === this.$a;
        }
      }
      async function Pu(e, t, n = !0) {
        const r = td(e);
        let s;
        const i = r.xa.get(t);
        return i ? (r.sharedClientState.addLocalQueryTarget(i.targetId), (s = i.view.Ca())) : (s = await qu(r, t, n, !0)), s;
      }
      async function Ou(e, t) {
        const n = td(e);
        await qu(n, t, !0, !1);
      }
      async function qu(e, t, n, r) {
        const s = await fc(e.localStore, xo(t)),
          i = s.targetId,
          o = e.sharedClientState.addLocalQueryTarget(i, n);
        let a;
        return r && (a = await Ru(e, t, i, "current" === o, s.resumeToken)), e.isPrimaryClient && n && Bc(e.remoteStore, s), a;
      }
      async function Ru(e, t, n, r, s) {
        e.Ua = (t, n, r) =>
          (async function (e, t, n, r) {
            let s = t.view.ga(n);
            s.ss && (s = await gc(e.localStore, t.query, !1).then(({ documents: e }) => t.view.ga(e, s)));
            const i = r && r.targetChanges.get(t.targetId),
              o = r && null != r.targetMismatches.get(t.targetId),
              a = t.view.applyChanges(s, e.isPrimaryClient, i, o);
            return Qu(e, t.targetId, a.ba), a.snapshot;
          })(e, t, n, r);
        const i = await gc(e.localStore, t, !0),
          o = new Lu(t, i.Es),
          a = o.ga(i.documents),
          l = za.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" !== e.onlineState, s),
          c = o.applyChanges(a, e.isPrimaryClient, l);
        Qu(e, n, c.ba);
        const u = new Mu(t, n, o);
        return e.xa.set(t, u), e.Oa.has(n) ? e.Oa.get(n).push(t) : e.Oa.set(n, [t]), c.snapshot;
      }
      async function Fu(e, t, n) {
        const r = fs(e),
          s = r.xa.get(t),
          i = r.Oa.get(s.targetId);
        if (i.length > 1)
          return (
            r.Oa.set(
              s.targetId,
              i.filter((e) => !ko(e, t))
            ),
            void r.xa.delete(t)
          );
        r.isPrimaryClient
          ? (r.sharedClientState.removeLocalQueryTarget(s.targetId),
            r.sharedClientState.isActiveQueryTarget(s.targetId) ||
              (await mc(r.localStore, s.targetId, !1)
                .then(() => {
                  r.sharedClientState.clearQueryState(s.targetId), n && $c(r.remoteStore, s.targetId), Wu(r, s.targetId);
                })
                .catch(Us)))
          : (Wu(r, s.targetId), await mc(r.localStore, s.targetId, !0));
      }
      async function Bu(e, t) {
        const n = fs(e),
          r = n.xa.get(t),
          s = n.Oa.get(r.targetId);
        n.isPrimaryClient && 1 === s.length && (n.sharedClientState.removeLocalQueryTarget(r.targetId), $c(n.remoteStore, r.targetId));
      }
      async function $u(e, t) {
        const n = fs(e);
        try {
          const e = await (function (e, t) {
            const n = fs(e),
              r = t.snapshotVersion;
            let s = n.us;
            return n.persistence
              .runTransaction("Apply remote event", "readwrite-primary", (e) => {
                const i = n.hs.newChangeBuffer({ trackRemovals: !0 });
                s = n.us;
                const o = [];
                t.targetChanges.forEach((i, a) => {
                  const l = s.get(a);
                  if (!l) return;
                  o.push(n.Gr.removeMatchingKeys(e, i.removedDocuments, a).next(() => n.Gr.addMatchingKeys(e, i.addedDocuments, a)));
                  let c = l.withSequenceNumber(e.currentSequenceNumber);
                  null !== t.targetMismatches.get(a)
                    ? (c = c.withResumeToken(mi.EMPTY_BYTE_STRING, Ms.min()).withLastLimboFreeSnapshotVersion(Ms.min()))
                    : i.resumeToken.approximateByteSize() > 0 && (c = c.withResumeToken(i.resumeToken, r)),
                    (s = s.insert(a, c)),
                    (function (e, t, n) {
                      return (
                        0 === e.resumeToken.approximateByteSize() ||
                        t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8 ||
                        n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0
                      );
                    })(l, c, i) && o.push(n.Gr.updateTargetData(e, c));
                });
                let a = Fo(),
                  l = Wo();
                if (
                  (t.documentUpdates.forEach((r) => {
                    t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
                  }),
                  o.push(
                    hc(e, i, t.documentUpdates).next((e) => {
                      (a = e.Is), (l = e.ds);
                    })
                  ),
                  !r.isEqual(Ms.min()))
                ) {
                  const t = n.Gr.getLastRemoteSnapshotVersion(e).next((t) => n.Gr.setTargetsMetadata(e, e.currentSequenceNumber, r));
                  o.push(t);
                }
                return Gs.waitFor(o)
                  .next(() => i.apply(e))
                  .next(() => n.localDocuments.getLocalViewOfDocuments(e, a, l))
                  .next(() => a);
              })
              .then((e) => ((n.us = s), e));
          })(n.localStore, t);
          t.targetChanges.forEach((e, t) => {
            const r = n.La.get(t);
            r &&
              (ps(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1),
              e.addedDocuments.size > 0
                ? (r.Fa = !0)
                : e.modifiedDocuments.size > 0
                ? ps(r.Fa)
                : e.removedDocuments.size > 0 && (ps(r.Fa), (r.Fa = !1)));
          }),
            await Ju(n, e, t);
        } catch (e) {
          await Us(e);
        }
      }
      function Vu(e, t, n) {
        const r = fs(e);
        if ((r.isPrimaryClient && 0 === n) || (!r.isPrimaryClient && 1 === n)) {
          const e = [];
          r.xa.forEach((n, r) => {
            const s = r.view.ea(t);
            s.snapshot && e.push(s.snapshot);
          }),
            (function (e, t) {
              const n = fs(e);
              n.onlineState = t;
              let r = !1;
              n.queries.forEach((e, n) => {
                for (const e of n.J_) e.ea(t) && (r = !0);
              }),
                r && _u(n);
            })(r.eventManager, t),
            e.length && r.Ma.R_(e),
            (r.onlineState = t),
            r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
        }
      }
      async function ju(e, t, n) {
        const r = fs(e);
        r.sharedClientState.updateQueryState(t, "rejected", n);
        const s = r.La.get(t),
          i = s && s.key;
        if (i) {
          let e = new li(qs.comparator);
          e = e.insert(i, Gi.newNoDocument(i, Ms.min()));
          const n = Wo().add(i),
            s = new ja(Ms.min(), new Map(), new li(Is), e, n);
          await $u(r, s), (r.Ba = r.Ba.remove(i)), r.La.delete(t), Xu(r);
        } else
          await mc(r.localStore, t, !1)
            .then(() => Wu(r, t, n))
            .catch(Us);
      }
      async function zu(e, t) {
        const n = fs(e),
          r = t.batch.batchId;
        try {
          const e = await (function (e, t) {
            const n = fs(e);
            return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e) => {
              const r = t.batch.keys(),
                s = n.hs.newChangeBuffer({ trackRemovals: !0 });
              return (function (e, t, n, r) {
                const s = n.batch,
                  i = s.keys();
                let o = Gs.resolve();
                return (
                  i.forEach((e) => {
                    o = o
                      .next(() => r.getEntry(t, e))
                      .next((t) => {
                        const i = n.docVersions.get(e);
                        ps(null !== i),
                          t.version.compareTo(i) < 0 &&
                            (s.applyToRemoteDocument(t, n), t.isValidDocument() && (t.setReadTime(n.commitVersion), r.addEntry(t)));
                      });
                  }),
                  o.next(() => e.mutationQueue.removeMutationBatch(t, s))
                );
              })(n, e, t, s)
                .next(() => s.apply(e))
                .next(() => n.mutationQueue.performConsistencyCheck(e))
                .next(() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId))
                .next(() =>
                  n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(
                    e,
                    (function (e) {
                      let t = Wo();
                      for (let n = 0; n < e.mutationResults.length; ++n)
                        e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                      return t;
                    })(t)
                  )
                )
                .next(() => n.localDocuments.getDocuments(e, r));
            });
          })(n.localStore, t);
          Hu(n, r, null), Gu(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await Ju(n, e);
        } catch (e) {
          await Us(e);
        }
      }
      async function Uu(e, t, n) {
        const r = fs(e);
        try {
          const e = await (function (e, t) {
            const n = fs(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e) => {
              let r;
              return n.mutationQueue
                .lookupMutationBatch(e, t)
                .next((t) => (ps(null !== t), (r = t.keys()), n.mutationQueue.removeMutationBatch(e, t)))
                .next(() => n.mutationQueue.performConsistencyCheck(e))
                .next(() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t))
                .next(() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r))
                .next(() => n.localDocuments.getDocuments(e, r));
            });
          })(r.localStore, t);
          Hu(r, t, n), Gu(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await Ju(r, e);
        } catch (n) {
          await Us(n);
        }
      }
      function Gu(e, t) {
        (e.Qa.get(t) || []).forEach((e) => {
          e.resolve();
        }),
          e.Qa.delete(t);
      }
      function Hu(e, t, n) {
        const r = fs(e);
        let s = r.qa[r.currentUser.toKey()];
        if (s) {
          const e = s.get(t);
          e && (n ? e.reject(n) : e.resolve(), (s = s.remove(t))), (r.qa[r.currentUser.toKey()] = s);
        }
      }
      function Wu(e, t, n = null) {
        e.sharedClientState.removeLocalQueryTarget(t);
        for (const r of e.Oa.get(t)) e.xa.delete(r), n && e.Ma.Wa(r, n);
        e.Oa.delete(t),
          e.isPrimaryClient &&
            e.ka.yr(t).forEach((t) => {
              e.ka.containsKey(t) || Ku(e, t);
            });
      }
      function Ku(e, t) {
        e.Na.delete(t.path.canonicalString());
        const n = e.Ba.get(t);
        null !== n && ($c(e.remoteStore, n), (e.Ba = e.Ba.remove(t)), e.La.delete(n), Xu(e));
      }
      function Qu(e, t, n) {
        for (const r of n)
          r instanceof Iu
            ? (e.ka.addReference(r.key, t), Yu(e, r))
            : r instanceof ku
            ? (ls("SyncEngine", "Document no longer in limbo: " + r.key),
              e.ka.removeReference(r.key, t),
              e.ka.containsKey(r.key) || Ku(e, r.key))
            : hs();
      }
      function Yu(e, t) {
        const n = t.key,
          r = n.path.canonicalString();
        e.Ba.get(n) || e.Na.has(r) || (ls("SyncEngine", "New document in limbo: " + n), e.Na.add(r), Xu(e));
      }
      function Xu(e) {
        for (; e.Na.size > 0 && e.Ba.size < e.maxConcurrentLimboResolutions; ) {
          const t = e.Na.values().next().value;
          e.Na.delete(t);
          const n = new qs(Ns.fromString(t)),
            r = e.Ka.next();
          e.La.set(r, new Du(n)),
            (e.Ba = e.Ba.insert(n, r)),
            Bc(e.remoteStore, new kl(xo(Eo(n.path)), r, "TargetPurposeLimboResolution", Ks.oe));
        }
      }
      async function Ju(e, t, n) {
        const r = fs(e),
          s = [],
          i = [],
          o = [];
        r.xa.isEmpty() ||
          (r.xa.forEach((e, a) => {
            o.push(
              r.Ua(a, t, n).then((e) => {
                var t;
                if ((e || n) && r.isPrimaryClient) {
                  const s = e
                    ? !e.fromCache
                    : null === (t = null == n ? void 0 : n.targetChanges.get(a.targetId)) || void 0 === t
                    ? void 0
                    : t.current;
                  r.sharedClientState.updateQueryState(a.targetId, s ? "current" : "not-current");
                }
                if (e) {
                  s.push(e);
                  const t = ic.zi(a.targetId, e);
                  i.push(t);
                }
              })
            );
          }),
          await Promise.all(o),
          r.Ma.R_(s),
          await (async function (e, t) {
            const n = fs(e);
            try {
              await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e) =>
                Gs.forEach(t, (t) =>
                  Gs.forEach(t.Wi, (r) => n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(() =>
                    Gs.forEach(t.Gi, (r) => n.persistence.referenceDelegate.removeReference(e, t.targetId, r))
                  )
                )
              );
            } catch (e) {
              if (!Ws(e)) throw e;
              ls("LocalStore", "Failed to update sequence numbers: " + e);
            }
            for (const e of t) {
              const t = e.targetId;
              if (!e.fromCache) {
                const e = n.us.get(t),
                  r = e.snapshotVersion,
                  s = e.withLastLimboFreeSnapshotVersion(r);
                n.us = n.us.insert(t, s);
              }
            }
          })(r.localStore, i));
      }
      async function Zu(e, t) {
        const n = fs(e);
        if (!n.currentUser.isEqual(t)) {
          ls("SyncEngine", "User change. New user:", t.toKey());
          const e = await uc(n.localStore, t);
          (n.currentUser = t),
            (function (e, t) {
              e.Qa.forEach((e) => {
                e.forEach((e) => {
                  e.reject(new gs(ms.CANCELLED, t));
                });
              }),
                e.Qa.clear();
            })(n, "'waitForPendingWrites' promise is rejected due to a user change."),
            n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds),
            await Ju(n, e.Ts);
        }
      }
      function ed(e, t) {
        const n = fs(e),
          r = n.La.get(t);
        if (r && r.Fa) return Wo().add(r.key);
        {
          let e = Wo();
          const r = n.Oa.get(t);
          if (!r) return e;
          for (const t of r) {
            const r = n.xa.get(t);
            e = e.unionWith(r.view.fa);
          }
          return e;
        }
      }
      function td(e) {
        const t = fs(e);
        return (
          (t.remoteStore.remoteSyncer.applyRemoteEvent = $u.bind(null, t)),
          (t.remoteStore.remoteSyncer.getRemoteKeysForTarget = ed.bind(null, t)),
          (t.remoteStore.remoteSyncer.rejectListen = ju.bind(null, t)),
          (t.Ma.R_ = Eu.bind(null, t.eventManager)),
          (t.Ma.Wa = Tu.bind(null, t.eventManager)),
          t
        );
      }
      function nd(e) {
        const t = fs(e);
        return (
          (t.remoteStore.remoteSyncer.applySuccessfulWrite = zu.bind(null, t)),
          (t.remoteStore.remoteSyncer.rejectFailedWrite = Uu.bind(null, t)),
          t
        );
      }
      class rd {
        constructor() {
          (this.kind = "memory"), (this.synchronizeTabs = !1);
        }
        async initialize(e) {
          (this.serializer = kc(e.databaseInfo.databaseId)),
            (this.sharedClientState = this.za(e)),
            (this.persistence = this.ja(e)),
            await this.persistence.start(),
            (this.localStore = this.Ha(e)),
            (this.gcScheduler = this.Ja(e, this.localStore)),
            (this.indexBackfillerScheduler = this.Ya(e, this.localStore));
        }
        Ja(e, t) {
          return null;
        }
        Ya(e, t) {
          return null;
        }
        Ha(e) {
          return cc(this.persistence, new ac(), e.initialUser, this.serializer);
        }
        ja(e) {
          return new tc(rc.ei, this.serializer);
        }
        za(e) {
          return new wc();
        }
        async terminate() {
          var e, t;
          null === (e = this.gcScheduler) || void 0 === e || e.stop(),
            null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(),
            this.sharedClientState.shutdown(),
            await this.persistence.shutdown();
        }
      }
      rd.provider = { build: () => new rd() };
      class sd extends rd {
        constructor(e) {
          super(), (this.cacheSizeBytes = e);
        }
        Ja(e, t) {
          ps(this.persistence.referenceDelegate instanceof sc);
          const n = this.persistence.referenceDelegate.garbageCollector;
          return new $l(n, e.asyncQueue, t);
        }
        ja(e) {
          const t = void 0 !== this.cacheSizeBytes ? ql.withCacheSize(this.cacheSizeBytes) : ql.DEFAULT;
          return new tc((e) => sc.ei(e, t), this.serializer);
        }
      }
      class id {
        async initialize(e, t) {
          this.localStore ||
            ((this.localStore = e.localStore),
            (this.sharedClientState = e.sharedClientState),
            (this.datastore = this.createDatastore(t)),
            (this.remoteStore = this.createRemoteStore(t)),
            (this.eventManager = this.createEventManager(t)),
            (this.syncEngine = this.createSyncEngine(t, !e.synchronizeTabs)),
            (this.sharedClientState.onlineStateHandler = (e) => Vu(this.syncEngine, e, 1)),
            (this.remoteStore.remoteSyncer.handleCredentialChange = Zu.bind(null, this.syncEngine)),
            await cu(this.remoteStore, this.syncEngine.isPrimaryClient));
        }
        createEventManager(e) {
          return new vu();
        }
        createDatastore(e) {
          const t = kc(e.databaseInfo.databaseId),
            n = (function (e) {
              return new Ac(e);
            })(e.databaseInfo);
          return (function (e, t, n, r) {
            return new Pc(e, t, n, r);
          })(e.authCredentials, e.appCheckCredentials, n, t);
        }
        createRemoteStore(e) {
          return (function (e, t, n, r, s) {
            return new qc(e, t, n, r, s);
          })(this.localStore, this.datastore, e.asyncQueue, (e) => Vu(this.syncEngine, e, 0), Sc.p() ? new Sc() : new bc());
        }
        createSyncEngine(e, t) {
          return (function (e, t, n, r, s, i, o) {
            const a = new Nu(e, t, n, r, s, i);
            return o && (a.$a = !0), a;
          })(
            this.localStore,
            this.remoteStore,
            this.eventManager,
            this.sharedClientState,
            e.initialUser,
            e.maxConcurrentLimboResolutions,
            t
          );
        }
        async terminate() {
          var e, t;
          await (async function (e) {
            const t = fs(e);
            ls("RemoteStore", "RemoteStore shutting down."), t.k_.add(5), await Fc(t), t.Q_.shutdown(), t.K_.set("Unknown");
          })(this.remoteStore),
            null === (e = this.datastore) || void 0 === e || e.terminate(),
            null === (t = this.eventManager) || void 0 === t || t.terminate();
        }
      }
      id.provider = { build: () => new id() };
      class od {
        constructor(e) {
          (this.observer = e), (this.muted = !1);
        }
        next(e) {
          this.muted || (this.observer.next && this.Xa(this.observer.next, e));
        }
        error(e) {
          this.muted || (this.observer.error ? this.Xa(this.observer.error, e) : cs("Uncaught Error in snapshot listener:", e.toString()));
        }
        eu() {
          this.muted = !0;
        }
        Xa(e, t) {
          setTimeout(() => {
            this.muted || e(t);
          }, 0);
        }
      }
      class ad {
        constructor(e, t, n, r, s) {
          (this.authCredentials = e),
            (this.appCheckCredentials = t),
            (this.asyncQueue = n),
            (this.databaseInfo = r),
            (this.user = ss.UNAUTHENTICATED),
            (this.clientId = As.newId()),
            (this.authCredentialListener = () => Promise.resolve()),
            (this.appCheckCredentialListener = () => Promise.resolve()),
            (this._uninitializedComponentsProvider = s),
            this.authCredentials.start(n, async (e) => {
              ls("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), (this.user = e);
            }),
            this.appCheckCredentials.start(
              n,
              (e) => (ls("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user))
            );
        }
        get configuration() {
          return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100,
          };
        }
        setCredentialChangeListener(e) {
          this.authCredentialListener = e;
        }
        setAppCheckTokenChangeListener(e) {
          this.appCheckCredentialListener = e;
        }
        terminate() {
          this.asyncQueue.enterRestrictedMode();
          const e = new ys();
          return (
            this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async () => {
              try {
                this._onlineComponents && (await this._onlineComponents.terminate()),
                  this._offlineComponents && (await this._offlineComponents.terminate()),
                  this.authCredentials.shutdown(),
                  this.appCheckCredentials.shutdown(),
                  e.resolve();
              } catch (t) {
                const n = pu(t, "Failed to shutdown persistence");
                e.reject(n);
              }
            }),
            e.promise
          );
        }
      }
      async function ld(e, t) {
        e.asyncQueue.verifyOperationInProgress(), ls("FirestoreClient", "Initializing OfflineComponentProvider");
        const n = e.configuration;
        await t.initialize(n);
        let r = n.initialUser;
        e.setCredentialChangeListener(async (e) => {
          r.isEqual(e) || (await uc(t.localStore, e), (r = e));
        }),
          t.persistence.setDatabaseDeletedListener(() => e.terminate()),
          (e._offlineComponents = t);
      }
      async function cd(e, t) {
        e.asyncQueue.verifyOperationInProgress();
        const n = await ud(e);
        ls("FirestoreClient", "Initializing OnlineComponentProvider"),
          await t.initialize(n, e.configuration),
          e.setCredentialChangeListener((e) => lu(t.remoteStore, e)),
          e.setAppCheckTokenChangeListener((e, n) => lu(t.remoteStore, n)),
          (e._onlineComponents = t);
      }
      async function ud(e) {
        if (!e._offlineComponents)
          if (e._uninitializedComponentsProvider) {
            ls("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
              await ld(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
              const n = t;
              if (
                !(function (e) {
                  return "FirebaseError" === e.name
                    ? e.code === ms.FAILED_PRECONDITION || e.code === ms.UNIMPLEMENTED
                    : !("undefined" != typeof DOMException && e instanceof DOMException) || 22 === e.code || 20 === e.code || 11 === e.code;
                })(n)
              )
                throw n;
              us("Error using user provided cache. Falling back to memory cache: " + n), await ld(e, new rd());
            }
          } else ls("FirestoreClient", "Using default OfflineComponentProvider"), await ld(e, new sd(void 0));
        return e._offlineComponents;
      }
      async function dd(e) {
        return (
          e._onlineComponents ||
            (e._uninitializedComponentsProvider
              ? (ls("FirestoreClient", "Using user provided OnlineComponentProvider"),
                await cd(e, e._uninitializedComponentsProvider._online))
              : (ls("FirestoreClient", "Using default OnlineComponentProvider"), await cd(e, new id()))),
          e._onlineComponents
        );
      }
      function hd(e) {
        return dd(e).then((e) => e.syncEngine);
      }
      async function pd(e) {
        const t = await dd(e),
          n = t.eventManager;
        return (
          (n.onListen = Pu.bind(null, t.syncEngine)),
          (n.onUnlisten = Fu.bind(null, t.syncEngine)),
          (n.onFirstRemoteStoreListen = Ou.bind(null, t.syncEngine)),
          (n.onLastRemoteStoreUnlisten = Bu.bind(null, t.syncEngine)),
          n
        );
      }
      function fd(e, t, n = {}) {
        const r = new ys();
        return (
          e.asyncQueue.enqueueAndForget(async () =>
            (function (e, t, n, r, s) {
              const i = new od({
                  next: (a) => {
                    i.eu(), t.enqueueAndForget(() => Su(e, o));
                    const l = a.docs.has(n);
                    !l && a.fromCache
                      ? s.reject(new gs(ms.UNAVAILABLE, "Failed to get document because the client is offline."))
                      : l && a.fromCache && r && "server" === r.source
                      ? s.reject(
                          new gs(
                            ms.UNAVAILABLE,
                            'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)'
                          )
                        )
                      : s.resolve(a);
                  },
                  error: (e) => s.reject(e),
                }),
                o = new Au(Eo(n.path), i, { includeMetadataChanges: !0, ua: !0 });
              return bu(e, o);
            })(await pd(e), e.asyncQueue, t, n, r)
          ),
          r.promise
        );
      }
      function md(e, t, n = {}) {
        const r = new ys();
        return (
          e.asyncQueue.enqueueAndForget(async () =>
            (function (e, t, n, r, s) {
              const i = new od({
                  next: (n) => {
                    i.eu(),
                      t.enqueueAndForget(() => Su(e, o)),
                      n.fromCache && "server" === r.source
                        ? s.reject(
                            new gs(
                              ms.UNAVAILABLE,
                              'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)'
                            )
                          )
                        : s.resolve(n);
                  },
                  error: (e) => s.reject(e),
                }),
                o = new Au(n, i, { includeMetadataChanges: !0, ua: !0 });
              return bu(e, o);
            })(await pd(e), e.asyncQueue, t, n, r)
          ),
          r.promise
        );
      }
      function gd(e) {
        const t = {};
        return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
      }
      const yd = new Map();
      function vd(e, t, n) {
        if (!n) throw new gs(ms.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
      }
      function wd(e) {
        if (!qs.isDocumentKey(e))
          throw new gs(
            ms.INVALID_ARGUMENT,
            `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`
          );
      }
      function bd(e) {
        if (qs.isDocumentKey(e))
          throw new gs(
            ms.INVALID_ARGUMENT,
            `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`
          );
      }
      function Sd(e) {
        if (void 0 === e) return "undefined";
        if (null === e) return "null";
        if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
        if ("number" == typeof e || "boolean" == typeof e) return "" + e;
        if ("object" == typeof e) {
          if (e instanceof Array) return "an array";
          {
            const t = (function (e) {
              return e.constructor ? e.constructor.name : null;
            })(e);
            return t ? `a custom ${t} object` : "an object";
          }
        }
        return "function" == typeof e ? "a function" : hs();
      }
      function Ed(e, t) {
        if (("_delegate" in e && (e = e._delegate), !(e instanceof t))) {
          if (t.name === e.constructor.name)
            throw new gs(
              ms.INVALID_ARGUMENT,
              "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?"
            );
          {
            const n = Sd(e);
            throw new gs(ms.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
          }
        }
        return e;
      }
      class Td {
        constructor(e) {
          var t, n;
          if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new gs(ms.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            (this.host = "firestore.googleapis.com"), (this.ssl = !0);
          } else (this.host = e.host), (this.ssl = null === (t = e.ssl) || void 0 === t || t);
          if (
            ((this.credentials = e.credentials),
            (this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties),
            (this.localCache = e.localCache),
            void 0 === e.cacheSizeBytes)
          )
            this.cacheSizeBytes = 41943040;
          else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576)
              throw new gs(ms.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
          }
          (function (e, t, n, r) {
            if (!0 === t && !0 === r) throw new gs(ms.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
          })(
            "experimentalForceLongPolling",
            e.experimentalForceLongPolling,
            "experimentalAutoDetectLongPolling",
            e.experimentalAutoDetectLongPolling
          ),
            (this.experimentalForceLongPolling = !!e.experimentalForceLongPolling),
            this.experimentalForceLongPolling
              ? (this.experimentalAutoDetectLongPolling = !1)
              : void 0 === e.experimentalAutoDetectLongPolling
              ? (this.experimentalAutoDetectLongPolling = !0)
              : (this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling),
            (this.experimentalLongPollingOptions = gd(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {})),
            (function (e) {
              if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds))
                  throw new gs(ms.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5)
                  throw new gs(ms.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30)
                  throw new gs(ms.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
              }
            })(this.experimentalLongPollingOptions),
            (this.useFetchStreams = !!e.useFetchStreams);
        }
        isEqual(e) {
          return (
            this.host === e.host &&
            this.ssl === e.ssl &&
            this.credentials === e.credentials &&
            this.cacheSizeBytes === e.cacheSizeBytes &&
            this.experimentalForceLongPolling === e.experimentalForceLongPolling &&
            this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling &&
            (function (e, t) {
              return e.timeoutSeconds === t.timeoutSeconds;
            })(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) &&
            this.ignoreUndefinedProperties === e.ignoreUndefinedProperties &&
            this.useFetchStreams === e.useFetchStreams
          );
        }
      }
      class _d {
        constructor(e, t, n, r) {
          (this._authCredentials = e),
            (this._appCheckCredentials = t),
            (this._databaseId = n),
            (this._app = r),
            (this.type = "firestore-lite"),
            (this._persistenceKey = "(lite)"),
            (this._settings = new Td({})),
            (this._settingsFrozen = !1),
            (this._terminateTask = "notTerminated");
        }
        get app() {
          if (!this._app)
            throw new gs(ms.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
          return this._app;
        }
        get _initialized() {
          return this._settingsFrozen;
        }
        get _terminated() {
          return "notTerminated" !== this._terminateTask;
        }
        _setSettings(e) {
          if (this._settingsFrozen)
            throw new gs(
              ms.FAILED_PRECONDITION,
              "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object."
            );
          (this._settings = new Td(e)),
            void 0 !== e.credentials &&
              (this._authCredentials = (function (e) {
                if (!e) return new ws();
                switch (e.type) {
                  case "firstParty":
                    return new Ts(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                  case "provider":
                    return e.client;
                  default:
                    throw new gs(ms.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
                }
              })(e.credentials));
        }
        _getSettings() {
          return this._settings;
        }
        _freezeSettings() {
          return (this._settingsFrozen = !0), this._settings;
        }
        _delete() {
          return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
        }
        async _restart() {
          "notTerminated" === this._terminateTask ? await this._terminate() : (this._terminateTask = "notTerminated");
        }
        toJSON() {
          return { app: this._app, databaseId: this._databaseId, settings: this._settings };
        }
        _terminate() {
          return (
            (function (e) {
              const t = yd.get(e);
              t && (ls("ComponentProvider", "Removing Datastore"), yd.delete(e), t.terminate());
            })(this),
            Promise.resolve()
          );
        }
      }
      function Cd(e, t, n, r = {}) {
        var s;
        const i = (e = Ed(e, _d))._getSettings(),
          o = `${t}:${n}`;
        if (
          ("firestore.googleapis.com" !== i.host &&
            i.host !== o &&
            us("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."),
          e._setSettings(Object.assign(Object.assign({}, i), { host: o, ssl: !1 })),
          r.mockUserToken)
        ) {
          let t, n;
          if ("string" == typeof r.mockUserToken) (t = r.mockUserToken), (n = ss.MOCK_USER);
          else {
            t = (function (e, t) {
              if (e.uid)
                throw new Error(
                  'The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.'
                );
              const n = t || "demo-project",
                r = e.iat || 0,
                s = e.sub || e.user_id;
              if (!s) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
              const i = Object.assign(
                {
                  iss: `https://securetoken.google.com/${n}`,
                  aud: n,
                  iat: r,
                  exp: r + 3600,
                  auth_time: r,
                  sub: s,
                  user_id: s,
                  firebase: { sign_in_provider: "custom", identities: {} },
                },
                e
              );
              return [_n(JSON.stringify({ alg: "none", type: "JWT" })), _n(JSON.stringify(i)), ""].join(".");
            })(r.mockUserToken, null === (s = e._app) || void 0 === s ? void 0 : s.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new gs(ms.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new ss(i);
          }
          e._authCredentials = new bs(new vs(t, n));
        }
      }
      class xd {
        constructor(e, t, n) {
          (this.converter = t), (this._query = n), (this.type = "query"), (this.firestore = e);
        }
        withConverter(e) {
          return new xd(this.firestore, e, this._query);
        }
      }
      class Ad {
        constructor(e, t, n) {
          (this.converter = t), (this._key = n), (this.type = "document"), (this.firestore = e);
        }
        get _path() {
          return this._key.path;
        }
        get id() {
          return this._key.path.lastSegment();
        }
        get path() {
          return this._key.path.canonicalString();
        }
        get parent() {
          return new Id(this.firestore, this.converter, this._key.path.popLast());
        }
        withConverter(e) {
          return new Ad(this.firestore, e, this._key);
        }
      }
      class Id extends xd {
        constructor(e, t, n) {
          super(e, t, Eo(n)), (this._path = n), (this.type = "collection");
        }
        get id() {
          return this._query.path.lastSegment();
        }
        get path() {
          return this._query.path.canonicalString();
        }
        get parent() {
          const e = this._path.popLast();
          return e.isEmpty() ? null : new Ad(this.firestore, null, new qs(e));
        }
        withConverter(e) {
          return new Id(this.firestore, e, this._path);
        }
      }
      function kd(e, t, ...n) {
        if (((e = Bn(e)), vd("collection", "path", t), e instanceof _d)) {
          const r = Ns.fromString(t, ...n);
          return bd(r), new Id(e, null, r);
        }
        {
          if (!(e instanceof Ad || e instanceof Id))
            throw new gs(
              ms.INVALID_ARGUMENT,
              "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore"
            );
          const r = e._path.child(Ns.fromString(t, ...n));
          return bd(r), new Id(e.firestore, null, r);
        }
      }
      function Ld(e, t, ...n) {
        if (((e = Bn(e)), 1 === arguments.length && (t = As.newId()), vd("doc", "path", t), e instanceof _d)) {
          const r = Ns.fromString(t, ...n);
          return wd(r), new Ad(e, null, new qs(r));
        }
        {
          if (!(e instanceof Ad || e instanceof Id))
            throw new gs(
              ms.INVALID_ARGUMENT,
              "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore"
            );
          const r = e._path.child(Ns.fromString(t, ...n));
          return wd(r), new Ad(e.firestore, e instanceof Id ? e.converter : null, new qs(r));
        }
      }
      class Md {
        constructor(e = Promise.resolve()) {
          (this.Iu = []),
            (this.du = !1),
            (this.Eu = []),
            (this.Au = null),
            (this.Ru = !1),
            (this.Vu = !1),
            (this.mu = []),
            (this.r_ = new Lc(this, "async_queue_retry")),
            (this.fu = () => {
              const e = Ic();
              e && ls("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.r_.Jo();
            }),
            (this.gu = e);
          const t = Ic();
          t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.fu);
        }
        get isShuttingDown() {
          return this.du;
        }
        enqueueAndForget(e) {
          this.enqueue(e);
        }
        enqueueAndForgetEvenWhileRestricted(e) {
          this.pu(), this.yu(e);
        }
        enterRestrictedMode(e) {
          if (!this.du) {
            (this.du = !0), (this.Vu = e || !1);
            const t = Ic();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.fu);
          }
        }
        enqueue(e) {
          if ((this.pu(), this.du)) return new Promise(() => {});
          const t = new ys();
          return this.yu(() => (this.du && this.Vu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise))).then(() => t.promise);
        }
        enqueueRetryable(e) {
          this.enqueueAndForget(() => (this.Iu.push(e), this.wu()));
        }
        async wu() {
          if (0 !== this.Iu.length) {
            try {
              await this.Iu[0](), this.Iu.shift(), this.r_.reset();
            } catch (e) {
              if (!Ws(e)) throw e;
              ls("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.Iu.length > 0 && this.r_.jo(() => this.wu());
          }
        }
        yu(e) {
          const t = this.gu.then(
            () => (
              (this.Ru = !0),
              e()
                .catch((e) => {
                  (this.Au = e), (this.Ru = !1);
                  const t = (function (e) {
                    let t = e.message || "";
                    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
                  })(e);
                  throw (cs("INTERNAL UNHANDLED ERROR: ", t), e);
                })
                .then((e) => ((this.Ru = !1), e))
            )
          );
          return (this.gu = t), t;
        }
        enqueueAfterDelay(e, t, n) {
          this.pu(), this.mu.indexOf(e) > -1 && (t = 0);
          const r = hu.createAndSchedule(this, e, t, n, (e) => this.Su(e));
          return this.Eu.push(r), r;
        }
        pu() {
          this.Au && hs();
        }
        verifyOperationInProgress() {}
        async bu() {
          let e;
          do {
            (e = this.gu), await e;
          } while (e !== this.gu);
        }
        Du(e) {
          for (const t of this.Eu) if (t.timerId === e) return !0;
          return !1;
        }
        vu(e) {
          return this.bu().then(() => {
            this.Eu.sort((e, t) => e.targetTimeMs - t.targetTimeMs);
            for (const t of this.Eu) if ((t.skipDelay(), "all" !== e && t.timerId === e)) break;
            return this.bu();
          });
        }
        Cu(e) {
          this.mu.push(e);
        }
        Su(e) {
          const t = this.Eu.indexOf(e);
          this.Eu.splice(t, 1);
        }
      }
      class Dd extends _d {
        constructor(e, t, n, r) {
          super(e, t, n, r),
            (this.type = "firestore"),
            (this._queue = new Md()),
            (this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]");
        }
        async _terminate() {
          if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            (this._queue = new Md(e)), (this._firestoreClient = void 0), await e;
          }
        }
      }
      function Nd(e) {
        if (e._terminated) throw new gs(ms.FAILED_PRECONDITION, "The client has already been terminated.");
        return e._firestoreClient || Pd(e), e._firestoreClient;
      }
      function Pd(e) {
        var t, n, r;
        const s = e._freezeSettings(),
          i = (function (e, t, n, r) {
            return new Ti(
              e,
              t,
              n,
              r.host,
              r.ssl,
              r.experimentalForceLongPolling,
              r.experimentalAutoDetectLongPolling,
              gd(r.experimentalLongPollingOptions),
              r.useFetchStreams
            );
          })(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, s);
        e._componentsProvider ||
          ((null === (n = s.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) &&
            (null === (r = s.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) &&
            (e._componentsProvider = { _offline: s.localCache._offlineComponentProvider, _online: s.localCache._onlineComponentProvider })),
          (e._firestoreClient = new ad(
            e._authCredentials,
            e._appCheckCredentials,
            e._queue,
            i,
            e._componentsProvider &&
              (function (e) {
                const t = null == e ? void 0 : e._online.build();
                return { _offline: null == e ? void 0 : e._offline.build(t), _online: t };
              })(e._componentsProvider)
          ));
      }
      class Od {
        constructor(e) {
          this._byteString = e;
        }
        static fromBase64String(e) {
          try {
            return new Od(mi.fromBase64String(e));
          } catch (e) {
            throw new gs(ms.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
          }
        }
        static fromUint8Array(e) {
          return new Od(mi.fromUint8Array(e));
        }
        toBase64() {
          return this._byteString.toBase64();
        }
        toUint8Array() {
          return this._byteString.toUint8Array();
        }
        toString() {
          return "Bytes(base64: " + this.toBase64() + ")";
        }
        isEqual(e) {
          return this._byteString.isEqual(e._byteString);
        }
      }
      class qd {
        constructor(...e) {
          for (let t = 0; t < e.length; ++t)
            if (0 === e[t].length)
              throw new gs(ms.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
          this._internalPath = new Os(e);
        }
        isEqual(e) {
          return this._internalPath.isEqual(e._internalPath);
        }
      }
      class Rd {
        constructor(e) {
          this._methodName = e;
        }
      }
      class Fd {
        constructor(e, t) {
          if (!isFinite(e) || e < -90 || e > 90)
            throw new gs(ms.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
          if (!isFinite(t) || t < -180 || t > 180)
            throw new gs(ms.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
          (this._lat = e), (this._long = t);
        }
        get latitude() {
          return this._lat;
        }
        get longitude() {
          return this._long;
        }
        isEqual(e) {
          return this._lat === e._lat && this._long === e._long;
        }
        toJSON() {
          return { latitude: this._lat, longitude: this._long };
        }
        _compareTo(e) {
          return Is(this._lat, e._lat) || Is(this._long, e._long);
        }
      }
      class Bd {
        constructor(e) {
          this._values = (e || []).map((e) => e);
        }
        toArray() {
          return this._values.map((e) => e);
        }
        isEqual(e) {
          return (function (e, t) {
            if (e.length !== t.length) return !1;
            for (let n = 0; n < e.length; ++n) if (e[n] !== t[n]) return !1;
            return !0;
          })(this._values, e._values);
        }
      }
      const $d = /^__.*__$/;
      class Vd {
        constructor(e, t, n) {
          (this.data = e), (this.fieldMask = t), (this.fieldTransforms = n);
        }
        toMutation(e, t) {
          return null !== this.fieldMask
            ? new Sa(e, this.data, this.fieldMask, t, this.fieldTransforms)
            : new ba(e, this.data, t, this.fieldTransforms);
        }
      }
      class jd {
        constructor(e, t, n) {
          (this.data = e), (this.fieldMask = t), (this.fieldTransforms = n);
        }
        toMutation(e, t) {
          return new Sa(e, this.data, this.fieldMask, t, this.fieldTransforms);
        }
      }
      function zd(e) {
        switch (e) {
          case 0:
          case 2:
          case 1:
            return !0;
          case 3:
          case 4:
            return !1;
          default:
            throw hs();
        }
      }
      class Ud {
        constructor(e, t, n, r, s, i) {
          (this.settings = e),
            (this.databaseId = t),
            (this.serializer = n),
            (this.ignoreUndefinedProperties = r),
            void 0 === s && this.Fu(),
            (this.fieldTransforms = s || []),
            (this.fieldMask = i || []);
        }
        get path() {
          return this.settings.path;
        }
        get Mu() {
          return this.settings.Mu;
        }
        xu(e) {
          return new Ud(
            Object.assign(Object.assign({}, this.settings), e),
            this.databaseId,
            this.serializer,
            this.ignoreUndefinedProperties,
            this.fieldTransforms,
            this.fieldMask
          );
        }
        Ou(e) {
          var t;
          const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e),
            r = this.xu({ path: n, Nu: !1 });
          return r.Bu(e), r;
        }
        Lu(e) {
          var t;
          const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e),
            r = this.xu({ path: n, Nu: !1 });
          return r.Fu(), r;
        }
        ku(e) {
          return this.xu({ path: void 0, Nu: !0 });
        }
        qu(e) {
          return sh(e, this.settings.methodName, this.settings.Qu || !1, this.path, this.settings.Ku);
        }
        contains(e) {
          return (
            void 0 !== this.fieldMask.find((t) => e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t) => e.isPrefixOf(t.field))
          );
        }
        Fu() {
          if (this.path) for (let e = 0; e < this.path.length; e++) this.Bu(this.path.get(e));
        }
        Bu(e) {
          if (0 === e.length) throw this.qu("Document fields must not be empty");
          if (zd(this.Mu) && $d.test(e)) throw this.qu('Document fields cannot begin and end with "__"');
        }
      }
      class Gd {
        constructor(e, t, n) {
          (this.databaseId = e), (this.ignoreUndefinedProperties = t), (this.serializer = n || kc(e));
        }
        $u(e, t, n, r = !1) {
          return new Ud(
            { Mu: e, methodName: t, Ku: n, path: Os.emptyPath(), Nu: !1, Qu: r },
            this.databaseId,
            this.serializer,
            this.ignoreUndefinedProperties
          );
        }
      }
      function Hd(e) {
        const t = e._freezeSettings(),
          n = kc(e._databaseId);
        return new Gd(e._databaseId, !!t.ignoreUndefinedProperties, n);
      }
      function Wd(e, t, n, r, s, i = {}) {
        const o = e.$u(i.merge || i.mergeFields ? 2 : 0, t, n, s);
        eh("Data must be an object, but it was:", o, r);
        const a = Jd(r, o);
        let l, c;
        if (i.merge) (l = new pi(o.fieldMask)), (c = o.fieldTransforms);
        else if (i.mergeFields) {
          const e = [];
          for (const r of i.mergeFields) {
            const s = th(t, r, n);
            if (!o.contains(s))
              throw new gs(ms.INVALID_ARGUMENT, `Field '${s}' is specified in your field mask but missing from your input data.`);
            ih(e, s) || e.push(s);
          }
          (l = new pi(e)), (c = o.fieldTransforms.filter((e) => l.covers(e.field)));
        } else (l = null), (c = o.fieldTransforms);
        return new Vd(new zi(a), l, c);
      }
      class Kd extends Rd {
        _toFieldTransform(e) {
          if (2 !== e.Mu)
            throw 1 === e.Mu
              ? e.qu(`${this._methodName}() can only appear at the top level of your update data`)
              : e.qu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
          return e.fieldMask.push(e.path), null;
        }
        isEqual(e) {
          return e instanceof Kd;
        }
      }
      function Qd(e, t, n, r) {
        const s = e.$u(1, t, n);
        eh("Data must be an object, but it was:", s, r);
        const i = [],
          o = zi.empty();
        oi(r, (e, r) => {
          const a = rh(t, e, n);
          r = Bn(r);
          const l = s.Lu(a);
          if (r instanceof Kd) i.push(a);
          else {
            const e = Xd(r, l);
            null != e && (i.push(a), o.set(a, e));
          }
        });
        const a = new pi(i);
        return new jd(o, a, s.fieldTransforms);
      }
      function Yd(e, t, n, r, s, i) {
        const o = e.$u(1, t, n),
          a = [th(t, r, n)],
          l = [s];
        if (i.length % 2 != 0)
          throw new gs(
            ms.INVALID_ARGUMENT,
            `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`
          );
        for (let e = 0; e < i.length; e += 2) a.push(th(t, i[e])), l.push(i[e + 1]);
        const c = [],
          u = zi.empty();
        for (let e = a.length - 1; e >= 0; --e)
          if (!ih(c, a[e])) {
            const t = a[e];
            let n = l[e];
            n = Bn(n);
            const r = o.Lu(t);
            if (n instanceof Kd) c.push(t);
            else {
              const e = Xd(n, r);
              null != e && (c.push(t), u.set(t, e));
            }
          }
        const d = new pi(c);
        return new jd(u, d, o.fieldTransforms);
      }
      function Xd(e, t) {
        if (Zd((e = Bn(e)))) return eh("Unsupported field value:", t, e), Jd(e, t);
        if (e instanceof Rd)
          return (
            (function (e, t) {
              if (!zd(t.Mu)) throw t.qu(`${e._methodName}() can only be used with update() and set()`);
              if (!t.path) throw t.qu(`${e._methodName}() is not currently supported inside arrays`);
              const n = e._toFieldTransform(t);
              n && t.fieldTransforms.push(n);
            })(e, t),
            null
          );
        if (void 0 === e && t.ignoreUndefinedProperties) return null;
        if ((t.path && t.fieldMask.push(t.path), e instanceof Array)) {
          if (t.settings.Nu && 4 !== t.Mu) throw t.qu("Nested arrays are not supported");
          return (function (e, t) {
            const n = [];
            let r = 0;
            for (const s of e) {
              let e = Xd(s, t.ku(r));
              null == e && (e = { nullValue: "NULL_VALUE" }), n.push(e), r++;
            }
            return { arrayValue: { values: n } };
          })(e, t);
        }
        return (function (e, t) {
          if (null === (e = Bn(e))) return { nullValue: "NULL_VALUE" };
          if ("number" == typeof e) return Jo(t.serializer, e);
          if ("boolean" == typeof e) return { booleanValue: e };
          if ("string" == typeof e) return { stringValue: e };
          if (e instanceof Date) {
            const n = Ls.fromDate(e);
            return { timestampValue: nl(t.serializer, n) };
          }
          if (e instanceof Ls) {
            const n = new Ls(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return { timestampValue: nl(t.serializer, n) };
          }
          if (e instanceof Fd) return { geoPointValue: { latitude: e.latitude, longitude: e.longitude } };
          if (e instanceof Od) return { bytesValue: rl(t.serializer, e._byteString) };
          if (e instanceof Ad) {
            const n = t.databaseId,
              r = e.firestore._databaseId;
            if (!r.isEqual(n))
              throw t.qu(
                `Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`
              );
            return { referenceValue: ol(e.firestore._databaseId || t.databaseId, e._key.path) };
          }
          if (e instanceof Bd)
            return (function (e, t) {
              return {
                mapValue: {
                  fields: {
                    __type__: { stringValue: "__vector__" },
                    value: {
                      arrayValue: {
                        values: e.toArray().map((e) => {
                          if ("number" != typeof e) throw t.qu("VectorValues must only contain numeric values.");
                          return Yo(t.serializer, e);
                        }),
                      },
                    },
                  },
                },
              };
            })(e, t);
          throw t.qu(`Unsupported field value: ${Sd(e)}`);
        })(e, t);
      }
      function Jd(e, t) {
        const n = {};
        return (
          ai(e)
            ? t.path && t.path.length > 0 && t.fieldMask.push(t.path)
            : oi(e, (e, r) => {
                const s = Xd(r, t.Ou(e));
                null != s && (n[e] = s);
              }),
          { mapValue: { fields: n } }
        );
      }
      function Zd(e) {
        return !(
          "object" != typeof e ||
          null === e ||
          e instanceof Array ||
          e instanceof Date ||
          e instanceof Ls ||
          e instanceof Fd ||
          e instanceof Od ||
          e instanceof Ad ||
          e instanceof Rd ||
          e instanceof Bd
        );
      }
      function eh(e, t, n) {
        if (
          !Zd(n) ||
          !(function (e) {
            return (
              "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e))
            );
          })(n)
        ) {
          const r = Sd(n);
          throw "an object" === r ? t.qu(e + " a custom object") : t.qu(e + " " + r);
        }
      }
      function th(e, t, n) {
        if ((t = Bn(t)) instanceof qd) return t._internalPath;
        if ("string" == typeof t) return rh(e, t);
        throw sh("Field path arguments must be of type string or ", e, !1, void 0, n);
      }
      const nh = new RegExp("[~\\*/\\[\\]]");
      function rh(e, t, n) {
        if (t.search(nh) >= 0) throw sh(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, !1, void 0, n);
        try {
          return new qd(...t.split("."))._internalPath;
        } catch (r) {
          throw sh(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, !1, void 0, n);
        }
      }
      function sh(e, t, n, r, s) {
        const i = r && !r.isEmpty(),
          o = void 0 !== s;
        let a = `Function ${t}() called with invalid data`;
        n && (a += " (via `toFirestore()`)"), (a += ". ");
        let l = "";
        return (
          (i || o) && ((l += " (found"), i && (l += ` in field ${r}`), o && (l += ` in document ${s}`), (l += ")")),
          new gs(ms.INVALID_ARGUMENT, a + e + l)
        );
      }
      function ih(e, t) {
        return e.some((e) => e.isEqual(t));
      }
      class oh {
        constructor(e, t, n, r, s) {
          (this._firestore = e), (this._userDataWriter = t), (this._key = n), (this._document = r), (this._converter = s);
        }
        get id() {
          return this._key.path.lastSegment();
        }
        get ref() {
          return new Ad(this._firestore, this._converter, this._key);
        }
        exists() {
          return null !== this._document;
        }
        data() {
          if (this._document) {
            if (this._converter) {
              const e = new ah(this._firestore, this._userDataWriter, this._key, this._document, null);
              return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
          }
        }
        get(e) {
          if (this._document) {
            const t = this._document.data.field(lh("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
          }
        }
      }
      class ah extends oh {
        data() {
          return super.data();
        }
      }
      function lh(e, t) {
        return "string" == typeof t ? rh(e, t) : t instanceof qd ? t._internalPath : t._delegate._internalPath;
      }
      function ch(e) {
        if ("L" === e.limitType && 0 === e.explicitOrderBy.length)
          throw new gs(ms.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
      }
      class uh {
        convertValue(e, t = "none") {
          switch (xi(e)) {
            case 0:
              return null;
            case 1:
              return e.booleanValue;
            case 2:
              return vi(e.integerValue || e.doubleValue);
            case 3:
              return this.convertTimestamp(e.timestampValue);
            case 4:
              return this.convertServerTimestamp(e, t);
            case 5:
              return e.stringValue;
            case 6:
              return this.convertBytes(wi(e.bytesValue));
            case 7:
              return this.convertReference(e.referenceValue);
            case 8:
              return this.convertGeoPoint(e.geoPointValue);
            case 9:
              return this.convertArray(e.arrayValue, t);
            case 11:
              return this.convertObject(e.mapValue, t);
            case 10:
              return this.convertVectorValue(e.mapValue);
            default:
              throw hs();
          }
        }
        convertObject(e, t) {
          return this.convertObjectMap(e.fields, t);
        }
        convertObjectMap(e, t = "none") {
          const n = {};
          return (
            oi(e, (e, r) => {
              n[e] = this.convertValue(r, t);
            }),
            n
          );
        }
        convertVectorValue(e) {
          var t, n, r;
          const s =
            null ===
              (r =
                null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t.value.arrayValue) || void 0 === n ? void 0 : n.values) ||
            void 0 === r
              ? void 0
              : r.map((e) => vi(e.doubleValue));
          return new Bd(s);
        }
        convertGeoPoint(e) {
          return new Fd(vi(e.latitude), vi(e.longitude));
        }
        convertArray(e, t) {
          return (e.values || []).map((e) => this.convertValue(e, t));
        }
        convertServerTimestamp(e, t) {
          switch (t) {
            case "previous":
              const n = Si(e);
              return null == n ? null : this.convertValue(n, t);
            case "estimate":
              return this.convertTimestamp(Ei(e));
            default:
              return null;
          }
        }
        convertTimestamp(e) {
          const t = yi(e);
          return new Ls(t.seconds, t.nanos);
        }
        convertDocumentKey(e, t) {
          const n = Ns.fromString(e);
          ps(Il(n));
          const r = new _i(n.get(1), n.get(3)),
            s = new qs(n.popFirst(5));
          return (
            r.isEqual(t) ||
              cs(
                `Document ${s} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`
              ),
            s
          );
        }
      }
      function dh(e, t, n) {
        let r;
        return (r = e ? (n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t)) : t), r;
      }
      class hh {
        constructor(e, t) {
          (this.hasPendingWrites = e), (this.fromCache = t);
        }
        isEqual(e) {
          return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
        }
      }
      class ph extends oh {
        constructor(e, t, n, r, s, i) {
          super(e, t, n, r, i), (this._firestore = e), (this._firestoreImpl = e), (this.metadata = s);
        }
        exists() {
          return super.exists();
        }
        data(e = {}) {
          if (this._document) {
            if (this._converter) {
              const t = new fh(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, null);
              return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
          }
        }
        get(e, t = {}) {
          if (this._document) {
            const n = this._document.data.field(lh("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
          }
        }
      }
      class fh extends ph {
        data(e = {}) {
          return super.data(e);
        }
      }
      class mh {
        constructor(e, t, n, r) {
          (this._firestore = e),
            (this._userDataWriter = t),
            (this._snapshot = r),
            (this.metadata = new hh(r.hasPendingWrites, r.fromCache)),
            (this.query = n);
        }
        get docs() {
          const e = [];
          return this.forEach((t) => e.push(t)), e;
        }
        get size() {
          return this._snapshot.docs.size;
        }
        get empty() {
          return 0 === this.size;
        }
        forEach(e, t) {
          this._snapshot.docs.forEach((n) => {
            e.call(
              t,
              new fh(
                this._firestore,
                this._userDataWriter,
                n.key,
                n,
                new hh(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache),
                this.query.converter
              )
            );
          });
        }
        docChanges(e = {}) {
          const t = !!e.includeMetadataChanges;
          if (t && this._snapshot.excludesMetadataChanges)
            throw new gs(
              ms.INVALID_ARGUMENT,
              "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot()."
            );
          return (
            (this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t) ||
              ((this._cachedChanges = (function (e, t) {
                if (e._snapshot.oldDocs.isEmpty()) {
                  let t = 0;
                  return e._snapshot.docChanges.map((n) => {
                    const r = new fh(
                      e._firestore,
                      e._userDataWriter,
                      n.doc.key,
                      n.doc,
                      new hh(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache),
                      e.query.converter
                    );
                    return n.doc, { type: "added", doc: r, oldIndex: -1, newIndex: t++ };
                  });
                }
                {
                  let n = e._snapshot.oldDocs;
                  return e._snapshot.docChanges
                    .filter((e) => t || 3 !== e.type)
                    .map((t) => {
                      const r = new fh(
                        e._firestore,
                        e._userDataWriter,
                        t.doc.key,
                        t.doc,
                        new hh(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache),
                        e.query.converter
                      );
                      let s = -1,
                        i = -1;
                      return (
                        0 !== t.type && ((s = n.indexOf(t.doc.key)), (n = n.delete(t.doc.key))),
                        1 !== t.type && ((n = n.add(t.doc)), (i = n.indexOf(t.doc.key))),
                        { type: gh(t.type), doc: r, oldIndex: s, newIndex: i }
                      );
                    });
                }
              })(this, t)),
              (this._cachedChangesIncludeMetadataChanges = t)),
            this._cachedChanges
          );
        }
      }
      function gh(e) {
        switch (e) {
          case 0:
            return "added";
          case 2:
          case 3:
            return "modified";
          case 1:
            return "removed";
          default:
            return hs();
        }
      }
      class yh extends uh {
        constructor(e) {
          super(), (this.firestore = e);
        }
        convertBytes(e) {
          return new Od(e);
        }
        convertReference(e) {
          const t = this.convertDocumentKey(e, this.firestore._databaseId);
          return new Ad(this.firestore, null, t);
        }
      }
      function vh(e) {
        e = Ed(e, xd);
        const t = Ed(e.firestore, Dd),
          n = Nd(t),
          r = new yh(t);
        return ch(e._query), md(n, e._query).then((n) => new mh(t, r, e, n));
      }
      function wh(e, t, n, ...r) {
        e = Ed(e, Ad);
        const s = Ed(e.firestore, Dd),
          i = Hd(s);
        let o;
        return (
          (o = "string" == typeof (t = Bn(t)) || t instanceof qd ? Yd(i, "updateDoc", e._key, t, n, r) : Qd(i, "updateDoc", e._key, t)),
          bh(s, [o.toMutation(e._key, ha.exists(!0))])
        );
      }
      function bh(e, t) {
        return (function (e, t) {
          const n = new ys();
          return (
            e.asyncQueue.enqueueAndForget(async () =>
              (async function (e, t, n) {
                const r = nd(e);
                try {
                  const e = await (function (e, t) {
                    const n = fs(e),
                      r = Ls.now(),
                      s = t.reduce((e, t) => e.add(t.key), Wo());
                    let i, o;
                    return n.persistence
                      .runTransaction("Locally write mutations", "readwrite", (e) => {
                        let a = Fo(),
                          l = Wo();
                        return n.hs
                          .getEntries(e, s)
                          .next((e) => {
                            (a = e),
                              a.forEach((e, t) => {
                                t.isValidDocument() || (l = l.add(e));
                              });
                          })
                          .next(() => n.localDocuments.getOverlayedDocuments(e, a))
                          .next((s) => {
                            i = s;
                            const o = [];
                            for (const e of t) {
                              const t = va(e, i.get(e.key).overlayedDocument);
                              null != t && o.push(new Sa(e.key, t, Ui(t.value.mapValue), ha.exists(!0)));
                            }
                            return n.mutationQueue.addMutationBatch(e, r, o, t);
                          })
                          .next((t) => {
                            o = t;
                            const r = t.applyToLocalDocumentSet(i, l);
                            return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                          });
                      })
                      .then(() => ({ batchId: o.batchId, changes: Vo(i) }));
                  })(r.localStore, t);
                  r.sharedClientState.addPendingMutation(e.batchId),
                    (function (e, t, n) {
                      let r = e.qa[e.currentUser.toKey()];
                      r || (r = new li(Is)), (r = r.insert(t, n)), (e.qa[e.currentUser.toKey()] = r);
                    })(r, e.batchId, n),
                    await Ju(r, e.changes),
                    await Zc(r.remoteStore);
                } catch (e) {
                  const t = pu(e, "Failed to persist write");
                  n.reject(t);
                }
              })(await hd(e), t, n)
            ),
            n.promise
          );
        })(Nd(e), t);
      }
      function Sh(e, t, n) {
        const r = n.docs.get(t._key),
          s = new yh(e);
        return new ph(e, s, t._key, r, new hh(n.hasPendingWrites, n.fromCache), t.converter);
      }
      new WeakMap();
      if (
        ((function (e, t = !0) {
          !(function (e) {
            is = e;
          })("11.2.0"),
            Cr(
              new $n(
                "firestore",
                (e, { instanceIdentifier: n, options: r }) => {
                  const s = e.getProvider("app").getImmediate(),
                    i = new Dd(
                      new Ss(e.getProvider("auth-internal")),
                      new Cs(e.getProvider("app-check-internal")),
                      (function (e, t) {
                        if (!Object.prototype.hasOwnProperty.apply(e.options, ["projectId"]))
                          throw new gs(ms.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
                        return new _i(e.options.projectId, t);
                      })(s, n),
                      s
                    );
                  return (r = Object.assign({ useFetchStreams: t }, r)), i._setSettings(r), i;
                },
                "PUBLIC"
              ).setMultipleInstances(!0)
            ),
            Lr(rs, "4.7.6", e),
            Lr(rs, "4.7.6", "esm2017");
        })(),
        null !== document.querySelector(".cart__drawer"))
      ) {
        const Jh = document.querySelector(".cart__drawer-wrap"),
          Zh =
            (document.querySelector(".cart__drawer-overlay"),
            document.querySelector(".cart__drawer"),
            document.getElementById("cart-header-text")),
          ep = document.querySelector(".cart__drawer-ticker"),
          tp = document.getElementById("cart-upsell-warning"),
          np = (document.getElementById("cart-subscription-warning"), document.getElementById("cart-product-warning")),
          rp = document.querySelector(".cart__drawer-items"),
          sp = document.querySelector(".cart__drawer-upsells"),
          ip = document.querySelectorAll(".cart__drawer-upsells-item"),
          op = document.querySelector(".bag-count"),
          ap = document.getElementById("checkout-button"),
          lp = document.querySelector(".cart__drawer-footer"),
          cp = () => {
            fetch("/cart.js", { headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" } })
              .then((e) => e.json())
              .then((e) => {
                console.log("BB CART", e), (rp.innerHTML = "");
                let t = !1,
                  n = [],
                  r = !0,
                  s = 0,
                  i = 0;
                if ((console.log(e, "cart"), e.item_count > 0)) {
                  console.log("ovde sammm");
                  const { items: o } = e;
                  let a = 1;
                  o.forEach((e) => {
                    console.log("e.product_type-->", e.product_type);
                    if (
                      (void 0 !== e.selling_plan_allocation
                        ? ((t = !0),
                          e.product_type.includes("Protein") ||
                          e.product_type.includes("Merch") ||
                          e.product_type.includes("Gift Card") ||
                          e.product_type.includes("Granola") ||
                          e.product_type.includes("Blender Bombs")
                            ? (s = 2)
                            : (s += e.quantity))
                        : e.product_type.includes("Protein") ||
                          e.product_type.includes("Merch") ||
                          e.product_type.includes("Gift Card") ||
                          e.product_type.includes("Granola") ||
                          e.product_type.includes("Blender Bombs")
                        ? (i = 2)
                        : (i += e.quantity),
                      up(e, rp, a),
                      void 0 !== window.upsells &&
                        window.upsells.length &&
                        (window.upsellProdTypes.includes(e.product_type) ? n.push(e.key) : (r = !1), window.upsells.includes(e.variant_id)))
                    ) {
                      var o = upsells.indexOf(e.variant_id);
                      window.upsells.splice(o, 1);
                    }
                    a++;
                  }),
                    console.log(s, i, "subscriptionProductCountOvdeees"),
                    (op.textContent = e.item_count),
                    (Zh.textContent = `Bomb Bag (${e.item_count})`),
                    (ap.textContent = `Checkout — ${Shopify.formatMoney(e.total_price)}`),
                    (lp.style.display = "block"),
                    null !== ep && (ep.style.display = "flex"),
                    null !== sp &&
                      (void 0 !== window.upsells &&
                        window.upsells.length &&
                        ((sp.style.display = "block"),
                        void 0 !== window.randomizeUpsells &&
                          !0 === window.randomizeUpsells &&
                          ((e) => {
                            for (let t = e.length - 1; t > 0; t--) {
                              const n = Math.floor(Math.random() * (t + 1));
                              [e[t], e[n]] = [e[n], e[t]];
                            }
                          })(window.upsells),
                        ip.forEach((e) => {
                          e.style.display = "none";
                        }),
                        (document.getElementById(`upsell-${window.upsells[0]}`).style.display = "grid")),
                      window.upsells.length || (sp.style.display = "none"));
                  console.log("e.total_price", e.total_price);
                  s < 2 && i < 2
                    ? (console.log(t, "less than 22"),
                      setTimeout(() => {
                        console.log("granola");
                        console.log("dodaj disabled 11111");
                        if (e.total_price < 1750) {
                          document.querySelector("#checkout-button").classList.add("disabled"),
                            (np.style.display = "block"),
                            ap.setAttribute("disabled", "true");
                        }
                      }, 500))
                    : (r || (ap.removeAttribute("disabled"), ap.classList.remove("disabled")), (np.style.display = "none")),
                    r
                      ? (ap.classList.add("disabled"),
                        ap.setAttribute("disabled", !0),
                        (tp.style.display = "block"),
                        n.length &&
                          n.forEach((e) => {
                            Bp(e, 0);
                          }))
                      : (t || (ap.removeAttribute("disabled"), ap.classList.remove("disabled")), (tp.style.display = "none"));
                  if (e.total_price < 1750) {
                    console.log("222222222");
                    document.querySelector("#checkout-button").classList.add("disabled");
                    np.style.display = "block";
                    ap.setAttribute("disabled", "true");
                  } else {
                    console.log("3333333");
                    ap.removeAttribute("disabled");
                    ap.classList.remove("disabled");
                    np.style.display = "none";
                  }
                } else
                  (op.textContent = "0"),
                    (Zh.textContent = "Bomb Bag"),
                    (rp.innerHTML =
                      '<div class=\'caps-21 text-center md:text-18\'>Your cart is empty</div><div class="text-center -mt-4 md:-mt-2"><a href="/collections/all" class="button--dark-pink">Shop Now</a></div>'),
                    (lp.style.display = "none"),
                    null !== ep && (ep.style.display = "none"),
                    null !== sp && (sp.style.display = "none");
              });
          },
          up = (e, t, n) => {
            console.log(e, t, n);
            let r = document
              .createRange()
              .createContextualFragment(
                `\n\t\t\t<div class="cart__drawer-item">\n\t\t\t\t${
                  window.disableCartProdLinks
                    ? `<div class="cart__drawer-item-image">\n\t\t\t\t\t\t<img src="${e.featured_image.url}" alt="${e.featured_image.alt}" />\n\t\t\t\t\t</div>`
                    : `<a href="${e.url}" class="cart__drawer-item-image">\n\t\t\t\t\t\t<img src="${e.featured_image.url}" alt="${e.featured_image.alt}" />\n\t\t\t\t\t</a>`
                }\n\t\t\t\t<div class="cart__drawer-item-content">\n\t\t\t\t\t<div class="cart__drawer-item-content-top">\n\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t${
                  window.disableCartProdLinks
                    ? `<div class="cart__drawer-item-title">\n\t\t\t\t\t\t\t\t\t${
                        e.product_title.endsWith("_") ? e.product_title.slice(0, -1) : e.product_title
                      }\n\t\t\t\t\t\t\t\t</div>`
                    : `<a href="${e.url}" class="cart__drawer-item-title">\n\t\t\t\t\t\t\t\t\t${
                        e.product_title.endsWith("_") ? e.product_title.slice(0, -1) : e.product_title
                      }\n\t\t\t\t\t\t\t\t</a>`
                }\n\n\t\t\t\t\t\t\t${
                  e.gift_card ||
                  e.product_type.includes("Bombs") ||
                  e.product_type.includes("Bar") ||
                  void 0 !== e.selling_plan_allocation ||
                  e.product_has_only_default_variant ||
                  !(e.options_with_values.length > 0)
                    ? ""
                    : e.options_with_values
                        .map(
                          (e) =>
                            `<div class="cart__drawer-item-content-options">\n\t\t\t\t\t\t\t\t\t<div class="mr-1">${e.name}:</div>\n\t\t\t\t\t\t\t\t\t<div>${e.value}</div>\n\t\t\t\t\t\t\t\t</div>`
                        )
                        .join("")
                }\n\n\t\t\t\t\t\t\t${
                  e.selling_plan_allocation && e.selling_plan_allocation.selling_plan
                    ? `<div class="cart__drawer-item-content-options">\n\t\t\t\t\t\t\t\t\t<div class="cart__drawer-item-content-options--delivery">Delivery ${e.selling_plan_allocation.selling_plan.name.replace(
                        /\*/g,
                        ""
                      )}</div>\n\t\t\t\t\t\t\t\t</div>`
                    : e.product_type.includes("Bombs") || e.product_type.includes("Bar")
                    ? `<div>\n\t\t\t\t\t\t\t\t\t<p class="font-grenette text-14 mt-0.5">Upgrade to a Subscription and Save</p>\n\t\t\t\t\t\t\t\t\t<skio-cart-upsell item='${JSON.stringify(
                        (({ product_description: e, ...t }) => t)(e)
                      )}' line='${n}'></skio-cart-upsell>\n\t\t\t\t\t\t\t\t</div>`
                    : `<div class="cart__drawer-item-content-options">\n\t\t\t\t\t\t\t\t\t<div class="cart__drawer-item-content-options--delivery" style="color: #888; display:none;">No subscription attached</div>\n\t\t\t\t\t\t\t\t</div>`
                }\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="cart__drawer-item-price">\n\t\t\t\t\t\t\t${
                  Shopify.formatMoney(e.original_line_price) !== Shopify.formatMoney(e.final_line_price)
                    ? `<span>${Shopify.formatMoney(e.final_line_price).replace(
                        ".00",
                        ""
                      )}</span> <s class="text-cream">${Shopify.formatMoney(e.original_line_price).replace(".00", "")}</s>`
                    : `<span>${Shopify.formatMoney(e.final_line_price).replace(".00", "")}</span>`
                }\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="cart__drawer-item-content-bottom">\n\t\t\t\t\t\t<div class="cart__drawer-item-qty">\n\t\t\t\t\t\t\t<span onclick="window.cartItemUpdate('${
                  e.key
                }',${e.quantity - 1})">-</span>\n\t\t\t\t\t\t\t<span>${
                  e.quantity
                }</span>\n\t\t\t\t\t\t\t<span onclick="window.cartItemUpdate('${e.key}',${
                  e.quantity + 1
                })">+</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t`
              );
            t.prepend(r);
          },
          dp = () => {
            Jh.classList.add("active");
          },
          hp = () => {
            Jh.classList.contains("active") && Jh.classList.remove("active");
          };
        function pp(e, t, n) {
          if (e instanceof Date) {
            var r = new Date(e),
              s = function () {
                r.getDate() != e.getDate() && r.setDate(0);
              };
            switch (String(t).toLowerCase()) {
              case "year":
                r.setFullYear(r.getFullYear() + n), s();
                break;
              case "quarter":
                r.setMonth(r.getMonth() + 3 * n), s();
                break;
              case "month":
                r.setMonth(r.getMonth() + n), s();
                break;
              case "week":
                r.setDate(r.getDate() + 7 * n);
                break;
              case "day":
                r.setDate(r.getDate() + n);
                break;
              case "hour":
                r.setTime(r.getTime() + 36e5 * n);
                break;
              case "minute":
                r.setTime(r.getTime() + 6e4 * n);
                break;
              case "second":
                r.setTime(r.getTime() + 1e3 * n);
                break;
              default:
                r = void 0;
            }
            return r;
          }
        }
        function fp(e) {
          return e.toString().padStart(2, "0");
        }
        function mp(e) {
          return (
            [e.getFullYear(), fp(e.getMonth() + 1), fp(e.getDate())].join("-") +
            " " +
            [fp(e.getHours()), fp(e.getMinutes()), fp(e.getSeconds())].join(":")
          );
        }
        const gp = (function (e, t) {
            const n = "string" == typeof e ? e : t || "(default)",
              r = xr(
                "object" == typeof e
                  ? e
                  : (function (e = wr) {
                      const t = Sr.get(e);
                      if (!t && e === wr && kn()) return kr();
                      if (!t) throw Ar.create("no-app", { appName: e });
                      return t;
                    })(),
                "firestore"
              ).getImmediate({ identifier: n });
            if (!r._initialized) {
              const e = In("firestore");
              e && Cd(r, ...e);
            }
            return r;
          })(
            kr({
              apiKey: "AIzaSyCW_yMKRlmCP3URcF3VlYNj6AsetFMOu44",
              authDomain: "bombcopopup.firebaseapp.com",
              projectId: "bombcopopup",
              storageBucket: "bombcopopup.firebasestorage.app",
              messagingSenderId: "116378805721",
              appId: "1:116378805721:web:1153f73f534e19b8ae65c8",
            })
          ),
          yp =
            (kd(gp, "productEvents"),
            async (e, t) => {
              const n = Ld(gp, "productEvents", e);
              try {
                const e = await (function (e) {
                  e = Ed(e, Ad);
                  const t = Ed(e.firestore, Dd);
                  return fd(Nd(t), e._key).then((n) => Sh(t, e, n));
                })(n);
                if (e.exists()) {
                  const t = e.data().addedCount || 0;
                  await wh(n, { addedCount: t + 1 });
                } else
                  await (function (e, t, n) {
                    e = Ed(e, Ad);
                    const r = Ed(e.firestore, Dd),
                      s = dh(e.converter, t, n);
                    return bh(r, [Wd(Hd(r), "setDoc", e._key, s, null !== e.converter, n).toMutation(e._key, ha.none())]);
                  })(n, { name: t, addedCount: 1, percentage: 0 });
                await vp(), await wp();
              } catch (e) {
                console.error("Error updating Firestore:", e);
              }
            }),
          vp = async () => {
            const e = kd(gp, "productEvents"),
              t = await vh(e);
            let n = 0;
            const r = [];
            t.forEach((e) => {
              const t = e.data();
              (n += t.addedCount), r.push({ id: e.id, ...t });
            });
            for (const e of r) {
              const t = ((e.addedCount / n) * 100).toFixed(2);
              await wh(Ld(gp, "productEvents", e.id), { percentage: parseFloat(t) });
            }
          },
          wp = async () => {
            const e = kd(gp, "productEvents"),
              t = await vh(e),
              n = [];
            t.forEach((e) => {
              const t = e.data();
              n.push({ id: e.id, ...t });
            });
            for (const e of n) {
              const t = e.addedCount > 0 ? ((e.popupPurchasedCount / e.addedCount) * 100).toFixed(2) : 0;
              await wh(Ld(gp, "productEvents", e.id), { popupConversionRate: parseFloat(t) });
            }
          },
          bp =
            '\n  <div id="product-popup" class="hidden fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 px-[10px]">\n    <div class="bg-white p-6 rounded-2xl shadow-lg max-w-2xl w-full text-center relative">\n      <h2 class="text-[30px] font-bold mb-2">Spice Up Your Smoothies! ❤️</h2>\n\t  <p class="text-red-500 font-bold mb-4 text-[16px]">Pair your Love Blender Bomb with Chocolate or Vanilla Bomb Protein for 50% Off Your First Month!</p>\n      <p class="text-red-500 font-bold mb-4 text-[20px]">Hurry! This irresistible offer ends in <span class="bold" id="countdown-timer">5:00</span></p>\n      <div class="flex justify-around items-center gap-6">\n        <div class="text-center">\n          <img src="https://thebombco.com/cdn/shop/files/73.png?v=1736865819&width=1800" class="w-32 h-32 mx-auto mb-2">\n          <p class="font-bold">Chocolate Bomb Plant Protein</p>\n\t\t  <div class="text-center mt-[10px]">\n\t\t\t<span class="text-lg font-bold">Only $28.99</span>\n\t\t\t<span class="text-sm line-through text-gray-500">$57.98</span>\n\t\t  </div>\n          <button id="add-product-1" class="button--dark-pink px-4 py-2 rounded-lg mt-[10px]">\n\t\t  Add to My Order\n          </button>\n        </div>\n        <div class="text-center">\n          <img src="https://thebombco.com/cdn/shop/files/79.png?v=1736864927&width=1800" class="w-32 h-32 mx-auto mb-2">\n          <p class="font-bold">Vanilla Bomb Plant Protein</p>\n\t\t  <div class="text-center mt-[10px]">\n\t\t\t<span class="text-lg font-bold">Only $28.99</span>\n\t\t\t<span class="text-sm line-through text-gray-500">$57.98</span>\n\t\t  </div>\n          <button id="add-product-2" class="button--dark-pink px-4 py-2 rounded-lg mt-[10px]">\n\t\t  Add to My Order\n          </button>\n        </div>\n      </div>\n      <button id="decline-offer" class="bg-transparent text-gray-800 underline mt-6">I\'ll skip the magic this time.</button>\n    </div>\n  </div>\n';
        document.body.insertAdjacentHTML("beforeend", bp);
        const Sp = (e, t) => {
          let n,
            r,
            s = e;
          const i = setInterval(() => {
            (n = Math.floor(s / 60)),
              (r = s % 60),
              (r = r < 10 ? "0" + r : r),
              (t.textContent = `${n}:${r}`),
              --s < 0 && (clearInterval(i), document.getElementById("product-popup").classList.add("hidden"));
          }, 1e3);
        };
        document.querySelector("body").getAttribute;
        const Ep = (e) => {
            let t = document.getElementById(e).querySelector('[name="add"]'),
              n = t.getAttribute("data-special");
            console.log(n, "dataSpecial");
            let r = t.innerHTML;
            t.setAttribute("disabled", !0), (t.innerHTML = "<span>Adding...</span>");
            const s = bn()(document.getElementById(e), { hash: !0 });
            let i;
            if ("love" === n) {
              const e = document.getElementById("product-popup");
              e.classList.remove("hidden");
              const n = document.getElementById("countdown-timer");
              Sp(300, n),
                document.getElementById("add-product-1").addEventListener("click", () => {
                  (i = [
                    { id: s.id, quantity: parseInt(s.quantity || 1) },
                    { id: 42525702291636, quantity: 1, selling_plan: 7719223476, properties: { popup_added: !0 } },
                  ]),
                    yp("42525702291636", "Chocolate Bomb Plant Protein"),
                    Tp(i, t, r, e);
                }),
                document.getElementById("add-product-2").addEventListener("click", () => {
                  (i = [
                    { id: s.id, quantity: parseInt(s.quantity || 1) },
                    { id: 42525699113140, quantity: 1, selling_plan: 7719223476, properties: { popup_added: !0 } },
                  ]),
                    yp("42525699113140", "Vanilla Bomb Plant Protein"),
                    Tp(i, t, r, e);
                }),
                document.getElementById("decline-offer").addEventListener("click", () => {
                  (i = [{ id: s.id, quantity: parseInt(s.quantity || 1) }]), yp("Decline Offer", "Decline Offer"), Tp(i, t, r, e);
                });
            } else (i = [{ id: s.id, quantity: parseInt(s.quantity || 1) }]), Tp(i, t, r);
          },
          Tp = (e, t, n, r = null) => {
            fetch("/cart/add.js", {
              body: JSON.stringify({ items: e }),
              headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
              method: "POST",
            })
              .then((e) => e.json())
              .then((e) => {
                console.log(e, "data"), cp(), dp(), t.removeAttribute("disabled"), (t.innerHTML = n), r && r.classList.add("hidden");
              })
              .catch((e) => {
                console.error("Error adding items to cart:", e),
                  t.removeAttribute("disabled"),
                  (t.innerHTML = n),
                  r && r.classList.add("hidden");
              });
          },
          _p = (e) => {
            console.log("e-->", e);
            console.log(document.getElementById(e));
            console.log("bn()", bn());
            var formCartObj = bn()(document.getElementById(e), { hash: !0 });
            console.log("---->", formCartObj.quantity);
            let t = document.getElementById(e).querySelector('[name="add"]'),
              n = t.innerHTML;
            t.setAttribute("disabled", !0),
              (t.innerHTML = "<span>Adding...</span>"),
              ap.setAttribute("disabled", !0),
              (ap.textContent = "Loading...");
            if (formCartObj.productType == "blender-bombs") {
              formCartObj.quantity = 1;
            }
            console.log(JSON.stringify(formCartObj), "bodyyy"),
              fetch("/cart/add.js", {
                body: JSON.stringify(formCartObj),
                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                method: "POST",
              })
                .then((e) => e.json())
                .then((e) => {
                  console.log(e, "data"), cp(), dp(), t.removeAttribute("disabled"), (t.innerHTML = n);
                  let r = mp(new Date()),
                    s = new Date(r);
                  console.log(r, s, "date"), console.log(pp(s, "minute", 10), "dateAdd(d, minute, 1)");
                  let i = pp(s, "minute", 10);
                  var o, a, l;
                  (o = i),
                    (o = (o = new Date(o)).getTime()),
                    isNaN(o) ||
                      setInterval(function () {
                        var e = new Date(),
                          t =
                            ((e = new Date(
                              e.getUTCFullYear(),
                              e.getUTCMonth(),
                              e.getUTCDate(),
                              e.getUTCHours(),
                              e.getUTCMinutes(),
                              e.getUTCSeconds()
                            )),
                            parseInt((o - e.getTime()) / 1e3));
                        t >= 0 &&
                          (parseInt(t / 86400),
                          (t %= 86400),
                          parseInt(t / 3600),
                          (t %= 3600),
                          (a = parseInt(t / 60)),
                          (t %= 60),
                          (l = parseInt(t)),
                          (document.getElementById("minutess").innerHTML = ("0" + a).slice(-2)),
                          (document.getElementById("secondss").innerHTML = ("0" + l).slice(-2)));
                      }, 1e3);
                  let c = document.querySelector(".countdown");
                  setTimeout(() => {
                    c && c.classList.add("show");
                  }, 1e3);
                });
          },
          Cp = () => {
            let e = document.querySelector("#add-to-cart-button");
            console.log(window.variantIdFirst, window.variantIdSecond, window.variantIdThird, "variantIdSHOW"),
              window.variantIdFirst && window.variantIdSecond && e.removeAttribute("disabled");
          };
        var Eh = document.querySelector(".js-product-one-selector"),
          Th = document.querySelector(".js-product-two-selector");
        let xp = () => {
          const e = document.querySelector(".js-product-one-selector"),
            t = e.options[e.selectedIndex],
            n = document.querySelector(".js-product-two-selector"),
            r = n.options[n.selectedIndex],
            s = t.getAttribute("data-type"),
            i = r.getAttribute("data-type");
          let o,
            a,
            l,
            c,
            u = 0;
          "Blender Bombs" === s && "Blender Bombs" === i && (u = -10.08),
            "Blender Bombs" === s && "Bomb Bars" === i && (u = -7.12),
            "Blender Bombs" === s && "Protein Powder" === i && (u = -14.49),
            "Protein Powder" === s && "Blender Bombs" === i && (u = -14.49),
            "Protein Powder" === s && "Protein Powder" === i && (u = -18.9),
            "Protein Powder" === s && "Bomb Bars" === i && (u = -11.53),
            "Bomb Bars" === s && "Bomb Bars" === i && (u = -4.16),
            "Bomb Bars" === s && "Protein Powder" === i && (u = -11.53),
            "Bomb Bars" === s && "Blender Bombs" === i && (u = -7.12),
            console.log(s, i, "prTypeFirst"),
            (a = r.getAttribute("data-price")),
            (o = t.getAttribute("data-price")),
            (l = t.getAttribute("data-original-price")),
            (c = r.getAttribute("data-original-price")),
            console.log(o, a, "priceInfo"),
            null == o && (o = 0),
            null == a && (a = 0);
          let d = (parseFloat(o) + parseFloat(a)) / 100,
            h = (parseFloat(l) + parseFloat(c)) / 100,
            p = d - u,
            f = document.querySelector(".js-pr"),
            m = document.querySelector(".js-pr-original"),
            g = document.querySelector(".js-pr-once");
          (f.innerHTML = `$${p.toFixed(2)}`),
            console.log(isNaN(h), h, "total_price_original"),
            g && !isNaN(h) && (g.innerHTML = `$${h.toFixed(2)}`);
          let y = h - p,
            v = document.querySelector(".js-save");
          console.log(y, "diff"),
            console.log(l, c, "priceOriginal"),
            null !== l &&
              null !== c &&
              (console.log("ovde si"), (m.innerHTML = `$${h.toFixed(2)}`), (v.innerHTML = `Save<br> $${y.toFixed(2)}`));
        };
        Eh &&
          Eh.addEventListener("change", function () {
            let e = Eh.value,
              t = Eh.options[Eh.selectedIndex].getAttribute("data-image"),
              n = Eh.options[Eh.selectedIndex].getAttribute("data-selling-plan-id");
            (document.querySelector(".js-image-1").src = t),
              console.log(n, "sellingPlanId"),
              (window.variantIdFirst = e),
              n && (window.sellingPlanSelectorIdFirst = n),
              setTimeout(() => {
                xp();
              }, 400),
              Cp();
          }),
          Th &&
            Th.addEventListener("change", function () {
              let e = Th.value,
                t = Th.options[Th.selectedIndex].getAttribute("data-image"),
                n = Th.options[Th.selectedIndex].getAttribute("data-selling-plan-id");
              (document.querySelector(".js-image-2").src = t),
                console.log(e, "variantId"),
                console.log(n, "sellingPlanIdSecond"),
                (window.variantIdSecond = e),
                n && (window.sellingPlanSelectorIdSecond = n),
                setTimeout(() => {
                  xp();
                }, 400),
                Cp();
            });
        const Ap = () => {
          let e = document.querySelector("#add-to-cart-button");
          console.log(window.variantIdFirstM, window.variantIdSecondM, window.variantIdThirdM, "variantIdSHOWMIXMATCH"),
            window.variantIdFirstM && window.variantIdSecondM && window.variantIdThirdM && e.removeAttribute("disabled");
        };
        var _h = document.querySelector(".js-product-one-selector-m"),
          Ch = document.querySelector(".js-product-two-selector-m"),
          xh = document.querySelector(".js-product-three-selector-m");
        console.log(_h, Ch, xh, "variantSelectorFirstM"),
          _h &&
            _h.addEventListener("change", function () {
              let e = _h.value,
                t = _h.options[_h.selectedIndex].getAttribute("data-image"),
                n = _h.options[_h.selectedIndex].getAttribute("data-selling-plan-id");
              (document.querySelector(".js-image-1").src = t),
                console.log(t, "imageId"),
                console.log(e, "variantId"),
                (window.variantIdFirstM = e),
                n && (window.sellingPlanIdFirstM = n),
                Ap();
            }),
          Ch &&
            Ch.addEventListener("change", function () {
              let e = Ch.value,
                t = Ch.options[Ch.selectedIndex].getAttribute("data-image"),
                n = Ch.options[Ch.selectedIndex].getAttribute("data-selling-plan-id");
              (document.querySelector(".js-image-2").src = t),
                console.log(e, "variantId"),
                (window.variantIdSecondM = e),
                n && (window.sellingPlanIdSecondM = n),
                Ap();
            }),
          xh &&
            xh.addEventListener("change", function () {
              let e = xh.value,
                t = xh.options[xh.selectedIndex].getAttribute("data-image"),
                n = xh.options[xh.selectedIndex].getAttribute("data-selling-plan-id");
              (document.querySelector(".js-image-3").src = t),
                console.log(e, "variantId"),
                (window.variantIdThirdM = e),
                n && (window.sellingPlanIdThirdM = n),
                Ap();
            });
        const Ip = () => {
          let e = document.querySelector("#add-to-cart-button");
          console.log(window.variantIdFirstB, window.variantIdSecondB, window.variantIdThirdB, "variantIdBUY2GET1FREE"),
            window.variantIdFirstB && window.variantIdSecondB && window.variantIdThirdB && e.removeAttribute("disabled");
        };
        (window.priceFirst = 0), (window.priceSecond = 0), (window.priceThird = 0);
        const kp = (e, t, n) => {
          let r = Math.min(e, t, n);
          e === r ? (e = 0) : t === r ? (t = 0) : (n = 0);
          let s = (e + t + n) / 100;
          console.log(s, "price"), (document.querySelector(".js-price").innerHTML = `$${s.toFixed(2)}`);
        };
        var Ah = document.querySelector(".js-product-one-selector-b"),
          Ih = document.querySelector(".js-product-two-selector-b"),
          kh = document.querySelector(".js-product-three-selector-b");
        console.log(Ah, Ih, kh, "variantSelectorFirstM"),
          Ah &&
            Ah.addEventListener("change", function () {
              let e = Ah.value,
                t = Ah.options[Ah.selectedIndex].getAttribute("data-image"),
                n = Ah.options[Ah.selectedIndex].getAttribute("data-original-price");
              (window.priceFirst = parseFloat(n)),
                (document.querySelector(".js-image-1").src = t),
                console.log(t, "imageId"),
                console.log(e, "variantId"),
                (window.variantIdFirstB = e),
                kp(window.priceFirst, window.priceSecond, window.priceThird),
                Ip();
            }),
          Ih &&
            Ih.addEventListener("change", function () {
              let e = Ih.value,
                t = Ih.options[Ih.selectedIndex].getAttribute("data-image"),
                n = Ih.options[Ih.selectedIndex].getAttribute("data-original-price");
              (window.priceSecond = parseFloat(n)),
                (document.querySelector(".js-image-2").src = t),
                console.log(e, "variantId"),
                (window.variantIdSecondB = e),
                kp(window.priceFirst, window.priceSecond, window.priceThird),
                Ip();
            }),
          kh &&
            kh.addEventListener("change", function () {
              let e = kh.value,
                t = kh.options[kh.selectedIndex].getAttribute("data-image"),
                n = kh.options[kh.selectedIndex].getAttribute("data-original-price");
              (window.priceThird = parseFloat(n)),
                (document.querySelector(".js-image-3").src = t),
                console.log(e, "variantId"),
                (window.variantIdThirdB = e),
                kp(window.priceFirst, window.priceSecond, window.priceThird),
                Ip();
            });
        let Lp = document.querySelectorAll(".pdp-plan-option-item-radio"),
          Mp = !0;
        console.log(Lp, "optionPlanSelectorNew"),
          Lp &&
            Lp.forEach((e) => {
              e.addEventListener("click", function () {
                console.log("kliknuto"),
                  Lp.forEach((e) => {
                    e.parentNode.classList.remove("pdp-plan-option-item--active");
                  }),
                  e.parentNode.classList.add("pdp-plan-option-item--active");
                let t = e.getAttribute("value");
                if ((console.log("koji je ovde values", t), "Subscribe" === t || "Single Pack" == t)) {
                  Mp = !0;
                  let e;
                  if (document.querySelector(".js-c-price")) {
                    let t = document.querySelector(".js-c-price").innerHTML;
                    document.querySelector(".nodics-price") && (e = document.querySelector(".nodics-price").innerHTML),
                      (document.querySelector(".js-discounted-price").textContent = t),
                      (document.querySelector(".js-normal-price").textContent = e);
                    if (document.querySelectorAll(".js-save")[0]) {
                      document.querySelectorAll(".js-save")[0].classList.remove("hidden");
                    }
                    if (document.querySelectorAll(".js-save")[1]) {
                      document.querySelectorAll(".js-save")[1].classList.remove("hidden");
                    }
                    if (document.querySelectorAll(".js-save")[2]) {
                      document.querySelectorAll(".js-save")[2].classList.remove("hidden");
                    }
                  }
                } else {
                  Mp = !1;
                  let e;
                  if (document.querySelector(".disc-price")) {
                    let t = document.querySelector(".disc-price").innerHTML;
                    document.querySelector(".nodics-price") && (e = document.querySelector(".nodics-price").innerHTML),
                      (document.querySelector(".js-discounted-price").textContent = t),
                      (document.querySelector(".js-normal-price").textContent = e);
                    if (document.querySelectorAll(".js-save")[0]) {
                      document.querySelectorAll(".js-save")[0].classList.remove("hidden");
                    }
                    if (document.querySelectorAll(".js-save")[1]) {
                      document.querySelectorAll(".js-save")[1].classList.remove("hidden");
                    }
                    if (document.querySelectorAll(".js-save")[2]) {
                      document.querySelectorAll(".js-save")[2].classList.remove("hidden");
                    }
                  }
                }
                console.log(Mp, t, "value");
              });
            });
        var Lh = document.querySelector(".js-plan-selector");
        Lh &&
          ((window.sellingPlanSelectorId = 1080000692),
          Lh.addEventListener("change", function () {
            let e = Lh.value;
            console.log(e, "variantId"), (window.sellingPlanSelectorId = e);
          }));
        const Dp = () => {
            const e = {
              items: [
                { id: window.variantIdFirst, selling_plan: window.sellingPlanSelectorId, quantity: 1 },
                { id: window.variantIdSecond, selling_plan: window.sellingPlanSelectorId, quantity: 1 },
              ],
            };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(e),
            })
              .then((e) => (console.log(e.status, "ok"), 200 === e.status && (cp(), dp()), e.json()))
              .catch((e) => {
                console.error("Error:", e);
              }),
              console.log("test test");
          },
          Np = {
            "Blender Bombs": { "4-weeks": "7689601204", "8-weeks": "7689633972" },
            "Bomb Bars": { "4-weeks": "7719289012", "8-weeks": "7719321780" },
            "Protein Powder": { "4-weeks": "7719223476", "8-weeks": "7719256244" },
          },
          Pp = document.querySelector("#plan-selector");
        Pp &&
          Pp.addEventListener("change", (e) => {
            const t = e.target.value;
            document.querySelectorAll("[data-type]").forEach((e) => {
              const n = e.getAttribute("data-type");
              if (Np[n]) {
                const r = Np[n][t];
                e.setAttribute("data-selling-plan-id", r);
              }
            });
            var n = document.querySelector(".js-product-one-selector"),
              r = document.querySelector(".js-product-two-selector");
            let s = n.options[n.selectedIndex].getAttribute("data-selling-plan-id"),
              i = r.options[r.selectedIndex].getAttribute("data-selling-plan-id");
            console.log(s, i, "sellingPlanId"), (window.sellingPlanSelectorIdFirst = s), (window.sellingPlanSelectorIdSecond = i);
          });
        const Op = () => {
            let e = [];
            e = Mp
              ? [
                  { id: window.variantIdFirst, selling_plan: window.sellingPlanSelectorIdFirst, quantity: 1 },
                  { id: window.variantIdSecond, selling_plan: window.sellingPlanSelectorIdSecond, quantity: 1 },
                ]
              : [
                  { id: window.variantIdFirst, quantity: 1 },
                  { id: window.variantIdSecond, quantity: 1 },
                ];
            const t = { items: e };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(t),
            })
              .then((e) => (console.log(e.status, "ok"), 200 === e.status && (cp(), dp()), e.json()))
              .catch((e) => {
                console.error("Error:", e);
              }),
              console.log("test test");
          },
          qp = document.querySelector("#plan-selector-bundle");
        qp &&
          qp.addEventListener("change", (e) => {
            const t = e.target.value;
            document.querySelectorAll("[data-type]").forEach((e) => {
              const n = e.getAttribute("data-type");
              if (Np[n]) {
                const r = Np[n][t];
                e.setAttribute("data-selling-plan-id", r);
              }
            });
            var n = document.querySelector(".js-product-one-selector-m"),
              r = document.querySelector(".js-product-two-selector-m"),
              s = document.querySelector(".js-product-three-selector-m");
            let i = n.options[n.selectedIndex].getAttribute("data-selling-plan-id");
            window.sellingPlanIdFirstM = i;
            let o = r.options[r.selectedIndex].getAttribute("data-selling-plan-id");
            window.sellingPlanIdSecondM = o;
            let a = s.options[s.selectedIndex].getAttribute("data-selling-plan-id");
            window.sellingPlanIdThirdM = a;
          });
        const Rp = () => {
            let e = [];
            (e = Mp
              ? [
                  { id: window.variantIdFirstM, selling_plan: window.sellingPlanIdFirstM, quantity: 1 },
                  { id: window.variantIdSecondM, selling_plan: window.sellingPlanIdSecondM, quantity: 1 },
                  { id: window.variantIdThirdM, selling_plan: window.sellingPlanIdThirdM, quantity: 1 },
                ]
              : [
                  { id: window.variantIdFirstM, quantity: 1 },
                  { id: window.variantIdSecondM, quantity: 1 },
                  { id: window.variantIdThirdM, quantity: 1 },
                ]),
              console.log(e, "addItemsssss");
            const t = { items: e };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(t),
            })
              .then((e) => (console.log(e.status, "ok"), 200 === e.status && (cp(), dp()), e.json()))
              .catch((e) => {
                console.error("Error:", e);
              }),
              console.log("test test");
          },
          Fp = () => {
            let e = [];
            (e = [
              { id: window.variantIdFirstB, quantity: 1 },
              { id: window.variantIdSecondB, quantity: 1 },
              { id: window.variantIdThirdB, quantity: 1 },
            ]),
              console.log(e, "add buy 2 get 1 free");
            const t = { items: e };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(t),
            })
              .then((e) => (console.log(e.status, "ok"), 200 === e.status && (cp(), dp()), e.json()))
              .catch((e) => {
                console.error("Error:", e);
              }),
              console.log("test test");
          },
          Bp = (e, t) => {
            const n = `updates[${e}]=${t}`;
            ap.setAttribute("disabled", !0),
              (ap.textContent = "Loading..."),
              fetch(`/cart/update.js?${n}`, {
                headers: { "Content-Type": "application/json", "X-Requested-With": "xmlhttprequest" },
                method: "POST",
              })
                .then((e) => e.json())
                .then(() => {
                  cp(), dp();
                });
          },
          $p = async () => {
            let e = document.querySelector(".js-copy-code"),
              t = e.getAttribute("data-code");
            console.log(e, "textHolder");
            try {
              await navigator.clipboard.writeText(t), (e.textContent = "Copied!"), console.log("Content copied to clipboard");
            } catch (e) {
              console.error("Failed to copy: ", e);
            }
          };
        (window.refreshCart = cp),
          (window.addToCarts = _p),
          (window.addToCartLove = Ep),
          (window.cartItemUpdate = Bp),
          (window.showCart = dp),
          (window.closeCart = hp),
          (window.addToCartBundle = Dp),
          (window.addToCartBundleMix = Rp),
          (window.addToCartBundleOneTime = Op),
          (window.addToCartBuyTwo = Fp),
          (window.copyContent = $p);
      }
      refreshCart(),
        "#cart" == window.location.hash && showCart(),
        document.querySelectorAll(".js-scroll-top").forEach((e) => {
          e.addEventListener("click", function (e) {
            e.preventDefault(), window.scrollTo({ top: 0, behavior: "smooth" });
          });
        });
      n(250);
      new Wt(".swiper-slider", {
        slidesPerView: 1,
        loop: !0,
        spaceBetween: 20,
        pagination: { el: document.querySelector(".swiper-pagination-custom"), type: "bullets", clickable: !0 },
        modules: [nn, Yt, Jt],
        breakpoints: { 768: { slidesPerView: 2, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 20 } },
      });
      console.log("testimonials.js loaded");
      const Mh = new Wt(".wknd-testimonial-swiper", {
        slidesPerView: 1.6,
        spaceBetween: 20,
        centeredSlides: !0,
        loop: !0,
        modules: [nn, Yt, Jt],
        navigation: { nextEl: ".wknd-testimoinals-next", prevEl: ".wknd-testimoinals-prev" },
        pagination: { el: ".wknd-testimoinals-pagination", clickable: !0 },
      });
      var Dh = new Wt(".thumb-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: !0,
        watchSlidesVisibility: !0,
        watchSlidesProgress: !0,
        loop: !0,
        modules: [nn, Yt, Jt],
      });
      new Wt(".main-slider", {
        slidesPerView: 1.5,
        spaceBetween: 10,
        loop: !0,
        modules: [nn, Yt, Jt],
        pagination: { el: ".wknd-testimoinals-pagination-mobile", clickable: !0 },
        thumbs: { swiper: Dh },
      });
      Mh.init();
      class Nh {
        constructor(e) {
          (this.element = e.element),
            (this.video = this.element.querySelector("video")),
            (this.playPauseBtn = this.element.querySelector(".video-image-heading-text__media-play-pause")),
            null !== this.video &&
              this.playPauseBtn.addEventListener("click", (e) => {
                1 == this.video.paused
                  ? (this.video.play(), this.playPauseBtn.classList.toggle("pause"))
                  : (this.video.pause(), this.playPauseBtn.classList.toggle("pause"));
              });
        }
      }
      document.querySelectorAll(".video-image-heading-text").forEach((e) => {
        new Nh({ element: e });
      });
    })();
})();
